import type { StructuredResource } from '@bamboohr/utils/lib/locale';

export default {
	'   Survey Id: ': {
		translation: '   Survey Id: ',
	},
	'  See import results below for more information.': {
		translation: '  See import results below for more information.',
	},
	' %sCancel scheduled changes%s': {
		translation: ' %sCancel scheduled changes%s',
	},
	' (%1$s Person)': {
		translation: {
			one: ' (%1$s Person)',
			other: ' (%1$s People)',
		},
	},
	' (Added)': {
		translation: ' (Added)',
	},
	' (Fees may apply)': {
		translation: ' (Fees may apply)',
	},
	' (Hybrid)': {
		translation: ' (Hybrid)',
	},
	' (Set in group 1)': {
		translation: ' (Set in group 1)',
	},
	' (Termination)': {
		translation: ' (Termination)',
	},
	' (Was: ': {
		translation: ' (Was: ',
	},
	' (for all employees)': {
		translation: ' (for all employees)',
	},
	' (plus an additional **{1}**)': {
		translation: ' (plus an additional **{1}**)',
	},
	' - Allow Employee to resubmit': {
		translation: ' - Allow Employee to resubmit',
	},
	' - Allow Manager to resubmit': {
		translation: ' - Allow Manager to resubmit',
	},
	' - Preferred': {
		translation: ' - Preferred',
	},
	' <a href="/settings/account/upgrade.php">Upgrade your account</a> to add more active employees.':
		{
			translation:
				' <a href="/settings/account/upgrade.php">Upgrade your account</a> to add more active employees.',
		},
	' Add a note...': {
		translation: ' Add a note...',
	},
	' App': {
		translation: ' App',
	},
	' Are you sure you want to do this?': {
		translation: ' Are you sure you want to do this?',
	},
	' Be sure your account is funded to avoid {1} fees.': {
		translation: ' Be sure your account is funded to avoid {1} fees.',
	},
	' CSV file does not exist or is not readable': {
		translation: ' CSV file does not exist or is not readable',
	},
	' Changing this setting after employees are enrolled in benefit plans is messy.':
		{
			translation:
				' Changing this setting after employees are enrolled in benefit plans is messy.',
		},
	' Contact %1$s at <a href="mailto:%2$s">%3$s</a> to add more active employees.':
		{
			translation:
				' Contact %1$s at <a href=\\"mailto:%2$s\\">%3$s</a> to add more active employees.',
		},
	' Enter Question (e.g. Why do you want to work here?)': {
		translation: ' Enter Question (e.g. Why do you want to work here?)',
	},
	' Field': {
		translation: ' Field',
	},
	' Follow the steps in <a href="http://saml-doc.okta.com/Provisioning_Docs/BambooHR_Provisioning.html">this guide</a>.':
		{
			translation:
				' Follow the steps in <a href=\\"http://saml-doc.okta.com/Provisioning_Docs/BambooHR_Provisioning.html\\">this guide</a>.',
		},
	' Getting Started Checklist': {
		translation: ' Getting Started Checklist',
	},
	" If you don't see your jobs posted within 48 hours, contact Indeed to submit a visibility request":
		{
			translation:
				" If you don't see your jobs posted within 48 hours, contact Indeed to submit a visibility request",
		},
	" If you have any questions, don't hesitate to reach out to us!": {
		translation:
			" If you have any questions, don't hesitate to reach out to us!",
	},
	' It contains %1$s item(s).': {
		translation: ' It contains %1$s item(s).',
	},
	' Required': {
		translation: ' Required',
	},
	' Standard Reports': {
		translation: ' Standard Reports',
	},
	' Tool': {
		translation: ' Tool',
	},
	' You will need to download new forms to sign.': {
		translation: ' You will need to download new forms to sign.',
	},
	' You will not be able to change this setting.': {
		translation: ' You will not be able to change this setting.',
	},
	' access levels:': {
		translation: ' access levels:',
	},
	' after': {
		translation: ' after',
	},
	' and': {
		translation: ' and',
	},
	' and ': {
		translation: ' and ',
	},
	' and start fresh.': {
		translation: ' and start fresh.',
	},
	' before': {
		translation: ' before',
	},
	' before BambooHR services are cancelled.': {
		translation: ' before BambooHR services are cancelled.',
	},
	' before Payroll services are cancelled.': {
		translation: ' before Payroll services are cancelled.',
	},
	' benefit effective date': {
		translation: ' benefit effective date',
	},
	' commented on your goals': {
		translation: ' commented on your goals',
	},
	' commented on your goals.': {
		translation: ' commented on your goals.',
	},
	' commission': {
		translation: ' commission',
	},
	' contract': {
		translation: ' contract',
	},
	' currently belongs to ': {
		translation: ' currently belongs to ',
	},
	' days': {
		translation: ' days',
	},
	' days left in your free trial.': {
		translation: ' days left in your free trial.',
	},
	' delete all your current plans and enrollments': {
		translation: ' delete all your current plans and enrollments',
	},
	' direct report': {
		translation: ' direct report',
	},
	' direct reports': {
		translation: ' direct reports',
	},
	' exclude from group.': {
		translation: ' exclude from group.',
	},
	" folder on the employee's profile.": {
		translation: " folder on the employee's profile.",
	},
	' for the following plan types.': {
		translation: ' for the following plan types.',
	},
	' in Bamboo Payroll': {
		translation: ' in Bamboo Payroll',
	},
	' in the following single access level?:': {
		translation: ' in the following single access level?:',
	},
	' is scheduled!': {
		translation: ' is scheduled!',
	},
	' link opens in a new window': {
		translation: ' link opens in a new window',
	},
	' more training...': {
		translation: {
			one: ' more training...',
			other: ' more trainings...',
		},
	},
	' more trainings...': {
		translation: ' more trainings...',
	},
	' of Employee Contribution': {
		translation: ' of Employee Contribution',
	},
	' of Gross': {
		translation: ' of Gross',
	},
	' of Net': {
		translation: ' of Net',
	},
	' on ': {
		translation: ' on ',
	},
	' pay date': {
		translation: ' pay date',
	},
	' pay date ': {
		translation: ' pay date ',
	},
	' pay dates': {
		translation: ' pay dates',
	},
	' pay dates ': {
		translation: ' pay dates ',
	},
	' some people ': {
		translation: ' some people ',
	},
	' survey responses': {
		translation: ' survey responses',
	},
	' the benefit effective date': {
		translation: ' the benefit effective date',
	},
	" then follow the steps to set up the integration.  Once you're done, you'll be redirected back here.":
		{
			translation:
				" then follow the steps to set up the integration.  Once you're done, you'll be redirected back here.",
		},
	' then follow the steps to set up the integration. Once that is done, you’ll be redirected back here. ':
		{
			translation:
				' then follow the steps to set up the integration. Once that is done, you’ll be redirected back here. ',
		},
	' this person ': {
		translation: ' this person ',
	},
	' until BambooHR services are cancelled.': {
		translation: ' until BambooHR services are cancelled.',
	},
	' until Payroll services are cancelled.': {
		translation: ' until Payroll services are cancelled.',
	},
	' year': {
		translation: ' year',
	},
	' yrs': {
		translation: ' yrs',
	},
	' | <a href="%s&amp;p=%d">Next &raquo; </a>': {
		translation: ' | <a href=\\"%s&amp;p=%d\\">Next &raquo; </a>',
	},
	'!*safePlanName*!': {
		translation: '!*safePlanName*!',
	},
	'"%1$s" successfully deleted.': {
		translation: '\\"%1$s\\" successfully deleted.',
	},
	'"%s" already exists as a location and has been unarchived.': {
		translation:
			'\\"%s\\" already exists as a location and has been unarchived.',
	},
	'"%s" already exists as a pay schedule and has been unarchived.': {
		translation:
			'\\"%s\\" already exists as a pay schedule and has been unarchived.',
	},
	'"%s" already exists as a pay schedule.': {
		translation: '\\"%s\\" already exists as a pay schedule.',
	},
	'"%s" already exists as a time off category and has been unarchived.': {
		translation:
			'\\"%s\\" already exists as a time off category and has been unarchived.',
	},
	'"%s" already exists as a time off type and has been unarchived.': {
		translation:
			'\\"%s\\" already exists as a time off type and has been unarchived.',
	},
	'"%s" already exists in this list and has been unarchived.': {
		translation:
			'\\"%s\\" already exists in this list and has been unarchived.',
	},
	'"%s" already exists in this list.': {
		translation: '\\"%s\\" already exists in this list.',
	},
	'"%s" already exists.': {
		translation: '\\"%s\\" already exists.',
	},
	'"%s" could not be created': {
		translation: '"%s" could not be created',
	},
	'"%s" could not be updated': {
		translation: '"%s" could not be updated',
	},
	'"%s" is already an existing location. If you do not see it on this list, it is likely archived.':
		{
			translation:
				'\\"%s\\" is already an existing location. If you do not see it on this list, it is likely archived.',
		},
	'"%s" was added successfully': {
		translation: '\\"%s\\" was added successfully',
	},
	'"%s" was saved as a new location.': {
		translation: '"%s" was saved as a new location.',
	},
	'"%s" was updated.': {
		translation: '\\"%s\\" was updated.',
	},
	'"A goal properly set is halfway reached." - Zig Ziglar': {
		translation: '\\"A goal properly set is halfway reached.\\" - Zig Ziglar',
	},
	'"Get to know you" Questions:': {
		translation: '\\"Get to know you\\" Questions:',
	},
	'"It always seems impossible until it\'s done." - Nelson Mandela': {
		translation:
			'\\"It always seems impossible until it\'s done.\\" - Nelson Mandela',
	},
	'"Non-Accruing" refers to flexible (e.g. "Unlimited" time off types.': {
		translation:
			'\\"Non-Accruing\\" refers to flexible (e.g. \\"Unlimited\\" time off types.',
	},
	'"What you get by achieving your goals is not as important as what you become by achieving your goals." - Zig Ziglar':
		{
			translation:
				'\\"What you get by achieving your goals is not as important as what you become by achieving your goals.\\" - Zig Ziglar',
		},
	'"Whoops... No worries. Please fix any missing or incorrect information and try again."':
		{
			translation:
				'\\"Whoops... No worries. Please fix any missing or incorrect information and try again.\\"',
		},
	'"{1}" will be added to "{2}"': {
		translation: '\\"{1}\\" will be added to \\"{2}\\"',
	},
	'# Fields Missing or Invalid': {
		translation: '# Fields Missing or Invalid',
	},
	'# Options Granted': {
		translation: '# Options Granted',
	},
	'# of Employees Updated': {
		translation: '# of Employees Updated',
	},
	'# of Equity Granted': {
		translation: '# of Equity Granted',
	},
	'# of Equity Granted must be a whole number.': {
		translation: '# of Equity Granted must be a whole number.',
	},
	'# of Rows Imported': {
		translation: '# of Rows Imported',
	},
	'# of candidates': {
		translation: '# of candidates',
	},
	'# of candidates moved to inactive status': {
		translation: '# of candidates moved to inactive status',
	},
	'# of characters before column data is truncated.': {
		translation: '# of characters before column data is truncated.',
	},
	'${type} (as of ${date})': {
		translation: '${type} (as of ${date})',
	},
	'% Change': {
		translation: '% Change',
	},
	'% of candidates (total)': {
		translation: '% of candidates (total)',
	},
	'% of candidates moved to inactive status': {
		translation: '% of candidates moved to inactive status',
	},
	'%(reviewerPreferredFirstName)s %(reviewerLastName)s just completed Feedback for:':
		{
			translation:
				'%(reviewerPreferredFirstName)s %(reviewerLastName)s just completed Feedback for:',
		},
	'%1': {
		translation: '%1',
	},
	"%1 (%2%%) DIDN'T MOVE PAST THIS STATUS": {
		translation: "%1 (%2%%) DIDN'T MOVE PAST THIS STATUS",
	},
	'%1 (%2%%) SET TO NOT HIRED FROM THIS STATUS': {
		translation: '%1 (%2%%) SET TO NOT HIRED FROM THIS STATUS',
	},
	'%1 (as of %2)': {
		translation: '%1 (as of %2)',
	},
	'%1 (six months after your last survey.)': {
		translation: '%1 (six months after your last survey.)',
	},
	'%1 Access Levels': {
		translation: '%1 Access Levels',
	},
	'%1 Anniversary': {
		translation: '%1 Anniversary',
	},
	'%1 Collaborators': {
		translation: '%1 Collaborators',
	},
	'%1 Departments': {
		translation: '%1 Departments',
	},
	'%1 Divisions': {
		translation: '%1 Divisions',
	},
	'%1 Hours Import': {
		translation: '%1 Hours Import',
	},
	'%1 Locations': {
		translation: '%1 Locations',
	},
	'%1 Selected': {
		translation: '%1 Selected',
	},
	'%1 Total Employees': {
		translation: '%1 Total Employees',
	},
	'%1 applied for the %2 opening.': {
		translation: '%1 applied for the %2 opening.',
	},
	'%1 at %2': {
		translation: '%1 at %2',
	},
	'%1 by %2': {
		translation: '%1 by %2',
	},
	'%1 called... it wants its browser back.': {
		translation: '%1 called... it wants its browser back.',
	},
	'%1 checkboxes in this group': {
		translation: '%1 checkboxes in this group',
	},
	'%1 days': {
		translation: '%1 days',
	},
	"%1 doesn't have an email address.": {
		translation: "%1 doesn't have an email address.",
	},
	'%1 file uploaded': {
		translation: {
			one: '%1 file uploaded',
			other: '%1 files uploaded',
		},
	},
	'%1 for %2': {
		translation: '%1 for %2',
	},
	'%1 has been successfully uninstalled.': {
		translation: '%1 has been successfully uninstalled.',
	},
	'%1 has provided feedback about %2.': {
		translation: '%1 has provided feedback about %2.',
	},
	'%1 is requesting an update to their personal information.': {
		translation: '%1 is requesting an update to their personal information.',
	},
	'%1 is waiting for your signature.': {
		translation: '%1 is waiting for your signature.',
	},
	'%1 job titles still need EEO categories.': {
		translation: '%1 job titles still need EEO categories.',
	},
	'%1 made a request: %2 request for %3.': {
		translation: '%1 made a request: %2 request for %3.',
	},
	'%1 months': {
		translation: '%1 months',
	},
	'%1 needs a home or work email in order to be added to an Access Level.': {
		translation:
			'%1 needs a home or work email in order to be added to an Access Level.',
	},
	'%1 of %2': {
		translation: '%1 of %2',
	},
	'%1 of the scheduled alert dates fall on a weekend.': {
		translation: '%1 of the scheduled alert dates fall on a weekend.',
	},
	'%1 out of %2 employees have finished the survey.': {
		translation: '%1 out of %2 employees have finished the survey.',
	},
	'%1 pending signature requests have been canceled.': {
		translation: '%1 pending signature requests have been canceled.',
	},
	'%1 per month': {
		translation: '%1 per month',
	},
	'%1 per year': {
		translation: '%1 per year',
	},
	'%1 posted an Announcement, %2': {
		translation: '%1 posted an Announcement, %2',
	},
	'%1 potential problems': {
		translation: '%1 potential problems',
	},
	'%1 requested %2 off – %3 %4 of %5': {
		translation: '%1 requested %2 off – %3 %4 of %5',
	},
	'%1 selected': {
		translation: '%1 selected',
	},
	'%1 successfully imported': {
		translation: '%1 successfully imported',
	},
	'%1 to hire': {
		translation: '%1 to hire',
	},
	'%1 total files': {
		translation: '%1 total files',
	},
	'%1 will lose all of their peer reviews, goals, and assessments. This action cannot be undone.':
		{
			translation:
				'%1 will lose all of their peer reviews, goals, and assessments. This action cannot be undone.',
		},
	'%1 will see follow-up notes.': {
		translation: '%1 will see follow-up notes.',
	},
	'%1$d active person': {
		translation: {
			one: '%1$d active person',
			other: '%1$d active people',
		},
	},
	'%1$d day left': {
		translation: {
			one: '%1$d day left',
			other: '%1$d days left',
		},
	},
	'%1$d holidays were successfully copied to %2$d.': {
		translation: '%1$d holidays were successfully copied to %2$d.',
	},
	'%1$d of the scheduled alert dates fall on a weekend.': {
		translation: '%1$d of the scheduled alert dates fall on a weekend.',
	},
	'%1$d person': {
		translation: {
			one: '%1$d person',
			other: '%1$d people',
		},
	},
	'%1$d-%2$d of %3$d': {
		translation: '%1$d-%2$d of %3$d',
	},
	'%1$s': {
		translation: '%1$s',
	},
	'%1$s ': {
		translation: '%1$s ',
	},
	'%1$s %2$s ': {
		translation: '%1$s %2$s ',
	},
	'%1$s %2$s (your current browser) is currently supported, but with a degraded experience.':
		{
			translation:
				'%1$s %2$s (your current browser) is currently supported, but with a degraded experience.',
		},
	'%1$s %2$s (your current browser) is not currently supported.': {
		translation: '%1$s %2$s (your current browser) is not currently supported.',
	},
	'%1$s %2$s of %3$s.': {
		translation: '%1$s %2$s of %3$s.',
	},
	'%1$s ATTACHED': {
		translation: '%1$s ATTACHED',
	},
	'%1$s Access Levels': {
		translation: '%1$s Access Levels',
	},
	'%1$s Accrual Policy was set to %2$s': {
		translation: '%1$s Accrual Policy was set to %2$s',
	},
	'%1$s Accrual Policy was set to Flexible (e.g. Unlimited)': {
		translation: '%1$s Accrual Policy was set to Flexible (e.g. Unlimited)',
	},
	'%1$s Accrual Policy was set to Manually Updated': {
		translation: '%1$s Accrual Policy was set to Manually Updated',
	},
	'%1$s Accrual Policy was set to None': {
		translation: '%1$s Accrual Policy was set to None',
	},
	'%1$s Accrual Policy was set to None (e.g. Flexible, Unlimited, etc.)': {
		translation:
			'%1$s Accrual Policy was set to None (e.g. Flexible, Unlimited, etc.)',
	},
	'%1$s Accrual Policy was set to a new policy': {
		translation: '%1$s Accrual Policy was set to a new policy',
	},
	'%1$s Applicants': {
		translation: '%1$s Applicants',
	},
	'%1$s Attached': {
		translation: '%1$s Attached',
	},
	'%1$s Calendar': {
		translation: '%1$s Calendar',
	},
	'%1$s Day': {
		translation: {
			one: '%1$s Day',
			other: '%1$s Days',
		},
	},
	'%1$s Day Used %2$s(YTD)%3$s': {
		translation: {
			one: '%1$s Day Used %2$s(YTD)%3$s',
			other: '%1$s Days Used %2$s(YTD)%3$s',
		},
	},
	'%1$s Department': {
		translation: '%1$s Department',
	},
	'%1$s Division': {
		translation: '%1$s Division',
	},
	'%1$s Employee': {
		translation: '%1$s Employee',
	},
	'%1$s Employee Logged Time': {
		translation: {
			one: '%1$s Employee Logged Time',
			other: '%1$s Employees Logged Time',
		},
	},
	'%1$s Employees': {
		translation: '%1$s Employees',
	},
	'%1$s Hour': {
		translation: {
			one: '%1$s Hour',
			other: '%1$s Hours',
		},
	},
	'%1$s Hour Used %2$s(YTD)%3$s': {
		translation: {
			one: '%1$s Hour Used %2$s(YTD)%3$s',
			other: '%1$s Hours Used %2$s(YTD)%3$s',
		},
	},
	'%1$s Hours for %2$s': {
		translation: '%1$s Hours for %2$s',
	},
	'%1$s Office': {
		translation: '%1$s Office',
	},
	'%1$s Overtime': {
		translation: '%1$s Overtime',
	},
	'%1$s Pay Schedule': {
		translation: '%1$s Pay Schedule',
	},
	'%1$s Paystub': {
		translation: '%1$s Paystub',
	},
	'%1$s Pending Approval': {
		translation: {
			one: '%1$s Pending Approval',
			other: '%1$s Pending Approvals',
		},
	},
	'%1$s Request: %2$s': {
		translation: '%1$s Request: %2$s',
	},
	'%1$s Row Successfully Imported': {
		translation: {
			one: '%1$s Row Successfully Imported',
			other: '%1$s Rows Successfully Imported',
		},
	},
	'%1$s Settings': {
		translation: '%1$s Settings',
	},
	'%1$s Time Off Categories': {
		translation: '%1$s Time Off Categories',
	},
	'%1$s Time Off Types': {
		translation: '%1$s Time Off Types',
	},
	'%1$s Today': {
		translation: '%1$s Today',
	},
	'%1$s Uses BambooHR': {
		translation: '%1$s Uses BambooHR',
	},
	'%1$s active training, %2$s past due or expired': {
		translation: {
			one: '%1$s active training, %2$s past due or expired',
			other: '%1$s active trainings, %2$s past due or expired',
		},
	},
	'%1$s and %2$s don’t have email addresses in BambooHR and won’t be emailed.':
		{
			translation:
				'%1$s and %2$s don’t have email addresses in BambooHR and won’t be emailed.',
		},
	'%1$s and %2$s more': {
		translation: '%1$s and %2$s more',
	},
	'%1$s and %2$s more...': {
		translation: '%1$s and %2$s more...',
	},
	'%1$s approved this at %2$s (%3$s day ago)': {
		translation: {
			one: '%1$s approved this at %2$s (%3$s day ago)',
			other: '%1$s approved this at %2$s (%3$s days ago)',
		},
	},
	'%1$s approved this at %2$s (%3$s hour ago)': {
		translation: {
			one: '%1$s approved this at %2$s (%3$s hour ago)',
			other: '%1$s approved this at %2$s (%3$s hours ago)',
		},
	},
	'%1$s approved this on %2$s': {
		translation: '%1$s approved this on %2$s',
	},
	'%1$s assigned an offboarding task for %2$s to you.': {
		translation: '%1$s assigned an offboarding task for %2$s to you.',
	},
	'%1$s assigned an offboarding task to you.': {
		translation: '%1$s assigned an offboarding task to you.',
	},
	'%1$s assigned an onboarding task for %2$s to you.': {
		translation: '%1$s assigned an onboarding task for %2$s to you.',
	},
	'%1$s assigned an onboarding task to you.': {
		translation: '%1$s assigned an onboarding task to you.',
	},
	'%1$s at %2$s': {
		translation: '%1$s at %2$s',
	},
	'%1$s at %2$s by %3$s': {
		translation: '%1$s at %2$s by %3$s',
	},
	'%1$s avatar': {
		translation: '%1$s avatar',
	},
	'%1$s candidates are being moved to %2$s. This could take just a moment.': {
		translation:
			'%1$s candidates are being moved to %2$s. This could take just a moment.',
	},
	'%1$s candidates were successfully deleted.': {
		translation: '%1$s candidates were successfully deleted.',
	},
	'%1$s cannot have fewer than %2$s character': {
		translation: {
			one: '%1$s cannot have fewer than %2$s character',
			other: '%1$s cannot have fewer than %2$s characters',
		},
	},
	'%1$s cannot have more than %2$s character': {
		translation: {
			one: '%1$s cannot have more than %2$s character',
			other: '%1$s cannot have more than %2$s characters',
		},
	},
	'%1$s change from %2$s to %3$s scheduled': {
		translation: '%1$s change from %2$s to %3$s scheduled',
	},
	'%1$s chose not to sign this document.': {
		translation: '%1$s chose not to sign this document.',
	},
	'%1$s completed this at %2$s (%3$s day ago)': {
		translation: {
			one: '%1$s completed this at %2$s (%3$s day ago)',
			other: '%1$s completed this at %2$s (%3$s days ago)',
		},
	},
	'%1$s completed this at %2$s (%3$s hour ago)': {
		translation: {
			one: '%1$s completed this at %2$s (%3$s hour ago)',
			other: '%1$s completed this at %2$s (%3$s hours ago)',
		},
	},
	'%1$s completed this on %2$s': {
		translation: '%1$s completed this on %2$s',
	},
	'%1$s day': {
		translation: {
			one: '%1$s day',
			other: '%1$s days',
		},
	},
	'%1$s day available': {
		translation: {
			one: '%1$s day available',
			other: '%1$s days available',
		},
	},
	'%1$s day of %2$s for %3$s': {
		translation: {
			one: '%1$s day of %2$s for %3$s',
			other: '%1$s days of %2$s for %3$s',
		},
	},
	'%1$s day used %2$s(YTD)%3$s': {
		translation: {
			one: '%1$s day used %2$s(YTD)%3$s',
			other: '%1$s days used %2$s(YTD)%3$s',
		},
	},
	'%1$s day(s)': {
		translation: '%1$s day(s)',
	},
	'%1$s days': {
		translation: '%1$s days',
	},
	'%1$s days ': {
		translation: '%1$s days ',
	},
	'%1$s days available': {
		translation: '%1$s days available',
	},
	'%1$s days left': {
		translation: '%1$s days left',
	},
	"%1$s days until your company's BambooHR account is suspended.": {
		translation:
			"%1$s days until your company's BambooHR account is suspended.",
	},
	"%1$s days until your company's BambooHR account is suspended. Please %2$s to review your billing information and make a payment to avoid suspension.":
		{
			translation:
				"%1$s days until your company's BambooHR account is suspended. Please %2$s to review your billing information and make a payment to avoid suspension.",
		},
	'%1$s denied this at %2$s (%3$s day ago)': {
		translation: {
			one: '%1$s denied this at %2$s (%3$s day ago)',
			other: '%1$s denied this at %2$s (%3$s days ago)',
		},
	},
	'%1$s denied this at %2$s (%3$s hour ago)': {
		translation: {
			one: '%1$s denied this at %2$s (%3$s hour ago)',
			other: '%1$s denied this at %2$s (%3$s hours ago)',
		},
	},
	'%1$s denied this on %2$s': {
		translation: '%1$s denied this on %2$s',
	},
	"%1$s doesn't have a home address state set so we can't calculate overtime.":
		{
			translation:
				"%1$s doesn't have a home address state set so we can't calculate overtime.",
		},
	"%1$s doesn't have a location set so we can't calculate overtime.": {
		translation:
			"%1$s doesn't have a location set so we can't calculate overtime.",
	},
	"%1$s doesn't have a state set so we can't calculate overtime.": {
		translation:
			"%1$s doesn't have a state set so we can't calculate overtime.",
	},
	"%1$s doesn't have an email address.": {
		translation: "%1$s doesn't have an email address.",
	},
	'%1$s doesn’t have an email address in BambooHR and won’t be emailed.': {
		translation:
			'%1$s doesn’t have an email address in BambooHR and won’t be emailed.',
	},
	'%1$s employees will be unenrolled.': {
		translation: '%1$s employees will be unenrolled.',
	},
	'%1$s files': {
		translation: '%1$s files',
	},
	'%1$s for %2$s': {
		translation: '%1$s for %2$s',
	},
	'%1$s goal, ': {
		translation: {
			one: '%1$s goal, ',
			other: '%1$s goals, ',
		},
	},
	'%1$s has Requested Time Off': {
		translation: '%1$s has Requested Time Off',
	},
	'%1$s has an invalid value length': {
		translation: '%1$s has an invalid value length',
	},
	'%1$s has been added but still needs a Tax ID. Please enter it as soon as possible.':
		{
			translation:
				'%1$s has been added but still needs a Tax ID. Please enter it as soon as possible.',
		},
	'%1$s has been added to your company taxes.': {
		translation: '%1$s has been added to your company taxes.',
	},
	'%1$s has been added.': {
		translation: '%1$s has been added.',
	},
	'%1$s has been added. Instructions have been sent to %2$s': {
		translation: '%1$s has been added. Instructions have been sent to %2$s',
	},
	'%1$s has been deleted.': {
		translation: '%1$s has been deleted.',
	},
	'%1$s has been set to end on %2$s.': {
		translation: '%1$s has been set to end on %2$s.',
	},
	'%1$s has no completed trainings during %2$s.': {
		translation: '%1$s has no completed trainings during %2$s.',
	},
	'%1$s has no completed trainings.': {
		translation: '%1$s has no completed trainings.',
	},
	'%1$s has no upcoming trainings.': {
		translation: '%1$s has no upcoming trainings.',
	},
	'%1$s hour': {
		translation: {
			one: '%1$s hour',
			other: '%1$s hours',
		},
	},
	'%1$s hour available': {
		translation: {
			one: '%1$s hour available',
			other: '%1$s hours available',
		},
	},
	'%1$s hour of %2$s for %3$s': {
		translation: {
			one: '%1$s hour of %2$s for %3$s',
			other: '%1$s hours of %2$s for %3$s',
		},
	},
	'%1$s hour used %2$s(YTD)%3$s': {
		translation: {
			one: '%1$s hour used %2$s(YTD)%3$s',
			other: '%1$s hours used %2$s(YTD)%3$s',
		},
	},
	'%1$s hour(s)': {
		translation: '%1$s hour(s)',
	},
	'%1$s hours ': {
		translation: '%1$s hours ',
	},
	'%1$s hours available': {
		translation: '%1$s hours available',
	},
	'%1$s is in an Access Level that cannot be combined with %2$s': {
		translation: '%1$s is in an Access Level that cannot be combined with %2$s',
	},
	'%1$s is invalid': {
		translation: '%1$s is invalid',
	},
	'%1$s is not a valid paid per option when on a syncing pay schedule.': {
		translation:
			'%1$s is not a valid paid per option when on a syncing pay schedule.',
	},
	'%1$s is not a valid pay type option when on a syncing pay schedule.': {
		translation:
			'%1$s is not a valid pay type option when on a syncing pay schedule.',
	},
	'%1$s is required': {
		translation: '%1$s is required',
	},
	'%1$s is still clocked in': {
		translation: '%1$s is still clocked in',
	},
	'%1$s might have forgotten to clock out.': {
		translation: '%1$s might have forgotten to clock out.',
	},
	'%1$s month': {
		translation: {
			one: '%1$s month',
			other: '%1$s months',
		},
	},
	'%1$s more': {
		translation: '%1$s more',
	},
	'%1$s needs a home or work email in order to be added to an Access Level.': {
		translation:
			'%1$s needs a home or work email in order to be added to an Access Level.',
	},
	'%1$s needs a home or work email in order to be added to an Access Level. Add one or both below.':
		{
			translation:
				'%1$s needs a home or work email in order to be added to an Access Level. Add one or both below.',
		},
	'%1$s needs to have a pay schedule before time tracking can be enabled.': {
		translation:
			'%1$s needs to have a pay schedule before time tracking can be enabled.',
	},
	'%1$s new item added': {
		translation: {
			one: '%1$s new item added',
			other: '%1$s new items added',
		},
	},
	'%1$s of %2$s Completed': {
		translation: '%1$s of %2$s Completed',
	},
	'%1$s of holiday pay': {
		translation: '%1$s of holiday pay',
	},
	'%1$s on %2$s': {
		translation: '%1$s on %2$s',
	},
	'%1$s or %2$s to avoid suspension.': {
		translation: '%1$s or %2$s to avoid suspension.',
	},
	'%1$s overdue': {
		translation: '%1$s overdue',
	},
	'%1$s pending approval': {
		translation: {
			one: '%1$s pending approval',
			other: '%1$s pending approvals',
		},
	},
	'%1$s pending signer': {
		translation: {
			one: '%1$s pending signer',
			other: '%1$s pending signers',
		},
	},
	'%1$s people are missing required payroll information for the next payroll, %2$s.':
		{
			translation:
				'%1$s people are missing required payroll information for the next payroll, %2$s.',
		},
	'%1$s person is missing required payroll information for the next payroll, %2$s.':
		{
			translation:
				'%1$s person is missing required payroll information for the next payroll, %2$s.',
		},
	'%1$s policy %2$s': {
		translation: '%1$s policy %2$s',
	},
	'%1$s requested a %2$s change for %3$s.': {
		translation: '%1$s requested a %2$s change for %3$s.',
	},
	'%1$s requested an update in their personal information.': {
		translation: '%1$s requested an update in their personal information.',
	},
	'%1$s requested an update to their personal information.': {
		translation: '%1$s requested an update to their personal information.',
	},
	'%1$s requested time off for %2$s.': {
		translation: '%1$s requested time off for %2$s.',
	},
	'%1$s saved successfully!': {
		translation: '%1$s saved successfully!',
	},
	'%1$s settings were successfully updated': {
		translation: '%1$s settings were successfully updated',
	},
	'%1$s should not filled, since status is not terminated.': {
		translation: '%1$s should not filled, since status is not terminated.',
	},
	'%1$s starts in 1 day': {
		translation: {
			one: '%1$s starts in 1 day',
			other: '%1$s starts in %2$s days',
		},
	},
	'%1$s task added and is now applicable to this employee.': {
		translation: '%1$s task added and is now applicable to this employee.',
	},
	'%1$s task completed!': {
		translation: '%1$s task completed!',
	},
	'%1$s task reopened.': {
		translation: '%1$s task reopened.',
	},
	'%1$s time off has been made inactive and will no longer be included in payroll.':
		{
			translation:
				'%1$s time off has been made inactive and will no longer be included in payroll.',
		},
	'%1$s time off has been made inactive.': {
		translation: '%1$s time off has been made inactive.',
	},
	'%1$s time off is now active.': {
		translation: '%1$s time off is now active.',
	},
	'%1$s time off type was updated successfully.': {
		translation: '%1$s time off type was updated successfully.',
	},
	'%1$s times': {
		translation: '%1$s times',
	},
	'%1$s was added successfully.': {
		translation: '%1$s was added successfully.',
	},
	'%1$s was deleted successfully': {
		translation: '%1$s was deleted successfully',
	},
	'%1$s was moved to %2$s': {
		translation: '%1$s was moved to %2$s',
	},
	'%1$s was successfully deleted.': {
		translation: '%1$s was successfully deleted.',
	},
	'%1$s was successfully installed': {
		translation: '%1$s was successfully installed',
	},
	'%1$s was successfully shared.': {
		translation: '%1$s was successfully shared.',
	},
	'%1$s was successfully uninstalled': {
		translation: '%1$s was successfully uninstalled',
	},
	'%1$s was successfully unshared.': {
		translation: '%1$s was successfully unshared.',
	},
	'%1$s will be able to access the following document:': {
		translation: '%1$s will be able to access the following document:',
	},
	'%1$s will be asked to fill in the following payroll information.': {
		translation:
			'%1$s will be asked to fill in the following payroll information.',
	},
	'%1$s will lose access to the following document:': {
		translation: '%1$s will lose access to the following document:',
	},
	'%1$s will not get any new timesheets, but will still be able to log time on their current timesheet and it will still be sent for approval.':
		{
			translation:
				'%1$s will not get any new timesheets, but will still be able to log time on their current timesheet and it will still be sent for approval.',
		},
	'%1$s will receive this email with a link to view the offer letter.': {
		translation:
			'%1$s will receive this email with a link to view the offer letter.',
	},
	"%1$s will still be able to track time, but we won't calculate overtime.": {
		translation:
			"%1$s will still be able to track time, but we won't calculate overtime.",
	},
	'%1$s will still be able to view and sign the offer after the expiration date.':
		{
			translation:
				'%1$s will still be able to view and sign the offer after the expiration date.',
		},
	"%1$s won't be included in payroll until we can verify this address.": {
		translation:
			"%1$s won't be included in payroll until we can verify this address.",
	},
	'%1$s year': {
		translation: {
			one: '%1$s year',
			other: '%1$s years',
		},
	},
	'%1$s – %2$s of %3$s': {
		translation: '%1$s – %2$s of %3$s',
	},
	'%1$s%2$s (Hybrid)': {
		translation: '%1$s%2$s (Hybrid)',
	},
	'%1$s%2$s (Remote)': {
		translation: '%1$s%2$s (Remote)',
	},
	'%1$s%2$s%3$s more required item to complete': {
		translation: '%1$s%2$s%3$s more required item to complete',
	},
	'%1$s%2$s%3$s more required items to complete': {
		translation: '%1$s%2$s%3$s more required items to complete',
	},
	"%1$s' Time Off Request was Approved": {
		translation: "%1$s' Time Off Request was Approved",
	},
	"%1$s' Time Off Request was Canceled": {
		translation: "%1$s' Time Off Request was Canceled",
	},
	"%1$s' Time Off Request was Denied": {
		translation: "%1$s' Time Off Request was Denied",
	},
	"%1$s' Time Off Request was Updated": {
		translation: "%1$s' Time Off Request was Updated",
	},
	"%1$s's %3$s%2$s-year%4$s Anniversary!": {
		translation: "%1$s's %3$s%2$s-year%4$s Anniversary!",
	},
	"%1$s's Time Off Request was Approved": {
		translation: "%1$s's Time Off Request was Approved",
	},
	"%1$s's Time Off Request was Canceled": {
		translation: "%1$s's Time Off Request was Canceled",
	},
	"%1$s's Time Off Request was Denied": {
		translation: "%1$s's Time Off Request was Denied",
	},
	"%1$s's Time Off Request was Updated": {
		translation: "%1$s's Time Off Request was Updated",
	},
	"%1$s's first day is today, so please take the time to say hi and welcome %1$s to the team.":
		{
			translation:
				"%1$s's first day is today, so please take the time to say hi and welcome %1$s to the team.",
		},
	'%1$s, %2$s': {
		translation: '%1$s, %2$s',
	},
	'%1$s, %2$s (Hybrid)': {
		translation: '%1$s, %2$s (Hybrid)',
	},
	'%1$s, %2$s (Remote)': {
		translation: '%1$s, %2$s (Remote)',
	},
	'%1$s, %2$s, and %3$s more applicants don’t have email addresses in BambooHR and won’t be emailed.':
		{
			translation:
				'%1$s, %2$s, and %3$s more applicants don’t have email addresses in BambooHR and won’t be emailed.',
		},
	"%1$s, You're All Ready to Go.": {
		translation: "%1$s, You're All Ready to Go.",
	},
	'%1$s-%2$s of %3$s': {
		translation: '%1$s-%2$s of %3$s',
	},
	'%1$s/hour': {
		translation: '%1$s/hour',
	},
	'%1$sApproved%2s by %3$s': {
		translation: '%1$sApproved%2s by %3$s',
	},
	'%1$sBenefit Types%2$s mean that you only have to record the information relevant to each benefit.':
		{
			translation:
				'%1$sBenefit Types%2$s mean that you only have to record the information relevant to each benefit.',
		},
	'%1$sChange%2$s Access Level from %1$s%3$s%2$s to %1$s%4$s%2$s': {
		translation:
			'%1$sChange%2$s Access Level from %1$s%3$s%2$s to %1$s%4$s%2$s',
	},
	"%1$sDon't worry%2$s, we'll send you another one right now.": {
		translation: "%1$sDon't worry%2$s, we'll send you another one right now.",
	},
	'%1%%': {
		translation: '%1%%',
	},
	'%1%% Complete': {
		translation: '%1%% Complete',
	},
	'%1%% Completion Rate': {
		translation: '%1%% Completion Rate',
	},
	'%1%% Full': {
		translation: '%1%% Full',
	},
	'%1%% complete': {
		translation: '%1%% complete',
	},
	'%1%% of total cost': {
		translation: '%1%% of total cost',
	},
	'%1%2 Average Turnover': {
		translation: '%1%2 Average Turnover',
	},
	'%1%2 Total Turnover': {
		translation: '%1%2 Total Turnover',
	},
	'%1: %2/%3': {
		translation: '%1: %2/%3',
	},
	'%1s %2s': {
		translation: '%1s %2s',
	},
	'%1s created this version on %1s.': {
		translation: '%1s created this version on %1s.',
	},
	'%1s created this version on %2s.': {
		translation: '%1s created this version on %2s.',
	},
	'%1s does not have any uploaded documents yet.': {
		translation: '%1s does not have any uploaded documents yet.',
	},
	'%1s of %2s Follow up Notes': {
		translation: '%1s of %2s Follow up Notes',
	},
	'%1s per %2s': {
		translation: '%1s per %2s',
	},
	'%1s request for %2s has already been %3s by %4s.': {
		translation: '%1s request for %2s has already been %3s by %4s.',
	},
	'%1s revised this offer and sent a new version to %2s on %3s. %4s can no longer access this version.':
		{
			translation:
				'%1s revised this offer and sent a new version to %2s on %3s. %4s can no longer access this version.',
		},
	'%1s sent a new version to %2s on %3s. %4s can no longer access this version.':
		{
			translation:
				'%1s sent a new version to %2s on %3s. %4s can no longer access this version.',
		},
	'%1s sent this offer to %1s on %1s.': {
		translation: '%1s sent this offer to %1s on %1s.',
	},
	'%1s sent this offer to %2s on %3s.': {
		translation: '%1s sent this offer to %2s on %3s.',
	},
	'%1sExample:%2s At company B, employees earn time off for the last two weeks that they worked.':
		{
			translation:
				'%1sExample:%2s At company B, employees earn time off for the last two weeks that they worked.',
		},
	'%1sExample:%2s Company A gives its employees five weeks of time off at the beginning of the year.':
		{
			translation:
				'%1sExample:%2s Company A gives its employees five weeks of time off at the beginning of the year.',
		},
	'%1sImportant%2s: Everyone will see the information you include regardless of their Access Level.':
		{
			translation:
				'%1sImportant%2s: Everyone will see the information you include regardless of their Access Level.',
		},
	'%1spersonal information%2s.': {
		translation: '%1spersonal information%2s.',
	},
	'%2$s person': {
		translation: {
			one: '%2$s person',
			other: '%2$s people',
		},
	},
	'%d %s %s have a budget.': {
		translation: '%d %s %s have a budget.',
	},
	'%d Match': {
		translation: {
			one: '%d Match',
			other: '%d Matches',
		},
	},
	'%d Match [%s]': {
		translation: {
			one: '%d Match %s',
			other: '%d Matches %s',
		},
	},
	'%d Month Cliff': {
		translation: '%d Month Cliff',
	},
	'%d More': {
		translation: '%d More',
	},
	'%d Year Vesting': {
		translation: '%d Year Vesting',
	},
	'%d completed task': {
		translation: {
			one: '%d completed task',
			other: '%d completed tasks',
		},
	},
	'%d employee was successfully added.': {
		translation: {
			one: '%d employee was successfully added.',
			other: '%d employees were successfully added.',
		},
	},
	'%d employee was successfully updated.': {
		translation: {
			one: '%d employee was successfully updated.',
			other: '%d employees were successfully updated.',
		},
	},
	'%d employees were successfully imported.': {
		translation: '%d employees were successfully imported.',
	},
	'%d of %d ': {
		translation: '%d of %d ',
	},
	'%d row was successfully processed.': {
		translation: {
			one: '%d row was successfully processed.',
			other: '%d rows were successfully processed.',
		},
	},
	'%s': {
		translation: '%s',
	},
	'%s %s %s': {
		translation: '%s %s %s',
	},
	'%s %s of %s.': {
		translation: '%s %s of %s.',
	},
	'%s (Hybrid)': {
		translation: '%s (Hybrid)',
	},
	'%s (Remote)': {
		translation: '%s (Remote)',
	},
	'%s - link opens in a new tab': {
		translation: '%s - link opens in a new tab',
	},
	'%s - opens modal for plan information': {
		translation: '%s - opens modal for plan information',
	},
	'%s / Day': {
		translation: '%s / Day',
	},
	'%s / Day x %d Days x 52 Weeks': {
		translation: '%s / Day x %d Days x 52 Weeks',
	},
	'%s / Hour': {
		translation: '%s / Hour',
	},
	'%s / Hour x %d Hours x 52 Weeks': {
		translation: '%s / Hour x %d Hours x 52 Weeks',
	},
	'%s / Month': {
		translation: '%s / Month',
	},
	'%s / Month x %d Months / Year': {
		translation: '%s / Month x %d Months / Year',
	},
	'%s / Pay Period': {
		translation: '%s / Pay Period',
	},
	'%s / Piece': {
		translation: '%s / Piece',
	},
	'%s / Quarter': {
		translation: '%s / Quarter',
	},
	'%s / Quarter x %d Quarters / Year': {
		translation: '%s / Quarter x %d Quarters / Year',
	},
	'%s / Week': {
		translation: '%s / Week',
	},
	'%s / Week x %d Weeks / Year': {
		translation: '%s / Week x %d Weeks / Year',
	},
	'%s / Year': {
		translation: '%s / Year',
	},
	'%s Active Employee': {
		translation: {
			one: '%s Active Employee',
			other: '%s Active Employees',
		},
	},
	'%s Answers?': {
		translation: '%s Answers?',
	},
	'%s Applicant': {
		translation: {
			one: '%s Applicant',
			other: '%s Applicants',
		},
	},
	'%s Apps': {
		translation: '%s Apps',
	},
	'%s Balance Adjustment Saved Successfully': {
		translation: '%s Balance Adjustment Saved Successfully',
	},
	'%s Completed Your Assessment': {
		translation: '%s Completed Your Assessment',
	},
	'%s Cost Change': {
		translation: '%s Cost Change',
	},
	'%s Cost Change on %s': {
		translation: '%s Cost Change on %s',
	},
	'%s Day': {
		translation: '%s Day',
	},
	'%s Detractors': {
		translation: '%s Detractors',
	},
	'%s Earned': {
		translation: '%s Earned',
	},
	'%s Employees': {
		translation: '%s Employees',
	},
	'%s Employees Eligible': {
		translation: '%s Employees Eligible',
	},
	'%s Flexible Policy': {
		translation: '%s Flexible Policy',
	},
	'%s Hours': {
		translation: '%s Hours',
	},
	'%s Manual Policy': {
		translation: '%s Manual Policy',
	},
	'%s NEW': {
		translation: '%s NEW',
	},
	'%s Name': {
		translation: '%s Name',
	},
	'%s Neutrals': {
		translation: '%s Neutrals',
	},
	'%s New': {
		translation: {
			one: '%s New',
			other: '%s New',
		},
	},
	'%s Person': {
		translation: {
			one: '%s Person',
			other: '%s People',
		},
	},
	'%s Policy Saved Successfully': {
		translation: '%s Policy Saved Successfully',
	},
	'%s Promoters': {
		translation: '%s Promoters',
	},
	'%s Request Details': {
		translation: '%s Request Details',
	},
	'%s Selected': {
		translation: {
			one: '%s Selected',
			other: '%s Selected',
		},
	},
	'%s State W-4 Withholding': {
		translation: '%s State W-4 Withholding',
	},
	'%s Total': {
		translation: '%s Total',
	},
	'%s Used': {
		translation: '%s Used',
	},
	'%s added successfully to %s': {
		translation: '%s added successfully to %s',
	},
	'%s already exists and has been re-enabled.': {
		translation: '%s already exists and has been re-enabled.',
	},
	"%s already has an employee record in BambooHR. This means you won't be able to hire, but you can still send an offer. The signed offer will automatically show on the employee documents tab.":
		{
			translation:
				"%s already has an employee record in BambooHR. This means you won't be able to hire, but you can still send an offer. The signed offer will automatically show on the employee documents tab.",
		},
	'%s costs updated due to change in pay schedule': {
		translation: '%s costs updated due to change in pay schedule',
	},
	'%s coverage will be terminated on %s': {
		translation: '%s coverage will be terminated on %s',
	},
	'%s coverage will be waived on %s': {
		translation: '%s coverage will be waived on %s',
	},
	'%s coverage will be withdrawn on %s': {
		translation: '%s coverage will be withdrawn on %s',
	},
	'%s data has been synchronized': {
		translation: '%s data has been synchronized',
	},
	'%s day': {
		translation: {
			one: '%s day',
			other: '%s days',
		},
	},
	'%s day left in your free trial.': {
		translation: '%s day left in your free trial.',
	},
	'%s day of %s': {
		translation: {
			one: '%s day of %s',
			other: '%s days of %s',
		},
	},
	'%s days': {
		translation: '%s days',
	},
	'%s days left': {
		translation: '%s days left',
	},
	'%s days left in your free trial.': {
		translation: '%s days left in your free trial.',
	},
	'%s employee is currently connected with this location.': {
		translation: {
			one: '%s employee is currently connected with this location.',
			other: '%s employees are currently connected with this location.',
		},
	},
	'%s employees will be unenrolled': {
		translation: '%s employees will be unenrolled',
	},
	'%s got the job!': {
		translation: '%s got the job!',
	},
	'%s has a birthday today. Check it out!': {
		translation: '%s has a birthday today. Check it out!',
	},
	'%s has an anniversary today. Check it out!': {
		translation: '%s has an anniversary today. Check it out!',
	},
	'%s has been added as a company holiday': {
		translation: '%s has been added as a company holiday',
	},
	'%s has been added as a new category.': {
		translation: '%s has been added as a new category.',
	},
	'%s has been added as a new list.': {
		translation: '%s has been added as a new list.',
	},
	'%s has been added as a new tasklist.': {
		translation: '%s has been added as a new tasklist.',
	},
	'%s has been added back as a tasklist.': {
		translation: '%s has been added back as a tasklist.',
	},
	'%s has been added back in as a category.': {
		translation: '%s has been added back in as a category.',
	},
	'%s has been added back in as a list.': {
		translation: '%s has been added back in as a list.',
	},
	'%s has been added.': {
		translation: '%s has been added.',
	},
	'%s has been filled. Winner Winner Chicken Dinner!': {
		translation: '%s has been filled. Winner Winner Chicken Dinner!',
	},
	'%s has been saved.': {
		translation: '%s has been saved.',
	},
	'%s has been successfully renamed.': {
		translation: '%s has been successfully renamed.',
	},
	'%s has been successfully uninstalled.': {
		translation: '%s has been successfully uninstalled.',
	},
	'%s has been successfully updated.': {
		translation: '%s has been successfully updated.',
	},
	'%s has been unarchived.': {
		translation: '%s has been unarchived.',
	},
	'%s has reported a Qualifying Life Event': {
		translation: '%s has reported a Qualifying Life Event',
	},
	'%s hour of %s': {
		translation: {
			one: '%s hour of %s',
			other: '%s hours of %s',
		},
	},
	'%s hours': {
		translation: '%s hours',
	},
	'%s is after the last allowed date': {
		translation: '%s is after the last allowed date',
	},
	'%s is already an active category.': {
		translation: '%s is already an active category.',
	},
	'%s is already an active list.': {
		translation: '%s is already an active list.',
	},
	'%s is before the earliest allowed date': {
		translation: '%s is before the earliest allowed date',
	},
	'%s is outside of the allowed date range': {
		translation: '%s is outside of the allowed date range',
	},
	'%s is required': {
		translation: {
			one: '%s is required',
			other: '%s are required',
		},
	},
	'%s is required and cannot be blank': {
		translation: {
			one: '%s is required and cannot be blank',
			other: '%s are required and cannot be blank',
		},
	},
	'%s may not be altered.': {
		translation: '%s may not be altered.',
	},
	'%s month': {
		translation: {
			one: '%s month',
			other: '%s months',
		},
	},
	'%s of %s': {
		translation: '%s of %s',
	},
	'%s of %s open': {
		translation: '%s of %s open',
	},
	'%s of Gross Pay': {
		translation: '%s of Gross Pay',
	},
	'%s of Net Pay': {
		translation: '%s of Net Pay',
	},
	'%s of the month': {
		translation: '%s of the month',
	},
	'%s of the quarter': {
		translation: '%s of the quarter',
	},
	'%s of the year': {
		translation: '%s of the year',
	},
	'%s termination': {
		translation: {
			one: '%s termination',
			other: '%s terminations',
		},
	},
	'%s was not installed so no changes were made.': {
		translation: '%s was not installed so no changes were made.',
	},
	'%s was saved successfully': {
		translation: '%s was saved successfully',
	},
	'%s was successfully archived': {
		translation: '%s was successfully archived',
	},
	'%s was successfully archived.': {
		translation: '%s was successfully archived.',
	},
	'%s was successfully deleted': {
		translation: '%s was successfully deleted',
	},
	'%s was successfully deleted.': {
		translation: '%s was successfully deleted.',
	},
	'%s was successfully removed': {
		translation: '%s was successfully removed',
	},
	'%s was successfully removed.': {
		translation: '%s was successfully removed.',
	},
	'%s was successfully renamed.': {
		translation: '%s was successfully renamed.',
	},
	'%s was successfully updated': {
		translation: '%s was successfully updated',
	},
	'%s will still be able to view and sign the offer after the expiration date.':
		{
			translation:
				'%s will still be able to view and sign the offer after the expiration date.',
		},
	'%s year': {
		translation: {
			one: '%s year',
			other: '%s years',
		},
	},
	'%s yr': {
		translation: '%s yr',
	},
	"%s's Birthday!": {
		translation: "%s's Birthday!",
	},
	"%s's Manager": {
		translation: "%s's Manager",
	},
	'%s-%s': {
		translation: '%s-%s',
	},
	'%sChanges have been canceled.%s %s Undo %s': {
		translation: '%sChanges have been canceled.%s %s Undo %s',
	},
	'%sChanges have been canceled.%s %sUndo%s': {
		translation: '%sChanges have been canceled.%s %sUndo%s',
	},
	'%sChanges have been scheduled for %s. Additional changes will override this information.%s':
		{
			translation:
				'%sChanges have been scheduled for %s. Additional changes will override this information.%s',
		},
	'%sClose this Job Opening %s - and remove the public posting': {
		translation: '%sClose this Job Opening %s - and remove the public posting',
	},
	'%sImportant:%s this employee is the hiring lead for one or more job openings. Please choose a new hiring lead:':
		{
			translation:
				'%sImportant:%s this employee is the hiring lead for one or more job openings. Please choose a new hiring lead:',
		},
	"'Contract' is no longer a valid pay type. Please select Hourly, Salary or Commission":
		{
			translation:
				"'Contract' is no longer a valid pay type. Please select Hourly, Salary or Commission",
		},
	"'Not Hired Because...' Breakdown": {
		translation: "'Not Hired Because...' Breakdown",
	},
	"'Prefer Not To Say' and 'Custom' options cannot be combined with any other options.":
		{
			translation:
				"'Prefer Not To Say' and 'Custom' options cannot be combined with any other options.",
		},
	'(%1$s employee will be unenrolled)': {
		translation: '(%1$s employee will be unenrolled)',
	},
	'(%1$s employees will be unenrolled': {
		translation: '(%1$s employees will be unenrolled',
	},
	'(%1$s employees will be unenrolled)': {
		translation: '(%1$s employees will be unenrolled)',
	},
	'(%1$s person)': {
		translation: {
			one: '(%1$s person)',
			other: '(%1$s people)',
		},
	},
	'(%1$s yr)': {
		translation: {
			one: '(%1$s yr)',
			other: '(%1$s yrs)',
		},
	},
	'(%1)': {
		translation: '(%1)',
	},
	'(%1s yr)': {
		translation: {
			one: '(%1s yr)',
			other: '(%1s yrs)',
		},
	},
	'(-)': {
		translation: '(-)',
	},
	'(0 employees will be unenrolled)': {
		translation: '(0 employees will be unenrolled)',
	},
	'(1 day)': {
		translation: {
			one: '(1 day)',
			other: '(%s days)',
		},
	},
	'(1 employee will be unenrolled)': {
		translation: '(1 employee will be unenrolled)',
	},
	'(<30%1 completion)': {
		translation: '(<30%1 completion)',
	},
	'(Completed on %s)': {
		translation: '(Completed on %s)',
	},
	'(Due today)': {
		translation: '(Due today)',
	},
	"(Employees won't see this section)": {
		translation: "(Employees won't see this section)",
	},
	'(Group)': {
		translation: '(Group)',
	},
	'(Legal Full Name)': {
		translation: '(Legal Full Name)',
	},
	'(New Hire)': {
		translation: '(New Hire)',
	},
	'(No carrier)': {
		translation: '(No carrier)',
	},
	'(One Email Required)': {
		translation: '(One Email Required)',
	},
	'(Only seen by Managers)': {
		translation: '(Only seen by Managers)',
	},
	'(Optional)': {
		translation: '(Optional)',
	},
	'(Per Pay Period)': {
		translation: '(Per Pay Period)',
	},
	'(Primary Mailing/Filing)': {
		translation: '(Primary Mailing/Filing)',
	},
	'(Rehire)': {
		translation: '(Rehire)',
	},
	'(Report employees in only one category)': {
		translation: '(Report employees in only one category)',
	},
	'(Required)': {
		translation: '(Required)',
	},
	'(Termination)': {
		translation: '(Termination)',
	},
	'(This setting will apply to all future %s plans you create.)': {
		translation: '(This setting will apply to all future %s plans you create.)',
	},
	'(Vesting this year)': {
		translation: '(Vesting this year)',
	},
	'(W-4, I-9)': {
		translation: '(W-4, I-9)',
	},
	"(We use this to calculate each salaried employee's pre-tax check size)": {
		translation:
			"(We use this to calculate each salaried employee's pre-tax check size)",
	},
	'(YTD)': {
		translation: '(YTD)',
	},
	'(You)': {
		translation: '(You)',
	},
	'(archived)': {
		translation: '(archived)',
	},
	'(currently synced with %1$s)': {
		translation: '(currently synced with %1$s)',
	},
	'(from Hire Date)': {
		translation: '(from Hire Date)',
	},
	'(no company name yet)': {
		translation: '(no company name yet)',
	},
	'(no department yet)': {
		translation: '(no department yet)',
	},
	'(no job title yet)': {
		translation: '(no job title yet)',
	},
	'(none)': {
		translation: '(none)',
	},
	'(optional)': {
		translation: '(optional)',
	},
	'(per pay period)': {
		translation: '(per pay period)',
	},
	'(plus an additional %1$s)': {
		translation: '(plus an additional %1$s)',
	},
	'(signers pending)': {
		translation: '(signers pending)',
	},
	'(today)': {
		translation: '(today)',
	},
	'(with errors)': {
		translation: '(with errors)',
	},
	'* Flexible or Unlimited. Does not accrue hours.': {
		translation: '* Flexible or Unlimited. Does not accrue hours.',
	},
	'* It will not be possible to send to "%1$s" because they do not have an email address in BambooHR':
		{
			translation:
				'* It will not be possible to send to \\"%1$s\\" because they do not have an email address in BambooHR',
		},
	'*% of Detractors* (Neutrals are not counted)': {
		translation: '*% of Detractors* (Neutrals are not counted)',
	},
	'**Change** Access Level from **{1}** to **{2}**': {
		translation: '**Change** Access Level from **{1}** to **{2}**',
	},
	'**Get the word out!**': {
		translation: '**Get the word out!**',
	},
	'**Includes:**': {
		translation: '**Includes:**',
	},
	'**Note**: This will change all **{1}** policies, requests, and historical data to be represented in hours.':
		{
			translation:
				'**Note**: This will change all **{1}** policies, requests, and historical data to be represented in hours.',
		},
	"**Note:** By adding an employee to this workflow, you may be giving them access to sensitive information that they normally don't have permission to view.":
		{
			translation:
				"**Note:** By adding an employee to this workflow, you may be giving them access to sensitive information that they normally don't have permission to view.",
		},
	'**[Learn more]**': {
		translation: '**[Learn more]**',
	},
	'**[{1}](1)** reports to **[{2}](2)**': {
		translation: '**[{1}](1)** reports to **[{2}](2)**',
	},
	'**[{1}](1)** reports to **{2}**': {
		translation: '**[{1}](1)** reports to **{2}**',
	},
	'**{1} {2} (your current browser) is currently supported, but with a degraded experience**':
		{
			translation:
				'**{1} {2} (your current browser) is currently supported, but with a degraded experience**',
		},
	'**{1} {2} (your current browser) is not currently supported**.': {
		translation:
			'**{1} {2} (your current browser) is not currently supported**.',
	},
	'**{1}** reports to **[{2}](2)**': {
		translation: '**{1}** reports to **[{2}](2)**',
	},
	'**{1}** reports to **{2}**': {
		translation: '**{1}** reports to **{2}**',
	},
	'**{1}** {2}': {
		translation: '**{1}** {2}',
	},
	'**{1}** {2} **{3}** the benefit effective date.': {
		translation: '**{1}** {2} **{3}** the benefit effective date.',
	},
	'*Everyone* seems to be in today in `%1$s`.': {
		translation: '*Everyone* seems to be in today in `%1$s`.',
	},
	'*Everyone* seems to be in today in the `%1$s %2$s`.': {
		translation: '*Everyone* seems to be in today in the `%1$s %2$s`.',
	},
	'*Everyone* seems to be in today.': {
		translation: '*Everyone* seems to be in today.',
	},
	'*No one* seems to be in today in `%1$s`.': {
		translation: '*No one* seems to be in today in `%1$s`.',
	},
	'*No one* seems to be in today in the `%1$s %2$s`.': {
		translation: '*No one* seems to be in today in the `%1$s %2$s`.',
	},
	'*No one* seems to be in today.': {
		translation: '*No one* seems to be in today.',
	},
	'*No one* seems to be out today in `%1$s`.': {
		translation: '*No one* seems to be out today in `%1$s`.',
	},
	'*No one* seems to be out today in the `%1$s %2$s`.': {
		translation: '*No one* seems to be out today in the `%1$s %2$s`.',
	},
	'*No one* seems to be out today in the `%1$s`.': {
		translation: '*No one* seems to be out today in the `%1$s`.',
	},
	'*No one* seems to be out today.': {
		translation: '*No one* seems to be out today.',
	},
	'*Note that within CATS, you can adjust your workflow to allow for the employee record to be sent to BambooHR in any one of the status phases.':
		{
			translation:
				'*Note that within CATS, you can adjust your workflow to allow for the employee record to be sent to BambooHR in any one of the status phases.',
		},
	'*Note: The Job Title field will only sync over into BambooHR if the title already exists within the BambooHR drop-down field list.':
		{
			translation:
				'*Note: The Job Title field will only sync over into BambooHR if the title already exists within the BambooHR drop-down field list.',
		},
	'*Unemployment State': {
		translation: '*Unemployment State',
	},
	'*{1} of each check* goes to {2} {3} {4}': {
		translation: '*{1} of each check* goes to {2} {3} {4}',
	},
	'*{1} of the remaining amount* goes to {2} {3} {4}': {
		translation: '*{1} of the remaining amount* goes to {2} {3} {4}',
	},
	'+ Add': {
		translation: '+ Add',
	},
	'+ Add Item': {
		translation: '+ Add Item',
	},
	'+ Add Payee': {
		translation: '+ Add Payee',
	},
	'+ Add Rating': {
		translation: '+ Add Rating',
	},
	'+ Add Status': {
		translation: '+ Add Status',
	},
	'+ Add Tasks': {
		translation: '+ Add Tasks',
	},
	'+ Add a Custom Question': {
		translation: '+ Add a Custom Question',
	},
	'+ Add a Question': {
		translation: '+ Add a Question',
	},
	'+ Add a group': {
		translation: '+ Add a group',
	},
	'+ Add a new coverage option': {
		translation: '+ Add a new coverage option',
	},
	'+ Add another group': {
		translation: '+ Add another group',
	},
	'+ New Tasks': {
		translation: '+ New Tasks',
	},
	', ': {
		translation: ', ',
	},
	', End Date, Project or Task and Pay Rate': {
		translation: ', End Date, Project or Task and Pay Rate',
	},
	', Gender Identity, and Pronouns': {
		translation: ', Gender Identity, and Pronouns',
	},
	', but they will expire %s %s after %s': {
		translation: ', but they will expire %s %s after %s',
	},
	', but they will expire %s %s after your anniversary date': {
		translation: ', but they will expire %s %s after your anniversary date',
	},
	', which will expire %s %s after %s': {
		translation: ', which will expire %s %s after %s',
	},
	', which will expire %s %s after your anniversary date': {
		translation: ', which will expire %s %s after your anniversary date',
	},
	', your interview is coming up! Good luck!': {
		translation: ', your interview is coming up! Good luck!',
	},
	', your interview with ': {
		translation: ', your interview with ',
	},
	'- Select Manager -': {
		translation: '- Select Manager -',
	},
	'- Select Period -': {
		translation: '- Select Period -',
	},
	'- Select Review Period -': {
		translation: '- Select Review Period -',
	},
	'-- Add New --': {
		translation: '-- Add New --',
	},
	'-- Month --': {
		translation: '-- Month --',
	},
	'-- No Template --': {
		translation: '-- No Template --',
	},
	'-- Select --': {
		translation: '-- Select --',
	},
	'-- Select Location --': {
		translation: '-- Select Location --',
	},
	'-- Year --': {
		translation: '-- Year --',
	},
	'--- add a new category ---': {
		translation: '--- add a new category ---',
	},
	'--- add a new option ---': {
		translation: '--- add a new option ---',
	},
	'--Select--': {
		translation: '--Select--',
	},
	'-Category-': {
		translation: '-Category-',
	},
	'-Goal Alignment-': {
		translation: '-Goal Alignment-',
	},
	'-List-': {
		translation: '-List-',
	},
	'-Select Job Opening-': {
		translation: '-Select Job Opening-',
	},
	'-Select-': {
		translation: '-Select-',
	},
	'.': {
		translation: '.',
	},
	'...loading': {
		translation: '...loading',
	},
	'/hour': {
		translation: '/hour',
	},
	'/month': {
		translation: '/month',
	},
	'/piece': {
		translation: '/piece',
	},
	'/year': {
		translation: '/year',
	},
	'0 Applicants': {
		translation: '0 Applicants',
	},
	'0 Employees': {
		translation: '0 Employees',
	},
	'0 comments': {
		translation: '0 comments',
	},
	'0%% Completed (0 of %1)': {
		translation: '0%% Completed (0 of %1)',
	},
	'1 - Gross Wage': {
		translation: '1 - Gross Wage',
	},
	'1 - Strongly Disagree': {
		translation: '1 - Strongly Disagree',
	},
	'1 Employee': {
		translation: '1 Employee',
	},
	'1 day': {
		translation: {
			one: '1 day',
			other: '%1$s days',
		},
	},
	'1 day left to send packet': {
		translation: {
			one: '1 day left to send packet',
			other: '%1$s days left to send packet',
		},
	},
	'1 employee will be unenrolled': {
		translation: '1 employee will be unenrolled',
	},
	'1 employee will be unenrolled.': {
		translation: '1 employee will be unenrolled.',
	},
	'1 hour': {
		translation: '1 hour',
	},
	'1 job title still needs an EEO category.': {
		translation: '1 job title still needs an EEO category.',
	},
	'1 minute': {
		translation: '1 minute',
	},
	'1 month': {
		translation: {
			one: '1 month',
			other: '%1$s months',
		},
	},
	"1 or more files won't be deleted because they are part of the Implementation folder":
		{
			translation:
				"1 or more files won't be deleted because they are part of the Implementation folder",
		},
	"1 or more files won't be deleted because you don't have access": {
		translation:
			"1 or more files won't be deleted because you don't have access",
	},
	'1 week': {
		translation: {
			one: '1 week',
			other: '%1$s weeks',
		},
	},
	'1 year': {
		translation: {
			one: '1 year',
			other: '%1$s years',
		},
	},
	'1) Name report': {
		translation: '1) Name report',
	},
	'1-3 years': {
		translation: '1-3 years',
	},
	'1. How satisfied were you with the content of your job? (e.g. responsibilities, objectives,& work-load)':
		{
			translation:
				'1. How satisfied were you with the content of your job? (e.g. responsibilities, objectives,& work-load)',
		},
	'1. Select the employees': {
		translation: '1. Select the employees',
	},
	'1. Small': {
		translation: '1. Small',
	},
	'1.0 is equal to one full-time worker': {
		translation: '1.0 is equal to one full-time worker',
	},
	'10 - Dependant Care Benefits': {
		translation: '10 - Dependant Care Benefits',
	},
	'10+ years': {
		translation: '10+ years',
	},
	"10. How would you rate our company's performance at making good business decisions at the appropriate level?":
		{
			translation:
				"10. How would you rate our company's performance at making good business decisions at the appropriate level?",
		},
	'100% of remainder': {
		translation: '100% of remainder',
	},
	'10th': {
		translation: '10th',
	},
	'10th day': {
		translation: '10th day',
	},
	'11 - Nonqualified Plans': {
		translation: '11 - Nonqualified Plans',
	},
	'11. How would your rate the working conditions and general environment at our company? (e.g. location, facilities, equipment)':
		{
			translation:
				'11. How would your rate the working conditions and general environment at our company? (e.g. location, facilities, equipment)',
		},
	'11th': {
		translation: '11th',
	},
	'11th day': {
		translation: '11th day',
	},
	'12 - Codes': {
		translation: '12 - Codes',
	},
	'12 Months': {
		translation: '12 Months',
	},
	'12. How would you rate your relationship with your direct supervisor?': {
		translation:
			'12. How would you rate your relationship with your direct supervisor?',
	},
	'12th': {
		translation: '12th',
	},
	'12th day': {
		translation: '12th day',
	},
	'13 - Statutory Employee': {
		translation: '13 - Statutory Employee',
	},
	'13. How would you rate your relationships with other key stakeholders that you need to interact with to perform your job?':
		{
			translation:
				'13. How would you rate your relationships with other key stakeholders that you need to interact with to perform your job?',
		},
	'13th': {
		translation: '13th',
	},
	'13th day': {
		translation: '13th day',
	},
	'14 - Other': {
		translation: '14 - Other',
	},
	'14 Day Log (CSV)': {
		translation: '14 Day Log (CSV)',
	},
	'14. Why are you leaving the Company (main reason & secondary reason)?': {
		translation:
			'14. Why are you leaving the Company (main reason & secondary reason)?',
	},
	'14th': {
		translation: '14th',
	},
	'14th day': {
		translation: '14th day',
	},
	'15 - State ID': {
		translation: '15 - State ID',
	},
	'15. If you are leaving because of dissatisfaction or concern with your position, when and how did you first communicate this with your manager or Human Resources?  What actions did the Company take?':
		{
			translation:
				'15. If you are leaving because of dissatisfaction or concern with your position, when and how did you first communicate this with your manager or Human Resources?  What actions did the Company take?',
		},
	'15th': {
		translation: '15th',
	},
	'15th day': {
		translation: '15th day',
	},
	'16 - State Wage': {
		translation: '16 - State Wage',
	},
	'16. If you have accepted another job:': {
		translation: '16. If you have accepted another job:',
	},
	'16th': {
		translation: '16th',
	},
	'16th day': {
		translation: '16th day',
	},
	'17 - State Tax': {
		translation: '17 - State Tax',
	},
	'17. what skills or attitudes did you learn at  our company that you will take to your next job?':
		{
			translation:
				'17. what skills or attitudes did you learn at  our company that you will take to your next job?',
		},
	'17th': {
		translation: '17th',
	},
	'17th day': {
		translation: '17th day',
	},
	'18 - Local Wages': {
		translation: '18 - Local Wages',
	},
	'18. What could the Company have done to strengthen your long-term commitment to Company??':
		{
			translation:
				'18. What could the Company have done to strengthen your long-term commitment to Company??',
		},
	'18th': {
		translation: '18th',
	},
	'18th day': {
		translation: '18th day',
	},
	'19 - Local Tax': {
		translation: '19 - Local Tax',
	},
	'19. What suggestions can you offer to Company to improve as an employer?': {
		translation:
			'19. What suggestions can you offer to Company to improve as an employer?',
	},
	'19th': {
		translation: '19th',
	},
	'19th day': {
		translation: '19th day',
	},
	'1st': {
		translation: '1st',
	},
	'1st Accrual Period': {
		translation: '1st Accrual Period',
	},
	'1st Quarter': {
		translation: '1st Quarter',
	},
	'1st day': {
		translation: '1st day',
	},
	'1st of January': {
		translation: '1st of January',
	},
	'2 - Disagree': {
		translation: '2 - Disagree',
	},
	'2 - Federal Tax Withheld': {
		translation: '2 - Federal Tax Withheld',
	},
	'2 Weeks': {
		translation: '2 Weeks',
	},
	'2 weeks': {
		translation: '2 weeks',
	},
	'2) Choose fields': {
		translation: '2) Choose fields',
	},
	'2-3 years': {
		translation: '2-3 years',
	},
	'2-Step Enabled': {
		translation: '2-Step Enabled',
	},
	'2-Step Login': {
		translation: '2-Step Login',
	},
	'2-Step Login Configuration': {
		translation: '2-Step Login Configuration',
	},
	'2. How would you rate Company in supporting your learning and career development within the company?':
		{
			translation:
				'2. How would you rate Company in supporting your learning and career development within the company?',
		},
	'2. Medium': {
		translation: '2. Medium',
	},
	'2. Select the forms': {
		translation: '2. Select the forms',
	},
	'20 - Locality Name': {
		translation: '20 - Locality Name',
	},
	'20. Would you recommend others to work for Company?': {
		translation: '20. Would you recommend others to work for Company?',
	},
	'20th': {
		translation: '20th',
	},
	'20th day': {
		translation: '20th day',
	},
	'21. Would you ever consider rejoining Company?': {
		translation: '21. Would you ever consider rejoining Company?',
	},
	'21st': {
		translation: '21st',
	},
	'21st day': {
		translation: '21st day',
	},
	'22. Do you have any other comments you would like to make of Company?': {
		translation:
			'22. Do you have any other comments you would like to make of Company?',
	},
	'22nd': {
		translation: '22nd',
	},
	'22nd day': {
		translation: '22nd day',
	},
	'23. Please indicate whom you wish to share your feedback with:': {
		translation:
			'23. Please indicate whom you wish to share your feedback with:',
	},
	'23rd': {
		translation: '23rd',
	},
	'23rd day': {
		translation: '23rd day',
	},
	'24th': {
		translation: '24th',
	},
	'24th day': {
		translation: '24th day',
	},
	'25th': {
		translation: '25th',
	},
	'25th day': {
		translation: '25th day',
	},
	'26th': {
		translation: '26th',
	},
	'26th day': {
		translation: '26th day',
	},
	'27th': {
		translation: '27th',
	},
	'27th day': {
		translation: '27th day',
	},
	'28th': {
		translation: '28th',
	},
	'28th day': {
		translation: '28th day',
	},
	'2nd': {
		translation: '2nd',
	},
	'2nd Quarter': {
		translation: '2nd Quarter',
	},
	'2nd day': {
		translation: '2nd day',
	},
	'3 - Neutral': {
		translation: '3 - Neutral',
	},
	'3 - Social Security Wage': {
		translation: '3 - Social Security Wage',
	},
	'3 Months': {
		translation: '3 Months',
	},
	'3 direct reports': {
		translation: '3 direct reports',
	},
	'3 more required items to complete': {
		translation: '3 more required items to complete',
	},
	'3) Filter results': {
		translation: '3) Filter results',
	},
	'3-5 years': {
		translation: '3-5 years',
	},
	'3. How would you like to download the forms?': {
		translation: '3. How would you like to download the forms?',
	},
	'3. How would you rate the performance of your team/department at meeting its commitments to stakeholders? (e.g. customers, shareholders, employees)':
		{
			translation:
				'3. How would you rate the performance of your team/department at meeting its commitments to stakeholders? (e.g. customers, shareholders, employees)',
		},
	'3. Large': {
		translation: '3. Large',
	},
	'30 days prior to the end of a review period, Assessments are opened up to Employees and Managers. Once the first Assessment has been started, the questions cannot be edited until the beginning of the next period (%1$s).':
		{
			translation:
				'30 days prior to the end of a review period, Assessments are opened up to Employees and Managers. Once the first Assessment has been started, the questions cannot be edited until the beginning of the next period (%1$s).',
		},
	'30 days prior to the end of the review period, assessments are opened up to employees and managers. Once the first assessment has started, the questions cannot be edited until the beginning of the next period (%1).':
		{
			translation:
				'30 days prior to the end of the review period, assessments are opened up to employees and managers. Once the first assessment has started, the questions cannot be edited until the beginning of the next period (%1).',
		},
	'360 Feedback reviews do not transfer over to BambooHR with the integration.':
		{
			translation:
				'360 Feedback reviews do not transfer over to BambooHR with the integration.',
		},
	'3rd': {
		translation: '3rd',
	},
	'3rd Party Integrations': {
		translation: '3rd Party Integrations',
	},
	'3rd Quarter': {
		translation: '3rd Quarter',
	},
	'3rd day': {
		translation: '3rd day',
	},
	'4 - Agree': {
		translation: '4 - Agree',
	},
	'4 - Social Security Withheld': {
		translation: '4 - Social Security Withheld',
	},
	'4 Months': {
		translation: '4 Months',
	},
	'4 direct reports': {
		translation: '4 direct reports',
	},
	'4) Sort Results': {
		translation: '4) Sort Results',
	},
	'4-5 years': {
		translation: '4-5 years',
	},
	'4. How would you rate the overall adequacy of communication and access to information needed to perform well in your job?':
		{
			translation:
				'4. How would you rate the overall adequacy of communication and access to information needed to perform well in your job?',
		},
	'4. XLarge': {
		translation: '4. XLarge',
	},
	'401(a)': {
		translation: '401(a)',
	},
	'401(k)': {
		translation: '401(k)',
	},
	'401(k) - Roth': {
		translation: '401(k) - Roth',
	},
	'401(k) After Tax': {
		translation: '401(k) After Tax',
	},
	'401(k) Loan Repayment': {
		translation: '401(k) Loan Repayment',
	},
	'401(k) Plan': {
		translation: '401(k) Plan',
	},
	'401(k) Plan 2025': {
		translation: '401(k) Plan 2025',
	},
	'401k': {
		translation: '401k',
	},
	'403 - Access Denied': {
		translation: '403 - Access Denied',
	},
	'403(b)': {
		translation: '403(b)',
	},
	'403(b) - Roth': {
		translation: '403(b) - Roth',
	},
	'403(b) Loan Repayment': {
		translation: '403(b) Loan Repayment',
	},
	'403(c) Loan Repayment': {
		translation: '403(c) Loan Repayment',
	},
	'404 Error': {
		translation: '404 Error',
	},
	'408(k)': {
		translation: '408(k)',
	},
	'408(k) SEP Roth': {
		translation: '408(k) SEP Roth',
	},
	'408(p)': {
		translation: '408(p)',
	},
	'408(p) SIMPLE IRA': {
		translation: '408(p) SIMPLE IRA',
	},
	'408(p) SIMPLE IRA Roth': {
		translation: '408(p) SIMPLE IRA Roth',
	},
	'409A': {
		translation: '409A',
	},
	'457(b)': {
		translation: '457(b)',
	},
	'457(b) - Roth': {
		translation: '457(b) - Roth',
	},
	'4th': {
		translation: '4th',
	},
	'4th Quarter': {
		translation: '4th Quarter',
	},
	'4th day': {
		translation: '4th day',
	},
	'5 - Medicare Wage': {
		translation: '5 - Medicare Wage',
	},
	'5 - Strongly Agree': {
		translation: '5 - Strongly Agree',
	},
	'5) Group by (optional)': {
		translation: '5) Group by (optional)',
	},
	'5-10 years': {
		translation: '5-10 years',
	},
	'5. How would you rate Company on providing adequate resources needed to do your work effectively?':
		{
			translation:
				'5. How would you rate Company on providing adequate resources needed to do your work effectively?',
		},
	'5. XXLarge': {
		translation: '5. XXLarge',
	},
	'501(c)(18)(D)': {
		translation: '501(c)(18)(D)',
	},
	'501c (post-tax)': {
		translation: '501c (post-tax)',
	},
	'5th': {
		translation: '5th',
	},
	'5th day': {
		translation: '5th day',
	},
	'6 - Medicare Withheld': {
		translation: '6 - Medicare Withheld',
	},
	'6 Months': {
		translation: '6 Months',
	},
	'6 months - 1 year': {
		translation: '6 months - 1 year',
	},
	'6-9 years': {
		translation: '6-9 years',
	},
	'6. How would you rate Company on the clarity of objectives and direction provided by your direct manager/supervisor?':
		{
			translation:
				'6. How would you rate Company on the clarity of objectives and direction provided by your direct manager/supervisor?',
		},
	'6th': {
		translation: '6th',
	},
	'6th day': {
		translation: '6th day',
	},
	'7 - Social Security Tips': {
		translation: '7 - Social Security Tips',
	},
	"7. How would you rate the fairness of Company's overall compensation (pay and benefits) for the job you performed?":
		{
			translation:
				"7. How would you rate the fairness of Company's overall compensation (pay and benefits) for the job you performed?",
		},
	'7th': {
		translation: '7th',
	},
	'7th day': {
		translation: '7th day',
	},
	'8 - Allocated Tips': {
		translation: '8 - Allocated Tips',
	},
	'8 or more characters': {
		translation: '8 or more characters',
	},
	'8. How do you believe Company is performing in the area of employee recognition?':
		{
			translation:
				'8. How do you believe Company is performing in the area of employee recognition?',
		},
	'8th': {
		translation: '8th',
	},
	'8th day': {
		translation: '8th day',
	},
	"9. How would you rate Company's commitment to Quality (standard processes and systems)?":
		{
			translation:
				"9. How would you rate Company's commitment to Quality (standard processes and systems)?",
		},
	'9th': {
		translation: '9th',
	},
	'9th day': {
		translation: '9th day',
	},
	'< 1 year': {
		translation: '< 1 year',
	},
	'< 6 months': {
		translation: '< 6 months',
	},
	'<a href="%1$s&p=%2$d">&laquo; Prev</a>': {
		translation: '<a href=\\"%1$s&p=%2$d\\">&laquo; Prev</a>',
	},
	'<a href="https://boomr.zendesk.com/hc/en-us/articles/213583823-Setting-up-the-BambooHR-Integration">https://boomr.zendesk.com/hc/en-us/articles/213583823-Setting-up-the-BambooHR-Integration</a>':
		{
			translation:
				'<a href=\\"https://boomr.zendesk.com/hc/en-us/articles/213583823-Setting-up-the-BambooHR-Integration\\">https://boomr.zendesk.com/hc/en-us/articles/213583823-Setting-up-the-BambooHR-Integration</a>',
		},
	'<a href="https://help.bamboohr.com/hc/en-us/articles/216830487-How-does-BeneTrac-Integrate-with-BambooHR-">Learn more at our Help Center</a>':
		{
			translation:
				'<a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830487-How-does-BeneTrac-Integrate-with-BambooHR-\\">Learn more at our Help Center</a>',
		},
	"<b>Find the right people faster</b><br> Our ATS is a surprisingly simple way to reach more qualified candidates and allows you to track, share, and evaluate applicant information quickly so you can gain first mover advantage in a competitive hiring market, helping you build your company with the best candidates possible. Plus, our ATS works hand in hand with our HR software, so you can enter data once and you're done.":
		{
			translation:
				"<b>Find the right people faster</b><br> Our ATS is a surprisingly simple way to reach more qualified candidates and allows you to track, share, and evaluate applicant information quickly so you can gain first mover advantage in a competitive hiring market, helping you build your company with the best candidates possible. Plus, our ATS works hand in hand with our HR software, so you can enter data once and you're done.",
		},
	'<b>IMPORTANT NOTE:</b> This integration syncs ALL employees from BambooHR to Gusto and there is no way to change this.  Only use this integration if ALL employees in your BambooHR account should be synced to Gusto. <p>The integration is a one way sync from BambooHR to Gusto. The following fields are updated automatically: First name, Last name, Email, SSN, Date of birth, Address, City, State, ZIP, Location address, Hire date, Title, and Compensation.</p>':
		{
			translation:
				'<b>IMPORTANT NOTE:</b> This integration syncs ALL employees from BambooHR to Gusto and there is no way to change this.  Only use this integration if ALL employees in your BambooHR account should be synced to Gusto. <p>The integration is a one way sync from BambooHR to Gusto. The following fields are updated automatically: First name, Last name, Email, SSN, Date of birth, Address, City, State, ZIP, Location address, Hire date, Title, and Compensation.</p>',
		},
	'<b>Note:</b> If your policy allows for employees to earn at different rates based on their length of service, you can manipulate the rate this employee is eligible for by adjusting the Accrual Level Start Date below.':
		{
			translation:
				'<b>Note:</b> If your policy allows for employees to earn at different rates based on their length of service, you can manipulate the rate this employee is eligible for by adjusting the Accrual Level Start Date below.',
		},
	'<h3>Are you sure you want to take this company offline?</h3> Users will not be able to access any part of the software. Only DevOps will be able to reverse this action.':
		{
			translation:
				'<h3>Are you sure you want to take this company offline?</h3> Users will not be able to access any part of the software. Only DevOps will be able to reverse this action.',
		},
	'<li>Error connecting to NetSuite. Retrying...</li>': {
		translation: '<li>Error connecting to NetSuite. Retrying...</li>',
	},
	'<p>*Note: if you\'re NOT a PayScale customer, but are interested in salary reports, please see PayScale\'s offer in the "Special Offers" category of the marketplace.</p>':
		{
			translation:
				'<p>*Note: if you\'re NOT a PayScale customer, but are interested in salary reports, please see PayScale\'s offer in the \\"Special Offers\\" category of the marketplace.</p>',
		},
	'<p>BambooHR customers receive a discounted price for MarketRate Reports. This is a promotion from PayScale and is not an integrated product with BambooHR.</p>':
		{
			translation:
				'<p>BambooHR customers receive a discounted price for MarketRate Reports. This is a promotion from PayScale and is not an integrated product with BambooHR.</p>',
		},
	'<p>Boomr is a modern time tracking solution that keeps employees connected to each other in real-time. Designed for business, our intelligent mobile apps and visual management dashboard offer a unique, cloud-based solution to keep your workforce running at optimal efficiency.</p> <p>At Boomr, we believe that every shift has a story. After an employee checks in for work, Boomr will record time that is spent on projects, allow for collaborative messaging between employees and track breaks and overtime hours with reliability and precision. Shift data is available across the entire organization and can be synced to a variety of industry-leading payroll and billing software products.</p>':
		{
			translation:
				'<p>Boomr is a modern time tracking solution that keeps employees connected to each other in real-time. Designed for business, our intelligent mobile apps and visual management dashboard offer a unique, cloud-based solution to keep your workforce running at optimal efficiency.</p> <p>At Boomr, we believe that every shift has a story. After an employee checks in for work, Boomr will record time that is spent on projects, allow for collaborative messaging between employees and track breaks and overtime hours with reliability and precision. Shift data is available across the entire organization and can be synced to a variety of industry-leading payroll and billing software products.</p>',
		},
	'<p>For joint customers of PayScale and BambooHR, we built an integration which makes it a LOT easier to keep your employees up-to-date in PayScale… and the more up-to-date they are, the better the data is that you’ll actually be getting for them! (A win-win!)</p>':
		{
			translation:
				'<p>For joint customers of PayScale and BambooHR, we built an integration which makes it a LOT easier to keep your employees up-to-date in PayScale… and the more up-to-date they are, the better the data is that you’ll actually be getting for them! (A win-win!)</p>',
		},
	'<p>Get pay right with fresh market data and visual reports. PayScale gives organizations the ability to price positions leveraging a modern compensation algorithm and the largest salary database in the world.</p>':
		{
			translation:
				'<p>Get pay right with fresh market data and visual reports. PayScale gives organizations the ability to price positions leveraging a modern compensation algorithm and the largest salary database in the world.</p>',
		},
	'<p>No spreadsheets, no hassle... just good up-to-date employee data.</p>': {
		translation:
			'<p>No spreadsheets, no hassle... just good up-to-date employee data.</p>',
	},
	"<p>We'll pull back your employee information from BambooHR (like title, first name, last name, and salary) and update Insight on a monthly basis with that information.</p>":
		{
			translation:
				"<p>We'll pull back your employee information from BambooHR (like title, first name, last name, and salary) and update Insight on a monthly basis with that information.</p>",
		},
	"<p>With PayScale's rich data and Market Reports you'll be confident in how pay works and why.</p>":
		{
			translation:
				"<p>With PayScale's rich data and Market Reports you'll be confident in how pay works and why.</p>",
		},
	'<span class="bold">Note: </span>Make sure your Time Off import file is saved as a .txt, .csv, .xls, or .xlsx file and upload it here.':
		{
			translation:
				'<span class=\\"bold\\">Note: </span>Make sure your Time Off import file is saved as a .txt, .csv, .xls, or .xlsx file and upload it here.',
		},
	'<span class="bold">Note: </span>This will change all "%s" policies, requests, and historical data to be represented in <span id="unitlabel" style="text-transform:lowercase"></span>.':
		{
			translation:
				'<span class=\\"bold\\">Note: </span>This will change all \\"%s\\" policies, requests, and historical data to be represented in <span id=\\"unitlabel\\" style=\\"text-transform:lowercase\\"></span>.',
		},
	'<span>Show</span> Import Details': {
		translation: '<span>Show</span> Import Details',
	},
	'<strong>%1$s</strong> will be able to access the following document:': {
		translation:
			'<strong>%1$s</strong> will be able to access the following document:',
	},
	'<strong>%1$s</strong> will lose access to the following document:': {
		translation:
			'<strong>%1$s</strong> will lose access to the following document:',
	},
	'<strong>Important:</strong> Everyone will see the information you include regardless of their Access Level.':
		{
			translation:
				'<strong>Important:</strong> Everyone will see the information you include regardless of their Access Level.',
		},
	'<strong>Note: </strong>Make sure your Time Off import file is saved as a .txt, .csv, .xls, or .xlsx file and upload it here.':
		{
			translation:
				'<strong>Note: </strong>Make sure your Time Off import file is saved as a .txt, .csv, .xls, or .xlsx file and upload it here.',
		},
	'<ul>\n\t\t\t<li>Want to attract new talent with competitive offers?</li>\n\t\t\t<li>Want to retain current important team members? </li>\n\t\t\t<li>Want to understand what your employees are worth in the market?</li>\n\t\t</ul>':
		{
			translation:
				'<ul>\n\t\t\t<li>Want to attract new talent with competitive offers?</li>\n\t\t\t<li>Want to retain current important team members? </li>\n\t\t\t<li>Want to understand what your employees are worth in the market?</li>\n\t\t</ul>',
		},
	'= Required': {
		translation: "'= Required",
	},
	'>30 / <30': {
		translation: '>30 / <30',
	},
	'A BambooHR Subscription is Required': {
		translation: 'A BambooHR Subscription is Required',
	},
	'A Benefit Group is a set of people who are all assigned the same benefit plans.':
		{
			translation:
				'A Benefit Group is a set of people who are all assigned the same benefit plans.',
		},
	'A Candidate Status with that name already exists.  Try another one?': {
		translation:
			'A Candidate Status with that name already exists.  Try another one?',
	},
	'A Day AM': {
		translation: 'A Day AM',
	},
	'A Day PM': {
		translation: 'A Day PM',
	},
	'A Pay Rate must be set with paid-per value.': {
		translation: 'A Pay Rate must be set with paid-per value.',
	},
	'A Pay Schedule is required for Time Tracking': {
		translation: 'A Pay Schedule is required for Time Tracking',
	},
	"A Pay Schedule is required for the employee's current or upcoming benefit enrollments":
		{
			translation:
				"A Pay Schedule is required for the employee's current or upcoming benefit enrollments",
		},
	"A Pay Schedule is required for this employee's current or upcoming benefit enrollments":
		{
			translation:
				"A Pay Schedule is required for this employee's current or upcoming benefit enrollments",
		},
	'A Pay Schedule is required for this time tracking': {
		translation: 'A Pay Schedule is required for this time tracking',
	},
	'A Quick Review of eNPS': {
		translation: 'A Quick Review of eNPS',
	},
	'A benefit plan has an invalid coverage: %s': {
		translation: 'A benefit plan has an invalid coverage: %s',
	},
	'A calendar field is missing': {
		translation: 'A calendar field is missing',
	},
	'A change request has been submitted for the changes entered.': {
		translation: 'A change request has been submitted for the changes entered.',
	},
	'A concise description of the contents of this section.': {
		translation: 'A concise description of the contents of this section.',
	},
	'A configuration with this info already exists.': {
		translation: 'A configuration with this info already exists.',
	},
	'A cosmetic representation of Pulse Survey question': {
		translation: 'A cosmetic representation of Pulse Survey question',
	},
	'A current or future job information line is not valid for an employee’s current or future pay schedule.':
		{
			translation:
				'A current or future job information line is not valid for an employee’s current or future pay schedule.',
		},
	'A date "completed" is required and must be a valid date in yyyy-mm-dd format (ie. 2016-01-01)':
		{
			translation:
				'A date \\"completed\\" is required and must be a valid date in yyyy-mm-dd format (ie. 2016-01-01)',
		},
	'A filter set already exists with that name': {
		translation: 'A filter set already exists with that name',
	},
	'A full-time employee is, for a calendar month, an employee employed on average at least 30 hours of service per week, or 130 hours of service per month.':
		{
			translation:
				'A full-time employee is, for a calendar month, an employee employed on average at least 30 hours of service per week, or 130 hours of service per month.',
		},
	'A horizontal version of your logo is preferable if available.': {
		translation:
			'A horizontal version of your logo is preferable if available.',
	},
	'A legend is shown that spans from %1 to %2': {
		translation: 'A legend is shown that spans from %1 to %2',
	},
	'A maximum of 1 day is allowed.': {
		translation: 'A maximum of 1 day is allowed.',
	},
	'A maximum of 24 hours is allowed.': {
		translation: 'A maximum of 24 hours is allowed.',
	},
	"A misalignment is when a manager's perception of an employee's value and/or engagement does not align with the employee's perception of how they are valued by the company. View the employee's assessment to see the misalignment. This is a good opportunity for the manager and employee to have a thoughtful discussion about the misalignment.":
		{
			translation:
				"A misalignment is when a manager's perception of an employee's value and/or engagement does not align with the employee's perception of how they are valued by the company. View the employee's assessment to see the misalignment. This is a good opportunity for the manager and employee to have a thoughtful discussion about the misalignment.",
		},
	'A null deduction type is not allowed for this benefit plan.': {
		translation: 'A null deduction type is not allowed for this benefit plan.',
	},
	'A paid-per value must be set for Pay Rate.': {
		translation: 'A paid-per value must be set for Pay Rate.',
	},
	'A pay schedule is required to enable time tracking.': {
		translation: 'A pay schedule is required to enable time tracking.',
	},
	'A person receiving a 1099 is not considered an employee and will not be included in the ACA reporting.':
		{
			translation:
				'A person receiving a 1099 is not considered an employee and will not be included in the ACA reporting.',
		},
	'A premium calculation basis option must be selected.': {
		translation: 'A premium calculation basis option must be selected.',
	},
	'A prominent banner will appear on this company’s page to indicates special considerations when dealing with privacy and data management.':
		{
			translation:
				'A prominent banner will appear on this company’s page to indicates special considerations when dealing with privacy and data management.',
		},
	'A reminder has been sent to %1.': {
		translation: 'A reminder has been sent to %1.',
	},
	'A report folder with the same name already exists.': {
		translation: 'A report folder with the same name already exists.',
	},
	'A report with this info already exists.': {
		translation: 'A report with this info already exists.',
	},
	'A required field is missing. Please update your data and try again.': {
		translation:
			'A required field is missing. Please update your data and try again.',
	},
	'A salaried employee cannot have an hourly rate.  Use a pay type of hourly instead.':
		{
			translation:
				'A salaried employee cannot have an hourly rate.  Use a pay type of hourly instead.',
		},
	'A score of zero would mean you have as many Detractors as Promoters.': {
		translation:
			'A score of zero would mean you have as many Detractors as Promoters.',
	},
	'A temporary employee who receives compensation and therefore will be included in the ACA reporting.':
		{
			translation:
				'A temporary employee who receives compensation and therefore will be included in the ACA reporting.',
		},
	'A temporary employee who receives no compensation and therefore will not be included in ACA reporting.':
		{
			translation:
				'A temporary employee who receives no compensation and therefore will not be included in ACA reporting.',
		},
	'A terminated employee.': {
		translation: 'A terminated employee.',
	},
	'A time machine would be handy right now': {
		translation: 'A time machine would be handy right now',
	},
	'A to Z': {
		translation: 'A to Z',
	},
	"A valid address is required to pay employees, so %1$s can't be paid until we verify this address":
		{
			translation:
				"A valid address is required to pay employees, so %1$s can't be paid until we verify this address",
		},
	'A valid employee ID must be submitted': {
		translation: 'A valid employee ID must be submitted',
	},
	'A valid first or last name is required!': {
		translation: 'A valid first or last name is required!',
	},
	A4: {
		translation: 'A4',
	},
	'ACA Benefit History': {
		translation: 'ACA Benefit History',
	},
	'ACA Benefit History Report': {
		translation: 'ACA Benefit History Report',
	},
	'ACA Compliance': {
		translation: 'ACA Compliance',
	},
	'ACA Features are Currently Disabled': {
		translation: 'ACA Features are Currently Disabled',
	},
	'ACA Features are Currently Enabled': {
		translation: 'ACA Features are Currently Enabled',
	},
	'ACA Full Time': {
		translation: 'ACA Full Time',
	},
	'ACA Full-Time': {
		translation: 'ACA Full-Time',
	},
	'ACA Minimum Value': {
		translation: 'ACA Minimum Value',
	},
	'ACA Minimum Value setting in Benefits Tracking': {
		translation: 'ACA Minimum Value setting in Benefits Tracking',
	},
	'ACA Monthly Totals': {
		translation: 'ACA Monthly Totals',
	},
	'ACA Settings': {
		translation: 'ACA Settings',
	},
	'ACA Status': {
		translation: 'ACA Status',
	},
	'ACA Status field in the Employment Status table': {
		translation: 'ACA Status field in the Employment Status table',
	},
	'ACA Status is required': {
		translation: 'ACA Status is required',
	},
	'ACA Status must be Yes, No or Non-Assessment. ': {
		translation: 'ACA Status must be Yes, No or Non-Assessment. ',
	},
	'ACA Status will be set to “No” for any unselected Employment Statuses.': {
		translation:
			'ACA Status will be set to “No” for any unselected Employment Statuses.',
	},
	'ACA Tracking': {
		translation: 'ACA Tracking',
	},
	'ACA Tracking is Currently OFF': {
		translation: 'ACA Tracking is Currently OFF',
	},
	'ACA requires employers to report the cost of coverage under an employer-sponsored group health plan.':
		{
			translation:
				'ACA requires employers to report the cost of coverage under an employer-sponsored group health plan.',
		},
	'ACA-related benefits and employment status reports': {
		translation: 'ACA-related benefits and employment status reports',
	},
	'ACLS #': {
		translation: 'ACLS #',
	},
	'ACLS expiration': {
		translation: 'ACLS expiration',
	},
	'ADP Code': {
		translation: 'ADP Code',
	},
	'ADP Company Code': {
		translation: 'ADP Company Code',
	},
	'ADP File Number': {
		translation: 'ADP File Number',
	},
	'ADP Sign in': {
		translation: 'ADP Sign in',
	},
	'AHCCCS #': {
		translation: 'AHCCCS #',
	},
	'AIM Username': {
		translation: 'AIM Username',
	},
	'AMP Provide Housing': {
		translation: 'AMP Provide Housing',
	},
	API: {
		translation: 'API',
	},
	'API Access': {
		translation: 'API Access',
	},
	'API Key': {
		translation: 'API Key',
	},
	'API Key Name': {
		translation: 'API Key Name',
	},
	'API Key copied to clipboard': {
		translation: 'API Key copied to clipboard',
	},
	'API Key: This is the API Key that you generated from within BambooHR in the first step.':
		{
			translation:
				'API Key: This is the API Key that you generated from within BambooHR in the first step.',
		},
	'API Keys': {
		translation: 'API Keys',
	},
	'API Management': {
		translation: 'API Management',
	},
	"API keys can not be edited when testing another user's account": {
		translation:
			"API keys can not be edited when testing another user's account",
	},
	ATS: {
		translation: 'ATS',
	},
	'ATS Export': {
		translation: 'ATS Export',
	},
	'AZ Medicaid #': {
		translation: 'AZ Medicaid #',
	},
	Accept: {
		translation: 'Accept',
	},
	'Accept Offer': {
		translation: 'Accept Offer',
	},
	'Accept Refund': {
		translation: 'Accept Refund',
	},
	'Accepted ': {
		translation: 'Accepted ',
	},
	'Accepted an offer for **{1}**': {
		translation: 'Accepted an offer for **{1}**',
	},
	'Accepted an offer for [**{1}**]': {
		translation: 'Accepted an offer for [**{1}**]',
	},
	Access: {
		translation: 'Access',
	},
	'Access Denied': {
		translation: 'Access Denied',
	},
	'Access Disabled': {
		translation: 'Access Disabled',
	},
	'Access Level': {
		translation: 'Access Level',
	},
	'Access Level Assignment': {
		translation: 'Access Level Assignment',
	},
	'Access Level Name': {
		translation: 'Access Level Name',
	},
	'Access Level Permissions': {
		translation: 'Access Level Permissions',
	},
	'Access Level Settings': {
		translation: 'Access Level Settings',
	},
	'Access Level Type': {
		translation: 'Access Level Type',
	},
	'Access Level Types': {
		translation: 'Access Level Types',
	},
	'Access Levels': {
		translation: 'Access Levels',
	},
	'Access Levels for': {
		translation: 'Access Levels for',
	},
	'Access Varies': {
		translation: 'Access Varies',
	},
	'Access already granted to the Time Tracking settings area, which includes managing projects':
		{
			translation:
				'Access already granted to the Time Tracking settings area, which includes managing projects',
		},
	'Access already granted to the Time Tracking settings area, which includes managing shift differentials':
		{
			translation:
				'Access already granted to the Time Tracking settings area, which includes managing shift differentials',
		},
	'Access denied': {
		translation: 'Access denied',
	},
	'Access the entire account, including the Account page': {
		translation: 'Access the entire account, including the Account page',
	},
	'Access to Any ACA Benefit Plan': {
		translation: 'Access to Any ACA Benefit Plan',
	},
	'Access to Any Benefit Plan': {
		translation: 'Access to Any Benefit Plan',
	},
	'Access to Benefit Settings': {
		translation: 'Access to Benefit Settings',
	},
	'Access to Benefits Administration Reports': {
		translation: 'Access to Benefits Administration Reports',
	},
	'Access to view or edit at least one ACA Benefit Plan': {
		translation: 'Access to view or edit at least one ACA Benefit Plan',
	},
	'Access to view or edit at least one Benefit Plan': {
		translation: 'Access to view or edit at least one Benefit Plan',
	},
	"Access to view other Employees' ": {
		translation: "Access to view other Employees' ",
	},
	Accident: {
		translation: 'Accident',
	},
	Account: {
		translation: 'Account',
	},
	'Account #': {
		translation: 'Account #',
	},
	'Account %1:': {
		translation: 'Account %1:',
	},
	'Account Access': {
		translation: 'Account Access',
	},
	'Account Balance': {
		translation: 'Account Balance',
	},
	'Account Executive': {
		translation: 'Account Executive',
	},
	'Account History': {
		translation: 'Account History',
	},
	'Account Info': {
		translation: 'Account Info',
	},
	'Account Information': {
		translation: 'Account Information',
	},
	'Account Nickname': {
		translation: 'Account Nickname',
	},
	'Account Number': {
		translation: 'Account Number',
	},
	'Account Number:': {
		translation: 'Account Number:',
	},
	'Account Owner': {
		translation: 'Account Owner',
	},
	'Account Owner or Full Admin Access Level': {
		translation: 'Account Owner or Full Admin Access Level',
	},
	'Account Owner or Full Admin Access Level or Someone With Those Access Levels Has Shared This':
		{
			translation:
				'Account Owner or Full Admin Access Level or Someone With Those Access Levels Has Shared This',
		},
	'Account Owner, Full Admin or Payroll Admin Access Level': {
		translation: 'Account Owner, Full Admin or Payroll Admin Access Level',
	},
	'Account Settings': {
		translation: 'Account Settings',
	},
	'Account Type': {
		translation: 'Account Type',
	},
	'Account enabled': {
		translation: 'Account enabled',
	},
	'Account info of the user who authorized the application': {
		translation: 'Account info of the user who authorized the application',
	},
	'Account information from NetSuite': {
		translation: 'Account information from NetSuite',
	},
	'Account number is Masked': {
		translation: 'Account number is Masked',
	},
	'Account number must be a number': {
		translation: 'Account number must be a number',
	},
	'Account number must have less than 17 characters': {
		translation: 'Account number must have less than 17 characters',
	},
	Accountant: {
		translation: 'Accountant',
	},
	Accrual: {
		translation: 'Accrual',
	},
	'Accrual Details': {
		translation: 'Accrual Details',
	},
	'Accrual Frequency': {
		translation: 'Accrual Frequency',
	},
	'Accrual Level Start Date': {
		translation: 'Accrual Level Start Date',
	},
	'Accrual Level Start Date Saved Successfully': {
		translation: 'Accrual Level Start Date Saved Successfully',
	},
	'Accrual Options': {
		translation: 'Accrual Options',
	},
	'Accrual Period': {
		translation: 'Accrual Period',
	},
	'Accrual Policies': {
		translation: 'Accrual Policies',
	},
	'Accrual Policy': {
		translation: 'Accrual Policy',
	},
	'Accrual Preview': {
		translation: 'Accrual Preview',
	},
	'Accrual Schedule': {
		translation: 'Accrual Schedule',
	},
	'Accrual Start Date': {
		translation: 'Accrual Start Date',
	},
	'Accrual for %1$s': {
		translation: 'Accrual for %1$s',
	},
	'Accrual for %1$s hours worked - %2$s to %3$s': {
		translation: 'Accrual for %1$s hours worked - %2$s to %3$s',
	},
	'Accrual for %1$s to %2$s': {
		translation: 'Accrual for %1$s to %2$s',
	},
	'Accruals Happen...': {
		translation: 'Accruals Happen...',
	},
	'Accruals will be calculated from this date forward for employees added to the policy':
		{
			translation:
				'Accruals will be calculated from this date forward for employees added to the policy',
		},
	'Accruals will be recalculated from this date forward.': {
		translation: 'Accruals will be recalculated from this date forward.',
	},
	Accrued: {
		translation: 'Accrued',
	},
	'Accrued (+)': {
		translation: 'Accrued (+)',
	},
	'Accruing Time Off Balances': {
		translation: 'Accruing Time Off Balances',
	},
	'Accruing in Days': {
		translation: 'Accruing in Days',
	},
	'Accruing in Hours': {
		translation: 'Accruing in Hours',
	},
	'Acess Level Types': {
		translation: 'Acess Level Types',
	},
	Achiever: {
		translation: 'Achiever',
	},
	'Act now! Make sure to send requests today.': {
		translation: 'Act now! Make sure to send requests today.',
	},
	'Act now! Send requests by %s.': {
		translation: 'Act now! Send requests by %s.',
	},
	'Act now! Send requests today.': {
		translation: 'Act now! Send requests today.',
	},
	"Act now, before it's too late... Requests must be sent by %s.": {
		translation:
			"Act now, before it's too late... Requests must be sent by %s.",
	},
	Action: {
		translation: 'Action',
	},
	'Action Buttons': {
		translation: 'Action Buttons',
	},
	'Action Items': {
		translation: 'Action Items',
	},
	'Action required': {
		translation: 'Action required',
	},
	'Action saved! Care to comment on this update? (optional)': {
		translation: 'Action saved! Care to comment on this update? (optional)',
	},
	Actions: {
		translation: 'Actions',
	},
	Activate: {
		translation: 'Activate',
	},
	'Activate the integration by logging in to Performance Pro account and click "System Setup" in the left-hand menu column and then choose "Company Settings".  Navigate to the "Appraisal Settings" tab and click the HRIS Integration checkbox in the far, right-hand column and save at the top of the screen.':
		{
			translation:
				'Activate the integration by logging in to Performance Pro account and click \\"System Setup\\" in the left-hand menu column and then choose \\"Company Settings\\".  Navigate to the \\"Appraisal Settings\\" tab and click the HRIS Integration checkbox in the far, right-hand column and save at the top of the screen.',
		},
	Active: {
		translation: 'Active',
	},
	'Active At Work': {
		translation: 'Active At Work',
	},
	'Active Candidates': {
		translation: 'Active Candidates',
	},
	'Active Duty Wartime or Campaign Badge Veteran': {
		translation: 'Active Duty Wartime or Campaign Badge Veteran',
	},
	'Active Employees': {
		translation: 'Active Employees',
	},
	'Active Group Plan Exists': {
		translation: 'Active Group Plan Exists',
	},
	'Active Military (Overseas)': {
		translation: 'Active Military (Overseas)',
	},
	'Active Military (USA)': {
		translation: 'Active Military (USA)',
	},
	'Active Status Workflow': {
		translation: 'Active Status Workflow',
	},
	'Active Statuses': {
		translation: 'Active Statuses',
	},
	'Active Time Off Categories': {
		translation: 'Active Time Off Categories',
	},
	'Active Time Off Types': {
		translation: 'Active Time Off Types',
	},
	'Active for (avg. days)': {
		translation: 'Active for (avg. days)',
	},
	'Active secured download links': {
		translation: 'Active secured download links',
	},
	Add: {
		translation: 'Add',
	},
	'Add %1$s': {
		translation: 'Add %1$s',
	},
	'Add %1$s to %2$s': {
		translation: 'Add %1$s to %2$s',
	},
	'Add %1$s to a location with a US address to automatically calculate overtime based on the state overtime laws.':
		{
			translation:
				'Add %1$s to a location with a US address to automatically calculate overtime based on the state overtime laws.',
		},
	'Add %s': {
		translation: 'Add %s',
	},
	'Add %s Account': {
		translation: 'Add %s Account',
	},
	'Add %s as a new employee now.': {
		translation: 'Add %s as a new employee now.',
	},
	'Add Account': {
		translation: 'Add Account',
	},
	'Add Additional Fields': {
		translation: 'Add Additional Fields',
	},
	'Add Address Now': {
		translation: 'Add Address Now',
	},
	'Add Alert': {
		translation: 'Add Alert',
	},
	'Add Another Approver': {
		translation: 'Add Another Approver',
	},
	'Add Another Employee': {
		translation: 'Add Another Employee',
	},
	'Add Another Plan': {
		translation: 'Add Another Plan',
	},
	'Add Bank Account': {
		translation: 'Add Bank Account',
	},
	'Add Benefit Group': {
		translation: 'Add Benefit Group',
	},
	'Add Candidate': {
		translation: 'Add Candidate',
	},
	'Add Category': {
		translation: 'Add Category',
	},
	'Add Comment': {
		translation: 'Add Comment',
	},
	'Add Company': {
		translation: 'Add Company',
	},
	'Add Company Files': {
		translation: 'Add Company Files',
	},
	'Add Company/EIN': {
		translation: 'Add Company/EIN',
	},
	'Add Contact': {
		translation: 'Add Contact',
	},
	'Add Coverage Option': {
		translation: 'Add Coverage Option',
	},
	'Add Credit Card': {
		translation: 'Add Credit Card',
	},
	'Add Deduction': {
		translation: 'Add Deduction',
	},
	'Add Default Status': {
		translation: 'Add Default Status',
	},
	'Add Dependent': {
		translation: 'Add Dependent',
	},
	'Add Direct Deposit': {
		translation: 'Add Direct Deposit',
	},
	'Add Education': {
		translation: 'Add Education',
	},
	'Add Email Address': {
		translation: 'Add Email Address',
	},
	'Add Employee': {
		translation: 'Add Employee',
	},
	'Add Employee Info': {
		translation: 'Add Employee Info',
	},
	'Add Employees': {
		translation: 'Add Employees',
	},
	'Add Employees to %1': {
		translation: 'Add Employees to %1',
	},
	'Add Employment Status': {
		translation: 'Add Employment Status',
	},
	'Add Entry': {
		translation: 'Add Entry',
	},
	'Add Fields': {
		translation: 'Add Fields',
	},
	'Add File': {
		translation: 'Add File',
	},
	'Add File to Shared Folder?': {
		translation: 'Add File to Shared Folder?',
	},
	'Add Files': {
		translation: 'Add Files',
	},
	'Add Filter': {
		translation: 'Add Filter',
	},
	'Add Filters': {
		translation: 'Add Filters',
	},
	'Add Folder': {
		translation: 'Add Folder',
	},
	'Add Follow-Up Notes': {
		translation: 'Add Follow-Up Notes',
	},
	'Add Google Users': {
		translation: 'Add Google Users',
	},
	'Add Group': {
		translation: 'Add Group',
	},
	'Add Hire Date': {
		translation: 'Add Hire Date',
	},
	'Add Holiday': {
		translation: 'Add Holiday',
	},
	'Add Info': {
		translation: 'Add Info',
	},
	'Add Initials': {
		translation: 'Add Initials',
	},
	'Add Item': {
		translation: 'Add Item',
	},
	'Add Items': {
		translation: 'Add Items',
	},
	'Add Items From Template': {
		translation: 'Add Items From Template',
	},
	'Add Job Opening': {
		translation: 'Add Job Opening',
	},
	'Add JumpCloud provided API Key': {
		translation: 'Add JumpCloud provided API Key',
	},
	'Add Legal Hold': {
		translation: 'Add Legal Hold',
	},
	'Add Level': {
		translation: 'Add Level',
	},
	'Add Link': {
		translation: 'Add Link',
	},
	'Add Map': {
		translation: 'Add Map',
	},
	'Add Mapping': {
		translation: 'Add Mapping',
	},
	'Add New API Key': {
		translation: 'Add New API Key',
	},
	'Add New Billing Contact': {
		translation: 'Add New Billing Contact',
	},
	'Add New Class Code': {
		translation: 'Add New Class Code',
	},
	'Add New Coverage': {
		translation: 'Add New Coverage',
	},
	'Add New Deduction Name': {
		translation: 'Add New Deduction Name',
	},
	'Add New Email Alert': {
		translation: 'Add New Email Alert',
	},
	'Add New Employee': {
		translation: 'Add New Employee',
	},
	'Add New Employees': {
		translation: 'Add New Employees',
	},
	'Add New Key': {
		translation: 'Add New Key',
	},
	'Add New Location': {
		translation: 'Add New Location',
	},
	'Add New Plan': {
		translation: 'Add New Plan',
	},
	'Add New Rate': {
		translation: 'Add New Rate',
	},
	'Add New Rate For ': {
		translation: 'Add New Rate For ',
	},
	'Add New Rate For %1$s': {
		translation: 'Add New Rate For %1$s',
	},
	'Add New Source': {
		translation: 'Add New Source',
	},
	'Add Note': {
		translation: 'Add Note',
	},
	'Add Partner': {
		translation: 'Add Partner',
	},
	'Add Pay Group': {
		translation: 'Add Pay Group',
	},
	'Add Pay Schedule': {
		translation: 'Add Pay Schedule',
	},
	'Add Payee': {
		translation: 'Add Payee',
	},
	'Add People': {
		translation: 'Add People',
	},
	'Add Photo': {
		translation: 'Add Photo',
	},
	'Add Plan': {
		translation: 'Add Plan',
	},
	'Add Policy': {
		translation: 'Add Policy',
	},
	'Add Post-Tax Deduction': {
		translation: 'Add Post-Tax Deduction',
	},
	'Add Project': {
		translation: 'Add Project',
	},
	'Add Project or Note': {
		translation: 'Add Project or Note',
	},
	'Add Question': {
		translation: 'Add Question',
	},
	'Add Rating': {
		translation: 'Add Rating',
	},
	'Add Reminder': {
		translation: 'Add Reminder',
	},
	'Add Report': {
		translation: 'Add Report',
	},
	'Add Report to Shared Folder?': {
		translation: 'Add Report to Shared Folder?',
	},
	'Add Selected': {
		translation: 'Add Selected',
	},
	'Add Selected Items': {
		translation: 'Add Selected Items',
	},
	'Add Signature': {
		translation: 'Add Signature',
	},
	'Add Sort': {
		translation: 'Add Sort',
	},
	'Add Standard Holidays': {
		translation: 'Add Standard Holidays',
	},
	'Add Status': {
		translation: 'Add Status',
	},
	'Add Status to Workflow...': {
		translation: 'Add Status to Workflow...',
	},
	'Add Tabs': {
		translation: 'Add Tabs',
	},
	'Add Tag': {
		translation: 'Add Tag',
	},
	'Add Task': {
		translation: 'Add Task',
	},
	'Add Tasks': {
		translation: 'Add Tasks',
	},
	'Add Tax': {
		translation: 'Add Tax',
	},
	'Add Tax Type': {
		translation: 'Add Tax Type',
	},
	'Add Time Entry': {
		translation: 'Add Time Entry',
	},
	'Add Time Off Policy': {
		translation: 'Add Time Off Policy',
	},
	'Add Time Off Type': {
		translation: 'Add Time Off Type',
	},
	'Add Training': {
		translation: 'Add Training',
	},
	'Add User to "%1$s"': {
		translation: 'Add User to \\"%1$s\\"',
	},
	'Add User to Group': {
		translation: 'Add User to Group',
	},
	'Add User to Groups': {
		translation: 'Add User to Groups',
	},
	'Add Webhook': {
		translation: 'Add Webhook',
	},
	'Add Your Bank Account': {
		translation: 'Add Your Bank Account',
	},
	'Add Your Billing Details': {
		translation: 'Add Your Billing Details',
	},
	'Add a %1 Plan': {
		translation: 'Add a %1 Plan',
	},
	'Add a %s': {
		translation: 'Add a %s',
	},
	'Add a %s.': {
		translation: 'Add a %s.',
	},
	'Add a Benefit Group.': {
		translation: 'Add a Benefit Group.',
	},
	'Add a Benefit Plan': {
		translation: 'Add a Benefit Plan',
	},
	'Add a Comment': {
		translation: 'Add a Comment',
	},
	'Add a Comment...': {
		translation: 'Add a Comment...',
	},
	'Add a Deduction': {
		translation: 'Add a Deduction',
	},
	'Add a Dental Plan': {
		translation: 'Add a Dental Plan',
	},
	'Add a Department Approval': {
		translation: 'Add a Department Approval',
	},
	'Add a Disability Plan': {
		translation: 'Add a Disability Plan',
	},
	'Add a Division Approval': {
		translation: 'Add a Division Approval',
	},
	'Add a Flex Spending Plan': {
		translation: 'Add a Flex Spending Plan',
	},
	'Add a Health Plan': {
		translation: 'Add a Health Plan',
	},
	'Add a Health Savings Plan': {
		translation: 'Add a Health Savings Plan',
	},
	'Add a Holiday': {
		translation: 'Add a Holiday',
	},
	'Add a Home or Work Email for %1$s': {
		translation: 'Add a Home or Work Email for %1$s',
	},
	'Add a Life Insurance Plan': {
		translation: 'Add a Life Insurance Plan',
	},
	'Add a Location Approval': {
		translation: 'Add a Location Approval',
	},
	'Add a Medical Plan': {
		translation: 'Add a Medical Plan',
	},
	'Add a New Category': {
		translation: 'Add a New Category',
	},
	'Add a New Goal': {
		translation: 'Add a New Goal',
	},
	'Add a New Location': {
		translation: 'Add a New Location',
	},
	'Add a New Report': {
		translation: 'Add a New Report',
	},
	'Add a Non-Employee BambooHR User': {
		translation: 'Add a Non-Employee BambooHR User',
	},
	'Add a Note': {
		translation: 'Add a Note',
	},
	'Add a Pay Schedule': {
		translation: 'Add a Pay Schedule',
	},
	'Add a Photo': {
		translation: 'Add a Photo',
	},
	'Add a Reimbursement Plan': {
		translation: 'Add a Reimbursement Plan',
	},
	'Add a Retirement Plan': {
		translation: 'Add a Retirement Plan',
	},
	'Add a Supplemental Health Plan': {
		translation: 'Add a Supplemental Health Plan',
	},
	'Add a Task': {
		translation: 'Add a Task',
	},
	'Add a Template above.': {
		translation: 'Add a Template above.',
	},
	"Add a US state to %1$s's home address to automatically calculate overtime based on the state overtime laws.":
		{
			translation:
				"Add a US state to %1$s's home address to automatically calculate overtime based on the state overtime laws.",
		},
	"Add a US state to %1$s's location to automatically calculate overtime based on the state overtime laws.":
		{
			translation:
				"Add a US state to %1$s's location to automatically calculate overtime based on the state overtime laws.",
		},
	'Add a Variable Plan': {
		translation: 'Add a Variable Plan',
	},
	'Add a Vision Plan': {
		translation: 'Add a Vision Plan',
	},
	'Add a Webhook.': {
		translation: 'Add a Webhook.',
	},
	'Add a billing contact so we know who to contact with billing questions or concerns.':
		{
			translation:
				'Add a billing contact so we know who to contact with billing questions or concerns.',
		},
	'Add a comment': {
		translation: 'Add a comment',
	},
	'Add a comment (Optional)': {
		translation: 'Add a comment (Optional)',
	},
	'Add a comment...': {
		translation: 'Add a comment...',
	},
	'Add a comment... (Optional)': {
		translation: 'Add a comment... (Optional)',
	},
	'Add a few questions to get to know %1$s a little better and introduce them to the team.':
		{
			translation:
				'Add a few questions to get to know %1$s a little better and introduce them to the team.',
		},
	'Add a file': {
		translation: 'Add a file',
	},
	'Add a new %1': {
		translation: 'Add a new %1',
	},
	'Add a new announcement': {
		translation: 'Add a new announcement',
	},
	'Add a new category': {
		translation: 'Add a new category',
	},
	'Add a new coverage option': {
		translation: 'Add a new coverage option',
	},
	'Add a new option to the list': {
		translation: 'Add a new option to the list',
	},
	'Add a new tasklist': {
		translation: 'Add a new tasklist',
	},
	'Add a note...': {
		translation: 'Add a note...',
	},
	'Add a pay schedule': {
		translation: 'Add a pay schedule',
	},
	'Add a percent cap or total payoff amount': {
		translation: 'Add a percent cap or total payoff amount',
	},
	'Add a tag...': {
		translation: 'Add a tag...',
	},
	'Add additional fields to the form': {
		translation: 'Add additional fields to the form',
	},
	'Add an %1 Plan': {
		translation: 'Add an %1 Plan',
	},
	'Add an %s Task': {
		translation: 'Add an %s Task',
	},
	'Add an Employment Status': {
		translation: 'Add an Employment Status',
	},
	'Add an Other Plan': {
		translation: 'Add an Other Plan',
	},
	'Add an Upcoming Training': {
		translation: 'Add an Upcoming Training',
	},
	'Add and Edit Fields': {
		translation: 'Add and Edit Fields',
	},
	'Add and Manage Hours Worked.': {
		translation: 'Add and Manage Hours Worked.',
	},
	'Add another Pay Group': {
		translation: 'Add another Pay Group',
	},
	"Add any department to which employees will be assigned, and remove those you don't need.":
		{
			translation:
				"Add any department to which employees will be assigned, and remove those you don't need.",
		},
	'Add bank account information for %1$s below': {
		translation: 'Add bank account information for %1$s below',
	},
	'Add departments': {
		translation: 'Add departments',
	},
	'Add divisions': {
		translation: 'Add divisions',
	},
	'Add employee non-benefit deductions': {
		translation: 'Add employee non-benefit deductions',
	},
	'Add event': {
		translation: 'Add event',
	},
	'Add follow-up notes after chatting with %1 about the assessment.': {
		translation:
			'Add follow-up notes after chatting with %1 about the assessment.',
	},
	'Add garnishments, tax levies, loan repayments, etc. here. Benefit deductions are managed on the [Benefits] Tab.':
		{
			translation:
				'Add garnishments, tax levies, loan repayments, etc. here. Benefit deductions are managed on the [Benefits] Tab.',
		},
	'Add locations': {
		translation: 'Add locations',
	},
	'Add more security to your BambooHR Account': {
		translation: 'Add more security to your BambooHR Account',
	},
	'Add note...': {
		translation: 'Add note...',
	},
	'Add plan to %1$s': {
		translation: 'Add plan to %1$s',
	},
	'Add some Email Alerts.': {
		translation: 'Add some Email Alerts.',
	},
	'Add some Employee Trainings': {
		translation: 'Add some Employee Trainings',
	},
	'Add some Offboarding Tasks.': {
		translation: 'Add some Offboarding Tasks.',
	},
	'Add some Onboarding Tasks.': {
		translation: 'Add some Onboarding Tasks.',
	},
	'Add some email alerts.': {
		translation: 'Add some email alerts.',
	},
	'Add some now': {
		translation: 'Add some now',
	},
	"Add the Employees you'd like in this Group": {
		translation: "Add the Employees you'd like in this Group",
	},
	"Add the Plans that you'd like to apply to this group (from over there on the right)":
		{
			translation:
				"Add the Plans that you'd like to apply to this group (from over there on the right)",
		},
	'Add this to ALL active employees.': {
		translation: 'Add this to ALL active employees.',
	},
	'Add your Announcement here…': {
		translation: 'Add your Announcement here…',
	},
	'Add your Tax ID as soon as possible to avoid incurring fees.': {
		translation: 'Add your Tax ID as soon as possible to avoid incurring fees.',
	},
	'Add your comment on %s...': {
		translation: 'Add your comment on %s...',
	},
	'Add your job description here…': {
		translation: 'Add your job description here…',
	},
	'Add your reply...': {
		translation: 'Add your reply...',
	},
	'Add%1$sPhoto': {
		translation: 'Add%1$sPhoto',
	},
	'Add, delete, and edit custom tags you have added': {
		translation: 'Add, delete, and edit custom tags you have added',
	},
	'Add, edit, and/or delete hours from the Hours Importer and Hours API': {
		translation:
			'Add, edit, and/or delete hours from the Hours Importer and Hours API',
	},
	'Add, edit, and/or delete projects and assign employees': {
		translation: 'Add, edit, and/or delete projects and assign employees',
	},
	'Add, edit, and/or delete shift differentials': {
		translation: 'Add, edit, and/or delete shift differentials',
	},
	'Add...': {
		translation: 'Add...',
	},
	Added: {
		translation: 'Added',
	},
	'Added %s by %s': {
		translation: 'Added %s by %s',
	},
	'Added on': {
		translation: 'Added on',
	},
	'Added on %s (%s)': {
		translation: 'Added on %s (%s)',
	},
	'Added to %s': {
		translation: 'Added to %s',
	},
	'Added to %s on %s': {
		translation: 'Added to %s on %s',
	},
	'Added to **{1}**': {
		translation: 'Added to **{1}**',
	},
	'Added to Talent Pool Date': {
		translation: 'Added to Talent Pool Date',
	},
	'Added to [**{1}**]': {
		translation: 'Added to [**{1}**]',
	},
	'Added {1} by {2} ({3})': {
		translation: 'Added {1} by {2} ({3})',
	},
	'Additional Appovers': {
		translation: 'Additional Appovers',
	},
	'Additional Attachment': {
		translation: 'Additional Attachment',
	},
	'Additional Privacy Contractual Obligations': {
		translation: 'Additional Privacy Contractual Obligations',
	},
	'Additional Questions': {
		translation: 'Additional Questions',
	},
	'Additional Signers': {
		translation: 'Additional Signers',
	},
	'Additional Withholding': {
		translation: 'Additional Withholding',
	},
	'Additional item filter': {
		translation: 'Additional item filter',
	},
	Additions: {
		translation: 'Additions',
	},
	'Additions & Terminations': {
		translation: 'Additions & Terminations',
	},
	'Additions and Terminations Report': {
		translation: 'Additions and Terminations Report',
	},
	Address: {
		translation: 'Address',
	},
	'Address (Sensitive)': {
		translation: 'Address (Sensitive)',
	},
	'Address (this is entered into the Address Line 1 field of BambooHR)': {
		translation:
			'Address (this is entered into the Address Line 1 field of BambooHR)',
	},
	'Address (tied to Address Line 1 in BambooHR)': {
		translation: 'Address (tied to Address Line 1 in BambooHR)',
	},
	'Address Change': {
		translation: 'Address Change',
	},
	'Address Changes': {
		translation: 'Address Changes',
	},
	'Address Line 1': {
		translation: 'Address Line 1',
	},
	'Address Line 1 is required': {
		translation: 'Address Line 1 is required',
	},
	'Address Line 2': {
		translation: 'Address Line 2',
	},
	'Address Lines 1 & 2': {
		translation: 'Address Lines 1 & 2',
	},
	'Address entered': {
		translation: 'Address entered',
	},
	'Address line 1 & 2': {
		translation: 'Address line 1 & 2',
	},
	'Address must be in the US (Country must be US)': {
		translation: 'Address must be in the US (Country must be US)',
	},
	'Adjust %s Balance': {
		translation: 'Adjust %s Balance',
	},
	'Adjust Balance': {
		translation: 'Adjust Balance',
	},
	'Adjust Offboarding Task': {
		translation: 'Adjust Offboarding Task',
	},
	'Adjust Onboarding Task': {
		translation: 'Adjust Onboarding Task',
	},
	'Adjust Task': {
		translation: 'Adjust Task',
	},
	Adjustment: {
		translation: 'Adjustment',
	},
	'Adjustment by %1$s': {
		translation: 'Adjustment by %1$s',
	},
	Adjustments: {
		translation: 'Adjustments',
	},
	'Adjustments (YTD)': {
		translation: 'Adjustments (YTD)',
	},
	Admin: {
		translation: 'Admin',
	},
	'Admin Leave': {
		translation: 'Admin Leave',
	},
	'Administrate Payroll': {
		translation: 'Administrate Payroll',
	},
	'Administration Date': {
		translation: 'Administration Date',
	},
	'Administrative Leave (field)': {
		translation: 'Administrative Leave (field)',
	},
	'Administrative Support Workers': {
		translation: 'Administrative Support Workers',
	},
	'Administrator users in NetSuite cannot be updated.': {
		translation: 'Administrator users in NetSuite cannot be updated.',
	},
	Adoption: {
		translation: 'Adoption',
	},
	'Adoption of a Child': {
		translation: 'Adoption of a Child',
	},
	'Advance #1': {
		translation: 'Advance #1',
	},
	'Advance #2': {
		translation: 'Advance #2',
	},
	'Advance Date': {
		translation: 'Advance Date',
	},
	'Advanced Approvals': {
		translation: 'Advanced Approvals',
	},
	'Advanced Options': {
		translation: 'Advanced Options',
	},
	'Advanced approval by department created.': {
		translation: 'Advanced approval by department created.',
	},
	'Advanced approval by division created.': {
		translation: 'Advanced approval by division created.',
	},
	'Advanced approval by location created.': {
		translation: 'Advanced approval by location created.',
	},
	'Advanced approval removed.': {
		translation: 'Advanced approval removed.',
	},
	'Advanced options': {
		translation: 'Advanced options',
	},
	'Affordable Care Act tracking is now disabled in your account.': {
		translation:
			'Affordable Care Act tracking is now disabled in your account.',
	},
	'Affordable Care Act tracking is now enabled in your account.': {
		translation: 'Affordable Care Act tracking is now enabled in your account.',
	},
	'After 2020': {
		translation: 'After 2020',
	},
	'After a waiting period': {
		translation: 'After a waiting period',
	},
	"After clicking 'Install', follow the prompts to map field and data information between BambooHR and Gusto.":
		{
			translation:
				"After clicking 'Install', follow the prompts to map field and data information between BambooHR and Gusto.",
		},
	"After continuing you will only have <span class='bold'>%d GB of storage.</span> We won't delete anything, but you won't be able to upload anything else until you are under that amount.":
		{
			translation:
				"After continuing you will only have <span class='bold'>%d GB of storage.</span> We won't delete anything, but you won't be able to upload anything else until you are under that amount.",
		},
	'After install, you can configure this connection in': {
		translation: 'After install, you can configure this connection in',
	},
	'After it appears in your bank account activity, enter the amount below': {
		translation:
			'After it appears in your bank account activity, enter the amount below',
	},
	'After logging into OneLogin, locate the following information in their system (you will need to copy and paste this information into your BambooHR account):':
		{
			translation:
				'After logging into OneLogin, locate the following information in their system (you will need to copy and paste this information into your BambooHR account):',
		},
	'After logging into your Instant Payroll account, click on the "Administration" menu and then select "Employee Import." You can then select BambooHR from the employee import options for the list dropdown. You\'ll then be prompted to enter a BambooHR API Key and company sub-domain to link your BambooHR account with your Instant Payroll account. You can then click on the "Validate Data"; button. Note, employee data will not be imported at this time, this will only validate the data connection.':
		{
			translation:
				'After logging into your Instant Payroll account, click on the \\"Administration\\" menu and then select \\"Employee Import.\\" You can then select BambooHR from the employee import options for the list dropdown. You\'ll then be prompted to enter a BambooHR API Key and company sub-domain to link your BambooHR account with your Instant Payroll account. You can then click on the \\"Validate Data\\"; button. Note, employee data will not be imported at this time, this will only validate the data connection.',
		},
	'After logging into your Newton account, click on the name of the employee from the Home Page screen.':
		{
			translation:
				'After logging into your Newton account, click on the name of the employee from the Home Page screen.',
		},
	'After relation option': {
		translation: 'After relation option',
	},
	'After saving the job position information, click the "Push New Hire to BambooHR" link that will appear. This will then send the information about this applicant over to BambooHR and automatically create a new employee record.':
		{
			translation:
				'After saving the job position information, click the \\"Push New Hire to BambooHR\\" link that will appear. This will then send the information about this applicant over to BambooHR and automatically create a new employee record.',
		},
	'After the app is installed, you can access RightSignature documents under the Reports section of BambooHR by clicking on "Signed Documents". You\'ll then need to click on the "Enable" button which will take you to RightSignature to login to your account and authorize BambooHR access to your account.':
		{
			translation:
				'After the app is installed, you can access RightSignature documents under the Reports section of BambooHR by clicking on \\"Signed Documents\\". You\'ll then need to click on the \\"Enable\\" button which will take you to RightSignature to login to your account and authorize BambooHR access to your account.',
		},
	'After the information has been pushed to BambooHR, the link on the applicant screen will change to show "Jump to BambooHR". Clicking this link will then take you to the employee record within BambooHR.':
		{
			translation:
				'After the information has been pushed to BambooHR, the link on the applicant screen will change to show \\"Jump to BambooHR\\". Clicking this link will then take you to the employee record within BambooHR.',
		},
	"After you configure OrgChart Now to connect to your BambooHR account, you can use the Import Wizard to create org charts. In less then 3 minutes, you'll have professional quality org charts that you can publish to PDF or PowerPoint. In addition, you can save copies of your org charts and then use drag and drop tools to edit.":
		{
			translation:
				"After you configure OrgChart Now to connect to your BambooHR account, you can use the Import Wizard to create org charts. In less then 3 minutes, you'll have professional quality org charts that you can publish to PDF or PowerPoint. In addition, you can save copies of your org charts and then use drag and drop tools to edit.",
		},
	'After you set up the integration, PayScale will get your employee information from BambooHR via API and update your employees in Insight.':
		{
			translation:
				'After you set up the integration, PayScale will get your employee information from BambooHR via API and update your employees in Insight.',
		},
	"After you've started the integration in Cronofy, click the “install” button below and you're done! Now you can schedule interviews inside BambooHR ATS.":
		{
			translation:
				"After you've started the integration in Cronofy, click the “install” button below and you're done! Now you can schedule interviews inside BambooHR ATS.",
		},
	'After your API settings have been saved, you can then import and export information between Simplepay.ca and BambooHR.':
		{
			translation:
				'After your API settings have been saved, you can then import and export information between Simplepay.ca and BambooHR.',
		},
	'Again, if you have any questions please %1$semail%2$s %3$s.': {
		translation: 'Again, if you have any questions please %1$semail%2$s %3$s.',
	},
	'Again, if you have any questions please %1$semail%2$s or call %3$s at %4$s ext. %5$s.':
		{
			translation:
				'Again, if you have any questions please %1$semail%2$s or call %3$s at %4$s ext. %5$s.',
		},
	'Again, if you have any questions please %1$semail%2$s or call %3$s at %4$s.':
		{
			translation:
				'Again, if you have any questions please %1$semail%2$s or call %3$s at %4$s.',
		},
	'Again, if you have any questions please call %1$s at %2$s ext. %3$s.': {
		translation:
			'Again, if you have any questions please call %1$s at %2$s ext. %3$s.',
	},
	'Again, if you have any questions please call %1$s at %2$s.': {
		translation: 'Again, if you have any questions please call %1$s at %2$s.',
	},
	Age: {
		translation: 'Age',
	},
	'Age Bar Chart': {
		translation: 'Age Bar Chart',
	},
	'Age Breakdown': {
		translation: 'Age Breakdown',
	},
	'Age Breakdown By Department': {
		translation: 'Age Breakdown By Department',
	},
	'Age Donut Chart': {
		translation: 'Age Donut Chart',
	},
	'Age Profile': {
		translation: 'Age Profile',
	},
	'Age Profile Report': {
		translation: 'Age Profile Report',
	},
	'Age: ': {
		translation: 'Age: ',
	},
	'Agency Refund': {
		translation: 'Agency Refund',
	},
	'Agency Refund Details': {
		translation: 'Agency Refund Details',
	},
	'Agency Refund Notice': {
		translation: 'Agency Refund Notice',
	},
	'Agency Refund Total': {
		translation: 'Agency Refund Total',
	},
	'Agency Refunds': {
		translation: 'Agency Refunds',
	},
	Agender: {
		translation: 'Agender',
	},
	Agree: {
		translation: 'Agree',
	},
	'Agree to the Terms of Use': {
		translation: 'Agree to the Terms of Use',
	},
	'Alert Customizations (Optional)': {
		translation: 'Alert Customizations (Optional)',
	},
	'Alert Date': {
		translation: 'Alert Date',
	},
	'Alert Field': {
		translation: 'Alert Field',
	},
	'Alert name': {
		translation: 'Alert name',
	},
	'Alert will include information about all employees': {
		translation: 'Alert will include information about all employees',
	},
	'Alert will include information about all employees.': {
		translation: 'Alert will include information about all employees.',
	},
	'Alert will only include information about that employee': {
		translation: 'Alert will only include information about that employee',
	},
	'Alert will only include information about that employee.': {
		translation: 'Alert will only include information about that employee.',
	},
	'Alert will only include information about their direct reports': {
		translation:
			'Alert will only include information about their direct reports',
	},
	'Alert will only include information about their direct reports.': {
		translation:
			'Alert will only include information about their direct reports.',
	},
	Alerts: {
		translation: 'Alerts',
	},
	'Aligns with:': {
		translation: 'Aligns with:',
	},
	All: {
		translation: 'All',
	},
	'All %1$s payroll types allowed are already in use': {
		translation: 'All %1$s payroll types allowed are already in use',
	},
	'All %1$s pending signatures for %2$s were cancelled.': {
		translation: 'All %1$s pending signatures for %2$s were cancelled.',
	},
	'All (%1)': {
		translation: 'All (%1)',
	},
	'All APIs': {
		translation: 'All APIs',
	},
	'All Apps': {
		translation: 'All Apps',
	},
	'All Changes': {
		translation: 'All Changes',
	},
	'All Company Items': {
		translation: 'All Company Items',
	},
	'All Current And Future Time Off Categories': {
		translation: 'All Current And Future Time Off Categories',
	},
	'All Current And Future Time Off Types': {
		translation: 'All Current And Future Time Off Types',
	},
	'All Current and Future Time Off Categories': {
		translation: 'All Current and Future Time Off Categories',
	},
	'All Current and Future Time Off Types': {
		translation: 'All Current and Future Time Off Types',
	},
	'All Data': {
		translation: 'All Data',
	},
	'All Departments': {
		translation: 'All Departments',
	},
	'All Departments/Divisions': {
		translation: 'All Departments/Divisions',
	},
	'All Employees': {
		translation: 'All Employees',
	},
	'All Employees in your Company currently have an active Access Level': {
		translation:
			'All Employees in your Company currently have an active Access Level',
	},
	'All Employees were included in this Review Period': {
		translation: 'All Employees were included in this Review Period',
	},
	'All Event Types': {
		translation: 'All Event Types',
	},
	'All Fields': {
		translation: 'All Fields',
	},
	'All Fields are set to %1$s': {
		translation: 'All Fields are set to %1$s',
	},
	'All Fields are set to **{1}**': {
		translation: 'All Fields are set to **{1}**',
	},
	'All Files': {
		translation: 'All Files',
	},
	'All In': {
		translation: 'All In',
	},
	'All Job Openings': {
		translation: 'All Job Openings',
	},
	'All Of': {
		translation: 'All Of',
	},
	'All Offboarding Tasks Completed on %1$s': {
		translation: 'All Offboarding Tasks Completed on %1$s',
	},
	'All Onboarding Tasks Completed on %1$s': {
		translation: 'All Onboarding Tasks Completed on %1$s',
	},
	'All Other Departments': {
		translation: 'All Other Departments',
	},
	'All Other Divisions': {
		translation: 'All Other Divisions',
	},
	'All Other Locations': {
		translation: 'All Other Locations',
	},
	'All Pay Groups': {
		translation: 'All Pay Groups',
	},
	'All Performance features have been disabled.': {
		translation: 'All Performance features have been disabled.',
	},
	'All Posts': {
		translation: 'All Posts',
	},
	'All Projects': {
		translation: 'All Projects',
	},
	'All Responses': {
		translation: 'All Responses',
	},
	'All Sales Reps': {
		translation: 'All Sales Reps',
	},
	'All Statuses': {
		translation: 'All Statuses',
	},
	'All Synced!': {
		translation: 'All Synced!',
	},
	'All Tags': {
		translation: 'All Tags',
	},
	'All Topics': {
		translation: 'All Topics',
	},
	'All Types': {
		translation: 'All Types',
	},
	'All Webhooks': {
		translation: 'All Webhooks',
	},
	'All accruals and carryover events since ${recalcDate} will be recalculated':
		{
			translation:
				'All accruals and carryover events since ${recalcDate} will be recalculated',
		},
	'All benefit plans and employee enrollments successfully deleted.': {
		translation:
			'All benefit plans and employee enrollments successfully deleted.',
	},
	'All current and future folders are set to %1$s': {
		translation: 'All current and future folders are set to %1$s',
	},
	"All data between the systems is kept in sync automatically so you don't have to worry about updating multiple systems. This integration will allow you to do the following:":
		{
			translation:
				"All data between the systems is kept in sync automatically so you don't have to worry about updating multiple systems. This integration will allow you to do the following:",
		},
	'All dbs query files are only available to download for thirty days': {
		translation:
			'All dbs query files are only available to download for thirty days',
	},
	'All employees': {
		translation: 'All employees',
	},
	'All fields have been added': {
		translation: 'All fields have been added',
	},
	'All forms as one PDF file': {
		translation: 'All forms as one PDF file',
	},
	'All future approvals will follow this pattern.': {
		translation: 'All future approvals will follow this pattern.',
	},
	'All goals appear to be on track and none are past due.': {
		translation: 'All goals appear to be on track and none are past due.',
	},
	'All locations': {
		translation: 'All locations',
	},
	'All non-benefit deductions for my employees have been added. Onward!': {
		translation:
			'All non-benefit deductions for my employees have been added. Onward!',
	},
	'All non-sensitive employee-related information': {
		translation: 'All non-sensitive employee-related information',
	},
	'All of your **Paid** Time Off types need to be set to **hours, not days**. These types are currently set to days and need to be updated.':
		{
			translation:
				'All of your **Paid** Time Off types need to be set to **hours, not days**. These types are currently set to days and need to be updated.',
		},
	"All of your employee need to be in a pay group (even if you're not paying them through Bamboo Payroll).":
		{
			translation:
				"All of your employee need to be in a pay group (even if you're not paying them through Bamboo Payroll).",
		},
	'All performance features are disabled': {
		translation: 'All performance features are disabled',
	},
	'All ratings need to have a value.': {
		translation: 'All ratings need to have a value.',
	},
	'All recipients': {
		translation: 'All recipients',
	},
	'All required items are complete': {
		translation: 'All required items are complete',
	},
	'All rights reserved': {
		translation: 'All rights reserved',
	},
	'All rights reserved.': {
		translation: 'All rights reserved.',
	},
	'All set! Everyone has W-4 withholding info.': {
		translation: 'All set! Everyone has W-4 withholding info.',
	},
	'All set! Your group email is scheduled and will be sent on %1$s!': {
		translation:
			'All set! Your group email is scheduled and will be sent on %1$s!',
	},
	'All tabs have been added': {
		translation: 'All tabs have been added',
	},
	'All tax documents have been sent to employees': {
		translation: 'All tax documents have been sent to employees',
	},
	"All the tasks have already been added! There's nothing left to import.": {
		translation:
			"All the tasks have already been added! There's nothing left to import.",
	},
	'All time': {
		translation: 'All time',
	},
	'All time-tracking employees': {
		translation: 'All time-tracking employees',
	},
	'All trainings with this category will be re-assigned to no category. This action cannot be undone.':
		{
			translation:
				'All trainings with this category will be re-assigned to no category. This action cannot be undone.',
		},
	'All users with one of these permissions will have access to the payroll tab in BambooHR and Payroll Reports.':
		{
			translation:
				'All users with one of these permissions will have access to the payroll tab in BambooHR and Payroll Reports.',
		},
	'All your permissions in BambooHR will carry over with the integration.': {
		translation:
			'All your permissions in BambooHR will carry over with the integration.',
	},
	'All {1} Candidates selected.': {
		translation: 'All {1} Candidates selected.',
	},
	Allergies: {
		translation: 'Allergies',
	},
	'Allow Access to BambooHR': {
		translation: 'Allow Access to BambooHR',
	},
	'Allow Employee & Manager to upload files as part of the Assessment': {
		translation:
			'Allow Employee & Manager to upload files as part of the Assessment',
	},
	'Allow Manager and Employee Self-Assessments': {
		translation: 'Allow Manager and Employee Self-Assessments',
	},
	'Allow access to these Dashboard features:': {
		translation: 'Allow access to these Dashboard features:',
	},
	'Allow access to these Folders in Company Files:': {
		translation: 'Allow access to these Folders in Company Files:',
	},
	'Allow assigned employees to mark this training complete': {
		translation: 'Allow assigned employees to mark this training complete',
	},
	'Allow editing and deleting of history line items': {
		translation: 'Allow editing and deleting of history line items',
	},
	'Allow editing and deleting of history line items.': {
		translation: 'Allow editing and deleting of history line items.',
	},
	'Allow editing and deleting of line items on all tables': {
		translation: 'Allow editing and deleting of line items on all tables',
	},
	'Allow employees to create and comment on goals, share them with others, and update their status':
		{
			translation:
				'Allow employees to create and comment on goals, share them with others, and update their status',
		},
	'Allow employees to login with email and password, in addition to Google': {
		translation:
			'Allow employees to login with email and password, in addition to Google',
	},
	'Allow employees to see...': {
		translation: 'Allow employees to see...',
	},
	'Allow employees to upload files to their Employee Uploads folder': {
		translation:
			'Allow employees to upload files to their Employee Uploads folder',
	},
	'Allow employees to upload files to their Employee Uploads folder.': {
		translation:
			'Allow employees to upload files to their Employee Uploads folder.',
	},
	'Allow employees to upload their own photos, regardless of other permissions':
		{
			translation:
				'Allow employees to upload their own photos, regardless of other permissions',
		},
	'Allow employees to upload their own photos, regardless of other permissions.':
		{
			translation:
				'Allow employees to upload their own photos, regardless of other permissions.',
		},
	'Allow full access to these areas in Settings:': {
		translation: 'Allow full access to these areas in Settings:',
	},
	'Allow it to be seen by...': {
		translation: 'Allow it to be seen by...',
	},
	'Allow optional email & password login': {
		translation: 'Allow optional email & password login',
	},
	'Allow the employee to upload files to this task': {
		translation: 'Allow the employee to upload files to this task',
	},
	'Allow the user to access the Levels and Bands tool, to create, modify, and delete levels, and assign them to job titles. ':
		{
			translation:
				'Allow the user to access the Levels and Bands tool, to create, modify, and delete levels, and assign them to job titles. ',
		},
	'Allow the user to access the Total Rewards tool to add and remove users from Total Rewards':
		{
			translation:
				'Allow the user to access the Total Rewards tool to add and remove users from Total Rewards',
		},
	'Allow the user to access the compensation benchmarking tool to view, create, and edit compensation benchmarks.':
		{
			translation:
				'Allow the user to access the compensation benchmarking tool to view, create, and edit compensation benchmarks.',
		},
	'Allow the user to access the compensation planning tool to create, edit, close compensation cycles, and make changes to worksheets, and view employee compensation data.':
		{
			translation:
				'Allow the user to access the compensation planning tool to create, edit, close compensation cycles, and make changes to worksheets, and view employee compensation data.',
		},
	'Allow them to see the same info about themselves as they can see about others.':
		{
			translation:
				'Allow them to see the same info about themselves as they can see about others.',
		},
	'Allow this person to access TRAXPayroll from the payroll tab in BambooHR': {
		translation:
			'Allow this person to access TRAXPayroll from the payroll tab in BambooHR',
	},
	'Allows access to API': {
		translation: 'Allows access to API',
	},
	'Allows access to all authorized scopes for all employees. Must be installed by an admin.':
		{
			translation:
				'Allows access to all authorized scopes for all employees. Must be installed by an admin.',
		},
	'Allows access to all fields': {
		translation: 'Allows access to all fields',
	},
	'Allows access to employee payroll provider information': {
		translation: 'Allows access to employee payroll provider information',
	},
	'Allows access to employee provider information': {
		translation: 'Allows access to employee provider information',
	},
	'Allows access to payroll related fields': {
		translation: 'Allows access to payroll related fields',
	},
	'Allows access to query custom reports and creation of bulk data requests': {
		translation:
			'Allows access to query custom reports and creation of bulk data requests',
	},
	'Allows the application to authenticate with BambooHR': {
		translation: 'Allows the application to authenticate with BambooHR',
	},
	'Allows the application to reauthenticate to BambooHR with a refresh token': {
		translation:
			'Allows the application to reauthenticate to BambooHR with a refresh token',
	},
	'Allows them to see the same info about themselves as they can see about others.':
		{
			translation:
				'Allows them to see the same info about themselves as they can see about others.',
		},
	'Allows viewing data cleaning job data.': {
		translation: 'Allows viewing data cleaning job data.',
	},
	'Almost there! Just a few more things to take care of...': {
		translation: 'Almost there! Just a few more things to take care of...',
	},
	'Almost there...': {
		translation: 'Almost there...',
	},
	'Already in Bamboo': {
		translation: 'Already in Bamboo',
	},
	'Already in BambooHR': {
		translation: 'Already in BambooHR',
	},
	'Alright, %1$s can now track time worked and access the timesheet.': {
		translation:
			'Alright, %1$s can now track time worked and access the timesheet.',
	},
	'Alright, %1$s is scheduled to start tracking time on %2$s.': {
		translation: 'Alright, %1$s is scheduled to start tracking time on %2$s.',
	},
	'Alright, %1s is scheduled to start tracking time on %2s.': {
		translation: 'Alright, %1s is scheduled to start tracking time on %2s.',
	},
	'Alright, %s can now track time worked and access the timesheet.': {
		translation:
			'Alright, %s can now track time worked and access the timesheet.',
	},
	'Also Considered For:': {
		translation: 'Also Considered For:',
	},
	'Also applied for...': {
		translation: 'Also applied for...',
	},
	'Also delete completed items': {
		translation: 'Also delete completed items',
	},
	'Also show this information about each employee:': {
		translation: 'Also show this information about each employee:',
	},
	'Also, fields like hire date and date of birth are essential for getting the most out of BambooHR.':
		{
			translation:
				'Also, fields like hire date and date of birth are essential for getting the most out of BambooHR.',
		},
	'Although you are unsharing this document, %1$s can still view it as part of a group. Do you want to proceed?':
		{
			translation:
				'Although you are unsharing this document, %1$s can still view it as part of a group. Do you want to proceed?',
		},
	'Although you are unsharing this document, <strong>%1$s</strong> can still view it as part of a group. Do you want to proceed?':
		{
			translation:
				'Although you are unsharing this document, <strong>%1$s</strong> can still view it as part of a group. Do you want to proceed?',
		},
	'Altius #': {
		translation: 'Altius #',
	},
	'Amendment Pending': {
		translation: 'Amendment Pending',
	},
	'American Express': {
		translation: 'American Express',
	},
	'American Indian or Alaska Native': {
		translation: 'American Indian or Alaska Native',
	},
	Amount: {
		translation: 'Amount',
	},
	'Amount Accrued': {
		translation: 'Amount Accrued',
	},
	'Amount Per Pay Period': {
		translation: 'Amount Per Pay Period',
	},
	'Amount Scheduled': {
		translation: 'Amount Scheduled',
	},
	'Amount Taken (YTD)': {
		translation: 'Amount Taken (YTD)',
	},
	'Amount Tracked In': {
		translation: 'Amount Tracked In',
	},
	'Amount:': {
		translation: 'Amount:',
	},
	'An Error Occurred': {
		translation: 'An Error Occurred',
	},
	'An I-9 has already been created for this employee.': {
		translation: 'An I-9 has already been created for this employee.',
	},
	'An accrual policy defines the rules for how this time off balance will accrue over time.':
		{
			translation:
				'An accrual policy defines the rules for how this time off balance will accrue over time.',
		},
	'An active Advantage Payroll Instant Payroll account is required for this data integration. Please contact BambooHR to get in touch with the independently owned Advantage Payroll office that covers your area.':
		{
			translation:
				'An active Advantage Payroll Instant Payroll account is required for this data integration. Please contact BambooHR to get in touch with the independently owned Advantage Payroll office that covers your area.',
		},
	'An active Newton account is required for this integration. <a href="http://hr.bamboohr.com/newton-referral/">Click here</a> to get started with Newton.':
		{
			translation:
				'An active Newton account is required for this integration. <a href=\\"http://hr.bamboohr.com/newton-referral/\\">Click here</a> to get started with Newton.',
		},
	'An active iApplicants account is required for this data integration. Please visit <a href="http://www.iapplicants.com" target="_blank" rel="noopener noreferrer">www.iapplicants.com</a> for more information.':
		{
			translation:
				'An active iApplicants account is required for this data integration. Please visit <a href=\\"http://www.iapplicants.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">www.iapplicants.com</a> for more information.',
		},
	'An email requesting {1} complete feedback was sent {2}.': {
		translation: 'An email requesting {1} complete feedback was sent {2}.',
	},
	'An email requesting {1} complete peer feedback was sent {2}.': {
		translation: 'An email requesting {1} complete peer feedback was sent {2}.',
	},
	'An email will automatically be sent to the admin with a link to download the export.':
		{
			translation:
				'An email will automatically be sent to the admin with a link to download the export.',
		},
	'An email will be sent to %1$s containing a reset password.': {
		translation: 'An email will be sent to %1$s containing a reset password.',
	},
	'An email with a link to reset their password will be sent to **{1}**': {
		translation:
			'An email with a link to reset their password will be sent to **{1}**',
	},
	'An email with a link to sign the electronic documents will be sent.': {
		translation:
			'An email with a link to sign the electronic documents will be sent.',
	},
	'An email with password reset instructions has been sent to %2$s at %1$s': {
		translation:
			'An email with password reset instructions has been sent to %2$s at %1$s',
	},
	'An employee status with valid dates is required for trax syncing pay schedules':
		{
			translation:
				'An employee status with valid dates is required for trax syncing pay schedules',
		},
	'An employee transitions from Level 1 to Level 2 during the accrual period.':
		{
			translation:
				'An employee transitions from Level 1 to Level 2 during the accrual period.',
		},
	'An employee who is hired to a position for which the annual employment is generally six months or less and begins approximately the same part of the year, such as summer or winter.':
		{
			translation:
				'An employee who is hired to a position for which the annual employment is generally six months or less and begins approximately the same part of the year, such as summer or winter.',
		},
	'An error has occurred while getting the preview, please try again later': {
		translation:
			'An error has occurred while getting the preview, please try again later',
	},
	'An error has occurred while saving, please try again': {
		translation: 'An error has occurred while saving, please try again',
	},
	'An error has occurred while saving.': {
		translation: 'An error has occurred while saving.',
	},
	'An error has occurred.': {
		translation: 'An error has occurred.',
	},
	'An error occured while processing your request': {
		translation: 'An error occured while processing your request',
	},
	'An error occurred': {
		translation: 'An error occurred',
	},
	'An error occurred attempting to authenticate your account and tokens': {
		translation:
			'An error occurred attempting to authenticate your account and tokens',
	},
	'An error occurred configuring Netsuite.': {
		translation: 'An error occurred configuring Netsuite.',
	},
	'An error occurred saving this record.': {
		translation: 'An error occurred saving this record.',
	},
	'An error occurred try to get data from elastic search': {
		translation: 'An error occurred try to get data from elastic search',
	},
	'An error occurred trying to delete the template. Please try again.': {
		translation:
			'An error occurred trying to delete the template. Please try again.',
	},
	'An error occurred trying to save the template.  Please check your user and get to know you recipient values and try again.':
		{
			translation:
				'An error occurred trying to save the template.  Please check your user and get to know you recipient values and try again.',
		},
	'An error occurred when attempting to login using this ticket, please try again or contact support.':
		{
			translation:
				'An error occurred when attempting to login using this ticket, please try again or contact support.',
		},
	'An error occurred when attempting to share a folder.': {
		translation: 'An error occurred when attempting to share a folder.',
	},
	'An error occurred when trying to copy the benefit group.': {
		translation: 'An error occurred when trying to copy the benefit group.',
	},
	'An error occurred when trying to get goal settings.': {
		translation: 'An error occurred when trying to get goal settings.',
	},
	'An error occurred when trying to save goal settings.': {
		translation: 'An error occurred when trying to save goal settings.',
	},
	'An error occurred when trying to the delete review cycle configuration.': {
		translation:
			'An error occurred when trying to the delete review cycle configuration.',
	},
	'An error occurred when trying to update the review cycle configuration.': {
		translation:
			'An error occurred when trying to update the review cycle configuration.',
	},
	'An error occurred while adding this benefit group to the benefit plan. ': {
		translation:
			'An error occurred while adding this benefit group to the benefit plan. ',
	},
	'An error occurred while creating attached eSignatures. Please try again later.':
		{
			translation:
				'An error occurred while creating attached eSignatures. Please try again later.',
		},
	'An error occurred while deleting the plan from the benefit group': {
		translation:
			'An error occurred while deleting the plan from the benefit group',
	},
	'An error occurred while deleting this benefit group': {
		translation: 'An error occurred while deleting this benefit group',
	},
	'An error occurred while deleting this benefit plan coverage': {
		translation: 'An error occurred while deleting this benefit plan coverage',
	},
	'An error occurred while deleting this goal': {
		translation: 'An error occurred while deleting this goal',
	},
	'An error occurred while disabling BambooHR payroll.': {
		translation: 'An error occurred while disabling BambooHR payroll.',
	},
	'An error occurred while disabling offer letter tool. ': {
		translation: 'An error occurred while disabling offer letter tool. ',
	},
	'An error occurred while enabling BambooHR payroll. ': {
		translation: 'An error occurred while enabling BambooHR payroll. ',
	},
	'An error occurred while enabling offer letter tool. ': {
		translation: 'An error occurred while enabling offer letter tool. ',
	},
	'An error occurred while loading the page data. Please try again.': {
		translation:
			'An error occurred while loading the page data. Please try again.',
	},
	'An error occurred while logging in. Please wait a few seconds and try again.':
		{
			translation:
				'An error occurred while logging in. Please wait a few seconds and try again.',
		},
	'An error occurred while processing your request': {
		translation: 'An error occurred while processing your request',
	},
	'An error occurred while saving this benefit group': {
		translation: 'An error occurred while saving this benefit group',
	},
	'An error occurred while saving this benefit plan coverage': {
		translation: 'An error occurred while saving this benefit plan coverage',
	},
	'An error occurred while saving this benefit plan coverage: ': {
		translation: 'An error occurred while saving this benefit plan coverage: ',
	},
	'An error occurred while trying to calculate the future balances': {
		translation:
			'An error occurred while trying to calculate the future balances',
	},
	'An error occurred while trying to complete the goal. Please try again.': {
		translation:
			'An error occurred while trying to complete the goal. Please try again.',
	},
	'An error occurred while trying to create a data benchmarking agreement.': {
		translation:
			'An error occurred while trying to create a data benchmarking agreement.',
	},
	'An error occurred while trying to create a report folder.': {
		translation: 'An error occurred while trying to create a report folder.',
	},
	'An error occurred while trying to create the impromptu assessment.': {
		translation:
			'An error occurred while trying to create the impromptu assessment.',
	},
	'An error occurred while trying to get information about performance tools.':
		{
			translation:
				'An error occurred while trying to get information about performance tools.',
		},
	'An error occurred while trying to get new review cycle data.': {
		translation: 'An error occurred while trying to get new review cycle data.',
	},
	'An error occurred while trying to get the Review Cycle Configuration.': {
		translation:
			'An error occurred while trying to get the Review Cycle Configuration.',
	},
	'An error occurred while trying to retrieve data benchmarking agreements.': {
		translation:
			'An error occurred while trying to retrieve data benchmarking agreements.',
	},
	'An error occurred while trying to retrieve signed documents.': {
		translation: 'An error occurred while trying to retrieve signed documents.',
	},
	'An error occurred while trying to update data benchmarking agreements.': {
		translation:
			'An error occurred while trying to update data benchmarking agreements.',
	},
	'An error occurred while unlocking the assessment': {
		translation: 'An error occurred while unlocking the assessment',
	},
	'An error occurred while unlocking the assessment.': {
		translation: 'An error occurred while unlocking the assessment.',
	},
	'An error occurred while updating the publish date.': {
		translation: 'An error occurred while updating the publish date.',
	},
	'An error occurred while updating this benefit group': {
		translation: 'An error occurred while updating this benefit group',
	},
	'An error occurred while validating LinkedIn location.': {
		translation: 'An error occurred while validating LinkedIn location.',
	},
	'An error occurred.': {
		translation: 'An error occurred.',
	},
	'An error occurred. Please try again.': {
		translation: 'An error occurred. Please try again.',
	},
	'An error occurred. Some files were not deleted.': {
		translation: 'An error occurred. Some files were not deleted.',
	},
	'An exception occurred while gathering candidate list data.': {
		translation: 'An exception occurred while gathering candidate list data.',
	},
	'An invite will be sent to this email address.': {
		translation: 'An invite will be sent to this email address.',
	},
	'An offboarding task has been assigned to you.': {
		translation: 'An offboarding task has been assigned to you.',
	},
	'An offer was sent to %1$s on %2$s': {
		translation: 'An offer was sent to %1$s on %2$s',
	},
	'An offer was sent to **{1}** on {2}.': {
		translation: 'An offer was sent to **{1}** on {2}.',
	},
	'An onboarding task has been assigned to you.': {
		translation: 'An onboarding task has been assigned to you.',
	},
	'An unexpected error occurred': {
		translation: 'An unexpected error occurred',
	},
	'An unexpected error occurred while adding a report to favorites.': {
		translation:
			'An unexpected error occurred while adding a report to favorites.',
	},
	'An unexpected error occurred while adding a report.': {
		translation: 'An unexpected error occurred while adding a report.',
	},
	'An unexpected error occurred while closing an Employee Wellbeing survey.': {
		translation:
			'An unexpected error occurred while closing an Employee Wellbeing survey.',
	},
	'An unexpected error occurred while removing a report from favorites.': {
		translation:
			'An unexpected error occurred while removing a report from favorites.',
	},
	'An unexpected error occurred while retrieving favorite reports.': {
		translation:
			'An unexpected error occurred while retrieving favorite reports.',
	},
	'An unexpected error occurred while retrieving my reports.': {
		translation: 'An unexpected error occurred while retrieving my reports.',
	},
	'An unexpected error occurred while retrieving recent reports.': {
		translation:
			'An unexpected error occurred while retrieving recent reports.',
	},
	'An unexpected error occurred while retrieving reports from the specified report folder.':
		{
			translation:
				'An unexpected error occurred while retrieving reports from the specified report folder.',
		},
	'An unexpected error occurred while sending survey notifications.': {
		translation:
			'An unexpected error occurred while sending survey notifications.',
	},
	'An unexpected error occurred while sending survey reminders.': {
		translation: 'An unexpected error occurred while sending survey reminders.',
	},
	'An unexpected error occurred while setting your favorite reports.': {
		translation:
			'An unexpected error occurred while setting your favorite reports.',
	},
	'An unexpected error occurred while starting the next Employee Wellbeing survey.':
		{
			translation:
				'An unexpected error occurred while starting the next Employee Wellbeing survey.',
		},
	'An unexpected error occurred while trying to retrieve legacy reports.': {
		translation:
			'An unexpected error occurred while trying to retrieve legacy reports.',
	},
	'An unexpected error occurred while trying to retrieve one or multiple standard reports.':
		{
			translation:
				'An unexpected error occurred while trying to retrieve one or multiple standard reports.',
		},
	'An unexpected error occurred while trying to trigger a new Data Benchmarking Agreement.':
		{
			translation:
				'An unexpected error occurred while trying to trigger a new Data Benchmarking Agreement.',
		},
	'An unexpected error occurred while updating a report folder.': {
		translation: 'An unexpected error occurred while updating a report folder.',
	},
	'An unexpected error occurred with Employee Wellbeing.': {
		translation: 'An unexpected error occurred with Employee Wellbeing.',
	},
	'An unexpected error occurred with the Employee Wellbeing cron (Process Flow).':
		{
			translation:
				'An unexpected error occurred with the Employee Wellbeing cron (Process Flow).',
		},
	'An unexpected error occurred.': {
		translation: 'An unexpected error occurred.',
	},
	'An unexpected error occurred. Please try again.': {
		translation: 'An unexpected error occurred. Please try again.',
	},
	'An unexpected error occurred. The survey has already started.': {
		translation:
			'An unexpected error occurred. The survey has already started.',
	},
	'An unexpected error occurred. The survey is already closed.': {
		translation: 'An unexpected error occurred. The survey is already closed.',
	},
	And: {
		translation: 'And',
	},
	"And don't worry - we'll always reach out if we have any questions.": {
		translation:
			"And don't worry - we'll always reach out if we have any questions.",
	},
	Androgyne: {
		translation: 'Androgyne',
	},
	Anniversaries: {
		translation: 'Anniversaries',
	},
	'Anniversaries & Birthdays': {
		translation: 'Anniversaries & Birthdays',
	},
	Anniversary: {
		translation: 'Anniversary',
	},
	Announcement: {
		translation: 'Announcement',
	},
	'Announcement Title': {
		translation: 'Announcement Title',
	},
	'Announcement deleted': {
		translation: 'Announcement deleted',
	},
	Announcements: {
		translation: 'Announcements',
	},
	'Announcements will appear on the BambooHR Home for employees you include below.':
		{
			translation:
				'Announcements will appear on the BambooHR Home for employees you include below.',
		},
	Annual: {
		translation: 'Annual',
	},
	'Annual Amount': {
		translation: 'Annual Amount',
	},
	'Annual Dates': {
		translation: 'Annual Dates',
	},
	'Annual Gross Salary': {
		translation: 'Annual Gross Salary',
	},
	'Annual Max': {
		translation: 'Annual Max',
	},
	'Annual Max:': {
		translation: 'Annual Max:',
	},
	'Annual PTO': {
		translation: 'Annual PTO',
	},
	'Annual Pay Increase': {
		translation: 'Annual Pay Increase',
	},
	'Annual Percentage': {
		translation: 'Annual Percentage',
	},
	'Annual Percentage must be a number': {
		translation: 'Annual Percentage must be a number',
	},
	'Annual Security Training': {
		translation: 'Annual Security Training',
	},
	'Annual Vest Amount': {
		translation: 'Annual Vest Amount',
	},
	'Annual Vest Date': {
		translation: 'Annual Vest Date',
	},
	'Annual Withholding Allowance': {
		translation: 'Annual Withholding Allowance',
	},
	'Annual earnings': {
		translation: 'Annual earnings',
	},
	'Annualized Rate': {
		translation: 'Annualized Rate',
	},
	Annually: {
		translation: 'Annually',
	},
	'Another entry in this request has an error.': {
		translation: 'Another entry in this request has an error.',
	},
	'Another win! Thanks for accepting our Data Processing Agreement.': {
		translation:
			'Another win! Thanks for accepting our Data Processing Agreement.',
	},
	'Answers are hidden while previewing as another user.': {
		translation: 'Answers are hidden while previewing as another user.',
	},
	'Answers will be hidden': {
		translation: 'Answers will be hidden',
	},
	Antibody: {
		translation: 'Antibody',
	},
	Antigen: {
		translation: 'Antigen',
	},
	Any: {
		translation: 'Any',
	},
	'Any additions or changes to select personal and job information of employees are automatically pushed to Google Cloud Identity within one minute.':
		{
			translation:
				'Any additions or changes to select personal and job information of employees are automatically pushed to Google Cloud Identity within one minute.',
		},
	'Any additions or changes to select personal and job information of employees are automatically pushed to Jump Cloud within one minute.':
		{
			translation:
				'Any additions or changes to select personal and job information of employees are automatically pushed to Jump Cloud within one minute.',
		},
	'Any additions or changes to select personal and job information of employees are automatically pushed to JumpCloud within one minute.':
		{
			translation:
				'Any additions or changes to select personal and job information of employees are automatically pushed to JumpCloud within one minute.',
		},
	'Any additions or changes to select personal and job information of employees are automatically pushed to NetSuite within one minute.':
		{
			translation:
				'Any additions or changes to select personal and job information of employees are automatically pushed to NetSuite within one minute.',
		},
	'Any associated attachments or replies will also be deleted.': {
		translation: 'Any associated attachments or replies will also be deleted.',
	},
	'Any employee who was not treated as a full-time employee for one or more months of the calendar year under the look-back measurement method for determining full-time employee status under the employer shared responsiblity provisions.':
		{
			translation:
				'Any employee who was not treated as a full-time employee for one or more months of the calendar year under the look-back measurement method for determining full-time employee status under the employer shared responsiblity provisions.',
		},
	'Any employee who was not treated as a full-time employee for one or more months of the calendar year under the look-back measurement method.':
		{
			translation:
				'Any employee who was not treated as a full-time employee for one or more months of the calendar year under the look-back measurement method.',
		},
	'Any employee who was treated as a full-time employee for one or more months of the calendar year under the look-back measurement method for determining full-time employee status under the employer shared responsiblity provisions.':
		{
			translation:
				'Any employee who was treated as a full-time employee for one or more months of the calendar year under the look-back measurement method for determining full-time employee status under the employer shared responsiblity provisions.',
		},
	'Any employee who was treated as a full-time employee for one or more months of the calendar year under the look-back measurement method.':
		{
			translation:
				'Any employee who was treated as a full-time employee for one or more months of the calendar year under the look-back measurement method.',
		},
	'Any in-progress signatures will not be removed.': {
		translation: 'Any in-progress signatures will not be removed.',
	},
	'Any pending or complete signature requests will be canceled and discarded if you change the offer template.':
		{
			translation:
				'Any pending or complete signature requests will be canceled and discarded if you change the offer template.',
		},
	"Anything you'd like to add?": {
		translation: "Anything you'd like to add?",
	},
	'Anywhere it is used': {
		translation: 'Anywhere it is used',
	},
	'Apollo login': {
		translation: 'Apollo login',
	},
	'App Details': {
		translation: 'App Details',
	},
	'App Info': {
		translation: 'App Info',
	},
	'App Integrations': {
		translation: 'App Integrations',
	},
	'App Settings': {
		translation: 'App Settings',
	},
	Applicable: {
		translation: 'Applicable',
	},
	'Applicant Info': {
		translation: 'Applicant Info',
	},
	'Applicant Photo': {
		translation: 'Applicant Photo',
	},
	'Applicant Rating': {
		translation: 'Applicant Rating',
	},
	'Applicant Source Report': {
		translation: 'Applicant Source Report',
	},
	'Applicant Status has been successfully enabled.': {
		translation: 'Applicant Status has been successfully enabled.',
	},
	'Applicant Status has been successfully removed.': {
		translation: 'Applicant Status has been successfully removed.',
	},
	'Applicant for %1s': {
		translation: 'Applicant for %1s',
	},
	'ApplicantPRO™ integrates with BambooHR through our API. When you are ready to hire an applicant, simply click to export them over to BambooHR and a new employee record will automatically be created and populated with the following information:':
		{
			translation:
				'ApplicantPRO™ integrates with BambooHR through our API. When you are ready to hire an applicant, simply click to export them over to BambooHR and a new employee record will automatically be created and populated with the following information:',
		},
	'ApplicantPro is affordable, easy to use hiring software that was built to simplify every step in your hiring process. We give you a branded career site, automatic push to job boards (free and paid), posting to social media, email templates, ability to screen applicants, unlimited free manager logins for collaboration, online employment applications, electronic resume collection, reporting (including EEO and OFCCP) and much more.':
		{
			translation:
				'ApplicantPro is affordable, easy to use hiring software that was built to simplify every step in your hiring process. We give you a branded career site, automatic push to job boards (free and paid), posting to social media, email templates, ability to screen applicants, unlimited free manager logins for collaboration, online employment applications, electronic resume collection, reporting (including EEO and OFCCP) and much more.',
		},
	Applicants: {
		translation: 'Applicants',
	},
	'Applicants by Disability and Gender': {
		translation: 'Applicants by Disability and Gender',
	},
	'Applicants by Race and Gender': {
		translation: 'Applicants by Race and Gender',
	},
	'Applicants by Veteran Status and Gender': {
		translation: 'Applicants by Veteran Status and Gender',
	},
	Application: {
		translation: 'Application',
	},
	'Application Date': {
		translation: 'Application Date',
	},
	'Application Questions': {
		translation: 'Application Questions',
	},
	'Application Questions for this Job': {
		translation: 'Application Questions for this Job',
	},
	'Application Questions from %s': {
		translation: 'Application Questions from %s',
	},
	'Application Status': {
		translation: 'Application Status',
	},
	'Application filter defaults updated successfully': {
		translation: 'Application filter defaults updated successfully',
	},
	'Application filters saved successfully': {
		translation: 'Application filters saved successfully',
	},
	'Application not found': {
		translation: 'Application not found',
	},
	'Application not found.': {
		translation: 'Application not found.',
	},
	'Application status': {
		translation: 'Application status',
	},
	Applied: {
		translation: 'Applied',
	},
	'Applied For': {
		translation: 'Applied For',
	},
	'Applied for **{1}**': {
		translation: 'Applied for **{1}**',
	},
	'Applied on': {
		translation: 'Applied on',
	},
	'Applied on %s (%s)': {
		translation: 'Applied on %s (%s)',
	},
	'Applied on: ': {
		translation: 'Applied on: ',
	},
	'Applied to [**{1}**]': {
		translation: 'Applied to [**{1}**]',
	},
	Applied_Filters: {
		translation: 'Applied_Filters',
	},
	Apply: {
		translation: 'Apply',
	},
	'Apply Existing Plan': {
		translation: 'Apply Existing Plan',
	},
	'Apply Initials': {
		translation: 'Apply Initials',
	},
	'Apply Plan': {
		translation: 'Apply Plan',
	},
	'Apply Signature': {
		translation: 'Apply Signature',
	},
	'Apply an Existing Plan': {
		translation: 'Apply an Existing Plan',
	},
	'Apply for This Job': {
		translation: 'Apply for This Job',
	},
	'Apply for this Job': {
		translation: 'Apply for this Job',
	},
	'Apply for this Position': {
		translation: 'Apply for this Position',
	},
	'Approval Actions': {
		translation: 'Approval Actions',
	},
	'Approval Added': {
		translation: 'Approval Added',
	},
	'Approval Description': {
		translation: 'Approval Description',
	},
	'Approval Details': {
		translation: 'Approval Details',
	},
	'Approval Disabled': {
		translation: 'Approval Disabled',
	},
	'Approval Fields': {
		translation: 'Approval Fields',
	},
	'Approval Name': {
		translation: 'Approval Name',
	},
	'Approval Paths by Department': {
		translation: 'Approval Paths by Department',
	},
	'Approval Paths by Division': {
		translation: 'Approval Paths by Division',
	},
	'Approval Paths by Location': {
		translation: 'Approval Paths by Location',
	},
	'Approval Updated': {
		translation: 'Approval Updated',
	},
	'Approval due': {
		translation: 'Approval due',
	},
	'Approval due %1$s at %2$s': {
		translation: 'Approval due %1$s at %2$s',
	},
	'Approval due %1s at %2s (%3s).': {
		translation: 'Approval due %1s at %2s (%3s).',
	},
	'Approval name must be unique.': {
		translation: 'Approval name must be unique.',
	},
	'Approval path deleted.': {
		translation: 'Approval path deleted.',
	},
	'Approval updated!': {
		translation: 'Approval updated!',
	},
	'Approval was disabled': {
		translation: 'Approval was disabled',
	},
	'Approval was enabled': {
		translation: 'Approval was enabled',
	},
	Approvals: {
		translation: 'Approvals',
	},
	'Approvals due date must be after recommendations due date.': {
		translation: 'Approvals due date must be after recommendations due date.',
	},
	'Approvals due date must be within cycle dates.': {
		translation: 'Approvals due date must be within cycle dates.',
	},
	Approve: {
		translation: 'Approve',
	},
	'Approve All': {
		translation: 'Approve All',
	},
	'Approve All Hours': {
		translation: 'Approve All Hours',
	},
	'Approve Anyway': {
		translation: 'Approve Anyway',
	},
	'Approve Collection': {
		translation: 'Approve Collection',
	},
	'Approve Hours': {
		translation: 'Approve Hours',
	},
	'Approve Payroll': {
		translation: 'Approve Payroll',
	},
	'Approve Request': {
		translation: 'Approve Request',
	},
	'Approve Requests': {
		translation: 'Approve Requests',
	},
	'Approve Timesheets': {
		translation: 'Approve Timesheets',
	},
	'Approve all': {
		translation: 'Approve all',
	},
	'Approve any timesheets they are able to view.': {
		translation: 'Approve any timesheets they are able to view.',
	},
	Approved: {
		translation: 'Approved',
	},
	'Approved Hours': {
		translation: 'Approved Hours',
	},
	'Approved by %1$s on %2$s.': {
		translation: 'Approved by %1$s on %2$s.',
	},
	'Approved to Process': {
		translation: 'Approved to Process',
	},
	'Approved!': {
		translation: 'Approved!',
	},
	'Approved, Pending Wire Transfer': {
		translation: 'Approved, Pending Wire Transfer',
	},
	'Approved?': {
		translation: 'Approved?',
	},
	Approver: {
		translation: 'Approver',
	},
	Apps: {
		translation: 'Apps',
	},
	'Apps Settings': {
		translation: 'Apps Settings',
	},
	'Apps Usage': {
		translation: 'Apps Usage',
	},
	Apr: {
		translation: 'Apr',
	},
	April: {
		translation: 'April',
	},
	Archive: {
		translation: 'Archive',
	},
	Archived: {
		translation: 'Archived',
	},
	'Are You Sure? You May Lose Access...': {
		translation: 'Are You Sure? You May Lose Access...',
	},
	'Are you ready to enable time tracking?': {
		translation: 'Are you ready to enable time tracking?',
	},
	'Are you ready to enable time tracking? Your employees will be able to start tracking their time through BambooHR immediately.':
		{
			translation:
				'Are you ready to enable time tracking? Your employees will be able to start tracking their time through BambooHR immediately.',
		},
	'Are you ready to submit this completed assessment?': {
		translation: 'Are you ready to submit this completed assessment?',
	},
	'Are you still interested in seeing a demo of how it works?': {
		translation: 'Are you still interested in seeing a demo of how it works?',
	},
	'Are you sure that you want to disable ACA Tracking?': {
		translation: 'Are you sure that you want to disable ACA Tracking?',
	},
	'Are you sure that you want to permanently delete this plan and unenroll %1$s employee?':
		{
			translation:
				'Are you sure that you want to permanently delete this plan and unenroll %1$s employee?',
		},
	'Are you sure that you want to permanently delete this plan and unenroll %1$s employees?':
		{
			translation:
				'Are you sure that you want to permanently delete this plan and unenroll %1$s employees?',
		},
	'Are you sure that you want to permanently delete this plan and unenroll 1 employee?':
		{
			translation:
				'Are you sure that you want to permanently delete this plan and unenroll 1 employee?',
		},
	'Are you sure that you want to remove the %1$s coverage option?': {
		translation:
			'Are you sure that you want to remove the %1$s coverage option?',
	},
	'Are you sure that you want to remove this <br> plan from this group and unenroll 1 employee?':
		{
			translation:
				'Are you sure that you want to remove this <br> plan from this group and unenroll 1 employee?',
		},
	'Are you sure that you want to remove this plan from this group and unenroll %1$s employees?':
		{
			translation:
				'Are you sure that you want to remove this plan from this group and unenroll %1$s employees?',
		},
	'Are you sure that you want to remove this plan from this group and unenroll 1 employee?':
		{
			translation:
				'Are you sure that you want to remove this plan from this group and unenroll 1 employee?',
		},
	'Are you sure that you want to uninstall Xero (Payroll), AU?': {
		translation: 'Are you sure that you want to uninstall Xero (Payroll), AU?',
	},
	'Are you sure that you want to uninstall Xero (Payroll), UK?': {
		translation: 'Are you sure that you want to uninstall Xero (Payroll), UK?',
	},
	'Are you sure that you want to uninstall Xero Australia Payroll?': {
		translation:
			'Are you sure that you want to uninstall Xero Australia Payroll?',
	},
	'Are you sure that you want to uninstall Xero UK Payroll?': {
		translation: 'Are you sure that you want to uninstall Xero UK Payroll?',
	},
	'Are you sure you  want to delete the task "%s"?': {
		translation: 'Are you sure you  want to delete the task \\"%s\\"?',
	},
	'Are you sure you  want to%s %sdelete &quot;%s&quot;?%s': {
		translation: 'Are you sure you  want to%s %sdelete &quot;%s&quot;?%s',
	},
	'Are you sure you  want to%s %sdelete the Task &quot;%s&quot;?%s': {
		translation:
			'Are you sure you  want to%s %sdelete the Task &quot;%s&quot;?%s',
	},
	'Are you sure you  want to%s %sdelete the Webhook &quot;%s&quot;?%s': {
		translation:
			'Are you sure you  want to%s %sdelete the Webhook &quot;%s&quot;?%s',
	},
	'Are you sure you %s want to %sdelete %s%s?': {
		translation: 'Are you sure you %s want to %sdelete %s%s?',
	},
	'Are you sure you %s want to %sdelete this Announcement%s?': {
		translation: 'Are you sure you %s want to %sdelete this Announcement%s?',
	},
	'Are you sure you %s want to %sdelete this job opening%s?': {
		translation: 'Are you sure you %s want to %sdelete this job opening%s?',
	},
	'Are you sure you %s would like to %s remove %s%s as a billing contact?': {
		translation:
			'Are you sure you %s would like to %s remove %s%s as a billing contact?',
	},
	'Are you sure you want BambooHR Payroll to no longer collect and pay %1$s?': {
		translation:
			'Are you sure you want BambooHR Payroll to no longer collect and pay %1$s?',
	},
	'Are you sure you want to ': {
		translation: 'Are you sure you want to ',
	},
	'Are you sure you want to %1': {
		translation: 'Are you sure you want to %1',
	},
	'Are you sure you want to %1 %2the answers %3 %4 gave for the Get to Know You questions?%5':
		{
			translation:
				'Are you sure you want to %1 %2the answers %3 %4 gave for the Get to Know You questions?%5',
		},
	'Are you sure you want to %1 the answers %2 gave for the Get to Know You questions?':
		{
			translation:
				'Are you sure you want to %1 the answers %2 gave for the Get to Know You questions?',
		},
	'Are you sure you want to %1$s': {
		translation: 'Are you sure you want to %1$s',
	},
	'Are you sure you want to %1$sdelete this approval?%2$s': {
		translation: 'Are you sure you want to %1$sdelete this approval?%2$s',
	},
	'Are you sure you want to %s': {
		translation: 'Are you sure you want to %s',
	},
	'Are you sure you want to %s delete the uncompleted items for %s?': {
		translation:
			'Are you sure you want to %s delete the uncompleted items for %s?',
	},
	'Are you sure you want to %s delete this job opening %s and all its %s applicants%s?':
		{
			translation:
				'Are you sure you want to %s delete this job opening %s and all its %s applicants%s?',
		},
	'Are you sure you want to %scancel the New Hire Packet for %s%s?': {
		translation:
			'Are you sure you want to %scancel the New Hire Packet for %s%s?',
	},
	'Are you sure you want to %sdelete all information for this employee%s?': {
		translation:
			'Are you sure you want to %sdelete all information for this employee%s?',
	},
	'Are you sure you want to %sdelete this applicant%s?': {
		translation: 'Are you sure you want to %sdelete this applicant%s?',
	},
	'Are you sure you want to %sdelete this contact%s?': {
		translation: 'Are you sure you want to %sdelete this contact%s?',
	},
	'Are you sure you want to %sdelete this dependent%s?': {
		translation: 'Are you sure you want to %sdelete this dependent%s?',
	},
	'Are you sure you want to %sdelete%s the item %s?': {
		translation: 'Are you sure you want to %sdelete%s the item %s?',
	},
	'Are you sure you want to **delete this education record**?': {
		translation: 'Are you sure you want to **delete this education record**?',
	},
	'Are you sure you want to **turn off eNPS**?': {
		translation: 'Are you sure you want to **turn off eNPS**?',
	},
	'Are you sure you want to <b>remove this folder</b>?': {
		translation: 'Are you sure you want to <b>remove this folder</b>?',
	},
	'Are you sure you want to <span class="emphasis">delete this dependent</span>?':
		{
			translation:
				'Are you sure you want to <span class=\\"emphasis\\">delete this dependent</span>?',
		},
	'Are you sure you want to <span class="emphasis">delete this education record</span>?':
		{
			translation:
				'Are you sure you want to <span class=\\"emphasis\\">delete this education record</span>?',
		},
	"Are you sure you want to <span style='font-weight:900;'>remove this policy</span><br />for <span style='font-weight:900;'>%s</span>":
		{
			translation:
				"Are you sure you want to <span style='font-weight:900;'>remove this policy</span><br />for <span style='font-weight:900;'>%s</span>",
		},
	'Are you sure you want to <strong>remove this history item</strong><br />for <strong>%s</strong>?':
		{
			translation:
				'Are you sure you want to <strong>remove this history item</strong><br />for <strong>%s</strong>?',
		},
	'Are you sure you want to CLEAR ALL DATA from your company?': {
		translation: 'Are you sure you want to CLEAR ALL DATA from your company?',
	},
	'Are you sure you want to approve all hours for all employees with the "%1$s" pay schedule for the period of %2$s?':
		{
			translation:
				'Are you sure you want to approve all hours for all employees with the \\"%1$s\\" pay schedule for the period of %2$s?',
		},
	'Are you sure you want to archive the category %s': {
		translation: 'Are you sure you want to archive the category %s',
	},
	'Are you sure you want to archive the list %s': {
		translation: 'Are you sure you want to archive the list %s',
	},
	'Are you sure you want to cancel the New Hire Packet for %s?': {
		translation: 'Are you sure you want to cancel the New Hire Packet for %s?',
	},
	'Are you sure you want to cancel the feedback request sent to {1}?': {
		translation:
			'Are you sure you want to cancel the feedback request sent to {1}?',
	},
	'Are you sure you want to cancel the signature request?': {
		translation: 'Are you sure you want to cancel the signature request?',
	},
	'Are you sure you want to cancel these updates?': {
		translation: 'Are you sure you want to cancel these updates?',
	},
	'Are you sure you want to cancel this offer?': {
		translation: 'Are you sure you want to cancel this offer?',
	},
	'Are you sure you want to cancel this request?': {
		translation: 'Are you sure you want to cancel this request?',
	},
	'Are you sure you want to cancel this signature request?': {
		translation: 'Are you sure you want to cancel this signature request?',
	},
	'Are you sure you want to cancel?': {
		translation: 'Are you sure you want to cancel?',
	},
	'Are you sure you want to change the next <span class="semibold">review due date?</span>':
		{
			translation:
				'Are you sure you want to change the next <span class=\\"semibold\\">review due date?</span>',
		},
	'Are you sure you want to change the next review due date?': {
		translation: 'Are you sure you want to change the next review due date?',
	},
	'Are you sure you want to change your access level?': {
		translation: 'Are you sure you want to change your access level?',
	},
	'Are you sure you want to clear all performance data?': {
		translation: 'Are you sure you want to clear all performance data?',
	},
	'Are you sure you want to delete "%1"': {
		translation: 'Are you sure you want to delete \\"%1\\"',
	},
	'Are you sure you want to delete "%1$s" ?': {
		translation: 'Are you sure you want to delete \\"%1$s\\" ?',
	},
	'Are you sure you want to delete "%1$s"?': {
		translation: 'Are you sure you want to delete \\"%1$s\\"?',
	},
	'Are you sure you want to delete "%s"?': {
		translation: 'Are you sure you want to delete \\"%s\\"?',
	},
	'Are you sure you want to delete %1$sthese %2$s applicants%3$s?': {
		translation:
			'Are you sure you want to delete %1$sthese %2$s applicants%3$s?',
	},
	'Are you sure you want to delete %s?': {
		translation: 'Are you sure you want to delete %s?',
	},
	'Are you sure you want to delete __{1}__?': {
		translation: 'Are you sure you want to delete __{1}__?',
	},
	'Are you sure you want to delete accrual %1?': {
		translation: 'Are you sure you want to delete accrual %1?',
	},
	'Are you sure you want to delete all benefit plans and employee enrollments?':
		{
			translation:
				'Are you sure you want to delete all benefit plans and employee enrollments?',
		},
	'Are you sure you want to delete all direct deposit information and start receiving paper checks?':
		{
			translation:
				'Are you sure you want to delete all direct deposit information and start receiving paper checks?',
		},
	'Are you sure you want to delete all information for this employee?': {
		translation:
			'Are you sure you want to delete all information for this employee?',
	},
	'Are you sure you want to delete all plans and enrollments?': {
		translation: 'Are you sure you want to delete all plans and enrollments?',
	},
	'Are you sure you want to delete tag?': {
		translation: 'Are you sure you want to delete tag?',
	},
	'Are you sure you want to delete the "%1$s" policy?': {
		translation: 'Are you sure you want to delete the \\"%1$s\\" policy?',
	},
	'Are you sure you want to delete the "%1$s" time off type?': {
		translation:
			'Are you sure you want to delete the \\"%1$s\\" time off type?',
	},
	'Are you sure you want to delete the "%1$s%2$s%3$s" %4$s?': {
		translation: 'Are you sure you want to delete the \\"%1$s%2$s%3$s\\" %4$s?',
	},
	'Are you sure you want to delete the "%1$s%2$s%3$s" policy?': {
		translation:
			'Are you sure you want to delete the \\"%1$s%2$s%3$s\\" policy?',
	},
	'Are you sure you want to delete the "%1$s%2$s%3$s" time off type?': {
		translation:
			'Are you sure you want to delete the \\"%1$s%2$s%3$s\\" time off type?',
	},
	'Are you sure you want to delete the "%s" %s?': {
		translation: 'Are you sure you want to delete the \\"%s\\" %s?',
	},
	'Are you sure you want to delete the %1 to %2 entry?': {
		translation: 'Are you sure you want to delete the %1 to %2 entry?',
	},
	'Are you sure you want to delete the %1$s tag?': {
		translation: 'Are you sure you want to delete the %1$s tag?',
	},
	'Are you sure you want to delete the %3%1 to %2 entry%4?': {
		translation: 'Are you sure you want to delete the %3%1 to %2 entry%4?',
	},
	'Are you sure you want to delete the %s report?': {
		translation: 'Are you sure you want to delete the %s report?',
	},
	'Are you sure you want to delete the **"{1}"** pay schedule?': {
		translation:
			'Are you sure you want to delete the **\\"{1}\\"** pay schedule?',
	},
	'Are you sure you want to delete the category %1?': {
		translation: 'Are you sure you want to delete the category %1?',
	},
	'Are you sure you want to delete the category %1? All trainings with this category will be re-assigned to no category. This action cannot be undone.':
		{
			translation:
				'Are you sure you want to delete the category %1? All trainings with this category will be re-assigned to no category. This action cannot be undone.',
		},
	'Are you sure you want to delete the category %s': {
		translation: 'Are you sure you want to delete the category %s',
	},
	'Are you sure you want to delete the event named "%1"?': {
		translation: 'Are you sure you want to delete the event named \\"%1\\"?',
	},
	'Are you sure you want to delete the folder "%1"?': {
		translation: 'Are you sure you want to delete the folder \\"%1\\"?',
	},
	'Are you sure you want to delete the following pay stub?': {
		translation: 'Are you sure you want to delete the following pay stub?',
	},
	'Are you sure you want to delete the item %s %s?': {
		translation: 'Are you sure you want to delete the item %s %s?',
	},
	'Are you sure you want to delete the list %s': {
		translation: 'Are you sure you want to delete the list %s',
	},
	'Are you sure you want to delete the payee **{1}**?': {
		translation: 'Are you sure you want to delete the payee **{1}**?',
	},
	'Are you sure you want to delete the tasklist %1$s?': {
		translation: 'Are you sure you want to delete the tasklist %1$s?',
	},
	'Are you sure you want to delete the uncompleted items for %s?': {
		translation:
			'Are you sure you want to delete the uncompleted items for %s?',
	},
	'Are you sure you want to delete the {1} project?': {
		translation: 'Are you sure you want to delete the {1} project?',
	},
	'Are you sure you want to delete the {1} report?': {
		translation: 'Are you sure you want to delete the {1} report?',
	},
	'Are you sure you want to delete these %1$d documents?': {
		translation: 'Are you sure you want to delete these %1$d documents?',
	},
	'Are you sure you want to delete these applicants?': {
		translation: 'Are you sure you want to delete these applicants?',
	},
	'Are you sure you want to delete these candidates?': {
		translation: 'Are you sure you want to delete these candidates?',
	},
	'Are you sure you want to delete this Folder?': {
		translation: 'Are you sure you want to delete this Folder?',
	},
	'Are you sure you want to delete this approval?': {
		translation: 'Are you sure you want to delete this approval?',
	},
	'Are you sure you want to delete this candidate?': {
		translation: 'Are you sure you want to delete this candidate?',
	},
	'Are you sure you want to delete this comment and all its files?': {
		translation:
			'Are you sure you want to delete this comment and all its files?',
	},
	'Are you sure you want to delete this comment and its replies (including any attached files)?':
		{
			translation:
				'Are you sure you want to delete this comment and its replies (including any attached files)?',
		},
	'Are you sure you want to delete this comment and rating?': {
		translation: 'Are you sure you want to delete this comment and rating?',
	},
	'Are you sure you want to delete this comment and status?': {
		translation: 'Are you sure you want to delete this comment and status?',
	},
	'Are you sure you want to delete this comment?': {
		translation: 'Are you sure you want to delete this comment?',
	},
	'Are you sure you want to delete this completion of %1$s?': {
		translation: 'Are you sure you want to delete this completion of %1$s?',
	},
	'Are you sure you want to delete this contact?': {
		translation: 'Are you sure you want to delete this contact?',
	},
	'Are you sure you want to delete this deduction?': {
		translation: 'Are you sure you want to delete this deduction?',
	},
	'Are you sure you want to delete this file?': {
		translation: {
			one: 'Are you sure you want to delete this file?',
			other: 'Are you sure you want to delete these files?',
		},
	},
	'Are you sure you want to delete this group?': {
		translation: 'Are you sure you want to delete this group?',
	},
	'Are you sure you want to delete this job opening and all of its candidates?':
		{
			translation:
				'Are you sure you want to delete this job opening and all of its candidates?',
		},
	'Are you sure you want to delete this job opening?': {
		translation: 'Are you sure you want to delete this job opening?',
	},
	'Are you sure you want to delete this note?': {
		translation: 'Are you sure you want to delete this note?',
	},
	'Are you sure you want to delete this photo?': {
		translation: 'Are you sure you want to delete this photo?',
	},
	'Are you sure you want to delete this rating?': {
		translation: 'Are you sure you want to delete this rating?',
	},
	'Are you sure you want to delete this row?': {
		translation: 'Are you sure you want to delete this row?',
	},
	'Are you sure you want to delete this status?': {
		translation: 'Are you sure you want to delete this status?',
	},
	'Are you sure you want to delete this user?': {
		translation: 'Are you sure you want to delete this user?',
	},
	'Are you sure you want to delete this webhook?': {
		translation: 'Are you sure you want to delete this webhook?',
	},
	'Are you sure you want to delete {1} candidates?': {
		translation: 'Are you sure you want to delete {1} candidates?',
	},
	'Are you sure you want to delete “%1$s”?': {
		translation: 'Are you sure you want to delete “%1$s”?',
	},
	'Are you sure you want to delete...': {
		translation: 'Are you sure you want to delete...',
	},
	'Are you sure you want to disable this link?': {
		translation: 'Are you sure you want to disable this link?',
	},
	'Are you sure you want to disable time tracking for %1$s?': {
		translation: 'Are you sure you want to disable time tracking for %1$s?',
	},
	'Are you sure you want to edit the start date?': {
		translation: 'Are you sure you want to edit the start date?',
	},
	'Are you sure you want to end this plan?': {
		translation: 'Are you sure you want to end this plan?',
	},
	'Are you sure you want to import this file for this company?': {
		translation: 'Are you sure you want to import this file for this company?',
	},
	'Are you sure you want to leave now?': {
		translation: 'Are you sure you want to leave now?',
	},
	'Are you sure you want to permanently delete this benefit and unenroll %1$s employees?':
		{
			translation:
				'Are you sure you want to permanently delete this benefit and unenroll %1$s employees?',
		},
	'Are you sure you want to permanently delete this benefit group?': {
		translation:
			'Are you sure you want to permanently delete this benefit group?',
	},
	'Are you sure you want to permanently delete this employee?': {
		translation: 'Are you sure you want to permanently delete this employee?',
	},
	'Are you sure you want to permanently delete this event from the historical data?':
		{
			translation:
				'Are you sure you want to permanently delete this event from the historical data?',
		},
	'Are you sure you want to put ': {
		translation: 'Are you sure you want to put ',
	},
	'Are you sure you want to remove %1 as a billing contact?': {
		translation: 'Are you sure you want to remove %1 as a billing contact?',
	},
	'Are you sure you want to remove this folder?': {
		translation: 'Are you sure you want to remove this folder?',
	},
	'Are you sure you want to remove this plan from this group and unenroll %1$s employees?':
		{
			translation:
				'Are you sure you want to remove this plan from this group and unenroll %1$s employees?',
		},
	'Are you sure you want to remove this plan from this group and unenroll 1 employee?':
		{
			translation:
				'Are you sure you want to remove this plan from this group and unenroll 1 employee?',
		},
	'Are you sure you want to remove this plan from this group?': {
		translation: 'Are you sure you want to remove this plan from this group?',
	},
	'Are you sure you want to remove this signed document?': {
		translation: 'Are you sure you want to remove this signed document?',
	},
	'Are you sure you want to remove this status?': {
		translation: 'Are you sure you want to remove this status?',
	},
	'Are you sure you want to remove this tax?': {
		translation: 'Are you sure you want to remove this tax?',
	},
	'Are you sure you want to remove this user?': {
		translation: 'Are you sure you want to remove this user?',
	},
	'Are you sure you want to remove “%1$s”?': {
		translation: 'Are you sure you want to remove “%1$s”?',
	},
	'Are you sure you want to reset your last reminder status? By doing this, you will reset the last t-minus interval which determines the next assessment reminder to send.':
		{
			translation:
				'Are you sure you want to reset your last reminder status? By doing this, you will reset the last t-minus interval which determines the next assessment reminder to send.',
		},
	'Are you sure you want to send these requests?': {
		translation: 'Are you sure you want to send these requests?',
	},
	'Are you sure you want to setup trial peer feedback?': {
		translation: 'Are you sure you want to setup trial peer feedback?',
	},
	'Are you sure you want to start over tracking payroll changes?': {
		translation:
			'Are you sure you want to start over tracking payroll changes?',
	},
	'Are you sure you want to start peer feedback for %1': {
		translation: 'Are you sure you want to start peer feedback for %1',
	},
	'Are you sure you want to uninstall %1$s?': {
		translation: 'Are you sure you want to uninstall %1$s?',
	},
	'Are you sure you want to uninstall LinkedIn Promotional Jobs?': {
		translation:
			'Are you sure you want to uninstall LinkedIn Promotional Jobs?',
	},
	'Are you sure you want to upload this file for this company?': {
		translation: 'Are you sure you want to upload this file for this company?',
	},
	'Are you sure you want to%s %sdelete  &quot;%s&quot; ?%s': {
		translation: 'Are you sure you want to%s %sdelete  &quot;%s&quot; ?%s',
	},
	'Are you sure you want to%s %sdelete  &quot;%s&quot;?%s': {
		translation: 'Are you sure you want to%s %sdelete  &quot;%s&quot;?%s',
	},
	'Are you sure?': {
		translation: 'Are you sure?',
	},
	'Are you sure? Accounts marked as fraudulent are deleted (and lose their data) nightly.':
		{
			translation:
				'Are you sure? Accounts marked as fraudulent are deleted (and lose their data) nightly.',
		},
	'Are you sure? This account was previously marked as fraudulent.': {
		translation:
			'Are you sure? This account was previously marked as fraudulent.',
	},
	'Are you thinking about adding some?': {
		translation: 'Are you thinking about adding some?',
	},
	'Are your benefit plans and enrollments up to date in BambooHR?': {
		translation:
			'Are your benefit plans and enrollments up to date in BambooHR?',
	},
	'Armed Forces Service Medal Veteran': {
		translation: 'Armed Forces Service Medal Veteran',
	},
	'As a Group': {
		translation: 'As a Group',
	},
	'As always, if you need help setting up your integration, troubleshooting, or getting your Boomr account configured, please reach out to us at <a href="mailto:support@boomr.com">support@boomr.com</a> or by calling (877) 687-6228.':
		{
			translation:
				'As always, if you need help setting up your integration, troubleshooting, or getting your Boomr account configured, please reach out to us at <a href=\\"mailto:support@boomr.com\\">support@boomr.com</a> or by calling (877) 687-6228.',
		},
	'As of': {
		translation: 'As of',
	},
	'As of %1$s': {
		translation: 'As of %1$s',
	},
	'As of Date': {
		translation: 'As of Date',
	},
	'As of Today': {
		translation: 'As of Today',
	},
	'As of date': {
		translation: 'As of date',
	},
	"As part of BambooHR's ongoing effort to keep employee data as secure as possible, we've discontinued support of the employee directory Chrome extension.":
		{
			translation:
				"As part of BambooHR's ongoing effort to keep employee data as secure as possible, we've discontinued support of the employee directory Chrome extension.",
		},
	'As you add employees, verify that all of their information is correct.': {
		translation:
			'As you add employees, verify that all of their information is correct.',
	},
	Ascending: {
		translation: 'Ascending',
	},
	'Asia-Pacific': {
		translation: 'Asia-Pacific',
	},
	Asian: {
		translation: 'Asian',
	},
	'Asked how company can improve': {
		translation: 'Asked how company can improve',
	},
	'Asked what company does well': {
		translation: 'Asked what company does well',
	},
	'Asleep Grave': {
		translation: 'Asleep Grave',
	},
	Assessed: {
		translation: 'Assessed',
	},
	Assessment: {
		translation: 'Assessment',
	},
	'Assessment Canceled': {
		translation: 'Assessment Canceled',
	},
	'Assessment Completed': {
		translation: 'Assessment Completed',
	},
	'Assessment ID does not exist!': {
		translation: 'Assessment ID does not exist!',
	},
	'Assessment Notification Email': {
		translation: 'Assessment Notification Email',
	},
	'Assessment Progress': {
		translation: 'Assessment Progress',
	},
	'Assessment Questions': {
		translation: 'Assessment Questions',
	},
	'Assessment Review Periods': {
		translation: 'Assessment Review Periods',
	},
	'Assessment Schedule': {
		translation: 'Assessment Schedule',
	},
	'Assessment Skipped': {
		translation: 'Assessment Skipped',
	},
	'Assessment does not belong to employee.': {
		translation: 'Assessment does not belong to employee.',
	},
	'Assessment emails will be sent on %1': {
		translation: 'Assessment emails will be sent on %1',
	},
	'Assessment has already been submitted. Cannot submit again.': {
		translation: 'Assessment has already been submitted. Cannot submit again.',
	},
	'Assessment publish date must be within 30 days.': {
		translation: 'Assessment publish date must be within 30 days.',
	},
	'Assessment questions are locked for the remainder of the current review period.':
		{
			translation:
				'Assessment questions are locked for the remainder of the current review period.',
		},
	'Assessment settings have been successfully updated.': {
		translation: 'Assessment settings have been successfully updated.',
	},
	'Assessment skipped': {
		translation: 'Assessment skipped',
	},
	'Assessment was successfully unlocked': {
		translation: 'Assessment was successfully unlocked',
	},
	Assessments: {
		translation: 'Assessments',
	},
	'Assessments Disabled': {
		translation: 'Assessments Disabled',
	},
	'Assessments Due': {
		translation: 'Assessments Due',
	},
	'Assessments Not Started': {
		translation: 'Assessments Not Started',
	},
	'Assessments are available 30 days prior to the end of the current period. Please return between **{1}** and **{2}** to complete your Assessment.':
		{
			translation:
				'Assessments are available 30 days prior to the end of the current period. Please return between **{1}** and **{2}** to complete your Assessment.',
		},
	'Assessments can not be saved while previewing as another user': {
		translation:
			'Assessments can not be saved while previewing as another user',
	},
	'Assessments have already been skipped.': {
		translation: 'Assessments have already been skipped.',
	},
	'Assessments have been disabled.': {
		translation: 'Assessments have been disabled.',
	},
	'Assessments in Progress': {
		translation: 'Assessments in Progress',
	},
	'Asset Category': {
		translation: 'Asset Category',
	},
	'Asset Cost': {
		translation: 'Asset Cost',
	},
	'Asset Description': {
		translation: 'Asset Description',
	},
	Assets: {
		translation: 'Assets',
	},
	'Assets Assigned to Employee': {
		translation: 'Assets Assigned to Employee',
	},
	'Assets: Category': {
		translation: 'Assets: Category',
	},
	'Assets: Cost': {
		translation: 'Assets: Cost',
	},
	'Assets: Date Loaned': {
		translation: 'Assets: Date Loaned',
	},
	'Assets: Date Returned': {
		translation: 'Assets: Date Returned',
	},
	'Assets: Description': {
		translation: 'Assets: Description',
	},
	'Assets: Notes': {
		translation: 'Assets: Notes',
	},
	'Assets: Serial Number': {
		translation: 'Assets: Serial Number',
	},
	'Assign EEO Categories': {
		translation: 'Assign EEO Categories',
	},
	'Assign Feedback': {
		translation: 'Assign Feedback',
	},
	'Assign Peer Feedback': {
		translation: 'Assign Peer Feedback',
	},
	'Assign Policies': {
		translation: 'Assign Policies',
	},
	'Assign To': {
		translation: 'Assign To',
	},
	'Assign someone': {
		translation: 'Assign someone',
	},
	Assigned: {
		translation: 'Assigned',
	},
	'Assigned Assets': {
		translation: 'Assigned Assets',
	},
	'Assigned By': {
		translation: 'Assigned By',
	},
	'Assigned Date': {
		translation: 'Assigned Date',
	},
	'Assigned To': {
		translation: 'Assigned To',
	},
	'Assigned User': {
		translation: 'Assigned User',
	},
	'Assigned to': {
		translation: 'Assigned to',
	},
	'Assigned to %1$s': {
		translation: 'Assigned to %1$s',
	},
	'Assigned to Company': {
		translation: 'Assigned to Company',
	},
	'Assigned to Me': {
		translation: 'Assigned to Me',
	},
	'Assigned to You': {
		translation: 'Assigned to You',
	},
	'Assigned to...': {
		translation: 'Assigned to...',
	},
	'Associate HR Administrator': {
		translation: 'Associate HR Administrator',
	},
	"Associate's": {
		translation: "Associate's",
	},
	Astrazeneca: {
		translation: 'Astrazeneca',
	},
	Astronaut: {
		translation: 'Astronaut',
	},
	'Astronaut %1$s in Department %2$s': {
		translation: 'Astronaut %1$s in Department %2$s',
	},
	'At Least 30 Hours Worked': {
		translation: 'At Least 30 Hours Worked',
	},
	'At lease 1 number': {
		translation: 'At lease 1 number',
	},
	'At least %1 of these fields is required.': {
		translation: 'At least %1 of these fields is required.',
	},
	'At least 1 number': {
		translation: 'At least 1 number',
	},
	'At least one compensation type (salary, bonus, equity) must be included.': {
		translation:
			'At least one compensation type (salary, bonus, equity) must be included.',
	},
	'At least one completed eNPS survey': {
		translation: 'At least one completed eNPS survey',
	},
	'At least one completed employee wellbeing survey': {
		translation: 'At least one completed employee wellbeing survey',
	},
	'At least one employee just clocked out.': {
		translation: 'At least one employee just clocked out.',
	},
	'At least one file is an e-Signature document and will become invalid once this file is deleted.':
		{
			translation:
				'At least one file is an e-Signature document and will become invalid once this file is deleted.',
		},
	'At least one file is an e-Signature template, any in-progress signatures will not be removed.':
		{
			translation:
				'At least one file is an e-Signature template, any in-progress signatures will not be removed.',
		},
	'At least one job must be specified to seed.': {
		translation: 'At least one job must be specified to seed.',
	},
	'At least one must be checked': {
		translation: 'At least one must be checked',
	},
	'At least one valid email must be submitted': {
		translation: 'At least one valid email must be submitted',
	},
	'At the beginning of the period': {
		translation: 'At the beginning of the period',
	},
	'At the end of each period': {
		translation: 'At the end of each period',
	},
	'At the end of the period': {
		translation: 'At the end of the period',
	},
	Attach: {
		translation: 'Attach',
	},
	'Attach File(s)': {
		translation: 'Attach File(s)',
	},
	'Attach Files': {
		translation: 'Attach Files',
	},
	'Attach a file': {
		translation: 'Attach a file',
	},
	'Attach file(s)': {
		translation: 'Attach file(s)',
	},
	'Attempted to save a draft when an offer letter already exists.': {
		translation:
			'Attempted to save a draft when an offer letter already exists.',
	},
	'Attempted to update a data benchmarking agreement that cannot be updated. Agreement Id: ':
		{
			translation:
				'Attempted to update a data benchmarking agreement that cannot be updated. Agreement Id: ',
		},
	'Attempted update to an offer letter which has already been sent.': {
		translation:
			'Attempted update to an offer letter which has already been sent.',
	},
	'Attempting to change read-only field': {
		translation: 'Attempting to change read-only field',
	},
	Attendance: {
		translation: 'Attendance',
	},
	'Attendance/Punctuality': {
		translation: 'Attendance/Punctuality',
	},
	'Attending school?': {
		translation: 'Attending school?',
	},
	'Audit Trail': {
		translation: 'Audit Trail',
	},
	Aug: {
		translation: 'Aug',
	},
	August: {
		translation: 'August',
	},
	'Authenticate with BambooHR': {
		translation: 'Authenticate with BambooHR',
	},
	'Authenticator App': {
		translation: 'Authenticator App',
	},
	Author: {
		translation: 'Author',
	},
	'Authorizes the application to perform scoped actions on behalf of the user who authorized the application.':
		{
			translation:
				'Authorizes the application to perform scoped actions on behalf of the user who authorized the application.',
		},
	'Auto insurance': {
		translation: 'Auto insurance',
	},
	'Auto-Eligibility': {
		translation: 'Auto-Eligibility',
	},
	'Automatic eligibility': {
		translation: 'Automatic eligibility',
	},
	'Automatic eligibility update': {
		translation: 'Automatic eligibility update',
	},
	'Automatically send a welcome message in Slack to newly matched users.': {
		translation:
			'Automatically send a welcome message in Slack to newly matched users.',
	},
	Available: {
		translation: 'Available',
	},
	'Available Balance': {
		translation: 'Available Balance',
	},
	'Available Employees': {
		translation: 'Available Employees',
	},
	'Available Plans': {
		translation: 'Available Plans',
	},
	'Available Start Date': {
		translation: 'Available Start Date',
	},
	'Available Tiers': {
		translation: 'Available Tiers',
	},
	'Available employees': {
		translation: 'Available employees',
	},
	'Available on the Core and Pro Packages': {
		translation: 'Available on the Core and Pro Packages',
	},
	'Available when the job\'s status is set to "Open"': {
		translation: 'Available when the job\'s status is set to \\"Open\\"',
	},
	"Available when the job's status is set to Open": {
		translation: "Available when the job's status is set to Open",
	},
	Avatar: {
		translation: 'Avatar',
	},
	Average: {
		translation: 'Average',
	},
	'Average Age': {
		translation: 'Average Age',
	},
	'Average Monthly Turnover': {
		translation: 'Average Monthly Turnover',
	},
	'Average:': {
		translation: 'Average:',
	},
	'Avg Candidate Age': {
		translation: 'Avg Candidate Age',
	},
	'Avg. Candidate Age': {
		translation: 'Avg. Candidate Age',
	},
	'Avg. Duration': {
		translation: 'Avg. Duration',
	},
	'Avg. Employee Count': {
		translation: 'Avg. Employee Count',
	},
	'Avg. Time to Hire': {
		translation: 'Avg. Time to Hire',
	},
	'Avoid using a white (reversed out) version of your logo.': {
		translation: 'Avoid using a white (reversed out) version of your logo.',
	},
	'Awaiting Approval': {
		translation: 'Awaiting Approval',
	},
	'Awaiting Signatures': {
		translation: 'Awaiting Signatures',
	},
	'Awesome!': {
		translation: 'Awesome!',
	},
	'Awesome! It looks like you want to add/update %1$s record.': {
		translation: {
			one: 'Awesome! It looks like you want to add/update %1$s record.',
			other: 'Awesome! It looks like you want to add/update %1$s records.',
		},
	},
	'Awesome! It looks like you want to add/update %d records. Now, match up the field names in BambooHR with the columns from the import file. Check the sample data on the right to make sure everything looks good.':
		{
			translation:
				'Awesome! It looks like you want to add/update %d records. Now, match up the field names in BambooHR with the columns from the import file. Check the sample data on the right to make sure everything looks good.',
		},
	'Awesome! It looks like you want to add/update %s record.': {
		translation: {
			one: 'Awesome! It looks like you want to add/update %s record.',
			other: 'Awesome! It looks like you want to add/update %s records.',
		},
	},
	'Awesome! Thanks for accepting our Data Processing Agreement.': {
		translation: 'Awesome! Thanks for accepting our Data Processing Agreement.',
	},
	B: {
		translation: 'B',
	},
	'B Day AM': {
		translation: 'B Day AM',
	},
	'B Day PM': {
		translation: 'B Day PM',
	},
	B1: {
		translation: 'B1',
	},
	B2: {
		translation: 'B2',
	},
	'BENU offers benefits enrollment technology, benefits outsourcing, employee communication and wellness services. The company\'s flexible benefits platform is used by companies in industries ranging from healthcare to technology to business services. Learn more at <a href="http://www.benu.com" target="_blank" rel="noopener noreferrer">www.benu.com</a>.':
		{
			translation:
				'BENU offers benefits enrollment technology, benefits outsourcing, employee communication and wellness services. The company\'s flexible benefits platform is used by companies in industries ranging from healthcare to technology to business services. Learn more at <a href=\\"http://www.benu.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">www.benu.com</a>.',
		},
	'BLS #': {
		translation: 'BLS #',
	},
	'BLS expiration': {
		translation: 'BLS expiration',
	},
	BaTabs: {
		translation: 'BaTabs',
	},
	'BaTabs - Examples': {
		translation: 'BaTabs - Examples',
	},
	'BaTabs - Paths': {
		translation: 'BaTabs - Paths',
	},
	"Bachelor's": {
		translation: "Bachelor's",
	},
	'Bachelors degree?': {
		translation: 'Bachelors degree?',
	},
	Back: {
		translation: 'Back',
	},
	'Back taxes': {
		translation: 'Back taxes',
	},
	'Back to Account Info': {
		translation: 'Back to Account Info',
	},
	'Back to Billing': {
		translation: 'Back to Billing',
	},
	'Back to Checklist': {
		translation: 'Back to Checklist',
	},
	'Back to Home': {
		translation: 'Back to Home',
	},
	'Back to Onboarding': {
		translation: 'Back to Onboarding',
	},
	'Back to PTO': {
		translation: 'Back to PTO',
	},
	'Back to Report': {
		translation: 'Back to Report',
	},
	'Back to Template': {
		translation: 'Back to Template',
	},
	'Back-dated Deduction Change': {
		translation: 'Back-dated Deduction Change',
	},
	'Back-dated Enrollment Change': {
		translation: 'Back-dated Enrollment Change',
	},
	'Backend pay scale': {
		translation: 'Backend pay scale',
	},
	'Background Check': {
		translation: 'Background Check',
	},
	'Background Check Management': {
		translation: 'Background Check Management',
	},
	'Background Checks': {
		translation: 'Background Checks',
	},
	'Background Tab': {
		translation: 'Background Tab',
	},
	'Background check': {
		translation: 'Background check',
	},
	'Background check information': {
		translation: 'Background check information',
	},
	'Background checks': {
		translation: 'Background checks',
	},
	'Background status': {
		translation: 'Background status',
	},
	'Bad job opening exception.': {
		translation: 'Bad job opening exception.',
	},
	"Bad timing, but reach out to your manager or HR administrator and they should make sure you're taken care of.":
		{
			translation:
				"Bad timing, but reach out to your manager or HR administrator and they should make sure you're taken care of.",
		},
	'Badge #': {
		translation: 'Badge #',
	},
	Balance: {
		translation: 'Balance',
	},
	'Balance adjustment': {
		translation: 'Balance adjustment',
	},
	'Balance adjustment import': {
		translation: 'Balance adjustment import',
	},
	'Balance on date of request: ': {
		translation: 'Balance on date of request: ',
	},
	Balances: {
		translation: 'Balances',
	},
	Balloon: {
		translation: 'Balloon',
	},
	'Bamboo HR Admin stuff...': {
		translation: 'Bamboo HR Admin stuff...',
	},
	'Bamboo Payroll': {
		translation: 'Bamboo Payroll',
	},
	'Bamboo Vacation': {
		translation: 'Bamboo Vacation',
	},
	'Bamboo does its best to match these lists, but cannot manage these lists in NetSuite. You will need to reconcile these lists yourself.':
		{
			translation:
				'Bamboo does its best to match these lists, but cannot manage these lists in NetSuite. You will need to reconcile these lists yourself.',
		},
	BambooHR: {
		translation: 'BambooHR',
	},
	'BambooHR + Apps = HR Awesomeness': {
		translation: 'BambooHR + Apps = HR Awesomeness',
	},
	'BambooHR - Easy-to-Use HR Software': {
		translation: 'BambooHR - Easy-to-Use HR Software',
	},
	'BambooHR Access Level': {
		translation: 'BambooHR Access Level',
	},
	'BambooHR Advantage Package Demo Video': {
		translation: 'BambooHR Advantage Package Demo Video',
	},
	'BambooHR Assistant Response': {
		translation: 'BambooHR Assistant Response',
	},
	'BambooHR Automated Email': {
		translation: 'BambooHR Automated Email',
	},
	'BambooHR Demo': {
		translation: 'BambooHR Demo',
	},
	'BambooHR Field': {
		translation: 'BambooHR Field',
	},
	'BambooHR File Notification': {
		translation: 'BambooHR File Notification',
	},
	'BambooHR Files': {
		translation: 'BambooHR Files',
	},
	'BambooHR Help': {
		translation: 'BambooHR Help',
	},
	'BambooHR Help Center': {
		translation: 'BambooHR Help Center',
	},
	'BambooHR Hiring App': {
		translation: 'BambooHR Hiring App',
	},
	'BambooHR Learning Courses': {
		translation: 'BambooHR Learning Courses',
	},
	'BambooHR Main Navigation': {
		translation: 'BambooHR Main Navigation',
	},
	'BambooHR Manage Navigation': {
		translation: 'BambooHR Manage Navigation',
	},
	'BambooHR Manual Policy': {
		translation: 'BambooHR Manual Policy',
	},
	'BambooHR Marketplace': {
		translation: 'BambooHR Marketplace',
	},
	'BambooHR Page Banners': {
		translation: 'BambooHR Page Banners',
	},
	'BambooHR Payroll': {
		translation: 'BambooHR Payroll',
	},
	'BambooHR Product Training': {
		translation: 'BambooHR Product Training',
	},
	'BambooHR Support Representative': {
		translation: 'BambooHR Support Representative',
	},
	'BambooHR Time Tracking Hours': {
		translation: 'BambooHR Time Tracking Hours',
	},
	'BambooHR Time Tracking currently doesn’t include the following:': {
		translation:
			'BambooHR Time Tracking currently doesn’t include the following:',
	},
	'BambooHR Time Tracking is an add-on feature that can be added at an additional cost. For questions and pricing, talk to your sales rep.':
		{
			translation:
				'BambooHR Time Tracking is an add-on feature that can be added at an additional cost. For questions and pricing, talk to your sales rep.',
		},
	'BambooHR Time Tracking makes tracking hourly attendance fast, accurate, and easy, with self-service time entry, streamlined approvals, automatic overtime calculation, and beautiful payroll reporting.':
		{
			translation:
				'BambooHR Time Tracking makes tracking hourly attendance fast, accurate, and easy, with self-service time entry, streamlined approvals, automatic overtime calculation, and beautiful payroll reporting.',
		},
	'BambooHR Unlimited Policy': {
		translation: 'BambooHR Unlimited Policy',
	},
	'BambooHR access for %s has been disabled.': {
		translation: 'BambooHR access for %s has been disabled.',
	},
	'BambooHR access is required for Employees to participate in Performance Management.':
		{
			translation:
				'BambooHR access is required for Employees to participate in Performance Management.',
		},
	'BambooHR access is required for employees to participate in performance management.':
		{
			translation:
				'BambooHR access is required for employees to participate in performance management.',
		},
	'BambooHR access will be disabled at 11:59 PM on <span class="no-wrap">%s.</span>':
		{
			translation:
				'BambooHR access will be disabled at 11:59 PM on <span class=\\"no-wrap\\">%s.</span>',
		},
	'BambooHR and Browsers': {
		translation: 'BambooHR and Browsers',
	},
	"BambooHR does not have permission to view the Company ID of '%s' and Employee ID of '%s'.":
		{
			translation:
				"BambooHR does not have permission to view the Company ID of '%s' and Employee ID of '%s'.",
		},
	'BambooHR export files are only available to download for thirty days': {
		translation:
			'BambooHR export files are only available to download for thirty days',
	},
	'BambooHR goes with you on iOS and Android.': {
		translation: 'BambooHR goes with you on iOS and Android.',
	},
	'BambooHR has been configured to work with your Google Apps account.': {
		translation:
			'BambooHR has been configured to work with your Google Apps account.',
	},
	'BambooHR integrates seamlessly through our API with TraxPayroll sending employee information directly into their system and receiving paystub information directly from their system. This allows you to keep your employee data as the master record within BambooHR, but track time and attendance and do payroll through TraxPayroll.':
		{
			translation:
				'BambooHR integrates seamlessly through our API with TraxPayroll sending employee information directly into their system and receiving paystub information directly from their system. This allows you to keep your employee data as the master record within BambooHR, but track time and attendance and do payroll through TraxPayroll.',
		},
	'BambooHR needs to know a number of employees.': {
		translation: 'BambooHR needs to know a number of employees.',
	},
	'BambooHR needs to know the name of the company.': {
		translation: 'BambooHR needs to know the name of the company.',
	},
	'BambooHR needs to know what domain should be used to access this account.': {
		translation:
			'BambooHR needs to know what domain should be used to access this account.',
	},
	'BambooHR now supports pre-paying for benefits': {
		translation: 'BambooHR now supports pre-paying for benefits',
	},
	'BambooHR offers you what really matters: Goal Tracking, Assessments, and Peer Feedback. You will also have the ability to track goal progress and view a report of where your employees stand when it comes to engagement and performance.':
		{
			translation:
				'BambooHR offers you what really matters: Goal Tracking, Assessments, and Peer Feedback. You will also have the ability to track goal progress and view a report of where your employees stand when it comes to engagement and performance.',
		},
	'BambooHR syncs employee information into Jobber making it easy to measure employee engagement and satisfaction.':
		{
			translation:
				'BambooHR syncs employee information into Jobber making it easy to measure employee engagement and satisfaction.',
		},
	'BambooHR works best on modern browsers.': {
		translation: 'BambooHR works best on modern browsers.',
	},
	"BambooHR's Performance Management module is available as an add-on to our BambooHR Professional package. When enabled, it is available to setup and configure in the same BambooHR interface you already know and love.":
		{
			translation:
				"BambooHR's Performance Management module is available as an add-on to our BambooHR Professional package. When enabled, it is available to setup and configure in the same BambooHR interface you already know and love.",
		},
	"BambooHR's list of users is up to date!": {
		translation: "BambooHR's list of users is up to date!",
	},
	'BambooHR.Utils': {
		translation: 'BambooHR.Utils',
	},
	'BamoohHR Files': {
		translation: 'BambooHR Files',
	},
	'Bank Account': {
		translation: 'Bank Account',
	},
	'Bank Account Name': {
		translation: 'Bank Account Name',
	},
	'Bank Account Setup': {
		translation: 'Bank Account Setup',
	},
	'Bank Account Verification': {
		translation: 'Bank Account Verification',
	},
	'Bank Accounts': {
		translation: 'Bank Accounts',
	},
	'Bank Address:': {
		translation: 'Bank Address:',
	},
	'Bank Authorization Forms': {
		translation: 'Bank Authorization Forms',
	},
	'Bank Name': {
		translation: 'Bank Name',
	},
	'Bank Statement': {
		translation: 'Bank Statement',
	},
	'Bank account changes saved!': {
		translation: 'Bank account changes saved!',
	},
	'Bank account changes saved! You will need to download new forms to sign.': {
		translation:
			'Bank account changes saved! You will need to download new forms to sign.',
	},
	'Bank account nickname saved!': {
		translation: 'Bank account nickname saved!',
	},
	'Bank accounts for multiple EINs': {
		translation: 'Bank accounts for multiple EINs',
	},
	'Bank name': {
		translation: 'Bank name',
	},
	'Bank:': {
		translation: 'Bank:',
	},
	Bankruptcy: {
		translation: 'Bankruptcy',
	},
	'Base Pay': {
		translation: 'Base Pay',
	},
	'Based on %1 responses that mention %2.': {
		translation: 'Based on %1 responses that mention %2.',
	},
	'Based on recent changes, you are due for a tax refund.': {
		translation: 'Based on recent changes, you are due for a tax refund.',
	},
	'Based on this new employment status, the Employee Tax Type may need to be updated. Double-check it.':
		{
			translation:
				'Based on this new employment status, the Employee Tax Type may need to be updated. Double-check it.',
		},
	'Based on this new status, the Employee Tax Type may need to be updated.': {
		translation:
			'Based on this new status, the Employee Tax Type may need to be updated.',
	},
	'Based on your policy settings, there are currently no available additional accrual options.':
		{
			translation:
				'Based on your policy settings, there are currently no available additional accrual options.',
		},
	'Based on your previous selections, there are no employment types that fit this category.':
		{
			translation:
				'Based on your previous selections, there are no employment types that fit this category.',
		},
	'Basic Info': {
		translation: 'Basic Info',
	},
	'Basic Information': {
		translation: 'Basic Information',
	},
	'Basic Life': {
		translation: 'Basic Life',
	},
	'Basic Life 2025': {
		translation: 'Basic Life 2025',
	},
	'Basic Life 2026': {
		translation: 'Basic Life 2026',
	},
	'Basic Sick': {
		translation: 'Basic Sick',
	},
	'Basic Trouble Shooting': {
		translation: 'Basic Trouble Shooting',
	},
	'Basic Vacation': {
		translation: 'Basic Vacation',
	},
	'Be assured that signed documentation is legal - "Documents executed on RightSignature fulfill e-signature law requirements and contain a court-admissable audit log and Signature Certificate. With a multi-factor authentication portfolio and biometric signature data, RightSignature documents not only look more professional, they have stronger legal defensibility than traditional paper documents."':
		{
			translation:
				'Be assured that signed documentation is legal - \\"Documents executed on RightSignature fulfill e-signature law requirements and contain a court-admissable audit log and Signature Certificate. With a multi-factor authentication portfolio and biometric signature data, RightSignature documents not only look more professional, they have stronger legal defensibility than traditional paper documents.\\"',
		},
	"Be relieved. It's not likely to work out anyway.": {
		translation: "Be relieved. It's not likely to work out anyway.",
	},
	'Bear with us…': {
		translation: 'Bear with us…',
	},
	'Because of this change in Pay Frequency some group members will need to be moved to a new Benefit Group with a matching deduction frequency.':
		{
			translation:
				'Because of this change in Pay Frequency some group members will need to be moved to a new Benefit Group with a matching deduction frequency.',
		},
	"Because there's nothing to show, this tab will be hidden.": {
		translation: "Because there's nothing to show, this tab will be hidden.",
	},
	'Because you are changing an address that affects the state tax withholding, you are required to re-enter the information below':
		{
			translation:
				'Because you are changing an address that affects the state tax withholding, you are required to re-enter the information below',
		},
	'Because you have an integration installed that requires pay groups, the pay schedule field in this report is irrelevant.':
		{
			translation:
				'Because you have an integration installed that requires pay groups, the pay schedule field in this report is irrelevant.',
		},
	'Because you have an integration installed that requires pay groups, the pay schedule field in this report is irrelevant. Edit and save this report to remove this column from the report.':
		{
			translation:
				'Because you have an integration installed that requires pay groups, the pay schedule field in this report is irrelevant. Edit and save this report to remove this column from the report.',
		},
	'Becoming eligible for Medicaid': {
		translation: 'Becoming eligible for Medicaid',
	},
	'Becoming eligible for Medicare': {
		translation: 'Becoming eligible for Medicare',
	},
	"Before %1$s can be installed, you'll need to uninstall %2$s": {
		translation: "Before %1$s can be installed, you'll need to uninstall %2$s",
	},
	'Before %1$s can become a Payroll Admin, you need to set a default Employee Access Level for Payroll admins.':
		{
			translation:
				'Before %1$s can become a Payroll Admin, you need to set a default Employee Access Level for Payroll admins.',
		},
	'Before 2020': {
		translation: 'Before 2020',
	},
	"Before adding this employee to the '%1' pay schedule you need to update the employee's Social Security Number.":
		{
			translation:
				"Before adding this employee to the '%1' pay schedule you need to update the employee's Social Security Number.",
		},
	'Before enabling Time Tracking, review and check off each of the setup steps listed above.':
		{
			translation:
				'Before enabling Time Tracking, review and check off each of the setup steps listed above.',
		},
	'Before exporting the employee over to BambooHR, you will want to ensure that all pertinent documentation has been uploaded to the Candidate\'s record within Newton. To do this, view the Candidate\'s record and click the "Attachments" link. Select the type of file and click the "upload" button. When you export the Candidate, all documentation from this location will automatically be uploaded to the Documents Tab in BambooHR.':
		{
			translation:
				'Before exporting the employee over to BambooHR, you will want to ensure that all pertinent documentation has been uploaded to the Candidate\'s record within Newton. To do this, view the Candidate\'s record and click the \\"Attachments\\" link. Select the type of file and click the \\"upload\\" button. When you export the Candidate, all documentation from this location will automatically be uploaded to the Documents Tab in BambooHR.',
		},
	'Before including this employee in payroll you need to correct the following information.':
		{
			translation:
				'Before including this employee in payroll you need to correct the following information.',
		},
	'Before requesting signatures for this file you’ll need to set it up. Don’t worry, it’s easy.':
		{
			translation:
				'Before requesting signatures for this file you’ll need to set it up. Don’t worry, it’s easy.',
		},
	'Before requesting signatures, you’ll need to set this file up. Don’t worry, it’s easy.':
		{
			translation:
				'Before requesting signatures, you’ll need to set this file up. Don’t worry, it’s easy.',
		},
	'Before scheduling your demo, we want to make sure BambooHR Time Tracking is a good fit for you.':
		{
			translation:
				'Before scheduling your demo, we want to make sure BambooHR Time Tracking is a good fit for you.',
		},
	'Before using the Payroll Change Report for the first time, please confirm that employee payroll information in BambooHR matches the information in your payroll system.':
		{
			translation:
				'Before using the Payroll Change Report for the first time, please confirm that employee payroll information in BambooHR matches the information in your payroll system.',
		},
	'Before we can verify your company information, you will need to add the payroll bank account information.':
		{
			translation:
				'Before we can verify your company information, you will need to add the payroll bank account information.',
		},
	'Before we can verify your company information, you will need to complete your bank account setup.':
		{
			translation:
				'Before we can verify your company information, you will need to complete your bank account setup.',
		},
	'Before you add a Payroll Admin, you need to set a default Employee Access Level that will apply to all Payroll admins.':
		{
			translation:
				'Before you add a Payroll Admin, you need to set a default Employee Access Level that will apply to all Payroll admins.',
		},
	'Before you can connect your BambooHR account to GT Clocks you must agree to the [Terms of Use](1).':
		{
			translation:
				'Before you can connect your BambooHR account to GT Clocks you must agree to the [Terms of Use](1).',
		},
	'Before you can upload your file you will need to create a folder to put it in.':
		{
			translation:
				'Before you can upload your file you will need to create a folder to put it in.',
		},
	'Before you clicked approve, one or more employees clocked out.': {
		translation:
			'Before you clicked approve, one or more employees clocked out.',
	},
	'Before you continue': {
		translation: 'Before you continue',
	},
	'Before you continue...': {
		translation: 'Before you continue...',
	},
	'Begin Assessments': {
		translation: 'Begin Assessments',
	},
	'Beginning Balance': {
		translation: 'Beginning Balance',
	},
	'Beginning Balance (Days)': {
		translation: 'Beginning Balance (Days)',
	},
	'Beginning Balance (Hours)': {
		translation: 'Beginning Balance (Hours)',
	},
	'Beginning date must be before end date.': {
		translation: 'Beginning date must be before end date.',
	},
	'Beginning of period': {
		translation: 'Beginning of period',
	},
	Bell: {
		translation: 'Bell',
	},
	'Below is a list of the tax funds we need to collect as part of your onboarding. Once we have your approval, we will sweep the funds from your bank account and make the respective tax payments.':
		{
			translation:
				'Below is a list of the tax funds we need to collect as part of your onboarding. Once we have your approval, we will sweep the funds from your bank account and make the respective tax payments.',
		},
	'Below is a list of the taxes that we need to collect that were collected by your previous payroll vendor. Once we have your approval, we will transfer the funds from your account so that we can make tax payments on your behalf at the end of the quarter.':
		{
			translation:
				'Below is a list of the taxes that we need to collect that were collected by your previous payroll vendor. Once we have your approval, we will transfer the funds from your account so that we can make tax payments on your behalf at the end of the quarter.',
		},
	'Below is a step by step guide to setting up the integration, as well as some helpful information for how Boomr and BambooHR work together once connected.':
		{
			translation:
				'Below is a step by step guide to setting up the integration, as well as some helpful information for how Boomr and BambooHR work together once connected.',
		},
	Benchmark: {
		translation: 'Benchmark',
	},
	'Benchmarking Filters': {
		translation: 'Benchmarking Filters',
	},
	'BeneTrac Site ID': {
		translation: 'BeneTrac Site ID',
	},
	'BeneTrac Status': {
		translation: 'BeneTrac Status',
	},
	'BeneTrac Status Options': {
		translation: 'BeneTrac Status Options',
	},
	'BeneTrac status': {
		translation: 'BeneTrac status',
	},
	'BeneTrac status is empty or cannot be found.': {
		translation: 'BeneTrac status is empty or cannot be found.',
	},
	Beneficiary: {
		translation: 'Beneficiary',
	},
	'Beneficiary Address:': {
		translation: 'Beneficiary Address:',
	},
	'Beneficiary Name:': {
		translation: 'Beneficiary Name:',
	},
	Benefit: {
		translation: 'Benefit',
	},
	'Benefit Class': {
		translation: 'Benefit Class',
	},
	'Benefit Class: Change Reason': {
		translation: 'Benefit Class: Change Reason',
	},
	'Benefit Class: Class': {
		translation: 'Benefit Class: Class',
	},
	'Benefit Class: Date': {
		translation: 'Benefit Class: Date',
	},
	'Benefit Election Changes': {
		translation: 'Benefit Election Changes',
	},
	'Benefit Eligibility': {
		translation: 'Benefit Eligibility',
	},
	'Benefit Enrollment Information': {
		translation: 'Benefit Enrollment Information',
	},
	'Benefit Enrollments': {
		translation: 'Benefit Enrollments',
	},
	'Benefit Group': {
		translation: 'Benefit Group',
	},
	'Benefit Group Name': {
		translation: 'Benefit Group Name',
	},
	'Benefit Group Plan Updated': {
		translation: 'Benefit Group Plan Updated',
	},
	'Benefit Group: %s saved successfully': {
		translation: 'Benefit Group: %s saved successfully',
	},
	'Benefit Group: has been updated': {
		translation: 'Benefit Group: has been updated',
	},
	'Benefit Groups': {
		translation: 'Benefit Groups',
	},
	'Benefit Groups Are Going Away': {
		translation: 'Benefit Groups Are Going Away',
	},
	'Benefit History': {
		translation: 'Benefit History',
	},
	'Benefit Information': {
		translation: 'Benefit Information',
	},
	'Benefit Plan': {
		translation: 'Benefit Plan',
	},
	'Benefit Plan Access': {
		translation: 'Benefit Plan Access',
	},
	'Benefit Plan Company Annual Max': {
		translation: 'Benefit Plan Company Annual Max',
	},
	'Benefit Plan Company Cap Amount': {
		translation: 'Benefit Plan Company Cap Amount',
	},
	'Benefit Plan Company Pays': {
		translation: 'Benefit Plan Company Pays',
	},
	'Benefit Plan Company Pays - Currency code': {
		translation: 'Benefit Plan Company Pays - Currency code',
	},
	'Benefit Plan Company Pays Percent Type': {
		translation: 'Benefit Plan Company Pays Percent Type',
	},
	'Benefit Plan Coverage': {
		translation: 'Benefit Plan Coverage',
	},
	'Benefit Plan Coverage Deleted': {
		translation: 'Benefit Plan Coverage Deleted',
	},
	'Benefit Plan Coverage: %s removed': {
		translation: 'Benefit Plan Coverage: %s removed',
	},
	'Benefit Plan Coverage: %s saved successfully': {
		translation: 'Benefit Plan Coverage: %s saved successfully',
	},
	'Benefit Plan Effective Date': {
		translation: 'Benefit Plan Effective Date',
	},
	'Benefit Plan Eligibility Date': {
		translation: 'Benefit Plan Eligibility Date',
	},
	'Benefit Plan Employee Annual Max': {
		translation: 'Benefit Plan Employee Annual Max',
	},
	'Benefit Plan Employee Cap Amount': {
		translation: 'Benefit Plan Employee Cap Amount',
	},
	'Benefit Plan Employee Monthly Max': {
		translation: 'Benefit Plan Employee Monthly Max',
	},
	'Benefit Plan Employee Pays': {
		translation: 'Benefit Plan Employee Pays',
	},
	'Benefit Plan Employee Pays - Currency code': {
		translation: 'Benefit Plan Employee Pays - Currency code',
	},
	'Benefit Plan Employee Pays Percent Type': {
		translation: 'Benefit Plan Employee Pays Percent Type',
	},
	'Benefit Plan End Date': {
		translation: 'Benefit Plan End Date',
	},
	'Benefit Plan Name': {
		translation: 'Benefit Plan Name',
	},
	'Benefit Plan Start Date': {
		translation: 'Benefit Plan Start Date',
	},
	'Benefit Plan Status': {
		translation: 'Benefit Plan Status',
	},
	'Benefit Plans': {
		translation: 'Benefit Plans',
	},
	'Benefit Settings Access': {
		translation: 'Benefit Settings Access',
	},
	'Benefit Summary': {
		translation: 'Benefit Summary',
	},
	'Benefit Summary Report': {
		translation: 'Benefit Summary Report',
	},
	'Benefit Transition Report': {
		translation: 'Benefit Transition Report',
	},
	'Benefit coverage terminated': {
		translation: 'Benefit coverage terminated',
	},
	'Benefit deduction migration configure': {
		translation: 'Benefit deduction migration configure',
	},
	'Benefit group has been copied.': {
		translation: 'Benefit group has been copied.',
	},
	'Benefit group has been deleted.': {
		translation: 'Benefit group has been deleted.',
	},
	'Benefit groups are often used because different people may be offered different benefit packages based on pay period, location, position, or tenure.':
		{
			translation:
				'Benefit groups are often used because different people may be offered different benefit packages based on pay period, location, position, or tenure.',
		},
	'Benefit groups can be added from the settings page.': {
		translation: 'Benefit groups can be added from the settings page.',
	},
	'Benefit history record successfully deleted': {
		translation: 'Benefit history record successfully deleted',
	},
	'Benefit plan %s is now part of the enrollment window. Please include it in your submission.':
		{
			translation: {
				one: 'Benefit plan %s is now part of the enrollment window. Please include it in your submission.',
				other:
					'Benefit plans %s are now part of the enrollment window. Please include them in your submission.',
			},
		},
	'Benefit record not found': {
		translation: 'Benefit record not found',
	},
	'Benefit updated': {
		translation: 'Benefit updated',
	},
	'Benefit withdrawn': {
		translation: 'Benefit withdrawn',
	},
	Benefits: {
		translation: 'Benefits',
	},
	'Benefits Administration': {
		translation: 'Benefits Administration',
	},
	'Benefits Administrator': {
		translation: 'Benefits Administrator',
	},
	'Benefits Eligibility': {
		translation: 'Benefits Eligibility',
	},
	'Benefits Importer': {
		translation: 'Benefits Importer',
	},
	'Benefits Migration': {
		translation: 'Benefits Migration',
	},
	'Benefits Overview': {
		translation: 'Benefits Overview',
	},
	'Benefits Power Edit': {
		translation: 'Benefits Power Edit',
	},
	'Benefits Reports Access': {
		translation: 'Benefits Reports Access',
	},
	'Benefits Summary': {
		translation: 'Benefits Summary',
	},
	'Benefits Tab.': {
		translation: 'Benefits Tab.',
	},
	'Benefits Upgrade': {
		translation: 'Benefits Upgrade',
	},
	'Benefits Version 2': {
		translation: 'Benefits Version 2',
	},
	"Benefits can sometimes be confusing to employees, but we're here to make them easier.":
		{
			translation:
				"Benefits can sometimes be confusing to employees, but we're here to make them easier.",
		},
	'Benefits can sometimes be confusing to employees, but we’re here to make them easier. Let’s get started by getting to know a little bit about your plan.':
		{
			translation:
				'Benefits can sometimes be confusing to employees, but we’re here to make them easier. Let’s get started by getting to know a little bit about your plan.',
		},
	Bereavement: {
		translation: 'Bereavement',
	},
	Berevement: {
		translation: 'Berevement',
	},
	'Besides resume, what info can collaborators view?': {
		translation: 'Besides resume, what info can collaborators view?',
	},
	'Best Work': {
		translation: 'Best Work',
	},
	Between: {
		translation: 'Between',
	},
	'Bi-weekly': {
		translation: 'Bi-weekly',
	},
	Bigender: {
		translation: 'Bigender',
	},
	Billable: {
		translation: 'Billable',
	},
	'Billable Hours': {
		translation: 'Billable Hours',
	},
	'Billable and non-billable hours': {
		translation: 'Billable and non-billable hours',
	},
	Billing: {
		translation: 'Billing',
	},
	'Billing Address': {
		translation: 'Billing Address',
	},
	'Billing Contact Already Exists': {
		translation: 'Billing Contact Already Exists',
	},
	'Billing Contact Successfully Added': {
		translation: 'Billing Contact Successfully Added',
	},
	'Billing Contact(s)': {
		translation: 'Billing Contact(s)',
	},
	'Billing Date': {
		translation: 'Billing Date',
	},
	'Billing History': {
		translation: 'Billing History',
	},
	'Billing Information': {
		translation: 'Billing Information',
	},
	'Billing contact was succesfully deleted': {
		translation: 'Billing contact was succesfully deleted',
	},
	'Billing contact was successfully deleted': {
		translation: 'Billing contact was successfully deleted',
	},
	'Biometric Data': {
		translation: 'Biometric Data',
	},
	Birth: {
		translation: 'Birth',
	},
	'Birth Date': {
		translation: 'Birth Date',
	},
	'Birth Date is required': {
		translation: 'Birth Date is required',
	},
	'Birth date': {
		translation: 'Birth date',
	},
	'Birth of a Child': {
		translation: 'Birth of a Child',
	},
	Birthdate: {
		translation: 'Birthdate',
	},
	Birthday: {
		translation: 'Birthday',
	},
	Birthdays: {
		translation: 'Birthdays',
	},
	'Birthdays for %1$s': {
		translation: 'Birthdays for %1$s',
	},
	Birthplace: {
		translation: 'Birthplace',
	},
	'Bitium empowers companies to realize the full potential of web-based apps like BambooHR, collaboration tools, CRM, social networks, accounting programs, bug trackers, customer service dashboards, marketing tools, and other Software-as-a-Service.':
		{
			translation:
				'Bitium empowers companies to realize the full potential of web-based apps like BambooHR, collaboration tools, CRM, social networks, accounting programs, bug trackers, customer service dashboards, marketing tools, and other Software-as-a-Service.',
		},
	'Black or African American': {
		translation: 'Black or African American',
	},
	'Blue Cross #': {
		translation: 'Blue Cross #',
	},
	'Board certification': {
		translation: 'Board certification',
	},
	'Board certification date': {
		translation: 'Board certification date',
	},
	Bonus: {
		translation: 'Bonus',
	},
	'Bonus %': {
		translation: 'Bonus %',
	},
	'Bonus 2004': {
		translation: 'Bonus 2004',
	},
	'Bonus 2005': {
		translation: 'Bonus 2005',
	},
	'Bonus 2006': {
		translation: 'Bonus 2006',
	},
	'Bonus Increase': {
		translation: 'Bonus Increase',
	},
	'Bonus Summary': {
		translation: 'Bonus Summary',
	},
	'Bonus amount': {
		translation: 'Bonus amount',
	},
	'Bonus comments': {
		translation: 'Bonus comments',
	},
	'Bonus date': {
		translation: 'Bonus date',
	},
	'Bonus leave amount': {
		translation: 'Bonus leave amount',
	},
	'Bonus leave award date': {
		translation: 'Bonus leave award date',
	},
	'Bonus target': {
		translation: 'Bonus target',
	},
	'Bonus type': {
		translation: 'Bonus type',
	},
	'Bonus: Amount': {
		translation: 'Bonus: Amount',
	},
	'Bonus: Comment': {
		translation: 'Bonus: Comment',
	},
	'Bonus: Date': {
		translation: 'Bonus: Date',
	},
	'Bonus: Reason': {
		translation: 'Bonus: Reason',
	},
	'Bookmark this page to quickly access your Company Directory with just one click.':
		{
			translation:
				'Bookmark this page to quickly access your Company Directory with just one click.',
		},
	Booster: {
		translation: 'Booster',
	},
	'Boot Size': {
		translation: 'Boot Size',
	},
	Both: {
		translation: 'Both',
	},
	'Bottom axis for chart': {
		translation: 'Bottom axis for chart',
	},
	Branch: {
		translation: 'Branch',
	},
	'Breakdown By Age': {
		translation: 'Breakdown By Age',
	},
	'Breakdown By Gender': {
		translation: 'Breakdown By Gender',
	},
	'Breaking up is hard to do. Make it easier.': {
		translation: 'Breaking up is hard to do. Make it easier.',
	},
	Brother: {
		translation: 'Brother',
	},
	'Browse Fields': {
		translation: 'Browse Fields',
	},
	'Browse items': {
		translation: 'Browse items',
	},
	'Browsing {1} employee from [{2}]': {
		translation: {
			one: 'Browsing {1} employee from [{2}]',
			other: 'Browsing {1} employees from [{2}]',
		},
	},
	'Bubble Tail': {
		translation: 'Bubble Tail',
	},
	'Building Key': {
		translation: 'Building Key',
	},
	'Building some sweet BambooHR integrations?': {
		translation: 'Building some sweet BambooHR integrations?',
	},
	'Bulk Data Access': {
		translation: 'Bulk Data Access',
	},
	'Bulk Edit': {
		translation: 'Bulk Edit',
	},
	'Bulk Edit Successful.': {
		translation: 'Bulk Edit Successful.',
	},
	'Bulk imports are not supported on Remote Policies': {
		translation: 'Bulk imports are not supported on Remote Policies',
	},
	Bus: {
		translation: 'Bus',
	},
	'But even this will likely change in the future': {
		translation: 'But even this will likely change in the future',
	},
	'But even this will likely change in the future.': {
		translation: 'But even this will likely change in the future.',
	},
	"But if you used BambooHR + Bamboo Payroll, what you'd see here is": {
		translation:
			"But if you used BambooHR + Bamboo Payroll, what you'd see here is",
	},
	'But, hey, it was worth a try.': {
		translation: 'But, hey, it was worth a try.',
	},
	Butch: {
		translation: 'Butch',
	},
	'By %1 on %2 at %3': {
		translation: 'By %1 on %2 at %3',
	},
	"By 'date' I mean `MM/DD/YYYY`... not a candle light dinner.": {
		translation: "By 'date' I mean `MM/DD/YYYY`... not a candle light dinner.",
	},
	"By 'date' I mean `MM/DD/YYYY`... not a drive in the country and a picnic lunch.":
		{
			translation:
				"By 'date' I mean `MM/DD/YYYY`... not a drive in the country and a picnic lunch.",
		},
	"By 'date' I mean `MM/DD/YYYY`... not a moonlit walk in the park.": {
		translation:
			"By 'date' I mean `MM/DD/YYYY`... not a moonlit walk in the park.",
	},
	"By 'date' I mean `MM/DD/YYYY`... not bowling.": {
		translation: "By 'date' I mean `MM/DD/YYYY`... not bowling.",
	},
	"By 'date' I mean `MM/DD/YYYY`... not dinner and a movie.": {
		translation: "By 'date' I mean `MM/DD/YYYY`... not dinner and a movie.",
	},
	"By 'date' I mean `MM/DD/YYYY`... not ice skating.": {
		translation: "By 'date' I mean `MM/DD/YYYY`... not ice skating.",
	},
	'By accepting the Data Processing Agreement (“DPA”), I confirm that I am duly authorized to represent my company and accept the DPA on its behalf and that my company has employees in the European Union, EEA, the United Kingdom or Switzerland.':
		{
			translation:
				'By accepting the Data Processing Agreement (“DPA”), I confirm that I am duly authorized to represent my company and accept the DPA on its behalf and that my company has employees in the European Union, EEA, the United Kingdom or Switzerland.',
		},
	'By cancelling this setup, you will lose any unsaved changes you have made to %1$s.':
		{
			translation:
				'By cancelling this setup, you will lose any unsaved changes you have made to %1$s.',
		},
	'By clicking "Proceed" you will delete ALL existing peer feedback inbox items and associated assessments. Also, you will be resetting ALL peer feedback review period start dates.':
		{
			translation:
				'By clicking \\"Proceed\\" you will delete ALL existing peer feedback inbox items and associated assessments. Also, you will be resetting ALL peer feedback review period start dates.',
		},
	'By clicking "Proceed" you will delete all existing peer feedback inbox items and associated assessments from CURRENT review period. Also, you will be resetting the CURRENT peer feedback review period start date.':
		{
			translation:
				'By clicking \\"Proceed\\" you will delete all existing peer feedback inbox items and associated assessments from CURRENT review period. Also, you will be resetting the CURRENT peer feedback review period start date.',
		},
	'By clicking "Proceed" you will delete all existing peer feedback inbox items and associated assessments.':
		{
			translation:
				'By clicking \\"Proceed\\" you will delete all existing peer feedback inbox items and associated assessments.',
		},
	'By default, these fields will be on the approval form. You can add additional fields below.':
		{
			translation:
				'By default, these fields will be on the approval form. You can add additional fields below.',
		},
	'By default, we track the completion date of the training. You can opt to track other training details by checking the appropriate boxes below.':
		{
			translation:
				'By default, we track the completion date of the training. You can opt to track other training details by checking the appropriate boxes below.',
		},
	'By deleting that row, the employee will no longer have an active pay schedule.':
		{
			translation:
				'By deleting that row, the employee will no longer have an active pay schedule.',
		},
	'By deleting that row, the employee will no longer have valid data for their pay schedule.':
		{
			translation:
				'By deleting that row, the employee will no longer have valid data for their pay schedule.',
		},
	'By exiting this form before it is completed, you will lose any progress that you have made.':
		{
			translation:
				'By exiting this form before it is completed, you will lose any progress that you have made.',
		},
	"By installing this app in your BambooHR account you are enabling BambooHR as a Service Provider for SAML, web-based single sign-on (SSO). After installing, you'll be able to save the SAML Endpoint URL and SAML Certificate information given to you by your SAML Identity Provider (OneLogin, Okta, etc). Upon successful configuration you'll enjoy seamless, web-based single sign-on into BambooHR from your single sign-on portal or company intranet.":
		{
			translation:
				"By installing this app in your BambooHR account you are enabling BambooHR as a Service Provider for SAML, web-based single sign-on (SSO). After installing, you'll be able to save the SAML Endpoint URL and SAML Certificate information given to you by your SAML Identity Provider (OneLogin, Okta, etc). Upon successful configuration you'll enjoy seamless, web-based single sign-on into BambooHR from your single sign-on portal or company intranet.",
		},
	'By installing this integration you understand and authorize the following: This integration will match your employees in BambooHR to users in your Slack workspace and automatically install the BambooHR app in Slack for all matched users.':
		{
			translation:
				'By installing this integration you understand and authorize the following: This integration will match your employees in BambooHR to users in your Slack workspace and automatically install the BambooHR app in Slack for all matched users.',
		},
	'By subscribing to BambooHR you agree to the <a href="http://www.bamboohr.com/privacy.php" target="_blank" rel="noopener external nofollow noreferrer">Privacy Policy</a> and <a href="http://www.bamboohr.com/refund.php" target="_blank" rel="noopener noreferrer">Refund Policy</a>.':
		{
			translation:
				'By subscribing to BambooHR you agree to the <a href=\\"http://www.bamboohr.com/privacy.php\\" target=\\"_blank\\" rel=\\"noopener external nofollow noreferrer\\">Privacy Policy</a> and <a href=\\"http://www.bamboohr.com/refund.php\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Refund Policy</a>.',
		},
	'By {1} on {2} at {3}': {
		translation: 'By {1} on {2} at {3}',
	},
	'By {1}, Help us organize your *Variable Rate Benefit Plans*': {
		translation: 'By {1}, Help us organize your *Variable Rate Benefit Plans*',
	},
	'CA Ethnicity': {
		translation: 'CA Ethnicity',
	},
	'CA Health Insurance': {
		translation: 'CA Health Insurance',
	},
	'CA/GA CC/GA Balancing': {
		translation: 'CA/GA CC/GA Balancing',
	},
	'CAQH password': {
		translation: 'CAQH password',
	},
	'CAQH provider ID': {
		translation: 'CAQH provider ID',
	},
	'CAQH username': {
		translation: 'CAQH username',
	},
	'CATS Software integrates with BambooHR through our API. When an applicant is "Placed" within CATS, their demographic information can be sent over to BambooHR with a single click and a new employee record is automatically created within the BambooHR system.':
		{
			translation:
				'CATS Software integrates with BambooHR through our API. When an applicant is \\"Placed\\" within CATS, their demographic information can be sent over to BambooHR with a single click and a new employee record is automatically created within the BambooHR system.',
		},
	'CATS is a full-featured, web-based applicant tracking system. Accessible from any browser or mobile device, users can manage the entire tracking process from posting jobs to leading job boards and social networks to generating customized reports. Users can collect applications with the highly customizable, hosted career portal and find the right candidates with powerful searching capabilities.':
		{
			translation:
				'CATS is a full-featured, web-based applicant tracking system. Accessible from any browser or mobile device, users can manage the entire tracking process from posting jobs to leading job boards and social networks to generating customized reports. Users can collect applications with the highly customizable, hosted career portal and find the right candidates with powerful searching capabilities.',
		},
	'CC #': {
		translation: 'CC #',
	},
	'CC 1 Allocation Percent': {
		translation: 'CC 1 Allocation Percent',
	},
	'CC 2 Allocation Percent': {
		translation: 'CC 2 Allocation Percent',
	},
	'CC 3 Allocation Percent': {
		translation: 'CC 3 Allocation Percent',
	},
	'CC 4 Allocation Percent': {
		translation: 'CC 4 Allocation Percent',
	},
	'CC Exp Date': {
		translation: 'CC Exp Date',
	},
	'CC Number': {
		translation: 'CC Number',
	},
	'CDV Jones Percent': {
		translation: 'CDV Jones Percent',
	},
	CFO: {
		translation: 'CFO',
	},
	'CLEAR ALL DATA': {
		translation: 'CLEAR ALL DATA',
	},
	'CLICK HERE To Authenticate against your BambooHR account!': {
		translation: 'CLICK HERE To Authenticate against your BambooHR account!',
	},
	'CLICK HERE To Authenticate with your BambooHR account!': {
		translation: 'CLICK HERE To Authenticate with your BambooHR account!',
	},
	'CLICK HERE!': {
		translation: 'CLICK HERE!',
	},
	COA: {
		translation: 'COA',
	},
	'COMPAS Technology develops industry leading SaaS recruiting and talent management software solutions for both the Corporate and Staffing industries. We are committed to helping professionals within the talent acquisition and management industry recruit and on-board effectively and efficiently.':
		{
			translation:
				'COMPAS Technology develops industry leading SaaS recruiting and talent management software solutions for both the Corporate and Staffing industries. We are committed to helping professionals within the talent acquisition and management industry recruit and on-board effectively and efficiently.',
		},
	'COVID-19': {
		translation: 'COVID-19',
	},
	'COVID-19 Information': {
		translation: 'COVID-19 Information',
	},
	'COVID-19 Related Absence': {
		translation: 'COVID-19 Related Absence',
	},
	CPR: {
		translation: 'CPR',
	},
	'CPR Exp': {
		translation: 'CPR Exp',
	},
	'CPR Expiration': {
		translation: 'CPR Expiration',
	},
	'CSS Modules': {
		translation: 'CSS Modules',
	},
	CSV: {
		translation: 'CSV',
	},
	CURRENT: {
		translation: 'CURRENT',
	},
	CVV: {
		translation: 'CVV',
	},
	'Calculate Balance': {
		translation: 'Calculate Balance',
	},
	Calculated: {
		translation: 'Calculated',
	},
	Calculating: {
		translation: 'Calculating',
	},
	Calendar: {
		translation: 'Calendar',
	},
	'Calendar & Video Access': {
		translation: 'Calendar & Video Access',
	},
	'Calendar Color': {
		translation: 'Calendar Color',
	},
	'Calendar Filters': {
		translation: 'Calendar Filters',
	},
	'Calendar Menu': {
		translation: 'Calendar Menu',
	},
	'Calendar Picker': {
		translation: 'Calendar Picker',
	},
	'Calendar and Video Integrations': {
		translation: 'Calendar and Video Integrations',
	},
	"California law requires that Sick Time balance notices go out on the same day as an employee's paycheck.":
		{
			translation:
				"California law requires that Sick Time balance notices go out on the same day as an employee's paycheck.",
		},
	'Call %s to sign up!': {
		translation: 'Call %s to sign up!',
	},
	'Can Access Information For': {
		translation: 'Can Access Information For',
	},
	'Can Access Information for': {
		translation: 'Can Access Information for',
	},
	'Can Request Time Off': {
		translation: 'Can Request Time Off',
	},
	'Can Request Time Off for': {
		translation: 'Can Request Time Off for',
	},
	'Can View': {
		translation: 'Can View',
	},
	'Can be seen by ': {
		translation: 'Can be seen by ',
	},
	'Can edit requests where the time off has already been taken.': {
		translation: 'Can edit requests where the time off has already been taken.',
	},
	'Can not skip assessment that has already been completed and that does not have an associated manager assessment.':
		{
			translation:
				'Can not skip assessment that has already been completed and that does not have an associated manager assessment.',
		},
	'Can only change %1$sEmployee%2$s Access Levels (not Manager or Custom Levels)':
		{
			translation:
				'Can only change %1$sEmployee%2$s Access Levels (not Manager or Custom Levels)',
		},
	'Can only change Employee Access Levels (not Manager or Custom Levels)': {
		translation:
			'Can only change Employee Access Levels (not Manager or Custom Levels)',
	},
	'Can post new and edit Job Openings, add and edit Candidates.': {
		translation: 'Can post new and edit Job Openings, add and edit Candidates.',
	},
	'Can post new and edit Job Openings, create and edit Talent Pools, add and edit Candidates.':
		{
			translation:
				'Can post new and edit Job Openings, create and edit Talent Pools, add and edit Candidates.',
		},
	'Can post new and edit Job Openings, create and edit Talent Pools, schedule Interviews, add and edit Candidates.':
		{
			translation:
				'Can post new and edit Job Openings, create and edit Talent Pools, schedule Interviews, add and edit Candidates.',
		},
	'Can purchase premium job ads to boost visibility on job boards.': {
		translation:
			'Can purchase premium job ads to boost visibility on job boards.',
	},
	'Can record time off, assign policies, and adjust PTO balances.': {
		translation:
			'Can record time off, assign policies, and adjust PTO balances.',
	},
	'Can see:': {
		translation: 'Can see:',
	},
	'Can view payroll reports through BHR and TRAXPayroll': {
		translation: 'Can view payroll reports through BHR and TRAXPayroll',
	},
	'Can view payroll reports through BambooHR and TRAXPayroll': {
		translation: 'Can view payroll reports through BambooHR and TRAXPayroll',
	},
	'Can&#39;t find this policy': {
		translation: 'Can&#039;t find this policy',
	},
	"Can't Delete Yet...": {
		translation: "Can't Delete Yet...",
	},
	"Can't add more than %1$s custom questions.": {
		translation: "Can't add more than %1$s custom questions.",
	},
	"Can't add more than %s custom questions.": {
		translation: "Can't add more than %s custom questions.",
	},
	"Can't afford a fancy tropical vacation? Sand is only $9.00 per ton. You've just made enough money for about %1$s tons. Bring the beach to you.":
		{
			translation:
				"Can't afford a fancy tropical vacation? Sand is only $9.00 per ton. You've just made enough money for about %1$s tons. Bring the beach to you.",
		},
	"Can't be used to request time off, but you can still grant access for historical reporting purposes.":
		{
			translation:
				"Can't be used to request time off, but you can still grant access for historical reporting purposes.",
		},
	"Can't find your bank?": {
		translation: "Can't find your bank?",
	},
	"Can't move candidate(s) while one has an offer letter still in progress.": {
		translation:
			"Can't move candidate(s) while one has an offer letter still in progress.",
	},
	"Can't power edit calculated fields.": {
		translation: "Can't power edit calculated fields.",
	},
	"Can't update. One or more candidates has been moved or deleted.": {
		translation:
			"Can't update. One or more candidates has been moved or deleted.",
	},
	Canada: {
		translation: 'Canada',
	},
	Cancel: {
		translation: 'Cancel',
	},
	'Cancel All Pending': {
		translation: 'Cancel All Pending',
	},
	'Cancel Custom Approval': {
		translation: 'Cancel Custom Approval',
	},
	'Cancel Information Updates': {
		translation: 'Cancel Information Updates',
	},
	'Cancel New Hire Packet?': {
		translation: 'Cancel New Hire Packet?',
	},
	'Cancel Offer': {
		translation: 'Cancel Offer',
	},
	'Cancel Offer?': {
		translation: 'Cancel Offer?',
	},
	'Cancel Packet': {
		translation: 'Cancel Packet',
	},
	'Cancel Request': {
		translation: 'Cancel Request',
	},
	'Cancel Signature Request': {
		translation: 'Cancel Signature Request',
	},
	'Cancel Time Off Request': {
		translation: 'Cancel Time Off Request',
	},
	Canceled: {
		translation: 'Canceled',
	},
	'Cancellation notice': {
		translation: 'Cancellation notice',
	},
	Candidate: {
		translation: 'Candidate',
	},
	'Candidate ATS Sources Report': {
		translation: 'Candidate ATS Sources Report',
	},
	'Candidate Count': {
		translation: 'Candidate Count',
	},
	'Candidate First Name': {
		translation: 'Candidate First Name',
	},
	'Candidate Funnel': {
		translation: 'Candidate Funnel',
	},
	'Candidate Funnel Report': {
		translation: 'Candidate Funnel Report',
	},
	'Candidate Hiring Flows': {
		translation: 'Candidate Hiring Flows',
	},
	'Candidate History': {
		translation: 'Candidate History',
	},
	'Candidate Info': {
		translation: 'Candidate Info',
	},
	'Candidate Last Name': {
		translation: 'Candidate Last Name',
	},
	'Candidate Sources': {
		translation: 'Candidate Sources',
	},
	'Candidate Sources Report': {
		translation: 'Candidate Sources Report',
	},
	'Candidate Status has been successfully enabled.': {
		translation: 'Candidate Status has been successfully enabled.',
	},
	'Candidate Status has been successfully removed.': {
		translation: 'Candidate Status has been successfully removed.',
	},
	'Candidate Statuses': {
		translation: 'Candidate Statuses',
	},
	'Candidate for %1s': {
		translation: 'Candidate for %1s',
	},
	'Candidate for [{1} jobs].': {
		translation: 'Candidate for [{1} jobs].',
	},
	'Candidate for...': {
		translation: 'Candidate for...',
	},
	'Candidate id is invalid': {
		translation: 'Candidate id is invalid',
	},
	'Candidate not found': {
		translation: 'Candidate not found',
	},
	Candidates: {
		translation: 'Candidates',
	},
	'Candidates With Offers': {
		translation: 'Candidates With Offers',
	},
	'Candidates by Disability and Gender': {
		translation: 'Candidates by Disability and Gender',
	},
	'Candidates by Race and Gender': {
		translation: 'Candidates by Race and Gender',
	},
	'Candidates by Veteran Status and Gender': {
		translation: 'Candidates by Veteran Status and Gender',
	},
	'Candidates currently in this status will remain so until they are moved into a different status.':
		{
			translation:
				'Candidates currently in this status will remain so until they are moved into a different status.',
		},
	'Candy bar': {
		translation: 'Candy bar',
	},
	'Cannot Load Offer Letter': {
		translation: 'Cannot Load Offer Letter',
	},
	'Cannot View': {
		translation: 'Cannot View',
	},
	'Cannot be longer than 40 characters': {
		translation: 'Cannot be longer than 40 characters',
	},
	'Cannot be lower than minimum': {
		translation: 'Cannot be lower than minimum',
	},
	'Cannot change a clock out date while previewing as another user.': {
		translation:
			'Cannot change a clock out date while previewing as another user.',
	},
	'Cannot change deduction offset': {
		translation: 'Cannot change deduction offset',
	},
	'Cannot contain special characters': {
		translation: 'Cannot contain special characters',
	},
	'Cannot delete row: Invalid Id': {
		translation: 'Cannot delete row: Invalid Id',
	},
	'Cannot enroll in the %s coverage': {
		translation: 'Cannot enroll in the %s coverage',
	},
	'Cannot exceed maximum': {
		translation: 'Cannot exceed maximum',
	},
	"Cannot find reports to employee '%s'": {
		translation: "Cannot find reports to employee '%s'",
	},
	'Cannot find this benefit (%s)': {
		translation: 'Cannot find this benefit (%s)',
	},
	'Cannot find this custom field': {
		translation: 'Cannot find this custom field',
	},
	'Cannot find this employee': {
		translation: 'Cannot find this employee',
	},
	'Cannot find this employee or they are inactive': {
		translation: 'Cannot find this employee or they are inactive',
	},
	"Cannot find this employee, they are inactive, or don't have an enabled user":
		{
			translation:
				"Cannot find this employee, they are inactive, or don't have an enabled user",
		},
	'Cannot find this employee.': {
		translation: 'Cannot find this employee.',
	},
	'Cannot find this list value': {
		translation: 'Cannot find this list value',
	},
	'Cannot find this pay schedule': {
		translation: 'Cannot find this pay schedule',
	},
	'Cannot load latest offer letter edit.': {
		translation: 'Cannot load latest offer letter edit.',
	},
	'Cannot load packages right now!': {
		translation: 'Cannot load packages right now!',
	},
	'Cannot move candidate who has already been moved': {
		translation: 'Cannot move candidate who has already been moved',
	},
	'Cannot set FieldId when adding a training': {
		translation: 'Cannot set FieldId when adding a training',
	},
	'Cannot submit assessment. There was a problem with your answers: ': {
		translation:
			'Cannot submit assessment. There was a problem with your answers: ',
	},
	'Cannot transport clients': {
		translation: 'Cannot transport clients',
	},
	'Cant have a negative number': {
		translation: 'Cant have a negative number',
	},
	'Cap Amount': {
		translation: 'Cap Amount',
	},
	'Cap:': {
		translation: 'Cap:',
	},
	'Car 2 license #': {
		translation: 'Car 2 license #',
	},
	'Car 2 license state': {
		translation: 'Car 2 license state',
	},
	'Car 2 make / model': {
		translation: 'Car 2 make / model',
	},
	'Car 2 year': {
		translation: 'Car 2 year',
	},
	'Car 3 license #': {
		translation: 'Car 3 license #',
	},
	'Car 3 license state': {
		translation: 'Car 3 license state',
	},
	'Car 3 make / model': {
		translation: 'Car 3 make / model',
	},
	'Car 3 year': {
		translation: 'Car 3 year',
	},
	'Car allowance': {
		translation: 'Car allowance',
	},
	'Car license #': {
		translation: 'Car license #',
	},
	'Car license state': {
		translation: 'Car license state',
	},
	'Car make / model': {
		translation: 'Car make / model',
	},
	'Car year': {
		translation: 'Car year',
	},
	'Card #': {
		translation: 'Card #',
	},
	'Card # (Last 4 Digits)': {
		translation: 'Card # (Last 4 Digits)',
	},
	'Card Number': {
		translation: 'Card Number',
	},
	'Card Type': {
		translation: 'Card Type',
	},
	'Careful, these employees will be removed from their current group  and may lose benefits if you move them to this Group.':
		{
			translation:
				'Careful, these employees will be removed from their current group  and may lose benefits if you move them to this Group.',
		},
	'Careful, this employee will be removed from their current group and may lose benefits if you move them to another group.':
		{
			translation:
				'Careful, this employee will be removed from their current group and may lose benefits if you move them to another group.',
		},
	'Caroline Moon': {
		translation: 'Caroline Moon',
	},
	'Carrier Name': {
		translation: 'Carrier Name',
	},
	'Carryover Amount': {
		translation: 'Carryover Amount',
	},
	'Carryover Date': {
		translation: 'Carryover Date',
	},
	'Cascading Goals': {
		translation: 'Cascading Goals',
	},
	'Cascading goals cannot be aligned with another goal.': {
		translation: 'Cascading goals cannot be aligned with another goal.',
	},
	'Cascading goals cannot be shared.': {
		translation: 'Cascading goals cannot be shared.',
	},
	'Case #': {
		translation: 'Case #',
	},
	'Case Description': {
		translation: 'Case Description',
	},
	'Case Number': {
		translation: 'Case Number',
	},
	'Cash Advance Repayment': {
		translation: 'Cash Advance Repayment',
	},
	'Cash in Your Pocket': {
		translation: 'Cash in Your Pocket',
	},
	'Cash in your pocket': {
		translation: 'Cash in your pocket',
	},
	'Categories included in payroll must be in hours': {
		translation: 'Categories included in payroll must be in hours',
	},
	'Categorize Your Job Titles': {
		translation: 'Categorize Your Job Titles',
	},
	Category: {
		translation: 'Category',
	},
	'Category Name': {
		translation: 'Category Name',
	},
	'Category mappings saved successfully': {
		translation: 'Category mappings saved successfully',
	},
	'Category order successfully updated.': {
		translation: 'Category order successfully updated.',
	},
	"Caution: this exposes sensitive information, regardless of a user's other permissions.":
		{
			translation:
				"Caution: this exposes sensitive information, regardless of a user's other permissions.",
		},
	Celebrations: {
		translation: 'Celebrations',
	},
	'Cell Actions': {
		translation: 'Cell Actions',
	},
	'Cell Phone': {
		translation: 'Cell Phone',
	},
	'Cell carrier': {
		translation: 'Cell carrier',
	},
	'Cellular Phone': {
		translation: 'Cellular Phone',
	},
	"Certain employee information is required, even for employees who have been terminated (as long as they've worked this calendar year and will be receiving a W-2)":
		{
			translation:
				"Certain employee information is required, even for employees who have been terminated (as long as they've worked this calendar year and will be receiving a W-2)",
		},
	'Certificate Number': {
		translation: 'Certificate Number',
	},
	'Certification Number': {
		translation: 'Certification Number',
	},
	'Certification Title': {
		translation: 'Certification Title',
	},
	Certifications: {
		translation: 'Certifications',
	},
	'Certifications: Completion Date': {
		translation: 'Certifications: Completion Date',
	},
	'Certifications: Expiration Date': {
		translation: 'Certifications: Expiration Date',
	},
	'Certifications: Notes': {
		translation: 'Certifications: Notes',
	},
	'Certifications: Number': {
		translation: 'Certifications: Number',
	},
	'Certifications: Title': {
		translation: 'Certifications: Title',
	},
	Change: {
		translation: 'Change',
	},
	'Change "${label}" to...': {
		translation: 'Change \\"${label}\\" to...',
	},
	'Change %s to...': {
		translation: 'Change %s to...',
	},
	'Change Account': {
		translation: 'Change Account',
	},
	'Change Account Owner': {
		translation: 'Change Account Owner',
	},
	'Change All Start Dates': {
		translation: 'Change All Start Dates',
	},
	'Change Benefit Group': {
		translation: 'Change Benefit Group',
	},
	'Change Company Info': {
		translation: 'Change Company Info',
	},
	'Change Date': {
		translation: 'Change Date',
	},
	'Change Dates': {
		translation: 'Change Dates',
	},
	'Change Employee Numbers': {
		translation: 'Change Employee Numbers',
	},
	'Change Employee Photos': {
		translation: 'Change Employee Photos',
	},
	'Change Goals': {
		translation: 'Change Goals',
	},
	'Change Group': {
		translation: 'Change Group',
	},
	'Change History': {
		translation: 'Change History',
	},
	'Change Information Request': {
		translation: 'Change Information Request',
	},
	'Change My Password': {
		translation: 'Change My Password',
	},
	'Change Next Review Period Start Date': {
		translation: 'Change Next Review Period Start Date',
	},
	'Change Owner': {
		translation: 'Change Owner',
	},
	'Change Password': {
		translation: 'Change Password',
	},
	'Change Pay Date': {
		translation: 'Change Pay Date',
	},
	'Change Peer Feedback': {
		translation: 'Change Peer Feedback',
	},
	'Change Photo': {
		translation: 'Change Photo',
	},
	'Change Plan': {
		translation: 'Change Plan',
	},
	'Change Reason': {
		translation: 'Change Reason',
	},
	'Change Report Owner': {
		translation: 'Change Report Owner',
	},
	'Change Status': {
		translation: 'Change Status',
	},
	'Change Status To...': {
		translation: 'Change Status To...',
	},
	'Change Template': {
		translation: 'Change Template',
	},
	'Change Time Tracking Start Dates?': {
		translation: 'Change Time Tracking Start Dates?',
	},
	'Change Type': {
		translation: 'Change Type',
	},
	'Change Your Benefit Group': {
		translation: 'Change Your Benefit Group',
	},
	'Change anywhere it is used, including history.': {
		translation: 'Change anywhere it is used, including history.',
	},
	'Change communication message text is not set.': {
		translation: 'Change communication message text is not set.',
	},
	'Change communication subject is not set.': {
		translation: 'Change communication subject is not set.',
	},
	'Change date': {
		translation: 'Change date',
	},
	'Change for future but leave history alone.': {
		translation: 'Change for future but leave history alone.',
	},
	'Change in Information Request': {
		translation: 'Change in Information Request',
	},
	'Change in employment status': {
		translation: 'Change in employment status',
	},
	'Change of residence': {
		translation: 'Change of residence',
	},
	'Change scheduled start date': {
		translation: 'Change scheduled start date',
	},
	'Change the day you want to start tracking.': {
		translation: 'Change the day you want to start tracking.',
	},
	'Change the share date?': {
		translation: 'Change the share date?',
	},
	'Change the toggle option from "Off" to "On" and then click the blue Save button. This will activate the initial synchronization of data from BambooHR into SwipeClock&reg;. The initial synchronization will send over updates for ALL employees within BambooHR to SwipeClock&reg; creating any new users as needed. Going forward as long as the Synchronization is on, any changes made in BambooHR will be automatically updated in SwipeClock&reg; within one minute.':
		{
			translation:
				'Change the toggle option from \\"Off\\" to \\"On\\" and then click the blue Save button. This will activate the initial synchronization of data from BambooHR into SwipeClock&reg;. The initial synchronization will send over updates for ALL employees within BambooHR to SwipeClock&reg; creating any new users as needed. Going forward as long as the Synchronization is on, any changes made in BambooHR will be automatically updated in SwipeClock&reg; within one minute.',
		},
	'Change these types to hours': {
		translation: 'Change these types to hours',
	},
	'Change to Hours': {
		translation: 'Change to Hours',
	},
	'Change your plan': {
		translation: 'Change your plan',
	},
	Changed: {
		translation: 'Changed',
	},
	'Changed by': {
		translation: 'Changed by',
	},
	Changes: {
		translation: 'Changes',
	},
	'Changes Made': {
		translation: 'Changes Made',
	},
	'Changes since what checkpoint?': {
		translation: 'Changes since what checkpoint?',
	},
	'Changing Pay Group will also change the Pay Frequency. Because of this, you will need to select a new Benefit Group that matches the new frequency.':
		{
			translation:
				'Changing Pay Group will also change the Pay Frequency. Because of this, you will need to select a new Benefit Group that matches the new frequency.',
		},
	"Changing pay period also requires changes to benefit groups. Since you don't have permission to change benefit groups, you can't change this.":
		{
			translation:
				"Changing pay period also requires changes to benefit groups. Since you don't have permission to change benefit groups, you can't change this.",
		},
	"Changing pay schedule also requires changes to benefit groups. Since you don't have permission to change benefit groups, you can't change this.":
		{
			translation:
				"Changing pay schedule also requires changes to benefit groups. Since you don't have permission to change benefit groups, you can't change this.",
		},
	'Changing the Payroll sync info below may impact their payroll': {
		translation:
			'Changing the Payroll sync info below may impact their payroll',
	},
	'Changing the Payroll sync info below may impact their payroll.': {
		translation:
			'Changing the Payroll sync info below may impact their payroll.',
	},
	'Changing the template will cancel signature requests.': {
		translation: 'Changing the template will cancel signature requests.',
	},
	'Changing this will delete all approvals for "%1"': {
		translation: 'Changing this will delete all approvals for \\"%1\\"',
	},
	'Changing your access level could cause you to lose access to Bamboo features and functionality. You may not be able to undo this action.':
		{
			translation:
				'Changing your access level could cause you to lose access to Bamboo features and functionality. You may not be able to undo this action.',
		},
	'Chart Data': {
		translation: 'Chart Data',
	},
	Charts: {
		translation: 'Charts',
	},
	Chat: {
		translation: 'Chat',
	},
	'Chat with Us Now': {
		translation: 'Chat with Us Now',
	},
	Check: {
		translation: 'Check',
	},
	'Check #': {
		translation: 'Check #',
	},
	'Check & Resolve Conflicts': {
		translation: 'Check & Resolve Conflicts',
	},
	'Check Amount': {
		translation: 'Check Amount',
	},
	'Check Back for Some Delicious Data': {
		translation: 'Check Back for Some Delicious Data',
	},
	'Check amount': {
		translation: 'Check amount',
	},
	'Check another': {
		translation: 'Check another',
	},
	'Check back after assessments are complete on {1}': {
		translation: 'Check back after assessments are complete on {1}',
	},
	'Check back later.': {
		translation: 'Check back later.',
	},
	"Check that the candidate's email address is valid.": {
		translation: "Check that the candidate's email address is valid.",
	},
	'Check that the candidate’s email address is valid.': {
		translation: 'Check that the candidate’s email address is valid.',
	},
	'Check that they are assigned to the right location and pay schedule.': {
		translation:
			'Check that they are assigned to the right location and pay schedule.',
	},
	'Check the sample data on the right to make sure everything looks good.': {
		translation:
			'Check the sample data on the right to make sure everything looks good.',
	},
	'Check to make sure your home and job location addresses are valid.': {
		translation:
			'Check to make sure your home and job location addresses are valid.',
	},
	'Check your %1$s payroll summary report %2$s to make sure all your employees pay info is up to date.':
		{
			translation:
				'Check your %1$s payroll summary report %2$s to make sure all your employees pay info is up to date.',
		},
	'Check your location addresses so we can calculate overtime correctly.': {
		translation:
			'Check your location addresses so we can calculate overtime correctly.',
	},
	'Check your pay schedules so we can setup timesheets and approvals.': {
		translation:
			'Check your pay schedules so we can setup timesheets and approvals.',
	},
	'Check! Everyone has direct deposit info.': {
		translation: 'Check! Everyone has direct deposit info.',
	},
	Checkbox: {
		translation: 'Checkbox',
	},
	'Checkbox Not Selected': {
		translation: 'Checkbox Not Selected',
	},
	'Checkbox Selected': {
		translation: 'Checkbox Selected',
	},
	Checked: {
		translation: 'Checked',
	},
	'Checked Out': {
		translation: 'Checked Out',
	},
	Checking: {
		translation: 'Checking',
	},
	'Checking References': {
		translation: 'Checking References',
	},
	'Chief Culture Officer': {
		translation: 'Chief Culture Officer',
	},
	'Chief Executive Officer': {
		translation: 'Chief Executive Officer',
	},
	'Chief Financial Officer': {
		translation: 'Chief Financial Officer',
	},
	'Chief Information Officer': {
		translation: 'Chief Information Officer',
	},
	'Chief Operating Officer': {
		translation: 'Chief Operating Officer',
	},
	'Chief People Officer': {
		translation: 'Chief People Officer',
	},
	'Chief Revenue Officer': {
		translation: 'Chief Revenue Officer',
	},
	Child: {
		translation: 'Child',
	},
	'Child Coverage Amount': {
		translation: 'Child Coverage Amount',
	},
	'Child Support': {
		translation: 'Child Support',
	},
	'Child coverage amount specified but the plan does not support child coverage for benefit plan %s.':
		{
			translation:
				'Child coverage amount specified but the plan does not support child coverage for benefit plan %s.',
		},
	'Child coverage amount specified but we could not find a valid child dependent for benefit plan %s.':
		{
			translation:
				'Child coverage amount specified but we could not find a valid child dependent for benefit plan %s.',
		},
	'Child support and alimony': {
		translation: 'Child support and alimony',
	},
	Choose: {
		translation: 'Choose',
	},
	'Choose Data': {
		translation: 'Choose Data',
	},
	'Choose Fields': {
		translation: 'Choose Fields',
	},
	'Choose File': {
		translation: 'Choose File',
	},
	'Choose File(s)': {
		translation: 'Choose File(s)',
	},
	'Choose Files': {
		translation: 'Choose Files',
	},
	'Choose Folder': {
		translation: 'Choose Folder',
	},
	'Choose Photo': {
		translation: 'Choose Photo',
	},
	'Choose Specific Employees': {
		translation: 'Choose Specific Employees',
	},
	'Choose Your Options': {
		translation: 'Choose Your Options',
	},
	'Choose a Color Theme': {
		translation: 'Choose a Color Theme',
	},
	'Choose a Different File': {
		translation: 'Choose a Different File',
	},
	'Choose a source to get a unique URL to track applications in the Applicant Sources Report.':
		{
			translation:
				'Choose a source to get a unique URL to track applications in the Applicant Sources Report.',
		},
	'Choose a source to get a unique URL to track applications in the Candidate Source Report.':
		{
			translation:
				'Choose a source to get a unique URL to track applications in the Candidate Source Report.',
		},
	'Choose a template': {
		translation: 'Choose a template',
	},
	'Choose an\temployee': {
		translation: 'Choose an\temployee',
	},
	'Choose an ACA status for each Employment Status': {
		translation: 'Choose an ACA status for each Employment Status',
	},
	'Choose an Offer Template': {
		translation: 'Choose an Offer Template',
	},
	'Choose the employee document folder where this should be saved once signed.':
		{
			translation:
				'Choose the employee document folder where this should be saved once signed.',
		},
	"Choose the file you'd like to import:": {
		translation: "Choose the file you'd like to import:",
	},
	"Choose the template you'd like to use for %s's offer.": {
		translation: "Choose the template you'd like to use for %s's offer.",
	},
	'Choose to show all employees or select criteria to filter the results down to specific employees.':
		{
			translation:
				'Choose to show all employees or select criteria to filter the results down to specific employees.',
		},
	'Choose what people with this Access Level will see about other employees.': {
		translation:
			'Choose what people with this Access Level will see about other employees.',
	},
	'Choose what people with this Access Level will see about themselves.': {
		translation:
			'Choose what people with this Access Level will see about themselves.',
	},
	'Choose what should show on Home for people with this Access Level.': {
		translation:
			'Choose what should show on Home for people with this Access Level.',
	},
	'Choose what to do with unknown list values': {
		translation: 'Choose what to do with unknown list values',
	},
	'Choose which access level(s) can see it...': {
		translation: 'Choose which access level(s) can see it...',
	},
	"Choose which fields you'd like to show up on the Add Employee form.": {
		translation:
			"Choose which fields you'd like to show up on the Add Employee form.",
	},
	"Choose which fields you'd like to show up on the Add Employee form. Fields will be available to include in the New Hire Packet for your new employees.":
		{
			translation:
				"Choose which fields you'd like to show up on the Add Employee form. Fields will be available to include in the New Hire Packet for your new employees.",
		},
	'Choose which users in Google Apps you would like to add to BambooHR.': {
		translation:
			'Choose which users in Google Apps you would like to add to BambooHR.',
	},
	'Choose which widgets show on Home:': {
		translation: 'Choose which widgets show on Home:',
	},
	'Choose your people:': {
		translation: 'Choose your people:',
	},
	'Choose your quantifier:': {
		translation: 'Choose your quantifier:',
	},
	'Chose Not to Sign': {
		translation: 'Chose Not to Sign',
	},
	'Chose not to sign': {
		translation: 'Chose not to sign',
	},
	'Ciao.': {
		translation: 'Ciao.',
	},
	Cisgender: {
		translation: 'Cisgender',
	},
	Citizenship: {
		translation: 'Citizenship',
	},
	City: {
		translation: 'City',
	},
	'City cannot be empty': {
		translation: 'City cannot be empty',
	},
	'City is required': {
		translation: 'City is required',
	},
	'City, State Zip': {
		translation: 'City, State Zip',
	},
	'City, State, ZIP': {
		translation: 'City, State, ZIP',
	},
	Claims: {
		translation: 'Claims',
	},
	Class: {
		translation: 'Class',
	},
	'Class Code': {
		translation: 'Class Code',
	},
	'Class Code Description': {
		translation: 'Class Code Description',
	},
	'Class Description': {
		translation: 'Class Description',
	},
	'Class codes and rate history': {
		translation: 'Class codes and rate history',
	},
	Classification: {
		translation: 'Classification',
	},
	Clear: {
		translation: 'Clear',
	},
	'Clear All Performance Data': {
		translation: 'Clear All Performance Data',
	},
	'Clear Balance and Save': {
		translation: 'Clear Balance and Save',
	},
	'Clear Data': {
		translation: 'Clear Data',
	},
	'Clear Demo Data': {
		translation: 'Clear Demo Data',
	},
	'Clear Search': {
		translation: 'Clear Search',
	},
	'Clear Time Entries + Notes': {
		translation: 'Clear Time Entries + Notes',
	},
	'Clear Time Entry + Note': {
		translation: 'Clear Time Entry + Note',
	},
	'Clear all filters to Approve All': {
		translation: 'Clear all filters to Approve All',
	},
	'Clear data and add your own': {
		translation: 'Clear data and add your own',
	},
	'Clear data and add your own.': {
		translation: 'Clear data and add your own.',
	},
	'Clear out all benefit groups and plans, along with the histories associated with these plans for all employees.':
		{
			translation:
				'Clear out all benefit groups and plans, along with the histories associated with these plans for all employees.',
		},
	'Cleared Rating': {
		translation: 'Cleared Rating',
	},
	'Clearing all Performance data will remove Assessments, Goals, and Peer Feedback for all employees. The account will be reset as if Performance has just been turned on for the first time. This data cannot be restored once it has been deleted.':
		{
			translation:
				'Clearing all Performance data will remove Assessments, Goals, and Peer Feedback for all employees. The account will be reset as if Performance has just been turned on for the first time. This data cannot be restored once it has been deleted.',
		},
	'Clearing demo data and making it sparkle': {
		translation: 'Clearing demo data and making it sparkle',
	},
	'Click "Add Report" to create a new report.': {
		translation: 'Click \\"Add Report\\" to create a new report.',
	},
	'Click "New Report" to create a new report.': {
		translation: 'Click \\"New Report\\" to create a new report.',
	},
	'Click "Refresh" to see any recent changes.': {
		translation: 'Click \\"Refresh\\" to see any recent changes.',
	},
	'Click %sClose%s to refresh the page and see the updated status.': {
		translation:
			'Click %sClose%s to refresh the page and see the updated status.',
	},
	'Click <a href="%s">here</a> to import from Cornerstone.': {
		translation: 'Click <a href=\\"%s\\">here</a> to import from Cornerstone.',
	},
	'Click Get Started to begin your employment eligibility verification. You’ll be taken to a secure portal to verify your identity and upload required documents. Make sure to complete all steps to avoid delays.':
		{
			translation:
				'Click Get Started to begin your employment eligibility verification. You’ll be taken to a secure portal to verify your identity and upload required documents. Make sure to complete all steps to avoid delays.',
		},
	'Click Save': {
		translation: 'Click Save',
	},
	'Click [here](1) for best practices.': {
		translation: 'Click [here](1) for best practices.',
	},
	'Click below to jump to the most recent version of your offer.': {
		translation:
			'Click below to jump to the most recent version of your offer.',
	},
	'Click here for more detail.': {
		translation: 'Click here for more detail.',
	},
	'Click here to continue setting up Time Tracking.': {
		translation: 'Click here to continue setting up Time Tracking.',
	},
	'Click here to get started.': {
		translation: 'Click here to get started.',
	},
	'Click on fields in %1s the left panel to add them to the %2s Add Employee Form':
		{
			translation:
				'Click on fields in %1s the left panel to add them to the %2s Add Employee Form',
		},
	'Click on the "Connectors" icon and select "BambooHR" from the dropdown menu':
		{
			translation:
				'Click on the \\"Connectors\\" icon and select \\"BambooHR\\" from the dropdown menu',
		},
	'Click on the "Data" tab in OrgChart Now': {
		translation: 'Click on the \\"Data\\" tab in OrgChart Now',
	},
	'Click on the "Install" button (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click on the \\"Install\\" button (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click on the "Install" button and enter your required SwipeClock account information.':
		{
			translation:
				'Click on the \\"Install\\" button and enter your required SwipeClock account information.',
		},
	'Click on the "Install" button for this app on the left-hand side of your screen. (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click on the \\"Install\\" button for this app on the left-hand side of your screen. (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click on the "Install" button for this app. (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click on the \\"Install\\" button for this app. (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click on the "Install" button for this application. (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click on the \\"Install\\" button for this application. (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click on the "Install" button to enable this integration. (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click on the \\"Install\\" button to enable this integration. (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click on the \'Install\' button for this app (If you do not see the button please <a href="mailto:support@bamboohr.com">contact support</a>).':
		{
			translation:
				'Click on the \'Install\' button for this app (If you do not see the button please <a href=\\"mailto:support@bamboohr.com\\">contact support</a>).',
		},
	'Click on the Save button to save these settings': {
		translation: 'Click on the Save button to save these settings',
	},
	'Click the "Install" button for this app (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click the \\"Install\\" button for this app (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click the "Install" button for this app (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>). Enter the SAML information into BambooHR by pasting the SSO Login URL and the Certificate information from OneLogin. You will now be able click on the BambooHR App icon within OneLogin to log directly into BambooHR.':
		{
			translation:
				'Click the \\"Install\\" button for this app (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>). Enter the SAML information into BambooHR by pasting the SSO Login URL and the Certificate information from OneLogin. You will now be able click on the BambooHR App icon within OneLogin to log directly into BambooHR.',
		},
	'Click the "Install" button from this page and then select which optional additional tabs you\'d like to display in BambooHR. (If you do not see the button please contact <a href="mailto:support@bamboohr.com">support</a>)':
		{
			translation:
				'Click the \\"Install\\" button from this page and then select which optional additional tabs you\'d like to display in BambooHR. (If you do not see the button please contact <a href=\\"mailto:support@bamboohr.com\\">support</a>)',
		},
	'Click the "Save" button.': {
		translation: 'Click the \\"Save\\" button.',
	},
	'Click the "install" button for this app (if you don\'t see the button, contact <a href="mailto:support@bamboohr.com">support@bamboohr.com</a>':
		{
			translation:
				'Click the \\"install\\" button for this app (if you don\'t see the button, contact <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a>',
		},
	'Click the Integrations tab': {
		translation: 'Click the Integrations tab',
	},
	'Click the Save Credentials button and your API integration is now set up': {
		translation:
			'Click the Save Credentials button and your API integration is now set up',
	},
	'Click the links below to download the export files': {
		translation: 'Click the links below to download the export files',
	},
	'Click the save button': {
		translation: 'Click the save button',
	},
	'Click the save button.': {
		translation: 'Click the save button.',
	},
	"Click the “Mark as Hired” button on the Private tab on the candidate's profile page.":
		{
			translation:
				"Click the “Mark as Hired” button on the Private tab on the candidate's profile page.",
		},
	'Click the “install” button below. Once installed you’ll be able to schedule interviews for candidates in the ATS!':
		{
			translation:
				'Click the “install” button below. Once installed you’ll be able to schedule interviews for candidates in the ATS!',
		},
	'Click the Save Credentials button and your API integration is now set up!': {
		translation:
			'Click the Save Credentials button and your API integration is now set up!',
	},
	'Click to Copy': {
		translation: 'Click to Copy',
	},
	'Click to Schedule a Personal Demo': {
		translation: 'Click to Schedule a Personal Demo',
	},
	'Click to Sign': {
		translation: 'Click to Sign',
	},
	'Click to browse files': {
		translation: 'Click to browse files',
	},
	'Click to make the signature %s.': {
		translation: 'Click to make the signature %s.',
	},
	'Click to make the signature optional.': {
		translation: 'Click to make the signature optional.',
	},
	'Click to make the signature required.': {
		translation: 'Click to make the signature required.',
	},
	'Click to remove': {
		translation: 'Click to remove',
	},
	'Click to review and sign your offer letter': {
		translation: 'Click to review and sign your offer letter',
	},
	'Click to see SIN': {
		translation: 'Click to see SIN',
	},
	'Click to see SSN': {
		translation: 'Click to see SSN',
	},
	'Click to turn off': {
		translation: 'Click to turn off',
	},
	'Click to turn on': {
		translation: 'Click to turn on',
	},
	'Clicking this button would take the applicant to view their offer letter.': {
		translation:
			'Clicking this button would take the applicant to view their offer letter.',
	},
	'Client Tasks': {
		translation: 'Client Tasks',
	},
	'Client Tax Payments by Tax Type': {
		translation: 'Client Tax Payments by Tax Type',
	},
	"Client doesn't offer this benefit": {
		translation: "Client doesn't offer this benefit",
	},
	'Client, project, and/or task tracking': {
		translation: 'Client, project, and/or task tracking',
	},
	'Clients will be able to export all employees created in SimplePay.ca into BambooHR, from then on updates will be automatic in BambooHR.  They can also import data from BambooHR if a change is made in BambooHR through the "Synchronize Employees" box.  Any new data will be sent to SimplePay.ca.':
		{
			translation:
				'Clients will be able to export all employees created in SimplePay.ca into BambooHR, from then on updates will be automatic in BambooHR.  They can also import data from BambooHR if a change is made in BambooHR through the \\"Synchronize Employees\\" box.  Any new data will be sent to SimplePay.ca.',
		},
	'Cliff Months': {
		translation: 'Cliff Months',
	},
	'Clock In': {
		translation: 'Clock In',
	},
	'Clock Out': {
		translation: 'Clock Out',
	},
	'Clock Out & Approve': {
		translation: 'Clock Out & Approve',
	},
	'Clock in updated from **{1}** to **{2}**': {
		translation: 'Clock in updated from **{1}** to **{2}**',
	},
	'Clocked In': {
		translation: 'Clocked In',
	},
	'Clocked In: %1$s': {
		translation: 'Clocked In: %1$s',
	},
	'Clocked Out': {
		translation: 'Clocked Out',
	},
	'Clocked Out: %1$s': {
		translation: 'Clocked Out: %1$s',
	},
	'Clocked in': {
		translation: 'Clocked in',
	},
	'Clocked in to **{1}**': {
		translation: 'Clocked in to **{1}**',
	},
	'Clocked out': {
		translation: 'Clocked out',
	},
	'Clocked out at...': {
		translation: 'Clocked out at...',
	},
	'Clocking In': {
		translation: 'Clocking In',
	},
	'Clocking Out': {
		translation: 'Clocking Out',
	},
	'Clocking is disabled because you have a time entry saved for sometime in the future.':
		{
			translation:
				'Clocking is disabled because you have a time entry saved for sometime in the future.',
		},
	Close: {
		translation: 'Close',
	},
	'Close Alert Message': {
		translation: 'Close Alert Message',
	},
	'Close Sweep': {
		translation: 'Close Sweep',
	},
	'Close popover': {
		translation: 'Close popover',
	},
	'Close this job opening and remove the public posting': {
		translation: 'Close this job opening and remove the public posting',
	},
	Closed: {
		translation: 'Closed',
	},
	'Closed Date': {
		translation: 'Closed Date',
	},
	'Cloud Based Organizational Charting and Workforce Planning Software. OrgChart Now makes creating, maintaining and sharing org charts and workforce plans simple and efficient.':
		{
			translation:
				'Cloud Based Organizational Charting and Workforce Planning Software. OrgChart Now makes creating, maintaining and sharing org charts and workforce plans simple and efficient.',
		},
	Code: {
		translation: 'Code',
	},
	'Codes & Rates': {
		translation: 'Codes & Rates',
	},
	'Codes & Rates for %s': {
		translation: 'Codes & Rates for %s',
	},
	'Codes and rates were successfully updated': {
		translation: 'Codes and rates were successfully updated',
	},
	'Collaborate on this Job Opening': {
		translation: 'Collaborate on this Job Opening',
	},
	'Collaborate on this job opening': {
		translation: 'Collaborate on this job opening',
	},
	'Collaborating with:': {
		translation: 'Collaborating with:',
	},
	Collaborator: {
		translation: 'Collaborator',
	},
	Collapse: {
		translation: 'Collapse',
	},
	'Collapse All Folders': {
		translation: 'Collapse All Folders',
	},
	'Collapse Menu': {
		translation: 'Collapse Menu',
	},
	'Collapse row': {
		translation: 'Collapse row',
	},
	'Collected and paid by TRAX Payroll': {
		translation: 'Collected and paid by TRAX Payroll',
	},
	'Collected and paid by TRAXPayroll': {
		translation: 'Collected and paid by TRAXPayroll',
	},
	Collection: {
		translation: 'Collection',
	},
	'Collection Balance': {
		translation: 'Collection Balance',
	},
	'Collection Summary': {
		translation: 'Collection Summary',
	},
	'Collection Table Details': {
		translation: 'Collection Table Details',
	},
	Collections: {
		translation: 'Collections',
	},
	College: {
		translation: 'College',
	},
	'College - Associates': {
		translation: 'College - Associates',
	},
	'College - Bachelor of Arts': {
		translation: 'College - Bachelor of Arts',
	},
	'College - Bachelor of Fine Arts': {
		translation: 'College - Bachelor of Fine Arts',
	},
	'College - Bachelor of Science': {
		translation: 'College - Bachelor of Science',
	},
	'College - Doctorate': {
		translation: 'College - Doctorate',
	},
	'College - Master of Arts': {
		translation: 'College - Master of Arts',
	},
	'College - Master of Business Administration': {
		translation: 'College - Master of Business Administration',
	},
	'College - Master of Fine Arts': {
		translation: 'College - Master of Fine Arts',
	},
	'College - Master of Science': {
		translation: 'College - Master of Science',
	},
	'College/Institution': {
		translation: 'College/Institution',
	},
	'College/University': {
		translation: 'College/University',
	},
	Colors: {
		translation: 'Colors',
	},
	Column: {
		translation: 'Column',
	},
	'Column Name': {
		translation: 'Column Name',
	},
	'Column Settings': {
		translation: 'Column Settings',
	},
	'Comapny/EIN': {
		translation: 'Comapny/EIN',
	},
	'Combine %1$s%3$s%2$s with the access of %1$s%4$s%2$s': {
		translation: 'Combine %1$s%3$s%2$s with the access of %1$s%4$s%2$s',
	},
	'Combine **{1}** with the access of **{2}**': {
		translation: 'Combine **{1}** with the access of **{2}**',
	},
	Comment: {
		translation: 'Comment',
	},
	'Comment (Optional)': {
		translation: 'Comment (Optional)',
	},
	'Comment added successfully': {
		translation: 'Comment added successfully',
	},
	'Comment for the Approver(s)': {
		translation: 'Comment for the Approver(s)',
	},
	'Comment on %s': {
		translation: 'Comment on %s',
	},
	Comments: {
		translation: 'Comments',
	},
	'Comments + History': {
		translation: 'Comments + History',
	},
	'Comments/Notes': {
		translation: 'Comments/Notes',
	},
	Commission: {
		translation: 'Commission',
	},
	'Commission 2004': {
		translation: 'Commission 2004',
	},
	'Commission 2005': {
		translation: 'Commission 2005',
	},
	'Commission 2006': {
		translation: 'Commission 2006',
	},
	'Commission 2007': {
		translation: 'Commission 2007',
	},
	'Commission Only': {
		translation: 'Commission Only',
	},
	'Commission Summary': {
		translation: 'Commission Summary',
	},
	'Commission: Amount': {
		translation: 'Commission: Amount',
	},
	'Commission: Comment': {
		translation: 'Commission: Comment',
	},
	'Commission: Date': {
		translation: 'Commission: Date',
	},
	'Common Law': {
		translation: 'Common Law',
	},
	'Common Reports': {
		translation: 'Common Reports',
	},
	'Communication/Listening': {
		translation: 'Communication/Listening',
	},
	'Community Employment': {
		translation: 'Community Employment',
	},
	'Commuter Benefit': {
		translation: 'Commuter Benefit',
	},
	'Comp Time': {
		translation: 'Comp Time',
	},
	'Comp/In Lieu Time': {
		translation: 'Comp/In Lieu Time',
	},
	Company: {
		translation: 'Company',
	},
	'Company Address': {
		translation: 'Company Address',
	},
	'Company Administration': {
		translation: 'Company Administration',
	},
	'Company Announcements': {
		translation: 'Company Announcements',
	},
	'Company Annual Max': {
		translation: 'Company Annual Max',
	},
	'Company Cap Amount': {
		translation: 'Company Cap Amount',
	},
	'Company Code:': {
		translation: 'Company Code:',
	},
	'Company Contribution': {
		translation: 'Company Contribution',
	},
	'Company Cost': {
		translation: 'Company Cost',
	},
	'Company Created': {
		translation: 'Company Created',
	},
	'Company Credit Cards': {
		translation: 'Company Credit Cards',
	},
	'Company Directory': {
		translation: 'Company Directory',
	},
	'Company Directory settings updated': {
		translation: 'Company Directory settings updated',
	},
	'Company Email Address': {
		translation: 'Company Email Address',
	},
	'Company Field Settings': {
		translation: 'Company Field Settings',
	},
	'Company Files': {
		translation: 'Company Files',
	},
	'Company Handbook Quiz': {
		translation: 'Company Handbook Quiz',
	},
	'Company Holiday': {
		translation: 'Company Holiday',
	},
	'Company Holidays': {
		translation: 'Company Holidays',
	},
	'Company ID': {
		translation: 'Company ID',
	},
	'Company ID in path does not match Company ID in request body': {
		translation: 'Company ID in path does not match Company ID in request body',
	},
	'Company ID: %1$s': {
		translation: 'Company ID: %1$s',
	},
	'Company Id being used by the current application.': {
		translation: 'Company Id being used by the current application.',
	},
	'Company Id could not be found.': {
		translation: 'Company Id could not be found.',
	},
	'Company Identifier': {
		translation: 'Company Identifier',
	},
	'Company Info': {
		translation: 'Company Info',
	},
	'Company Info changes saved!': {
		translation: 'Company Info changes saved!',
	},
	'Company Information': {
		translation: 'Company Information',
	},
	'Company Legal Name': {
		translation: 'Company Legal Name',
	},
	'Company Level Deduction: %s already exists. Please choose a different name.':
		{
			translation:
				'Company Level Deduction: %s already exists. Please choose a different name.',
		},
	'Company Links': {
		translation: 'Company Links',
	},
	'Company Male/Female Ratio': {
		translation: 'Company Male/Female Ratio',
	},
	'Company Motivators': {
		translation: 'Company Motivators',
	},
	'Company Name': {
		translation: 'Company Name',
	},
	'Company Non-Disclosure Training': {
		translation: 'Company Non-Disclosure Training',
	},
	'Company Org Chart': {
		translation: 'Company Org Chart',
	},
	'Company Paid': {
		translation: 'Company Paid',
	},
	'Company Pays': {
		translation: 'Company Pays',
	},
	'Company Pays (Old)': {
		translation: 'Company Pays (Old)',
	},
	'Company Pays (Updated)': {
		translation: 'Company Pays (Updated)',
	},
	'Company Pays Percent Type': {
		translation: 'Company Pays Percent Type',
	},
	'Company Pays Percent Type (Gross/Employee Contribution)': {
		translation: 'Company Pays Percent Type (Gross/Employee Contribution)',
	},
	'Company Performance': {
		translation: 'Company Performance',
	},
	'Company Performance Summary': {
		translation: 'Company Performance Summary',
	},
	'Company Score': {
		translation: 'Company Score',
	},
	'Company Size': {
		translation: 'Company Size',
	},
	'Company and employee file size, when added together, cannot exceed %s for a single export. You have the\noption of filtering employee files to split the process into multiple exports if the limit is exceeded.':
		{
			translation:
				'Company and employee file size, when added together, cannot exceed %s for a single export. You have the\noption of filtering employee files to split the process into multiple exports if the limit is exceeded.',
		},
	'Company and personal': {
		translation: 'Company and personal',
	},
	"Company does'nt have this tool.": {
		translation: "Company does'nt have this tool.",
	},
	"Company doesn't have this tool": {
		translation: "Company doesn't have this tool",
	},
	"Company doesn't have this tool.": {
		translation: "Company doesn't have this tool.",
	},
	'Company logo': {
		translation: 'Company logo',
	},
	'Company logo removed': {
		translation: 'Company logo removed',
	},
	'Company name': {
		translation: 'Company name',
	},
	'Company only': {
		translation: 'Company only',
	},
	'Company pays': {
		translation: 'Company pays',
	},
	'Company pays ($ or %)': {
		translation: 'Company pays ($ or %)',
	},
	'Company pays - Currency code': {
		translation: 'Company pays - Currency code',
	},
	'Company pays for benefit updated.': {
		translation: 'Company pays for benefit updated.',
	},
	'Company pays monthly': {
		translation: 'Company pays monthly',
	},
	'Company property': {
		translation: 'Company property',
	},
	'Company/EIN': {
		translation: 'Company/EIN',
	},
	'Compare Bamboo and NetSuite Employee lists': {
		translation: 'Compare Bamboo and NetSuite Employee lists',
	},
	'Compare Bamboo and NetSuite Lists': {
		translation: 'Compare Bamboo and NetSuite Lists',
	},
	'Compare Employee Lists': {
		translation: 'Compare Employee Lists',
	},
	'Compare Lists': {
		translation: 'Compare Lists',
	},
	'Compare To Peer Companies': {
		translation: 'Compare To Peer Companies',
	},
	'Compare to Peer Companies': {
		translation: 'Compare to Peer Companies',
	},
	Compensation: {
		translation: 'Compensation',
	},
	'Compensation - Benchmarking Admin': {
		translation: 'Compensation - Benchmarking Admin',
	},
	'Compensation - Levels and Bands Admin': {
		translation: 'Compensation - Levels and Bands Admin',
	},
	'Compensation - Planning Admin': {
		translation: 'Compensation - Planning Admin',
	},
	'Compensation - Total Rewards Admin': {
		translation: 'Compensation - Total Rewards Admin',
	},
	'Compensation Benchmarking': {
		translation: 'Compensation Benchmarking',
	},
	'Compensation Change Reason': {
		translation: 'Compensation Change Reason',
	},
	'Compensation Date and Hire Date don’t align.': {
		translation: 'Compensation Date and Hire Date don’t align.',
	},
	'Compensation Details': {
		translation: 'Compensation Details',
	},
	'Compensation Effective Date is required': {
		translation: 'Compensation Effective Date is required',
	},
	'Compensation History': {
		translation: 'Compensation History',
	},
	'Compensation Planning...': {
		translation: 'Compensation Planning...',
	},
	'Compensation comments': {
		translation: 'Compensation comments',
	},
	'Compensation: Date': {
		translation: 'Compensation: Date',
	},
	'Compensation: End date': {
		translation: 'Compensation: End date',
	},
	'Compensatory Time': {
		translation: 'Compensatory Time',
	},
	Complete: {
		translation: 'Complete',
	},
	'Complete %1$s': {
		translation: 'Complete %1$s',
	},
	'Complete %1s': {
		translation: 'Complete %1s',
	},
	'Complete Assessment': {
		translation: 'Complete Assessment',
	},
	'Complete Company Info': {
		translation: 'Complete Company Info',
	},
	'Complete Later': {
		translation: 'Complete Later',
	},
	'Complete and sign the following bank authorization forms': {
		translation: 'Complete and sign the following bank authorization forms',
	},
	'Complete and sign the following forms': {
		translation: 'Complete and sign the following forms',
	},
	'Complete it now »': {
		translation: 'Complete it now »',
	},
	"Complete the assessments on the Performance tab on each employee's profile.":
		{
			translation:
				"Complete the assessments on the Performance tab on each employee's profile.",
		},
	'Complete the import': {
		translation: 'Complete the import',
	},
	"Complete your Manager Assessment to unlock the Employee's Assessment": {
		translation:
			"Complete your Manager Assessment to unlock the Employee's Assessment",
	},
	'Complete your Self & Team Assessments': {
		translation: 'Complete your Self & Team Assessments',
	},
	'Complete your Self Assessment': {
		translation: 'Complete your Self Assessment',
	},
	"Complete your Self Assessment to unlock your Manager's Assessment": {
		translation:
			"Complete your Self Assessment to unlock your Manager's Assessment",
	},
	'Complete your Self and Team Assessments': {
		translation: 'Complete your Self and Team Assessments',
	},
	Completed: {
		translation: 'Completed',
	},
	'Completed %1$s': {
		translation: 'Completed %1$s',
	},
	'Completed Assessments': {
		translation: 'Completed Assessments',
	},
	'Completed Changes': {
		translation: 'Completed Changes',
	},
	'Completed Date': {
		translation: 'Completed Date',
	},
	'Completed Document': {
		translation: 'Completed Document',
	},
	'Completed Payroll Changes': {
		translation: 'Completed Payroll Changes',
	},
	'Completed Tasks': {
		translation: 'Completed Tasks',
	},
	'Completed Training': {
		translation: 'Completed Training',
	},
	'Completed by': {
		translation: 'Completed by',
	},
	'Completed by %1$s on %2$s': {
		translation: 'Completed by %1$s on %2$s',
	},
	'Completed by: %1$s on %2$s': {
		translation: 'Completed by: %1$s on %2$s',
	},
	'Completed date': {
		translation: 'Completed date',
	},
	'Completed on ': {
		translation: 'Completed on ',
	},
	'Completed on %s': {
		translation: 'Completed on %s',
	},
	'Completed on %s.': {
		translation: 'Completed on %s.',
	},
	'Completed step': {
		translation: 'Completed step',
	},
	"Completed trainings can't be un-completed.": {
		translation: "Completed trainings can't be un-completed.",
	},
	'Completed: ': {
		translation: 'Completed: ',
	},
	'Completed: %1$s': {
		translation: 'Completed: %1$s',
	},
	'Completed: %s      %s': {
		translation: 'Completed: %s      %s',
	},
	'Completed: %s   %s   %s': {
		translation: 'Completed: %s   %s   %s',
	},
	'Completed: {1}': {
		translation: 'Completed: {1}',
	},
	'Completed: {1} by {2}': {
		translation: 'Completed: {1} by {2}',
	},
	Completeness: {
		translation: 'Completeness',
	},
	Completion: {
		translation: 'Completion',
	},
	'Completion Date': {
		translation: 'Completion Date',
	},
	'Completion Deadline:': {
		translation: 'Completion Deadline:',
	},
	'Completion by Department': {
		translation: 'Completion by Department',
	},
	'Completion by Division': {
		translation: 'Completion by Division',
	},
	'Compliance Auditor': {
		translation: 'Compliance Auditor',
	},
	Computer: {
		translation: 'Computer',
	},
	Confidential: {
		translation: 'Confidential',
	},
	'Confidentiality Agreement': {
		translation: 'Confidentiality Agreement',
	},
	'Configuration not Found.': {
		translation: 'Configuration not Found.',
	},
	'Configure ACA-related settings for your account. ACA tracking makes available the following:':
		{
			translation:
				'Configure ACA-related settings for your account. ACA tracking makes available the following:',
		},
	'Configure ACA-related settings for your account. Enable tracking to gain access to 1) the ACA Full Time Status field in the Employment Status table, 2) the ACA Minimum Value setting in Benefits Tracking and 3) ACA-related benefits and employment status reports.':
		{
			translation:
				'Configure ACA-related settings for your account. Enable tracking to gain access to 1) the ACA Full Time Status field in the Employment Status table, 2) the ACA Minimum Value setting in Benefits Tracking and 3) ACA-related benefits and employment status reports.',
		},
	'Configure Payroll Deduction Schedule': {
		translation: 'Configure Payroll Deduction Schedule',
	},
	'Configure Schedule': {
		translation: 'Configure Schedule',
	},
	'Confirm New Password': {
		translation: 'Confirm New Password',
	},
	'Confirm Password': {
		translation: 'Confirm Password',
	},
	'Confirm Request': {
		translation: 'Confirm Request',
	},
	'Confirm Signature': {
		translation: 'Confirm Signature',
	},
	'Confirm deposit amount to complete bank account setup': {
		translation: 'Confirm deposit amount to complete bank account setup',
	},
	'Confirm new password': {
		translation: 'Confirm new password',
	},
	'Confirm new password field does not match new password.': {
		translation: 'Confirm new password field does not match new password.',
	},
	'Confirmed by HR': {
		translation: 'Confirmed by HR',
	},
	"Congrats, you're ready for BambooHR Payroll!": {
		translation: "Congrats, you're ready for BambooHR Payroll!",
	},
	'Congratulations! %s has been installed .': {
		translation: 'Congratulations! %s has been installed .',
	},
	'Congratulations! %s has been installed.': {
		translation: 'Congratulations! %s has been installed.',
	},
	'Congratulations! GT Clocks has been installed.': {
		translation: 'Congratulations! GT Clocks has been installed.',
	},
	'Congratulations! The import was completed without any errors or invalid records.':
		{
			translation:
				'Congratulations! The import was completed without any errors or invalid records.',
		},
	'Congratulations, %s!': {
		translation: 'Congratulations, %s!',
	},
	'Connect to GT Clocks': {
		translation: 'Connect to GT Clocks',
	},
	'Connect via Email': {
		translation: 'Connect via Email',
	},
	'Connect via Facebook': {
		translation: 'Connect via Facebook',
	},
	'Connect via LinkedIn': {
		translation: 'Connect via LinkedIn',
	},
	'Connect via Pinterest': {
		translation: 'Connect via Pinterest',
	},
	'Connect via Twitter': {
		translation: 'Connect via Twitter',
	},
	'Consumer Key: ': {
		translation: 'Consumer Key: ',
	},
	'Consumer Secret: ': {
		translation: 'Consumer Secret: ',
	},
	Contact: {
		translation: 'Contact',
	},
	'Contact <a href="mailto:bamboohr@plansource.com">bamboohr@plansource.com</a> for more information on how PlanSource can simplify your HR and benefits processes.':
		{
			translation:
				'Contact <a href=\\"mailto:bamboohr@plansource.com\\">bamboohr@plansource.com</a> for more information on how PlanSource can simplify your HR and benefits processes.',
		},
	"Contact BambooHR's Customer Service Department to enable and activate the integration in your BambooHR account. We'll take care of the rest for you.":
		{
			translation:
				"Contact BambooHR's Customer Service Department to enable and activate the integration in your BambooHR account. We'll take care of the rest for you.",
		},
	'Contact BambooHR\'s Customer Service Department to enable this integration in your BambooHR account (this will add some additional required custom fields in the "Job" tab in your BambooHR account).':
		{
			translation:
				'Contact BambooHR\'s Customer Service Department to enable this integration in your BambooHR account (this will add some additional required custom fields in the \\"Job\\" tab in your BambooHR account).',
		},
	"Contact BambooHR's Customer Service Department to finish the settings required for this integration.":
		{
			translation:
				"Contact BambooHR's Customer Service Department to finish the settings required for this integration.",
		},
	'Contact Info': {
		translation: 'Contact Info',
	},
	'Contact Information': {
		translation: 'Contact Information',
	},
	'Contact Phone #': {
		translation: 'Contact Phone #',
	},
	'Contact Primary': {
		translation: 'Contact Primary',
	},
	'Contact URL': {
		translation: 'Contact URL',
	},
	'Contact Us To Learn More': {
		translation: 'Contact Us To Learn More',
	},
	'Contact customer support for more details.': {
		translation: 'Contact customer support for more details.',
	},
	'Contact email': {
		translation: 'Contact email',
	},
	'Contact removed.': {
		translation: 'Contact removed.',
	},
	'Contact the BambooHR Customer Service Department to enable this integration.':
		{
			translation:
				'Contact the BambooHR Customer Service Department to enable this integration.',
		},
	'Contact the HRN Performance Solutions Client Support team and give them your BambooHR API key and sub-domain. They will then enable the BambooHR integration in the Performance Pro product':
		{
			translation:
				'Contact the HRN Performance Solutions Client Support team and give them your BambooHR API key and sub-domain. They will then enable the BambooHR integration in the Performance Pro product',
		},
	'Contact us today to learn more and get a no-hassle quote. Click on the "Request Info" button on the left-side, or call us today at 801-251-1588.':
		{
			translation:
				'Contact us today to learn more and get a no-hassle quote. Click on the \\"Request Info\\" button on the left-side, or call us today at 801-251-1588.',
		},
	'Contact us today to learn more and get a no-hassle quote. Click on the Request Info button on the left-side, or call us today at 801-251-1588.':
		{
			translation:
				'Contact us today to learn more and get a no-hassle quote. Click on the Request Info button on the left-side, or call us today at 801-251-1588.',
		},
	'Contact your ApplicantPRO account representative and give them your BambooHR sub-domain and API Key for connecting your BambooHR account to your ApplicantPRO account.':
		{
			translation:
				'Contact your ApplicantPRO account representative and give them your BambooHR sub-domain and API Key for connecting your BambooHR account to your ApplicantPRO account.',
		},
	'Contact your BambooHR<br/> account owner to sign up:': {
		translation: 'Contact your BambooHR<br/> account owner to sign up:',
	},
	'Contact your iApplicants account representative and give them your BambooHR sub-domain and API Key for connecting your BambooHR account to your iApplicants account.':
		{
			translation:
				'Contact your iApplicants account representative and give them your BambooHR sub-domain and API Key for connecting your BambooHR account to your iApplicants account.',
		},
	'Content Marketer': {
		translation: 'Content Marketer',
	},
	Continue: {
		translation: 'Continue',
	},
	'Continue %1$s Plan': {
		translation: 'Continue %1$s Plan',
	},
	'Continue Working': {
		translation: 'Continue Working',
	},
	'Continue »': {
		translation: 'Continue »',
	},
	Contract: {
		translation: 'Contract',
	},
	'Contract End Date': {
		translation: 'Contract End Date',
	},
	'Contract end date': {
		translation: 'Contract end date',
	},
	'Contract is no longer a valid pay type. Please select hourly, salary, or commission only.':
		{
			translation:
				'Contract is no longer a valid pay type. Please select hourly, salary, or commission only.',
		},
	Contractor: {
		translation: 'Contractor',
	},
	'Contractor (1099)': {
		translation: 'Contractor (1099)',
	},
	'Contribution Value': {
		translation: 'Contribution Value',
	},
	'Contribution amounts will be added when you enroll an employee in this plan.':
		{
			translation:
				'Contribution amounts will be added when you enroll an employee in this plan.',
		},
	'Contribution amounts will be updated when you add this plan to a benefit group.':
		{
			translation:
				'Contribution amounts will be updated when you add this plan to a benefit group.',
		},
	'Contribution to a savings account used for healthcare expenses (pre-tax)': {
		translation:
			'Contribution to a savings account used for healthcare expenses (pre-tax)',
	},
	Contributor: {
		translation: 'Contributor',
	},
	'Controllability of Departure': {
		translation: 'Controllability of Departure',
	},
	Controller: {
		translation: 'Controller',
	},
	'Convert %1$s': {
		translation: 'Convert %1$s',
	},
	'Convince %s to stay. %s would be difficult to replace.': {
		translation: 'Convince %s to stay. %s would be difficult to replace.',
	},
	'Convince them to stay. They would be difficult to replace.': {
		translation: 'Convince them to stay. They would be difficult to replace.',
	},
	'Cookies accepted': {
		translation: 'Cookies accepted',
	},
	Copied: {
		translation: 'Copied',
	},
	'Copied certificate to clipboard': {
		translation: 'Copied certificate to clipboard',
	},
	'Copied!': {
		translation: 'Copied!',
	},
	'Copies of each will be kept on the old profile.': {
		translation: 'Copies of each will be kept on the old profile.',
	},
	'Copies of each will be kept on the old profiles.': {
		translation: 'Copies of each will be kept on the old profiles.',
	},
	Copy: {
		translation: 'Copy',
	},
	'Copy %s Holidays': {
		translation: 'Copy %s Holidays',
	},
	'Copy key': {
		translation: 'Copy key',
	},
	'Copy link': {
		translation: 'Copy link',
	},
	'Copy of DL': {
		translation: 'Copy of DL',
	},
	'Copy this embed code': {
		translation: 'Copy this embed code',
	},
	'Copy to clipboard': {
		translation: 'Copy to clipboard',
	},
	'Cornerstone Company Name': {
		translation: 'Cornerstone Company Name',
	},
	"Cornerstone Manager's email": {
		translation: "Cornerstone Manager's email",
	},
	'Cornerstone onDemand': {
		translation: 'Cornerstone onDemand',
	},
	"Cornerstone onDemand is a global leader in Talent Management – and now has a solution for small and medium business. Award-winning performance reviews, interactive info-graphics, and powerful analytics are specifically designed to meet the needs of growing businesses. User-friendly, intuitive, and affordable, it's about making Performance Reviews and eLearning useful for everyone.":
		{
			translation:
				"Cornerstone onDemand is a global leader in Talent Management – and now has a solution for small and medium business. Award-winning performance reviews, interactive info-graphics, and powerful analytics are specifically designed to meet the needs of growing businesses. User-friendly, intuitive, and affordable, it's about making Performance Reviews and eLearning useful for everyone.",
		},
	'Cornerstone settings saved': {
		translation: 'Cornerstone settings saved',
	},
	"Cornerstone's server is busy, and asks that you try again in 30 seconds.": {
		translation:
			"Cornerstone's server is busy, and asks that you try again in 30 seconds.",
	},
	'Corporate Card': {
		translation: 'Corporate Card',
	},
	'Corporate Trainer': {
		translation: 'Corporate Trainer',
	},
	'Corrupt PDF Provided, Please Try Again.': {
		translation: 'Corrupt PDF Provided, Please Try Again.',
	},
	Cost: {
		translation: 'Cost',
	},
	'Cost Center 1': {
		translation: 'Cost Center 1',
	},
	'Cost Center 1 Status': {
		translation: 'Cost Center 1 Status',
	},
	'Cost Center 2': {
		translation: 'Cost Center 2',
	},
	'Cost Center 2 Status': {
		translation: 'Cost Center 2 Status',
	},
	'Cost Center 3': {
		translation: 'Cost Center 3',
	},
	'Cost Center 3 Status': {
		translation: 'Cost Center 3 Status',
	},
	'Cost Center 4': {
		translation: 'Cost Center 4',
	},
	'Cost Center 4 Status': {
		translation: 'Cost Center 4 Status',
	},
	'Cost Frequency (Per deduction or Monthly)': {
		translation: 'Cost Frequency (Per deduction or Monthly)',
	},
	'Cost Per Paycheck': {
		translation: 'Cost Per Paycheck',
	},
	'Cost per month': {
		translation: 'Cost per month',
	},
	'Cost per pay period': {
		translation: 'Cost per pay period',
	},
	'Cost per paycheck': {
		translation: 'Cost per paycheck',
	},
	'Cost:': {
		translation: 'Cost:',
	},
	'Could not %s, NetSuite says:': {
		translation: 'Could not %s, NetSuite says:',
	},
	'Could not download the file. Please wait until the virus scan is complete and try again.':
		{
			translation:
				'Could not download the file. Please wait until the virus scan is complete and try again.',
		},
	'Could not find a feedback assignment inbox task.': {
		translation: 'Could not find a feedback assignment inbox task.',
	},
	'Could not find file.': {
		translation: 'Could not find file.',
	},
	'Could not interpret your request!': {
		translation: 'Could not interpret your request!',
	},
	'Could not load employee': {
		translation: 'Could not load employee',
	},
	'Could not load employee modal!': {
		translation: 'Could not load employee modal!',
	},
	'Could not load set access modal!': {
		translation: 'Could not load set access modal!',
	},
	'Could not load task.': {
		translation: 'Could not load task.',
	},
	'Could not parse the date.  Check that the date format to import is mm-dd-yyyy or mm/dd/yyyy.':
		{
			translation:
				'Could not parse the date.  Check that the date format to import is mm-dd-yyyy or mm/dd/yyyy.',
		},
	'Could not parse the date. Check that the date format to import is mm/dd/yyyy.':
		{
			translation:
				'Could not parse the date. Check that the date format to import is mm/dd/yyyy.',
		},
	'Could not restore Benefit Plan': {
		translation: 'Could not restore Benefit Plan',
	},
	'Could not restore Group Plan': {
		translation: 'Could not restore Group Plan',
	},
	'Could not restore Group Plan Costs': {
		translation: 'Could not restore Group Plan Costs',
	},
	'Could not save a duplicate row in this table.': {
		translation: 'Could not save a duplicate row in this table.',
	},
	'Could not save this setting.': {
		translation: 'Could not save this setting.',
	},
	'Could not send validation email': {
		translation: 'Could not send validation email',
	},
	'Could not update employee': {
		translation: 'Could not update employee',
	},
	Count: {
		translation: 'Count',
	},
	'Count No Filters': {
		translation: 'Count No Filters',
	},
	'Count me in!': {
		translation: 'Count me in!',
	},
	'Count of employees that are currently hired and not terminated': {
		translation:
			'Count of employees that are currently hired and not terminated',
	},
	'Count of employees that are currently hired and not terminated.': {
		translation:
			'Count of employees that are currently hired and not terminated.',
	},
	'Count of employees that are marked as ACA Full-Time': {
		translation: 'Count of employees that are marked as ACA Full-Time',
	},
	'Count of employees that are marked as ACA Full-Time.': {
		translation: 'Count of employees that are marked as ACA Full-Time.',
	},
	'Count:': {
		translation: 'Count:',
	},
	Country: {
		translation: 'Country',
	},
	'Country ISO code': {
		translation: 'Country ISO code',
	},
	'Country cannot be empty': {
		translation: 'Country cannot be empty',
	},
	'Country is required': {
		translation: 'Country is required',
	},
	'Country must be the United States': {
		translation: 'Country must be the United States',
	},
	County: {
		translation: 'County',
	},
	'Court Ordered Dependent': {
		translation: 'Court Ordered Dependent',
	},
	'Court judgments': {
		translation: 'Court judgments',
	},
	'Court order': {
		translation: 'Court order',
	},
	'Cover Letter': {
		translation: 'Cover Letter',
	},
	Coverage: {
		translation: 'Coverage',
	},
	'Coverage Amount': {
		translation: 'Coverage Amount',
	},
	'Coverage Approval Date': {
		translation: 'Coverage Approval Date',
	},
	'Coverage Effective Date': {
		translation: 'Coverage Effective Date',
	},
	'Coverage Level': {
		translation: 'Coverage Level',
	},
	'Coverage Name': {
		translation: 'Coverage Name',
	},
	'Coverage Offered': {
		translation: 'Coverage Offered',
	},
	'Coverage Option Name': {
		translation: 'Coverage Option Name',
	},
	'Coverage Options': {
		translation: 'Coverage Options',
	},
	'Coverage Termination Date': {
		translation: 'Coverage Termination Date',
	},
	'Coverage Tier': {
		translation: 'Coverage Tier',
	},
	'Coverage level': {
		translation: 'Coverage level',
	},
	'Coverage terminated': {
		translation: 'Coverage terminated',
	},
	Coverages: {
		translation: 'Coverages',
	},
	'Coverages and Costs': {
		translation: 'Coverages and Costs',
	},
	'Coworkers were more committed to doing great work.': {
		translation: 'Coworkers were more committed to doing great work.',
	},
	Craft: {
		translation: 'Craft',
	},
	'Craft Workers': {
		translation: 'Craft Workers',
	},
	'Create %1': {
		translation: 'Create %1',
	},
	'Create Account': {
		translation: 'Create Account',
	},
	'Create Approval': {
		translation: 'Create Approval',
	},
	'Create Calendar Feed': {
		translation: 'Create Calendar Feed',
	},
	'Create Category': {
		translation: 'Create Category',
	},
	'Create Company': {
		translation: 'Create Company',
	},
	'Create Custom Field': {
		translation: 'Create Custom Field',
	},
	'Create Event': {
		translation: 'Create Event',
	},
	'Create Event w/ Meet': {
		translation: 'Create Event w/ Meet',
	},
	'Create Event w/ Zoom': {
		translation: 'Create Event w/ Zoom',
	},
	'Create Folder': {
		translation: 'Create Folder',
	},
	'Create New Hire Packet': {
		translation: 'Create New Hire Packet',
	},
	'Create New Offer': {
		translation: 'Create New Offer',
	},
	'Create New Reports': {
		translation: 'Create New Reports',
	},
	'Create Offer': {
		translation: 'Create Offer',
	},
	'Create Offer Letter': {
		translation: 'Create Offer Letter',
	},
	'Create Partner': {
		translation: 'Create Partner',
	},
	'Create Random Google Meeting': {
		translation: 'Create Random Google Meeting',
	},
	'Create Random Teams Meeting': {
		translation: 'Create Random Teams Meeting',
	},
	'Create Random Zoom Meeting': {
		translation: 'Create Random Zoom Meeting',
	},
	'Create Review Cycle': {
		translation: 'Create Review Cycle',
	},
	'Create Shared File': {
		translation: 'Create Shared File',
	},
	'Create Shared Report': {
		translation: 'Create Shared Report',
	},
	'Create Snapshot': {
		translation: 'Create Snapshot',
	},
	'Create Your Account': {
		translation: 'Create Your Account',
	},
	'Create Your Account to Get Started': {
		translation: 'Create Your Account to Get Started',
	},
	'Create a Folder First': {
		translation: 'Create a Folder First',
	},
	'Create a New Approval': {
		translation: 'Create a New Approval',
	},
	'Create a New Folder': {
		translation: 'Create a New Folder',
	},
	'Create a new plan': {
		translation: 'Create a new plan',
	},
	'Create and Manage Application Specific Webhooks': {
		translation: 'Create and Manage Application Specific Webhooks',
	},
	'Create and Manage Background Checks': {
		translation: 'Create and Manage Background Checks',
	},
	'Create event': {
		translation: 'Create event',
	},
	'Create tasks to make the process run smoothly.': {
		translation: 'Create tasks to make the process run smoothly.',
	},
	'Create, track, and collaborate on your goals.': {
		translation: 'Create, track, and collaborate on your goals.',
	},
	Created: {
		translation: 'Created',
	},
	'Created %1$s': {
		translation: 'Created %1$s',
	},
	'Created %1$s by %2$s': {
		translation: 'Created %1$s by %2$s',
	},
	'Created %s': {
		translation: 'Created %s',
	},
	'Created %s by %s': {
		translation: 'Created %s by %s',
	},
	'Created By': {
		translation: 'Created By',
	},
	'Created By User Id': {
		translation: 'Created By User Id',
	},
	'Created Date': {
		translation: 'Created Date',
	},
	'Created On': {
		translation: 'Created On',
	},
	'Created by %1$s': {
		translation: 'Created by %1$s',
	},
	'Created by %s': {
		translation: 'Created by %s',
	},
	'Created:': {
		translation: 'Created:',
	},
	Creator: {
		translation: 'Creator',
	},
	Credentials: {
		translation: 'Credentials',
	},
	'Credit Card Field': {
		translation: 'Credit Card Field',
	},
	'Credit Card Number': {
		translation: 'Credit Card Number',
	},
	'Credit Cards (Sensitive)': {
		translation: 'Credit Cards (Sensitive)',
	},
	'Credit Cards Assigned to Employee': {
		translation: 'Credit Cards Assigned to Employee',
	},
	'Credit card has expired': {
		translation: 'Credit card has expired',
	},
	Credits: {
		translation: 'Credits',
	},
	'Credits:': {
		translation: 'Credits:',
	},
	'Criminal Offense': {
		translation: 'Criminal Offense',
	},
	'Critical Illness': {
		translation: 'Critical Illness',
	},
	'Crop Logo': {
		translation: 'Crop Logo',
	},
	'Cultural Awareness': {
		translation: 'Cultural Awareness',
	},
	'Curious as to how you create a signature template and send it to your employees? What about the report that shows which documents have been signed? Check out our <a href="https://help.bamboohr.com/hc/en-us/sections/203763267-Files-Documents-and-eSignature">tutorial videos and documentation</a> in our Help Center.':
		{
			translation:
				'Curious as to how you create a signature template and send it to your employees? What about the report that shows which documents have been signed? Check out our <a href=\\"https://help.bamboohr.com/hc/en-us/sections/203763267-Files-Documents-and-eSignature\\">tutorial videos and documentation</a> in our Help Center.',
		},
	Currency: {
		translation: 'Currency',
	},
	'Currency Code': {
		translation: 'Currency Code',
	},
	'Currency must be %1': {
		translation: 'Currency must be %1',
	},
	'Currency must be USD and a value greater than 0 for overtime rate when employee is on a syncing pay schedule.':
		{
			translation:
				'Currency must be USD and a value greater than 0 for overtime rate when employee is on a syncing pay schedule.',
		},
	'Currency must be USD and a value greater than 0 for rate and/or overtime rate when employee is on a syncing pay schedule.':
		{
			translation:
				'Currency must be USD and a value greater than 0 for rate and/or overtime rate when employee is on a syncing pay schedule.',
		},
	'Currency must be USD and a value greater than or equal to 0 for overtime rate when employee is on a syncing pay schedule.':
		{
			translation:
				'Currency must be USD and a value greater than or equal to 0 for overtime rate when employee is on a syncing pay schedule.',
		},
	'Currency must be USD for rate and/or overtime rate when employee is on a syncing pay schedule.':
		{
			translation:
				'Currency must be USD for rate and/or overtime rate when employee is on a syncing pay schedule.',
		},
	'Currency must be USD when employee is on a syncing pay schedule.': {
		translation:
			'Currency must be USD when employee is on a syncing pay schedule.',
	},
	'Currency must be a value of 0 or greater for rate.': {
		translation: 'Currency must be a value of 0 or greater for rate.',
	},
	Current: {
		translation: 'Current',
	},
	'Current %s Balance': {
		translation: 'Current %s Balance',
	},
	'Current Access Level(s)': {
		translation: 'Current Access Level(s)',
	},
	'Current Add-Ons': {
		translation: 'Current Add-Ons',
	},
	'Current Balance': {
		translation: 'Current Balance',
	},
	'Current Feedback': {
		translation: 'Current Feedback',
	},
	'Current Feedback Request': {
		translation: 'Current Feedback Request',
	},
	'Current Openings': {
		translation: 'Current Openings',
	},
	'Current Password': {
		translation: 'Current Password',
	},
	'Current Pay': {
		translation: 'Current Pay',
	},
	'Current Pay Per': {
		translation: 'Current Pay Per',
	},
	'Current Quarter': {
		translation: 'Current Quarter',
	},
	'Current Rate: %1$s': {
		translation: 'Current Rate: %1$s',
	},
	'Current Review Period': {
		translation: 'Current Review Period',
	},
	'Current User': {
		translation: 'Current User',
	},
	'Current approvals are set by department.': {
		translation: 'Current approvals are set by department.',
	},
	'Current approvals are set by division.': {
		translation: 'Current approvals are set by division.',
	},
	'Current approvals are set by location.': {
		translation: 'Current approvals are set by location.',
	},
	'Current balance': {
		translation: 'Current balance',
	},
	'Current number of Benefit Groups': {
		translation: 'Current number of Benefit Groups',
	},
	'Current number of Benefit Plans': {
		translation: 'Current number of Benefit Plans',
	},
	'Current number of employees *not* in a Benefit Group': {
		translation: 'Current number of employees *not* in a Benefit Group',
	},
	'Current password': {
		translation: 'Current password',
	},
	'Current password was incorrect': {
		translation: 'Current password was incorrect',
	},
	'Current pay': {
		translation: 'Current pay',
	},
	'Current step': {
		translation: 'Current step',
	},
	'Currently Accessible Features': {
		translation: 'Currently Accessible Features',
	},
	'Currently Using': {
		translation: 'Currently Using',
	},
	'Currently clocked in entry.': {
		translation: 'Currently clocked in entry.',
	},
	'Currently the fields that automatically sync between BambooHR and SwipeClock&reg; are listed in the screenshot above. Each field in BambooHR is listed along with its corresponding field within SwipeClock&reg;. The fields marked as "n/a" in the BambooHR column do not currently fill automatically, however we may update the integration in the future to allow these fields to auto-sync as well.':
		{
			translation:
				'Currently the fields that automatically sync between BambooHR and SwipeClock&reg; are listed in the screenshot above. Each field in BambooHR is listed along with its corresponding field within SwipeClock&reg;. The fields marked as \\"n/a\\" in the BambooHR column do not currently fill automatically, however we may update the integration in the future to allow these fields to auto-sync as well.',
		},
	'Currently, you do not have permission or the training tool is disabled.': {
		translation:
			'Currently, you do not have permission or the training tool is disabled.',
	},
	'Currently, you do not have permission to complete this training.': {
		translation:
			'Currently, you do not have permission to complete this training.',
	},
	'Currently, you do not have permission to delete a training category or the training tool is disabled.':
		{
			translation:
				'Currently, you do not have permission to delete a training category or the training tool is disabled.',
		},
	'Currently, you do not have permission to delete an employee training record or the training tool is disabled.':
		{
			translation:
				'Currently, you do not have permission to delete an employee training record or the training tool is disabled.',
		},
	'Currently, you do not have permission to edit a training category or the training tool is disabled.':
		{
			translation:
				'Currently, you do not have permission to edit a training category or the training tool is disabled.',
		},
	'Currently, you do not have permission to view this employee.': {
		translation: 'Currently, you do not have permission to view this employee.',
	},
	'Currently, you do not have permission to view training records for employee or the training tool is disabled.':
		{
			translation:
				'Currently, you do not have permission to view training records for employee or the training tool is disabled.',
		},
	'Curriculum Designer': {
		translation: 'Curriculum Designer',
	},
	Custom: {
		translation: 'Custom',
	},
	'Custom Access Level': {
		translation: 'Custom Access Level',
	},
	'Custom Access Levels can be configured to allow Employees to see and/or edit information for some or all employees in your company.':
		{
			translation:
				'Custom Access Levels can be configured to allow Employees to see and/or edit information for some or all employees in your company.',
		},
	'Custom Alert': {
		translation: 'Custom Alert',
	},
	'Custom Approvals': {
		translation: 'Custom Approvals',
	},
	'Custom Asset Table': {
		translation: 'Custom Asset Table',
	},
	'Custom Checklist': {
		translation: 'Custom Checklist',
	},
	'Custom Date Range': {
		translation: 'Custom Date Range',
	},
	'Custom Date Range...': {
		translation: 'Custom Date Range...',
	},
	'Custom Fields': {
		translation: 'Custom Fields',
	},
	'Custom Fields & Tables': {
		translation: 'Custom Fields & Tables',
	},
	'Custom Fields (Sensitive)': {
		translation: 'Custom Fields (Sensitive)',
	},
	'Custom Filter': {
		translation: 'Custom Filter',
	},
	'Custom Filter...': {
		translation: 'Custom Filter...',
	},
	'Custom Gender Identity': {
		translation: 'Custom Gender Identity',
	},
	'Custom Grant Type Name': {
		translation: 'Custom Grant Type Name',
	},
	'Custom Group(s)': {
		translation: 'Custom Group(s)',
	},
	'Custom Message': {
		translation: 'Custom Message',
	},
	'Custom Questions': {
		translation: 'Custom Questions',
	},
	'Custom Tab ': {
		translation: 'Custom Tab ',
	},
	'Custom Table Alert': {
		translation: 'Custom Table Alert',
	},
	'Custom Tags': {
		translation: 'Custom Tags',
	},
	'Custom Tax Withholding': {
		translation: 'Custom Tax Withholding',
	},
	'Custom Withholding Amount': {
		translation: 'Custom Withholding Amount',
	},
	'Custom approval approved': {
		translation: 'Custom approval approved',
	},
	'Custom approval canceled': {
		translation: 'Custom approval canceled',
	},
	'Custom approval deleted': {
		translation: 'Custom approval deleted',
	},
	'Custom approval denied': {
		translation: 'Custom approval denied',
	},
	'Custom country': {
		translation: 'Custom country',
	},
	'Customer Account Number': {
		translation: 'Customer Account Number',
	},
	'Customer Announcements': {
		translation: 'Customer Announcements',
	},
	'Customer Care Trainer': {
		translation: 'Customer Care Trainer',
	},
	'Customer Download URL': {
		translation: 'Customer Download URL',
	},
	'Customer Education Manager': {
		translation: 'Customer Education Manager',
	},
	'Customer Implementation Manager': {
		translation: 'Customer Implementation Manager',
	},
	'Customer Retention Manager': {
		translation: 'Customer Retention Manager',
	},
	'Customer Success': {
		translation: 'Customer Success',
	},
	'Customer Success Advocate': {
		translation: 'Customer Success Advocate',
	},
	Customers: {
		translation: 'Customers',
	},
	'Customers who are using the Professional version of BambooHR, already have this feature included! Customers who are using a grandfathered version of our product can contact us today to learn more and get a no-hassle quote to upgrade to the Professional version. Click on the "Request Info" button on the left-side, or call us today at 801-251-1588.':
		{
			translation:
				'Customers who are using the Professional version of BambooHR, already have this feature included! Customers who are using a grandfathered version of our product can contact us today to learn more and get a no-hassle quote to upgrade to the Professional version. Click on the \\"Request Info\\" button on the left-side, or call us today at 801-251-1588.',
		},
	Customizations: {
		translation: 'Customizations',
	},
	'Customize Add Employee Form': {
		translation: 'Customize Add Employee Form',
	},
	'Customize Fields': {
		translation: 'Customize Fields',
	},
	'Customize Fields for All Employees': {
		translation: 'Customize Fields for All Employees',
	},
	'Customize New Hire Packet Fields': {
		translation: 'Customize New Hire Packet Fields',
	},
	'Customize Rating': {
		translation: 'Customize Rating',
	},
	'Customize Ratings': {
		translation: 'Customize Ratings',
	},
	'Customize Tabs': {
		translation: 'Customize Tabs',
	},
	'Customize View': {
		translation: 'Customize View',
	},
	'Customize export': {
		translation: 'Customize export',
	},
	'Customize the subject and message of the email template.': {
		translation: 'Customize the subject and message of the email template.',
	},
	'Customize the welcome email that goes out to your employees to speak in your company voice and make it your own. You can even personalize it by including any of the placeholders *{1}*, *{2}*, *{3}* or *{4}* and they will automagically be filled in when the New Hire Packet is created.':
		{
			translation:
				'Customize the welcome email that goes out to your employees to speak in your company voice and make it your own. You can even personalize it by including any of the placeholders *{1}*, *{2}*, *{3}* or *{4}* and they will automagically be filled in when the New Hire Packet is created.',
		},
	'Customize the welcome email that goes out to your employees to speak in your company voice and make it your own. You can even personalize it by including any of the placeholders *{1}*, *{2}*, *{3}*, or *{4}* and they will automagically be filled in when the New Hire Packet is created.':
		{
			translation:
				'Customize the welcome email that goes out to your employees to speak in your company voice and make it your own. You can even personalize it by including any of the placeholders *{1}*, *{2}*, *{3}*, or *{4}* and they will automagically be filled in when the New Hire Packet is created.',
		},
	'Customize view': {
		translation: 'Customize view',
	},
	'Customized Education Table': {
		translation: 'Customized Education Table',
	},
	'Cycle currency is not set.': {
		translation: 'Cycle currency is not set.',
	},
	'Cycle end date is not set.': {
		translation: 'Cycle end date is not set.',
	},
	'Cycle name is not set.': {
		translation: 'Cycle name is not set.',
	},
	'Cycle start date is not set.': {
		translation: 'Cycle start date is not set.',
	},
	'C’mon…what else are you thinking? Add some more details.': {
		translation: 'C’mon…what else are you thinking? Add some more details.',
	},
	"D'oh! The hire date has already passed.": {
		translation: "D'oh! The hire date has already passed.",
	},
	DBA: {
		translation: 'DBA',
	},
	'DBA Name': {
		translation: 'DBA Name',
	},
	'DEA #': {
		translation: 'DEA #',
	},
	'DEA expiration': {
		translation: 'DEA expiration',
	},
	DEDUCTIONS: {
		translation: 'DEDUCTIONS',
	},
	DELETE: {
		translation: 'DELETE',
	},
	'DEPOSITED TO %1$s': {
		translation: 'DEPOSITED TO %1$s',
	},
	'DEPOSITED TO %1$s %2$s': {
		translation: 'DEPOSITED TO %1$s %2$s',
	},
	'DL #': {
		translation: 'DL #',
	},
	'DL Expiration': {
		translation: 'DL Expiration',
	},
	'DL State': {
		translation: 'DL State',
	},
	'DMBA #': {
		translation: 'DMBA #',
	},
	'DMV Violations': {
		translation: 'DMV Violations',
	},
	'DMV Violations ': {
		translation: 'DMV Violations ',
	},
	DOB: {
		translation: 'DOB',
	},
	DOT: {
		translation: 'DOT',
	},
	'DOT Exp. Date': {
		translation: 'DOT Exp. Date',
	},
	"Dagnabbit! Something on our side has prevented this file from uploading. We'll get right on it.":
		{
			translation:
				"Dagnabbit! Something on our side has prevented this file from uploading. We'll get right on it.",
		},
	"Dagnabbit! Something on our side prevented this file from uploading. We'll get right on it.":
		{
			translation:
				"Dagnabbit! Something on our side prevented this file from uploading. We'll get right on it.",
		},
	Daily: {
		translation: 'Daily',
	},
	'Daily Graph': {
		translation: 'Daily Graph',
	},
	'Daily Hours': {
		translation: 'Daily Hours',
	},
	'Daily Total': {
		translation: 'Daily Total',
	},
	'Daily total added for **{1}**': {
		translation: 'Daily total added for **{1}**',
	},
	'Daily total updated from **{1}** to **{2}**': {
		translation: 'Daily total updated from **{1}** to **{2}**',
	},
	"Daily values require at least a '0'.": {
		translation: "Daily values require at least a '0'.",
	},
	"Dang, you don't have any Offer Templates set up.": {
		translation: "Dang, you don't have any Offer Templates set up.",
	},
	Dashboard: {
		translation: 'Dashboard',
	},
	'Dashboard is not available': {
		translation: 'Dashboard is not available',
	},
	'Data Center Location': {
		translation: 'Data Center Location',
	},
	'Data Center:': {
		translation: 'Data Center:',
	},
	'Data Cleaner': {
		translation: 'Data Cleaner',
	},
	'Data Processing Agreement (DPA)': {
		translation: 'Data Processing Agreement (DPA)',
	},
	'Data Review': {
		translation: 'Data Review',
	},
	'Data may not be significant': {
		translation: 'Data may not be significant',
	},
	'Data series for %s': {
		translation: 'Data series for %s',
	},
	'Data will sync and be updated in each system based on the field information in the image above.':
		{
			translation:
				'Data will sync and be updated in each system based on the field information in the image above.',
		},
	DataTable: {
		translation: 'DataTable',
	},
	Database: {
		translation: 'Database',
	},
	'Database:': {
		translation: 'Database:',
	},
	Date: {
		translation: 'Date',
	},
	'Date Assigned': {
		translation: 'Date Assigned',
	},
	'Date Available': {
		translation: 'Date Available',
	},
	'Date Completed': {
		translation: 'Date Completed',
	},
	'Date Created': {
		translation: 'Date Created',
	},
	'Date Field': {
		translation: 'Date Field',
	},
	'Date Filter': {
		translation: 'Date Filter',
	},
	'Date Input Format': {
		translation: 'Date Input Format',
	},
	'Date Loaned': {
		translation: 'Date Loaned',
	},
	'Date Recorded': {
		translation: 'Date Recorded',
	},
	'Date Returned': {
		translation: 'Date Returned',
	},
	'Date Taken': {
		translation: 'Date Taken',
	},
	'Date Verified': {
		translation: 'Date Verified',
	},
	'Date Waived': {
		translation: 'Date Waived',
	},
	'Date bonus leave awarded': {
		translation: 'Date bonus leave awarded',
	},
	'Date is out of range': {
		translation: 'Date is out of range',
	},
	'Date must be in the format mm-dd-yyyy or mm/dd/yyyy.': {
		translation: 'Date must be in the format mm-dd-yyyy or mm/dd/yyyy.',
	},
	'Date of Birth': {
		translation: 'Date of Birth',
	},
	'Date of Change': {
		translation: 'Date of Change',
	},
	'Date of Expense': {
		translation: 'Date of Expense',
	},
	'Date of Hire': {
		translation: 'Date of Hire',
	},
	'Date of Issue': {
		translation: 'Date of Issue',
	},
	'Date of birth': {
		translation: 'Date of birth',
	},
	'Date of birth must be in the format mm-dd-yyyy or mm/dd/yyyy.': {
		translation:
			'Date of birth must be in the format mm-dd-yyyy or mm/dd/yyyy.',
	},
	'Date of change': {
		translation: 'Date of change',
	},
	'Date required': {
		translation: 'Date required',
	},
	'Date(s) Off': {
		translation: 'Date(s) Off',
	},
	'Date/Time': {
		translation: 'Date/Time',
	},
	'Date: Oldest First': {
		translation: 'Date: Oldest First',
	},
	'Date: Recent First': {
		translation: 'Date: Recent First',
	},
	Dates: {
		translation: 'Dates',
	},
	Daughter: {
		translation: 'Daughter',
	},
	Day: {
		translation: 'Day',
	},
	'Day Available': {
		translation: {
			one: 'Day Available',
			other: 'Days Available',
		},
	},
	'Day Left': {
		translation: {
			one: 'Day Left',
			other: 'Days Left',
		},
	},
	'Day Total: %1': {
		translation: 'Day Total: %1',
	},
	'Day of the Week': {
		translation: 'Day of the Week',
	},
	'Day(s)': {
		translation: 'Day(s)',
	},
	'Day(s) Off': {
		translation: 'Day(s) Off',
	},
	Days: {
		translation: 'Days',
	},
	'Days Active': {
		translation: 'Days Active',
	},
	'Days in advance to display': {
		translation: 'Days in advance to display',
	},
	Deactivate: {
		translation: 'Deactivate',
	},
	'Dead Letter Queue': {
		translation: 'Dead Letter Queue',
	},
	Death: {
		translation: 'Death',
	},
	'Death of a child': {
		translation: 'Death of a child',
	},
	'Death of a spouse': {
		translation: 'Death of a spouse',
	},
	'Death of employee': {
		translation: 'Death of employee',
	},
	Dec: {
		translation: 'Dec',
	},
	December: {
		translation: 'December',
	},
	'Decline to Answer': {
		translation: 'Decline to Answer',
	},
	'Decline to answer': {
		translation: 'Decline to answer',
	},
	Declined: {
		translation: 'Declined',
	},
	'Declined Offer': {
		translation: 'Declined Offer',
	},
	'Declined to Answer': {
		translation: 'Declined to Answer',
	},
	'Deducted from Your Check': {
		translation: 'Deducted from Your Check',
	},
	Deduction: {
		translation: 'Deduction',
	},
	'Deduction Active': {
		translation: 'Deduction Active',
	},
	'Deduction Change Active': {
		translation: 'Deduction Change Active',
	},
	'Deduction Change Scheduled': {
		translation: 'Deduction Change Scheduled',
	},
	'Deduction Changes': {
		translation: 'Deduction Changes',
	},
	'Deduction End Scheduled': {
		translation: 'Deduction End Scheduled',
	},
	'Deduction Ended': {
		translation: 'Deduction Ended',
	},
	'Deduction Export File': {
		translation: 'Deduction Export File',
	},
	'Deduction Frequency': {
		translation: 'Deduction Frequency',
	},
	'Deduction Happens': {
		translation: 'Deduction Happens',
	},
	'Deduction Migration Saved.': {
		translation: 'Deduction Migration Saved.',
	},
	'Deduction Name': {
		translation: 'Deduction Name',
	},
	'Deduction Schedule Saved.': {
		translation: 'Deduction Schedule Saved.',
	},
	'Deduction Scheduled': {
		translation: 'Deduction Scheduled',
	},
	'Deduction Type': {
		translation: 'Deduction Type',
	},
	'Deduction deleted successfully.': {
		translation: 'Deduction deleted successfully.',
	},
	'Deduction edited successfully.': {
		translation: 'Deduction edited successfully.',
	},
	'Deduction is no longer active in payroll': {
		translation: 'Deduction is no longer active in payroll',
	},
	'Deduction is no longer active in payroll.': {
		translation: 'Deduction is no longer active in payroll.',
	},
	'Deduction name added successfully': {
		translation: 'Deduction name added successfully',
	},
	'Deduction will end in payroll on %1$s': {
		translation: 'Deduction will end in payroll on %1$s',
	},
	Deductions: {
		translation: 'Deductions',
	},
	'Deductions Amount': {
		translation: 'Deductions Amount',
	},
	'Deductions Change': {
		translation: 'Deductions Change',
	},
	'Deductions for this Benefit Group are made:': {
		translation: 'Deductions for this Benefit Group are made:',
	},
	'Deductions for this group are made:': {
		translation: 'Deductions for this group are made:',
	},
	'Default Country': {
		translation: 'Default Country',
	},
	'Default Currency': {
		translation: 'Default Currency',
	},
	'Default Hours': {
		translation: 'Default Hours',
	},
	'Default Hours per Day': {
		translation: 'Default Hours per Day',
	},
	'Default Hours per Day...': {
		translation: 'Default Hours per Day...',
	},
	'Defines how employees with this policy will accrue their time off.': {
		translation:
			'Defines how employees with this policy will accrue their time off.',
	},
	Degree: {
		translation: 'Degree',
	},
	Delete: {
		translation: 'Delete',
	},
	'Delete %1$s': {
		translation: 'Delete %1$s',
	},
	'Delete %s': {
		translation: 'Delete %s',
	},
	'Delete API Key': {
		translation: 'Delete API Key',
	},
	'Delete API Key?_one': {
		translation: 'Delete API Key?',
	},
	'Delete API Key?_other': {
		translation: '',
	},
	'Delete Access Level': {
		translation: 'Delete Access Level',
	},
	'Delete Accrual Level': {
		translation: 'Delete Accrual Level',
	},
	'Delete Alert': {
		translation: 'Delete Alert',
	},
	'Delete All': {
		translation: 'Delete All',
	},
	'Delete Announcement': {
		translation: 'Delete Announcement',
	},
	'Delete Announcement...': {
		translation: 'Delete Announcement...',
	},
	'Delete Applicant': {
		translation: 'Delete Applicant',
	},
	'Delete Approval': {
		translation: 'Delete Approval',
	},
	'Delete Benefit Group': {
		translation: 'Delete Benefit Group',
	},
	'Delete Candidate': {
		translation: 'Delete Candidate',
	},
	'Delete Candidates': {
		translation: 'Delete Candidates',
	},
	'Delete Category': {
		translation: 'Delete Category',
	},
	'Delete Comment': {
		translation: 'Delete Comment',
	},
	'Delete Comment ': {
		translation: 'Delete Comment ',
	},
	'Delete Comment and Rating?': {
		translation: 'Delete Comment and Rating?',
	},
	'Delete Comment and Status?': {
		translation: 'Delete Comment and Status?',
	},
	'Delete Comment?': {
		translation: 'Delete Comment?',
	},
	'Delete Contact': {
		translation: 'Delete Contact',
	},
	'Delete Deduction': {
		translation: 'Delete Deduction',
	},
	'Delete Dependent': {
		translation: 'Delete Dependent',
	},
	'Delete Device': {
		translation: 'Delete Device',
	},
	'Delete Education': {
		translation: 'Delete Education',
	},
	'Delete Education Entry': {
		translation: 'Delete Education Entry',
	},
	'Delete Email Alert': {
		translation: 'Delete Email Alert',
	},
	'Delete Employee': {
		translation: 'Delete Employee',
	},
	'Delete Employee...': {
		translation: 'Delete Employee...',
	},
	'Delete Employee?': {
		translation: 'Delete Employee?',
	},
	'Delete Event': {
		translation: 'Delete Event',
	},
	'Delete Folder': {
		translation: 'Delete Folder',
	},
	'Delete Folder & Files': {
		translation: 'Delete Folder & Files',
	},
	'Delete Goal': {
		translation: 'Delete Goal',
	},
	'Delete Group': {
		translation: 'Delete Group',
	},
	'Delete Holiday': {
		translation: 'Delete Holiday',
	},
	'Delete Hour Type Mapping': {
		translation: 'Delete Hour Type Mapping',
	},
	'Delete Item': {
		translation: 'Delete Item',
	},
	'Delete Items': {
		translation: 'Delete Items',
	},
	'Delete Job Opening': {
		translation: 'Delete Job Opening',
	},
	'Delete Map': {
		translation: 'Delete Map',
	},
	'Delete Note': {
		translation: 'Delete Note',
	},
	'Delete Offer': {
		translation: 'Delete Offer',
	},
	'Delete Partner': {
		translation: 'Delete Partner',
	},
	'Delete Pay Group': {
		translation: 'Delete Pay Group',
	},
	'Delete Pay Schedule': {
		translation: 'Delete Pay Schedule',
	},
	'Delete Peer Feedback': {
		translation: 'Delete Peer Feedback',
	},
	'Delete Peer Feedback Review Periods': {
		translation: 'Delete Peer Feedback Review Periods',
	},
	'Delete Photo': {
		translation: 'Delete Photo',
	},
	'Delete Photo?': {
		translation: 'Delete Photo?',
	},
	'Delete Plan': {
		translation: 'Delete Plan',
	},
	'Delete Plans and Enrollments': {
		translation: 'Delete Plans and Enrollments',
	},
	'Delete Policy': {
		translation: 'Delete Policy',
	},
	'Delete Post-Tax Deduction': {
		translation: 'Delete Post-Tax Deduction',
	},
	'Delete Project': {
		translation: 'Delete Project',
	},
	'Delete Rating and Comment?': {
		translation: 'Delete Rating and Comment?',
	},
	'Delete Rating?': {
		translation: 'Delete Rating?',
	},
	'Delete Report': {
		translation: 'Delete Report',
	},
	'Delete Reports': {
		translation: 'Delete Reports',
	},
	'Delete Review Periods': {
		translation: 'Delete Review Periods',
	},
	'Delete Row': {
		translation: 'Delete Row',
	},
	'Delete Selected Category': {
		translation: 'Delete Selected Category',
	},
	'Delete Selected Files': {
		translation: 'Delete Selected Files',
	},
	'Delete Selected Tasklist': {
		translation: 'Delete Selected Tasklist',
	},
	'Delete Source': {
		translation: 'Delete Source',
	},
	'Delete Status and Comment?': {
		translation: 'Delete Status and Comment?',
	},
	'Delete Status?': {
		translation: 'Delete Status?',
	},
	'Delete Task': {
		translation: 'Delete Task',
	},
	'Delete Template': {
		translation: 'Delete Template',
	},
	'Delete These Items': {
		translation: 'Delete These Items',
	},
	'Delete This Announcement': {
		translation: 'Delete This Announcement',
	},
	'Delete This Category': {
		translation: 'Delete This Category',
	},
	'Delete This Email Alert': {
		translation: 'Delete This Email Alert',
	},
	'Delete This Item': {
		translation: 'Delete This Item',
	},
	'Delete This Job': {
		translation: 'Delete This Job',
	},
	'Delete This Task': {
		translation: 'Delete This Task',
	},
	'Delete This Training': {
		translation: 'Delete This Training',
	},
	'Delete This Webhook': {
		translation: 'Delete This Webhook',
	},
	'Delete Time Entry': {
		translation: 'Delete Time Entry',
	},
	'Delete Time Off Policy': {
		translation: 'Delete Time Off Policy',
	},
	'Delete Time Off Type': {
		translation: 'Delete Time Off Type',
	},
	'Delete Training': {
		translation: 'Delete Training',
	},
	'Delete all assesments and peer feedback within a specific review period. Any goals that were completed during the deleted review period will be visible in the next review period.':
		{
			translation:
				'Delete all assesments and peer feedback within a specific review period. Any goals that were completed during the deleted review period will be visible in the next review period.',
		},
	'Delete all peer feedback within a specific review period. Assessments will remain available, and any goals that were completed during the deleted review period will be visible in the next review period.':
		{
			translation:
				'Delete all peer feedback within a specific review period. Assessments will remain available, and any goals that were completed during the deleted review period will be visible in the next review period.',
		},
	'Delete anywhere it is used, including existing items.': {
		translation: 'Delete anywhere it is used, including existing items.',
	},
	'Delete attachment': {
		translation: 'Delete attachment',
	},
	'Delete comment': {
		translation: 'Delete comment',
	},
	'Delete for new employees but leave existing items alone.': {
		translation: 'Delete for new employees but leave existing items alone.',
	},
	'Delete me': {
		translation: 'Delete me',
	},
	'Delete row %s': {
		translation: 'Delete row %s',
	},
	'Delete this Access Level': {
		translation: 'Delete this Access Level',
	},
	'Delete this Applicant': {
		translation: 'Delete this Applicant',
	},
	'Delete this Task for ...': {
		translation: 'Delete this Task for ...',
	},
	'Delete this User': {
		translation: 'Delete this User',
	},
	'Delete this task for...': {
		translation: 'Delete this task for...',
	},
	Deleted: {
		translation: 'Deleted',
	},
	'Deleted daily total: **{1}**': {
		translation: 'Deleted daily total: **{1}**',
	},
	'Deleted time entry: **{1}**': {
		translation: 'Deleted time entry: **{1}**',
	},
	'Deleting it may impact their payroll. We suggest moving employees to a new Pay Group before deleting this one.':
		{
			translation:
				'Deleting it may impact their payroll. We suggest moving employees to a new Pay Group before deleting this one.',
		},
	'Deleting it will end the deduction for them.': {
		translation: 'Deleting it will end the deduction for them.',
	},
	'Deleting this rating will reset it to what it was previously.': {
		translation:
			'Deleting this rating will reset it to what it was previously.',
	},
	'Deleting this rating will reset it to whatever it was before.': {
		translation:
			'Deleting this rating will reset it to whatever it was before.',
	},
	'Deleting this rating will reset it to whatever it was before. The comment made with the rating and any replies made to it will also be removed.':
		{
			translation:
				'Deleting this rating will reset it to whatever it was before. The comment made with the rating and any replies made to it will also be removed.',
		},
	'Deleting this rating will reset it to whatever it was before. The comment made with the rating will also be removed.':
		{
			translation:
				'Deleting this rating will reset it to whatever it was before. The comment made with the rating will also be removed.',
		},
	'Deleting this row will remove the active pay schedule for this benefits enabled employee':
		{
			translation:
				'Deleting this row will remove the active pay schedule for this benefits enabled employee',
		},
	'Deleting this row will remove the active pay schedule for this employee': {
		translation:
			'Deleting this row will remove the active pay schedule for this employee',
	},
	'Deleting this row will remove the active pay schedule for this time tracking enabled employee':
		{
			translation:
				'Deleting this row will remove the active pay schedule for this time tracking enabled employee',
		},
	'Deleting this status will reset it to what it was previously.': {
		translation:
			'Deleting this status will reset it to what it was previously.',
	},
	'Deleting this tax will permanently remove it from your company taxes. However, if this tax has ever been paid it will still show in your reports.':
		{
			translation:
				'Deleting this tax will permanently remove it from your company taxes. However, if this tax has ever been paid it will still show in your reports.',
		},
	'Demand Generation Manager': {
		translation: 'Demand Generation Manager',
	},
	'Demographic Information': {
		translation: 'Demographic Information',
	},
	Denied: {
		translation: 'Denied',
	},
	'Denied Approval': {
		translation: 'Denied Approval',
	},
	'Denied Custom Approval': {
		translation: 'Denied Custom Approval',
	},
	'Denied Information Update Approval': {
		translation: 'Denied Information Update Approval',
	},
	'Denied Time Off Request': {
		translation: 'Denied Time Off Request',
	},
	Dental: {
		translation: 'Dental',
	},
	'Dental Basic': {
		translation: 'Dental Basic',
	},
	'Dental Basic 2025': {
		translation: 'Dental Basic 2025',
	},
	'Dental Insurance': {
		translation: 'Dental Insurance',
	},
	'Dental Plan': {
		translation: 'Dental Plan',
	},
	'Dental Plus': {
		translation: 'Dental Plus',
	},
	'Dental Plus 2025': {
		translation: 'Dental Plus 2025',
	},
	Deny: {
		translation: 'Deny',
	},
	'Deny Anyway': {
		translation: 'Deny Anyway',
	},
	'Deny Request': {
		translation: 'Deny Request',
	},
	Department: {
		translation: 'Department',
	},
	'Department #': {
		translation: 'Department #',
	},
	'Department & Division': {
		translation: 'Department & Division',
	},
	"Department '%1$s' not found": {
		translation: "Department '%1$s' not found",
	},
	'Department Bar Chart': {
		translation: 'Department Bar Chart',
	},
	'Department Donut Chart': {
		translation: 'Department Donut Chart',
	},
	'Department ID': {
		translation: 'Department ID',
	},
	'Department is not valid for employee’s pay schedule.': {
		translation: 'Department is not valid for employee’s pay schedule.',
	},
	'Department was added successfully': {
		translation: 'Department was added successfully',
	},
	'Department(s):': {
		translation: 'Department(s):',
	},
	'Department/Division': {
		translation: 'Department/Division',
	},
	'Department: %1$s': {
		translation: 'Department: %1$s',
	},
	Departments: {
		translation: 'Departments',
	},
	Dependability: {
		translation: 'Dependability',
	},
	'Dependent Birth Date': {
		translation: 'Dependent Birth Date',
	},
	'Dependent Care Purposes': {
		translation: 'Dependent Care Purposes',
	},
	'Dependent City': {
		translation: 'Dependent City',
	},
	'Dependent Country': {
		translation: 'Dependent Country',
	},
	'Dependent County': {
		translation: 'Dependent County',
	},
	'Dependent First Name': {
		translation: 'Dependent First Name',
	},
	'Dependent Full-Time Student': {
		translation: 'Dependent Full-Time Student',
	},
	'Dependent Gender': {
		translation: 'Dependent Gender',
	},
	'Dependent Home Phone': {
		translation: 'Dependent Home Phone',
	},
	'Dependent Information': {
		translation: 'Dependent Information',
	},
	'Dependent Last Name': {
		translation: 'Dependent Last Name',
	},
	'Dependent Middle Name': {
		translation: 'Dependent Middle Name',
	},
	'Dependent Post Code': {
		translation: 'Dependent Post Code',
	},
	'Dependent Postal Code': {
		translation: 'Dependent Postal Code',
	},
	'Dependent Province': {
		translation: 'Dependent Province',
	},
	'Dependent Relationship': {
		translation: 'Dependent Relationship',
	},
	'Dependent SIN': {
		translation: 'Dependent SIN',
	},
	'Dependent SSN': {
		translation: 'Dependent SSN',
	},
	'Dependent SSN/SIN': {
		translation: 'Dependent SSN/SIN',
	},
	'Dependent State': {
		translation: 'Dependent State',
	},
	'Dependent Street 1': {
		translation: 'Dependent Street 1',
	},
	'Dependent Street 2': {
		translation: 'Dependent Street 2',
	},
	'Dependent US Citizen': {
		translation: 'Dependent US Citizen',
	},
	'Dependent ZIP': {
		translation: 'Dependent ZIP',
	},
	'Dependent ZIP Code': {
		translation: 'Dependent ZIP Code',
	},
	'Dependent added.': {
		translation: 'Dependent added.',
	},
	'Dependent age': {
		translation: 'Dependent age',
	},
	'Dependent deleted successfully.': {
		translation: 'Dependent deleted successfully.',
	},
	'Dependent disability': {
		translation: 'Dependent disability',
	},
	'Dependent gained citizenship': {
		translation: 'Dependent gained citizenship',
	},
	'Dependent gained eligibility for Medicaid/CHIP': {
		translation: 'Dependent gained eligibility for Medicaid/CHIP',
	},
	'Dependent gained eligibility for Medicare': {
		translation: 'Dependent gained eligibility for Medicare',
	},
	'Dependent gained outside health coverage': {
		translation: 'Dependent gained outside health coverage',
	},
	'Dependent lost eligibility for Medicaid/CHIP': {
		translation: 'Dependent lost eligibility for Medicaid/CHIP',
	},
	'Dependent lost outside health coverage': {
		translation: 'Dependent lost outside health coverage',
	},
	'Dependent moved to a different ZIP or county': {
		translation: 'Dependent moved to a different ZIP or county',
	},
	'Dependent moved to or from school': {
		translation: 'Dependent moved to or from school',
	},
	'Dependent moved to or from seasonal work location': {
		translation: 'Dependent moved to or from seasonal work location',
	},
	'Dependent moved to or from shelter or transitional housing': {
		translation: 'Dependent moved to or from shelter or transitional housing',
	},
	'Dependent qualifying for CHIP': {
		translation: 'Dependent qualifying for CHIP',
	},
	'Dependent turned 26': {
		translation: 'Dependent turned 26',
	},
	'Dependent turning 26 years old': {
		translation: 'Dependent turning 26 years old',
	},
	Dependents: {
		translation: 'Dependents',
	},
	'Dependents Amount': {
		translation: 'Dependents Amount',
	},
	'Deployment start date': {
		translation: 'Deployment start date',
	},
	Deposit: {
		translation: 'Deposit',
	},
	'Deposit Amount': {
		translation: 'Deposit Amount',
	},
	'Deposit Order': {
		translation: 'Deposit Order',
	},
	'Deposit Schedule': {
		translation: 'Deposit Schedule',
	},
	'Deposit Type': {
		translation: 'Deposit Type',
	},
	Deposited: {
		translation: 'Deposited',
	},
	'Deposited to': {
		translation: 'Deposited to',
	},
	Descending: {
		translation: 'Descending',
	},
	Description: {
		translation: 'Description',
	},
	'Description (Optional)': {
		translation: 'Description (Optional)',
	},
	'Description (optional)': {
		translation: 'Description (optional)',
	},
	"Description Field can't exceed 255 characters.": {
		translation: "Description Field can't exceed 255 characters.",
	},
	'Description and examples': {
		translation: 'Description and examples',
	},
	'Deselect All Files': {
		translation: 'Deselect All Files',
	},
	'Desired Pay': {
		translation: 'Desired Pay',
	},
	'Desired Salary': {
		translation: 'Desired Salary',
	},
	'Desk Phone': {
		translation: 'Desk Phone',
	},
	Desktop: {
		translation: 'Desktop',
	},
	Details: {
		translation: 'Details',
	},
	Detractor: {
		translation: 'Detractor',
	},
	'Detractor Tags': {
		translation: 'Detractor Tags',
	},
	Detractors: {
		translation: 'Detractors',
	},
	'Detractors (0-6)': {
		translation: 'Detractors (0-6)',
	},
	'Detractors (Rated 0-6)': {
		translation: 'Detractors (Rated 0-6)',
	},
	'Dev Utilities': {
		translation: 'Dev Utilities',
	},
	'Developing Components': {
		translation: 'Developing Components',
	},
	'Device ID': {
		translation: 'Device ID',
	},
	'Did you forget to clock out?': {
		translation: 'Did you forget to clock out?',
	},
	'Did you mean one of these?': {
		translation: 'Did you mean one of these?',
	},
	'Dietary Restrictions': {
		translation: 'Dietary Restrictions',
	},
	Difference: {
		translation: 'Difference',
	},
	'Direct Deposit': {
		translation: 'Direct Deposit',
	},
	'Direct Deposit Account(s)': {
		translation: 'Direct Deposit Account(s)',
	},
	'Direct Deposit Accounts': {
		translation: 'Direct Deposit Accounts',
	},
	'Direct Deposit Change': {
		translation: 'Direct Deposit Change',
	},
	'Direct Deposit Changes': {
		translation: 'Direct Deposit Changes',
	},
	'Direct Deposit Form': {
		translation: 'Direct Deposit Form',
	},
	'Direct Deposit info added for %1$s': {
		translation: 'Direct Deposit info added for %1$s',
	},
	'Direct Deposit info updated.': {
		translation: 'Direct Deposit info updated.',
	},
	"Direct Deposit info updated. Keep in mind you may get a paper check depending on your company's settings. After that, your new direct deposit information will take effect.":
		{
			translation:
				"Direct Deposit info updated. Keep in mind you may get a paper check depending on your company's settings. After that, your new direct deposit information will take effect.",
		},
	'Direct Reports': {
		translation: 'Direct Reports',
	},
	'Direct and Indirect Reports': {
		translation: 'Direct and Indirect Reports',
	},
	'Direct deposit account type not valid.': {
		translation: 'Direct deposit account type not valid.',
	},
	'Direct deposit amount must be greater than zero.': {
		translation: 'Direct deposit amount must be greater than zero.',
	},
	'Direct deposit amount must be numeric.': {
		translation: 'Direct deposit amount must be numeric.',
	},
	'Direct deposit percent rule type can not be greater than 100.': {
		translation:
			'Direct deposit percent rule type can not be greater than 100.',
	},
	'Direct deposit routing number must be ': {
		translation: 'Direct deposit routing number must be ',
	},
	'Direct deposit routing number must be all digits': {
		translation: 'Direct deposit routing number must be all digits',
	},
	'Direct deposit rule type not valid.': {
		translation: 'Direct deposit rule type not valid.',
	},
	'Director of Customer Success': {
		translation: 'Director of Customer Success',
	},
	'Director of HR': {
		translation: 'Director of HR',
	},
	'Director of IT': {
		translation: 'Director of IT',
	},
	'Director of Marketing': {
		translation: 'Director of Marketing',
	},
	'Director of Talent Management': {
		translation: 'Director of Talent Management',
	},
	Directory: {
		translation: 'Directory',
	},
	'Directory ID': {
		translation: 'Directory ID',
	},
	'Directory: Quick Access': {
		translation: 'Directory: Quick Access',
	},
	Disability: {
		translation: 'Disability',
	},
	'Disability Plan': {
		translation: 'Disability Plan',
	},
	'Disability code': {
		translation: 'Disability code',
	},
	Disable: {
		translation: 'Disable',
	},
	'Disable ACA Tracking': {
		translation: 'Disable ACA Tracking',
	},
	'Disable Access': {
		translation: 'Disable Access',
	},
	'Disable Access Now': {
		translation: 'Disable Access Now',
	},
	'Disable Approval': {
		translation: 'Disable Approval',
	},
	'Disable Approval?': {
		translation: 'Disable Approval?',
	},
	'Disable Benefits Administration': {
		translation: 'Disable Benefits Administration',
	},
	'Disable Time Tracking': {
		translation: 'Disable Time Tracking',
	},
	'Disable employee goal tracking': {
		translation: 'Disable employee goal tracking',
	},
	'Disable link.': {
		translation: 'Disable link.',
	},
	Disabled: {
		translation: 'Disabled',
	},
	'Disabled API Key': {
		translation: 'Disabled API Key',
	},
	'Disabled Access Token': {
		translation: 'Disabled Access Token',
	},
	'Disabled Veteran': {
		translation: 'Disabled Veteran',
	},
	'Disabled and Aged 26 or Older': {
		translation: 'Disabled and Aged 26 or Older',
	},
	"Disabled approvals won't show in the change request list in the employee profile action menu (the gear icon). Existing requests using this approval will not be affected.":
		{
			translation:
				"Disabled approvals won't show in the change request list in the employee profile action menu (the gear icon). Existing requests using this approval will not be affected.",
		},
	'Disabled for previewing': {
		translation: 'Disabled for previewing',
	},
	'Disabled for trial accounts.': {
		translation: 'Disabled for trial accounts.',
	},
	Disagree: {
		translation: 'Disagree',
	},
	'Discard Changes': {
		translation: 'Discard Changes',
	},
	'Disconnecting will immediately stop all LinkedIn Promotional Jobs and remove them from LinkedIn.':
		{
			translation:
				'Disconnecting will immediately stop all LinkedIn Promotional Jobs and remove them from LinkedIn.',
		},
	Discover: {
		translation: 'Discover',
	},
	'Discussion Items': {
		translation: 'Discussion Items',
	},
	Dislikes: {
		translation: 'Dislikes',
	},
	'Dismiss message': {
		translation: 'Dismiss message',
	},
	'Dismiss slidedown': {
		translation: 'Dismiss slidedown',
	},
	'Display Name': {
		translation: 'Display Name',
	},
	'Display birthdays': {
		translation: 'Display birthdays',
	},
	'Display employment anniversaries': {
		translation: 'Display employment anniversaries',
	},
	'Display if benefit plan is one of:': {
		translation: 'Display if benefit plan is one of:',
	},
	'Display if enrolled benefit plan is one of:': {
		translation: 'Display if enrolled benefit plan is one of:',
	},
	'Display if the employee election is:': {
		translation: 'Display if the employee election is:',
	},
	'Disposition Code': {
		translation: 'Disposition Code',
	},
	Disqualified: {
		translation: 'Disqualified',
	},
	Distraction: {
		translation: 'Distraction',
	},
	Division: {
		translation: 'Division',
	},
	"Division '%1$s' not found": {
		translation: "Division '%1$s' not found",
	},
	'Division Bar Chart': {
		translation: 'Division Bar Chart',
	},
	'Division D': {
		translation: 'Division D',
	},
	'Division Donut Chart': {
		translation: 'Division Donut Chart',
	},
	'Division is not valid for employee’s pay schedule.': {
		translation: 'Division is not valid for employee’s pay schedule.',
	},
	'Division(s):': {
		translation: 'Division(s):',
	},
	'Division: %1$s': {
		translation: 'Division: %1$s',
	},
	Divisions: {
		translation: 'Divisions',
	},
	Divorce: {
		translation: 'Divorce',
	},
	'Do I really have to add direct deposit accounts for everyone?': {
		translation:
			'Do I really have to add direct deposit accounts for everyone?',
	},
	'Do client employees pre-pay or post-pay for their benefits? This tool determines when employees start paying for benefits relative to their enrollment date for medical, dental, vision, HSA, and FSA plans. (Clients can configure all other plan types.)':
		{
			translation:
				'Do client employees pre-pay or post-pay for their benefits? This tool determines when employees start paying for benefits relative to their enrollment date for medical, dental, vision, HSA, and FSA plans. (Clients can configure all other plan types.)',
		},
	'Do employees pre-pay or post-pay for their benefits? (In the past, post-pay was the only option.) ':
		{
			translation:
				'Do employees pre-pay or post-pay for their benefits? (In the past, post-pay was the only option.) ',
		},
	"Do everything I could to keep %s. We'd be in trouble.": {
		translation: "Do everything I could to keep %s. We'd be in trouble.",
	},
	"Do everything we could to keep them. We'd be in trouble.": {
		translation: "Do everything we could to keep them. We'd be in trouble.",
	},
	'Do not import this field': {
		translation: 'Do not import this field',
	},
	'Do not press back or navigate away from this screen.': {
		translation: 'Do not press back or navigate away from this screen.',
	},
	'Do or do not... There is no try.': {
		translation: 'Do or do not... There is no try.',
	},
	'Do this later': {
		translation: 'Do this later',
	},
	'Do you need to get away?': {
		translation: 'Do you need to get away?',
	},
	'Do you want to disable feedback?': {
		translation: 'Do you want to disable feedback?',
	},
	'Do you want to discard your changes?': {
		translation: 'Do you want to discard your changes?',
	},
	'Do you want to get your hands on all of our cool new features before your friends? Early access lets you use and give feedback on all of our new features before they become available to everybody.':
		{
			translation:
				'Do you want to get your hands on all of our cool new features before your friends? Early access lets you use and give feedback on all of our new features before they become available to everybody.',
		},
	'Do you want to start a new synchronization job (this may delay the current synchronization job)?':
		{
			translation:
				'Do you want to start a new synchronization job (this may delay the current synchronization job)?',
		},
	"Doctor's Appointment": {
		translation: "Doctor's Appointment",
	},
	Doctorate: {
		translation: 'Doctorate',
	},
	Document: {
		translation: 'Document',
	},
	'Document Name': {
		translation: 'Document Name',
	},
	'Document Signed': {
		translation: 'Document Signed',
	},
	'Document sent for signing': {
		translation: {
			one: 'Document sent for signing',
			other: 'Document sent for signing',
		},
	},
	Documents: {
		translation: 'Documents',
	},
	'Does Something Not Look Right?': {
		translation: 'Does Something Not Look Right?',
	},
	'Does everything look good?': {
		translation: 'Does everything look good?',
	},
	'Does not accrue hours.': {
		translation: 'Does not accrue hours.',
	},
	'Does something not look right?': {
		translation: 'Does something not look right?',
	},
	'Does this benefit deduction happen every paycheck?': {
		translation: 'Does this benefit deduction happen every paycheck?',
	},
	'Does this benefit deduction happen every paycheck? (%1$s)': {
		translation: 'Does this benefit deduction happen every paycheck? (%1$s)',
	},
	'Does this plan meet the minimum value standard?': {
		translation: 'Does this plan meet the minimum value standard?',
	},
	'Does this plan qualify as minimum essential coverage?': {
		translation: 'Does this plan qualify as minimum essential coverage?',
	},
	'Does your company have employees in the **European Union**, **EEA**, the **United Kingdom** or **Switzerland**?':
		{
			translation:
				'Does your company have employees in the **European Union**, **EEA**, the **United Kingdom** or **Switzerland**?',
		},
	Dollar: {
		translation: 'Dollar',
	},
	Domain: {
		translation: 'Domain',
	},
	'Domain was updated': {
		translation: 'Domain was updated',
	},
	'Domestic Partnership': {
		translation: 'Domestic Partnership',
	},
	'Domestic partner': {
		translation: 'Domestic partner',
	},
	"Don't Comment": {
		translation: "Don't Comment",
	},
	"Don't Hire %s": {
		translation: "Don't Hire %s",
	},
	"Don't Reset": {
		translation: "Don't Reset",
	},
	"Don't Save": {
		translation: "Don't Save",
	},
	"Don't Send Request Yet": {
		translation: "Don't Send Request Yet",
	},
	"Don't forget your shovel": {
		translation: "Don't forget your shovel",
	},
	"Don't leave them hanging; move them to another %1$s before deleting this.": {
		translation:
			"Don't leave them hanging; move them to another %1$s before deleting this.",
	},
	"Don't leave them hanging; move them to another coverage option before deleting this one.":
		{
			translation:
				"Don't leave them hanging; move them to another coverage option before deleting this one.",
		},
	"Don't leave them hanging; move them to another group before deleting this one.":
		{
			translation:
				"Don't leave them hanging; move them to another group before deleting this one.",
		},
	"Don't leave them hanging; move them to another group before deleting this.":
		{
			translation:
				"Don't leave them hanging; move them to another group before deleting this.",
		},
	"Don't save yet": {
		translation: "Don't save yet",
	},
	"Don't see the email?": {
		translation: "Don't see the email?",
	},
	"Don't show this again": {
		translation: "Don't show this again",
	},
	"Don't worry though, in the meantime you can still request time off.": {
		translation:
			"Don't worry though, in the meantime you can still request time off.",
	},
	"Don't worry, doing so won't actually make the employee any less educated": {
		translation:
			"Don't worry, doing so won't actually make the employee any less educated",
	},
	"Don't worry, it's pretty simple and shouldn't take long.": {
		translation: "Don't worry, it's pretty simple and shouldn't take long.",
	},
	"Don't worry, only managers will ever see peer feedback. Otherwise it could get pretty awkward.":
		{
			translation:
				"Don't worry, only managers will ever see peer feedback. Otherwise it could get pretty awkward.",
		},
	"Don't worry, people won't see this new tab yet.": {
		translation: "Don't worry, people won't see this new tab yet.",
	},
	"Don't worry, we'll send you another one right now.": {
		translation: "Don't worry, we'll send you another one right now.",
	},
	"Don't worry, we'll take it one step at a time": {
		translation: "Don't worry, we'll take it one step at a time",
	},
	"Don't worry, you'll be able to add them back later if you need to.": {
		translation:
			"Don't worry, you'll be able to add them back later if you need to.",
	},
	"Don't worry, your employees' enrollments will remain intact and unaffected by this update.":
		{
			translation:
				"Don't worry, your employees' enrollments will remain intact and unaffected by this update.",
		},
	"Don't worry, your employees' enrollments will remain intact and unaffected by this update. [Learn more]":
		{
			translation:
				"Don't worry, your employees' enrollments will remain intact and unaffected by this update. [Learn more]",
		},
	'Donation To Non-Profit Organization': {
		translation: 'Donation To Non-Profit Organization',
	},
	Done: {
		translation: 'Done',
	},
	'Done Previewing': {
		translation: 'Done Previewing',
	},
	'Done reviewing this page?': {
		translation: 'Done reviewing this page?',
	},
	'Done! The mid-quarter sweep for %1 has been closed.': {
		translation: 'Done! The mid-quarter sweep for %1 has been closed.',
	},
	'Done! The mid-quarter sweep for Bob’s Transportation Services has been closed.':
		{
			translation:
				'Done! The mid-quarter sweep for Bob’s Transportation Services has been closed.',
		},
	'Done! The mid-quarter sweep has been closed.': {
		translation: 'Done! The mid-quarter sweep has been closed.',
	},
	'Done! Your job openings will now be posted on your website.': {
		translation: 'Done! Your job openings will now be posted on your website.',
	},
	'Done! Your time has been saved.': {
		translation: 'Done! Your time has been saved.',
	},
	'Donut chart': {
		translation: 'Donut chart',
	},
	'Don’t worry, each person won’t see that the message was also sent to other people.':
		{
			translation:
				'Don’t worry, each person won’t see that the message was also sent to other people.',
		},
	'Don’t worry, only managers will ever see the feedback. Otherwise it could get pretty awkward.':
		{
			translation:
				'Don’t worry, only managers will ever see the feedback. Otherwise it could get pretty awkward.',
		},
	'Don’t worry, you can add whatever you need when it comes time to create the offer.':
		{
			translation:
				'Don’t worry, you can add whatever you need when it comes time to create the offer.',
		},
	Dosage: {
		translation: 'Dosage',
	},
	'Double Time': {
		translation: 'Double Time',
	},
	'Double check below and select the correct address for %1$s': {
		translation: 'Double check below and select the correct address for %1$s',
	},
	'Double check that all your addresses are accurate.': {
		translation: 'Double check that all your addresses are accurate.',
	},
	'Double check that everything is accurate.': {
		translation: 'Double check that everything is accurate.',
	},
	'Double check that everything looks correct. After this screen your benefits migration will be complete; eligibility requirements will be managed within each plan.':
		{
			translation:
				'Double check that everything looks correct. After this screen your benefits migration will be complete; eligibility requirements will be managed within each plan.',
		},
	"Double check the address below and make sure it's exactly right": {
		translation:
			"Double check the address below and make sure it's exactly right",
	},
	'Double check with the client that this is correct.': {
		translation: 'Double check with the client that this is correct.',
	},
	'Double-check and make sure it looks right.': {
		translation: 'Double-check and make sure it looks right.',
	},
	Download: {
		translation: 'Download',
	},
	'Download All (.zip)': {
		translation: 'Download All (.zip)',
	},
	'Download All Candidate Information': {
		translation: 'Download All Candidate Information',
	},
	'Download Employee Forms (I-9, W-4, etc.)': {
		translation: 'Download Employee Forms (I-9, W-4, etc.)',
	},
	'Download Error File': {
		translation: 'Download Error File',
	},
	'Download Forms': {
		translation: 'Download Forms',
	},
	'Download Forms (W-4, I-9)': {
		translation: 'Download Forms (W-4, I-9)',
	},
	'Download Org Chart': {
		translation: 'Download Org Chart',
	},
	'Download PDF': {
		translation: 'Download PDF',
	},
	'Download PNG': {
		translation: 'Download PNG',
	},
	'Download Report': {
		translation: 'Download Report',
	},
	'Download Secure File From BambooHR': {
		translation: 'Download Secure File From BambooHR',
	},
	'Download Selected Files': {
		translation: 'Download Selected Files',
	},
	'Download Your All Dbs Query File': {
		translation: 'Download Your All Dbs Query File',
	},
	'Download Your Offer Documents': {
		translation: 'Download Your Offer Documents',
	},
	'Download a .csv to import to:': {
		translation: 'Download a .csv to import to:',
	},
	'Download a simplified version of the org chart in PDF or PNG format.': {
		translation:
			'Download a simplified version of the org chart in PDF or PNG format.',
	},
	'Download and sign these 2 forms. Once completed, upload them below.': {
		translation:
			'Download and sign these 2 forms. Once completed, upload them below.',
	},
	'Download and sign these 3 forms. Once completed, upload them below.': {
		translation:
			'Download and sign these 3 forms. Once completed, upload them below.',
	},
	'Download and sign your bank account authorization forms': {
		translation: 'Download and sign your bank account authorization forms',
	},
	'Download and sign your company payroll forms': {
		translation: 'Download and sign your company payroll forms',
	},
	'Download file': {
		translation: 'Download file',
	},
	'Download your BambooHR Export File': {
		translation: 'Download your BambooHR Export File',
	},
	'Download your BambooHR export file': {
		translation: 'Download your BambooHR export file',
	},
	Downloads: {
		translation: 'Downloads',
	},
	Draft: {
		translation: 'Draft',
	},
	'Draft & Open': {
		translation: 'Draft & Open',
	},
	'Draft Created': {
		translation: 'Draft Created',
	},
	'Draft Offer': {
		translation: 'Draft Offer',
	},
	'Drag Categories to Reorder': {
		translation: 'Drag Categories to Reorder',
	},
	'Drag Category to Reorder': {
		translation: 'Drag Category to Reorder',
	},
	'Drag Category to Reorder:': {
		translation: 'Drag Category to Reorder:',
	},
	'Drag Lists to Reorder': {
		translation: 'Drag Lists to Reorder',
	},
	'Drag and drop existing reports or add a new report.': {
		translation: 'Drag and drop existing reports or add a new report.',
	},
	'Drag and drop or click to browse files': {
		translation: 'Drag and drop or click to browse files',
	},
	'Drag and drop or click to browse files.': {
		translation: 'Drag and drop or click to browse files.',
	},
	'Drag files to this folder or upload new files': {
		translation: 'Drag files to this folder or upload new files',
	},
	'Drag to reorder': {
		translation: 'Drag to reorder',
	},
	'Drag to reorder Employee Record Tabs': {
		translation: 'Drag to reorder Employee Record Tabs',
	},
	'Drag to reorder information on the': {
		translation: 'Drag to reorder information on the',
	},
	'Drag to reorder information on the %1 Tab': {
		translation: 'Drag to reorder information on the %1 Tab',
	},
	'Drag to reorder information on the %s Tab': {
		translation: 'Drag to reorder information on the %s Tab',
	},
	Draw: {
		translation: 'Draw',
	},
	'Draw your initials with your mouse': {
		translation: 'Draw your initials with your mouse',
	},
	'Draw your initials...': {
		translation: 'Draw your initials...',
	},
	'Draw your signature with your finger…': {
		translation: 'Draw your signature with your finger…',
	},
	'Draw your signature with your mouse...': {
		translation: 'Draw your signature with your mouse...',
	},
	'Draw your signature...': {
		translation: 'Draw your signature...',
	},
	'Drive more business with goals and real-time coaching. Inspire achievement with recognition and real rewards. Improve performance all the time, not just at review time. Now you can extend the power of Work.com on Salesforce with the BambooHR application. Contact BambooHR today to learn more.':
		{
			translation:
				'Drive more business with goals and real-time coaching. Inspire achievement with recognition and real rewards. Improve performance all the time, not just at review time. Now you can extend the power of Work.com on Salesforce with the BambooHR application. Contact BambooHR today to learn more.',
		},
	'Driver Classification': {
		translation: 'Driver Classification',
	},
	'Driver License': {
		translation: 'Driver License',
	},
	'Driver License: #': {
		translation: 'Driver License: #',
	},
	'Driver License: Classification': {
		translation: 'Driver License: Classification',
	},
	'Driver License: DMV Violations ': {
		translation: 'Driver License: DMV Violations ',
	},
	'Driver License: Expiration': {
		translation: 'Driver License: Expiration',
	},
	'Driver License: State': {
		translation: 'Driver License: State',
	},
	'Driver job': {
		translation: 'Driver job',
	},
	"Driver's license": {
		translation: "Driver's license",
	},
	'Drivers License, Passport, Visa': {
		translation: 'Drivers License, Passport, Visa',
	},
	Driving: {
		translation: 'Driving',
	},
	'Drop Files Here to Upload': {
		translation: 'Drop Files Here to Upload',
	},
	'Drop file here to upload...': {
		translation: 'Drop file here to upload...',
	},
	'Drop to upload': {
		translation: 'Drop to upload',
	},
	'Drug-Free Workplace': {
		translation: 'Drug-Free Workplace',
	},
	Due: {
		translation: 'Due',
	},
	'Due %1': {
		translation: 'Due %1',
	},
	'Due %d %s %s %s ': {
		translation: 'Due %d %s %s %s ',
	},
	'Due Date': {
		translation: 'Due Date',
	},
	'Due Date Icon': {
		translation: 'Due Date Icon',
	},
	'Due First': {
		translation: 'Due First',
	},
	'Due Last': {
		translation: 'Due Last',
	},
	'Due Today': {
		translation: 'Due Today',
	},
	'Due Today.': {
		translation: 'Due Today.',
	},
	'Due in %s Day': {
		translation: {
			one: 'Due in %s Day',
			other: 'Due in %s Days',
		},
	},
	'Due on %s': {
		translation: 'Due on %s',
	},
	'Due within': {
		translation: 'Due within',
	},
	Duplicate: {
		translation: 'Duplicate',
	},
	'Duplicate %1': {
		translation: 'Duplicate %1',
	},
	'Duplicate %1 Plan': {
		translation: 'Duplicate %1 Plan',
	},
	'Duplicate Access Level': {
		translation: 'Duplicate Access Level',
	},
	'Duplicate Benefit Group': {
		translation: 'Duplicate Benefit Group',
	},
	'Duplicate Custom Filter Set Name': {
		translation: 'Duplicate Custom Filter Set Name',
	},
	'Duplicate Default Filter Set Name': {
		translation: 'Duplicate Default Filter Set Name',
	},
	'Duplicate Email': {
		translation: 'Duplicate Email',
	},
	'Duplicate Filter Set Name': {
		translation: 'Duplicate Filter Set Name',
	},
	'Duplicate Job Opening': {
		translation: 'Duplicate Job Opening',
	},
	'Duplicate NIN': {
		translation: 'Duplicate NIN',
	},
	'Duplicate Name: %1$s': {
		translation: 'Duplicate Name: %1$s',
	},
	'Duplicate National ID': {
		translation: 'Duplicate National ID',
	},
	'Duplicate Plan': {
		translation: 'Duplicate Plan',
	},
	'Duplicate Policy': {
		translation: 'Duplicate Policy',
	},
	'Duplicate SIN': {
		translation: 'Duplicate SIN',
	},
	'Duplicate SSN': {
		translation: 'Duplicate SSN',
	},
	'Duplicate SSN & SIN': {
		translation: 'Duplicate SSN & SIN',
	},
	'Duplicate Social Security Number': {
		translation: 'Duplicate Social Security Number',
	},
	'Duplicate Template': {
		translation: 'Duplicate Template',
	},
	'Duplicate a Benefit Plan': {
		translation: 'Duplicate a Benefit Plan',
	},
	'Duplicate carrier EIN': {
		translation: 'Duplicate carrier EIN',
	},
	'Duplicate carrier name: %1$s': {
		translation: 'Duplicate carrier name: %1$s',
	},
	'Duplicate row for employee detected.': {
		translation: 'Duplicate row for employee detected.',
	},
	'Duplicate table row: there is already a contact with this information for this employee':
		{
			translation:
				'Duplicate table row: there is already a contact with this information for this employee',
		},
	'Duplicate table row: there is already a dependent with this information for this employee':
		{
			translation:
				'Duplicate table row: there is already a dependent with this information for this employee',
		},
	'Duplicate table row: there is already a row with this data for this employee':
		{
			translation:
				'Duplicate table row: there is already a row with this data for this employee',
		},
	"Duplicating the file %1$s would cause you to exceed your plan's storage limit. Contact your system administrator for assistance.":
		{
			translation:
				"Duplicating the file %1$s would cause you to exceed your plan's storage limit. Contact your system administrator for assistance.",
		},
	'E-mail Sent': {
		translation: 'E-mail Sent',
	},
	EEID: {
		translation: 'EEID',
	},
	'EEO Categories Assigned': {
		translation: 'EEO Categories Assigned',
	},
	'EEO Categories assigned but jobs left behind:': {
		translation: 'EEO Categories assigned but jobs left behind:',
	},
	'EEO Category': {
		translation: 'EEO Category',
	},
	'EEO Details': {
		translation: 'EEO Details',
	},
	'EEO Details Report': {
		translation: 'EEO Details Report',
	},
	'EEO Job Category': {
		translation: 'EEO Job Category',
	},
	'EEO-1': {
		translation: 'EEO-1',
	},
	'EEO-1 Report': {
		translation: 'EEO-1 Report',
	},
	EIN: {
		translation: 'EIN',
	},
	'EIN #': {
		translation: 'EIN #',
	},
	'EIN Deleted': {
		translation: 'EIN Deleted',
	},
	'EIN is not valid.': {
		translation: 'EIN is not valid.',
	},
	'EIN must be a valid EIN': {
		translation: 'EIN must be a valid EIN',
	},
	'EIN must be unique': {
		translation: 'EIN must be unique',
	},
	'EIN was deleted': {
		translation: 'EIN was deleted',
	},
	'EMIA #': {
		translation: 'EMIA #',
	},
	'EMP Custom Answer %s': {
		translation: 'EMP Custom Answer %s',
	},
	'EMP Custom Question %s': {
		translation: 'EMP Custom Question %s',
	},
	'EMP: ': {
		translation: 'EMP: ',
	},
	'EMP: File Attached': {
		translation: 'EMP: File Attached',
	},
	'EMP: How could I improve?': {
		translation: 'EMP: How could I improve?',
	},
	'EMP: What are some things I do well?': {
		translation: 'EMP: What are some things I do well?',
	},
	'ERROR: Invalid Pay Schedule ID!': {
		translation: 'ERROR: Invalid Pay Schedule ID!',
	},
	'ERROR: Invalid parameters!': {
		translation: 'ERROR: Invalid parameters!',
	},
	EXPIRED: {
		translation: 'EXPIRED',
	},
	'Each Employee may have unique info': {
		translation: 'Each Employee may have unique info',
	},
	'Each document will also require signatures from:': {
		translation: 'Each document will also require signatures from:',
	},
	'Each employee may have unique info': {
		translation: 'Each employee may have unique info',
	},
	'Each form as a separate PDF file': {
		translation: 'Each form as a separate PDF file',
	},
	"Each month we'll refresh your employee information with a new sync from BambooHR and ensure employee data in Insight is up-to-date.":
		{
			translation:
				"Each month we'll refresh your employee information with a new sync from BambooHR and ensure employee data in Insight is up-to-date.",
		},
	'Early Access': {
		translation: 'Early Access',
	},
	'Early Access Features': {
		translation: 'Early Access Features',
	},
	'Early Access Hub': {
		translation: 'Early Access Hub',
	},
	'Early access has been disabled': {
		translation: 'Early access has been disabled',
	},
	'Early access has been enabled': {
		translation: 'Early access has been enabled',
	},
	Earned: {
		translation: 'Earned',
	},
	'Earned YTD': {
		translation: 'Earned YTD',
	},
	'Earned this period': {
		translation: 'Earned this period',
	},
	'Earned year to date': {
		translation: 'Earned year to date',
	},
	'Earned/Used': {
		translation: 'Earned/Used',
	},
	Earnings: {
		translation: 'Earnings',
	},
	'Earnings: Date': {
		translation: 'Earnings: Date',
	},
	'Earnings: Prior Year W2/K1': {
		translation: 'Earnings: Prior Year W2/K1',
	},
	'Easily collect signatures for documents electronically.': {
		translation: 'Easily collect signatures for documents electronically.',
	},
	'Easily send out documentation to an employee for signature electronically right from BambooHR':
		{
			translation:
				'Easily send out documentation to an employee for signature electronically right from BambooHR',
		},
	'Easily view and approve employee requests.': {
		translation: 'Easily view and approve employee requests.',
	},
	"Easy tiger! That's too many files for us to handle all at once. Select just a handful and try again.":
		{
			translation:
				"Easy tiger! That's too many files for us to handle all at once. Select just a handful and try again.",
		},
	Edit: {
		translation: 'Edit',
	},
	'Edit ': {
		translation: 'Edit ',
	},
	'Edit %1 Plan': {
		translation: 'Edit %1 Plan',
	},
	'Edit %1$s': {
		translation: 'Edit %1$s',
	},
	'Edit %s': {
		translation: 'Edit %s',
	},
	'Edit %s Item': {
		translation: 'Edit %s Item',
	},
	'Edit - Approval Required': {
		translation: 'Edit - Approval Required',
	},
	'Edit API Key': {
		translation: 'Edit API Key',
	},
	'Edit Applicant': {
		translation: 'Edit Applicant',
	},
	'Edit Approval Form': {
		translation: 'Edit Approval Form',
	},
	'Edit Bank Account': {
		translation: 'Edit Bank Account',
	},
	'Edit Benefit Group': {
		translation: 'Edit Benefit Group',
	},
	'Edit Candidate': {
		translation: 'Edit Candidate',
	},
	'Edit Candidate Info': {
		translation: 'Edit Candidate Info',
	},
	'Edit Category': {
		translation: 'Edit Category',
	},
	'Edit Change History Report': {
		translation: 'Edit Change History Report',
	},
	'Edit Comment': {
		translation: 'Edit Comment',
	},
	'Edit Company Info': {
		translation: 'Edit Company Info',
	},
	'Edit Coverage Option': {
		translation: 'Edit Coverage Option',
	},
	'Edit Custom Access Level': {
		translation: 'Edit Custom Access Level',
	},
	'Edit Custom Tag': {
		translation: 'Edit Custom Tag',
	},
	'Edit Deduction': {
		translation: 'Edit Deduction',
	},
	'Edit Dependent': {
		translation: 'Edit Dependent',
	},
	'Edit EEO Categories': {
		translation: 'Edit EEO Categories',
	},
	'Edit Eligibility': {
		translation: 'Edit Eligibility',
	},
	'Edit Email Template': {
		translation: 'Edit Email Template',
	},
	'Edit Employee Access Level': {
		translation: 'Edit Employee Access Level',
	},
	'Edit Employment Status': {
		translation: 'Edit Employment Status',
	},
	'Edit Enrollment': {
		translation: 'Edit Enrollment',
	},
	'Edit Fields': {
		translation: 'Edit Fields',
	},
	'Edit First Pay Date': {
		translation: 'Edit First Pay Date',
	},
	'Edit Goal': {
		translation: 'Edit Goal',
	},
	'Edit Group': {
		translation: 'Edit Group',
	},
	'Edit Holiday': {
		translation: 'Edit Holiday',
	},
	'Edit Hour Type Mapping': {
		translation: 'Edit Hour Type Mapping',
	},
	'Edit Hours Worked': {
		translation: 'Edit Hours Worked',
	},
	'Edit Job Opening': {
		translation: 'Edit Job Opening',
	},
	'Edit List Values': {
		translation: 'Edit List Values',
	},
	'Edit Location': {
		translation: 'Edit Location',
	},
	'Edit Manager Access Level': {
		translation: 'Edit Manager Access Level',
	},
	'Edit Mapping': {
		translation: 'Edit Mapping',
	},
	'Edit New Hire Packet': {
		translation: 'Edit New Hire Packet',
	},
	'Edit Non-Employee User': {
		translation: 'Edit Non-Employee User',
	},
	'Edit Not Eligible': {
		translation: 'Edit Not Eligible',
	},
	'Edit Offer': {
		translation: 'Edit Offer',
	},
	'Edit Offer Template': {
		translation: 'Edit Offer Template',
	},
	'Edit Packet': {
		translation: 'Edit Packet',
	},
	'Edit Past Time Off Requests': {
		translation: 'Edit Past Time Off Requests',
	},
	'Edit Pay Group': {
		translation: 'Edit Pay Group',
	},
	'Edit Pay Schedule': {
		translation: 'Edit Pay Schedule',
	},
	'Edit Payee': {
		translation: 'Edit Payee',
	},
	'Edit Payment Info': {
		translation: 'Edit Payment Info',
	},
	'Edit Payroll Admin Access Level': {
		translation: 'Edit Payroll Admin Access Level',
	},
	'Edit Payroll Non-Approver Access Level': {
		translation: 'Edit Payroll Non-Approver Access Level',
	},
	'Edit Payroll Reports Only Access Level': {
		translation: 'Edit Payroll Reports Only Access Level',
	},
	'Edit Photo': {
		translation: 'Edit Photo',
	},
	'Edit Plan': {
		translation: 'Edit Plan',
	},
	'Edit Plan for %1$s': {
		translation: 'Edit Plan for %1$s',
	},
	'Edit Plan for This Group': {
		translation: 'Edit Plan for This Group',
	},
	'Edit Point-In-Time Report': {
		translation: 'Edit Point-In-Time Report',
	},
	'Edit Project': {
		translation: 'Edit Project',
	},
	'Edit Question': {
		translation: 'Edit Question',
	},
	'Edit Report': {
		translation: 'Edit Report',
	},
	'Edit Salesforce Payroll Info ID': {
		translation: 'Edit Salesforce Payroll Info ID',
	},
	'Edit Signature Template': {
		translation: 'Edit Signature Template',
	},
	'Edit Subscription': {
		translation: 'Edit Subscription',
	},
	'Edit Tax Withholding': {
		translation: 'Edit Tax Withholding',
	},
	'Edit Terminate Coverage': {
		translation: 'Edit Terminate Coverage',
	},
	'Edit Time Off Request': {
		translation: 'Edit Time Off Request',
	},
	'Edit Training': {
		translation: 'Edit Training',
	},
	'Edit User': {
		translation: 'Edit User',
	},
	'Edit Value': {
		translation: 'Edit Value',
	},
	'Edit Waive': {
		translation: 'Edit Waive',
	},
	'Edit Webhook': {
		translation: 'Edit Webhook',
	},
	'Edit Withdraw': {
		translation: 'Edit Withdraw',
	},
	'Edit a Benefit Plan': {
		translation: 'Edit a Benefit Plan',
	},
	'Edit a Pay Schedule': {
		translation: 'Edit a Pay Schedule',
	},
	'Edit a dependent': {
		translation: 'Edit a dependent',
	},
	'Edit and save this report to remove this column from the report.': {
		translation:
			'Edit and save this report to remove this column from the report.',
	},
	'Edit announcement': {
		translation: 'Edit announcement',
	},
	'Edit my report': {
		translation: 'Edit my report',
	},
	'Edit or delete': {
		translation: 'Edit or delete',
	},
	'Edit pay date': {
		translation: 'Edit pay date',
	},
	'Edit settings': {
		translation: 'Edit settings',
	},
	'Edit this Report': {
		translation: 'Edit this Report',
	},
	'Edit, delete or add anything you need. Employment status is important for running reports on employees.':
		{
			translation:
				'Edit, delete or add anything you need. Employment status is important for running reports on employees.',
		},
	Edited: {
		translation: 'Edited',
	},
	'Editing Options': {
		translation: 'Editing Options',
	},
	'Editing Pay Group will also affect Benefit Groups. Unfortunately, you do not have permissions to change Benefit Groups. Please contact an administrator to make this change.':
		{
			translation:
				'Editing Pay Group will also affect Benefit Groups. Unfortunately, you do not have permissions to change Benefit Groups. Please contact an administrator to make this change.',
		},
	'Editing Pay Schedule will also affect Benefit Groups. Unfortunately, you do not have permissions to change Benefit Groups. Please contact an administrator to make this change.':
		{
			translation:
				'Editing Pay Schedule will also affect Benefit Groups. Unfortunately, you do not have permissions to change Benefit Groups. Please contact an administrator to make this change.',
		},
	Education: {
		translation: 'Education',
	},
	'Education History': {
		translation: 'Education History',
	},
	'Education Level': {
		translation: 'Education Level',
	},
	Effective: {
		translation: 'Effective',
	},
	'Effective Date': {
		translation: 'Effective Date',
	},
	'Effective date': {
		translation: 'Effective date',
	},
	'Effective date is not set.': {
		translation: 'Effective date is not set.',
	},
	'Effective date is outside the allowed range.': {
		translation: 'Effective date is outside the allowed range.',
	},
	'Effective date is required and must be in the format mm-dd-yyyy or mm/dd/yyyy.':
		{
			translation:
				'Effective date is required and must be in the format mm-dd-yyyy or mm/dd/yyyy.',
		},
	'Effective: %s': {
		translation: 'Effective: %s',
	},
	'Either SSN or EIN must have a value': {
		translation: 'Either SSN or EIN must have a value',
	},
	'Either the benefitPlanId or the deductionCode property must be set': {
		translation:
			'Either the benefitPlanId or the deductionCode property must be set',
	},
	'Either the benefitPlanId or the memoCode property must be set': {
		translation:
			'Either the benefitPlanId or the memoCode property must be set',
	},
	Eligibility: {
		translation: 'Eligibility',
	},
	'Eligibility Changes': {
		translation: 'Eligibility Changes',
	},
	'Eligibility Date': {
		translation: 'Eligibility Date',
	},
	'Eligibility and Cost': {
		translation: 'Eligibility and Cost',
	},
	'Eligibility date': {
		translation: 'Eligibility date',
	},
	'Eligibility rules for each benefit plan/group combination is required': {
		translation:
			'Eligibility rules for each benefit plan/group combination is required',
	},
	'Eligibility rules have been applied': {
		translation: 'Eligibility rules have been applied',
	},
	Eligible: {
		translation: 'Eligible',
	},
	'Eligible For Re-hire': {
		translation: 'Eligible For Re-hire',
	},
	'Eligible for %s': {
		translation: 'Eligible for %s',
	},
	'Eligible for %s on %s': {
		translation: 'Eligible for %s on %s',
	},
	'Eligible for Bonus': {
		translation: 'Eligible for Bonus',
	},
	'Eligible for Rehire': {
		translation: 'Eligible for Rehire',
	},
	'Eligible to accrue %1$s day annually': {
		translation: {
			one: 'Eligible to accrue %1$s day annually',
			other: 'Eligible to accrue %1$s days annually',
		},
	},
	'Eligible to accrue %1$s day bi-weekly': {
		translation: {
			one: 'Eligible to accrue %1$s day bi-weekly',
			other: 'Eligible to accrue %1$s days bi-weekly',
		},
	},
	'Eligible to accrue %1$s day daily': {
		translation: {
			one: 'Eligible to accrue %1$s day daily',
			other: 'Eligible to accrue %1$s days daily',
		},
	},
	'Eligible to accrue %1$s day hourly': {
		translation: {
			one: 'Eligible to accrue %1$s day hourly',
			other: 'Eligible to accrue %1$s days hourly',
		},
	},
	'Eligible to accrue %1$s day monthly': {
		translation: {
			one: 'Eligible to accrue %1$s day monthly',
			other: 'Eligible to accrue %1$s days monthly',
		},
	},
	'Eligible to accrue %1$s day on your anniversary': {
		translation: {
			one: 'Eligible to accrue %1$s day on your anniversary',
			other: 'Eligible to accrue %1$s days on your anniversary',
		},
	},
	'Eligible to accrue %1$s day quarterly': {
		translation: {
			one: 'Eligible to accrue %1$s day quarterly',
			other: 'Eligible to accrue %1$s days quarterly',
		},
	},
	'Eligible to accrue %1$s day semi-annually': {
		translation: {
			one: 'Eligible to accrue %1$s day semi-annually',
			other: 'Eligible to accrue %1$s days semi-annually',
		},
	},
	'Eligible to accrue %1$s day semi-monthly': {
		translation: {
			one: 'Eligible to accrue %1$s day semi-monthly',
			other: 'Eligible to accrue %1$s days semi-monthly',
		},
	},
	'Eligible to accrue %1$s day weekly': {
		translation: {
			one: 'Eligible to accrue %1$s day weekly',
			other: 'Eligible to accrue %1$s days weekly',
		},
	},
	'Eligible to accrue %1$s hour annually': {
		translation: {
			one: 'Eligible to accrue %1$s hour annually',
			other: 'Eligible to accrue %1$s hours annually',
		},
	},
	'Eligible to accrue %1$s hour bi-weekly': {
		translation: {
			one: 'Eligible to accrue %1$s hour bi-weekly',
			other: 'Eligible to accrue %1$s hours bi-weekly',
		},
	},
	'Eligible to accrue %1$s hour daily': {
		translation: {
			one: 'Eligible to accrue %1$s hour daily',
			other: 'Eligible to accrue %1$s hours daily',
		},
	},
	'Eligible to accrue %1$s hour hourly': {
		translation: {
			one: 'Eligible to accrue %1$s hour hourly',
			other: 'Eligible to accrue %1$s hours hourly',
		},
	},
	'Eligible to accrue %1$s hour monthly': {
		translation: {
			one: 'Eligible to accrue %1$s hour monthly',
			other: 'Eligible to accrue %1$s hours monthly',
		},
	},
	'Eligible to accrue %1$s hour on your anniversary': {
		translation: {
			one: 'Eligible to accrue %1$s hour on your anniversary',
			other: 'Eligible to accrue %1$s hours on your anniversary',
		},
	},
	'Eligible to accrue %1$s hour quarterly': {
		translation: {
			one: 'Eligible to accrue %1$s hour quarterly',
			other: 'Eligible to accrue %1$s hours quarterly',
		},
	},
	'Eligible to accrue %1$s hour semi-annually': {
		translation: {
			one: 'Eligible to accrue %1$s hour semi-annually',
			other: 'Eligible to accrue %1$s hours semi-annually',
		},
	},
	'Eligible to accrue %1$s hour semi-monthly': {
		translation: {
			one: 'Eligible to accrue %1$s hour semi-monthly',
			other: 'Eligible to accrue %1$s hours semi-monthly',
		},
	},
	'Eligible to accrue %1$s hour weekly': {
		translation: {
			one: 'Eligible to accrue %1$s hour weekly',
			other: 'Eligible to accrue %1$s hours weekly',
		},
	},
	'Em. Record, Files, Reports Only': {
		translation: 'Em. Record, Files, Reports Only',
	},
	Email: {
		translation: 'Email',
	},
	'Email %s': {
		translation: 'Email %s',
	},
	'Email Address': {
		translation: 'Email Address',
	},
	'Email Address (this is entered into the Home Email field of BambooHR)': {
		translation:
			'Email Address (this is entered into the Home Email field of BambooHR)',
	},
	'Email Alerts': {
		translation: 'Email Alerts',
	},
	'Email Attachment': {
		translation: 'Email Attachment',
	},
	'Email COMPAS at support@mycompas.com or calling (888) 552-6672. See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831877-How-does-COMPAS-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'Email COMPAS at support@mycompas.com or calling (888) 552-6672. See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831877-How-does-COMPAS-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'Email Me a New Link': {
		translation: 'Email Me a New Link',
	},
	'Email Message': {
		translation: 'Email Message',
	},
	'Email Message...': {
		translation: 'Email Message...',
	},
	'Email Not Delivered': {
		translation: 'Email Not Delivered',
	},
	'Email Notifications': {
		translation: 'Email Notifications',
	},
	'Email Okta support at <a href="mailto:support@okta.com">support@okta.com</a>':
		{
			translation:
				'Email Okta support at <a href=\\"mailto:support@okta.com\\">support@okta.com</a>',
		},
	'Email Placeholders': {
		translation: 'Email Placeholders',
	},
	'Email Preview': {
		translation: 'Email Preview',
	},
	'Email Reply Window Expired': {
		translation: 'Email Reply Window Expired',
	},
	'Email Report': {
		translation: 'Email Report',
	},
	'Email Secure Download Link': {
		translation: 'Email Secure Download Link',
	},
	'Email Secure Link': {
		translation: 'Email Secure Link',
	},
	'Email Sent': {
		translation: 'Email Sent',
	},
	'Email Subject': {
		translation: 'Email Subject',
	},
	'Email Subject and Message': {
		translation: 'Email Subject and Message',
	},
	'Email Subject...': {
		translation: 'Email Subject...',
	},
	'Email Template': {
		translation: 'Email Template',
	},
	'Email Templates': {
		translation: 'Email Templates',
	},
	'Email This File': {
		translation: 'Email This File',
	},
	'Email address of the user who authorized the application': {
		translation: 'Email address of the user who authorized the application',
	},
	'Email has already been sent to one or more candidates.': {
		translation: 'Email has already been sent to one or more candidates.',
	},
	'Email message is too long.': {
		translation: 'Email message is too long.',
	},
	'Email our billing department at %1$s to update your payment method.': {
		translation:
			'Email our billing department at %1$s to update your payment method.',
	},
	'Email report with current filters applied': {
		translation: 'Email report with current filters applied',
	},
	'Email us at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a> or call 1-866-387-9595.':
		{
			translation:
				'Email us at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a> or call 1-866-387-9595.',
		},
	'Email us at <a href="mailto:support@greenhouse.io">support@greenhouse.io</a>, or check out our <a href="https://greenhouse.zendesk.com/hc/en-us/articles/207987266-Greenhouse-Onboarding-BambooHR">Help Article</a>.':
		{
			translation:
				'Email us at <a href=\\"mailto:support@greenhouse.io\\">support@greenhouse.io</a>, or check out our <a href=\\"https://greenhouse.zendesk.com/hc/en-us/articles/207987266-Greenhouse-Onboarding-BambooHR\\">Help Article</a>.',
		},
	'Email us at support@bamboohr.com or call 1-866-387-9595.': {
		translation: 'Email us at support@bamboohr.com or call 1-866-387-9595.',
	},
	'Emailed reports are sent exactly as you see them. Be wise when choosing your recipients. Also, for privacy reasons, SSN will be removed from any emailed reports.':
		{
			translation:
				'Emailed reports are sent exactly as you see them. Be wise when choosing your recipients. Also, for privacy reasons, SSN will be removed from any emailed reports.',
		},
	'Emailing is disabled while in trial.': {
		translation: 'Emailing is disabled while in trial.',
	},
	'Emailing is disabled while you are in a trial account.': {
		translation: 'Emailing is disabled while you are in a trial account.',
	},
	Emails: {
		translation: 'Emails',
	},
	'Emails were not updated': {
		translation: 'Emails were not updated',
	},
	'Emails were updated': {
		translation: 'Emails were updated',
	},
	'Emails will be sent to notify the appropriate people when an item is waiting for their review.':
		{
			translation:
				'Emails will be sent to notify the appropriate people when an item is waiting for their review.',
		},
	Emergency: {
		translation: 'Emergency',
	},
	'Emergency Contact': {
		translation: 'Emergency Contact',
	},
	'Emergency Contact City': {
		translation: 'Emergency Contact City',
	},
	'Emergency Contact Country': {
		translation: 'Emergency Contact Country',
	},
	'Emergency Contact County': {
		translation: 'Emergency Contact County',
	},
	'Emergency Contact Email': {
		translation: 'Emergency Contact Email',
	},
	'Emergency Contact Home Phone': {
		translation: 'Emergency Contact Home Phone',
	},
	'Emergency Contact Mobile Phone': {
		translation: 'Emergency Contact Mobile Phone',
	},
	'Emergency Contact Name': {
		translation: 'Emergency Contact Name',
	},
	'Emergency Contact Name and Relationship': {
		translation: 'Emergency Contact Name and Relationship',
	},
	'Emergency Contact Post Code': {
		translation: 'Emergency Contact Post Code',
	},
	'Emergency Contact Postal Code': {
		translation: 'Emergency Contact Postal Code',
	},
	'Emergency Contact Primary': {
		translation: 'Emergency Contact Primary',
	},
	'Emergency Contact Province': {
		translation: 'Emergency Contact Province',
	},
	'Emergency Contact Relationship': {
		translation: 'Emergency Contact Relationship',
	},
	'Emergency Contact State': {
		translation: 'Emergency Contact State',
	},
	'Emergency Contact Street 1': {
		translation: 'Emergency Contact Street 1',
	},
	'Emergency Contact Street 2': {
		translation: 'Emergency Contact Street 2',
	},
	'Emergency Contact Work Ext': {
		translation: 'Emergency Contact Work Ext',
	},
	'Emergency Contact Work Phone': {
		translation: 'Emergency Contact Work Phone',
	},
	'Emergency Contact ZIP Code': {
		translation: 'Emergency Contact ZIP Code',
	},
	'Emergency Contacts': {
		translation: 'Emergency Contacts',
	},
	Employee: {
		translation: 'Employee',
	},
	'Employee #': {
		translation: 'Employee #',
	},
	'Employee # must be a number': {
		translation: 'Employee # must be a number',
	},
	'Employee # must be no more than 6 digits': {
		translation: 'Employee # must be no more than 6 digits',
	},
	'Employee # must be set': {
		translation: 'Employee # must be set',
	},
	'Employee # must not have leading zeros': {
		translation: 'Employee # must not have leading zeros',
	},
	'Employee #: ': {
		translation: 'Employee #: ',
	},
	'Employee + Child': {
		translation: 'Employee + Child',
	},
	'Employee + Children': {
		translation: 'Employee + Children',
	},
	'Employee + Family': {
		translation: 'Employee + Family',
	},
	'Employee + Spouse': {
		translation: 'Employee + Spouse',
	},
	'Employee Access Level': {
		translation: 'Employee Access Level',
	},
	'Employee Access Level Applied': {
		translation: 'Employee Access Level Applied',
	},
	'Employee Access Level could not be updated for Payroll Admins': {
		translation:
			'Employee Access Level could not be updated for Payroll Admins',
	},
	'Employee Access Level has been updated for Payroll Admins': {
		translation: 'Employee Access Level has been updated for Payroll Admins',
	},
	'Employee Access Levels': {
		translation: 'Employee Access Levels',
	},
	'Employee Access Levels can be configured to allow Employees to see, edit, or edit with approval their own information only.':
		{
			translation:
				'Employee Access Levels can be configured to allow Employees to see, edit, or edit with approval their own information only.',
		},
	'Employee Actions': {
		translation: 'Employee Actions',
	},
	'Employee Address': {
		translation: 'Employee Address',
	},
	'Employee Annual Max': {
		translation: 'Employee Annual Max',
	},
	'Employee Assessment': {
		translation: 'Employee Assessment',
	},
	'Employee Benefit Information': {
		translation: 'Employee Benefit Information',
	},
	'Employee Benefits': {
		translation: 'Employee Benefits',
	},
	'Employee COVID-19 Data': {
		translation: 'Employee COVID-19 Data',
	},
	'Employee Cap Amount': {
		translation: 'Employee Cap Amount',
	},
	'Employee Class Name': {
		translation: 'Employee Class Name',
	},
	'Employee Community': {
		translation: 'Employee Community',
	},
	'Employee Community service failed to complete the request': {
		translation: 'Employee Community service failed to complete the request',
	},
	'Employee Compensation': {
		translation: 'Employee Compensation',
	},
	'Employee Contact': {
		translation: 'Employee Contact',
	},
	'Employee Contacts and Emergency Contacts': {
		translation: 'Employee Contacts and Emergency Contacts',
	},
	'Employee Contribution': {
		translation: 'Employee Contribution',
	},
	'Employee Cost': {
		translation: 'Employee Cost',
	},
	'Employee Count': {
		translation: 'Employee Count',
	},
	'Employee Coverage Amount': {
		translation: 'Employee Coverage Amount',
	},
	'Employee Custom Fields': {
		translation: 'Employee Custom Fields',
	},
	'Employee Data Filter(s)': {
		translation: 'Employee Data Filter(s)',
	},
	'Employee Dependent Information': {
		translation: 'Employee Dependent Information',
	},
	'Employee Dependent SSN/SIN': {
		translation: 'Employee Dependent SSN/SIN',
	},
	'Employee Directory': {
		translation: 'Employee Directory',
	},
	'Employee Diversity': {
		translation: 'Employee Diversity',
	},
	'Employee Documents': {
		translation: 'Employee Documents',
	},
	'Employee Education': {
		translation: 'Employee Education',
	},
	'Employee Education Information': {
		translation: 'Employee Education Information',
	},
	'Employee Education: End Date': {
		translation: 'Employee Education: End Date',
	},
	'Employee Education: Start Date': {
		translation: 'Employee Education: Start Date',
	},
	'Employee Encrypted Custom Fields': {
		translation: 'Employee Encrypted Custom Fields',
	},
	'Employee Enrollment Status': {
		translation: 'Employee Enrollment Status',
	},
	'Employee Ethnicity': {
		translation: 'Employee Ethnicity',
	},
	'Employee Export File': {
		translation: 'Employee Export File',
	},
	'Employee Field': {
		translation: 'Employee Field',
	},
	'Employee Fields': {
		translation: 'Employee Fields',
	},
	'Employee Fields Settings': {
		translation: 'Employee Fields Settings',
	},
	'Employee Files': {
		translation: 'Employee Files',
	},
	'Employee Goal Tracking': {
		translation: 'Employee Goal Tracking',
	},
	'Employee Handbook Quiz': {
		translation: 'Employee Handbook Quiz',
	},
	'Employee Head Count': {
		translation: 'Employee Head Count',
	},
	'Employee ID': {
		translation: 'Employee ID',
	},
	'Employee ID is required.': {
		translation: 'Employee ID is required.',
	},
	'Employee ID of the user who authorized the application': {
		translation: 'Employee ID of the user who authorized the application',
	},
	"Employee Id of '%s' was not found in the Trax system.": {
		translation: "Employee Id of '%s' was not found in the Trax system.",
	},
	'Employee Identification': {
		translation: 'Employee Identification',
	},
	'Employee Info': {
		translation: 'Employee Info',
	},
	'Employee Information': {
		translation: 'Employee Information',
	},
	'Employee Job Information': {
		translation: 'Employee Job Information',
	},
	'Employee Job Title': {
		translation: 'Employee Job Title',
	},
	'Employee License Authority': {
		translation: 'Employee License Authority',
	},
	'Employee License Type': {
		translation: 'Employee License Type',
	},
	'Employee List': {
		translation: 'Employee List',
	},
	'Employee Menu': {
		translation: 'Employee Menu',
	},
	'Employee Monthly Max': {
		translation: 'Employee Monthly Max',
	},
	'Employee Name': {
		translation: 'Employee Name',
	},
	'Employee Name and Number': {
		translation: 'Employee Name and Number',
	},
	'Employee Net Promoter Score (eNPS) is a standard method companies use to measure employee satisfaction and engagement. BambooHR will automate the survey process for you to make it easy as pie. Watch the short video above to learn more, or visit our eNPS and employee satisfaction [course pages].':
		{
			translation:
				'Employee Net Promoter Score (eNPS) is a standard method companies use to measure employee satisfaction and engagement. BambooHR will automate the survey process for you to make it easy as pie. Watch the short video above to learn more, or visit our eNPS and employee satisfaction [course pages].',
		},
	'Employee Net Promoter Score%1SM%2 (eNPS) is a standard method companies use to measure employee satisfaction and engagement. BambooHR will automate the survey process for you to make it easy as pie. Watch the short video above to learn more, or %3read more about it%4.':
		{
			translation:
				'Employee Net Promoter Score%1SM%2 (eNPS) is a standard method companies use to measure employee satisfaction and engagement. BambooHR will automate the survey process for you to make it easy as pie. Watch the short video above to learn more, or %3read more about it%4.',
		},
	'Employee Not Found': {
		translation: 'Employee Not Found',
	},
	'Employee Number': {
		translation: 'Employee Number',
	},
	'Employee Number & Status': {
		translation: 'Employee Number & Status',
	},
	'Employee Number is required': {
		translation: 'Employee Number is required',
	},
	'Employee Number must be unique': {
		translation: 'Employee Number must be unique',
	},
	'Employee Number of Giver': {
		translation: 'Employee Number of Giver',
	},
	'Employee Number of Receiver': {
		translation: 'Employee Number of Receiver',
	},
	'Employee Offered Coverage': {
		translation: 'Employee Offered Coverage',
	},
	'Employee Paid': {
		translation: 'Employee Paid',
	},
	'Employee Pay Schedule must be selected.': {
		translation: 'Employee Pay Schedule must be selected.',
	},
	'Employee Payroll Information': {
		translation: 'Employee Payroll Information',
	},
	'Employee Payroll Providers': {
		translation: 'Employee Payroll Providers',
	},
	'Employee Payroll Sync has been updated': {
		translation: 'Employee Payroll Sync has been updated',
	},
	'Employee Pays': {
		translation: 'Employee Pays',
	},
	'Employee Pays %1$s': {
		translation: 'Employee Pays %1$s',
	},
	'Employee Pays %1$s %2$s. Company Pays %3$s %4$s effective %5$s.': {
		translation:
			'Employee Pays %1$s %2$s. Company Pays %3$s %4$s effective %5$s.',
	},
	'Employee Pays %1$s effective %2$s': {
		translation: 'Employee Pays %1$s effective %2$s',
	},
	'Employee Pays %1$s entered on %2$s and set to a start date of %3$s': {
		translation:
			'Employee Pays %1$s entered on %2$s and set to a start date of %3$s',
	},
	'Employee Pays (Old)': {
		translation: 'Employee Pays (Old)',
	},
	'Employee Pays (Updated)': {
		translation: 'Employee Pays (Updated)',
	},
	'Employee Pays Percent Type': {
		translation: 'Employee Pays Percent Type',
	},
	'Employee Pays Percent Type (Gross/Net)': {
		translation: 'Employee Pays Percent Type (Gross/Net)',
	},
	'Employee Pays changed from %1$s to %2$s': {
		translation: 'Employee Pays changed from %1$s to %2$s',
	},
	'Employee Pays changed from %1$s to %2$s %3$s. Company Pays changed from %4$s to %5$s %6$s.':
		{
			translation:
				'Employee Pays changed from %1$s to %2$s %3$s. Company Pays changed from %4$s to %5$s %6$s.',
		},
	'Employee Performance': {
		translation: 'Employee Performance',
	},
	'Employee Photo': {
		translation: 'Employee Photo',
	},
	'Employee Policy Training': {
		translation: 'Employee Policy Training',
	},
	'Employee Project Allocation': {
		translation: 'Employee Project Allocation',
	},
	'Employee Project Hours': {
		translation: 'Employee Project Hours',
	},
	'Employee Providers': {
		translation: 'Employee Providers',
	},
	'Employee Question': {
		translation: 'Employee Question',
	},
	'Employee Rate': {
		translation: 'Employee Rate',
	},
	'Employee Record': {
		translation: 'Employee Record',
	},
	'Employee SSN': {
		translation: 'Employee SSN',
	},
	'Employee SSN, SIN, Birthday': {
		translation: 'Employee SSN, SIN, Birthday',
	},
	'Employee Said': {
		translation: 'Employee Said',
	},
	'Employee Satisfaction': {
		translation: 'Employee Satisfaction',
	},
	'Employee Satisfaction (eNPS®)': {
		translation: 'Employee Satisfaction (eNPS®)',
	},
	'Employee Satisfaction Introduction Email': {
		translation: 'Employee Satisfaction Introduction Email',
	},
	'Employee Satisfaction Survey Email': {
		translation: 'Employee Satisfaction Survey Email',
	},
	'Employee Satisfaction Survey Email will be sent to all employees on the first business day after  %1.':
		{
			translation:
				'Employee Satisfaction Survey Email will be sent to all employees on the first business day after  %1.',
		},
	'Employee Satisfaction Up To Speed Video': {
		translation: 'Employee Satisfaction Up To Speed Video',
	},
	'Employee Signature': {
		translation: 'Employee Signature',
	},
	'Employee Signature Date': {
		translation: 'Employee Signature Date',
	},
	'Employee Status': {
		translation: 'Employee Status',
	},
	'Employee Suggestions': {
		translation: 'Employee Suggestions',
	},
	'Employee Tasks': {
		translation: 'Employee Tasks',
	},
	'Employee Tax State': {
		translation: 'Employee Tax State',
	},
	'Employee Tax States': {
		translation: 'Employee Tax States',
	},
	'Employee Tax Type': {
		translation: 'Employee Tax Type',
	},
	'Employee Taxes': {
		translation: 'Employee Taxes',
	},
	'Employee Team list not found': {
		translation: 'Employee Team list not found',
	},
	'Employee Terminated': {
		translation: 'Employee Terminated',
	},
	'Employee Time Off History Item Object Not Found': {
		translation: 'Employee Time Off History Item Object Not Found',
	},
	'Employee Time Off Information': {
		translation: 'Employee Time Off Information',
	},
	'Employee Training Status Notes': {
		translation: 'Employee Training Status Notes',
	},
	'Employee Turnover': {
		translation: 'Employee Turnover',
	},
	'Employee Turnover Report': {
		translation: 'Employee Turnover Report',
	},
	'Employee Turnover Report Tab': {
		translation: 'Employee Turnover Report Tab',
	},
	'Employee Updates': {
		translation: 'Employee Updates',
	},
	'Employee View': {
		translation: 'Employee View',
	},
	'Employee Wellbeing': {
		translation: 'Employee Wellbeing',
	},
	'Employee Wellbeing is not enabled.': {
		translation: 'Employee Wellbeing is not enabled.',
	},
	'Employee accrues for part of the period': {
		translation: 'Employee accrues for part of the period',
	},
	'Employee already has this policy': {
		translation: 'Employee already has this policy',
	},
	'Employee anniversaries': {
		translation: 'Employee anniversaries',
	},
	'Employee anniversary for %1$s': {
		translation: 'Employee anniversary for %1$s',
	},
	'Employee benefit updated': {
		translation: 'Employee benefit updated',
	},
	'Employee benefit waived': {
		translation: 'Employee benefit waived',
	},
	'Employee cannot be found - no employee number': {
		translation: 'Employee cannot be found - no employee number',
	},
	'Employee created successfully, but the selected payroll provider could not be found.':
		{
			translation:
				'Employee created successfully, but the selected payroll provider could not be found.',
		},
	'Employee created successfully, but there was an issue with payroll provider setup.':
		{
			translation:
				'Employee created successfully, but there was an issue with payroll provider setup.',
		},
	'Employee deduction amount changed from %1$s to %2$s entered on %3$s and set to a start date of %4$s':
		{
			translation:
				'Employee deduction amount changed from %1$s to %2$s entered on %3$s and set to a start date of %4$s',
		},
	'Employee direct deposit account data cleared': {
		translation: 'Employee direct deposit account data cleared',
	},
	'Employee disability': {
		translation: 'Employee disability',
	},
	'Employee email': {
		translation: 'Employee email',
	},
	'Employee gained eligibility for Medicaid/CHIP': {
		translation: 'Employee gained eligibility for Medicaid/CHIP',
	},
	'Employee gained eligibility for Medicare': {
		translation: 'Employee gained eligibility for Medicare',
	},
	'Employee gained outside health coverage': {
		translation: 'Employee gained outside health coverage',
	},
	'Employee gets the full amount of PTO for the accrual period': {
		translation: 'Employee gets the full amount of PTO for the accrual period',
	},
	'Employee has an invalid timezone setup': {
		translation: 'Employee has an invalid timezone setup',
	},
	'Employee hire date': {
		translation: 'Employee hire date',
	},
	'Employee hire date is not set': {
		translation: 'Employee hire date is not set',
	},
	'Employee id': {
		translation: 'Employee id',
	},
	"Employee information in BambooHR can be imported into Advantage Payroll's Instant Payroll system by entering a BambooHR API Key and subdomain into Instant Payroll and then running the Employee Import wizard.":
		{
			translation:
				"Employee information in BambooHR can be imported into Advantage Payroll's Instant Payroll system by entering a BambooHR API Key and subdomain into Instant Payroll and then running the Employee Import wizard.",
		},
	'Employee is exempt from federal taxes': {
		translation: 'Employee is exempt from federal taxes',
	},
	'Employee is not assigned to the specified category': {
		translation: 'Employee is not assigned to the specified category',
	},
	'Employee is not assigned to the specified category.': {
		translation: 'Employee is not assigned to the specified category.',
	},
	'Employee is not enrolled in Benefits Administration': {
		translation: 'Employee is not enrolled in Benefits Administration',
	},
	'Employee lost eligibility for Medicaid/CHIP': {
		translation: 'Employee lost eligibility for Medicaid/CHIP',
	},
	'Employee lost outside health coverage': {
		translation: 'Employee lost outside health coverage',
	},
	'Employee marked as eligible for benefit': {
		translation: 'Employee marked as eligible for benefit',
	},
	'Employee marked as not eligible for benefit': {
		translation: 'Employee marked as not eligible for benefit',
	},
	'Employee moved to a different ZIP or county': {
		translation: 'Employee moved to a different ZIP or county',
	},
	'Employee moved to or from school': {
		translation: 'Employee moved to or from school',
	},
	'Employee moved to or from seasonal work location': {
		translation: 'Employee moved to or from seasonal work location',
	},
	'Employee moved to or from shelter or transitional housing': {
		translation: 'Employee moved to or from shelter or transitional housing',
	},
	'Employee not found': {
		translation: 'Employee not found',
	},
	'Employee not found.': {
		translation: 'Employee not found.',
	},
	'Employee not included': {
		translation: 'Employee not included',
	},
	'Employee not included in payroll': {
		translation: 'Employee not included in payroll',
	},
	'Employee not specified.': {
		translation: 'Employee not specified.',
	},
	'Employee number is required and may not be blank': {
		translation: 'Employee number is required and may not be blank',
	},
	'Employee number may not be left blank': {
		translation: 'Employee number may not be left blank',
	},
	'Employee number must be a number and may only contain digits': {
		translation: 'Employee number must be a number and may only contain digits',
	},
	'Employee number must be six digits or fewer': {
		translation: 'Employee number must be six digits or fewer',
	},
	'Employee number must be six digits or less': {
		translation: 'Employee number must be six digits or less',
	},
	'Employee number must not have a leading zero': {
		translation: 'Employee number must not have a leading zero',
	},
	'Employee number must not have leading zeros': {
		translation: 'Employee number must not have leading zeros',
	},
	'Employee number must only be numeric': {
		translation: 'Employee number must only be numeric',
	},
	'Employee number not found': {
		translation: 'Employee number not found',
	},
	'Employee pay stub deleted': {
		translation: 'Employee pay stub deleted',
	},
	'Employee pays': {
		translation: 'Employee pays',
	},
	'Employee pays ($ or %)': {
		translation: 'Employee pays ($ or %)',
	},
	'Employee pays - Currency code': {
		translation: 'Employee pays - Currency code',
	},
	'Employee pays deduction updated.': {
		translation: 'Employee pays deduction updated.',
	},
	'Employee pays monthly': {
		translation: 'Employee pays monthly',
	},
	'Employee photo': {
		translation: 'Employee photo',
	},
	'Employee photo exists': {
		translation: 'Employee photo exists',
	},
	'Employee photo version': {
		translation: 'Employee photo version',
	},
	'Employee referral': {
		translation: 'Employee referral',
	},
	'Employee successfully deleted from BambooHR, however...': {
		translation: 'Employee successfully deleted from BambooHR, however...',
	},
	'Employee tax withholding data cleared': {
		translation: 'Employee tax withholding data cleared',
	},
	'Employee timesheets will start and end as defined by your pay period.': {
		translation:
			'Employee timesheets will start and end as defined by your pay period.',
	},
	'Employee unpaid pay stubs deleted': {
		translation: 'Employee unpaid pay stubs deleted',
	},
	'Employee with the ID: %1$d does not exist': {
		translation: 'Employee with the ID: %1$d does not exist',
	},
	"Employee's Manager": {
		translation: "Employee's Manager",
	},
	"Employee's answer will go here.": {
		translation: "Employee's answer will go here.",
	},
	"Employee's department is not valid for employee’s pay schedule.": {
		translation:
			"Employee's department is not valid for employee’s pay schedule.",
	},
	"Employee's division is not valid for employee’s pay schedule.": {
		translation:
			"Employee's division is not valid for employee’s pay schedule.",
	},
	"Employee's location country is not valid for employee’s pay schedule.": {
		translation:
			"Employee's location country is not valid for employee’s pay schedule.",
	},
	"Employee's location is not valid for employee’s pay schedule.": {
		translation:
			"Employee's location is not valid for employee’s pay schedule.",
	},
	"Employee's location state is not valid for employee’s pay schedule.": {
		translation:
			"Employee's location state is not valid for employee’s pay schedule.",
	},
	"Employee's location zipcode is not valid for employee’s pay schedule.": {
		translation:
			"Employee's location zipcode is not valid for employee’s pay schedule.",
	},
	'Employee/Manager note cannot be longer than 800 characters!': {
		translation: 'Employee/Manager note cannot be longer than 800 characters!',
	},
	EmployeeMap: {
		translation: 'EmployeeMap',
	},
	Employees: {
		translation: 'Employees',
	},
	'Employees Assigned to %1': {
		translation: 'Employees Assigned to %1',
	},
	'Employees Excluded from Payroll': {
		translation: 'Employees Excluded from Payroll',
	},
	'Employees Icon': {
		translation: 'Employees Icon',
	},
	'Employees Included in Payroll': {
		translation: 'Employees Included in Payroll',
	},
	'Employees Offered Coverage': {
		translation: 'Employees Offered Coverage',
	},
	'Employees Tracking Time': {
		translation: 'Employees Tracking Time',
	},
	'Employees are given the opportunity to evaluate themselves, and managers are prompted to evaluate their direct reports each review period.':
		{
			translation:
				'Employees are given the opportunity to evaluate themselves, and managers are prompted to evaluate their direct reports each review period.',
		},
	'Employees assigned to time off policy': {
		translation: 'Employees assigned to time off policy',
	},
	'Employees can easily open, sign and automatically return documentation electronically (stored in both BambooHR and RightSignature)':
		{
			translation:
				'Employees can easily open, sign and automatically return documentation electronically (stored in both BambooHR and RightSignature)',
		},
	'Employees can log time with the [BambooHR mobile app](1).': {
		translation: 'Employees can log time with the [BambooHR mobile app](1).',
	},
	'Employees can select Non-binary for gender, and add pronoun and identity information':
		{
			translation:
				'Employees can select Non-binary for gender, and add pronoun and identity information',
		},
	'Employees can select Non-binary for gender, and add pronoun and identity information.':
		{
			translation:
				'Employees can select Non-binary for gender, and add pronoun and identity information.',
		},
	'Employees can start creating goals immediately after you save.': {
		translation:
			'Employees can start creating goals immediately after you save.',
	},
	"Employees can't be enrolled in two %1 plans at the same time.": {
		translation:
			"Employees can't be enrolled in two %1 plans at the same time.",
	},
	'Employees enter a single time amount for the entire day. E.g. 7h 30m': {
		translation:
			'Employees enter a single time amount for the entire day. E.g. 7h 30m',
	},
	'Employees enter start times and end times to track hours throughout the day.':
		{
			translation:
				'Employees enter start times and end times to track hours throughout the day.',
		},
	'Employees in %1 (%2)': {
		translation: 'Employees in %1 (%2)',
	},
	'Employees in %1$s Pay Schedule (%2$s)': {
		translation: 'Employees in %1$s Pay Schedule (%2$s)',
	},
	'Employees in pay schedule': {
		translation: 'Employees in pay schedule',
	},
	'Employees listed here will receive paper checks': {
		translation: 'Employees listed here will receive paper checks',
	},
	'Employees must have at least one employment status.': {
		translation: 'Employees must have at least one employment status.',
	},
	'Employees need friendship, comradery, and trust to thrive.': {
		translation: 'Employees need friendship, comradery, and trust to thrive.',
	},
	'Employees paid by %1$s cannot be added to Pay Schedules included in BambooHR Payroll.':
		{
			translation:
				'Employees paid by %1$s cannot be added to Pay Schedules included in BambooHR Payroll.',
		},
	'Employees receive time off at the beginning of the accrual period': {
		translation:
			'Employees receive time off at the beginning of the accrual period',
	},
	'Employees receive time off at the end of the accrual period': {
		translation: 'Employees receive time off at the end of the accrual period',
	},
	'Employees that need Direct Deposit info': {
		translation: 'Employees that need Direct Deposit info',
	},
	'Employees that respond {1} are labeled *{2}*': {
		translation: 'Employees that respond {1} are labeled *{2}*',
	},
	'Employees will no longer be able to log time to this project and any time already logged will no longer be included in reports.':
		{
			translation:
				'Employees will no longer be able to log time to this project and any time already logged will no longer be included in reports.',
		},
	'Employees will no longer have assessments, feedback or goals in their profile pages. Any current assessments or feedback requests will be cancelled. Re-enable performance any time you wish. To completely unsubscribe, contact your customer service representative.':
		{
			translation:
				'Employees will no longer have assessments, feedback or goals in their profile pages. Any current assessments or feedback requests will be cancelled. Re-enable performance any time you wish. To completely unsubscribe, contact your customer service representative.',
		},
	'Employees will then have an ACA status by virtue of their employment status.':
		{
			translation:
				'Employees will then have an ACA status by virtue of their employment status.',
		},
	'Employees will track their start time and end times. E.g 8AM - 5PM, 1PM - 5PM, etc.':
		{
			translation:
				'Employees will track their start time and end times. E.g 8AM - 5PM, 1PM - 5PM, etc.',
		},
	'Employees will track their total hours worked per shift, day, project, etc. E.g. 4h 30m, 8h 00m, etc.':
		{
			translation:
				'Employees will track their total hours worked per shift, day, project, etc. E.g. 4h 30m, 8h 00m, etc.',
		},
	'Employees with No Manager': {
		translation: 'Employees with No Manager',
	},
	'Employees with Status Mismatch': {
		translation: 'Employees with Status Mismatch',
	},
	'Employees with pending signatures': {
		translation: 'Employees with pending signatures',
	},
	'Employees with this level have <strong>no access</strong> to BambooHR and are unable to login.':
		{
			translation:
				'Employees with this level have <strong>no access</strong> to BambooHR and are unable to login.',
		},
	'Employees with this level have no access to BambooHR and are unable to login.':
		{
			translation:
				'Employees with this level have no access to BambooHR and are unable to login.',
		},
	'Employees without a Pay Group': {
		translation: 'Employees without a Pay Group',
	},
	'Employees without a manager will not show on the org chart, with the exception of a single top level person (e.g. CEO).':
		{
			translation:
				'Employees without a manager will not show on the org chart, with the exception of a single top level person (e.g. CEO).',
		},
	'Employees without an assigned department': {
		translation: 'Employees without an assigned department',
	},
	'Employees without an assigned division': {
		translation: 'Employees without an assigned division',
	},
	'Employees without an assigned location': {
		translation: 'Employees without an assigned location',
	},
	'Employees without hire dates are included in this report.': {
		translation: 'Employees without hire dates are included in this report.',
	},
	'Employees without managers cannot receive feedback.': {
		translation: 'Employees without managers cannot receive feedback.',
	},
	'Employees’ ACA Status will be set to “Yes” unless they have been working at your company for fewer than 90 days, in which case it will be set to “Non-Assessment.“':
		{
			translation:
				'Employees’ ACA Status will be set to “Yes” unless they have been working at your company for fewer than 90 days, in which case it will be set to “Non-Assessment.“',
		},
	'Employee’s Manager': {
		translation: 'Employee’s Manager',
	},
	Employer: {
		translation: 'Employer',
	},
	'Employer Identification #': {
		translation: 'Employer Identification #',
	},
	'Employer Info': {
		translation: 'Employer Info',
	},
	'Employer Information Report EEO-1': {
		translation: 'Employer Information Report EEO-1',
	},
	'Employer Pays': {
		translation: 'Employer Pays',
	},
	'Employer Rate': {
		translation: 'Employer Rate',
	},
	'Employer Taxes': {
		translation: 'Employer Taxes',
	},
	'Employment (last 5 yrs.)': {
		translation: 'Employment (last 5 yrs.)',
	},
	'Employment Eligibility Verification': {
		translation: 'Employment Eligibility Verification',
	},
	'Employment Status': {
		translation: 'Employment Status',
	},
	"Employment Status '%1$s' not found": {
		translation: "Employment Status '%1$s' not found",
	},
	'Employment Status (Effective Date)': {
		translation: 'Employment Status (Effective Date)',
	},
	'Employment Status Bar Chart': {
		translation: 'Employment Status Bar Chart',
	},
	'Employment Status Donut Chart': {
		translation: 'Employment Status Donut Chart',
	},
	'Employment Status Effective Date cannot be empty': {
		translation: 'Employment Status Effective Date cannot be empty',
	},
	'Employment Status Effective Date is required': {
		translation: 'Employment Status Effective Date is required',
	},
	'Employment Status History': {
		translation: 'Employment Status History',
	},
	'Employment Status History Report': {
		translation: 'Employment Status History Report',
	},
	'Employment Status cannot be empty': {
		translation: 'Employment Status cannot be empty',
	},
	'Employment Status is required': {
		translation: 'Employment Status is required',
	},
	'Employment Status is required on New Employees': {
		translation: 'Employment Status is required on New Employees',
	},
	'Employment Status: ACA Full-Time': {
		translation: 'Employment Status: ACA Full-Time',
	},
	'Employment Status: Date': {
		translation: 'Employment Status: Date',
	},
	'Employment Statuses': {
		translation: 'Employment Statuses',
	},
	'Employment Term': {
		translation: 'Employment Term',
	},
	'Employment Type': {
		translation: 'Employment Type',
	},
	'Employment Type was added successfully': {
		translation: 'Employment Type was added successfully',
	},
	'Employment Verification': {
		translation: 'Employment Verification',
	},
	'Employment anniversaries for %1$s': {
		translation: 'Employment anniversaries for %1$s',
	},
	'Employment end date': {
		translation: 'Employment end date',
	},
	'Employment start date': {
		translation: 'Employment start date',
	},
	'Employment status': {
		translation: 'Employment status',
	},
	'Employment status comments': {
		translation: 'Employment status comments',
	},
	'Employment status is empty or cannot be found.': {
		translation: 'Employment status is empty or cannot be found.',
	},
	'Employment status is empty or cannot be found. ': {
		translation: 'Employment status is empty or cannot be found. ',
	},
	'Employment status is not set': {
		translation: 'Employment status is not set',
	},
	'Empty or bad XML in employee tag': {
		translation: 'Empty or bad XML in employee tag',
	},
	Enable: {
		translation: 'Enable',
	},
	'Enable ACA Tracking': {
		translation: 'Enable ACA Tracking',
	},
	'Enable Access': {
		translation: 'Enable Access',
	},
	'Enable Approval': {
		translation: 'Enable Approval',
	},
	'Enable Benefits Administration': {
		translation: 'Enable Benefits Administration',
	},
	'Enable Cron': {
		translation: 'Enable Cron',
	},
	'Enable Feedback': {
		translation: 'Enable Feedback',
	},
	'Enable Netsuite Integration': {
		translation: 'Enable Netsuite Integration',
	},
	'Enable New User': {
		translation: 'Enable New User',
	},
	'Enable Now': {
		translation: 'Enable Now',
	},
	'Enable Peer Feedback': {
		translation: 'Enable Peer Feedback',
	},
	'Enable Performance Management in BambooHR for...': {
		translation: 'Enable Performance Management in BambooHR for...',
	},
	'Enable Self & Manager Assessments': {
		translation: 'Enable Self & Manager Assessments',
	},
	'Enable Sync to Cornerstone': {
		translation: 'Enable Sync to Cornerstone',
	},
	'Enable Time Clock': {
		translation: 'Enable Time Clock',
	},
	'Enable Time Tracking': {
		translation: 'Enable Time Tracking',
	},
	'Enable Time Tracking in Your Trial Account': {
		translation: 'Enable Time Tracking in Your Trial Account',
	},
	'Enable Time Tracking?': {
		translation: 'Enable Time Tracking?',
	},
	'Enable this approval to edit it or to be able to request a change using this approval workflow.':
		{
			translation:
				'Enable this approval to edit it or to be able to request a change using this approval workflow.',
		},
	"Enable to calculate overtime based on employee's %1shome address state%2s.":
		{
			translation:
				"Enable to calculate overtime based on employee's %1shome address state%2s.",
		},
	'Enable tracking to gain access to:': {
		translation: 'Enable tracking to gain access to:',
	},
	'Enable/Disable Time Tracking for all Employees': {
		translation: 'Enable/Disable Time Tracking for all Employees',
	},
	Enabled: {
		translation: 'Enabled',
	},
	'Enabled On': {
		translation: 'Enabled On',
	},
	'Enabling Google Single Sign-on makes it easy for employees to access their BambooHR account using their existing Google accounts login.':
		{
			translation:
				'Enabling Google Single Sign-on makes it easy for employees to access their BambooHR account using their existing Google accounts login.',
		},
	'Enabling Microsoft Single Sign-on makes it easy for employees to access their BambooHR account using their existing Microsoft accounts login.':
		{
			translation:
				'Enabling Microsoft Single Sign-on makes it easy for employees to access their BambooHR account using their existing Microsoft accounts login.',
		},
	'Enabling QuickBooks Online Payroll Single Sign-on makes it easy for employees to access their BambooHR account using their existing QuickBooks account login.':
		{
			translation:
				'Enabling QuickBooks Online Payroll Single Sign-on makes it easy for employees to access their BambooHR account using their existing QuickBooks account login.',
		},
	'Encountered an error while rendering the pdf.': {
		translation: 'Encountered an error while rendering the pdf.',
	},
	'Encrypted PDFs are not allowed.': {
		translation: 'Encrypted PDFs are not allowed.',
	},
	End: {
		translation: 'End',
	},
	'End Date': {
		translation: 'End Date',
	},
	'End Domestic Partnership': {
		translation: 'End Domestic Partnership',
	},
	'End Employment': {
		translation: 'End Employment',
	},
	'End Employments': {
		translation: 'End Employments',
	},
	'End Tax': {
		translation: 'End Tax',
	},
	'End Tax “%1$s” as of the date below.': {
		translation: 'End Tax “%1$s” as of the date below.',
	},
	'End Time': {
		translation: 'End Time',
	},
	'End date': {
		translation: 'End date',
	},
	'End date must be after start date.': {
		translation: 'End date must be after start date.',
	},
	'End date must be in the format mm-dd-yyyy or mm/dd/yyyy.': {
		translation: 'End date must be in the format mm-dd-yyyy or mm/dd/yyyy.',
	},
	'End of 1st Quarter': {
		translation: 'End of 1st Quarter',
	},
	'End of 2nd Quarter': {
		translation: 'End of 2nd Quarter',
	},
	'End of 3rd Quarter': {
		translation: 'End of 3rd Quarter',
	},
	'End of Current Quarter': {
		translation: 'End of Current Quarter',
	},
	'End of Season': {
		translation: 'End of Season',
	},
	'End of Year': {
		translation: 'End of Year',
	},
	'End of period': {
		translation: 'End of period',
	},
	'End on...': {
		translation: 'End on...',
	},
	'Ended %1$s': {
		translation: 'Ended %1$s',
	},
	Ending: {
		translation: 'Ending',
	},
	'Ending Balance': {
		translation: 'Ending Balance',
	},
	'Ending Balance (Days)': {
		translation: 'Ending Balance (Days)',
	},
	'Ending Balance (Hours)': {
		translation: 'Ending Balance (Hours)',
	},
	'Ends %1$s': {
		translation: 'Ends %1$s',
	},
	'Enforcing SSO for everyone in your company is strongly recommended.': {
		translation:
			'Enforcing SSO for everyone in your company is strongly recommended.',
	},
	Engaged: {
		translation: 'Engaged',
	},
	Engagement: {
		translation: 'Engagement',
	},
	'Enhance your BambooHR experience and connect with some of our exceptional technology partners. Some apps can be installed below.':
		{
			translation:
				'Enhance your BambooHR experience and connect with some of our exceptional technology partners. Some apps can be installed below.',
		},
	'Enjoy the rest of your day': {
		translation: 'Enjoy the rest of your day',
	},
	"Enjoy web-based single sign-on from your company's SSO portal or company intranet by clicking on the BambooHR link provided.":
		{
			translation:
				"Enjoy web-based single sign-on from your company's SSO portal or company intranet by clicking on the BambooHR link provided.",
		},
	Enroll: {
		translation: 'Enroll',
	},
	'Enroll Customer': {
		translation: 'Enroll Customer',
	},
	'Enroll Employees': {
		translation: 'Enroll Employees',
	},
	Enrolled: {
		translation: 'Enrolled',
	},
	'Enrolled Coverage': {
		translation: 'Enrolled Coverage',
	},
	'Enrolled in %s': {
		translation: 'Enrolled in %s',
	},
	'Enrolled in %s on %s': {
		translation: 'Enrolled in %s on %s',
	},
	'Enrolled in policy "%1$s"': {
		translation: 'Enrolled in policy \\"%1$s\\"',
	},
	'Enrollment Change': {
		translation: 'Enrollment Change',
	},
	'Enrollment Effective': {
		translation: 'Enrollment Effective',
	},
	'Enrollment Status': {
		translation: 'Enrollment Status',
	},
	'Enrollment Window': {
		translation: 'Enrollment Window',
	},
	'Enrollment Window Election Summary': {
		translation: 'Enrollment Window Election Summary',
	},
	'Enrollment entered on %1$s and set to a coverage effective date of %2$s.': {
		translation:
			'Enrollment entered on %1$s and set to a coverage effective date of %2$s.',
	},
	'Enrollment in %1$s coverage effective': {
		translation: 'Enrollment in %1$s coverage effective',
	},
	'Enrollment in %1$s entered on %2$s and set to a coverage effective date of %3$s.':
		{
			translation:
				'Enrollment in %1$s entered on %2$s and set to a coverage effective date of %3$s.',
		},
	'Enrollment in Employee Paid %1$s scheduled to start %2$s and end %3$s': {
		translation:
			'Enrollment in Employee Paid %1$s scheduled to start %2$s and end %3$s',
	},
	'Enrollment in Employee Pays %1$s / Company Pays %2$s effective': {
		translation:
			'Enrollment in Employee Pays %1$s / Company Pays %2$s effective',
	},
	'Enrollment window has been deleted or does not exist.': {
		translation: 'Enrollment window has been deleted or does not exist.',
	},
	Enter: {
		translation: 'Enter',
	},
	'Enter Address (Leave blank for remote employee)': {
		translation: 'Enter Address (Leave blank for remote employee)',
	},
	'Enter Company Information': {
		translation: 'Enter Company Information',
	},
	'Enter Different Bank Account': {
		translation: 'Enter Different Bank Account',
	},
	'Enter Hire Dates': {
		translation: 'Enter Hire Dates',
	},
	'Enter Hours Worked': {
		translation: 'Enter Hours Worked',
	},
	'Enter Names': {
		translation: 'Enter Names',
	},
	'Enter Pay Period End Date.': {
		translation: 'Enter Pay Period End Date.',
	},
	'Enter Question': {
		translation: 'Enter Question',
	},
	'Enter Question (e.g. Why do you want to work here?)': {
		translation: 'Enter Question (e.g. Why do you want to work here?)',
	},
	'Enter Translation': {
		translation: 'Enter Translation',
	},
	'Enter URL': {
		translation: 'Enter URL',
	},
	'Enter a clock out time below before approving hours.': {
		translation: 'Enter a clock out time below before approving hours.',
	},
	'Enter a date range for completed goals.': {
		translation: 'Enter a date range for completed goals.',
	},
	'Enter a date range for peer feedback.': {
		translation: 'Enter a date range for peer feedback.',
	},
	'Enter a name for the new Folder': {
		translation: 'Enter a name for the new Folder',
	},
	'Enter a name for the new folder': {
		translation: 'Enter a name for the new folder',
	},
	'Enter a name…': {
		translation: 'Enter a name…',
	},
	'Enter a new name for this File': {
		translation: 'Enter a new name for this File',
	},
	'Enter a new name for this Folder': {
		translation: 'Enter a new name for this Folder',
	},
	'Enter a new name for this category': {
		translation: 'Enter a new name for this category',
	},
	'Enter a new name for this file': {
		translation: 'Enter a new name for this file',
	},
	'Enter a new name for this folder': {
		translation: 'Enter a new name for this folder',
	},
	'Enter a new name for this list': {
		translation: 'Enter a new name for this list',
	},
	'Enter clock out times below before approving.': {
		translation: 'Enter clock out times below before approving.',
	},
	'Enter deposit amount': {
		translation: 'Enter deposit amount',
	},
	'Enter email addresses...': {
		translation: 'Enter email addresses...',
	},
	'Enter information about when %1$s should arrive, where to go and who to contact on their first day.':
		{
			translation:
				'Enter information about when %1$s should arrive, where to go and who to contact on their first day.',
		},
	'Enter information about when this new employee should arrive, where to go and who to contact on their first day.':
		{
			translation:
				'Enter information about when this new employee should arrive, where to go and who to contact on their first day.',
		},
	'Enter names ...': {
		translation: 'Enter names ...',
	},
	'Enter names or groups': {
		translation: 'Enter names or groups',
	},
	'Enter names or groups...': {
		translation: 'Enter names or groups...',
	},
	'Enter the Consumer Key and Consumer Secret where indicated in the "Install" process of this app.':
		{
			translation:
				'Enter the Consumer Key and Consumer Secret where indicated in the \\"Install\\" process of this app.',
		},
	'Enter the SAML Endpoint URL and SAML Certificate provided by your SAML Identity Provider into the appropriate fields. Please note that Metadata URLs are currently not supported for this app':
		{
			translation:
				'Enter the SAML Endpoint URL and SAML Certificate provided by your SAML Identity Provider into the appropriate fields. Please note that Metadata URLs are currently not supported for this app',
		},
	'Enter the SSO and Okta Certificate provided by your Okta Identity Provider in the appropriate fields. Please note that the metadata URLs are currently not supported for this app':
		{
			translation:
				'Enter the SSO and Okta Certificate provided by your Okta Identity Provider in the appropriate fields. Please note that the metadata URLs are currently not supported for this app',
		},
	'Enter the deposited amount to verify your account': {
		translation: 'Enter the deposited amount to verify your account',
	},
	'Enter the first part of your company\'s BambooHR website (note - do not include the "https://" or the ".bamboohr.com") and the API Key that you generated previously. For example, if my company URL is "http://test.bamboohr.com," then I would enter "test" into the Customer Subdomain box':
		{
			translation:
				'Enter the first part of your company\'s BambooHR website (note - do not include the \\"https://\\" or the \\".bamboohr.com\\") and the API Key that you generated previously. For example, if my company URL is \\"http://test.bamboohr.com,\\" then I would enter \\"test\\" into the Customer Subdomain box',
		},
	'Enter the required SwipeClock account information including your Site Code, Username, and Password.':
		{
			translation:
				'Enter the required SwipeClock account information including your Site Code, Username, and Password.',
		},
	'Enter the your BambooHR subdomain, which is the first part of your company\'s BambooHR website (note – do not include the "https://" or the ".bamboohr.com") and the API Key that you generated previously.':
		{
			translation:
				'Enter the your BambooHR subdomain, which is the first part of your company\'s BambooHR website (note – do not include the \\"https://\\" or the \\".bamboohr.com\\") and the API Key that you generated previously.',
		},
	'Enter your BambooHR API Key and Company Subdomain into the Greenhouse Integration tab of your Greenhouse instance.':
		{
			translation:
				'Enter your BambooHR API Key and Company Subdomain into the Greenhouse Integration tab of your Greenhouse instance.',
		},
	'Enter your BambooHR API Key and Company Subdomain into the provided fields <p>Note: Please enter your Company Subdomain without the URL parameters. For example, if your subdomain URL is bestcompany.bamboohr.com, enter bestcompany into the provided field.</p>':
		{
			translation:
				'Enter your BambooHR API Key and Company Subdomain into the provided fields <p>Note: Please enter your Company Subdomain without the URL parameters. For example, if your subdomain URL is bestcompany.bamboohr.com, enter bestcompany into the provided field.</p>',
		},
	'Enter your BambooHR Domain to login.': {
		translation: 'Enter your BambooHR Domain to login.',
	},
	'Enter your BambooHR username and password to grant access to this application to connect with your BambooHR account':
		{
			translation:
				'Enter your BambooHR username and password to grant access to this application to connect with your BambooHR account',
		},
	"Enter your email address and we'll send you a link to reset your password.":
		{
			translation:
				"Enter your email address and we'll send you a link to reset your password.",
		},
	'Enter your password to pick up where you left off.': {
		translation: 'Enter your password to pick up where you left off.',
	},
	'Enter your search phrase...': {
		translation: 'Enter your search phrase...',
	},
	'Enter your search term': {
		translation: 'Enter your search term',
	},
	'Enter your time like %1$s or %2$s—whatever feels most natural.': {
		translation:
			'Enter your time like %1$s or %2$s—whatever feels most natural.',
	},
	'Entered By': {
		translation: 'Entered By',
	},
	"Entering time shouldn't be hard.": {
		translation: "Entering time shouldn't be hard.",
	},
	'Enterprises that use a human resource management system such as BambooHR often rely on it as the authoritative source of employee data. But it’s challenging for IT to synchronize HR user records between Active Directory and enterprise applications. It only gets harder as more people join the organization, as they change roles over time, as they manually update their own information, and as they leave.':
		{
			translation:
				'Enterprises that use a human resource management system such as BambooHR often rely on it as the authoritative source of employee data. But it’s challenging for IT to synchronize HR user records between Active Directory and enterprise applications. It only gets harder as more people join the organization, as they change roles over time, as they manually update their own information, and as they leave.',
		},
	'Entity Acct #': {
		translation: 'Entity Acct #',
	},
	'Entity Bank Name': {
		translation: 'Entity Bank Name',
	},
	'Entity Name': {
		translation: 'Entity Name',
	},
	'Entity Routing #': {
		translation: 'Entity Routing #',
	},
	'Entry-level': {
		translation: 'Entry-level',
	},
	'EnvisionBX connects BambooHR to Xero Payroll, syncing Employees, leave approvals and leave balances.':
		{
			translation:
				'EnvisionBX connects BambooHR to Xero Payroll, syncing Employees, leave approvals and leave balances.',
		},
	'Eor Annual Pay': {
		translation: 'Eor Annual Pay',
	},
	'Equal Access': {
		translation: 'Equal Access',
	},
	'Equal Employment Opportunity': {
		translation: 'Equal Employment Opportunity',
	},
	'Equipment Safety Training Program': {
		translation: 'Equipment Safety Training Program',
	},
	Equity: {
		translation: 'Equity',
	},
	'Equity Compensation': {
		translation: 'Equity Compensation',
	},
	'Equity Increase': {
		translation: 'Equity Increase',
	},
	'Equity: # of Equity Granted': {
		translation: 'Equity: # of Equity Granted',
	},
	'Equity: Cliff Months': {
		translation: 'Equity: Cliff Months',
	},
	'Equity: Custom Grant Type Name': {
		translation: 'Equity: Custom Grant Type Name',
	},
	'Equity: Grant Date': {
		translation: 'Equity: Grant Date',
	},
	'Equity: Grant Type': {
		translation: 'Equity: Grant Type',
	},
	'Equity: Strike Price': {
		translation: 'Equity: Strike Price',
	},
	'Equity: Vesting Months': {
		translation: 'Equity: Vesting Months',
	},
	'Equity: Vesting Schedule': {
		translation: 'Equity: Vesting Schedule',
	},
	'Equity: Vesting Start Date': {
		translation: 'Equity: Vesting Start Date',
	},
	Error: {
		translation: 'Error',
	},
	'Error - unable to retrieve application.': {
		translation: 'Error - unable to retrieve application.',
	},
	'Error Message': {
		translation: 'Error Message',
	},
	'Error Not Found': {
		translation: 'Error Not Found',
	},
	'Error connecting to NetSuite. Please check your <a href="index.php">NetSuite account details</a> and try again.':
		{
			translation:
				'Error connecting to NetSuite. Please check your <a href=\\"index.php\\">NetSuite account details</a> and try again.',
		},
	'Error deleting training event': {
		translation: 'Error deleting training event',
	},
	'Error encountered making request to Remote API.': {
		translation: 'Error encountered making request to Remote API.',
	},
	'Error inserting employee time off policy': {
		translation: 'Error inserting employee time off policy',
	},
	'Error logged successfully.': {
		translation: 'Error logged successfully.',
	},
	'Error processing your request.': {
		translation: 'Error processing your request.',
	},
	'Error related to TRAXPayroll. Check for overlapping compensation history dates for the employee':
		{
			translation:
				'Error related to TRAXPayroll. Check for overlapping compensation history dates for the employee',
		},
	'Error related to TRAXPayroll. Check for overlapping compensation history dates for the employee.':
		{
			translation:
				'Error related to TRAXPayroll. Check for overlapping compensation history dates for the employee.',
		},
	'Error related to TRAXPayroll. Check your compensation history dates for the employee':
		{
			translation:
				'Error related to TRAXPayroll. Check your compensation history dates for the employee',
		},
	"Error related to TRAXPayroll. Check your compensation history start and end dates aren't overlapping an existing entry":
		{
			translation:
				"Error related to TRAXPayroll. Check your compensation history start and end dates aren't overlapping an existing entry",
		},
	'Error related to payroll. Check for overlapping compensation history dates for the employee.':
		{
			translation:
				'Error related to payroll. Check for overlapping compensation history dates for the employee.',
		},
	'Error removing time off history item': {
		translation: 'Error removing time off history item',
	},
	'Error saving the shared position fields.': {
		translation: 'Error saving the shared position fields.',
	},
	'Error saving the shared position questions.': {
		translation: 'Error saving the shared position questions.',
	},
	'Error updating time off history item.': {
		translation: 'Error updating time off history item.',
	},
	'Error when uploading file, please try again. If the issue persists, please contact support.':
		{
			translation:
				'Error when uploading file, please try again. If the issue persists, please contact support.',
		},
	'Error with the Communication Service call.': {
		translation: 'Error with the Communication Service call.',
	},
	'Errors Detected: ': {
		translation: 'Errors Detected: ',
	},
	Esignature: {
		translation: 'Esignature',
	},
	'Esignature Styles': {
		translation: 'Esignature Styles',
	},
	Esignatures: {
		translation: 'Esignatures',
	},
	'Estimate Time Off': {
		translation: 'Estimate Time Off',
	},
	'Estimated Pay': {
		translation: 'Estimated Pay',
	},
	'Estimated accrual is calculated by multiplying %d hours worked in a week x 52 weeks in a year.':
		{
			translation:
				'Estimated accrual is calculated by multiplying %d hours worked in a week x 52 weeks in a year.',
		},
	'Estimated accrual is calculated by multiplying hours worked in a week x 52 weeks in a year.':
		{
			translation:
				'Estimated accrual is calculated by multiplying hours worked in a week x 52 weeks in a year.',
		},
	Ethics: {
		translation: 'Ethics',
	},
	Ethnicity: {
		translation: 'Ethnicity',
	},
	'Ethnicity & EEO Job Category': {
		translation: 'Ethnicity & EEO Job Category',
	},
	'Ethnicity Bar Chart': {
		translation: 'Ethnicity Bar Chart',
	},
	'Ethnicity Disclosure': {
		translation: 'Ethnicity Disclosure',
	},
	'Ethnicity Donut Chart': {
		translation: 'Ethnicity Donut Chart',
	},
	Europe: {
		translation: 'Europe',
	},
	Event: {
		translation: 'Event',
	},
	'Event Details': {
		translation: 'Event Details',
	},
	'Event Type': {
		translation: 'Event Type',
	},
	'Event successfully saved.': {
		translation: 'Event successfully saved.',
	},
	Every: {
		translation: 'Every',
	},
	'Every %1$s': {
		translation: 'Every %1$s',
	},
	'Every %s Months': {
		translation: 'Every %s Months',
	},
	'Every 12 Months': {
		translation: 'Every 12 Months',
	},
	'Every 3 Months': {
		translation: 'Every 3 Months',
	},
	'Every 4 Months': {
		translation: 'Every 4 Months',
	},
	'Every 6 Months': {
		translation: 'Every 6 Months',
	},
	'Every Day': {
		translation: 'Every Day',
	},
	'Every Hour': {
		translation: 'Every Hour',
	},
	'Every Minute': {
		translation: 'Every Minute',
	},
	'Every Month': {
		translation: 'Every Month',
	},
	'Every Other Month': {
		translation: 'Every Other Month',
	},
	'Every Other Week': {
		translation: 'Every Other Week',
	},
	'Every day is a good day to celebrate something.': {
		translation: 'Every day is a good day to celebrate something.',
	},
	'Every manager will immediately receive an email and inbox task to assign peer feedback to their direct reports.':
		{
			translation:
				'Every manager will immediately receive an email and inbox task to assign peer feedback to their direct reports.',
		},
	'Every month': {
		translation: {
			one: 'Every month',
			other: 'Every %d months',
		},
	},
	'Every month on the %1$s %2$s': {
		translation: 'Every month on the %1$s %2$s',
	},
	'Every month on the 10th': {
		translation: 'Every month on the 10th',
	},
	'Every month on the 11th': {
		translation: 'Every month on the 11th',
	},
	'Every month on the 12th': {
		translation: 'Every month on the 12th',
	},
	'Every month on the 13th': {
		translation: 'Every month on the 13th',
	},
	'Every month on the 14th': {
		translation: 'Every month on the 14th',
	},
	'Every month on the 15th': {
		translation: 'Every month on the 15th',
	},
	'Every month on the 16th': {
		translation: 'Every month on the 16th',
	},
	'Every month on the 17th': {
		translation: 'Every month on the 17th',
	},
	'Every month on the 18th': {
		translation: 'Every month on the 18th',
	},
	'Every month on the 19th': {
		translation: 'Every month on the 19th',
	},
	'Every month on the 1st': {
		translation: 'Every month on the 1st',
	},
	'Every month on the 20th': {
		translation: 'Every month on the 20th',
	},
	'Every month on the 21st': {
		translation: 'Every month on the 21st',
	},
	'Every month on the 22nd': {
		translation: 'Every month on the 22nd',
	},
	'Every month on the 23rd': {
		translation: 'Every month on the 23rd',
	},
	'Every month on the 24th': {
		translation: 'Every month on the 24th',
	},
	'Every month on the 25th': {
		translation: 'Every month on the 25th',
	},
	'Every month on the 26th': {
		translation: 'Every month on the 26th',
	},
	'Every month on the 27th': {
		translation: 'Every month on the 27th',
	},
	'Every month on the 2nd': {
		translation: 'Every month on the 2nd',
	},
	'Every month on the 3rd': {
		translation: 'Every month on the 3rd',
	},
	'Every month on the 4th': {
		translation: 'Every month on the 4th',
	},
	'Every month on the 5th': {
		translation: 'Every month on the 5th',
	},
	'Every month on the 6th': {
		translation: 'Every month on the 6th',
	},
	'Every month on the 7th': {
		translation: 'Every month on the 7th',
	},
	'Every month on the 8th': {
		translation: 'Every month on the 8th',
	},
	'Every month on the 9th': {
		translation: 'Every month on the 9th',
	},
	'Every month on the last %1$s': {
		translation: 'Every month on the last %1$s',
	},
	'Every month on the last day': {
		translation: 'Every month on the last day',
	},
	'Every other %1$s': {
		translation: 'Every other %1$s',
	},
	'Every other week': {
		translation: 'Every other week',
	},
	'Every pay date': {
		translation: 'Every pay date',
	},
	'Every pay period': {
		translation: 'Every pay period',
	},
	'Every quarter': {
		translation: 'Every quarter',
	},
	'Every user needs a unique email address.<br/>Looks like <a href="%3$s">%1$s</a> is already using %2$s':
		{
			translation:
				'Every user needs a unique email address.<br/>Looks like <a href=\\"%3$s\\">%1$s</a> is already using %2$s',
		},
	'Every year': {
		translation: {
			one: 'Every year',
			other: 'Every %d years',
		},
	},
	'Everyday is a good day to celebrate something.': {
		translation: 'Everyday is a good day to celebrate something.',
	},
	Everyone: {
		translation: 'Everyone',
	},
	'Everyone Else': {
		translation: 'Everyone Else',
	},
	'Everyone at your company will now be required to use Google Single Sign-On.':
		{
			translation:
				'Everyone at your company will now be required to use Google Single Sign-On.',
		},
	'Everyone has at least one goal set.': {
		translation: 'Everyone has at least one goal set.',
	},
	'Everyone will be required to login with Google Single Sign-On.': {
		translation:
			'Everyone will be required to login with Google Single Sign-On.',
	},
	'Everyone will see the information you include regardless of their Access Level.':
		{
			translation:
				'Everyone will see the information you include regardless of their Access Level.',
		},
	'Everything look good?': {
		translation: 'Everything look good?',
	},
	'Everything should be up and running soon!': {
		translation: 'Everything should be up and running soon!',
	},
	"Everything's looking great": {
		translation: "Everything's looking great",
	},
	Example: {
		translation: 'Example',
	},
	'Example: At company B, employees earn time off for the last two weeks that they worked.':
		{
			translation:
				'Example: At company B, employees earn time off for the last two weeks that they worked.',
		},
	'Example: Company A gives its employees five weeks of time off at the beginning of the year.':
		{
			translation:
				'Example: Company A gives its employees five weeks of time off at the beginning of the year.',
		},
	Excel: {
		translation: 'Excel',
	},
	'Exception hourly': {
		translation: 'Exception hourly',
	},
	Excess: {
		translation: 'Excess',
	},
	'Excess Wage': {
		translation: 'Excess Wage',
	},
	'Exclude from Payroll': {
		translation: 'Exclude from Payroll',
	},
	'Excluded from Payroll': {
		translation: 'Excluded from Payroll',
	},
	'Excludes SSN': {
		translation: 'Excludes SSN',
	},
	Excused: {
		translation: 'Excused',
	},
	'Exec Sick': {
		translation: 'Exec Sick',
	},
	'Exec Vacation': {
		translation: 'Exec Vacation',
	},
	Execupay: {
		translation: 'Execupay',
	},
	'Execupay information': {
		translation: 'Execupay information',
	},
	Executive: {
		translation: 'Executive',
	},
	'Executive Assistant': {
		translation: 'Executive Assistant',
	},
	'Executive Dashboard': {
		translation: 'Executive Dashboard',
	},
	'Executive/Senior Level Officials and Managers': {
		translation: 'Executive/Senior Level Officials and Managers',
	},
	Executives: {
		translation: 'Executives',
	},
	Exempt: {
		translation: 'Exempt',
	},
	'Exempt Status': {
		translation: 'Exempt Status',
	},
	'Exempt from %s State Taxes': {
		translation: 'Exempt from %s State Taxes',
	},
	'Exempt from Federal Taxes': {
		translation: 'Exempt from Federal Taxes',
	},
	'Exemption Date': {
		translation: 'Exemption Date',
	},
	'Exemption Documentation Collected': {
		translation: 'Exemption Documentation Collected',
	},
	'Exemption Options': {
		translation: 'Exemption Options',
	},
	'Exemption Reason': {
		translation: 'Exemption Reason',
	},
	Exemptions: {
		translation: 'Exemptions',
	},
	Exit: {
		translation: 'Exit',
	},
	'Exit Interview Conducted By': {
		translation: 'Exit Interview Conducted By',
	},
	'Exit Interview Date': {
		translation: 'Exit Interview Date',
	},
	Expand: {
		translation: 'Expand',
	},
	'Expand All Folders': {
		translation: 'Expand All Folders',
	},
	'Expand Menu': {
		translation: 'Expand Menu',
	},
	'Expand row': {
		translation: 'Expand row',
	},
	'Expected Termination Date': {
		translation: 'Expected Termination Date',
	},
	'Expected Termination Date:': {
		translation: 'Expected Termination Date:',
	},
	'Expense $ amount': {
		translation: 'Expense $ amount',
	},
	'Expense Type': {
		translation: 'Expense Type',
	},
	'Expense tracking': {
		translation: 'Expense tracking',
	},
	Expenses: {
		translation: 'Expenses',
	},
	Experience: {
		translation: 'Experience',
	},
	'Experience Level': {
		translation: 'Experience Level',
	},
	'Experience level (alarms)': {
		translation: 'Experience level (alarms)',
	},
	"Experience the freedom of BeneTrac's paperless enrollment and online benefit management. It's the internet-based benefit software that simplifies administration. BeneTrac provides real-time access 24/7 for both administrators and employees. Just imagine—benefits data can be changed, updated or reviewed at any time, from any location.":
		{
			translation:
				"Experience the freedom of BeneTrac's paperless enrollment and online benefit management. It's the internet-based benefit software that simplifies administration. BeneTrac provides real-time access 24/7 for both administrators and employees. Just imagine—benefits data can be changed, updated or reviewed at any time, from any location.",
		},
	Experienced: {
		translation: 'Experienced',
	},
	Expiration: {
		translation: 'Expiration',
	},
	'Expiration Date': {
		translation: 'Expiration Date',
	},
	'Expiration Date must be in the future': {
		translation: 'Expiration Date must be in the future',
	},
	'Expiration Days': {
		translation: 'Expiration Days',
	},
	'Expiration Month': {
		translation: 'Expiration Month',
	},
	'Expiration Year': {
		translation: 'Expiration Year',
	},
	'Expiration date must be after issue date.': {
		translation: 'Expiration date must be after issue date.',
	},
	'Expiration of COBRA coverage': {
		translation: 'Expiration of COBRA coverage',
	},
	Expired: {
		translation: 'Expired',
	},
	'Expired Trainings': {
		translation: 'Expired Trainings',
	},
	Expires: {
		translation: 'Expires',
	},
	'Expires (1)': {
		translation: 'Expires (1)',
	},
	'Expires (2)': {
		translation: 'Expires (2)',
	},
	'Expires (3)': {
		translation: 'Expires (3)',
	},
	'Expires (4)': {
		translation: 'Expires (4)',
	},
	'Expiring Work Visas': {
		translation: 'Expiring Work Visas',
	},
	'Expiring within 90 days': {
		translation: 'Expiring within 90 days',
	},
	'Expiry Date': {
		translation: 'Expiry Date',
	},
	'Expiry Date can not be before Issued Date': {
		translation: 'Expiry Date can not be before Issued Date',
	},
	'Explore Our Add-Ons': {
		translation: 'Explore Our Add-Ons',
	},
	Export: {
		translation: 'Export',
	},
	'Export Files': {
		translation: 'Export Files',
	},
	'Export Job Data': {
		translation: 'Export Job Data',
	},
	'Export Report as...': {
		translation: 'Export Report as...',
	},
	'Export Type(s)': {
		translation: 'Export Type(s)',
	},
	'Export as...': {
		translation: 'Export as...',
	},
	'Export files for %1$s': {
		translation: 'Export files for %1$s',
	},
	'Export to Cornerstone': {
		translation: 'Export to Cornerstone',
	},
	Exporting: {
		translation: 'Exporting',
	},
	'Exporting Information: Press the Export Employees button to export all employees created in Simplepay.ca into BambooHR. After exporting, any updates made in Simplepay.ca will automatically be updated in BambooHR as well.':
		{
			translation:
				'Exporting Information: Press the Export Employees button to export all employees created in Simplepay.ca into BambooHR. After exporting, any updates made in Simplepay.ca will automatically be updated in BambooHR as well.',
		},
	'Exporting this report will mark all of your ': {
		translation: 'Exporting this report will mark all of your ',
	},
	Exposure: {
		translation: 'Exposure',
	},
	'Exposure Date': {
		translation: 'Exposure Date',
	},
	'Exposure Tracker': {
		translation: 'Exposure Tracker',
	},
	'Exposure Tracker: Comments': {
		translation: 'Exposure Tracker: Comments',
	},
	'Exposure Tracker: Exposure Date': {
		translation: 'Exposure Tracker: Exposure Date',
	},
	'Exposure Tracker: Notified': {
		translation: 'Exposure Tracker: Notified',
	},
	'Exposure Tracker: Vaccination Status': {
		translation: 'Exposure Tracker: Vaccination Status',
	},
	Ext: {
		translation: 'Ext',
	},
	'Ext.': {
		translation: 'Ext.',
	},
	'Ext. %s': {
		translation: 'Ext. %s',
	},
	'External Company ID': {
		translation: 'External Company ID',
	},
	'External ID': {
		translation: 'External ID',
	},
	'External Source': {
		translation: 'External Source',
	},
	'External Value': {
		translation: 'External Value',
	},
	'Extra Pay': {
		translation: 'Extra Pay',
	},
	'Extra Pay Summary': {
		translation: 'Extra Pay Summary',
	},
	'Extra Withholding': {
		translation: 'Extra Withholding',
	},
	'Eye Color': {
		translation: 'Eye Color',
	},
	'FCVS ID': {
		translation: 'FCVS ID',
	},
	'FCVS login ID': {
		translation: 'FCVS login ID',
	},
	'FCVS password': {
		translation: 'FCVS password',
	},
	FEMALE: {
		translation: 'FEMALE',
	},
	'FICA Exempt': {
		translation: 'FICA Exempt',
	},
	'FICA exempt': {
		translation: 'FICA exempt',
	},
	'FLSA Code': {
		translation: 'FLSA Code',
	},
	'FLSA Code & Pay Group': {
		translation: 'FLSA Code & Pay Group',
	},
	FMLA: {
		translation: 'FMLA',
	},
	FSA: {
		translation: 'FSA',
	},
	'FSA-Eligible HMO': {
		translation: 'FSA-Eligible HMO',
	},
	'FSA-Eligible HMO 2025': {
		translation: 'FSA-Eligible HMO 2025',
	},
	FTE: {
		translation: 'FTE',
	},
	'FTE (Full Time Equivalent)': {
		translation: 'FTE (Full Time Equivalent)',
	},
	'FTE (Full-Time Equivalent)': {
		translation: 'FTE (Full-Time Equivalent)',
	},
	'FTE <span>(Full-Time Equivalent)</span>': {
		translation: 'FTE <span>(Full-Time Equivalent)</span>',
	},
	'FTE must be a numeric value greater than 0': {
		translation: 'FTE must be a numeric value greater than 0',
	},
	'FTE must be a numeric value greater than or equal to 0': {
		translation: 'FTE must be a numeric value greater than or equal to 0',
	},
	'FTE must be a numeric value less than or equal to 1': {
		translation: 'FTE must be a numeric value less than or equal to 1',
	},
	'FTE was updated successfully.': {
		translation: 'FTE was updated successfully.',
	},
	'FUTA Exempt': {
		translation: 'FUTA Exempt',
	},
	'FUTA exempt': {
		translation: 'FUTA exempt',
	},
	'Fabric Playground': {
		translation: 'Fabric Playground',
	},
	Facebook: {
		translation: 'Facebook',
	},
	'Facebook ID': {
		translation: 'Facebook ID',
	},
	'Facebook URL': {
		translation: 'Facebook URL',
	},
	Failed: {
		translation: 'Failed',
	},
	'Failed To Logout Device': {
		translation: 'Failed To Logout Device',
	},
	'Failed to Deliver Response': {
		translation: 'Failed to Deliver Response',
	},
	'Failed to communicate with Employee Community service': {
		translation: 'Failed to communicate with Employee Community service',
	},
	'Failed to create automated restore point: ': {
		translation: 'Failed to create automated restore point: ',
	},
	'Failed to edit employee benefit': {
		translation: 'Failed to edit employee benefit',
	},
	'Failed to enroll employee in benefit': {
		translation: 'Failed to enroll employee in benefit',
	},
	'Failed to export job opening data': {
		translation: 'Failed to export job opening data',
	},
	'Failed to install LinkedIn app': {
		translation: 'Failed to install LinkedIn app',
	},
	'Failed to login using Microsoft SSO, check your configuration and try again':
		{
			translation:
				'Failed to login using Microsoft SSO, check your configuration and try again',
		},
	'Failed to mark employee eligible for benefit': {
		translation: 'Failed to mark employee eligible for benefit',
	},
	'Failed to mark employee not eligible for benefit': {
		translation: 'Failed to mark employee not eligible for benefit',
	},
	'Failed to remove future dated change': {
		translation: 'Failed to remove future dated change',
	},
	'Failed to save Direct Deposit changes.': {
		translation: 'Failed to save Direct Deposit changes.',
	},
	'Failed to terminate coverage for employee benefit': {
		translation: 'Failed to terminate coverage for employee benefit',
	},
	'Failed to waive employee benefit': {
		translation: 'Failed to waive employee benefit',
	},
	'Failed to withdraw employee benefit': {
		translation: 'Failed to withdraw employee benefit',
	},
	'Failure!': {
		translation: 'Failure!',
	},
	'Family Only': {
		translation: 'Family Only',
	},
	'Farewell, Friend.': {
		translation: 'Farewell, Friend.',
	},
	Father: {
		translation: 'Father',
	},
	'Favorite book/magazine/author': {
		translation: 'Favorite book/magazine/author',
	},
	'Favorite color': {
		translation: 'Favorite color',
	},
	'Favorite magazine': {
		translation: 'Favorite magazine',
	},
	'Fax Number': {
		translation: 'Fax Number',
	},
	'Feature Name': {
		translation: 'Feature Name',
	},
	'Feature Usage': {
		translation: 'Feature Usage',
	},
	Features: {
		translation: 'Features',
	},
	Feb: {
		translation: 'Feb',
	},
	February: {
		translation: 'February',
	},
	Federal: {
		translation: 'Federal',
	},
	'Federal EIN': {
		translation: 'Federal EIN',
	},
	'Federal Exempt': {
		translation: 'Federal Exempt',
	},
	'Federal Exemptions': {
		translation: 'Federal Exemptions',
	},
	'Federal FICA Exempt': {
		translation: 'Federal FICA Exempt',
	},
	'Federal FUTA Exempt': {
		translation: 'Federal FUTA Exempt',
	},
	'Federal Filing Status': {
		translation: 'Federal Filing Status',
	},
	'Federal Tax Exempt': {
		translation: 'Federal Tax Exempt',
	},
	'Federal Tax Withholding': {
		translation: 'Federal Tax Withholding',
	},
	'Federal W-4 Withholding': {
		translation: 'Federal W-4 Withholding',
	},
	'Federal W-4 Withholding Information': {
		translation: 'Federal W-4 Withholding Information',
	},
	'Federal Withholding': {
		translation: 'Federal Withholding',
	},
	'Federal Withholding Report': {
		translation: 'Federal Withholding Report',
	},
	'Federal and State Tax withholding information will appear here when all of your data is in order.':
		{
			translation:
				'Federal and State Tax withholding information will appear here when all of your data is in order.',
		},
	'Federal and State W-4 Withholding': {
		translation: 'Federal and State W-4 Withholding',
	},
	Feedback: {
		translation: 'Feedback',
	},
	'Feedback - Thumbs Down': {
		translation: 'Feedback - Thumbs Down',
	},
	'Feedback - Thumbs Up': {
		translation: 'Feedback - Thumbs Up',
	},
	'Feedback Answer %s': {
		translation: 'Feedback Answer %s',
	},
	'Feedback Completed': {
		translation: 'Feedback Completed',
	},
	'Feedback Disabled': {
		translation: 'Feedback Disabled',
	},
	'Feedback Enabled': {
		translation: 'Feedback Enabled',
	},
	'Feedback Frequency': {
		translation: 'Feedback Frequency',
	},
	'Feedback ID': {
		translation: 'Feedback ID',
	},
	'Feedback Question %s': {
		translation: 'Feedback Question %s',
	},
	'Feedback Schedule': {
		translation: 'Feedback Schedule',
	},
	'Feedback Status': {
		translation: 'Feedback Status',
	},
	'Feedback completed for %(employeePreferredFirst)s %(employeeLastName)s': {
		translation:
			'Feedback completed for %(employeePreferredFirst)s %(employeeLastName)s',
	},
	'Feedback enabled': {
		translation: 'Feedback enabled',
	},
	'Feedback has been disabled.': {
		translation: 'Feedback has been disabled.',
	},
	'Feedback is Disabled': {
		translation: 'Feedback is Disabled',
	},
	'Feedback request not found.': {
		translation: 'Feedback request not found.',
	},
	'Feedback settings have been successfully updated.': {
		translation: 'Feedback settings have been successfully updated.',
	},
	'Feedback will be Disabled': {
		translation: 'Feedback will be Disabled',
	},
	'Feeds - Example': {
		translation: 'Feeds - Example',
	},
	'Feeling a little chilly? Don’t worry, you just made enough to buy %1$s Snuggies (at $19.95 + $7.95 shipping). Invite some friends over and let the snuggling begin.':
		{
			translation:
				'Feeling a little chilly? Don’t worry, you just made enough to buy %1$s Snuggies (at $19.95 + $7.95 shipping). Invite some friends over and let the snuggling begin.',
		},
	'Feels Valued': {
		translation: 'Feels Valued',
	},
	'Feels Valued?': {
		translation: 'Feels Valued?',
	},
	'Feels valued?': {
		translation: 'Feels valued?',
	},
	Female: {
		translation: 'Female',
	},
	Field: {
		translation: 'Field',
	},
	'Field Metadata': {
		translation: 'Field Metadata',
	},
	'Field Name': {
		translation: 'Field Name',
	},
	'Field Value': {
		translation: 'Field Value',
	},
	'Field data was too long and could not be saved.': {
		translation: 'Field data was too long and could not be saved.',
	},
	'Field must be of type list.': {
		translation: 'Field must be of type list.',
	},
	'Field not found': {
		translation: 'Field not found',
	},
	'Field of study': {
		translation: 'Field of study',
	},
	'Field order for %s tab': {
		translation: 'Field order for %s tab',
	},
	'Fields changed successfully. Refreshing the page!': {
		translation: 'Fields changed successfully. Refreshing the page!',
	},
	'Fields synchronized to NetSuite': {
		translation: 'Fields synchronized to NetSuite',
	},
	'Fields that come over to BambooHR:': {
		translation: 'Fields that come over to BambooHR:',
	},
	'Fields to Change': {
		translation: 'Fields to Change',
	},
	'Fields will be available to include in the New Hire Packet for your new employees.':
		{
			translation:
				'Fields will be available to include in the New Hire Packet for your new employees.',
		},
	'Fields: ': {
		translation: 'Fields: ',
	},
	'File Actions': {
		translation: 'File Actions',
	},
	'File Description': {
		translation: 'File Description',
	},
	'File Icon': {
		translation: 'File Icon',
	},
	'File Storage': {
		translation: 'File Storage',
	},
	'File Upload': {
		translation: 'File Upload',
	},
	'File content could not be validated.': {
		translation: 'File content could not be validated.',
	},
	'File does not exist.': {
		translation: 'File does not exist.',
	},
	'File failed to upload': {
		translation: 'File failed to upload',
	},
	'File is empty.': {
		translation: 'File is empty.',
	},
	'File not found.': {
		translation: 'File not found.',
	},
	Files: {
		translation: 'Files',
	},
	'Files deleted successfully.': {
		translation: 'Files deleted successfully.',
	},
	'Files have successfully been restored.': {
		translation: 'Files have successfully been restored.',
	},
	'Files to sign': {
		translation: 'Files to sign',
	},
	'Filing Status': {
		translation: 'Filing Status',
	},
	'Fill out the offer information here and it will be filled into the offer letter.':
		{
			translation:
				'Fill out the offer information here and it will be filled into the offer letter.',
		},
	Filled: {
		translation: 'Filled',
	},
	'Filled %1$s': {
		translation: 'Filled %1$s',
	},
	'Filled Date': {
		translation: 'Filled Date',
	},
	'Filter Employees': {
		translation: 'Filter Employees',
	},
	'Filter Employees By': {
		translation: 'Filter Employees By',
	},
	'Filter Employees By...': {
		translation: 'Filter Employees By...',
	},
	'Filter Options': {
		translation: 'Filter Options',
	},
	'Filter Results': {
		translation: 'Filter Results',
	},
	'Filter by Company ID': {
		translation: 'Filter by Company ID',
	},
	'Filter by name, type': {
		translation: 'Filter by name, type',
	},
	'Filter by phone, email, etc...': {
		translation: 'Filter by phone, email, etc...',
	},
	'Filter by project, task': {
		translation: 'Filter by project, task',
	},
	'Filter options': {
		translation: 'Filter options',
	},
	'Filter placeholders...': {
		translation: 'Filter placeholders...',
	},
	'Filter results are based on information as it was at the selected date each month.':
		{
			translation:
				'Filter results are based on information as it was at the selected date each month.',
		},
	'Filter: %s Selected': {
		translation: 'Filter: %s Selected',
	},
	Filters: {
		translation: 'Filters',
	},
	'Final Dose Administration Date': {
		translation: 'Final Dose Administration Date',
	},
	'Final Pay Date': {
		translation: 'Final Pay Date',
	},
	'Final Pay Date:': {
		translation: 'Final Pay Date:',
	},
	'Final pay date is required': {
		translation: 'Final pay date is required',
	},
	'Finalize Approvals': {
		translation: 'Finalize Approvals',
	},
	'Finalize Recommendations': {
		translation: 'Finalize Recommendations',
	},
	'Finalizing your documents...': {
		translation: 'Finalizing your documents...',
	},
	Finance: {
		translation: 'Finance',
	},
	'Financial Account Number': {
		translation: 'Financial Account Number',
	},
	'Financial Analyst': {
		translation: 'Financial Analyst',
	},
	'Find more great technology partners BambooHR has teamed up with.<br /> Click a vendor to see how easy HR can be.':
		{
			translation:
				'Find more great technology partners BambooHR has teamed up with.<br /> Click a vendor to see how easy HR can be.',
		},
	Fingerprints: {
		translation: 'Fingerprints',
	},
	Finish: {
		translation: 'Finish',
	},
	'Finish & Save': {
		translation: 'Finish & Save',
	},
	'Finish Install': {
		translation: 'Finish Install',
	},
	'Finish Signing': {
		translation: 'Finish Signing',
	},
	'Finish in Remote': {
		translation: 'Finish in Remote',
	},
	Finished: {
		translation: 'Finished',
	},
	'Finished!': {
		translation: 'Finished!',
	},
	First: {
		translation: 'First',
	},
	'First Accrual': {
		translation: 'First Accrual',
	},
	'First Aid': {
		translation: 'First Aid',
	},
	'First Aid/CPR': {
		translation: 'First Aid/CPR',
	},
	'First Dose': {
		translation: 'First Dose',
	},
	'First Feedback Round': {
		translation: 'First Feedback Round',
	},
	'First Name': {
		translation: 'First Name',
	},
	'First Name Last Name': {
		translation: 'First Name Last Name',
	},
	'First Name cannot be empty': {
		translation: 'First Name cannot be empty',
	},
	"First Name is a required Field and can't be blank": {
		translation: "First Name is a required Field and can't be blank",
	},
	'First Name is required': {
		translation: 'First Name is required',
	},
	'First Name, Middle Initial': {
		translation: 'First Name, Middle Initial',
	},
	'First Pay Date': {
		translation: 'First Pay Date',
	},
	'First Payroll': {
		translation: 'First Payroll',
	},
	'First Payroll Date': {
		translation: 'First Payroll Date',
	},
	'First Payroll Deduction: ': {
		translation: 'First Payroll Deduction: ',
	},
	'First Payroll Deduction: %s': {
		translation: 'First Payroll Deduction: %s',
	},
	'First Year of Service': {
		translation: 'First Year of Service',
	},
	'First contact Cornerstone to enable single sign-on (SSO) for your account. Once that is enabled, enter your Cornerstone Company Name.':
		{
			translation:
				'First contact Cornerstone to enable single sign-on (SSO) for your account. Once that is enabled, enter your Cornerstone Company Name.',
		},
	'First name': {
		translation: 'First name',
	},
	'First name Last name': {
		translation: 'First name Last name',
	},
	'First name Middle initial': {
		translation: 'First name Middle initial',
	},
	'First of the month after a waiting period': {
		translation: 'First of the month after a waiting period',
	},
	'First of the month following a waiting period': {
		translation: 'First of the month following a waiting period',
	},
	"First off, we need to know who will be paid through BambooHR Payroll. All of your employees need to be in a *Pay Group* (even if you're not paying them through BambooHR Payroll).":
		{
			translation:
				"First off, we need to know who will be paid through BambooHR Payroll. All of your employees need to be in a *Pay Group* (even if you're not paying them through BambooHR Payroll).",
		},
	'First page': {
		translation: 'First page',
	},
	'First pay period for this pay schedule': {
		translation: 'First pay period for this pay schedule',
	},
	'First, *add a Pay Group.*': {
		translation: 'First, *add a Pay Group.*',
	},
	'First/Mid Level Officials and Managers': {
		translation: 'First/Mid Level Officials and Managers',
	},
	Fit: {
		translation: 'Fit',
	},
	'Fit Width': {
		translation: 'Fit Width',
	},
	Fixed: {
		translation: 'Fixed',
	},
	'Flex Savings Account': {
		translation: 'Flex Savings Account',
	},
	'Flex Spending': {
		translation: 'Flex Spending',
	},
	'Flex Spending Account': {
		translation: 'Flex Spending Account',
	},
	'Flex Spending Account Plan': {
		translation: 'Flex Spending Account Plan',
	},
	'Flex Time': {
		translation: 'Flex Time',
	},
	Flexible: {
		translation: 'Flexible',
	},
	'Flexible Spending Account': {
		translation: 'Flexible Spending Account',
	},
	'Flexible or Unlimited.': {
		translation: 'Flexible or Unlimited.',
	},
	"Flexible time off types don't have a balance.": {
		translation: "Flexible time off types don't have a balance.",
	},
	Folder: {
		translation: 'Folder',
	},
	'Folder Number': {
		translation: 'Folder Number',
	},
	'Folder Owner': {
		translation: 'Folder Owner',
	},
	'Folder already exists': {
		translation: 'Folder already exists',
	},
	'Folder name already exists': {
		translation: 'Folder name already exists',
	},
	'Folder too deeply nested max: ': {
		translation: 'Folder too deeply nested max: ',
	},
	'Folder too deeply nested, max: ': {
		translation: 'Folder too deeply nested, max: ',
	},
	'Follow-Up Notes': {
		translation: 'Follow-Up Notes',
	},
	'Follow-up Notes': {
		translation: 'Follow-up Notes',
	},
	For: {
		translation: 'For',
	},
	'For %s': {
		translation: 'For %s',
	},
	"For Employee I'm Adding:": {
		translation: {
			one: "For Employee I'm Adding:",
			other: "For the Employees I'm Adding:",
		},
	},
	'For Employees who can only see information for indirect and/or direct reports.':
		{
			translation:
				'For Employees who can only see information for indirect and/or direct reports.',
		},
	'For Employees who can see and/or edit information for some or all employees.':
		{
			translation:
				'For Employees who can see and/or edit information for some or all employees.',
		},
	'For Employees who should never see sensitive information for anyone but themselves.':
		{
			translation:
				'For Employees who should never see sensitive information for anyone but themselves.',
		},
	'For PC/Payroll: Place the files in the c:\\ADP\\PCPW\\ADPDATA directory, then import them into the Windows application.<br/>For Pay eXpert@reg;: Download the files to your desktop, then upload them into the Pay eXpert&reg; web site':
		{
			translation:
				'For PC/Payroll: Place the files in the c:\\\\ADP\\\\PCPW\\\\ADPDATA directory, then import them into the Windows application.<br/>For Pay eXpert@reg;: Download the files to your desktop, then upload them into the Pay eXpert&reg; web site',
		},
	'For accurate reporting, you need to assign an ACA status to your employment statuses.':
		{
			translation:
				'For accurate reporting, you need to assign an ACA status to your employment statuses.',
		},
	'For all %s plans, your first %s payroll deduction will be:': {
		translation: 'For all %s plans, your first %s payroll deduction will be:',
	},
	'For all unknown list values': {
		translation: 'For all unknown list values',
	},
	'For all unknown list values:': {
		translation: 'For all unknown list values:',
	},
	'For each employee in the file': {
		translation: 'For each employee in the file',
	},
	'For each row of data in the file': {
		translation: 'For each row of data in the file',
	},
	'For employees with different eligibility': {
		translation: 'For employees with different eligibility',
	},
	'For more information, please call Customer Service at 1-866-387-9595 between 8am-5pm (Mountain). Thank you!':
		{
			translation:
				'For more information, please call Customer Service at 1-866-387-9595 between 8am-5pm (Mountain). Thank you!',
		},
	"For now, only admins will see this tab. When you're ready, head over to Access Levels to give additional access.":
		{
			translation:
				"For now, only admins will see this tab. When you're ready, head over to Access Levels to give additional access.",
		},
	"For quick access to the employee directory, go to the People tab of your organization's BambooHR account, click on the \"Quick access to the directory\" link in the upper right-hand corner of your screen, and then bookmark the new tab that's created. It's that easy!":
		{
			translation:
				"For quick access to the employee directory, go to the People tab of your organization's BambooHR account, click on the \\\"Quick access to the directory\\\" link in the upper right-hand corner of your screen, and then bookmark the new tab that's created. It's that easy!",
		},
	'For some reason we are having trouble uploading files right now. Please give it another try in a few minutes.':
		{
			translation:
				'For some reason we are having trouble uploading files right now. Please give it another try in a few minutes.',
		},
	'For step by step instructions you can watch <a href="https://www.youtube.com/watch?v=SHFnD8jxxHk"> this video</a> on how to configure the BambooHR connector':
		{
			translation:
				'For step by step instructions you can watch <a href=\\"https://www.youtube.com/watch?v=SHFnD8jxxHk\\"> this video</a> on how to configure the BambooHR connector',
		},
	'For this to work, time off must be tracked in hours.': {
		translation: 'For this to work, time off must be tracked in hours.',
	},
	'For this to work, you can only select time off types that are tracked in hours.':
		{
			translation:
				'For this to work, you can only select time off types that are tracked in hours.',
		},
	'For users paid by TRAX Payroll, employee number can not be more than 20 characters':
		{
			translation:
				'For users paid by TRAX Payroll, employee number can not be more than 20 characters',
		},
	'For your current time tracking process, choose everything that you need:': {
		translation:
			'For your current time tracking process, choose everything that you need:',
	},
	'Force refresh': {
		translation: 'Force refresh',
	},
	'Forgot Password Instructions': {
		translation: 'Forgot Password Instructions',
	},
	'Forgot Password?': {
		translation: 'Forgot Password?',
	},
	'Forgot Your Password?': {
		translation: 'Forgot Your Password?',
	},
	'Forklift and Heavy Equipment': {
		translation: 'Forklift and Heavy Equipment',
	},
	'Form Validation Guide': {
		translation: 'Form Validation Guide',
	},
	Format: {
		translation: 'Format',
	},
	Forms: {
		translation: 'Forms',
	},
	"Forms uploaded successfully! Almost there, just add your company's payroll bank account information":
		{
			translation:
				"Forms uploaded successfully! Almost there, just add your company's payroll bank account information",
		},
	'Foster care': {
		translation: 'Foster care',
	},
	'Foster child': {
		translation: 'Foster child',
	},
	'Found %d new employee in Cornerstone.': {
		translation: {
			one: 'Found %d new employee in Cornerstone.',
			other: 'Found %d new employees in Cornerstone.',
		},
	},
	'Founded in early 2012 by Daniel Chait and Jon Stross, Greenhouse Software is a Recruiting Optimization Platform that helps companies source, interview, hire, and onboard the best talent. From sourcing candidates to custom interview kits, Greenhouse helps you find the best talent, conduct focused interviews, and gather relevant feedback quickly to make the right hiring decisions, faster. More than just an applicant tracking system, Greenhouse lets you integrate with your other tools and run your entire hiring process, end-to-end, from a single application. Current customers include companies like Airbnb, Pinterest, Riot Games and more.':
		{
			translation:
				'Founded in early 2012 by Daniel Chait and Jon Stross, Greenhouse Software is a Recruiting Optimization Platform that helps companies source, interview, hire, and onboard the best talent. From sourcing candidates to custom interview kits, Greenhouse helps you find the best talent, conduct focused interviews, and gather relevant feedback quickly to make the right hiring decisions, faster. More than just an applicant tracking system, Greenhouse lets you integrate with your other tools and run your entire hiring process, end-to-end, from a single application. Current customers include companies like Airbnb, Pinterest, Riot Games and more.',
		},
	'Founder and CEO': {
		translation: 'Founder and CEO',
	},
	'Four times a month': {
		translation: 'Four times a month',
	},
	Fraud: {
		translation: 'Fraud',
	},
	'Free Trial': {
		translation: 'Free Trial',
	},
	Freemium: {
		translation: 'Freemium',
	},
	French: {
		translation: 'French',
	},
	Frequency: {
		translation: 'Frequency',
	},
	Friday: {
		translation: 'Friday',
	},
	Fridays: {
		translation: 'Fridays',
	},
	Friend: {
		translation: 'Friend',
	},
	From: {
		translation: 'From',
	},
	'From the drop-down, select a previous date to compare against.  Check the box to store a new checkpoint as of the current point in time for future comparisons.  Click the "View Report" button.  This will generate a CSV file of core payroll-related data that has been updated or changed between now and the previous date selected.  The report will show you only the employees and field data that has been altered within the specified time frame and field names will be adjusted so that they reflect ADP terminology.  (i.e. Employee # will show as "File #" in the report)':
		{
			translation:
				'From the drop-down, select a previous date to compare against.  Check the box to store a new checkpoint as of the current point in time for future comparisons.  Click the \\"View Report\\" button.  This will generate a CSV file of core payroll-related data that has been updated or changed between now and the previous date selected.  The report will show you only the employees and field data that has been altered within the specified time frame and field names will be adjusted so that they reflect ADP terminology.  (i.e. Employee # will show as \\"File #\\" in the report)',
		},
	'From there, you can manage all the benefits offered to that employee by making any benefits changes within Maxwell Health.':
		{
			translation:
				'From there, you can manage all the benefits offered to that employee by making any benefits changes within Maxwell Health.',
		},
	'From within OneLogin, click the icon of the app that you want to log into. In this case, I would click on the BambooHR app icon. You will be taken directly into BambooHR.':
		{
			translation:
				'From within OneLogin, click the icon of the app that you want to log into. In this case, I would click on the BambooHR app icon. You will be taken directly into BambooHR.',
		},
	'From:': {
		translation: 'From:',
	},
	'Front End Developer': {
		translation: 'Front End Developer',
	},
	'Frontend pay scale': {
		translation: 'Frontend pay scale',
	},
	'Full (Male, Female, etc.)': {
		translation: 'Full (Male, Female, etc.)',
	},
	'Full Access': {
		translation: 'Full Access',
	},
	'Full Admin': {
		translation: 'Full Admin',
	},
	'Full Admin Users': {
		translation: 'Full Admin Users',
	},
	'Full Admin(s)': {
		translation: 'Full Admin(s)',
	},
	'Full Admins': {
		translation: 'Full Admins',
	},
	'Full Amount': {
		translation: 'Full Amount',
	},
	'Full Calendar': {
		translation: 'Full Calendar',
	},
	'Full Import Results': {
		translation: 'Full Import Results',
	},
	'Full Name': {
		translation: 'Full Name',
	},
	'Full Profile (Non-Sensitive)': {
		translation: 'Full Profile (Non-Sensitive)',
	},
	'Full Time Date': {
		translation: 'Full Time Date',
	},
	'Full Time Student': {
		translation: 'Full Time Student',
	},
	'Full-Time': {
		translation: 'Full-Time',
	},
	'Full-Time Student': {
		translation: 'Full-Time Student',
	},
	'Full-time Student and Aged 19-26': {
		translation: 'Full-time Student and Aged 19-26',
	},
	'Funds will be processed within **2-3 days** of approval.': {
		translation: 'Funds will be processed within **2-3 days** of approval.',
	},
	Furloughed: {
		translation: 'Furloughed',
	},
	'Future Feedback Dates': {
		translation: 'Future Feedback Dates',
	},
	'Future Hire Date': {
		translation: 'Future Hire Date',
	},
	'Future Peer Feedback Dates': {
		translation: 'Future Peer Feedback Dates',
	},
	'Future Review Periods': {
		translation: 'Future Review Periods',
	},
	'Future change on %1$s': {
		translation: 'Future change on %1$s',
	},
	GB: {
		translation: 'GB',
	},
	'GDPR Compliance': {
		translation: 'GDPR Compliance',
	},
	'GED or Equivalent': {
		translation: 'GED or Equivalent',
	},
	'GET method not allowed': {
		translation: 'GET method not allowed',
	},
	'GMP Trainer': {
		translation: 'GMP Trainer',
	},
	'GMP/HACCP Percent': {
		translation: 'GMP/HACCP Percent',
	},
	GPA: {
		translation: 'GPA',
	},
	'GPA/Other': {
		translation: 'GPA/Other',
	},
	'GPA/Score': {
		translation: 'GPA/Score',
	},
	'Garnishment Payments': {
		translation: 'Garnishment Payments',
	},
	"Garnishments, tax levies, loan repayments, etc. Benefit deductions are managed on the employee's ":
		{
			translation:
				"Garnishments, tax levies, loan repayments, etc. Benefit deductions are managed on the employee's ",
		},
	'Gas card': {
		translation: 'Gas card',
	},
	Gender: {
		translation: 'Gender',
	},
	'Gender & Marital Status': {
		translation: 'Gender & Marital Status',
	},
	"Gender '%1$s' not found": {
		translation: "Gender '%1$s' not found",
	},
	'Gender Bar Chart': {
		translation: 'Gender Bar Chart',
	},
	'Gender Breakdown': {
		translation: 'Gender Breakdown',
	},
	'Gender Donut Chart': {
		translation: 'Gender Donut Chart',
	},
	'Gender Identity': {
		translation: 'Gender Identity',
	},
	'Gender Non-conforming': {
		translation: 'Gender Non-conforming',
	},
	'Gender Profile': {
		translation: 'Gender Profile',
	},
	'Gender Profile Report': {
		translation: 'Gender Profile Report',
	},
	'Gender is required': {
		translation: 'Gender is required',
	},
	Genderfluid: {
		translation: 'Genderfluid',
	},
	Genderqueer: {
		translation: 'Genderqueer',
	},
	'General Account Settings': {
		translation: 'General Account Settings',
	},
	'General Application': {
		translation: 'General Application',
	},
	'General Healthcare': {
		translation: 'General Healthcare',
	},
	'General Healthcare Purposes': {
		translation: 'General Healthcare Purposes',
	},
	'General Settings': {
		translation: 'General Settings',
	},
	'General ledger data, exactly where you need it': {
		translation: 'General ledger data, exactly where you need it',
	},
	Generate: {
		translation: 'Generate',
	},
	'Generate Key': {
		translation: 'Generate Key',
	},
	'Generate a BambooHR API Key by hovering over your profile picture icon in the top-right and selecting "API Keys" from the dropdown menu and then clicking on "Add a New Key"':
		{
			translation:
				'Generate a BambooHR API Key by hovering over your profile picture icon in the top-right and selecting \\"API Keys\\" from the dropdown menu and then clicking on \\"Add a New Key\\"',
		},
	'Genetic Data': {
		translation: 'Genetic Data',
	},
	Geolocation: {
		translation: 'Geolocation',
	},
	'Geolocation/Geofencing': {
		translation: 'Geolocation/Geofencing',
	},
	German: {
		translation: 'German',
	},
	'Get BambooHR for [iPhone](1) or [Android](2)': {
		translation: 'Get BambooHR for [iPhone](1) or [Android](2)',
	},
	'Get Benefit Details': {
		translation: 'Get Benefit Details',
	},
	'Get Embed Code': {
		translation: 'Get Embed Code',
	},
	'Get Feedback About Your Team': {
		translation: 'Get Feedback About Your Team',
	},
	'Get Feedback about Your Team': {
		translation: 'Get Feedback about Your Team',
	},
	'Get Feedback from...': {
		translation: 'Get Feedback from...',
	},
	'Get Goals Details': {
		translation: 'Get Goals Details',
	},
	'Get Google Meeting': {
		translation: 'Get Google Meeting',
	},
	'Get Introduced': {
		translation: 'Get Introduced',
	},
	'Get Introduced to The Team': {
		translation: 'Get Introduced to The Team',
	},
	'Get Introduced to the Team': {
		translation: 'Get Introduced to the Team',
	},
	'Get Job Link': {
		translation: 'Get Job Link',
	},
	'Get Job Summaries': {
		translation: 'Get Job Summaries',
	},
	'Get Peer Feedback about Your Team': {
		translation: 'Get Peer Feedback about Your Team',
	},
	'Get Peer Feedback from...': {
		translation: 'Get Peer Feedback from...',
	},
	'Get Started': {
		translation: 'Get Started',
	},
	'Get Teams Meeting': {
		translation: 'Get Teams Meeting',
	},
	'Get Training Details': {
		translation: 'Get Training Details',
	},
	'Get User Access Levels': {
		translation: 'Get User Access Levels',
	},
	'Get Users List': {
		translation: 'Get Users List',
	},
	'Get a key and secret from your Cornerstone account by visiting <a href="https://csb.csod.com/account/profile" target="_blank" rel="noopener noreferrer">https://csb.csod.com/account/profile</a>':
		{
			translation:
				'Get a key and secret from your Cornerstone account by visiting <a href=\\"https://csb.csod.com/account/profile\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">https://csb.csod.com/account/profile</a>',
		},
	'Get a trackable link to share anywhere.': {
		translation: 'Get a trackable link to share anywhere.',
	},
	'Get clocking with Time Tracking in a flash': {
		translation: 'Get clocking with Time Tracking in a flash',
	},
	'Get familiar with Benefit Groups': {
		translation: 'Get familiar with Benefit Groups',
	},
	'Get in touch with your payroll implementation rep for more information about using this tool to fill in your missing data':
		{
			translation:
				'Get in touch with your payroll implementation rep for more information about using this tool to fill in your missing data',
		},
	'Get it free for [iOS](1) or [Android](2).': {
		translation: 'Get it free for [iOS](1) or [Android](2).',
	},
	'Get new employees started out on the right foot.': {
		translation: 'Get new employees started out on the right foot.',
	},
	'Get ready for your first day by downloading the BambooHR app.': {
		translation:
			'Get ready for your first day by downloading the BambooHR app.',
	},
	'Get started by adding a few new custom fields.': {
		translation: 'Get started by adding a few new custom fields.',
	},
	'Get the Word Out': {
		translation: 'Get the Word Out',
	},
	'Get the most out of BambooHR with the latest browsers': {
		translation: 'Get the most out of BambooHR with the latest browsers',
	},
	'Get to Know %1$s': {
		translation: 'Get to Know %1$s',
	},
	'Get to Know You Answers': {
		translation: 'Get to Know You Answers',
	},
	'Get to Know You Questions:': {
		translation: 'Get to Know You Questions:',
	},
	'Get to Know You%1$sQuestions Completed': {
		translation: 'Get to Know You%1$sQuestions Completed',
	},
	'Get to Know the Team': {
		translation: 'Get to Know the Team',
	},
	'Get your employee info in tip-top shape for payroll': {
		translation: 'Get your employee info in tip-top shape for payroll',
	},
	'Getting Started': {
		translation: 'Getting Started',
	},
	'Getting Started in BambooHR': {
		translation: 'Getting Started in BambooHR',
	},
	'Give Boomr authorization to access your BambooHR account. This will start the initial data sync and pull over important information, such as your lists of employees.':
		{
			translation:
				'Give Boomr authorization to access your BambooHR account. This will start the initial data sync and pull over important information, such as your lists of employees.',
		},
	'Give more context for this email alert.': {
		translation: 'Give more context for this email alert.',
	},
	'Give your Employees Access Levels to determine their access to information in BambooHR.':
		{
			translation:
				'Give your Employees Access Levels to determine their access to information in BambooHR.',
		},
	'Give your new %1 a name': {
		translation: 'Give your new %1 a name',
	},
	'Give your new category a name': {
		translation: 'Give your new category a name',
	},
	'Give your new folder a name': {
		translation: 'Give your new folder a name',
	},
	'Give your new list a name': {
		translation: 'Give your new list a name',
	},
	'Giving Feedback': {
		translation: 'Giving Feedback',
	},
	'Giving Feedback To': {
		translation: 'Giving Feedback To',
	},
	Global: {
		translation: 'Global',
	},
	'Global Employment': {
		translation: 'Global Employment',
	},
	'Global Webhooks': {
		translation: 'Global Webhooks',
	},
	'Global colors': {
		translation: 'Global colors',
	},
	'Global form styles': {
		translation: 'Global form styles',
	},
	'Global webhooks are created and managed on this page in the settings. These are account level webhooks.':
		{
			translation:
				'Global webhooks are created and managed on this page in the settings. These are account level webhooks.',
		},
	'Go Ahead, Bookmark This Page.': {
		translation: 'Go Ahead, Bookmark This Page.',
	},
	'Go Back': {
		translation: 'Go Back',
	},
	'Go Back and Make Changes': {
		translation: 'Go Back and Make Changes',
	},
	'Go Home': {
		translation: 'Go Home',
	},
	'Go To BambooHR': {
		translation: 'Go To BambooHR',
	},
	'Go To Dashboard': {
		translation: 'Go To Dashboard',
	},
	'Go ahead and select the order in which information updates are approved.': {
		translation:
			'Go ahead and select the order in which information updates are approved.',
	},
	'Go ahead and select the order in which request approvals are approved.': {
		translation:
			'Go ahead and select the order in which request approvals are approved.',
	},
	'Go back': {
		translation: 'Go back',
	},
	'Go back and enable goal tracking, assessments, or peer feedback.': {
		translation:
			'Go back and enable goal tracking, assessments, or peer feedback.',
	},
	'Go to BambooHR': {
		translation: 'Go to BambooHR',
	},
	'Go to Bank Account Settings': {
		translation: 'Go to Bank Account Settings',
	},
	'Go to Benefit Groups': {
		translation: 'Go to Benefit Groups',
	},
	'Go to Employee Satisfaction Report': {
		translation: 'Go to Employee Satisfaction Report',
	},
	'Go to Inbox': {
		translation: 'Go to Inbox',
	},
	'Go to LinkedIn Profile': {
		translation: 'Go to LinkedIn Profile',
	},
	'Go to Locations': {
		translation: 'Go to Locations',
	},
	'Go to Pay Schedules': {
		translation: 'Go to Pay Schedules',
	},
	'Go to Settings': {
		translation: 'Go to Settings',
	},
	'Go to Timesheet': {
		translation: 'Go to Timesheet',
	},
	'Go to Website': {
		translation: 'Go to Website',
	},
	'Go to the BambooHR summary and click the "Connect" button to start the integration. A new window will open and you will be prompted to sign in to your BambooHR account. If you do not have a BambooHR account, you will need to set one up.':
		{
			translation:
				'Go to the BambooHR summary and click the \\"Connect\\" button to start the integration. A new window will open and you will be prompted to sign in to your BambooHR account. If you do not have a BambooHR account, you will need to set one up.',
		},
	'Go to the Newest Version': {
		translation: 'Go to the Newest Version',
	},
	'Go to timesheet': {
		translation: 'Go to timesheet',
	},
	'Goal Comments': {
		translation: 'Goal Comments',
	},
	'Goal Description': {
		translation: 'Goal Description',
	},
	'Goal ID is required to update a goal.': {
		translation: 'Goal ID is required to update a goal.',
	},
	'Goal Settings have been successfully updated.': {
		translation: 'Goal Settings have been successfully updated.',
	},
	'Goal Title, Description, Due Date, Progress, Comments': {
		translation: 'Goal Title, Description, Due Date, Progress, Comments',
	},
	'Goal alignment': {
		translation: 'Goal alignment',
	},
	'Goal progress is updated by milestone completion': {
		translation: 'Goal progress is updated by milestone completion',
	},
	'Goal settings have been successfully updated.': {
		translation: 'Goal settings have been successfully updated.',
	},
	'Goal successfully deleted': {
		translation: 'Goal successfully deleted',
	},
	Goals: {
		translation: 'Goals',
	},
	'Goals Enabled in Setting': {
		translation: 'Goals Enabled in Setting',
	},
	'Goals Start Date': {
		translation: 'Goals Start Date',
	},
	'Goals Status': {
		translation: 'Goals Status',
	},
	'Goals have been disabled.': {
		translation: 'Goals have been disabled.',
	},
	'Goals have not been enabled in settings': {
		translation: 'Goals have not been enabled in settings',
	},
	'Going forward, I-9 verifications data will no longer sync. If uninstalled, your final charge will be on your next invoice.':
		{
			translation:
				'Going forward, I-9 verifications data will no longer sync. If uninstalled, your final charge will be on your next invoice.',
		},
	'Going forward, changes made within BambooHR will automatically update within Gusto.':
		{
			translation:
				'Going forward, changes made within BambooHR will automatically update within Gusto.',
		},
	'Going forward, your payroll data will no longer sync.': {
		translation: 'Going forward, your payroll data will no longer sync.',
	},
	'Going forward, your payroll data will no longer sync. If uninstalled, your final charge will be on your next invoice.':
		{
			translation:
				'Going forward, your payroll data will no longer sync. If uninstalled, your final charge will be on your next invoice.',
		},
	'Good engagement and a mostly positive attitude.': {
		translation: 'Good engagement and a mostly positive attitude.',
	},
	'Good news—no feedback requests are past due!': {
		translation: 'Good news—no feedback requests are past due!',
	},
	'Good to Know, Thanks': {
		translation: 'Good to Know, Thanks',
	},
	'Good to go?': {
		translation: 'Good to go?',
	},
	'Goodbye!': {
		translation: 'Goodbye!',
	},
	'Google Apps User Import': {
		translation: 'Google Apps User Import',
	},
	'Google SCIM Description': {
		translation: 'Google SCIM Description',
	},
	'Google Single Sign-On (SSO) makes logging into BambooHR a piece of cake!': {
		translation:
			'Google Single Sign-On (SSO) makes logging into BambooHR a piece of cake!',
	},
	'Google Single Sign-on settings updated': {
		translation: 'Google Single Sign-on settings updated',
	},
	'Google was unable to log you in.': {
		translation: 'Google was unable to log you in.',
	},
	'Got It': {
		translation: 'Got It',
	},
	'Got it': {
		translation: 'Got it',
	},
	'Got it! No need to accept the Data Processing Agreement then. Moving on...':
		{
			translation:
				'Got it! No need to accept the Data Processing Agreement then. Moving on...',
		},
	'Got it! Onboarding task added successfully.': {
		translation: 'Got it! Onboarding task added successfully.',
	},
	'Got it! Onboarding task updated successfully': {
		translation: 'Got it! Onboarding task updated successfully',
	},
	'Got it! Thank you for accepting our Data Processing Agreement.': {
		translation:
			'Got it! Thank you for accepting our Data Processing Agreement.',
	},
	'Got it! Thank you for responding to our Data Processing Agreement question.':
		{
			translation:
				'Got it! Thank you for responding to our Data Processing Agreement question.',
		},
	'Got it! Time tracking will start %1$s': {
		translation: 'Got it! Time tracking will start %1$s',
	},
	'Got it! Your changes were successfully saved.': {
		translation: 'Got it! Your changes were successfully saved.',
	},
	'Got it, Change Template': {
		translation: 'Got it, Change Template',
	},
	'Got it, I understand': {
		translation: 'Got it, I understand',
	},
	'Got it, Thanks': {
		translation: 'Got it, Thanks',
	},
	"Got it, you'll now get the extra-cool email with your full pay details on payday":
		{
			translation:
				"Got it, you'll now get the extra-cool email with your full pay details on payday",
		},
	'Got it, you’ll now get the simple email without any pay details on payday.':
		{
			translation:
				'Got it, you’ll now get the simple email without any pay details on payday.',
		},
	"Got it. Don't show me this again.": {
		translation: "Got it. Don't show me this again.",
	},
	'Grace period notice': {
		translation: 'Grace period notice',
	},
	'Grade (1)': {
		translation: 'Grade (1)',
	},
	'Grade (2)': {
		translation: 'Grade (2)',
	},
	'Grade (3)': {
		translation: 'Grade (3)',
	},
	'Grade (4)': {
		translation: 'Grade (4)',
	},
	Graduated: {
		translation: 'Graduated',
	},
	'Grant Access': {
		translation: 'Grant Access',
	},
	'Grant Date': {
		translation: 'Grant Date',
	},
	'Grant Date and Vesting Start Date are required': {
		translation: 'Grant Date and Vesting Start Date are required',
	},
	'Grant Type': {
		translation: 'Grant Type',
	},
	'Grant Type is missing or is not supported': {
		translation: 'Grant Type is missing or is not supported',
	},
	'Grants the ability to login to Payroll administration from Bamboo Home and allows users to edit the tax state field on the pay info tab':
		{
			translation:
				'Grants the ability to login to Payroll administration from Bamboo Home and allows users to edit the tax state field on the pay info tab',
		},
	'Great Job! Keep up the good work.': {
		translation: 'Great Job! Keep up the good work.',
	},
	'Great Scott!': {
		translation: 'Great Scott!',
	},
	'Great day! None of these employeees is missing data.': {
		translation: 'Great day! None of these employees are missing data.',
	},
	'Great day! None of these employees is missing data.': {
		translation: 'Great day! None of these employees is missing data.',
	},
	'Great! From now on, new': {
		translation: 'Great! From now on, new',
	},
	'Great! We will get to work on collecting those funds. They will be pulled in the next 2-3 days.':
		{
			translation:
				'Great! We will get to work on collecting those funds. They will be pulled in the next 2-3 days.',
		},
	'Great! We will get to work on refunding those funds. They will be sent in the next 2-3 days.':
		{
			translation:
				'Great! We will get to work on refunding those funds. They will be sent in the next 2-3 days.',
		},
	"Great! We'll take care of the employees currently in this group.": {
		translation:
			"Great! We'll take care of the employees currently in this group.",
	},
	'Great, thanks': {
		translation: 'Great, thanks',
	},
	'Great, thanks!': {
		translation: 'Great, thanks!',
	},
	'Grid Container': {
		translation: 'Grid Container',
	},
	Gridlets: {
		translation: 'Gridlets',
	},
	'Gross Pay': {
		translation: 'Gross Pay',
	},
	'Gross Taxable Wage': {
		translation: 'Gross Taxable Wage',
	},
	Group: {
		translation: 'Group',
	},
	'Group %1': {
		translation: 'Group %1',
	},
	'Group By': {
		translation: 'Group By',
	},
	'Group Details': {
		translation: 'Group Details',
	},
	'Group Forms': {
		translation: 'Group Forms',
	},
	'Group Name': {
		translation: 'Group Name',
	},
	'Group Number': {
		translation: 'Group Number',
	},
	'Group Number cannot be changed.': {
		translation: 'Group Number cannot be changed.',
	},
	'Group Update': {
		translation: 'Group Update',
	},
	'Group by': {
		translation: 'Group by',
	},
	'Group by...': {
		translation: 'Group by...',
	},
	'Guess what else?': {
		translation: 'Guess what else?',
	},
	Gusto: {
		translation: 'Gusto',
	},
	'Gusto - Special Payroll': {
		translation: 'Gusto - Special Payroll',
	},
	'Gusto Configuration': {
		translation: 'Gusto Configuration',
	},
	'Gusto has been installed sucessfully!': {
		translation: 'Gusto has been installed sucessfully!',
	},
	'Gym Reimbursement': {
		translation: 'Gym Reimbursement',
	},
	'Gym Reimbursement Plan': {
		translation: 'Gym Reimbursement Plan',
	},
	H1B: {
		translation: 'H1B',
	},
	H2B: {
		translation: 'H2B',
	},
	'HACCP Trainer': {
		translation: 'HACCP Trainer',
	},
	'HDHP 1': {
		translation: 'HDHP 1',
	},
	'HDHP 1 Plan': {
		translation: 'HDHP 1 Plan',
	},
	'HDHP 2': {
		translation: 'HDHP 2',
	},
	'HDHP 2 2025': {
		translation: 'HDHP 2 2025',
	},
	'HIPAA Training': {
		translation: 'HIPAA Training',
	},
	'HR Administrator': {
		translation: 'HR Administrator',
	},
	'HR Note': {
		translation: 'HR Note',
	},
	'HR Notes': {
		translation: 'HR Notes',
	},
	'HR Specialist': {
		translation: 'HR Specialist',
	},
	HSA: {
		translation: 'HSA',
	},
	'HSA Account #': {
		translation: 'HSA Account #',
	},
	'HSA Plan': {
		translation: 'HSA Plan',
	},
	'HSI Jones Percent': {
		translation: 'HSI Jones Percent',
	},
	'Hair Color': {
		translation: 'Hair Color',
	},
	Happiness: {
		translation: 'Happiness',
	},
	'Happy %1 Anniversary, %2!': {
		translation: 'Happy %1 Anniversary, %2!',
	},
	'Happy Anniversary!': {
		translation: 'Happy Anniversary!',
	},
	'Happy Bambooing!': {
		translation: 'Happy Bambooing!',
	},
	'Happy Birthday %1!': {
		translation: 'Happy Birthday %1!',
	},
	'Happy Birthday!': {
		translation: 'Happy Birthday!',
	},
	Hardware: {
		translation: 'Hardware',
	},
	'Hardware (e.g. a physical time clock to clock in/out)': {
		translation: 'Hardware (e.g. a physical time clock to clock in/out)',
	},
	'Harrassment Training': {
		translation: 'Harrassment Training',
	},
	'Has Been Shared With You': {
		translation: 'Has Been Shared With You',
	},
	'Has Dependents': {
		translation: 'Has Dependents',
	},
	'Has Emergency Contact': {
		translation: 'Has Emergency Contact',
	},
	'Hasta lasagna.': {
		translation: 'Hasta lasagna.',
	},
	'Hasta luego.': {
		translation: 'Hasta luego.',
	},
	'Hat Size': {
		translation: 'Hat Size',
	},
	'Have Account Owner or Full Admin Access Level': {
		translation: 'Have Account Owner or Full Admin Access Level',
	},
	'Have Account Owner or Full Admin Access Level or Someone With Those Access Levels Has Shared This':
		{
			translation:
				'Have Account Owner or Full Admin Access Level or Someone With Those Access Levels Has Shared This',
		},
	'Have Account Owner, Full Admin or Payroll Admin Access Level': {
		translation: 'Have Account Owner, Full Admin or Payroll Admin Access Level',
	},
	'Have Payroll Admin Access Level': {
		translation: 'Have Payroll Admin Access Level',
	},
	'Have a good one!': {
		translation: 'Have a good one!',
	},
	'Have a lot of employees to update?': {
		translation: 'Have a lot of employees to update?',
	},
	'Have a lot of fields to fill in?': {
		translation: 'Have a lot of fields to fill in?',
	},
	'Have multiple signers for a single document (i.e. the Employee signs first, and then the document is sent to the Manager for their signature as well)':
		{
			translation:
				'Have multiple signers for a single document (i.e. the Employee signs first, and then the document is sent to the Manager for their signature as well)',
		},
	'He/him': {
		translation: 'He/him',
	},
	'He/they': {
		translation: 'He/they',
	},
	'Head of Household': {
		translation: 'Head of Household',
	},
	"Head's up!": {
		translation: "Head's up!",
	},
	"Head's up: Indeed has [search quality guidelines](1) that job postings must adhere to in order to be posted.":
		{
			translation:
				"Head's up: Indeed has [search quality guidelines](1) that job postings must adhere to in order to be posted.",
		},
	Headcount: {
		translation: 'Headcount',
	},
	'Headcount Report': {
		translation: 'Headcount Report',
	},
	'Headcount and Turnover': {
		translation: 'Headcount and Turnover',
	},
	'Headquarters Country': {
		translation: 'Headquarters Country',
	},
	'Heads Up': {
		translation: 'Heads Up',
	},
	'Heads up': {
		translation: 'Heads up',
	},
	'Heads up!': {
		translation: 'Heads up!',
	},
	'Heads up! If you sign your name (or use any other clearly distinguishing bit of information) the survey is no longer anonymous!':
		{
			translation:
				'Heads up! If you sign your name (or use any other clearly distinguishing bit of information) the survey is no longer anonymous!',
		},
	'Heads up! Only one file was uploaded, make sure it’s the one you want.': {
		translation:
			'Heads up! Only one file was uploaded, make sure it’s the one you want.',
	},
	"Heads up! This step can't be fully completed until everyone has their job information and a home address added in the [Employee Information] step.":
		{
			translation:
				"Heads up! This step can't be fully completed until everyone has their job information and a home address added in the [Employee Information] step.",
		},
	'Heads up: Indeed has [search quality guidelines] that job postings must adhere to in order to be posted.':
		{
			translation:
				'Heads up: Indeed has [search quality guidelines] that job postings must adhere to in order to be posted.',
		},
	'Heads up: Indeed has [search quality guidelines](1) that job postings must adhere to in order to be posted.':
		{
			translation:
				'Heads up: Indeed has [search quality guidelines](1) that job postings must adhere to in order to be posted.',
		},
	Health: {
		translation: 'Health',
	},
	'Health Insurance - CA': {
		translation: 'Health Insurance - CA',
	},
	'Health Insurance - Platinum': {
		translation: 'Health Insurance - Platinum',
	},
	'Health Plan': {
		translation: 'Health Plan',
	},
	'Health Savings': {
		translation: 'Health Savings',
	},
	'Health Savings Account': {
		translation: 'Health Savings Account',
	},
	'Heavy Equipment 1': {
		translation: 'Heavy Equipment 1',
	},
	'Heavy Equipment 1 Date': {
		translation: 'Heavy Equipment 1 Date',
	},
	'Heavy Equipment 2': {
		translation: 'Heavy Equipment 2',
	},
	'Heavy Equipment 2 Date': {
		translation: 'Heavy Equipment 2 Date',
	},
	'Heavy Equipment 3': {
		translation: 'Heavy Equipment 3',
	},
	'Heavy Equipment 3 Date': {
		translation: 'Heavy Equipment 3 Date',
	},
	'Heavy Equipment 4': {
		translation: 'Heavy Equipment 4',
	},
	'Heavy Equipment 4 Date': {
		translation: 'Heavy Equipment 4 Date',
	},
	'Heavy Equipment 5': {
		translation: 'Heavy Equipment 5',
	},
	'Heavy Equipment 5 Date': {
		translation: 'Heavy Equipment 5 Date',
	},
	'Heavy Equipment 6': {
		translation: 'Heavy Equipment 6',
	},
	'Heavy Equipment 6 Date': {
		translation: 'Heavy Equipment 6 Date',
	},
	'Heavy Equipment 7': {
		translation: 'Heavy Equipment 7',
	},
	'Heavy Equipment 7 Date': {
		translation: 'Heavy Equipment 7 Date',
	},
	Height: {
		translation: 'Height',
	},
	"Helium costs about $75.00 per 1,000 cubic feet. 1,000 cubic feet of helium is enough to lift 68 pounds into the air. Your paycheck could pay for enough helium to lift %1$s pounds into the air. (Don't try this at home).":
		{
			translation:
				"Helium costs about $75.00 per 1,000 cubic feet. 1,000 cubic feet of helium is enough to lift 68 pounds into the air. Your paycheck could pay for enough helium to lift %1$s pounds into the air. (Don't try this at home).",
		},
	'Help us Organize your Variable Rate Plans': {
		translation: 'Help us Organize your Variable Rate Plans',
	},
	'Hep B': {
		translation: 'Hep B',
	},
	'Hep B Vaccine': {
		translation: 'Hep B Vaccine',
	},
	'Here are some details about %1$s:': {
		translation: 'Here are some details about %1$s:',
	},
	'Here are some examples of non-benefit deductions that you should be considering':
		{
			translation:
				'Here are some examples of non-benefit deductions that you should be considering',
		},
	'Here is a copy of your completed account authorization forms. Keep these for your records.':
		{
			translation:
				'Here is a copy of your completed account authorization forms. Keep these for your records.',
		},
	'Here is a copy of your completed forms.': {
		translation: 'Here is a copy of your completed forms.',
	},
	'Here is the file: ': {
		translation: 'Here is the file: ',
	},
	"Here's a few helpful things to know as you get started.": {
		translation: "Here's a few helpful things to know as you get started.",
	},
	"Here's a little guide to finding your API key in BambooHR: http://go.payscale.com/ev0YeK01020LNj0eW6b6K0K":
		{
			translation:
				"Here's a little guide to finding your API key in BambooHR: http://go.payscale.com/ev0YeK01020LNj0eW6b6K0K",
		},
	"Here's a visual representation of your upcoming performance timeline.": {
		translation:
			"Here's a visual representation of your upcoming performance timeline.",
	},
	"Here's how this will go down: %s will have a new profile on the new job. The old profile will be archived, but will still be accessible from the new profile.":
		{
			translation:
				"Here's how this will go down: %s will have a new profile on the new job. The old profile will be archived, but will still be accessible from the new profile.",
		},
	"Here's how this will go down: these candidates will have new profiles on the new job. The old profiles will be archived, but will still be accessible from the new profile.":
		{
			translation:
				"Here's how this will go down: these candidates will have new profiles on the new job. The old profiles will be archived, but will still be accessible from the new profile.",
		},
	"Here's how this will go down: these candidates will have new profiles on the new job. The old profiles will be archived, but will still be accessilble from the new profile.":
		{
			translation:
				"Here's how this will go down: these candidates will have new profiles on the new job. The old profiles will be archived, but will still be accessilble from the new profile.",
		},
	"Here's how this will go down: {1} will have a new profile on the new job. The old profile will be archived, but will still be accessible from the new profile.":
		{
			translation:
				"Here's how this will go down: {1} will have a new profile on the new job. The old profile will be archived, but will still be accessible from the new profile.",
		},
	'Hey Team,': {
		translation: 'Hey Team,',
	},
	"Hey, where'd all the Offer Templates go?": {
		translation: "Hey, where'd all the Offer Templates go?",
	},
	Hi: {
		translation: 'Hi',
	},
	'Hi %1$s, you still need to complete your New Hire Packet.': {
		translation: 'Hi %1$s, you still need to complete your New Hire Packet.',
	},
	'Hi %s': {
		translation: 'Hi %s',
	},
	"Hi Team!\n\nAs you know, one of the most important things at %1$s is you! We care about you and the experiences that you have working at %2$s. To gain insight into places we're excelling and areas that we can improve, we will be conducting a super short employee survey. I promise it is short - like two questions short. The survey will be sent to your email tomorrow morning to complete.\n\nYour experience at %3$s is important to us, and this survey is a chance to share your thoughts. It's places like this where we learn what we can do to make %4$s even better.\n\nThank you.":
		{
			translation:
				"Hi Team!\n\nAs you know, one of the most important things at %1$s is you! We care about you and the experiences that you have working at %2$s. To gain insight into places we're excelling and areas that we can improve, we will be conducting a super short employee survey. I promise it is short - like two questions short. The survey will be sent to your email tomorrow morning to complete.\n\nYour experience at %3$s is important to us, and this survey is a chance to share your thoughts. It's places like this where we learn what we can do to make %4$s even better.\n\nThank you.",
		},
	'Hi, %s': {
		translation: 'Hi, %s',
	},
	'Hi,%s': {
		translation: 'Hi,%s',
	},
	'Hidden:': {
		translation: 'Hidden:',
	},
	Hide: {
		translation: 'Hide',
	},
	'Hide Answers': {
		translation: 'Hide Answers',
	},
	'Hide Archived': {
		translation: 'Hide Archived',
	},
	'Hide Full Job Description': {
		translation: 'Hide Full Job Description',
	},
	'Hide Import Details': {
		translation: 'Hide Import Details',
	},
	'Hide Previous Comments': {
		translation: 'Hide Previous Comments',
	},
	'Hide import details': {
		translation: 'Hide import details',
	},
	'High School': {
		translation: 'High School',
	},
	'High engagement and a great attitude.': {
		translation: 'High engagement and a great attitude.',
	},
	'Highest Average Scores': {
		translation: 'Highest Average Scores',
	},
	'Highest Completion': {
		translation: 'Highest Completion',
	},
	'Highest Education': {
		translation: 'Highest Education',
	},
	'Highest Education Obtained': {
		translation: 'Highest Education Obtained',
	},
	'Highest degree earned': {
		translation: 'Highest degree earned',
	},
	Hire: {
		translation: 'Hire',
	},
	'Hire %1$s': {
		translation: 'Hire %1$s',
	},
	'Hire Date': {
		translation: 'Hire Date',
	},
	'Hire Date (First Day)': {
		translation: 'Hire Date (First Day)',
	},
	'Hire Date cannot be empty': {
		translation: 'Hire Date cannot be empty',
	},
	'Hire Date is required': {
		translation: 'Hire Date is required',
	},
	'Hire Date(First Day)': {
		translation: 'Hire Date(First Day)',
	},
	'Hire Date: %s': {
		translation: 'Hire Date: %s',
	},
	'Hire Dates': {
		translation: 'Hire Dates',
	},
	'Hire date': {
		translation: 'Hire date',
	},
	'Hire date cannot be empty': {
		translation: 'Hire date cannot be empty',
	},
	'Hire date is required and must be in the format mm-dd-yyyy or mm/dd/yyyy.': {
		translation:
			'Hire date is required and must be in the format mm-dd-yyyy or mm/dd/yyyy.',
	},
	'Hire dates help us to calculate things like accrual rates.': {
		translation: 'Hire dates help us to calculate things like accrual rates.',
	},
	Hired: {
		translation: 'Hired',
	},
	'Hired %1$s': {
		translation: 'Hired %1$s',
	},
	'Hired Declined to Answer': {
		translation: 'Hired Declined to Answer',
	},
	'Hired Elsewhere': {
		translation: 'Hired Elsewhere',
	},
	'Hired Female': {
		translation: 'Hired Female',
	},
	'Hired Male': {
		translation: 'Hired Male',
	},
	'Hired by %s': {
		translation: 'Hired by %s',
	},
	'Hired for **{1}**': {
		translation: 'Hired for **{1}**',
	},
	'Hired for [**{1}**]': {
		translation: 'Hired for [**{1}**]',
	},
	'Hired on %s': {
		translation: 'Hired on %s',
	},
	Hires: {
		translation: 'Hires',
	},
	Hiring: {
		translation: 'Hiring',
	},
	'Hiring Candidates': {
		translation: 'Hiring Candidates',
	},
	'Hiring Lead': {
		translation: 'Hiring Lead',
	},
	'Hiring Lead Email': {
		translation: 'Hiring Lead Email',
	},
	'Hiring Lead Extension': {
		translation: 'Hiring Lead Extension',
	},
	'Hiring Lead First & Last Name': {
		translation: 'Hiring Lead First & Last Name',
	},
	'Hiring Lead First Name': {
		translation: 'Hiring Lead First Name',
	},
	'Hiring Lead Job Title': {
		translation: 'Hiring Lead Job Title',
	},
	'Hiring Lead Last Name': {
		translation: 'Hiring Lead Last Name',
	},
	'Hiring Lead Name': {
		translation: 'Hiring Lead Name',
	},
	'Hiring Lead Phone Number': {
		translation: 'Hiring Lead Phone Number',
	},
	'Hiring Manager': {
		translation: 'Hiring Manager',
	},
	'Hiring Positions': {
		translation: 'Hiring Positions',
	},
	'Hiring Settings': {
		translation: 'Hiring Settings',
	},
	'HiringThing is an easy-to-use online hiring solution that gives users the tools they need to hire the right people quickly and effectively. Our free trial provides companies the opportunity to see just how easy it is to post jobs online as well as rate, categorize and analyze applicants. All plans include unlimited users and unlimited job applicants. And our streamlined integration with BambooHR means you can easily merge applicant data from HiringThing into your BambooHR account in seconds.':
		{
			translation:
				'HiringThing is an easy-to-use online hiring solution that gives users the tools they need to hire the right people quickly and effectively. Our free trial provides companies the opportunity to see just how easy it is to post jobs online as well as rate, categorize and analyze applicants. All plans include unlimited users and unlimited job applicants. And our streamlined integration with BambooHR means you can easily merge applicant data from HiringThing into your BambooHR account in seconds.',
		},
	'HiringThing will automatically push new hires into BambooHR when "Hired" in the applicant viewer. Pushed fields include First name, Last name, Home phone, Hire date, and Job title.':
		{
			translation:
				'HiringThing will automatically push new hires into BambooHR when \\"Hired\\" in the applicant viewer. Pushed fields include First name, Last name, Home phone, Hire date, and Job title.',
		},
	'Hispanic or Latino': {
		translation: 'Hispanic or Latino',
	},
	History: {
		translation: 'History',
	},
	'Hmm we expereinced a hiccupp, maybe try again?': {
		translation: 'Hmm we expereinced a hiccupp, maybe try again?',
	},
	'Hmm, we’re not feeling a connection.': {
		translation: 'Hmm, we’re not feeling a connection.',
	},
	"Hmm... It doesn't look like you currently have<br/>any applicants matching that status.":
		{
			translation:
				"Hmm... It doesn't look like you currently have<br/>any applicants matching that status.",
		},
	"Hmm... It looks like you currently don't have<br/>any <span class='semibold'>%s</span> Job Openings":
		{
			translation:
				"Hmm... It looks like you currently don't have<br/>any <span class='semibold'>%s</span> Job Openings",
		},
	"Hmm... We couldn't load more records. Please try again.": {
		translation: "Hmm... We couldn't load more records. Please try again.",
	},
	'Hold On. Not So Fast.': {
		translation: 'Hold On. Not So Fast.',
	},
	'Hold Up...': {
		translation: 'Hold Up...',
	},
	'Hold on!': {
		translation: 'Hold on!',
	},
	"Hold on, something's missing here": {
		translation: "Hold on, something's missing here",
	},
	'Hold on. Not so fast...': {
		translation: 'Hold on. Not so fast...',
	},
	'Hold up, partner!': {
		translation: 'Hold up, partner!',
	},
	'Hold up...': {
		translation: 'Hold up...',
	},
	Holiday: {
		translation: 'Holiday',
	},
	'Holiday (%1$sx)': {
		translation: 'Holiday (%1$sx)',
	},
	'Holiday Name': {
		translation: 'Holiday Name',
	},
	'Holiday PTO': {
		translation: 'Holiday PTO',
	},
	'Holiday Pay': {
		translation: 'Holiday Pay',
	},
	'Holiday Rate': {
		translation: 'Holiday Rate',
	},
	'Holiday hours and rates are set up in the %1sHolidays%2s settings.': {
		translation:
			'Holiday hours and rates are set up in the %1sHolidays%2s settings.',
	},
	Holidays: {
		translation: 'Holidays',
	},
	'Holidays are set up in the %1sHolidays%2s settings.': {
		translation: 'Holidays are set up in the %1sHolidays%2s settings.',
	},
	Home: {
		translation: 'Home',
	},
	'Home #': {
		translation: 'Home #',
	},
	'Home Email': {
		translation: 'Home Email',
	},
	'Home Page Widgets': {
		translation: 'Home Page Widgets',
	},
	'Home Phone': {
		translation: 'Home Phone',
	},
	'Home Static HTML': {
		translation: 'Home Static HTML',
	},
	'Home Widgets': {
		translation: 'Home Widgets',
	},
	'Home email is invalid': {
		translation: 'Home email is invalid',
	},
	'Home or Work Email is required': {
		translation: 'Home or Work Email is required',
	},
	'Home phone': {
		translation: 'Home phone',
	},
	Hometown: {
		translation: 'Hometown',
	},
	Hoodie: {
		translation: 'Hoodie',
	},
	'Hooray! Your account has been customized for your company.': {
		translation: 'Hooray! Your account has been customized for your company.',
	},
	'Hospital Indemnity': {
		translation: 'Hospital Indemnity',
	},
	'Hospital Indemnity - Pre-Tax': {
		translation: 'Hospital Indemnity - Pre-Tax',
	},
	'Hospital Indemnity 2025': {
		translation: 'Hospital Indemnity 2025',
	},
	'Host:': {
		translation: 'Host:',
	},
	Hour: {
		translation: 'Hour',
	},
	'Hour Type': {
		translation: 'Hour Type',
	},
	'Hour Type Name': {
		translation: 'Hour Type Name',
	},
	'Hourglass icon': {
		translation: 'Hourglass icon',
	},
	Hourly: {
		translation: 'Hourly',
	},
	'Hourly employees must be paid per hour.': {
		translation: 'Hourly employees must be paid per hour.',
	},
	'Hourly pay types require a paid per of Hour': {
		translation: 'Hourly pay types require a paid per of Hour',
	},
	Hours: {
		translation: 'Hours',
	},
	'Hours Date': {
		translation: 'Hours Date',
	},
	'Hours Per Pay Cycle': {
		translation: 'Hours Per Pay Cycle',
	},
	'Hours Per Week': {
		translation: 'Hours Per Week',
	},
	'Hours Worked': {
		translation: 'Hours Worked',
	},
	'Hours Worked Date': {
		translation: 'Hours Worked Date',
	},
	'Hours accrued': {
		translation: 'Hours accrued',
	},
	'Hours are ready for your approval.': {
		translation: 'Hours are ready for your approval.',
	},
	'Hours for %1 are ready for approval.': {
		translation: 'Hours for %1 are ready for approval.',
	},
	'Hours for this person were just updated. This is the new %s total.': {
		translation:
			'Hours for this person were just updated. This is the new %s total.',
	},
	'Hours for week': {
		translation: 'Hours for week',
	},
	'Hours have changed': {
		translation: 'Hours have changed',
	},
	'Hours ready for approval': {
		translation: 'Hours ready for approval',
	},
	'Hours scheduled': {
		translation: 'Hours scheduled',
	},
	'Hours taken (YTD)': {
		translation: 'Hours taken (YTD)',
	},
	'Hours were not saved': {
		translation: 'Hours were not saved',
	},
	'Hours:': {
		translation: 'Hours:',
	},
	Housing: {
		translation: 'Housing',
	},
	'How Are You Doing?': {
		translation: 'How Are You Doing?',
	},
	'How To Use Gusto With BambooHR': {
		translation: 'How To Use Gusto With BambooHR',
	},
	'How are Things Going?': {
		translation: 'How are Things Going?',
	},
	'How are Your Goals Coming Along?': {
		translation: 'How are Your Goals Coming Along?',
	},
	'How are hourly employees paid on holidays?': {
		translation: 'How are hourly employees paid on holidays?',
	},
	'How can we help you?': {
		translation: 'How can we help you?',
	},
	'How can we help?': {
		translation: 'How can we help?',
	},
	'How could %s improve as a manager?': {
		translation: 'How could %s improve as a manager?',
	},
	'How could %s improve?': {
		translation: 'How could %s improve?',
	},
	'How could I improve?': {
		translation: 'How could I improve?',
	},
	'How could [Name] improve?': {
		translation: 'How could [Name] improve?',
	},
	'How could the employees improve?': {
		translation: 'How could the employees improve?',
	},
	'How do employees log time at your company?': {
		translation: 'How do employees log time at your company?',
	},
	'How do you know who should be in this benefit group?': {
		translation: 'How do you know who should be in this benefit group?',
	},
	'How engaged are employees at work?': {
		translation: 'How engaged are employees at work?',
	},
	'How engaged is %s at work?': {
		translation: 'How engaged is %s at work?',
	},
	'How engaged is [Name] at work?': {
		translation: 'How engaged is [Name] at work?',
	},
	'How is eNPS Calculated?': {
		translation: 'How is eNPS Calculated?',
	},
	'How is this calculated?': {
		translation: 'How is this calculated?',
	},
	'How it Works': {
		translation: 'How it Works',
	},
	'How likely are you to recommend %1 as a place to work?': {
		translation: 'How likely are you to recommend %1 as a place to work?',
	},
	'How long did you work today?': {
		translation: 'How long did you work today?',
	},
	'How long should each review period be?': {
		translation: 'How long should each review period be?',
	},
	'How many employees are included in this report?': {
		translation: 'How many employees are included in this report?',
	},
	'How many entries will be recorded per day?': {
		translation: 'How many entries will be recorded per day?',
	},
	'How many hours in a day?': {
		translation: 'How many hours in a day?',
	},
	'How many work hours in a day?': {
		translation: 'How many work hours in a day?',
	},
	'How much will they pay?': {
		translation: 'How much will they pay?',
	},
	'How often do you want managers to get peer feedback on their direct reports?':
		{
			translation:
				'How often do you want managers to get peer feedback on their direct reports?',
		},
	'How often do you want managers to request feedback on their direct reports?':
		{
			translation:
				'How often do you want managers to request feedback on their direct reports?',
		},
	'How often does this deduction occur?': {
		translation: 'How often does this deduction occur?',
	},
	'How often will deductions happen?': {
		translation: 'How often will deductions happen?',
	},
	'How should this change occur?': {
		translation: 'How should this change occur?',
	},
	'How sweet it is!': {
		translation: 'How sweet it is!',
	},
	'How to Install': {
		translation: 'How to Install',
	},
	'How to Use': {
		translation: 'How to Use',
	},
	'How well does %1 recognize my value?': {
		translation: 'How well does %1 recognize my value?',
	},
	'How well does %s recognize my value?': {
		translation: 'How well does %s recognize my value?',
	},
	'How well does [Company] recognize my value?': {
		translation: 'How well does [Company] recognize my value?',
	},
	'How well does the company recognize my value?': {
		translation: 'How well does the company recognize my value?',
	},
	'How will they pay?': {
		translation: 'How will they pay?',
	},
	'How will time be logged?': {
		translation: 'How will time be logged?',
	},
	'How would you like the results sorted?': {
		translation: 'How would you like the results sorted?',
	},
	'How would you like to edit this information?': {
		translation: 'How would you like to edit this information?',
	},
	"How's this calculated?": {
		translation: "How's this calculated?",
	},
	'However, ': {
		translation: 'However, ',
	},
	'However, an option to login using email & password instead of SSO can be enabled by checking the box below.':
		{
			translation:
				'However, an option to login using email & password instead of SSO can be enabled by checking the box below.',
		},
	'Huh? Something went wrong while accepting the Data Processing Agreement. Please contact support.':
		{
			translation:
				'Huh? Something went wrong while accepting the Data Processing Agreement. Please contact support.',
		},
	'Human Resources': {
		translation: 'Human Resources',
	},
	Husband: {
		translation: 'Husband',
	},
	Hybrid: {
		translation: 'Hybrid',
	},
	'I Understand, Let Me Edit It': {
		translation: 'I Understand, Let Me Edit It',
	},
	'I agree to electronically signing the document according to section 16 of the <a href="https://www.bamboohr.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of Service</a>.':
		{
			translation:
				'I agree to electronically signing the document according to section 16 of the <a href=\\"https://www.bamboohr.com/terms-of-service/\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Terms of Service</a>.',
		},
	'I agree to electronically signing the document according to the <a href="https://www.bamboohr.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of Service</a>.':
		{
			translation:
				'I agree to electronically signing the document according to the <a href=\\"https://www.bamboohr.com/terms-of-service/\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Terms of Service</a>.',
		},
	'I agree to electronically signing the document according to the [Terms of Service].':
		{
			translation:
				'I agree to electronically signing the document according to the [Terms of Service].',
		},
	'I agree to the <a href="https://www.bamboohr.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions':
		{
			translation:
				'I agree to the <a href=\\"https://www.bamboohr.com/terms-of-service/\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Terms &amp; Conditions',
		},
	'I agree to the <a href="https://www.bamboohr.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>':
		{
			translation:
				'I agree to the <a href=\\"https://www.bamboohr.com/terms-of-service/\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Terms &amp; Conditions</a>',
		},
	'I agree to the Data Processing Agreement': {
		translation: 'I agree to the Data Processing Agreement',
	},
	'I agree to the Terms of Use': {
		translation: 'I agree to the Terms of Use',
	},
	'I also want a paper copy mailed to me at the end of each year.': {
		translation:
			'I also want a paper copy mailed to me at the end of each year.',
	},
	'I am enthusiastic about my job': {
		translation: 'I am enthusiastic about my job',
	},
	'I am excited about my job': {
		translation: 'I am excited about my job',
	},
	'I am given clear signals about what is expected of me': {
		translation: 'I am given clear signals about what is expected of me',
	},
	'I am optimistic at work': {
		translation: 'I am optimistic at work',
	},
	'I am proud of the work I do': {
		translation: 'I am proud of the work I do',
	},
	'I don’t feel valued at %s.': {
		translation: 'I don’t feel valued at %s.',
	},
	'I enjoy being with my coworkers': {
		translation: 'I enjoy being with my coworkers',
	},
	'I feel I am highly valued.': {
		translation: 'I feel I am highly valued.',
	},
	'I feel a sense of comradery with my colleagues': {
		translation: 'I feel a sense of comradery with my colleagues',
	},
	'I feel comfortable providing feedback to my supervisor': {
		translation: 'I feel comfortable providing feedback to my supervisor',
	},
	'I feel inspired in my job': {
		translation: 'I feel inspired in my job',
	},
	'I feel personal achievement in my role': {
		translation: 'I feel personal achievement in my role',
	},
	'I feel supported by my supervisor': {
		translation: 'I feel supported by my supervisor',
	},
	'I found several matches for your search: `%1$s`!': {
		translation: 'I found several matches for your search: `%1$s`!',
	},
	'I have a close friend at the company that I can confide in': {
		translation: 'I have a close friend at the company that I can confide in',
	},
	'I have a sense of personal investment in my role': {
		translation: 'I have a sense of personal investment in my role',
	},
	'I have access to someone who can help me when I’m stuck': {
		translation: 'I have access to someone who can help me when I’m stuck',
	},
	"I have more plans to add before I'm ready to apply them to my employees.": {
		translation:
			"I have more plans to add before I'm ready to apply them to my employees.",
	},
	'I have people to confide in at work': {
		translation: 'I have people to confide in at work',
	},
	'I have positive relationships at work': {
		translation: 'I have positive relationships at work',
	},
	'I have read and accept this offer of employment': {
		translation: 'I have read and accept this offer of employment',
	},
	'I often feel passionate about my work': {
		translation: 'I often feel passionate about my work',
	},
	'I receive recognition and praise for my work': {
		translation: 'I receive recognition and praise for my work',
	},
	'I regularly receive recognition from my manager': {
		translation: 'I regularly receive recognition from my manager',
	},
	'I sometimes feel valued.': {
		translation: 'I sometimes feel valued.',
	},
	'I think you are asking about %1$s:': {
		translation: 'I think you are asking about %1$s:',
	},
	'I understand, let me edit it': {
		translation: 'I understand, let me edit it',
	},
	'I will send a New Hire Packet to this employee requesting they fill out their %1s':
		{
			translation:
				'I will send a New Hire Packet to this employee requesting they fill out their %1s',
		},
	"I'd prefer a paper check": {
		translation: "I'd prefer a paper check",
	},
	"I'll Fix It": {
		translation: "I'll Fix It",
	},
	"I'll Update Our Info": {
		translation: "I'll Update Our Info",
	},
	"I'll fix it": {
		translation: "I'll fix it",
	},
	"I'm Done": {
		translation: "I'm Done",
	},
	"I'm not quite ready": {
		translation: "I'm not quite ready",
	},
	"I'm not sure others value what I do.": {
		translation: "I'm not sure others value what I do.",
	},
	"I'm requesting %1$s day of %2$s for %3$s.": {
		translation: {
			one: "I'm requesting %1$s day of %2$s for %3$s.",
			other: "I'm requesting %1$s days of %2$s for %3$s.",
		},
	},
	"I'm requesting %1$s hour of %2$s for %3$s.": {
		translation: {
			one: "I'm requesting %1$s hour of %2$s for %3$s.",
			other: "I'm requesting %1$s hours of %2$s for %3$s.",
		},
	},
	"I'm requesting a %1$s Change for %2$s.": {
		translation: "I'm requesting a %1$s Change for %2$s.",
	},
	"I'm requesting an %1$s Change for %2$s.": {
		translation: "I'm requesting an %1$s Change for %2$s.",
	},
	"I'm requesting an update to my personal information.": {
		translation: "I'm requesting an update to my personal information.",
	},
	"I'm requesting time off for %1$s.": {
		translation: "I'm requesting time off for %1$s.",
	},
	"I'm sorry! I didn't understand your query: `%1$s`": {
		translation: "I'm sorry! I didn't understand your query: `%1$s`",
	},
	"I've added all of my plans. I'm ready to apply them to my employees.": {
		translation:
			"I've added all of my plans. I'm ready to apply them to my employees.",
	},
	"I've assigned an offboarding task for %1$s to you.": {
		translation: "I've assigned an offboarding task for %1$s to you.",
	},
	"I've assigned an offboarding task to you.": {
		translation: "I've assigned an offboarding task to you.",
	},
	"I've assigned an onboarding task for %1$s to you.": {
		translation: "I've assigned an onboarding task for %1$s to you.",
	},
	'I-9': {
		translation: 'I-9',
	},
	'I-9 on file': {
		translation: 'I-9 on file',
	},
	'I9 Docs Expire Date': {
		translation: 'I9 Docs Expire Date',
	},
	'I9 Docs Presented': {
		translation: 'I9 Docs Presented',
	},
	IC: {
		translation: 'IC',
	},
	ID: {
		translation: 'ID',
	},
	'ID Badge': {
		translation: 'ID Badge',
	},
	'IHC #': {
		translation: 'IHC #',
	},
	'IP Address': {
		translation: 'IP Address',
	},
	'IRS mandated max contribution invalid.': {
		translation: 'IRS mandated max contribution invalid.',
	},
	'IRS mandated max contribution is %1': {
		translation: 'IRS mandated max contribution is %1',
	},
	ISO: {
		translation: 'ISO',
	},
	IT: {
		translation: 'IT',
	},
	'IT Security Engineer': {
		translation: 'IT Security Engineer',
	},
	Icon: {
		translation: 'Icon',
	},
	Icons: {
		translation: 'Icons',
	},
	'Identification (DL/Passport)': {
		translation: 'Identification (DL/Passport)',
	},
	'If %1 is flexible (e.g. unlimited) no policy is needed.': {
		translation: 'If %1 is flexible (e.g. unlimited) no policy is needed.',
	},
	'If %s got a job offer elsewhere, I would...': {
		translation: 'If %s got a job offer elsewhere, I would...',
	},
	'If [Name] got a job offer elsewhere, I would...': {
		translation: 'If [Name] got a job offer elsewhere, I would...',
	},
	'If a pay day lands on a weekend or federal holiday?': {
		translation: 'If a pay day lands on a weekend or federal holiday?',
	},
	'If an employee from your BambooHR account has not been set up in Boomr and you would like to add them, simply select "Add this employee". Leave the drop down set to "Ignore" for any employees that you do not want to set up in Boomr. Make sure to click the "Save" button in the bottom left-hand corner after you have finished matching and adding employees.':
		{
			translation:
				'If an employee from your BambooHR account has not been set up in Boomr and you would like to add them, simply select \\"Add this employee\\". Leave the drop down set to \\"Ignore\\" for any employees that you do not want to set up in Boomr. Make sure to click the \\"Save\\" button in the bottom left-hand corner after you have finished matching and adding employees.',
		},
	'If an employee got a job offer elsewhere, I would...': {
		translation: 'If an employee got a job offer elsewhere, I would...',
	},
	'If employees got job offers elsewhere, we would...': {
		translation: 'If employees got job offers elsewhere, we would...',
	},
	"If it's helpful, you can also use the [benefits power edit] tool to update multiple employees' information at once.":
		{
			translation:
				"If it's helpful, you can also use the [benefits power edit] tool to update multiple employees' information at once.",
		},
	'If so, it may be quicker to use the employee import tool (basically, importing a spreadsheet)':
		{
			translation:
				'If so, it may be quicker to use the employee import tool (basically, importing a spreadsheet)',
		},
	'If so, it may be quicker to use the federal withholding importer tool (this only works for federal withholding right now)':
		{
			translation:
				'If so, it may be quicker to use the federal withholding importer tool (this only works for federal withholding right now)',
		},
	'If so, let your manager know and they can correct your timesheet.': {
		translation:
			'If so, let your manager know and they can correct your timesheet.',
	},
	'If the filters are correct:': {
		translation: 'If the filters are correct:',
	},
	'If they are also in a Custom Access Level, their permissions will be combined.':
		{
			translation:
				'If they are also in a Custom Access Level, their permissions will be combined.',
		},
	'If you are able to make the switch to one of these browsers, you will enjoy a more robust and secure experience using BambooHR, in addition to many other modern web applications.':
		{
			translation:
				'If you are able to make the switch to one of these browsers, you will enjoy a more robust and secure experience using BambooHR, in addition to many other modern web applications.',
		},
	'If you are sure the address is correct, **get in touch with us as soon as possible at 866-872-9123** or **[payrollhelp@bamboohr.com]**':
		{
			translation:
				'If you are sure the address is correct, **get in touch with us as soon as possible at 866-872-9123** or **[payrollhelp@bamboohr.com]**',
		},
	'If you can use PowerPoint, you can use OrgChart Now. OrgChart Now is both simple and powerful. ':
		{
			translation:
				'If you can use PowerPoint, you can use OrgChart Now. OrgChart Now is both simple and powerful. ',
		},
	"If you cashed out this paycheck in dollar bills, your stack would be about %1$s inches tall. Don't forget to put some of that dough aside for a new wallet.":
		{
			translation:
				"If you cashed out this paycheck in dollar bills, your stack would be about %1$s inches tall. Don't forget to put some of that dough aside for a new wallet.",
		},
	'If you change any information in step one or two you will lose any changes that you have made in this step.':
		{
			translation:
				'If you change any information in step one or two you will lose any changes that you have made in this step.',
		},
	'If you change any information in step one or two, you will lose any changes that you have made in this step.':
		{
			translation:
				'If you change any information in step one or two, you will lose any changes that you have made in this step.',
		},
	'If you change this URL you change the address where %1$s and its employees will access their account.':
		{
			translation:
				'If you change this URL you change the address where %1$s and its employees will access their account.',
		},
	'If you change your approvals configuration, all current approvals will be deleted for "%1"':
		{
			translation:
				'If you change your approvals configuration, all current approvals will be deleted for \\"%1\\"',
		},
	'If you change your approvals configuration, all current approvals will be deleted.':
		{
			translation:
				'If you change your approvals configuration, all current approvals will be deleted.',
		},
	'If you continue, **{1} employees** will be unenrolled and ineligible for this plan.':
		{
			translation:
				'If you continue, **{1} employees** will be unenrolled and ineligible for this plan.',
		},
	'If you continue, the filters that you’ve set will be discarded.': {
		translation:
			'If you continue, the filters that you’ve set will be discarded.',
	},
	"If you decide you don't like it, just click the link at the bottom of the email to switch back to the simple email with no amounts.":
		{
			translation:
				"If you decide you don't like it, just click the link at the bottom of the email to switch back to the simple email with no amounts.",
		},
	'If you decide you don’t like it, just click the link at the bottom of the email to switch back to the fancy email with your pay details.':
		{
			translation:
				'If you decide you don’t like it, just click the link at the bottom of the email to switch back to the fancy email with your pay details.',
		},
	"If you do not see it in this list, it's likely archived.": {
		translation: "If you do not see it in this list, it's likely archived.",
	},
	"If you don't see your jobs posted within 48 hours, contact Indeed to submit a visibility request.":
		{
			translation:
				"If you don't see your jobs posted within 48 hours, contact Indeed to submit a visibility request.",
		},
	'If you got this check 100 years ago, you would be able to buy %1$s Ford Model T’s and still have some change leftover (at $440.00 a pop). Joyride, anyone?':
		{
			translation:
				'If you got this check 100 years ago, you would be able to buy %1$s Ford Model T’s and still have some change leftover (at $440.00 a pop). Joyride, anyone?',
		},
	'If you got this check 100 years ago, you would be able to buy %1$s eggs with it (at $0.14 a dozen). That’s a whole lotta’ omelets.':
		{
			translation:
				'If you got this check 100 years ago, you would be able to buy %1$s eggs with it (at $0.14 a dozen). That’s a whole lotta’ omelets.',
		},
	"If you got this check 100 years ago, you would be able to buy %1$s lbs of bacon (at $.27 per pound). Now that's bringing home the bacon!":
		{
			translation:
				"If you got this check 100 years ago, you would be able to buy %1$s lbs of bacon (at $.27 per pound). Now that's bringing home the bacon!",
		},
	'If you have any additional questions or would like to subscribe, you can call us at 1-866-387-9595':
		{
			translation:
				'If you have any additional questions or would like to subscribe, you can call us at 1-866-387-9595',
		},
	'If you have any question about whether this plan should be reported on the W-2, please check with your provider, broker, or attorney.':
		{
			translation:
				'If you have any question about whether this plan should be reported on the W-2, please check with your provider, broker, or attorney.',
		},
	"If you have any questions, please don't hesitate to ask.": {
		translation: "If you have any questions, please don't hesitate to ask.",
	},
	"If you have kept this information in a custom table, it won't be brought into BambooHR Payroll":
		{
			translation:
				"If you have kept this information in a custom table, it won't be brought into BambooHR Payroll",
		},
	"If you have kept this information in a custom table, remember that it won't be carried over into BambooHR Payroll":
		{
			translation:
				"If you have kept this information in a custom table, remember that it won't be carried over into BambooHR Payroll",
		},
	'If you move them from another Group, they will lose the benefits of their previous group.':
		{
			translation:
				'If you move them from another Group, they will lose the benefits of their previous group.',
		},
	'If you need assistance doing your ACA filing, we recommend you reach out to an expert service such as BambooHR’s trusted partner [ACA Reporting Service](1).':
		{
			translation:
				'If you need assistance doing your ACA filing, we recommend you reach out to an expert service such as BambooHR’s trusted partner [ACA Reporting Service](1).',
		},
	'If you need help setting up your integration, troubleshooting, or getting your PlanSource account configured please reach out to us by phone at 1-877-549-8549 or by email at <a href="mailto:service@plansource.com">service@plansource.com</a>. Our Support Hours are 8:00AM - 11:00PM EST, Monday - Friday.':
		{
			translation:
				'If you need help setting up your integration, troubleshooting, or getting your PlanSource account configured please reach out to us by phone at 1-877-549-8549 or by email at <a href=\\"mailto:service@plansource.com\\">service@plansource.com</a>. Our Support Hours are 8:00AM - 11:00PM EST, Monday - Friday.',
		},
	'If you need help, please contact your customer success manager or email <a href="mailto:CS@payscale.com">CS@payscale.com</a>.':
		{
			translation:
				'If you need help, please contact your customer success manager or email <a href=\\"mailto:CS@payscale.com\\">CS@payscale.com</a>.',
		},
	'If you need to make a change, click the link below.': {
		translation: 'If you need to make a change, click the link below.',
	},
	'If you need to make any tweaks, use the settings below.': {
		translation: 'If you need to make any tweaks, use the settings below.',
	},
	'If you proceed with current filters, these employees will be included in benefits.':
		{
			translation:
				'If you proceed with current filters, these employees will be included in benefits.',
		},
	'If you use employment status, department, division, location, or pay type to determine who gets benefits, new employees will automatically be eligible.':
		{
			translation:
				'If you use employment status, department, division, location, or pay type to determine who gets benefits, new employees will automatically be eligible.',
		},
	"If you want employees to receive feedback, make sure it's enabled above.": {
		translation:
			"If you want employees to receive feedback, make sure it's enabled above.",
	},
	"If you'd like employees & managers to conduct assessments, make sure it's enabled above.":
		{
			translation:
				"If you'd like employees & managers to conduct assessments, make sure it's enabled above.",
		},
	"If you'd like to convert this time off type to days, first edit or delete the policy.":
		{
			translation:
				"If you'd like to convert this time off type to days, first edit or delete the policy.",
		},
	'If you\'d like to learn more about Bridge, click the "Request Info" button on the left and a Bridge representative will be in touch shortly.':
		{
			translation:
				'If you\'d like to learn more about Bridge, click the \\"Request Info\\" button on the left and a Bridge representative will be in touch shortly.',
		},
	"If you'd like to send over data for all employees, check one or both boxes below and click Synchronize Now.":
		{
			translation:
				"If you'd like to send over data for all employees, check one or both boxes below and click Synchronize Now.",
		},
	"If you'd rather, you can": {
		translation: "If you'd rather, you can",
	},
	"If you're able to make the switch to one of these browsers, you will enjoy a more robust and secure experience using BambooHR, in addition to many other modern web applications":
		{
			translation:
				"If you're able to make the switch to one of these browsers, you will enjoy a more robust and secure experience using BambooHR, in addition to many other modern web applications",
		},
	"If you're an existing BambooHR & Bridge LMS customer, please contact your Bridge Implementation Consultant for help configuring this integration.":
		{
			translation:
				"If you're an existing BambooHR & Bridge LMS customer, please contact your Bridge Implementation Consultant for help configuring this integration.",
		},
	"If you're not sure what to choose, check out %1$sthis helpful guide%2$s from the Department of Labor.":
		{
			translation:
				"If you're not sure what to choose, check out %1$sthis helpful guide%2$s from the Department of Labor.",
		},
	"If you're not sure why, you can contact the HR administrator at %s.": {
		translation:
			"If you're not sure why, you can contact the HR administrator at %s.",
	},
	'If you\'ve added all of your company\'s plans, the best thing to do now is to add <span class="semibold">Benefit Groups.</span>':
		{
			translation:
				'If you\'ve added all of your company\'s plans, the best thing to do now is to add <span class=\\"semibold\\">Benefit Groups.</span>',
		},
	"If you've connected BambooHR to a payroll system, not having these plans in place and updated accordingly could negatively impact your employee's payroll.":
		{
			translation:
				"If you've connected BambooHR to a payroll system, not having these plans in place and updated accordingly could negatively impact your employee's payroll.",
		},
	"If your data looks good, complete the import now. We'll then pull your data into your account and you'll be all set.":
		{
			translation:
				"If your data looks good, complete the import now. We'll then pull your data into your account and you'll be all set.",
		},
	'If your policy allows for employees to earn at different rates based on their length of service, you can manipulate the rate this employee is eligible for by adjusting the Accrual Level Start Date below.':
		{
			translation:
				'If your policy allows for employees to earn at different rates based on their length of service, you can manipulate the rate this employee is eligible for by adjusting the Accrual Level Start Date below.',
		},
	'If your time needs to be adjusted, contact your manager or HR administrator.':
		{
			translation:
				'If your time needs to be adjusted, contact your manager or HR administrator.',
		},
	'If you’re ever stuck, you can reach out to PayScale: Email: <a href="mailto:CS@payscale.com">CS@payscale.com</a> Phone: 1-888-219-0327':
		{
			translation:
				'If you’re ever stuck, you can reach out to PayScale: Email: <a href=\\"mailto:CS@payscale.com\\">CS@payscale.com</a> Phone: 1-888-219-0327',
		},
	'Ignore Filing Status and Exemptions': {
		translation: 'Ignore Filing Status and Exemptions',
	},
	'Ignore filing status/other adjustments': {
		translation: 'Ignore filing status/other adjustments',
	},
	'Ignore unknown list values': {
		translation: 'Ignore unknown list values',
	},
	Illness: {
		translation: 'Illness',
	},
	'Illness in the family': {
		translation: 'Illness in the family',
	},
	Immediately: {
		translation: 'Immediately',
	},
	'Immediately after a waiting period': {
		translation: 'Immediately after a waiting period',
	},
	'Immediately upon hire': {
		translation: 'Immediately upon hire',
	},
	'Impact of Departure': {
		translation: 'Impact of Departure',
	},
	Implementation: {
		translation: 'Implementation',
	},
	'Implementation Outline': {
		translation: 'Implementation Outline',
	},
	'Implementation Progress': {
		translation: 'Implementation Progress',
	},
	Import: {
		translation: 'Import',
	},
	'Import Complete': {
		translation: 'Import Complete',
	},
	'Import Date': {
		translation: 'Import Date',
	},
	'Import Employee Benefit Data': {
		translation: 'Import Employee Benefit Data',
	},
	'Import Employee Benefit Data(new)': {
		translation: 'Import Employee Benefit Data(new)',
	},
	'Import Employee Hours': {
		translation: 'Import Employee Hours',
	},
	'Import File Column': {
		translation: 'Import File Column',
	},
	'Import From Template': {
		translation: 'Import From Template',
	},
	'Import Hours': {
		translation: 'Import Hours',
	},
	'Import Results': {
		translation: 'Import Results',
	},
	'Import Users from Cornerstone': {
		translation: 'Import Users from Cornerstone',
	},
	'Import XML data': {
		translation: 'Import XML data',
	},
	'Import basic employee data': {
		translation: 'Import basic employee data',
	},
	'Import from Cornerstone': {
		translation: 'Import from Cornerstone',
	},
	'Import table data': {
		translation: 'Import table data',
	},
	'Import the Data': {
		translation: 'Import the Data',
	},
	'Import this task when offboarding...': {
		translation: 'Import this task when offboarding...',
	},
	'Import this task when onboarding...': {
		translation: 'Import this task when onboarding...',
	},
	'Import type': {
		translation: 'Import type',
	},
	Important: {
		translation: 'Important',
	},
	'Important:': {
		translation: 'Important:',
	},
	'Important: ': {
		translation: 'Important: ',
	},
	'Important: the names of files attached to offer letter templates are viewable by anyone with this permission, regardless of individual file permissions.':
		{
			translation:
				'Important: the names of files attached to offer letter templates are viewable by anyone with this permission, regardless of individual file permissions.',
		},
	'Imported Hours': {
		translation: 'Imported Hours',
	},
	'Imported employee hours will be used for time off accruals and payroll.': {
		translation:
			'Imported employee hours will be used for time off accruals and payroll.',
	},
	Importing: {
		translation: 'Importing',
	},
	'Importing Information: Press the Import Employees button to pull the employee information from BambooHR and import it directly into Simplepay.ca':
		{
			translation:
				'Importing Information: Press the Import Employees button to pull the employee information from BambooHR and import it directly into Simplepay.ca',
		},
	'Impromptu Assessment': {
		translation: 'Impromptu Assessment',
	},
	'Impromptu Assessment Canceled': {
		translation: 'Impromptu Assessment Canceled',
	},
	'Improperly formatted id, user ids or user group ids.': {
		translation: 'Improperly formatted id, user ids or user group ids.',
	},
	'In Jazz view the resume of the employee you would like to add to BambooHR and click on the "Export" button under the Resume section. From the drop-down menu, select the option to export to BambooHR and you\'re done!':
		{
			translation:
				'In Jazz view the resume of the employee you would like to add to BambooHR and click on the \\"Export\\" button under the Resume section. From the drop-down menu, select the option to export to BambooHR and you\'re done!',
		},
	'In Objectives, create objectives cycle for the current quarter that is under review. In Reviews, create a review cycle for the current quarter. In 360 Feedback, create a cycle.':
		{
			translation:
				'In Objectives, create objectives cycle for the current quarter that is under review. In Reviews, create a review cycle for the current quarter. In 360 Feedback, create a cycle.',
		},
	'In Progress': {
		translation: 'In Progress',
	},
	'In Trial': {
		translation: 'In Trial',
	},
	'In a while, crocodile.': {
		translation: 'In a while, crocodile.',
	},
	'In case you need it, a report with all of your existing benefit information has been saved to your %1$sManage Reports%2$s menu.':
		{
			translation:
				'In case you need it, a report with all of your existing benefit information has been saved to your %1$sManage Reports%2$s menu.',
		},
	'In order to access the Bamboo Help Center, we need to verify your email address.':
		{
			translation:
				'In order to access the Bamboo Help Center, we need to verify your email address.',
		},
	'In order to convert %1$s to be tracked in hours, we need to know how many hours on day should equate to':
		{
			translation:
				'In order to convert %1$s to be tracked in hours, we need to know how many hours on day should equate to',
		},
	'In order to do that, you will need to create and assign Pay Groups to employees':
		{
			translation:
				'In order to do that, you will need to create and assign Pay Groups to employees',
		},
	'In order to enable self-service access for %s, they must have a valid work or home email.':
		{
			translation:
				'In order to enable self-service access for %s, they must have a valid work or home email.',
		},
	'In order to enable self-service access for <b>%s</b>, they must have a valid work or home email.':
		{
			translation:
				'In order to enable self-service access for <b>%s</b>, they must have a valid work or home email.',
		},
	'In order to enable self-service access for these employees, they must have a valid work or home email.':
		{
			translation:
				'In order to enable self-service access for these employees, they must have a valid work or home email.',
		},
	'In order to enroll in benefit plan %s you must also enroll in one of these benefit plans: %s':
		{
			translation:
				'In order to enroll in benefit plan %s you must also enroll in one of these benefit plans: %s',
		},
	'In order to make changes to this companies performance settings, the customer must activate performance in their company settings.':
		{
			translation:
				'In order to make changes to this companies performance settings, the customer must activate performance in their company settings.',
		},
	'In order to protect employee anonymity, we can’t show you the data of a group of six people or less. Please remove some filters to see more.':
		{
			translation:
				'In order to protect employee anonymity, we can’t show you the data of a group of six people or less. Please remove some filters to see more.',
		},
	'In order to use BambooHR, you’ll need to agree to the following.': {
		translation:
			'In order to use BambooHR, you’ll need to agree to the following.',
	},
	'In the configuration box, enter your BambooHR account subdomain and API Key and leave the "0" in the report ID field':
		{
			translation:
				'In the configuration box, enter your BambooHR account subdomain and API Key and leave the \\"0\\" in the report ID field',
		},
	'In the meantime you can review the last assessment': {
		translation: 'In the meantime you can review the last assessment',
	},
	InProgress: {
		translation: 'InProgress',
	},
	Inactive: {
		translation: 'Inactive',
	},
	'Inactive Candidates': {
		translation: 'Inactive Candidates',
	},
	'Inactive Employees': {
		translation: 'Inactive Employees',
	},
	'Inactive Plan': {
		translation: 'Inactive Plan',
	},
	'Inactive Time Off Categories': {
		translation: 'Inactive Time Off Categories',
	},
	'Inactive Time Off Types': {
		translation: 'Inactive Time Off Types',
	},
	'Inactive employees who are not terminated will appear in this report. Terminate inactive employees for accurate data.':
		{
			translation:
				'Inactive employees who are not terminated will appear in this report. Terminate inactive employees for accurate data.',
		},
	Inbox: {
		translation: 'Inbox',
	},
	'Incentive PTO': {
		translation: 'Incentive PTO',
	},
	'Incentive Paid Time': {
		translation: 'Incentive Paid Time',
	},
	Include: {
		translation: 'Include',
	},
	'Include Contractors': {
		translation: 'Include Contractors',
	},
	'Include Time Off Balances': {
		translation: 'Include Time Off Balances',
	},
	'Include Unapproved Time Off': {
		translation: 'Include Unapproved Time Off',
	},
	'Include employee in payroll': {
		translation: 'Include employee in payroll',
	},
	'Include employees eligible within the next...': {
		translation: 'Include employees eligible within the next...',
	},
	'Include employees hired more than...': {
		translation: 'Include employees hired more than...',
	},
	'Include employees with time tracking previously enabled': {
		translation: 'Include employees with time tracking previously enabled',
	},
	'Include expiration dates in the next...': {
		translation: 'Include expiration dates in the next...',
	},
	'Include expiration dates within the next...': {
		translation: 'Include expiration dates within the next...',
	},
	'Include in Payroll': {
		translation: 'Include in Payroll',
	},
	'Include in Performance Reviews': {
		translation: 'Include in Performance Reviews',
	},
	'Include other fields': {
		translation: 'Include other fields',
	},
	'Include others in this conversation': {
		translation: 'Include others in this conversation',
	},
	'Include these Time Off balances in the alert:': {
		translation: 'Include these Time Off balances in the alert:',
	},
	'Include this Category in Payroll': {
		translation: 'Include this Category in Payroll',
	},
	'Include this Employee in Payroll': {
		translation: 'Include this Employee in Payroll',
	},
	'Include this day': {
		translation: 'Include this day',
	},
	'Include this pay schedule in TRAX Payroll': {
		translation: 'Include this pay schedule in TRAX Payroll',
	},
	'Include this pay schedule in TRAXPayroll': {
		translation: 'Include this pay schedule in TRAXPayroll',
	},
	'Include this pay schedule in payroll': {
		translation: 'Include this pay schedule in payroll',
	},
	'Include this type in payroll': {
		translation: 'Include this type in payroll',
	},
	'Include those who completed optional renewing training.': {
		translation: 'Include those who completed optional renewing training.',
	},
	'Include time off requests submitted more than...': {
		translation: 'Include time off requests submitted more than...',
	},
	'Include today': {
		translation: 'Include today',
	},
	'Include your name and email in signature ': {
		translation: 'Include your name and email in signature ',
	},
	'Include...': {
		translation: 'Include...',
	},
	Included: {
		translation: 'Included',
	},
	'Included Employees (%1)': {
		translation: 'Included Employees (%1)',
	},
	'Included in Payroll': {
		translation: 'Included in Payroll',
	},
	'Included in Performance': {
		translation: 'Included in Performance',
	},
	'Included in payroll': {
		translation: 'Included in payroll',
	},
	'Includes Any Employee Address Details': {
		translation: 'Includes Any Employee Address Details',
	},
	'Includes Any Employee Name Details': {
		translation: 'Includes Any Employee Name Details',
	},
	'Includes Employee Ethnicity and Nationality': {
		translation: 'Includes Employee Ethnicity and Nationality',
	},
	'Includes Name, Gender, Demographics, Address, Phone, and Employee Number. Excludes Email, SSN, SIN, and Birthday':
		{
			translation:
				'Includes Name, Gender, Demographics, Address, Phone, and Employee Number. Excludes Email, SSN, SIN, and Birthday',
		},
	'Includes a transition to/from flexible time off': {
		translation: 'Includes a transition to/from flexible time off',
	},
	'Includes employee email!': {
		translation: 'Includes employee email!',
	},
	'Includes employees in a new hire waiting period.': {
		translation: 'Includes employees in a new hire waiting period.',
	},
	Incomplete: {
		translation: 'Incomplete',
	},
	'Incomplete Trainings': {
		translation: 'Incomplete Trainings',
	},
	Inconclusive: {
		translation: 'Inconclusive',
	},
	'Incorrect Date format (mm-dd-yyyy or mm/dd/yyyy)': {
		translation: 'Incorrect Date format (mm-dd-yyyy or mm/dd/yyyy)',
	},
	'Incorrect Expiry Date format (mm-dd-yyyy or mm/dd/yyyy)': {
		translation: 'Incorrect Expiry Date format (mm-dd-yyyy or mm/dd/yyyy)',
	},
	'Incorrect Issued Date format (mm-dd-yyyy or mm/dd/yyyy)': {
		translation: 'Incorrect Issued Date format (mm-dd-yyyy or mm/dd/yyyy)',
	},
	'Incremental Data Loading': {
		translation: 'Incremental Data Loading',
	},
	Indefinite: {
		translation: 'Indefinite',
	},
	'Individual Update': {
		translation: 'Individual Update',
	},
	'Individual update': {
		translation: 'Individual update',
	},
	Individually: {
		translation: 'Individually',
	},
	Industry: {
		translation: 'Industry',
	},
	Information: {
		translation: 'Information',
	},
	'Information Technology': {
		translation: 'Information Technology',
	},
	'Information Update request for %2s has already been %3s by %4s.': {
		translation:
			'Information Update request for %2s has already been %3s by %4s.',
	},
	'Information Updates': {
		translation: 'Information Updates',
	},
	'Information for this field is required.': {
		translation: 'Information for this field is required.',
	},
	'Information is pushed from BambooHR into Jobvite: This occurs when a change is made to an existing employee within BambooHR. A full list of employees* is sent over to Jobvite once per day (at 10:00 pm) and any updated values from BambooHR will replace the corresponding data within Jobvite for the respective individuals.':
		{
			translation:
				'Information is pushed from BambooHR into Jobvite: This occurs when a change is made to an existing employee within BambooHR. A full list of employees* is sent over to Jobvite once per day (at 10:00 pm) and any updated values from BambooHR will replace the corresponding data within Jobvite for the respective individuals.',
		},
	'Information is synced between BambooHR and Jobvite in two ways:': {
		translation:
			'Information is synced between BambooHR and Jobvite in two ways:',
	},
	'Information pulled from Jobvite and entered into BambooHR: This occurs when applicants are hired within Jobvite and new hires are pulled over into BambooHR once every 4 hours.':
		{
			translation:
				'Information pulled from Jobvite and entered into BambooHR: This occurs when applicants are hired within Jobvite and new hires are pulled over into BambooHR once every 4 hours.',
		},
	'Information update approved': {
		translation: 'Information update approved',
	},
	'Information update canceled': {
		translation: 'Information update canceled',
	},
	'Information update denied': {
		translation: 'Information update denied',
	},
	'Initial Stock Grant': {
		translation: 'Initial Stock Grant',
	},
	Initials: {
		translation: 'Initials',
	},
	'Input is not good.': {
		translation: 'Input is not good.',
	},
	'Insert Active Status': {
		translation: 'Insert Active Status',
	},
	'Insert a new employee': {
		translation: 'Insert a new employee',
	},
	'Insert your Directory ID from Google': {
		translation: 'Insert your Directory ID from Google',
	},
	'InsightsGrid is not available': {
		translation: 'InsightsGrid is not available',
	},
	'Instagram URL': {
		translation: 'Instagram URL',
	},
	Install: {
		translation: 'Install',
	},
	'Install %s': {
		translation: 'Install %s',
	},
	'Install %s in your Slack workspace. This will need to be done by a Slack workspace Admin.':
		{
			translation:
				'Install %s in your Slack workspace. This will need to be done by a Slack workspace Admin.',
		},
	'Install Conflict': {
		translation: 'Install Conflict',
	},
	'Install the Cronofy Integration here in BambooHR': {
		translation: 'Install the Cronofy Integration here in BambooHR',
	},
	'Installation is easy! Once you are a BambooHR customer you can easily get going with PlanSource. Just let us know you are interested by emailing <a href="mailto:bamboohr@plansource.com">bamboohr@plansource.com</a>, we’ll contact you with more information on getting started. You’ll have a PlanSource implementation team to work with every step of the way.':
		{
			translation:
				'Installation is easy! Once you are a BambooHR customer you can easily get going with PlanSource. Just let us know you are interested by emailing <a href=\\"mailto:bamboohr@plansource.com\\">bamboohr@plansource.com</a>, we’ll contact you with more information on getting started. You’ll have a PlanSource implementation team to work with every step of the way.',
		},
	'Installation ready': {
		translation: 'Installation ready',
	},
	Installed: {
		translation: 'Installed',
	},
	'Installed Apps': {
		translation: 'Installed Apps',
	},
	"Instead of using benefit groups to determine who's eligible for benefits, you'll set that up on the benefit plans themselves.":
		{
			translation:
				"Instead of using benefit groups to determine who's eligible for benefits, you'll set that up on the benefit plans themselves.",
		},
	'Instead we are displaying your currently available time off.': {
		translation: 'Instead we are displaying your currently available time off.',
	},
	Institution: {
		translation: 'Institution',
	},
	'Instructional Designer': {
		translation: 'Instructional Designer',
	},
	Instructor: {
		translation: 'Instructor',
	},
	'Instructure makes software that creates smarter people. It all started with Canvas in 2011 and the goal to make teaching and learning a lot easier. In 2015, we launched Bridge, which aims to change the way you (and, more importantly, your employees) think about employee engagement and corporate training. Today, more than 2,000 universities, school districts and institutions around the world use (and love) our products.':
		{
			translation:
				'Instructure makes software that creates smarter people. It all started with Canvas in 2011 and the goal to make teaching and learning a lot easier. In 2015, we launched Bridge, which aims to change the way you (and, more importantly, your employees) think about employee engagement and corporate training. Today, more than 2,000 universities, school districts and institutions around the world use (and love) our products.',
		},
	'Insufficient Permissions': {
		translation: 'Insufficient Permissions',
	},
	'Insufficient Permissions to change account owner': {
		translation: 'Insufficient Permissions to change account owner',
	},
	'Insufficient Permissions.': {
		translation: 'Insufficient Permissions.',
	},
	'Insufficient permissions': {
		translation: 'Insufficient permissions',
	},
	'Insufficient permissions.': {
		translation: 'Insufficient permissions.',
	},
	'Insufficient perms.': {
		translation: 'Insufficient perms.',
	},
	'Insurance Co.': {
		translation: 'Insurance Co.',
	},
	'Insurance Policy Number': {
		translation: 'Insurance Policy Number',
	},
	'Integration with Ask BambooHR': {
		translation: 'Integration with Ask BambooHR',
	},
	'Integrations Sign Up': {
		translation: 'Integrations Sign Up',
	},
	Intern: {
		translation: 'Intern',
	},
	'Intern (Eligible for benefits)': {
		translation: 'Intern (Eligible for benefits)',
	},
	'Intern (Ineligible for benefits)': {
		translation: 'Intern (Ineligible for benefits)',
	},
	'Intern Compensated': {
		translation: 'Intern Compensated',
	},
	'Intern Eligible': {
		translation: 'Intern Eligible',
	},
	'Intern Ineligible': {
		translation: 'Intern Ineligible',
	},
	'Intern Not Compensated': {
		translation: 'Intern Not Compensated',
	},
	Internal: {
		translation: 'Internal',
	},
	'Internal Contacts': {
		translation: 'Internal Contacts',
	},
	'Internal Error': {
		translation: 'Internal Error',
	},
	'Internal Job Code': {
		translation: 'Internal Job Code',
	},
	'Internal error': {
		translation: 'Internal error',
	},
	'Internal error.': {
		translation: 'Internal error.',
	},
	International: {
		translation: 'International',
	},
	'Internet Protocol (IP) Address Numbers': {
		translation: 'Internet Protocol (IP) Address Numbers',
	},
	'Internet Protocol Address': {
		translation: 'Internet Protocol Address',
	},
	'Internet Protocol Address Number': {
		translation: 'Internet Protocol Address Number',
	},
	Intersex: {
		translation: 'Intersex',
	},
	'Interview Schedule Link': {
		translation: 'Interview Schedule Link',
	},
	'Interview Templates': {
		translation: 'Interview Templates',
	},
	Interviewed: {
		translation: 'Interviewed',
	},
	'Introduce %1$s to the Team': {
		translation: 'Introduce %1$s to the Team',
	},
	'Introduce Yourself': {
		translation: 'Introduce Yourself',
	},
	'Invalid %s email for %s': {
		translation: 'Invalid %s email for %s',
	},
	'Invalid API Key': {
		translation: 'Invalid API Key',
	},
	'Invalid Access Token': {
		translation: 'Invalid Access Token',
	},
	'Invalid Action Requested': {
		translation: 'Invalid Action Requested',
	},
	'Invalid Answer': {
		translation: 'Invalid Answer',
	},
	'Invalid Configuration': {
		translation: 'Invalid Configuration',
	},
	'Invalid EEO job category ID': {
		translation: 'Invalid EEO job category ID',
	},
	'Invalid Email': {
		translation: 'Invalid Email',
	},
	'Invalid Email Address Found': {
		translation: 'Invalid Email Address Found',
	},
	'Invalid Email Addresses Found': {
		translation: 'Invalid Email Addresses Found',
	},
	'Invalid Field ID': {
		translation: 'Invalid Field ID',
	},
	'Invalid Holiday': {
		translation: 'Invalid Holiday',
	},
	'Invalid Home Email': {
		translation: 'Invalid Home Email',
	},
	'Invalid ID': {
		translation: 'Invalid ID',
	},
	'Invalid ID provided': {
		translation: 'Invalid ID provided',
	},
	'Invalid Id': {
		translation: 'Invalid Id',
	},
	'Invalid Issuing Country': {
		translation: 'Invalid Issuing Country',
	},
	'Invalid Issuing State': {
		translation: 'Invalid Issuing State',
	},
	'Invalid Issuing State - State must be a valid US state': {
		translation: 'Invalid Issuing State - State must be a valid US state',
	},
	'Invalid Limit to option specified when updating access Level': {
		translation: 'Invalid Limit to option specified when updating access Level',
	},
	'Invalid Link Url when adding a training': {
		translation: 'Invalid Link Url when adding a training',
	},
	'Invalid LinkedIn profile URL.': {
		translation: 'Invalid LinkedIn profile URL.',
	},
	'Invalid NIN': {
		translation: 'Invalid NIN',
	},
	'Invalid POST. Missing a required field': {
		translation: 'Invalid POST. Missing a required field',
	},
	'Invalid POST. Only send reimbursement amount and reimbursement frequency with reimbursement type benefit plans':
		{
			translation:
				'Invalid POST. Only send reimbursement amount and reimbursement frequency with reimbursement type benefit plans',
		},
	'Invalid POST. Reimbursement Plans types require reimbursement amount and frequency to be POSTed':
		{
			translation:
				'Invalid POST. Reimbursement Plans types require reimbursement amount and frequency to be POSTed',
		},
	'Invalid Perms': {
		translation: 'Invalid Perms',
	},
	'Invalid Potential Bonus Annual Amount': {
		translation: 'Invalid Potential Bonus Annual Amount',
	},
	'Invalid Potential Bonus Annual Percentage': {
		translation: 'Invalid Potential Bonus Annual Percentage',
	},
	'Invalid Reimbursement Frequency': {
		translation: 'Invalid Reimbursement Frequency',
	},
	'Invalid Report Folder.': {
		translation: 'Invalid Report Folder.',
	},
	'Invalid Request': {
		translation: 'Invalid Request',
	},
	'Invalid Request, missing customFields': {
		translation: 'Invalid Request, missing customFields',
	},
	'Invalid Request, missing section': {
		translation: 'Invalid Request, missing section',
	},
	'Invalid Request, missing tab': {
		translation: 'Invalid Request, missing tab',
	},
	'Invalid SSN': {
		translation: 'Invalid SSN',
	},
	'Invalid Survey ID': {
		translation: 'Invalid Survey ID',
	},
	'Invalid URL provided': {
		translation: 'Invalid URL provided',
	},
	'Invalid User Id': {
		translation: 'Invalid User Id',
	},
	'Invalid Work Email': {
		translation: 'Invalid Work Email',
	},
	"Invalid Workers' Compensation Code": {
		translation: "Invalid Workers' Compensation Code",
	},
	'Invalid Workflow': {
		translation: 'Invalid Workflow',
	},
	'Invalid `endDate` parameter: expected ISO date (YYYY-mm-dd) to succeed start date. Date range must not exceed ':
		{
			translation:
				'Invalid `endDate` parameter: expected ISO date (YYYY-mm-dd) to succeed start date. Date range must not exceed ',
		},
	'Invalid `startDate` parameter: expected ISO date (YYYY-mm-dd)': {
		translation:
			'Invalid `startDate` parameter: expected ISO date (YYYY-mm-dd)',
	},
	'Invalid accrual start date': {
		translation: 'Invalid accrual start date',
	},
	'Invalid amount': {
		translation: 'Invalid amount',
	},
	'Invalid amount date': {
		translation: 'Invalid amount date',
	},
	'Invalid amount requested': {
		translation: 'Invalid amount requested',
	},
	'Invalid approval type': {
		translation: 'Invalid approval type',
	},
	'Invalid argument': {
		translation: 'Invalid argument',
	},
	'Invalid assertion consumer service URL': {
		translation: 'Invalid assertion consumer service URL',
	},
	'Invalid cancel reason.': {
		translation: 'Invalid cancel reason.',
	},
	'Invalid characters in Passport Number': {
		translation: 'Invalid characters in Passport Number',
	},
	'Invalid client ID.': {
		translation: 'Invalid client ID.',
	},
	'Invalid data benchmarking agreement status.': {
		translation: 'Invalid data benchmarking agreement status.',
	},
	'Invalid data given.': {
		translation: 'Invalid data given.',
	},
	'Invalid data.': {
		translation: 'Invalid data.',
	},
	'Invalid date. Please choose a new date and try again.': {
		translation: 'Invalid date. Please choose a new date and try again.',
	},
	'Invalid direct reports type': {
		translation: 'Invalid direct reports type',
	},
	'Invalid education id': {
		translation: 'Invalid education id',
	},
	'Invalid email address': {
		translation: 'Invalid email address',
	},
	'Invalid email address.': {
		translation: 'Invalid email address.',
	},
	'Invalid employee': {
		translation: 'Invalid employee',
	},
	'Invalid employee id': {
		translation: 'Invalid employee id',
	},
	'Invalid employee id, or employee not a participant for period.': {
		translation:
			'Invalid employee id, or employee not a participant for period.',
	},
	'Invalid employee or timesheet id.': {
		translation: 'Invalid employee or timesheet id.',
	},
	'Invalid end date': {
		translation: 'Invalid end date',
	},
	'Invalid end date format, valid format is MM/DD/YYYY': {
		translation: 'Invalid end date format, valid format is MM/DD/YYYY',
	},
	'Invalid end date or end date is before start date': {
		translation: 'Invalid end date or end date is before start date',
	},
	'Invalid end date. The end date must come on or after the start date.': {
		translation:
			'Invalid end date. The end date must come on or after the start date.',
	},
	'Invalid expiration month': {
		translation: 'Invalid expiration month',
	},
	'Invalid expiration year': {
		translation: 'Invalid expiration year',
	},
	'Invalid field data for %1$s. Appropriate characters include %2$s': {
		translation:
			'Invalid field data for %1$s. Appropriate characters include %2$s',
	},
	'Invalid field data for %1$s. Inappropriate characters include %2$s': {
		translation:
			'Invalid field data for %1$s. Inappropriate characters include %2$s',
	},
	'Invalid field in report. Please save report again.': {
		translation: 'Invalid field in report. Please save report again.',
	},
	'Invalid field length for %1$s. Max length is %2$s': {
		translation: 'Invalid field length for %1$s. Max length is %2$s',
	},
	'Invalid fileId': {
		translation: 'Invalid fileId',
	},
	'Invalid filter value.': {
		translation: 'Invalid filter value.',
	},
	'Invalid format for %1$s.': {
		translation: 'Invalid format for %1$s.',
	},
	'Invalid format for %1$s. Valid format is %2$s': {
		translation: 'Invalid format for %1$s. Valid format is %2$s',
	},
	'Invalid frequency chosen when also trying to sync with payroll.': {
		translation:
			'Invalid frequency chosen when also trying to sync with payroll.',
	},
	'Invalid frequency for Assessments.': {
		translation: 'Invalid frequency for Assessments.',
	},
	'Invalid frequency for Feedback.': {
		translation: 'Invalid frequency for Feedback.',
	},
	'Invalid goal id or milestone id.': {
		translation: 'Invalid goal id or milestone id.',
	},
	'Invalid guideline': {
		translation: 'Invalid guideline',
	},
	'Invalid home email': {
		translation: 'Invalid home email',
	},
	'Invalid hours for employment statuses.': {
		translation: 'Invalid hours for employment statuses.',
	},
	'Invalid id.': {
		translation: 'Invalid id.',
	},
	'Invalid list id.': {
		translation: 'Invalid list id.',
	},
	'Invalid or Missing Argument': {
		translation: 'Invalid or Missing Argument',
	},
	'Invalid or missing arguments': {
		translation: 'Invalid or missing arguments',
	},
	'Invalid order.': {
		translation: 'Invalid order.',
	},
	'Invalid password.': {
		translation: 'Invalid password.',
	},
	'Invalid pdf url': {
		translation: 'Invalid pdf url',
	},
	'Invalid permissions': {
		translation: 'Invalid permissions',
	},
	'Invalid permissions.': {
		translation: 'Invalid permissions.',
	},
	'Invalid plan id.': {
		translation: 'Invalid plan id.',
	},
	'Invalid plan selected.  Please try again or contact billing@bamboohr.com.': {
		translation:
			'Invalid plan selected.  Please try again or contact billing@bamboohr.com.',
	},
	'Invalid policy': {
		translation: 'Invalid policy',
	},
	'Invalid policy changes data format.': {
		translation: 'Invalid policy changes data format.',
	},
	'Invalid policy type requested.': {
		translation: 'Invalid policy type requested.',
	},
	'Invalid policy when changing to or from None': {
		translation: 'Invalid policy when changing to or from None',
	},
	'Invalid report': {
		translation: 'Invalid report',
	},
	'Invalid report ID.': {
		translation: 'Invalid report ID.',
	},
	'Invalid request method or endpoint': {
		translation: 'Invalid request method or endpoint',
	},
	'Invalid review cycle configuration.': {
		translation: 'Invalid review cycle configuration.',
	},
	'Invalid review period id or employee id.': {
		translation: 'Invalid review period id or employee id.',
	},
	'Invalid review period.': {
		translation: 'Invalid review period.',
	},
	'Invalid routing number': {
		translation: 'Invalid routing number',
	},
	'Invalid selection for the employees category.': {
		translation: 'Invalid selection for the employees category.',
	},
	'Invalid specific person approver': {
		translation: 'Invalid specific person approver',
	},
	'Invalid start date': {
		translation: 'Invalid start date',
	},
	'Invalid start date for Assessments.': {
		translation: 'Invalid start date for Assessments.',
	},
	'Invalid start date for Feedback.': {
		translation: 'Invalid start date for Feedback.',
	},
	'Invalid start date for Peer Feedback.': {
		translation: 'Invalid start date for Peer Feedback.',
	},
	'Invalid start date for goals.': {
		translation: 'Invalid start date for goals.',
	},
	'Invalid start date format, valid format is MM/DD/YYYY': {
		translation: 'Invalid start date format, valid format is MM/DD/YYYY',
	},
	'Invalid start date. The start date must come on or before the end date.': {
		translation:
			'Invalid start date. The start date must come on or before the end date.',
	},
	'Invalid state value or state expired while setting up BambooHR Slack Integration, please retry from the Slack application page':
		{
			translation:
				'Invalid state value or state expired while setting up BambooHR Slack Integration, please retry from the Slack application page',
		},
	'Invalid task requested': {
		translation: 'Invalid task requested',
	},
	'Invalid task type or it no longer exists': {
		translation: 'Invalid task type or it no longer exists',
	},
	'Invalid tasklist item requested': {
		translation: 'Invalid tasklist item requested',
	},
	'Invalid tax type for given employment status.': {
		translation: 'Invalid tax type for given employment status.',
	},
	'Invalid tax type for the given employment status': {
		translation: 'Invalid tax type for the given employment status',
	},
	'Invalid team id': {
		translation: 'Invalid team id',
	},
	'Invalid time off category': {
		translation: 'Invalid time off category',
	},
	'Invalid time off policy': {
		translation: 'Invalid time off policy',
	},
	'Invalid time off type': {
		translation: 'Invalid time off type',
	},
	'Invalid time off type id': {
		translation: 'Invalid time off type id',
	},
	'Invalid time tracking ID given: %1$s': {
		translation: 'Invalid time tracking ID given: %1$s',
	},
	'Invalid timesheet type': {
		translation: 'Invalid timesheet type',
	},
	'Invalid type for a variable rate plan': {
		translation: 'Invalid type for a variable rate plan',
	},
	'Invalid type requested.': {
		translation: 'Invalid type requested.',
	},
	'Invalid user': {
		translation: 'Invalid user',
	},
	'Invalid value set for Holiday Rate.': {
		translation: 'Invalid value set for Holiday Rate.',
	},
	'Invalid verification type selected.': {
		translation: 'Invalid verification type selected.',
	},
	'Invalid webhook ID': {
		translation: 'Invalid webhook ID',
	},
	'Invalid webhook id': {
		translation: 'Invalid webhook id',
	},
	'Invalid website URL.': {
		translation: 'Invalid website URL.',
	},
	'Invalid work email': {
		translation: 'Invalid work email',
	},
	'Invoice History': {
		translation: 'Invoice History',
	},
	Invoicing: {
		translation: 'Invoicing',
	},
	'Involuntary termination of employment': {
		translation: 'Involuntary termination of employment',
	},
	'Is Employee': {
		translation: 'Is Employee',
	},
	'Is Engaged': {
		translation: 'Is Engaged',
	},
	'Is Highly Engaged': {
		translation: 'Is Highly Engaged',
	},
	'Is Highly Valued': {
		translation: 'Is Highly Valued',
	},
	'Is Moderately Engaged': {
		translation: 'Is Moderately Engaged',
	},
	'Is Moderately Valued': {
		translation: 'Is Moderately Valued',
	},
	'Is Not Engaged': {
		translation: 'Is Not Engaged',
	},
	'Is Not Valued': {
		translation: 'Is Not Valued',
	},
	'Is Somewhat Engaged': {
		translation: 'Is Somewhat Engaged',
	},
	'Is Somewhat Valued': {
		translation: 'Is Somewhat Valued',
	},
	'Is State Exempt': {
		translation: 'Is State Exempt',
	},
	'Is State UI Exempt ': {
		translation: 'Is State UI Exempt ',
	},
	'Is Supervisor': {
		translation: 'Is Supervisor',
	},
	'Is Valued': {
		translation: 'Is Valued',
	},
	'Is employee photo uploaded': {
		translation: 'Is employee photo uploaded',
	},
	'Is it better than you could have ever imagined or were there some areas that we could improve?':
		{
			translation:
				'Is it better than you could have ever imagined or were there some areas that we could improve?',
		},
	'Is the employee invested in their work?': {
		translation: 'Is the employee invested in their work?',
	},
	'Is the payroll deduction pre-tax or post-tax?': {
		translation: 'Is the payroll deduction pre-tax or post-tax?',
	},
	'Is the user who authorized the application an employee.': {
		translation: 'Is the user who authorized the application an employee.',
	},
	'Is this email actually correct?': {
		translation: 'Is this email actually correct?',
	},
	Issue: {
		translation: 'Issue',
	},
	'Issue Date': {
		translation: 'Issue Date',
	},
	'Issue Detected': {
		translation: 'Issue Detected',
	},
	Issued: {
		translation: 'Issued',
	},
	'Issued (1)': {
		translation: 'Issued (1)',
	},
	'Issued (2)': {
		translation: 'Issued (2)',
	},
	'Issued (3)': {
		translation: 'Issued (3)',
	},
	'Issued (4)': {
		translation: 'Issued (4)',
	},
	'Issued Date': {
		translation: 'Issued Date',
	},
	'Issuing Country': {
		translation: 'Issuing Country',
	},
	'Issuing authority': {
		translation: 'Issuing authority',
	},
	'Issuing country': {
		translation: 'Issuing country',
	},
	'Ist Year Vacation Policy': {
		translation: 'Ist Year Vacation Policy',
	},
	'It cannot be Quarterly, Twice a Year, or Yearly.': {
		translation: 'It cannot be Quarterly, Twice a Year, or Yearly.',
	},
	"It doesn't look like %s has an email address in BambooHR.": {
		translation: "It doesn't look like %s has an email address in BambooHR.",
	},
	'It doesn’t look like there are any pay schedules that are currently set up to sync with payroll.':
		{
			translation:
				'It doesn’t look like there are any pay schedules that are currently set up to sync with payroll.',
		},
	'It doesn’t need to be a placeholder to be included in the offer.': {
		translation:
			'It doesn’t need to be a placeholder to be included in the offer.',
	},
	'It happens. Try again in a moment.': {
		translation: 'It happens. Try again in a moment.',
	},
	'It has been more than 24 hours since we sent your password change email.': {
		translation:
			'It has been more than 24 hours since we sent your password change email.',
	},
	'It look like you were able to login, so we disabled this link to reset your password. If you are still having trouble, you can request a new link.':
		{
			translation:
				'It look like you were able to login, so we disabled this link to reset your password. If you are still having trouble, you can request a new link.',
		},
	"It looks like Employee Satisfaction with eNPS® isn't part of your current package.":
		{
			translation:
				"It looks like Employee Satisfaction with eNPS® isn't part of your current package.",
		},
	"It looks like Performance Management hasn't been activated on your account.":
		{
			translation:
				"It looks like Performance Management hasn't been activated on your account.",
		},
	"It looks like Time Tracking hasn't been activated on your account.": {
		translation:
			"It looks like Time Tracking hasn't been activated on your account.",
	},
	'It looks like something went wrong! Try again later.': {
		translation: 'It looks like something went wrong! Try again later.',
	},
	'It looks like this file has already been deleted.': {
		translation: 'It looks like this file has already been deleted.',
	},
	"It looks like you don't have access to that page. But hey, it was worth the try.":
		{
			translation:
				"It looks like you don't have access to that page. But hey, it was worth the try.",
		},
	"It looks like you don't have access to this page.": {
		translation: "It looks like you don't have access to this page.",
	},
	"It looks like you don't have any active health plans for the selected year.":
		{
			translation:
				"It looks like you don't have any active health plans for the selected year.",
		},
	'It looks like you have an employee that needs their employment status filled out before you can power edit this information.':
		{
			translation: {
				one: 'It looks like you have an employee that needs their employment status filled out before you can power edit this information.',
				other:
					'It looks like you have %1$s employees that need their employment status filled out before you can power edit this information.',
			},
		},
	'It looks like you have multiple ESS groups. Before you can continue you will need to move all users into one ESS group. Please <span class="bold">select a group to move your users to.</span></p>':
		{
			translation:
				'It looks like you have multiple ESS groups. Before you can continue you will need to move all users into one ESS group. Please <span class=\\"bold\\">select a group to move your users to.</span></p>',
		},
	"It looks like you haven't added any plans yet.": {
		translation: "It looks like you haven't added any plans yet.",
	},
	'It looks like you were able to login, so we disabled this link to reset your password. If you are still having trouble, you can request a new link.':
		{
			translation:
				'It looks like you were able to login, so we disabled this link to reset your password. If you are still having trouble, you can request a new link.',
		},
	"It looks like you're trying to add a candidate to a position that doesn't exist.":
		{
			translation:
				"It looks like you're trying to add a candidate to a position that doesn't exist.",
		},
	"It looks like you're trying to edit a candidate to a position that doesn't exist.":
		{
			translation:
				"It looks like you're trying to edit a candidate to a position that doesn't exist.",
		},
	'It looks like your company has already been set up. Switch back to that company data now?':
		{
			translation:
				'It looks like your company has already been set up. Switch back to that company data now?',
		},
	"It looks like your employer hasn't added a hire date yet.": {
		translation: "It looks like your employer hasn't added a hire date yet.",
	},
	'It may be a temporary thing.': {
		translation: 'It may be a temporary thing.',
	},
	'It may take a moment for the selected days to load.': {
		translation: 'It may take a moment for the selected days to load.',
	},
	"It seems the current manager isn't eligible to assess the employee quite yet. The manager must have been hired more than 45 days ago.":
		{
			translation:
				"It seems the current manager isn't eligible to assess the employee quite yet. The manager must have been hired more than 45 days ago.",
		},
	'It seems we ran into a snag while syncing with QuickBooks. Some data may not have been saved. Please try again in a few minutes.':
		{
			translation:
				'It seems we ran into a snag while syncing with QuickBooks. Some data may not have been saved. Please try again in a few minutes.',
		},
	"It seems your current manager isn't eligible to assess you quite yet. You must report to them for more than 45 days.":
		{
			translation:
				"It seems your current manager isn't eligible to assess you quite yet. You must report to them for more than 45 days.",
		},
	'It sure is quiet... maybe too quiet.': {
		translation: 'It sure is quiet... maybe too quiet.',
	},
	'It will also help us get you up and running quickly with the required paperwork.':
		{
			translation:
				'It will also help us get you up and running quickly with the required paperwork.',
		},
	'It will be easier to create Benefit Groups once all of your plans are added':
		{
			translation:
				'It will be easier to create Benefit Groups once all of your plans are added',
		},
	'It will be moved back to the Upcoming Training list.': {
		translation: 'It will be moved back to the Upcoming Training list.',
	},
	'It will be removed from your active taxes. However, in order to maintain history, it will be archived in your inactive payroll taxes.':
		{
			translation:
				'It will be removed from your active taxes. However, in order to maintain history, it will be archived in your inactive payroll taxes.',
		},
	'It worked! %1$s has been successfully reactivated.': {
		translation: 'It worked! %1$s has been successfully reactivated.',
	},
	"It's Time to Get Feedback about Your Team": {
		translation: "It's Time to Get Feedback about Your Team",
	},
	"It's Time to Review Your Assessment Questions": {
		translation: "It's Time to Review Your Assessment Questions",
	},
	"It's a great day! You have no more requests!": {
		translation: "It's a great day! You have no more requests!",
	},
	"It's a little quiet in here, don't you think?": {
		translation: "It's a little quiet in here, don't you think?",
	},
	"It's clear to me how my role contributes to the success of the company": {
		translation:
			"It's clear to me how my role contributes to the success of the company",
	},
	"It's time to request feedback about {1}": {
		translation: "It's time to request feedback about {1}",
	},
	"It's time! Let's get your account ready for BambooHR Payroll": {
		translation: "It's time! Let's get your account ready for BambooHR Payroll",
	},
	"It's your responsibility to let everyone know about the change.": {
		translation:
			"It's your responsibility to let everyone know about the change.",
	},
	Item: {
		translation: 'Item',
	},
	'Item Status': {
		translation: 'Item Status',
	},
	'Item filter': {
		translation: 'Item filter',
	},
	Items: {
		translation: 'Items',
	},
	'It’s probably not our fault, but we’re still very sorry about this.': {
		translation:
			'It’s probably not our fault, but we’re still very sorry about this.',
	},
	'Ive assigned an onboarding task to you.': {
		translation: 'Ive assigned an onboarding task to you.',
	},
	'I’m Done Looking': {
		translation: 'I’m Done Looking',
	},
	'Jacket Size': {
		translation: 'Jacket Size',
	},
	'Jade Playground': {
		translation: 'Jade Playground',
	},
	Jan: {
		translation: 'Jan',
	},
	January: {
		translation: 'January',
	},
	Japanese: {
		translation: 'Japanese',
	},
	'Jazz (formerly The Resumator) is simply the easiest, most efficient way for growing businesses to hire. It instantly replaces any cluttered HR email inbox with powerful, yet simple online tools for promoting jobs and reviewing resumes. Jazzmakes hiring less costly, highly collaborative and paper-free.':
		{
			translation:
				'Jazz (formerly The Resumator) is simply the easiest, most efficient way for growing businesses to hire. It instantly replaces any cluttered HR email inbox with powerful, yet simple online tools for promoting jobs and reviewing resumes. Jazzmakes hiring less costly, highly collaborative and paper-free.',
		},
	'Jazz integrates with BambooHR through our API allowing information to be transferred into BambooHR with the click of a button.':
		{
			translation:
				'Jazz integrates with BambooHR through our API allowing information to be transferred into BambooHR with the click of a button.',
		},
	Job: {
		translation: 'Job',
	},
	'Job Address': {
		translation: 'Job Address',
	},
	'Job Applications': {
		translation: 'Job Applications',
	},
	'Job Candidates': {
		translation: 'Job Candidates',
	},
	'Job Category': {
		translation: 'Job Category',
	},
	'Job Code': {
		translation: 'Job Code',
	},
	'Job Data 1': {
		translation: 'Job Data 1',
	},
	'Job Data 2': {
		translation: 'Job Data 2',
	},
	'Job Data 3': {
		translation: 'Job Data 3',
	},
	'Job Data 4': {
		translation: 'Job Data 4',
	},
	'Job Department': {
		translation: 'Job Department',
	},
	'Job Description': {
		translation: 'Job Description',
	},
	'Job Division': {
		translation: 'Job Division',
	},
	'Job History': {
		translation: 'Job History',
	},
	'Job Info': {
		translation: 'Job Info',
	},
	'Job Information': {
		translation: 'Job Information',
	},
	'Job Information History': {
		translation: 'Job Information History',
	},
	'Job Information: Change Reason': {
		translation: 'Job Information: Change Reason',
	},
	'Job Information: Date': {
		translation: 'Job Information: Date',
	},
	'Job Knowledge': {
		translation: 'Job Knowledge',
	},
	'Job Level': {
		translation: 'Job Level',
	},
	'Job Link': {
		translation: 'Job Link',
	},
	'Job Location': {
		translation: 'Job Location',
	},
	'Job Open': {
		translation: 'Job Open',
	},
	'Job Opening': {
		translation: 'Job Opening',
	},
	'Job Opening Name': {
		translation: 'Job Opening Name',
	},
	'Job Openings': {
		translation: 'Job Openings',
	},
	'Job Openings and Hiring': {
		translation: 'Job Openings and Hiring',
	},
	'Job Status': {
		translation: 'Job Status',
	},
	'Job Tenure': {
		translation: 'Job Tenure',
	},
	'Job Title': {
		translation: 'Job Title',
	},
	'Job Title & Reports To': {
		translation: 'Job Title & Reports To',
	},
	"Job Title '%1$s' not found": {
		translation: "Job Title '%1$s' not found",
	},
	'Job Title*': {
		translation: 'Job Title*',
	},
	'Job Title: %1$s': {
		translation: 'Job Title: %1$s',
	},
	'Job boards updated successfully.': {
		translation: 'Job boards updated successfully.',
	},
	'Job information is not valid for employee’s current or future pay schedule.':
		{
			translation:
				'Job information is not valid for employee’s current or future pay schedule.',
		},
	'Job title': {
		translation: 'Job title',
	},
	'Job title will always be included.': {
		translation: 'Job title will always be included.',
	},
	'Jobber is the easiest way to measure employee engagement or employee satisfaction. Jobber offers a real time dashboard in which your employee engagement or employee satisfaction will be displayed using indicators on a group level. Surveys can be conducted using one of our three questionnaires, including those of two well-known universities. Invitations can be sent by e-mail or mail and measuring can be done in intervals or continuously. Managers can be invited as users as well, having their own dashboard of their department.':
		{
			translation:
				'Jobber is the easiest way to measure employee engagement or employee satisfaction. Jobber offers a real time dashboard in which your employee engagement or employee satisfaction will be displayed using indicators on a group level. Surveys can be conducted using one of our three questionnaires, including those of two well-known universities. Invitations can be sent by e-mail or mail and measuring can be done in intervals or continuously. Managers can be invited as users as well, having their own dashboard of their department.',
		},
	'Jobvite API Key': {
		translation: 'Jobvite API Key',
	},
	'Jobvite API Secret': {
		translation: 'Jobvite API Secret',
	},
	'Jobvite Company ID': {
		translation: 'Jobvite Company ID',
	},
	'Jobvite User Email': {
		translation: 'Jobvite User Email',
	},
	"Jobvite is the leading recruiting platform for the social web. Today's fastest-growing companies use applicant tracking, recruiter CRM and social recruiting software solutions from Jobvite to target the right talent and build the best teams.":
		{
			translation:
				"Jobvite is the leading recruiting platform for the social web. Today's fastest-growing companies use applicant tracking, recruiter CRM and social recruiting software solutions from Jobvite to target the right talent and build the best teams.",
		},
	'Johnson & Johnson': {
		translation: 'Johnson & Johnson',
	},
	'Joining BambooHR': {
		translation: 'Joining BambooHR',
	},
	'Josh Davis': {
		translation: 'Josh Davis',
	},
	'Journal Entry': {
		translation: 'Journal Entry',
	},
	'Journal Entry Reports': {
		translation: 'Journal Entry Reports',
	},
	'Joy, satisfaction, contentment, and fulfillment pertaining to work.': {
		translation:
			'Joy, satisfaction, contentment, and fulfillment pertaining to work.',
	},
	'Json Content Type Expected': {
		translation: 'Json Content Type Expected',
	},
	Jul: {
		translation: 'Jul',
	},
	July: {
		translation: 'July',
	},
	'Jump Cloud SCIM Description': {
		translation: 'Jump Cloud SCIM Description',
	},
	'Jump to an employee...': {
		translation: 'Jump to an employee...',
	},
	'JumpCloud SCIM Description': {
		translation: 'JumpCloud SCIM Description',
	},
	Jun: {
		translation: 'Jun',
	},
	June: {
		translation: 'June',
	},
	'Jury Duty': {
		translation: 'Jury Duty',
	},
	'Just Checking ': {
		translation: 'Just Checking ',
	},
	'Just Checking...': {
		translation: 'Just Checking...',
	},
	'Just Checking…': {
		translation: 'Just Checking…',
	},
	'Just So You Know...': {
		translation: 'Just So You Know...',
	},
	'Just These Employees': {
		translation: 'Just These Employees',
	},
	"Just checking, because this can't be undone.": {
		translation: "Just checking, because this can't be undone.",
	},
	'Just checking...': {
		translation: 'Just checking...',
	},
	'Just enter a date range and click "Apply"': {
		translation: 'Just enter a date range and click \\"Apply\\"',
	},
	'Just enter a date range and click “Apply”': {
		translation: 'Just enter a date range and click “Apply”',
	},
	'Just new employees, but leave it for existing': {
		translation: 'Just new employees, but leave it for existing',
	},
	'Just now': {
		translation: 'Just now',
	},
	'Just one follow-up question for you…': {
		translation: 'Just one follow-up question for you…',
	},
	'Just so you know': {
		translation: 'Just so you know',
	},
	'Just so you know, Feedback is hidden from {1}.': {
		translation: 'Just so you know, Feedback is hidden from {1}.',
	},
	'Just so you know, feedback is hidden from {1}.': {
		translation: 'Just so you know, feedback is hidden from {1}.',
	},
	'Just so you know...': {
		translation: 'Just so you know...',
	},
	'Just to be safe, we logged you out.': {
		translation: 'Just to be safe, we logged you out.',
	},
	'Just want to make sure...': {
		translation: 'Just want to make sure...',
	},
	KB: {
		translation: 'KB',
	},
	'KYB successfully cleared': {
		translation: 'KYB successfully cleared',
	},
	'Keep Candidate': {
		translation: 'Keep Candidate',
	},
	'Keep Candidates': {
		translation: 'Keep Candidates',
	},
	'Keep Contact': {
		translation: 'Keep Contact',
	},
	'Keep Current Template': {
		translation: 'Keep Current Template',
	},
	'Keep Date': {
		translation: 'Keep Date',
	},
	'Keep Deduction': {
		translation: 'Keep Deduction',
	},
	'Keep Folder': {
		translation: 'Keep Folder',
	},
	'Keep Goal': {
		translation: 'Keep Goal',
	},
	'Keep Group': {
		translation: 'Keep Group',
	},
	'Keep Job Opening': {
		translation: 'Keep Job Opening',
	},
	'Keep Offer': {
		translation: 'Keep Offer',
	},
	'Keep Pay Schedule': {
		translation: 'Keep Pay Schedule',
	},
	'Keep Project': {
		translation: 'Keep Project',
	},
	'Keep Record': {
		translation: 'Keep Record',
	},
	'Keep Report': {
		translation: 'Keep Report',
	},
	'Keep Request': {
		translation: 'Keep Request',
	},
	'Keep Source': {
		translation: 'Keep Source',
	},
	'Keep Status': {
		translation: 'Keep Status',
	},
	'Keep Template': {
		translation: 'Keep Template',
	},
	'Keep This Category': {
		translation: 'Keep This Category',
	},
	'Keep This Task': {
		translation: 'Keep This Task',
	},
	'Keep This Training': {
		translation: 'Keep This Training',
	},
	'Keep Working': {
		translation: 'Keep Working',
	},
	'Keep all your employee data up to date in BambooHR and use it as your system of record. ':
		{
			translation:
				'Keep all your employee data up to date in BambooHR and use it as your system of record. ',
		},
	'Keep an Eye on your Goals': {
		translation: 'Keep an Eye on your Goals',
	},
	'Keep in mind that your prior payroll vendor may be holding additional quarterly withholding payments beyond what we’ve listed here. Please check with them and let us know if any other taxes should be collected.':
		{
			translation:
				'Keep in mind that your prior payroll vendor may be holding additional quarterly withholding payments beyond what we’ve listed here. Please check with them and let us know if any other taxes should be collected.',
		},
	'Keep in mind you will stay logged in until you choose to log out on the extension options page. Happy Bambooing!':
		{
			translation:
				'Keep in mind you will stay logged in until you choose to log out on the extension options page. Happy Bambooing!',
		},
	'Keep in mind, your prior payroll vendor may be holding additional quarterly withholding payments beyond what we’ve listed here. Please check with them and let us know if any other taxes should be collected.':
		{
			translation:
				'Keep in mind, your prior payroll vendor may be holding additional quarterly withholding payments beyond what we’ve listed here. Please check with them and let us know if any other taxes should be collected.',
		},
	'Keep signature request': {
		translation: 'Keep signature request',
	},
	'Keep track of what needs to get done when a new employee comes onboard. Applications, and paperwork, and bears! Oh, my!':
		{
			translation:
				'Keep track of what needs to get done when a new employee comes onboard. Applications, and paperwork, and bears! Oh, my!',
		},
	'Keep track of what needs to get done.': {
		translation: 'Keep track of what needs to get done.',
	},
	'Key Card': {
		translation: 'Key Card',
	},
	'Key card': {
		translation: 'Key card',
	},
	'Key card #': {
		translation: 'Key card #',
	},
	'Kick Off Data Cleaner': {
		translation: 'Kick Off Data Cleaner',
	},
	'Kick things off by adding a custom field or table.': {
		translation: 'Kick things off by adding a custom field or table.',
	},
	Kids: {
		translation: 'Kids',
	},
	'Knowing whether or not your employees are satisfied—and knowing why—could help you avoid increased turnover in an already tight labor market. Employee Satisfaction with eNPS® combines a simple, anonymous, two-question survey with powerful trend reporting to help you find out how your employees really feel and what you can do to improve their experience.':
		{
			translation:
				'Knowing whether or not your employees are satisfied—and knowing why—could help you avoid increased turnover in an already tight labor market. Employee Satisfaction with eNPS® combines a simple, anonymous, two-question survey with powerful trend reporting to help you find out how your employees really feel and what you can do to improve their experience.',
		},
	L1A: {
		translation: 'L1A',
	},
	L1B: {
		translation: 'L1B',
	},
	'Laborers and Helpers': {
		translation: 'Laborers and Helpers',
	},
	Landscape: {
		translation: 'Landscape',
	},
	Language: {
		translation: 'Language',
	},
	'Language not found': {
		translation: 'Language not found',
	},
	'Language notes': {
		translation: 'Language notes',
	},
	'Language spoken': {
		translation: 'Language spoken',
	},
	Languages: {
		translation: 'Languages',
	},
	'Largest first': {
		translation: 'Largest first',
	},
	Last: {
		translation: 'Last',
	},
	'Last %s': {
		translation: 'Last %s',
	},
	'Last 3 Months': {
		translation: 'Last 3 Months',
	},
	'Last 30 days': {
		translation: 'Last 30 days',
	},
	'Last 4 digits must be exactly 4 digits': {
		translation: 'Last 4 digits must be exactly 4 digits',
	},
	'Last 6 Months': {
		translation: 'Last 6 Months',
	},
	'Last 7 days': {
		translation: 'Last 7 days',
	},
	'Last 9 Months': {
		translation: 'Last 9 Months',
	},
	'Last Comment': {
		translation: 'Last Comment',
	},
	'Last Feedback': {
		translation: 'Last Feedback',
	},
	'Last Login': {
		translation: 'Last Login',
	},
	'Last Modified': {
		translation: 'Last Modified',
	},
	'Last Name': {
		translation: 'Last Name',
	},
	'Last Name Preferred Name': {
		translation: 'Last Name Preferred Name',
	},
	'Last Name cannot be empty': {
		translation: 'Last Name cannot be empty',
	},
	"Last Name is a required Field and can't be blank": {
		translation: "Last Name is a required Field and can't be blank",
	},
	'Last Name is required': {
		translation: 'Last Name is required',
	},
	'Last Name, First Name': {
		translation: 'Last Name, First Name',
	},
	'Last Name, First name Middle Name (Preferred Name)': {
		translation: 'Last Name, First name Middle Name (Preferred Name)',
	},
	'Last Name, Preferred Name': {
		translation: 'Last Name, Preferred Name',
	},
	'Last Pay Change': {
		translation: 'Last Pay Change',
	},
	'Last Pay Date': {
		translation: 'Last Pay Date',
	},
	'Last Payment': {
		translation: 'Last Payment',
	},
	'Last Payroll Deduction for Enrolled Employees: ': {
		translation: 'Last Payroll Deduction for Enrolled Employees: ',
	},
	'Last Payroll Deduction: ': {
		translation: 'Last Payroll Deduction: ',
	},
	'Last Payroll Deduction: %s': {
		translation: 'Last Payroll Deduction: %s',
	},
	'Last Sent': {
		translation: 'Last Sent',
	},
	'Last Success': {
		translation: 'Last Success',
	},
	'Last Update': {
		translation: 'Last Update',
	},
	'Last Update:': {
		translation: 'Last Update:',
	},
	'Last Updated By': {
		translation: 'Last Updated By',
	},
	'Last Viewed': {
		translation: 'Last Viewed',
	},
	'Last Year': {
		translation: 'Last Year',
	},
	'Last changed': {
		translation: 'Last changed',
	},
	'Last changed on: %1': {
		translation: 'Last changed on: %1',
	},
	'Last changed on: %1 by %2': {
		translation: 'Last changed on: %1 by %2',
	},
	'Last changed: ISO': {
		translation: 'Last changed: ISO',
	},
	'Last day': {
		translation: 'Last day',
	},
	'Last enabled:': {
		translation: 'Last enabled:',
	},
	'Last name': {
		translation: 'Last name',
	},
	'Last name, First name': {
		translation: 'Last name, First name',
	},
	'Last posted on %s': {
		translation: 'Last posted on %s',
	},
	'Last sent': {
		translation: 'Last sent',
	},
	'Last six months': {
		translation: 'Last six months',
	},
	'Last synchronized': {
		translation: 'Last synchronized',
	},
	'Last time': {
		translation: 'Last time',
	},
	'Last worked on: %s': {
		translation: 'Last worked on: %s',
	},
	'Later, gator.': {
		translation: 'Later, gator.',
	},
	'Leap Day': {
		translation: 'Leap Day',
	},
	'Learn More': {
		translation: 'Learn More',
	},
	'Learn about BambooHR’s payroll features and access your Bamboo Payroll account':
		{
			translation:
				'Learn about BambooHR’s payroll features and access your Bamboo Payroll account',
		},
	'Learn how': {
		translation: 'Learn how',
	},
	'Learn more': {
		translation: 'Learn more',
	},
	'Learn more about ACA Employer Mandate': {
		translation: 'Learn more about ACA Employer Mandate',
	},
	'Learn more about the iApplicants integration by visiting our <a href="https://help.bamboohr.com/forums/20349381-iApplicants-Applicant-Tracking" target="_blank" rel="noopener noreferrer">Help Center</a>. Or you can email us at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a> or call 1-866-387-9595.':
		{
			translation:
				'Learn more about the iApplicants integration by visiting our <a href=\\"https://help.bamboohr.com/forums/20349381-iApplicants-Applicant-Tracking\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Help Center</a>. Or you can email us at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a> or call 1-866-387-9595.',
		},
	'Learn more about this in our %1$sbrowser support help article%1$s.': {
		translation:
			'Learn more about this in our %1$sbrowser support help article%1$s.',
	},
	'Learn more about this in our [browser support help article]': {
		translation: 'Learn more about this in our [browser support help article]',
	},
	'Learn more with our ': {
		translation: 'Learn more with our ',
	},
	'Learn more.': {
		translation: 'Learn more.',
	},
	'Leave Employee Number blank to auto-assign the next available number.': {
		translation:
			'Leave Employee Number blank to auto-assign the next available number.',
	},
	'Leave of Absence': {
		translation: 'Leave of Absence',
	},
	'Leaving On': {
		translation: 'Leaving On',
	},
	'Left axis for chart': {
		translation: 'Left axis for chart',
	},
	'Legacy Login': {
		translation: 'Legacy Login',
	},
	'Legal Full Name': {
		translation: 'Legal Full Name',
	},
	'Legal Hold': {
		translation: 'Legal Hold',
	},
	'Legal separation': {
		translation: 'Legal separation',
	},
	Legend: {
		translation: 'Legend',
	},
	Length: {
		translation: 'Length',
	},
	'Length Of Service': {
		translation: 'Length Of Service',
	},
	'Length Of Service Bar Chart': {
		translation: 'Length Of Service Bar Chart',
	},
	'Length of Service': {
		translation: 'Length of Service',
	},
	'Length of Service Donut Chart': {
		translation: 'Length of Service Donut Chart',
	},
	'Length of service': {
		translation: 'Length of service',
	},
	'Length of service: ': {
		translation: 'Length of service: ',
	},
	'Length of service: Years': {
		translation: 'Length of service: Years',
	},
	'Less Engaged': {
		translation: 'Less Engaged',
	},
	'Less than ': {
		translation: 'Less than ',
	},
	'Less than 1 year': {
		translation: 'Less than 1 year',
	},
	'Let Managers Get Feedback for Their Employees': {
		translation: 'Let Managers Get Feedback for Their Employees',
	},
	'Let Managers Get Peer Feedback for Their Employees': {
		translation: 'Let Managers Get Peer Feedback for Their Employees',
	},
	"Let's Double Check": {
		translation: "Let's Double Check",
	},
	"Let's add your first employee": {
		translation: "Let's add your first employee",
	},
	"Let's find another way around": {
		translation: "Let's find another way around",
	},
	"Let's get 'em filled in": {
		translation: "Let's get 'em filled in",
	},
	"Let's get started": {
		translation: "Let's get started",
	},
	"Let's get started by getting to know a little bit about your Plan.": {
		translation:
			"Let's get started by getting to know a little bit about your Plan.",
	},
	"Let's get started!": {
		translation: "Let's get started!",
	},
	"Let's get this show on the road": {
		translation: "Let's get this show on the road",
	},
	"Let's get this show on the road! Add your first job opening above...": {
		translation:
			"Let's get this show on the road! Add your first job opening above...",
	},
	"Let's get this show on the road.": {
		translation: "Let's get this show on the road.",
	},
	"Let's see if we can get another page to pick up the slack.": {
		translation: "Let's see if we can get another page to pick up the slack.",
	},
	"Let's set up your new tab!": {
		translation: "Let's set up your new tab!",
	},
	"Let's start with Pay Groups": {
		translation: "Let's start with Pay Groups",
	},
	"Let's start with the basics.": {
		translation: "Let's start with the basics.",
	},
	"Let's sync up.": {
		translation: "Let's sync up.",
	},
	"Let's take a look at your time off balances on `%1$s`:": {
		translation: "Let's take a look at your time off balances on `%1$s`:",
	},
	"Let's take a look at your time off balances:": {
		translation: "Let's take a look at your time off balances:",
	},
	Letter: {
		translation: 'Letter',
	},
	'Let’s make sure this new employee gets paid. Will you pay them through BambooHR Payroll?':
		{
			translation:
				'Let’s make sure this new employee gets paid. Will you pay them through BambooHR Payroll?',
		},
	'Let’s start by updating all of your existing plans. We’ll need to get a little bit of additional information about each one.':
		{
			translation:
				'Let’s start by updating all of your existing plans. We’ll need to get a little bit of additional information about each one.',
		},
	Level: {
		translation: 'Level',
	},
	'Level %1$s': {
		translation: 'Level %1$s',
	},
	'Level 2 accruals will begin when the next accrual period starts.': {
		translation:
			'Level 2 accruals will begin when the next accrual period starts.',
	},
	'Level Compensation Type': {
		translation: 'Level Compensation Type',
	},
	'Level Currency': {
		translation: 'Level Currency',
	},
	'Level High': {
		translation: 'Level High',
	},
	'Level Low': {
		translation: 'Level Low',
	},
	'Level Mid': {
		translation: 'Level Mid',
	},
	'Level Name': {
		translation: 'Level Name',
	},
	'Level Percentage Range': {
		translation: 'Level Percentage Range',
	},
	'Level Transitions': {
		translation: 'Level Transitions',
	},
	'Level Transitions Happen...': {
		translation: 'Level Transitions Happen...',
	},
	Levels: {
		translation: 'Levels',
	},
	'Levels and Bands': {
		translation: 'Levels and Bands',
	},
	'Levels and Bands: Compensation Type': {
		translation: 'Levels and Bands: Compensation Type',
	},
	'Levels and Bands: Currency Code': {
		translation: 'Levels and Bands: Currency Code',
	},
	'Levels and Bands: High': {
		translation: 'Levels and Bands: High',
	},
	'Levels and Bands: Low': {
		translation: 'Levels and Bands: Low',
	},
	'Levels and Bands: Mid': {
		translation: 'Levels and Bands: Mid',
	},
	'Levels and Bands: Name': {
		translation: 'Levels and Bands: Name',
	},
	'Levels and Bands: Percentage Range': {
		translation: 'Levels and Bands: Percentage Range',
	},
	'Levels to export': {
		translation: 'Levels to export',
	},
	'Leverage Okta to do Single Sign-On, provisioning and de-provisioning, and HR-Driven IT provisioning with BambooHR.':
		{
			translation:
				'Leverage Okta to do Single Sign-On, provisioning and de-provisioning, and HR-Driven IT provisioning with BambooHR.',
		},
	'License #': {
		translation: 'License #',
	},
	'License # (1)': {
		translation: 'License # (1)',
	},
	'License # (2)': {
		translation: 'License # (2)',
	},
	'License # (3)': {
		translation: 'License # (3)',
	},
	'License # (4)': {
		translation: 'License # (4)',
	},
	'License Exp. Date': {
		translation: 'License Exp. Date',
	},
	'License Number': {
		translation: 'License Number',
	},
	'License Plate': {
		translation: 'License Plate',
	},
	'License Plate Number': {
		translation: 'License Plate Number',
	},
	'License State (1)': {
		translation: 'License State (1)',
	},
	'License State (2)': {
		translation: 'License State (2)',
	},
	'License State (3)': {
		translation: 'License State (3)',
	},
	'License State (4)': {
		translation: 'License State (4)',
	},
	'License Type': {
		translation: 'License Type',
	},
	'License plate #': {
		translation: 'License plate #',
	},
	'Life Happens': {
		translation: 'Life Happens',
	},
	'Life Insurance': {
		translation: 'Life Insurance',
	},
	'Life Insurance Plan': {
		translation: 'Life Insurance Plan',
	},
	'Life Insurance Type': {
		translation: 'Life Insurance Type',
	},
	Likes: {
		translation: 'Likes',
	},
	Limit: {
		translation: 'Limit',
	},
	'Limit number of posts to...': {
		translation: 'Limit number of posts to...',
	},
	'Limit what people can see by adding filters before sharing.': {
		translation: 'Limit what people can see by adding filters before sharing.',
	},
	'Limited Healthcare': {
		translation: 'Limited Healthcare',
	},
	'Limited time only… This Peer Feedback must be completed by %1s.': {
		translation:
			'Limited time only… This Peer Feedback must be completed by %1s.',
	},
	'Limited time only… This feedback must be completed by %1s.': {
		translation: 'Limited time only… This feedback must be completed by %1s.',
	},
	'Lindon, Utah': {
		translation: 'Lindon, Utah',
	},
	'Line chart': {
		translation: 'Line chart',
	},
	'Line item': {
		translation: 'Line item',
	},
	Link: {
		translation: 'Link',
	},
	'Link (URL)': {
		translation: 'Link (URL)',
	},
	'Link Expires': {
		translation: 'Link Expires',
	},
	'Link Name': {
		translation: 'Link Name',
	},
	'Link Name exceeded %1$s character limit': {
		translation: 'Link Name exceeded %1$s character limit',
	},
	'Link Sent': {
		translation: 'Link Sent',
	},
	'Link Title': {
		translation: 'Link Title',
	},
	'Link URL': {
		translation: 'Link URL',
	},
	'Link to this job': {
		translation: 'Link to this job',
	},
	LinkedIn: {
		translation: 'LinkedIn',
	},
	'LinkedIn ID': {
		translation: 'LinkedIn ID',
	},
	'LinkedIn Profile': {
		translation: 'LinkedIn Profile',
	},
	'LinkedIn Profile URL': {
		translation: 'LinkedIn Profile URL',
	},
	'LinkedIn URL': {
		translation: 'LinkedIn URL',
	},
	'LinkedIn company identifier and name are required': {
		translation: 'LinkedIn company identifier and name are required',
	},
	'LinkedIn company identifier is required': {
		translation: 'LinkedIn company identifier is required',
	},
	'LinkedIn company name is required': {
		translation: 'LinkedIn company name is required',
	},
	'LinkedIn company options are required': {
		translation: 'LinkedIn company options are required',
	},
	'LinkedIn settings not found.': {
		translation: 'LinkedIn settings not found.',
	},
	'LinkedIn, Twitter & Facebook': {
		translation: 'LinkedIn, Twitter & Facebook',
	},
	Links: {
		translation: 'Links',
	},
	List: {
		translation: 'List',
	},
	'List Employees with No Manager (%1)': {
		translation: 'List Employees with No Manager (%1)',
	},
	'List Employees with No Manager ({1})': {
		translation: 'List Employees with No Manager ({1})',
	},
	'List of Employees': {
		translation: 'List of Employees',
	},
	'List of files': {
		translation: 'List of files',
	},
	'List order successfully updated.': {
		translation: 'List order successfully updated.',
	},
	'Load more Celebrations': {
		translation: 'Load more Celebrations',
	},
	"Load more Who's Out": {
		translation: "Load more Who's Out",
	},
	'Loading Image...': {
		translation: 'Loading Image...',
	},
	'Loading Performance Data': {
		translation: 'Loading Performance Data',
	},
	'Loading Preview...': {
		translation: 'Loading Preview...',
	},
	'Loading Report': {
		translation: 'Loading Report',
	},
	'Loading Timeline': {
		translation: 'Loading Timeline',
	},
	'Loading employees from Netsuite': {
		translation: 'Loading employees from Netsuite',
	},
	'Loading lists from Netsuite': {
		translation: 'Loading lists from Netsuite',
	},
	'Loading your top secret pay information.': {
		translation: 'Loading your top secret pay information.',
	},
	'Loading...': {
		translation: 'Loading...',
	},
	Loan: {
		translation: 'Loan',
	},
	'Loan %s': {
		translation: 'Loan %s',
	},
	'Loan Number': {
		translation: 'Loan Number',
	},
	'Loan repayments': {
		translation: 'Loan repayments',
	},
	Local: {
		translation: 'Local',
	},
	'Local Source': {
		translation: 'Local Source',
	},
	'Local Time': {
		translation: 'Local Time',
	},
	'Local Value': {
		translation: 'Local Value',
	},
	'Local Work In': {
		translation: 'Local Work In',
	},
	'Locate the BambooHR Integration and click on the "Off" toggle. This will then open up a pop-up window where you will enter the following:':
		{
			translation:
				'Locate the BambooHR Integration and click on the \\"Off\\" toggle. This will then open up a pop-up window where you will enter the following:',
		},
	Location: {
		translation: 'Location',
	},
	"Location '%1$s' not found": {
		translation: "Location '%1$s' not found",
	},
	'Location Bar Chart': {
		translation: 'Location Bar Chart',
	},
	'Location Donut Chart': {
		translation: 'Location Donut Chart',
	},
	'Location Name': {
		translation: 'Location Name',
	},
	'Location Type': {
		translation: 'Location Type',
	},
	'Location cannot be empty': {
		translation: 'Location cannot be empty',
	},
	'Location is not valid for employee’s pay schedule.': {
		translation: 'Location is not valid for employee’s pay schedule.',
	},
	'Location is required': {
		translation: 'Location is required',
	},
	'Location of Expense': {
		translation: 'Location of Expense',
	},
	'Location was added successfully': {
		translation: 'Location was added successfully',
	},
	'Location · 0:00 pm local time': {
		translation: 'Location · 0:00 pm local time',
	},
	'Location(s):': {
		translation: 'Location(s):',
	},
	'Location: %1$s': {
		translation: 'Location: %1$s',
	},
	Locations: {
		translation: 'Locations',
	},
	'Locked Cell': {
		translation: 'Locked Cell',
	},
	'Log Back In': {
		translation: 'Log Back In',
	},
	'Log In': {
		translation: 'Log In',
	},
	'Log In to Payroll': {
		translation: 'Log In to Payroll',
	},
	'Log Out': {
		translation: 'Log Out',
	},
	'Log Out & Finish Later': {
		translation: 'Log Out & Finish Later',
	},
	'Log back in to pick up where you left off.': {
		translation: 'Log back in to pick up where you left off.',
	},
	'Log company assets you lend to employees.': {
		translation: 'Log company assets you lend to employees.',
	},
	'Log in': {
		translation: 'Log in',
	},
	'Log in with Email and Password': {
		translation: 'Log in with Email and Password',
	},
	'Log in with Google': {
		translation: 'Log in with Google',
	},
	'Log in with Microsoft': {
		translation: 'Log in with Microsoft',
	},
	'Log in with Okta': {
		translation: 'Log in with Okta',
	},
	'Log in with OneLogin': {
		translation: 'Log in with OneLogin',
	},
	'Log in with QuickBooks': {
		translation: 'Log in with QuickBooks',
	},
	'Log in with SAML': {
		translation: 'Log in with SAML',
	},
	'Log into Jazz and go to the Integrations Tab. Locate the integration for BambooHR, and click the "Edit Credentials" button':
		{
			translation:
				'Log into Jazz and go to the Integrations Tab. Locate the integration for BambooHR, and click the \\"Edit Credentials\\" button',
		},
	'Log into OneLogin and click the Find Apps Tab. In the search box, begin typing BambooHR and then click the option to "add" this app to your OneLogin account.':
		{
			translation:
				'Log into OneLogin and click the Find Apps Tab. In the search box, begin typing BambooHR and then click the option to \\"add\\" this app to your OneLogin account.',
		},
	'Log into your CATS account and locate the gear icon in the upper right-hand corner of your screen. Click on this icon and then click on the "Administration" link from the drop-down menu. On the Administration page, click the "Integrations" link.':
		{
			translation:
				'Log into your CATS account and locate the gear icon in the upper right-hand corner of your screen. Click on this icon and then click on the \\"Administration\\" link from the drop-down menu. On the Administration page, click the \\"Integrations\\" link.',
		},
	'Log out': {
		translation: 'Log out',
	},
	'Log time directly to the project': {
		translation: 'Log time directly to the project',
	},
	'Log time to specific tasks on the project': {
		translation: 'Log time to specific tasks on the project',
	},
	'Logged In notice': {
		translation: 'Logged In notice',
	},
	'Logged Out': {
		translation: 'Logged Out',
	},
	'Logged Time this Month': {
		translation: 'Logged Time this Month',
	},
	Login: {
		translation: 'Login',
	},
	'Login As A Specific User': {
		translation: 'Login As A Specific User',
	},
	'Login Expiration Date': {
		translation: 'Login Expiration Date',
	},
	'Login Incorrect': {
		translation: 'Login Incorrect',
	},
	'Login Settings': {
		translation: 'Login Settings',
	},
	'Login at https://insight.payscale.com/employeeRefresh.aspx': {
		translation: 'Login at https://insight.payscale.com/employeeRefresh.aspx',
	},
	'Login to BambooHR': {
		translation: 'Login to BambooHR',
	},
	'Login to COMPAS and go to the Partner Integrations Icon (located within the UTILITIES Tab). Locate the integration for BambooHR, and click the "Edit Credentials" button.':
		{
			translation:
				'Login to COMPAS and go to the Partner Integrations Icon (located within the UTILITIES Tab). Locate the integration for BambooHR, and click the \\"Edit Credentials\\" button.',
		},
	'Login to Continue': {
		translation: 'Login to Continue',
	},
	"Login to PayScale Insight and enter in your BambooHR API information. We'll take it from there!":
		{
			translation:
				"Login to PayScale Insight and enter in your BambooHR API information. We'll take it from there!",
		},
	'Login to your Cornerstone CSB account.': {
		translation: 'Login to your Cornerstone CSB account.',
	},
	'Login to your Greenhouse account': {
		translation: 'Login to your Greenhouse account',
	},
	'Login to your HiringThing account': {
		translation: 'Login to your HiringThing account',
	},
	'Login to your Jobber account and navigate to the settings panel and enter your BambooHR API key and subdomain':
		{
			translation:
				'Login to your Jobber account and navigate to the settings panel and enter your BambooHR API key and subdomain',
		},
	'Login to your NimbleSchedule account and navigate to "My Account" then go to Applications and click the widget for BambooHR to add it. You\'ll need to enter your BambooHR API key and BambooHR account sub-domain.':
		{
			translation:
				'Login to your NimbleSchedule account and navigate to \\"My Account\\" then go to Applications and click the widget for BambooHR to add it. You\'ll need to enter your BambooHR API key and BambooHR account sub-domain.',
		},
	'Login to your OrgChart Now account': {
		translation: 'Login to your OrgChart Now account',
	},
	'Login to your Small Improvements account and add company ID and API key under the Configuration tab.':
		{
			translation:
				'Login to your Small Improvements account and add company ID and API key under the Configuration tab.',
		},
	Logins: {
		translation: 'Logins',
	},
	Logo: {
		translation: 'Logo',
	},
	'Logo & Color': {
		translation: 'Logo & Color',
	},
	'London, UK': {
		translation: 'London, UK',
	},
	'Long break, huh?': {
		translation: 'Long break, huh?',
	},
	'Looking good! Your employee information is complete.': {
		translation: 'Looking good! Your employee information is complete.',
	},
	"Looking to take a vacation? Here's your PTO balances as of today:": {
		translation:
			"Looking to take a vacation? Here's your PTO balances as of today:",
	},
	'Looks like %1$s is inactive, so a reminder has not been sent.': {
		translation:
			'Looks like %1$s is inactive, so a reminder has not been sent.',
	},
	'Looks like everyone completed feedback in that date range': {
		translation: 'Looks like everyone completed feedback in that date range',
	},
	'Looks like some of the data you provided is invalid': {
		translation: 'Looks like some of the data you provided is invalid',
	},
	'Looks like something went wrong on our side. Sorry about that. Give it another shot?':
		{
			translation:
				'Looks like something went wrong on our side. Sorry about that. Give it another shot?',
		},
	"Looks like the id you provided doesn't exist.": {
		translation: "Looks like the id you provided doesn't exist.",
	},
	'Looks like you already have a benefit plan with that name. Please enter a different name.':
		{
			translation:
				'Looks like you already have a benefit plan with that name. Please enter a different name.',
		},
	'Looks like you already have a deduction with that name. Please enter a different name.':
		{
			translation:
				'Looks like you already have a deduction with that name. Please enter a different name.',
		},
	'Looks like you already have a plan with that name. Please enter a different name.':
		{
			translation:
				'Looks like you already have a plan with that name. Please enter a different name.',
		},
	'Looks like you and {1} may not be on the same page.': {
		translation: 'Looks like you and {1} may not be on the same page.',
	},
	"Looks like you don't have sufficient permissions to access this report, please contact your HR Administrator for assistance":
		{
			translation:
				"Looks like you don't have sufficient permissions to access this report, please contact your HR Administrator for assistance",
		},
	'Looks like you forgot to clock out.': {
		translation: 'Looks like you forgot to clock out.',
	},
	"Looks like you haven't set up an %1$s template.": {
		translation: "Looks like you haven't set up an %1$s template.",
	},
	'Loss due to carryover expiration': {
		translation: 'Loss due to carryover expiration',
	},
	'Loss due to carryover limit': {
		translation: 'Loss due to carryover limit',
	},
	'Loss due to year to year carry over limit': {
		translation: 'Loss due to year to year carry over limit',
	},
	'Loss due to year to year carry over limit.': {
		translation: 'Loss due to year to year carry over limit.',
	},
	"Loss of coverage under spouse's plan": {
		translation: "Loss of coverage under spouse's plan",
	},
	'Low engagement and is burned out.': {
		translation: 'Low engagement and is burned out.',
	},
	'Low response rate': {
		translation: 'Low response rate',
	},
	Lowercase: {
		translation: 'Lowercase',
	},
	'Lowest Average Scores': {
		translation: 'Lowest Average Scores',
	},
	'Lowest Completion': {
		translation: 'Lowest Completion',
	},
	MALE: {
		translation: 'MALE',
	},
	MB: {
		translation: 'MB',
	},
	'MGR Custom Answer %s': {
		translation: 'MGR Custom Answer %s',
	},
	'MGR Custom Question %s': {
		translation: 'MGR Custom Question %s',
	},
	'MGR: ': {
		translation: 'MGR: ',
	},
	'MGR: File Attached': {
		translation: 'MGR: File Attached',
	},
	'MGR: How could [Name] improve?': {
		translation: 'MGR: How could [Name] improve?',
	},
	'MGR: What are some things [Name] does well?': {
		translation: 'MGR: What are some things [Name] does well?',
	},
	MI: {
		translation: 'MI',
	},
	MIU: {
		translation: 'MIU',
	},
	MVR: {
		translation: 'MVR',
	},
	'MVR Date': {
		translation: 'MVR Date',
	},
	'MVR Exp.': {
		translation: 'MVR Exp.',
	},
	'Made an Offer': {
		translation: 'Made an Offer',
	},
	'Mailing Address': {
		translation: 'Mailing Address',
	},
	'Mailing address 1': {
		translation: 'Mailing address 1',
	},
	'Mailing address 2': {
		translation: 'Mailing address 2',
	},
	'Mailing city': {
		translation: 'Mailing city',
	},
	'Mailing state': {
		translation: 'Mailing state',
	},
	'Mailing zip code': {
		translation: 'Mailing zip code',
	},
	Major: {
		translation: 'Major',
	},
	'Major field of study': {
		translation: 'Major field of study',
	},
	'Major/Specialization': {
		translation: 'Major/Specialization',
	},
	'Make Your Changes': {
		translation: 'Make Your Changes',
	},
	'Make any necessary additions or changes and click "next"': {
		translation: 'Make any necessary additions or changes and click \\"next\\"',
	},
	'Make any necessary additions or changes and click "next".': {
		translation:
			'Make any necessary additions or changes and click \\"next\\".',
	},
	'Make changes using the new form fields': {
		translation: 'Make changes using the new form fields',
	},
	'Make changes using the new form fields.': {
		translation: 'Make changes using the new form fields.',
	},
	'Make everyone’s life a little bit easier and send a new hire packet.': {
		translation:
			'Make everyone’s life a little bit easier and send a new hire packet.',
	},
	'Make file upload required': {
		translation: 'Make file upload required',
	},
	"Make sure everyone listed has at least one direct deposit account, otherwise a paper check will be sent (like it's 1999, baby!)":
		{
			translation:
				"Make sure everyone listed has at least one direct deposit account, otherwise a paper check will be sent (like it's 1999, baby!)",
		},
	'Make sure non-benefit deductions such as garnishments are added for any employees that have them':
		{
			translation:
				'Make sure non-benefit deductions such as garnishments are added for any employees that have them',
		},
	'Make sure the box is checked next to Export to BambooHR?': {
		translation: 'Make sure the box is checked next to Export to BambooHR?',
	},
	'Make sure this information is updated by %1$s at 12 PM %2$s, or these employees won’t be paid.':
		{
			translation:
				'Make sure this information is updated by %1$s at 12 PM %2$s, or these employees won’t be paid.',
		},
	'Make sure this information is updated by %1$s at 12 PM Pacific Time, or these employees won’t be paid.':
		{
			translation:
				'Make sure this information is updated by %1$s at 12 PM Pacific Time, or these employees won’t be paid.',
		},
	'Make sure this information is updated by %1$s at 12 PM Pacific Time, or this employee won’t be paid.':
		{
			translation:
				'Make sure this information is updated by %1$s at 12 PM Pacific Time, or this employee won’t be paid.',
		},
	'Make sure to also update the fields highlighted in red.': {
		translation: 'Make sure to also update the fields highlighted in red.',
	},
	'Make sure you attach the requested file(s) before completing the task.': {
		translation:
			'Make sure you attach the requested file(s) before completing the task.',
	},
	'Make sure you cancel any outstanding offers on these candidates before moving them.':
		{
			translation:
				'Make sure you cancel any outstanding offers on these candidates before moving them.',
		},
	"Make sure you complete all the final details when an employee leaves the company. You've got to love checklists.":
		{
			translation:
				"Make sure you complete all the final details when an employee leaves the company. You've got to love checklists.",
		},
	'Make sure you select a pay group for each employee before continuing.': {
		translation:
			'Make sure you select a pay group for each employee before continuing.',
	},
	'Make sure your changes are saved before you approve.': {
		translation: 'Make sure your changes are saved before you approve.',
	},
	'Make sure your logo has a transparent background.': {
		translation: 'Make sure your logo has a transparent background.',
	},
	'Make sure your logo is a PNG, GIF, or JPG file.': {
		translation: 'Make sure your logo is a PNG, GIF, or JPG file.',
	},
	'Make sure your new password is secure:': {
		translation: 'Make sure your new password is secure:',
	},
	'Make sure your password is secure:': {
		translation: 'Make sure your password is secure:',
	},
	'Make sure you’re only trying to upload the file types specified.': {
		translation:
			'Make sure you’re only trying to upload the file types specified.',
	},
	'Make the same changes for the whole group': {
		translation: 'Make the same changes for the whole group',
	},
	'Make the white background on my logo transparent': {
		translation: 'Make the white background on my logo transparent',
	},
	'Make this Category name publicly visible on the calendar': {
		translation: 'Make this Category name publicly visible on the calendar',
	},
	'Making Changes for the New Year?': {
		translation: 'Making Changes for the New Year?',
	},
	Male: {
		translation: 'Male',
	},
	'Male/Female Headcount By Department': {
		translation: 'Male/Female Headcount By Department',
	},
	Manage: {
		translation: 'Manage',
	},
	'Manage %s': {
		translation: 'Manage %s',
	},
	'Manage Access': {
		translation: 'Manage Access',
	},
	'Manage Administrators': {
		translation: 'Manage Administrators',
	},
	'Manage Applications': {
		translation: 'Manage Applications',
	},
	'Manage Benefits (admin only)': {
		translation: 'Manage Benefits (admin only)',
	},
	'Manage Company Settings': {
		translation: 'Manage Company Settings',
	},
	'Manage Custom Tags': {
		translation: 'Manage Custom Tags',
	},
	'Manage Custom eNPS Tags': {
		translation: 'Manage Custom eNPS Tags',
	},
	'Manage Employee Access Levels': {
		translation: 'Manage Employee Access Levels',
	},
	'Manage Employee Tasks': {
		translation: 'Manage Employee Tasks',
	},
	'Manage Employees': {
		translation: 'Manage Employees',
	},
	'Manage Error Service': {
		translation: 'Manage Error Service',
	},
	'Manage Group': {
		translation: 'Manage Group',
	},
	'Manage Hour Imports': {
		translation: 'Manage Hour Imports',
	},
	'Manage Job Openings': {
		translation: 'Manage Job Openings',
	},
	'Manage Job Openings and Candidates': {
		translation: 'Manage Job Openings and Candidates',
	},
	'Manage Job Openings, Talent Pools, and Candidates': {
		translation: 'Manage Job Openings, Talent Pools, and Candidates',
	},
	'Manage Payroll Info': {
		translation: 'Manage Payroll Info',
	},
	'Manage Project Tracking': {
		translation: 'Manage Project Tracking',
	},
	'Manage Reports': {
		translation: 'Manage Reports',
	},
	'Manage Secure Download Link': {
		translation: 'Manage Secure Download Link',
	},
	'Manage Secure Download Links': {
		translation: 'Manage Secure Download Links',
	},
	'Manage Settings': {
		translation: 'Manage Settings',
	},
	'Manage Shift Differentials': {
		translation: 'Manage Shift Differentials',
	},
	'Manage Time Off Policy Assignments': {
		translation: 'Manage Time Off Policy Assignments',
	},
	'Manage Timesheet': {
		translation: 'Manage Timesheet',
	},
	'Manage Users': {
		translation: 'Manage Users',
	},
	'Manage and Run Payroll': {
		translation: 'Manage and Run Payroll',
	},
	'Manage errors and notifications': {
		translation: 'Manage errors and notifications',
	},
	'Manage state of company users': {
		translation: 'Manage state of company users',
	},
	'Manage timesheets': {
		translation: 'Manage timesheets',
	},
	'Manage your job postings and applicants.': {
		translation: 'Manage your job postings and applicants.',
	},
	Manager: {
		translation: 'Manager',
	},
	'Manager (Reports to)': {
		translation: 'Manager (Reports to)',
	},
	'Manager Access Level': {
		translation: 'Manager Access Level',
	},
	'Manager Access Levels can be configured to allow Managers to see specific information about their direct and/or indirect reports only.':
		{
			translation:
				'Manager Access Levels can be configured to allow Managers to see specific information about their direct and/or indirect reports only.',
		},
	'Manager Assessment': {
		translation: 'Manager Assessment',
	},
	'Manager Assessment will now be shared %1': {
		translation: 'Manager Assessment will now be shared %1',
	},
	'Manager Assessment will show here once completed.': {
		translation: 'Manager Assessment will show here once completed.',
	},
	'Manager ID': {
		translation: 'Manager ID',
	},
	'Manager Question': {
		translation: 'Manager Question',
	},
	'Manager Question (you can type [Name] and we’ll put in the Employee’s Name)':
		{
			translation:
				'Manager Question (you can type [Name] and we’ll put in the Employee’s Name)',
		},
	"Manager's Manager": {
		translation: "Manager's Manager",
	},
	"Manager's email": {
		translation: "Manager's email",
	},
	"Manager's note": {
		translation: "Manager's note",
	},
	'Manager/Supervisor': {
		translation: 'Manager/Supervisor',
	},
	'Manager: ': {
		translation: 'Manager: ',
	},
	Managers: {
		translation: 'Managers',
	},
	'Managers Icon': {
		translation: 'Managers Icon',
	},
	'Managers always have access to view all performance info for their direct and indirect reports. They can also create and edit goals.':
		{
			translation:
				'Managers always have access to view all performance info for their direct and indirect reports. They can also create and edit goals.',
		},
	'Managers always have access to view all performance info for their<br/>direct and indirect reports. They can also create and edit goals.':
		{
			translation:
				'Managers always have access to view all performance info for their<br/>direct and indirect reports. They can also create and edit goals.',
		},
	'Managers have the tools they need to be super.': {
		translation: 'Managers have the tools they need to be super.',
	},
	'Managers will always have full access to performance for their direct and indirect reports.':
		{
			translation:
				'Managers will always have full access to performance for their direct and indirect reports.',
		},
	"Managers will be able to make requests for feedback for their direct reports. Don't worry, only managers will ever see the feedback. Otherwise it could get pretty awkward.":
		{
			translation:
				"Managers will be able to make requests for feedback for their direct reports. Don't worry, only managers will ever see the feedback. Otherwise it could get pretty awkward.",
		},
	"Managers will be able to make requests for feedback for their direct reports. To help make sure nobody gets overloaded, we'll make sure they don't overlap with assessments.":
		{
			translation:
				"Managers will be able to make requests for feedback for their direct reports. To help make sure nobody gets overloaded, we'll make sure they don't overlap with assessments.",
		},
	'Manager’s Manager': {
		translation: 'Manager’s Manager',
	},
	'Managing employee data and benefits can be frustrating and time consuming. HR teams don’t have time to juggle multiple systems to keep employee information up to date. That’s why PlanSource and BambooHR have partnered together to introduce a seamless employee management and benefits administration system to cover all your HR needs. At PlanSource, our mission is to provide better technology for a better benefits and HR experience. Our benefits administration software provides cloud-based benefits shopping, enrollment, billing, compliance and administration.':
		{
			translation:
				'Managing employee data and benefits can be frustrating and time consuming. HR teams don’t have time to juggle multiple systems to keep employee information up to date. That’s why PlanSource and BambooHR have partnered together to introduce a seamless employee management and benefits administration system to cover all your HR needs. At PlanSource, our mission is to provide better technology for a better benefits and HR experience. Our benefits administration software provides cloud-based benefits shopping, enrollment, billing, compliance and administration.',
		},
	Mandarin: {
		translation: 'Mandarin',
	},
	'Manually Updated Balance': {
		translation: 'Manually Updated Balance',
	},
	'Manually updated': {
		translation: 'Manually updated',
	},
	Map: {
		translation: 'Map',
	},
	'Map & Directions': {
		translation: 'Map & Directions',
	},
	'Map Cornerstone Roles to the appropriate BambooHR Job Titles.': {
		translation:
			'Map Cornerstone Roles to the appropriate BambooHR Job Titles.',
	},
	'Map Job Titles to Cornerstone Roles': {
		translation: 'Map Job Titles to Cornerstone Roles',
	},
	Mar: {
		translation: 'Mar',
	},
	March: {
		translation: 'March',
	},
	'Marital Status': {
		translation: 'Marital Status',
	},
	'Marital Status is required': {
		translation: 'Marital Status is required',
	},
	'Marital status': {
		translation: 'Marital status',
	},
	'Mark as Dislike': {
		translation: 'Mark as Dislike',
	},
	'Mark as Eligible': {
		translation: 'Mark as Eligible',
	},
	'Mark as Like': {
		translation: 'Mark as Like',
	},
	'Mark as Not Eligible': {
		translation: 'Mark as Not Eligible',
	},
	'Marked done by ': {
		translation: 'Marked done by ',
	},
	'Marked done by %s on %s': {
		translation: 'Marked done by %s on %s',
	},
	Marketing: {
		translation: 'Marketing',
	},
	Marriage: {
		translation: 'Marriage',
	},
	Married: {
		translation: 'Married',
	},
	'Married Filing Jointly': {
		translation: 'Married Filing Jointly',
	},
	'Married, but withhold at single rate': {
		translation: 'Married, but withhold at single rate',
	},
	"Master's": {
		translation: "Master's",
	},
	MasterCard: {
		translation: 'MasterCard',
	},
	'Match BambooHR locations with Gusto locations below. Gusto requires address and phone number for each location. If needed you can create a new Bamboo location to ensure there is a match for all Gusto locations.':
		{
			translation:
				'Match BambooHR locations with Gusto locations below. Gusto requires address and phone number for each location. If needed you can create a new Bamboo location to ensure there is a match for all Gusto locations.',
		},
	'Match Fields': {
		translation: 'Match Fields',
	},
	'Match Import Data with BambooHR Data': {
		translation: 'Match Import Data with BambooHR Data',
	},
	"Match dollar-for-dollar up to 3%% of the employee's compensation and 50 cents on the dollar for the employee's contribution between 3-5%% of the employee's compensation.":
		{
			translation:
				"Match dollar-for-dollar up to 3%% of the employee's compensation and 50 cents on the dollar for the employee's contribution between 3-5%% of the employee's compensation.",
		},
	'Match export to what is on screen': {
		translation: 'Match export to what is on screen',
	},
	'Match your data': {
		translation: 'Match your data',
	},
	'Matched %d Employee in Bamboo and Cornerstone.': {
		translation: {
			one: 'Matched %d Employee in Bamboo and Cornerstone.',
			other: 'Matched %d Employees in Bamboo and Cornerstone',
		},
	},
	'Matching Benefit Groups': {
		translation: 'Matching Benefit Groups',
	},
	'Max Accrual': {
		translation: 'Max Accrual',
	},
	'Max Accrual (Optional)': {
		translation: 'Max Accrual (Optional)',
	},
	'Max Tax': {
		translation: 'Max Tax',
	},
	'Maximum character limit exceeded. Please update the information field to less than 500 characters':
		{
			translation:
				'Maximum character limit exceeded. Please update the information field to less than 500 characters',
		},
	'Maximum of 1 time every 60 seconds': {
		translation: 'Maximum of 1 time every 60 seconds',
	},
	'Maxwell Health is a fully paperless operating system for employee benefits that streamlines online enrollment in all types of benefits and empowers employees to engage with their health and wellbeing. Maxwell totally reinvents the benefits shopping experience with its lifestyled-based packaging of benefits, and Maxwell’s mobile app engages employees throughout the year (not just during open enrollment).':
		{
			translation:
				'Maxwell Health is a fully paperless operating system for employee benefits that streamlines online enrollment in all types of benefits and empowers employees to engage with their health and wellbeing. Maxwell totally reinvents the benefits shopping experience with its lifestyled-based packaging of benefits, and Maxwell’s mobile app engages employees throughout the year (not just during open enrollment).',
		},
	'Maxwell Health will be the system of record for employee benefits and benefits administration, while BambooHR will remain the system of record for all other employer and employee information. Together, they provide a simple, all-in-one benefits and HR solution.':
		{
			translation:
				'Maxwell Health will be the system of record for employee benefits and benefits administration, while BambooHR will remain the system of record for all other employer and employee information. Together, they provide a simple, all-in-one benefits and HR solution.',
		},
	May: {
		translation: 'May',
	},
	'Maybe they are having a dance party in the break room?': {
		translation: 'Maybe they are having a dance party in the break room?',
	},
	'Maybe they are on a bio-break?': {
		translation: 'Maybe they are on a bio-break?',
	},
	'Maybe they are on a coffee run?': {
		translation: 'Maybe they are on a coffee run?',
	},
	'Maybe they are on a donut run?': {
		translation: 'Maybe they are on a donut run?',
	},
	'Medi-Cal #': {
		translation: 'Medi-Cal #',
	},
	'Medicaid #': {
		translation: 'Medicaid #',
	},
	'Medicaid License #': {
		translation: 'Medicaid License #',
	},
	Medical: {
		translation: 'Medical',
	},
	'Medical - Section 125 (pre-tax)': {
		translation: 'Medical - Section 125 (pre-tax)',
	},
	'Medical Doctor': {
		translation: 'Medical Doctor',
	},
	'Medical FSA': {
		translation: 'Medical FSA',
	},
	'Medical FSA 2025': {
		translation: 'Medical FSA 2025',
	},
	'Medical Histories': {
		translation: 'Medical Histories',
	},
	'Medical History': {
		translation: 'Medical History',
	},
	'Medical Plan': {
		translation: 'Medical Plan',
	},
	'Medical Record Number': {
		translation: 'Medical Record Number',
	},
	'Medicare #': {
		translation: 'Medicare #',
	},
	'Medicare PTAN #': {
		translation: 'Medicare PTAN #',
	},
	'Medium engagement and an okay attitude.': {
		translation: 'Medium engagement and an okay attitude.',
	},
	'Meets ACA Min Essential Coverage is required.': {
		translation: 'Meets ACA Min Essential Coverage is required.',
	},
	'Meets ACA Min Value is required.': {
		translation: 'Meets ACA Min Value is required.',
	},
	'Member First Name': {
		translation: 'Member First Name',
	},
	'Member Last Name': {
		translation: 'Member Last Name',
	},
	'Member SSN': {
		translation: 'Member SSN',
	},
	Message: {
		translation: 'Message',
	},
	'Message Sent': {
		translation: 'Message Sent',
	},
	'Message is too long.': {
		translation: 'Message is too long.',
	},
	'Message to Signers': {
		translation: 'Message to Signers',
	},
	'Method not yet implemented.': {
		translation: 'Method not yet implemented.',
	},
	'MicroTemplate.mod.js': {
		translation: 'MicroTemplate.mod.js',
	},
	'Microsoft Single Sign-On (SSO) makes logging into BambooHR a piece of cake!':
		{
			translation:
				'Microsoft Single Sign-On (SSO) makes logging into BambooHR a piece of cake!',
		},
	'Microsoft Single Sign-on settings updated': {
		translation: 'Microsoft Single Sign-on settings updated',
	},
	'Mid-Quarter Approval Email': {
		translation: 'Mid-Quarter Approval Email',
	},
	'Mid-Quarter Summary': {
		translation: 'Mid-Quarter Summary',
	},
	'Mid-Quarter Sweeps': {
		translation: 'Mid-Quarter Sweeps',
	},
	'Mid-Quarter Sweeps to review': {
		translation: 'Mid-Quarter Sweeps to review',
	},
	'Mid-Quarter Tax Balances': {
		translation: 'Mid-Quarter Tax Balances',
	},
	'Mid-Quarter Tax Collection Approval': {
		translation: 'Mid-Quarter Tax Collection Approval',
	},
	'Mid-level': {
		translation: 'Mid-level',
	},
	'Middle Eastern or North African': {
		translation: 'Middle Eastern or North African',
	},
	'Middle Initial': {
		translation: 'Middle Initial',
	},
	'Middle Name': {
		translation: 'Middle Name',
	},
	'Middle initial': {
		translation: 'Middle initial',
	},
	'Migration Tasks': {
		translation: 'Migration Tasks',
	},
	'Milestone current value must be between start and end values.': {
		translation:
			'Milestone current value must be between start and end values.',
	},
	'Milestone does not exist for given goal.': {
		translation: 'Milestone does not exist for given goal.',
	},
	'Milestone start value and end value must both either be set or empty for all milestones.':
		{
			translation:
				'Milestone start value and end value must both either be set or empty for all milestones.',
		},
	'Milestone start value and end value must both either be set or empty.': {
		translation:
			'Milestone start value and end value must both either be set or empty.',
	},
	'Milestone title cannot be empty.': {
		translation: 'Milestone title cannot be empty.',
	},
	'Milestones are limited to %1$s per goal.': {
		translation: 'Milestones are limited to %1$s per goal.',
	},
	'Milestones can only be updated by updating their parent goal.': {
		translation:
			'Milestones can only be updated by updating their parent goal.',
	},
	'Milestones must have different start and end values.': {
		translation: 'Milestones must have different start and end values.',
	},
	'Military ID Number': {
		translation: 'Military ID Number',
	},
	'Military leave': {
		translation: 'Military leave',
	},
	'Minimum Experience': {
		translation: 'Minimum Experience',
	},
	Minute: {
		translation: 'Minute',
	},
	Miscellaneous: {
		translation: 'Miscellaneous',
	},
	'Miscellaneous settings': {
		translation: 'Miscellaneous settings',
	},
	Missing: {
		translation: 'Missing',
	},
	'Missing Application': {
		translation: 'Missing Application',
	},
	'Missing Card Type ... Visa, Mastercard, Discover, American Express': {
		translation:
			'Missing Card Type ... Visa, Mastercard, Discover, American Express',
	},
	'Missing Daily Amounts': {
		translation: 'Missing Daily Amounts',
	},
	'Missing Data': {
		translation: 'Missing Data',
	},
	'Missing Driver License Number': {
		translation: 'Missing Driver License Number',
	},
	'Missing Email': {
		translation: 'Missing Email',
	},
	'Missing Expiry Date': {
		translation: 'Missing Expiry Date',
	},
	'Missing Final Pay Date': {
		translation: 'Missing Final Pay Date',
	},
	'Missing Issued Date': {
		translation: 'Missing Issued Date',
	},
	'Missing Issuing Country': {
		translation: 'Missing Issuing Country',
	},
	'Missing Issuing State': {
		translation: 'Missing Issuing State',
	},
	'Missing Or Invalid Number of Equity Granted': {
		translation: 'Missing Or Invalid Number of Equity Granted',
	},
	'Missing Or Invalid Number of Options Granted': {
		translation: 'Missing Or Invalid Number of Options Granted',
	},
	'Missing Passport Number': {
		translation: 'Missing Passport Number',
	},
	'Missing Required Data': {
		translation: 'Missing Required Data',
	},
	'Missing Tax ID': {
		translation: 'Missing Tax ID',
	},
	'Missing apps tool.': {
		translation: 'Missing apps tool.',
	},
	'Missing data': {
		translation: 'Missing data',
	},
	'Missing direct deposit account number': {
		translation: 'Missing direct deposit account number',
	},
	'Missing direct deposit account type': {
		translation: 'Missing direct deposit account type',
	},
	'Missing direct deposit amount': {
		translation: 'Missing direct deposit amount',
	},
	'Missing direct deposit flat or percent flag.': {
		translation: 'Missing direct deposit flat or percent flag.',
	},
	'Missing direct deposit routing number': {
		translation: 'Missing direct deposit routing number',
	},
	'Missing email subject': {
		translation: 'Missing email subject',
	},
	'Missing employee ID(s)': {
		translation: 'Missing employee ID(s)',
	},
	'Missing employees tool.': {
		translation: 'Missing employees tool.',
	},
	'Missing expiration month': {
		translation: 'Missing expiration month',
	},
	'Missing expiration year': {
		translation: 'Missing expiration year',
	},
	'Missing fields are listed below': {
		translation: 'Missing fields are listed below',
	},
	'Missing fields: ': {
		translation: 'Missing fields: ',
	},
	'Missing last four digits': {
		translation: 'Missing last four digits',
	},
	'Missing or invalid location parameters.': {
		translation: 'Missing or invalid location parameters.',
	},
	'Missing or invalid required field(s): ACA Status': {
		translation: 'Missing or invalid required field(s): ACA Status',
	},
	'Missing or invalid required field.': {
		translation: 'Missing or invalid required field.',
	},
	'Missing paid per': {
		translation: 'Missing paid per',
	},
	'Missing pay period': {
		translation: 'Missing pay period',
	},
	'Missing pay rate': {
		translation: 'Missing pay rate',
	},
	'Missing pay schedule': {
		translation: 'Missing pay schedule',
	},
	'Missing pay type': {
		translation: 'Missing pay type',
	},
	'Missing permissions to access benefit plan details.': {
		translation: 'Missing permissions to access benefit plan details.',
	},
	'Missing permissions to access benefit plans for employee.': {
		translation: 'Missing permissions to access benefit plans for employee.',
	},
	'Missing position for application': {
		translation: 'Missing position for application',
	},
	'Missing required field: %1$s': {
		translation: 'Missing required field: %1$s',
	},
	'Missing required fields for importing time tracking data': {
		translation: 'Missing required fields for importing time tracking data',
	},
	'Missing table mapping for the table you passed in.': {
		translation: 'Missing table mapping for the table you passed in.',
	},
	Mobile: {
		translation: 'Mobile',
	},
	'Mobile #': {
		translation: 'Mobile #',
	},
	'Mobile App QR Code Login': {
		translation: 'Mobile App QR Code Login',
	},
	'Mobile Apps': {
		translation: 'Mobile Apps',
	},
	'Mobile Phone': {
		translation: 'Mobile Phone',
	},
	'Mobile Phone Received': {
		translation: 'Mobile Phone Received',
	},
	Modals: {
		translation: 'Modals',
	},
	Moderna: {
		translation: 'Moderna',
	},
	Monday: {
		translation: 'Monday',
	},
	Mondays: {
		translation: 'Mondays',
	},
	'Money-purchase retirement plan (pre-tax)': {
		translation: 'Money-purchase retirement plan (pre-tax)',
	},
	Monitor: {
		translation: 'Monitor',
	},
	Month: {
		translation: 'Month',
	},
	'Month(s)': {
		translation: 'Month(s)',
	},
	'Month-to-date': {
		translation: 'Month-to-date',
	},
	Monthly: {
		translation: 'Monthly',
	},
	'Monthly (sent on the 1st of each month)': {
		translation: 'Monthly (sent on the 1st of each month)',
	},
	'Monthly Max': {
		translation: 'Monthly Max',
	},
	'Monthly Max:': {
		translation: 'Monthly Max:',
	},
	'Monthly Pay Date': {
		translation: 'Monthly Pay Date',
	},
	'Monthly Pay Dates': {
		translation: 'Monthly Pay Dates',
	},
	'Monthly Totals Based On:': {
		translation: 'Monthly Totals Based On:',
	},
	'Monthly totals based on': {
		translation: 'Monthly totals based on',
	},
	Months: {
		translation: 'Months',
	},
	'Months must be greater than zero': {
		translation: 'Months must be greater than zero',
	},
	More: {
		translation: 'More',
	},
	'More Engaged': {
		translation: 'More Engaged',
	},
	'More Information': {
		translation: 'More Information',
	},
	'More Storage Space': {
		translation: 'More Storage Space',
	},
	'More about %1': {
		translation: 'More about %1',
	},
	'More info': {
		translation: 'More info',
	},
	'More options...': {
		translation: 'More options...',
	},
	'More than one day?': {
		translation: 'More than one day?',
	},
	'More...': {
		translation: 'More...',
	},
	'Mortgage License #': {
		translation: 'Mortgage License #',
	},
	'Most Common': {
		translation: 'Most Common',
	},
	'Most Mentioned Topics Over Time': {
		translation: 'Most Mentioned Topics Over Time',
	},
	'Most common': {
		translation: 'Most common',
	},
	'Most companies have only one or two benefit groups.': {
		translation: 'Most companies have only one or two benefit groups.',
	},
	'Most fields should have automatically matched, but some may not have. Look through and make sure everything looks right.':
		{
			translation:
				'Most fields should have automatically matched, but some may not have. Look through and make sure everything looks right.',
		},
	Mother: {
		translation: 'Mother',
	},
	"Mother's Maiden Name": {
		translation: "Mother's Maiden Name",
	},
	'Motivational factors the company can control: management, recognition, and clear expectations.':
		{
			translation:
				'Motivational factors the company can control: management, recognition, and clear expectations.',
		},
	Move: {
		translation: 'Move',
	},
	'Move %1 items': {
		translation: 'Move %1 items',
	},
	'Move %s': {
		translation: 'Move %s',
	},
	'Move %s Candidates': {
		translation: 'Move %s Candidates',
	},
	'Move %s to': {
		translation: 'Move %s to',
	},
	'Move %s to:': {
		translation: 'Move %s to:',
	},
	'Move Along': {
		translation: 'Move Along',
	},
	'Move Applicant': {
		translation: 'Move Applicant',
	},
	'Move Candidates to:': {
		translation: 'Move Candidates to:',
	},
	'Move applicants to': {
		translation: 'Move applicants to',
	},
	'Move {1}': {
		translation: 'Move {1}',
	},
	'Move {1} Candidates': {
		translation: 'Move {1} Candidates',
	},
	'Move {1} to:': {
		translation: 'Move {1} to:',
	},
	Moved: {
		translation: 'Moved',
	},
	'Moved From': {
		translation: 'Moved From',
	},
	'Moved To': {
		translation: 'Moved To',
	},
	'Moved from %1$s effective %2$s': {
		translation: 'Moved from %1$s effective %2$s',
	},
	'Moved from %1$s effective %2$s.': {
		translation: 'Moved from %1$s effective %2$s.',
	},
	'Moved from %1$s to %2$s effective %3$s': {
		translation: 'Moved from %1$s to %2$s effective %3$s',
	},
	'Moved from %1$s to %2$s effective %3$s.': {
		translation: 'Moved from %1$s to %2$s effective %3$s.',
	},
	'Moved from **{1}** to **{2}**': {
		translation: 'Moved from **{1}** to **{2}**',
	},
	'Moved from **{1}** to [**{2}**](2)': {
		translation: 'Moved from **{1}** to [**{2}**](2)',
	},
	'Moved from Employee Pays %1$s and Company Pays %2$s effective %3$s.': {
		translation:
			'Moved from Employee Pays %1$s and Company Pays %2$s effective %3$s.',
	},
	'Moved from Employee Pays %1$s to %2$s and Company Pays %3$s to %4$s effective %5$s':
		{
			translation:
				'Moved from Employee Pays %1$s to %2$s and Company Pays %3$s to %4$s effective %5$s',
		},
	'Moved from [**{1}**](1) to **{2}**': {
		translation: 'Moved from [**{1}**](1) to **{2}**',
	},
	'Moved from [**{1}**](1) to [**{2}**](2)': {
		translation: 'Moved from [**{1}**](1) to [**{2}**](2)',
	},
	'Moved from a start date of %1$s to %2$s': {
		translation: 'Moved from a start date of %1$s to %2$s',
	},
	'Moved from a start date of %1$s to %2$s and an end date of %3$s to %4$s': {
		translation:
			'Moved from a start date of %1$s to %2$s and an end date of %3$s to %4$s',
	},
	'Moved from a start of %1$s to %2$s and end of %3$s to %4$s': {
		translation: 'Moved from a start of %1$s to %2$s and end of %3$s to %4$s',
	},
	'Moved from an end date of %1$s to %2$s': {
		translation: 'Moved from an end date of %1$s to %2$s',
	},
	'Moved {1} from **{2}** to **{3}**': {
		translation: 'Moved {1} from **{2}** to **{3}**',
	},
	'Moved {1} from **{2}** to [**{3}**](2)': {
		translation: 'Moved {1} from **{2}** to [**{3}**](2)',
	},
	'Moved {1} from [**{2}**](1) to **{3}**': {
		translation: 'Moved {1} from [**{2}**](1) to **{3}**',
	},
	'Moved {1} from [**{2}**](1) to [**{3}**](2)': {
		translation: 'Moved {1} from [**{2}**](1) to [**{3}**](2)',
	},
	Moving: {
		translation: 'Moving',
	},
	'Moving:': {
		translation: 'Moving:',
	},
	'Multi-row line paragraph': {
		translation: 'Multi-row line paragraph',
	},
	'Multimedia Manager': {
		translation: 'Multimedia Manager',
	},
	'Multiple Access Levels': {
		translation: 'Multiple Access Levels',
	},
	'Multiple Access Levels...': {
		translation: 'Multiple Access Levels...',
	},
	'Multiple Daily Entry': {
		translation: 'Multiple Daily Entry',
	},
	"Multiple departments were found with the name: '%s'.": {
		translation: "Multiple departments were found with the name: '%s'.",
	},
	'Multiple entries throughout the day': {
		translation: 'Multiple entries throughout the day',
	},
	'Multiple pay rates for a single employee': {
		translation: 'Multiple pay rates for a single employee',
	},
	'Multiple selection list': {
		translation: 'Multiple selection list',
	},
	'Multiple team members have reason to celebrate today! Take a look!': {
		translation:
			'Multiple team members have reason to celebrate today! Take a look!',
	},
	'Must approve by %1$s': {
		translation: 'Must approve by %1$s',
	},
	'Must be at least three business days from today': {
		translation: 'Must be at least three business days from today',
	},
	'Must enter amount requested': {
		translation: 'Must enter amount requested',
	},
	'Must enter an emergency contact name': {
		translation: 'Must enter an emergency contact name',
	},
	'Must enter employee number': {
		translation: 'Must enter employee number',
	},
	'Must enter time off type': {
		translation: 'Must enter time off type',
	},
	'Must have a valid date': {
		translation: 'Must have a valid date',
	},
	'Must have access to all the fields within the report for your request to work':
		{
			translation:
				'Must have access to all the fields within the report for your request to work',
		},
	'Must include a valid name for the tag': {
		translation: 'Must include a valid name for the tag',
	},
	'Must not be null': {
		translation: 'Must not be null',
	},
	'Must specify users or groups to share with.': {
		translation: 'Must specify users or groups to share with.',
	},
	'My API Keys': {
		translation: 'My API Keys',
	},
	'My Benefits': {
		translation: 'My Benefits',
	},
	'My Circle': {
		translation: 'My Circle',
	},
	'My Current Package': {
		translation: 'My Current Package',
	},
	'My Devices': {
		translation: 'My Devices',
	},
	'My Devices & API Keys': {
		translation: 'My Devices & API Keys',
	},
	'My Info': {
		translation: 'My Info',
	},
	'My Information': {
		translation: 'My Information',
	},
	'My Reports': {
		translation: 'My Reports',
	},
	'My Tax Documents': {
		translation: 'My Tax Documents',
	},
	'My Timesheet': {
		translation: 'My Timesheet',
	},
	'My Training': {
		translation: 'My Training',
	},
	"My benefit information is in great shape. Let's move on.": {
		translation: "My benefit information is in great shape. Let's move on.",
	},
	"My company is a government contractor or I'd like to capture applicant gender, ethnicity, disability, or veteran status.":
		{
			translation:
				"My company is a government contractor or I'd like to capture applicant gender, ethnicity, disability, or veteran status.",
		},
	"My goals help my company's strategy move forward": {
		translation: "My goals help my company's strategy move forward",
	},
	'My profile pic': {
		translation: 'My profile pic',
	},
	'MySpace ID': {
		translation: 'MySpace ID',
	},
	'N/A': {
		translation: 'N/A',
	},
	NA: {
		translation: 'NA',
	},
	NIN: {
		translation: 'NIN',
	},
	'NOTE: To change this setting you have to': {
		translation: 'NOTE: To change this setting you have to',
	},
	'NPI #': {
		translation: 'NPI #',
	},
	'NPI password': {
		translation: 'NPI password',
	},
	'NPI user ID': {
		translation: 'NPI user ID',
	},
	NSO: {
		translation: 'NSO',
	},
	'NV BX(Athem)': {
		translation: 'NV BX(Athem)',
	},
	'NV Medicare #': {
		translation: 'NV Medicare #',
	},
	'NV license #': {
		translation: 'NV license #',
	},
	Name: {
		translation: 'Name',
	},
	'Name (First, Middle, Last and Nickname)': {
		translation: 'Name (First, Middle, Last and Nickname)',
	},
	'Name Your Goal': {
		translation: 'Name Your Goal',
	},
	'Name and type are both required': {
		translation: 'Name and type are both required',
	},
	'Name is required': {
		translation: 'Name is required',
	},
	'Name of school': {
		translation: 'Name of school',
	},
	'Name, Department, Location, or Email...': {
		translation: 'Name, Department, Location, or Email...',
	},
	'Name, department, location, or email...': {
		translation: 'Name, department, location, or email...',
	},
	'Name: A - Z': {
		translation: 'Name: A - Z',
	},
	'Name: Z - A': {
		translation: 'Name: Z - A',
	},
	'Names containing "%1"': {
		translation: 'Names containing \\"%1\\"',
	},
	'Names containing "%s"': {
		translation: 'Names containing \\"%s\\"',
	},
	'National ID': {
		translation: 'National ID',
	},
	'National Id must be unique': {
		translation: 'National Id must be unique',
	},
	'National Origin': {
		translation: 'National Origin',
	},
	Nationality: {
		translation: 'Nationality',
	},
	'Native Hawaiian or Other Pacific Islander': {
		translation: 'Native Hawaiian or Other Pacific Islander',
	},
	'Nature of Departure': {
		translation: 'Nature of Departure',
	},
	'Navigate to "Account Details" in the dropdown menu under "Your Account" in the top-right of your screen':
		{
			translation:
				'Navigate to \\"Account Details\\" in the dropdown menu under \\"Your Account\\" in the top-right of your screen',
		},
	'Navigate to the Add-Ons section within Simplepay.ca (Setup > Add-Ons > BambooHR). In the BambooHR API Settings section, enter the API Key related in the above step, and the BambooHR website address (note - do not include the "https://" section of the URL). Once you have entered the information, click the Save Settings button.':
		{
			translation:
				'Navigate to the Add-Ons section within Simplepay.ca (Setup > Add-Ons > BambooHR). In the BambooHR API Settings section, enter the API Key related in the above step, and the BambooHR website address (note - do not include the \\"https://\\" section of the URL). Once you have entered the information, click the Save Settings button.',
		},
	'Need Help Text for Google SCIM': {
		translation: 'Need Help Text for Google SCIM',
	},
	'Need Help Text for Jump Cloud SCIM': {
		translation: 'Need Help Text for Jump Cloud SCIM',
	},
	'Need Help Text for JumpCloud SCIM': {
		translation: 'Need Help Text for JumpCloud SCIM',
	},
	'Need Help?': {
		translation: 'Need Help?',
	},
	'Need a search term': {
		translation: 'Need a search term',
	},
	'Need help?': {
		translation: 'Need help?',
	},
	'Need to add another company/EIN?': {
		translation: 'Need to add another company/EIN?',
	},
	'Need to change your bank account?': {
		translation: 'Need to change your bank account?',
	},
	'Need to think about it. %s does a decent job.': {
		translation: 'Need to think about it. %s does a decent job.',
	},
	'Need to think about it. They do a decent job.': {
		translation: 'Need to think about it. They do a decent job.',
	},
	Negative: {
		translation: 'Negative',
	},
	'Negative balance reset to 0 on carryover date': {
		translation: 'Negative balance reset to 0 on carryover date',
	},
	'Negative balance reset to 0 on carryover date.': {
		translation: 'Negative balance reset to 0 on carryover date.',
	},
	'Net Amount': {
		translation: 'Net Amount',
	},
	'Net Pay': {
		translation: 'Net Pay',
	},
	'Net Pay: ': {
		translation: 'Net Pay: ',
	},
	'Net Promoter, NPS, and the NPS-related emoticons are registered trademarks, and Net Promoter Score and Net Promoter System are service marks of Bain & Company, Inc., Satmetrix Systems, Inc. and Fred Reichheld.':
		{
			translation:
				'Net Promoter, NPS, and the NPS-related emoticons are registered trademarks, and Net Promoter Score and Net Promoter System are service marks of Bain & Company, Inc., Satmetrix Systems, Inc. and Fred Reichheld.',
		},
	NetSuite: {
		translation: 'NetSuite',
	},
	'NetSuite Account: ': {
		translation: 'NetSuite Account: ',
	},
	'NetSuite Password: ': {
		translation: 'NetSuite Password: ',
	},
	'NetSuite Token Secret: ': {
		translation: 'NetSuite Token Secret: ',
	},
	'NetSuite Token: ': {
		translation: 'NetSuite Token: ',
	},
	'NetSuite Username: ': {
		translation: 'NetSuite Username: ',
	},
	"NetSuite is the world's leading provider of cloud-based business management software. 16,000 high-growth and midsized companies and divisions of large enterprises use NetSuite to manage core business processes with a single, fully integrated system covering ERP/financials, CRM, ecommerce, inventory and more. NetSuite also offers industry-specific solutions for professional services, software, wholesale distribution, manufacturing, and ecommerce. NetSuite OneWorld helps global, multi-company organizations manage subsidiaries better with robust multinational, multi-currency support.":
		{
			translation:
				"NetSuite is the world's leading provider of cloud-based business management software. 16,000 high-growth and midsized companies and divisions of large enterprises use NetSuite to manage core business processes with a single, fully integrated system covering ERP/financials, CRM, ecommerce, inventory and more. NetSuite also offers industry-specific solutions for professional services, software, wholesale distribution, manufacturing, and ecommerce. NetSuite OneWorld helps global, multi-company organizations manage subsidiaries better with robust multinational, multi-currency support.",
		},
	'NetSuite says:': {
		translation: 'NetSuite says:',
	},
	'NetSuite settings saved': {
		translation: 'NetSuite settings saved',
	},
	'Netsuite V2 cannot be installed from GreenHouse at this time.': {
		translation:
			'Netsuite V2 cannot be installed from GreenHouse at this time.',
	},
	Neutral: {
		translation: 'Neutral',
	},
	'Neutral Tags': {
		translation: 'Neutral Tags',
	},
	Neutrals: {
		translation: 'Neutrals',
	},
	'Neutrals (7-8)': {
		translation: 'Neutrals (7-8)',
	},
	'Neutrals (Rated 7-8)': {
		translation: 'Neutrals (Rated 7-8)',
	},
	'Neutrals and Detractors’ most disliked tags by number of survey responses. We calculate the eNPS for each tag and display the trend over time.':
		{
			translation:
				'Neutrals and Detractors’ most disliked tags by number of survey responses. We calculate the eNPS for each tag and display the trend over time.',
		},
	Never: {
		translation: 'Never',
	},
	'Never Mind': {
		translation: 'Never Mind',
	},
	'Never mind, I remember now': {
		translation: 'Never mind, I remember now',
	},
	'Never mind, I remember now.': {
		translation: 'Never mind, I remember now.',
	},
	"Nevermind, don't import this data": {
		translation: "Nevermind, don't import this data",
	},
	New: {
		translation: 'New',
	},
	'New %s Balance': {
		translation: 'New %s Balance',
	},
	'New %s Task': {
		translation: 'New %s Task',
	},
	'New Access Level': {
		translation: 'New Access Level',
	},
	'New Account Owner': {
		translation: 'New Account Owner',
	},
	'New Announcement': {
		translation: 'New Announcement',
	},
	'New BambooHR Benefits': {
		translation: 'New BambooHR Benefits',
	},
	'New Benefits - Add Benefit Groups': {
		translation: 'New Benefits - Add Benefit Groups',
	},
	'New Benefits - Benefit Groups': {
		translation: 'New Benefits - Benefit Groups',
	},
	'New Benefits - Plans': {
		translation: 'New Benefits - Plans',
	},
	'New Blank Email': {
		translation: 'New Blank Email',
	},
	'New Candidate': {
		translation: 'New Candidate',
	},
	'New Category': {
		translation: 'New Category',
	},
	'New Comments on Your Goals': {
		translation: 'New Comments on Your Goals',
	},
	'New Coverage Option': {
		translation: 'New Coverage Option',
	},
	'New Custom Access Level': {
		translation: 'New Custom Access Level',
	},
	'New Deduction saved successfully.': {
		translation: 'New Deduction saved successfully.',
	},
	'New Email': {
		translation: 'New Email',
	},
	'New Email Template': {
		translation: 'New Email Template',
	},
	'New Email to %1$s': {
		translation: 'New Email to %1$s',
	},
	'New Employee': {
		translation: 'New Employee',
	},
	'New Employee Access Level': {
		translation: 'New Employee Access Level',
	},
	'New Employee Info': {
		translation: 'New Employee Info',
	},
	'New Employee Info%1$sCompleted': {
		translation: 'New Employee Info%1$sCompleted',
	},
	'New Employee Information': {
		translation: 'New Employee Information',
	},
	'New Employees': {
		translation: 'New Employees',
	},
	'New Employment Status': {
		translation: 'New Employment Status',
	},
	'New Expiration Date': {
		translation: 'New Expiration Date',
	},
	'New Field Value': {
		translation: 'New Field Value',
	},
	'New Goal': {
		translation: 'New Goal',
	},
	'New Hire': {
		translation: 'New Hire',
	},
	'New Hire Packet': {
		translation: 'New Hire Packet',
	},
	'New Hire Packet - Sent': {
		translation: 'New Hire Packet - Sent',
	},
	'New Hire Packet - Signed': {
		translation: 'New Hire Packet - Signed',
	},
	'New Hire Packet Complete': {
		translation: 'New Hire Packet Complete',
	},
	'New Hire Packet Fields': {
		translation: 'New Hire Packet Fields',
	},
	'New Hire Packet Sent Date': {
		translation: 'New Hire Packet Sent Date',
	},
	'New Hire Packet Templates': {
		translation: 'New Hire Packet Templates',
	},
	'New Hire Packet template has been saved successfully': {
		translation: 'New Hire Packet template has been saved successfully',
	},
	'New Hire Packet template has been updated successfully': {
		translation: 'New Hire Packet template has been updated successfully',
	},
	'New Hire Tasks%1$sCompleted': {
		translation: 'New Hire Tasks%1$sCompleted',
	},
	'New Hire Training': {
		translation: 'New Hire Training',
	},
	'New Hire Training for HR': {
		translation: 'New Hire Training for HR',
	},
	'New Hire Welcome email has been updated successfully': {
		translation: 'New Hire Welcome email has been updated successfully',
	},
	'New Hire%1$sPacket Created': {
		translation: 'New Hire%1$sPacket Created',
	},
	'New Hire%1$sPacket Sent': {
		translation: 'New Hire%1$sPacket Sent',
	},
	'New Hire%1$sPacket Viewed': {
		translation: 'New Hire%1$sPacket Viewed',
	},
	'New Hires': {
		translation: 'New Hires',
	},
	'New Hour Import': {
		translation: 'New Hour Import',
	},
	'New Item': {
		translation: 'New Item',
	},
	'New Location': {
		translation: 'New Location',
	},
	'New Manager Access Level': {
		translation: 'New Manager Access Level',
	},
	'New Non-Employee User': {
		translation: 'New Non-Employee User',
	},
	'New Offer Template': {
		translation: 'New Offer Template',
	},
	'New Password': {
		translation: 'New Password',
	},
	'New Pay': {
		translation: 'New Pay',
	},
	'New Pay Group': {
		translation: 'New Pay Group',
	},
	'New Pay Schedule': {
		translation: 'New Pay Schedule',
	},
	'New Payroll Admin Access Level': {
		translation: 'New Payroll Admin Access Level',
	},
	'New Payroll Non-Approver Access Level': {
		translation: 'New Payroll Non-Approver Access Level',
	},
	'New Payroll Reports Only Access Level': {
		translation: 'New Payroll Reports Only Access Level',
	},
	'New Policy': {
		translation: 'New Policy',
	},
	'New Question': {
		translation: 'New Question',
	},
	'New Rate': {
		translation: 'New Rate',
	},
	'New Report': {
		translation: 'New Report',
	},
	'New Report Template': {
		translation: 'New Report Template',
	},
	'New Signature Request': {
		translation: 'New Signature Request',
	},
	'New Status': {
		translation: 'New Status',
	},
	'New Task': {
		translation: 'New Task',
	},
	'New Template': {
		translation: 'New Template',
	},
	'New Time Off Category': {
		translation: 'New Time Off Category',
	},
	'New Time Off Type': {
		translation: 'New Time Off Type',
	},
	'New Training': {
		translation: 'New Training',
	},
	'New Value': {
		translation: 'New Value',
	},
	'New changes made to employee information within BambooHR are automatically sent over to TraxPayroll and are updated in TraxPayroll pending approval by an administrator.':
		{
			translation:
				'New changes made to employee information within BambooHR are automatically sent over to TraxPayroll and are updated in TraxPayroll pending approval by an administrator.',
		},
	'New coverage option name must be unique. Please try again.': {
		translation: 'New coverage option name must be unique. Please try again.',
	},
	'New coverage option name must contain at least one letter. Please try again.':
		{
			translation:
				'New coverage option name must contain at least one letter. Please try again.',
		},
	'New employee hired in the middle of the accrual period': {
		translation: 'New employee hired in the middle of the accrual period',
	},
	'New entries cannot have an archived employment status': {
		translation: 'New entries cannot have an archived employment status',
	},
	'New hire packet notice': {
		translation: 'New hire packet notice',
	},
	'New password': {
		translation: 'New password',
	},
	'New password can not be the same as your current password.': {
		translation: 'New password can not be the same as your current password.',
	},
	'New password is not valid': {
		translation: 'New password is not valid',
	},
	'New rate will apply at the end of the next period after the employee is eligible.':
		{
			translation:
				'New rate will apply at the end of the next period after the employee is eligible.',
		},
	'New rate will apply immediately when the employee is eligible.': {
		translation:
			'New rate will apply immediately when the employee is eligible.',
	},
	'New rates Employee Paid %1$s': {
		translation: 'New rates Employee Paid %1$s',
	},
	'New templates created within RightSignature will be available in BambooHR within two minutes.':
		{
			translation:
				'New templates created within RightSignature will be available in BambooHR within two minutes.',
		},
	'Newton is fully-featured applicant tracking software specifically designed to drive the decisions that drive corporate recruiting for small and medium sized businesses. Best in class user interfaces and intuitive workflows make collaboration easy for everyone. Real-time dashboards create unparalleled visibility helping to ensure nothing slips through the cracks.':
		{
			translation:
				'Newton is fully-featured applicant tracking software specifically designed to drive the decisions that drive corporate recruiting for small and medium sized businesses. Best in class user interfaces and intuitive workflows make collaboration easy for everyone. Real-time dashboards create unparalleled visibility helping to ensure nothing slips through the cracks.',
		},
	Next: {
		translation: 'Next',
	},
	'Next %1 %2': {
		translation: 'Next %1 %2',
	},
	'Next Approver': {
		translation: 'Next Approver',
	},
	'Next Assessment reminders will be sent out on %1': {
		translation: 'Next Assessment reminders will be sent out on %1',
	},
	'Next Feedback Request': {
		translation: 'Next Feedback Request',
	},
	'Next Feedback Round': {
		translation: 'Next Feedback Round',
	},
	'Next Group': {
		translation: 'Next Group',
	},
	'Next Month': {
		translation: 'Next Month',
	},
	'Next Page': {
		translation: 'Next Page',
	},
	'Next Pay Periods': {
		translation: 'Next Pay Periods',
	},
	'Next Peer Feedback requests will be sent out on %1': {
		translation: 'Next Peer Feedback requests will be sent out on %1',
	},
	'Next Review Is Due...': {
		translation: 'Next Review Is Due...',
	},
	'Next Review Period': {
		translation: 'Next Review Period',
	},
	'Next Review is due...': {
		translation: 'Next Review is due...',
	},
	'Next Step': {
		translation: 'Next Step',
	},
	'Next page': {
		translation: 'Next page',
	},
	'Next: %1': {
		translation: 'Next: %1',
	},
	'Next: %s': {
		translation: 'Next: %s',
	},
	"Nice Job, You're All Done": {
		translation: "Nice Job, You're All Done",
	},
	"Nice try! Can't set amount higher than 100%1.": {
		translation: "Nice try! Can't set amount higher than 100%1.",
	},
	'Nice! %1$s was added successfully.': {
		translation: 'Nice! %1$s was added successfully.',
	},
	Nickname: {
		translation: 'Nickname',
	},
	'NimbleSchedule is an intuitive, web-based scheduling and labor management solution which provides immediate benefits by reducing labor costs, improving communications and maximizing productivity. This speedy scheduling solution offers best-of-class usability that renders most scheduling tasks into just a few clicks, while completely automating others. Spend less time scheduling employees and more time managing your business!':
		{
			translation:
				'NimbleSchedule is an intuitive, web-based scheduling and labor management solution which provides immediate benefits by reducing labor costs, improving communications and maximizing productivity. This speedy scheduling solution offers best-of-class usability that renders most scheduling tasks into just a few clicks, while completely automating others. Spend less time scheduling employees and more time managing your business!',
		},
	'Nin must be unique': {
		translation: 'Nin must be unique',
	},
	No: {
		translation: 'No',
	},
	'No ': {
		translation: 'No ',
	},
	'No %1$s': {
		translation: 'No %1$s',
	},
	'No %s entries have been added.': {
		translation: 'No %s entries have been added.',
	},
	'No ACA Benefit Plans': {
		translation: 'No ACA Benefit Plans',
	},
	'No Access': {
		translation: 'No Access',
	},
	'No Address': {
		translation: 'No Address',
	},
	'No Assessment ID was sent with request!': {
		translation: 'No Assessment ID was sent with request!',
	},
	'No Benefit Group': {
		translation: 'No Benefit Group',
	},
	'No Benefit Groups': {
		translation: 'No Benefit Groups',
	},
	'No Call/No Show': {
		translation: 'No Call/No Show',
	},
	'No Comment': {
		translation: 'No Comment',
	},
	'No Data': {
		translation: 'No Data',
	},
	'No Department': {
		translation: 'No Department',
	},
	'No Direct Reports': {
		translation: 'No Direct Reports',
	},
	'No Division': {
		translation: 'No Division',
	},
	'No Due Date': {
		translation: 'No Due Date',
	},
	'No Education Info has been added.': {
		translation: 'No Education Info has been added.',
	},
	'No Employee Information has been added to this Tab.': {
		translation: 'No Employee Information has been added to this Tab.',
	},
	'No Employment Status': {
		translation: 'No Employment Status',
	},
	'No Feedback': {
		translation: 'No Feedback',
	},
	'No File Given': {
		translation: 'No File Given',
	},
	'No File ID was sent with request!': {
		translation: 'No File ID was sent with request!',
	},
	'No Goals Set': {
		translation: 'No Goals Set',
	},
	'No Hires': {
		translation: 'No Hires',
	},
	'No Hires Yet': {
		translation: 'No Hires Yet',
	},
	'No Holidays have been added for %s.': {
		translation: 'No Holidays have been added for %s.',
	},
	'No IDs sent through to change.': {
		translation: 'No IDs sent through to change.',
	},
	"No Id's sent through to change.": {
		translation: "No Id's sent through to change.",
	},
	'No Job Title': {
		translation: 'No Job Title',
	},
	'No Location': {
		translation: 'No Location',
	},
	'No Manager': {
		translation: 'No Manager',
	},
	'No Name': {
		translation: 'No Name',
	},
	'No Owner': {
		translation: 'No Owner',
	},
	'No Pay Schedule': {
		translation: 'No Pay Schedule',
	},
	'No Policy Created': {
		translation: 'No Policy Created',
	},
	'No Policy Flags Selected': {
		translation: 'No Policy Flags Selected',
	},
	'No Problem!': {
		translation: 'No Problem!',
	},
	'No Reason': {
		translation: 'No Reason',
	},
	'No Rows To Show': {
		translation: 'No Rows To Show',
	},
	'No Signature Needed': {
		translation: 'No Signature Needed',
	},
	'No State': {
		translation: 'No State',
	},
	'No Survey Periods found': {
		translation: 'No Survey Periods found',
	},
	'No Tags found': {
		translation: 'No Tags found',
	},
	'No Template': {
		translation: 'No Template',
	},
	"No Thanks, I'm Done": {
		translation: "No Thanks, I'm Done",
	},
	'No Topics found': {
		translation: 'No Topics found',
	},
	'No Translation': {
		translation: 'No Translation',
	},
	'No URL parameter sent.': {
		translation: 'No URL parameter sent.',
	},
	'No Vesting Schedule': {
		translation: 'No Vesting Schedule',
	},
	'No Worries': {
		translation: 'No Worries',
	},
	'No applicants had email addresses.': {
		translation: 'No applicants had email addresses.',
	},
	'No application filter exists for this id.': {
		translation: 'No application filter exists for this id.',
	},
	'No beneficial ownership information found.': {
		translation: 'No beneficial ownership information found.',
	},
	'No benefit plans have been applied.': {
		translation: 'No benefit plans have been applied.',
	},
	'No benefit plans were found.  Add a plan to view the report.': {
		translation: 'No benefit plans were found.  Add a plan to view the report.',
	},
	'No candidate selected.': {
		translation: 'No candidate selected.',
	},
	'No candidates were selected.': {
		translation: 'No candidates were selected.',
	},
	'No companies match the current filters.': {
		translation: 'No companies match the current filters.',
	},
	'No credit card entries have been added.': {
		translation: 'No credit card entries have been added.',
	},
	'No date selected': {
		translation: 'No date selected',
	},
	'No department': {
		translation: 'No department',
	},
	'No departments found': {
		translation: 'No departments found',
	},
	'No dependents have been added': {
		translation: 'No dependents have been added',
	},
	'No due date': {
		translation: 'No due date',
	},
	'No email address specified.': {
		translation: 'No email address specified.',
	},
	'No emails were found to update this employee': {
		translation: 'No emails were found to update this employee',
	},
	'No emergency contacts have been added for this employee.': {
		translation: 'No emergency contacts have been added for this employee.',
	},
	'No employee hours have been imported yet.': {
		translation: 'No employee hours have been imported yet.',
	},
	"No employeeId argument was provided. Please structure key as 'request_time_off.{employeeId}'":
		{
			translation:
				"No employeeId argument was provided. Please structure key as 'request_time_off.{employeeId}'",
		},
	'No employees match this filter': {
		translation: 'No employees match this filter',
	},
	'No employees match this filter.': {
		translation: 'No employees match this filter.',
	},
	'No employees matched': {
		translation: 'No employees matched',
	},
	'No employees were updated': {
		translation: 'No employees were updated',
	},
	'No engagement and is checked out.': {
		translation: 'No engagement and is checked out.',
	},
	'No enrollment windows found': {
		translation: 'No enrollment windows found',
	},
	'No feedback has been given in this review period.': {
		translation: 'No feedback has been given in this review period.',
	},
	'No feedback was given in this date range.': {
		translation: 'No feedback was given in this date range.',
	},
	'No feedback was given in this review period.': {
		translation: 'No feedback was given in this review period.',
	},
	'No file selected': {
		translation: 'No file selected',
	},
	'No file selected.': {
		translation: 'No file selected.',
	},
	'No files selected': {
		translation: 'No files selected',
	},
	'No files to delete.': {
		translation: 'No files to delete.',
	},
	'No files to upload.': {
		translation: 'No files to upload.',
	},
	'No goals were completed during this review period.': {
		translation: 'No goals were completed during this review period.',
	},
	'No job openings found': {
		translation: 'No job openings found',
	},
	'No match, select a field': {
		translation: 'No match, select a field',
	},
	'No match, skip this field': {
		translation: 'No match, skip this field',
	},
	'No matches for': {
		translation: 'No matches for',
	},
	'No matches for "%1$s"': {
		translation: 'No matches for "%1$s"',
	},
	'No matches for "%s"': {
		translation: 'No matches for "%s"',
	},
	'No matches for "{1}"': {
		translation: 'No matches for "{1}"',
	},
	'No matches for these fields:': {
		translation: 'No matches for these fields:',
	},
	'No need for a support request, now you can create custom fields on your own!':
		{
			translation:
				'No need for a support request, now you can create custom fields on your own!',
		},
	'No need for a support request, now you can create custom fields, tabs, and tables on your own!':
		{
			translation:
				'No need for a support request, now you can create custom fields, tabs, and tables on your own!',
		},
	'No new data was entered.': {
		translation: 'No new data was entered.',
	},
	'No news is good news.': {
		translation: 'No news is good news.',
	},
	'No notes have been added for this employee': {
		translation: 'No notes have been added for this employee',
	},
	'No notes have been added for this employee.': {
		translation: 'No notes have been added for this employee.',
	},
	'No one completed feedback in this date range': {
		translation: 'No one completed feedback in this date range',
	},
	'No one else on the team will be out.': {
		translation: 'No one else on the team will be out.',
	},
	"No one has been set up as a payroll contact. Please notify the client's payroll implementation rep.":
		{
			translation:
				"No one has been set up as a payroll contact. Please notify the client's payroll implementation rep.",
		},
	'No one is assigned this policy.': {
		translation: 'No one is assigned this policy.',
	},
	'No one seems to be out today in `%1$s`.': {
		translation: 'No one seems to be out today in `%1$s`.',
	},
	'No one seems to be out today.': {
		translation: 'No one seems to be out today.',
	},
	'No partners have been added.': {
		translation: 'No partners have been added.',
	},
	'No pay periods found': {
		translation: 'No pay periods found',
	},
	'No pay schedules found': {
		translation: 'No pay schedules found',
	},
	'No payments for this tax have been made. This will permanently remove it from your company payroll taxes.':
		{
			translation:
				'No payments for this tax have been made. This will permanently remove it from your company payroll taxes.',
		},
	'No peer feedback review period found.': {
		translation: 'No peer feedback review period found.',
	},
	'No performance periods found': {
		translation: 'No performance periods found',
	},
	'No performance periods found.': {
		translation: 'No performance periods found.',
	},
	'No performance review cycles found': {
		translation: 'No performance review cycles found',
	},
	'No placeholders match your search...': {
		translation: 'No placeholders match your search...',
	},
	'No plan years found': {
		translation: 'No plan years found',
	},
	'No plans found': {
		translation: 'No plans found',
	},
	'No policy selected': {
		translation: 'No policy selected',
	},
	'No position was selected.': {
		translation: 'No position was selected.',
	},
	'No previous value': {
		translation: 'No previous value',
	},
	'No process flow found for Employee Wellbeing survey.': {
		translation: 'No process flow found for Employee Wellbeing survey.',
	},
	'No recipients are associated with this file export.': {
		translation: 'No recipients are associated with this file export.',
	},
	'No results match': {
		translation: 'No results match',
	},
	'No results...': {
		translation: 'No results...',
	},
	'No second-guessing, no double-entry, and no surprises—just a lightweight, easy-to-use, and reliable payroll solution—tightly integrated into the BambooHR you know and love':
		{
			translation:
				'No second-guessing, no double-entry, and no surprises—just a lightweight, easy-to-use, and reliable payroll solution—tightly integrated into the BambooHR you know and love',
		},
	'No signature needed': {
		translation: 'No signature needed',
	},
	'No status selected.': {
		translation: 'No status selected.',
	},
	'No statuses found': {
		translation: 'No statuses found',
	},
	'No terminations found in this date range.': {
		translation: 'No terminations found in this date range.',
	},
	'No tiers available for change': {
		translation: 'No tiers available for change',
	},
	'No time off categories found': {
		translation: 'No time off categories found',
	},
	'No time off types found': {
		translation: 'No time off types found',
	},
	'No upcoming time off.': {
		translation: 'No upcoming time off.',
	},
	'No valid dates were entered': {
		translation: 'No valid dates were entered',
	},
	'No valid ids were passed.': {
		translation: 'No valid ids were passed.',
	},
	'No viewable benefit plans were found.': {
		translation: 'No viewable benefit plans were found.',
	},
	'No visa information entries have been added.': {
		translation: 'No visa information entries have been added.',
	},
	'No worries, the request has already been %1s.': {
		translation: 'No worries, the request has already been %1s.',
	},
	'No worries, your signature is no longer needed.': {
		translation: 'No worries, your signature is no longer needed.',
	},
	'No worries. Please fix any missing or incorrect information and try again.':
		{
			translation:
				'No worries. Please fix any missing or incorrect information and try again.',
		},
	"No, Don't Cancel": {
		translation: "No, Don't Cancel",
	},
	"No, Don't Cancel it": {
		translation: "No, Don't Cancel it",
	},
	"No, Don't remove it": {
		translation: "No, Don't remove it",
	},
	'No, Hide the %1$s Section': {
		translation: 'No, Hide the %1$s Section',
	},
	'No, Hide the My Info Section': {
		translation: 'No, Hide the My Info Section',
	},
	"No, I don't have a disability": {
		translation: "No, I don't have a disability",
	},
	'No, I’ll Select New Dates': {
		translation: 'No, I’ll Select New Dates',
	},
	'No, Keep Offer': {
		translation: 'No, Keep Offer',
	},
	'No, Keep Reports': {
		translation: 'No, Keep Reports',
	},
	'No, Keep this Applicant': {
		translation: 'No, Keep this Applicant',
	},
	'No, Keep this Employee': {
		translation: 'No, Keep this Employee',
	},
	'No, Keep this Job': {
		translation: 'No, Keep this Job',
	},
	'No, Keep this User': {
		translation: 'No, Keep this User',
	},
	'No, it skips some paychecks': {
		translation: 'No, it skips some paychecks',
	},
	'No, keep it on': {
		translation: 'No, keep it on',
	},
	'No, not reportable': {
		translation: 'No, not reportable',
	},
	"No, the employee agrees to be paid the rest of his wages on the company's normal pay schedule.":
		{
			translation:
				"No, the employee agrees to be paid the rest of his wages on the company's normal pay schedule.",
		},
	"No, the employee agrees to be paid the rest of their wages on the company's normal pay schedule.":
		{
			translation:
				"No, the employee agrees to be paid the rest of their wages on the company's normal pay schedule.",
		},
	"No, we don't": {
		translation: "No, we don't",
	},
	'No. We really need this additional functionality': {
		translation: 'No. We really need this additional functionality',
	},
	'Nobody added': {
		translation: 'Nobody added',
	},
	'Nobody is currently collaborating on this job posting.': {
		translation: 'Nobody is currently collaborating on this job posting.',
	},
	'Nobody requested time off Today': {
		translation: 'Nobody requested time off Today',
	},
	'Nobody requested time off Tomorrow': {
		translation: 'Nobody requested time off Tomorrow',
	},
	'Nobody requested time off for %1': {
		translation: 'Nobody requested time off for %1',
	},
	'Nobody will be joining %1 for the next little while.': {
		translation: 'Nobody will be joining %1 for the next little while.',
	},
	'Non Billable': {
		translation: 'Non Billable',
	},
	'Non-Accruing (Days)': {
		translation: 'Non-Accruing (Days)',
	},
	'Non-Accruing (Hours)': {
		translation: 'Non-Accruing (Hours)',
	},
	'Non-Assessment': {
		translation: 'Non-Assessment',
	},
	'Non-Benefit Deductions': {
		translation: 'Non-Benefit Deductions',
	},
	'Non-Benefit Deductions Change': {
		translation: 'Non-Benefit Deductions Change',
	},
	'Non-Billable Hours': {
		translation: 'Non-Billable Hours',
	},
	'Non-Employee User': {
		translation: 'Non-Employee User',
	},
	"Non-Employee Users allow people outside your company (like contractors or auditors, for example) to access your account in BambooHR. They won't show up in the directory and they won't have an employee profile.":
		{
			translation:
				"Non-Employee Users allow people outside your company (like contractors or auditors, for example) to access your account in BambooHR. They won't show up in the directory and they won't have an employee profile.",
		},
	'Non-Regrettable': {
		translation: 'Non-Regrettable',
	},
	'Non-US address': {
		translation: 'Non-US address',
	},
	'Non-USD pay rate': {
		translation: 'Non-USD pay rate',
	},
	'Non-benefit Deduction Changes': {
		translation: 'Non-benefit Deduction Changes',
	},
	'Non-binary': {
		translation: 'Non-binary',
	},
	'Non-exempt': {
		translation: 'Non-exempt',
	},
	'Non-exempt requires a Pay Rate higher than $0.00': {
		translation: 'Non-exempt requires a Pay Rate higher than $0.00',
	},
	'Non-qualified deferred compensation plan (pre-tax)': {
		translation: 'Non-qualified deferred compensation plan (pre-tax)',
	},
	None: {
		translation: 'None',
	},
	'None Selected': {
		translation: 'None Selected',
	},
	'None of the above': {
		translation: 'None of the above',
	},
	'None of these employees has set up their direct deposit info.': {
		translation:
			'None of these employees has set up their direct deposit info.',
	},
	'None of these employees has set up their federal withholding info.': {
		translation:
			'None of these employees has set up their federal withholding info.',
	},
	'None of these employees has state tax or unemployment insurance info.': {
		translation:
			'None of these employees has state tax or unemployment insurance info.',
	},
	'None of your selected employees have access to this benefit.': {
		translation: 'None of your selected employees have access to this benefit.',
	},
	'North America': {
		translation: 'North America',
	},
	'Not Applicable': {
		translation: 'Not Applicable',
	},
	'Not Assigned': {
		translation: 'Not Assigned',
	},
	'Not Clocked In': {
		translation: 'Not Clocked In',
	},
	'Not Completed': {
		translation: 'Not Completed',
	},
	'Not Eligible': {
		translation: 'Not Eligible',
	},
	'Not Eligible as of': {
		translation: 'Not Eligible as of',
	},
	'Not Hired Because...': {
		translation: 'Not Hired Because...',
	},
	'Not Important': {
		translation: 'Not Important',
	},
	'Not Installed': {
		translation: 'Not Installed',
	},
	'Not Likely': {
		translation: 'Not Likely',
	},
	'Not Needed/Early Out': {
		translation: 'Not Needed/Early Out',
	},
	'Not Qualified': {
		translation: 'Not Qualified',
	},
	'Not Scheduled': {
		translation: 'Not Scheduled',
	},
	'Not Sent': {
		translation: 'Not Sent',
	},
	'Not Shareable': {
		translation: 'Not Shareable',
	},
	'Not Signed': {
		translation: 'Not Signed',
	},
	'Not Started': {
		translation: 'Not Started',
	},
	'Not Submitted': {
		translation: 'Not Submitted',
	},
	'Not Uploaded': {
		translation: 'Not Uploaded',
	},
	'Not Vaccinated': {
		translation: 'Not Vaccinated',
	},
	'Not a Fit': {
		translation: 'Not a Fit',
	},
	'Not a Veteran': {
		translation: 'Not a Veteran',
	},
	'Not a veteran': {
		translation: 'Not a veteran',
	},
	'Not able to add BambooHR Payroll. App conflict with: ': {
		translation: 'Not able to add BambooHR Payroll. App conflict with: ',
	},
	'Not authenticated with bearer token': {
		translation: 'Not authenticated with bearer token',
	},
	'Not authorized': {
		translation: 'Not authorized',
	},
	'Not eligible': {
		translation: 'Not eligible',
	},
	'Not eligible for %s': {
		translation: 'Not eligible for %s',
	},
	'Not eligible for %s on %s': {
		translation: 'Not eligible for %s on %s',
	},
	'Not right now': {
		translation: 'Not right now',
	},
	'Not seeing a placeholder you need?': {
		translation: 'Not seeing a placeholder you need?',
	},
	"Not sure about some of the payroll info below? That's okay, just fill out as much as you know. Anything not completed here will be sent to your company's payroll admins to fill out.":
		{
			translation:
				"Not sure about some of the payroll info below? That's okay, just fill out as much as you know. Anything not completed here will be sent to your company's payroll admins to fill out.",
		},
	'Not-Hispanic or Latino': {
		translation: 'Not-Hispanic or Latino',
	},
	Note: {
		translation: 'Note',
	},
	'Note Author': {
		translation: 'Note Author',
	},
	'Note Date': {
		translation: 'Note Date',
	},
	'Note Details': {
		translation: 'Note Details',
	},
	'Note Removed': {
		translation: 'Note Removed',
	},
	'Note added': {
		translation: 'Note added',
	},
	'Note added successfully': {
		translation: 'Note added successfully',
	},
	'Note deleted.': {
		translation: 'Note deleted.',
	},
	'Note for %1': {
		translation: 'Note for %1',
	},
	'Note from Employer': {
		translation: 'Note from Employer',
	},
	'Note has been deleted.': {
		translation: 'Note has been deleted.',
	},
	'Note pinned': {
		translation: 'Note pinned',
	},
	'Note saved': {
		translation: 'Note saved',
	},
	'Note that if they are also in a Custom Access Level, their permissions will be combined.':
		{
			translation:
				'Note that if they are also in a Custom Access Level, their permissions will be combined.',
		},
	'Note updated': {
		translation: 'Note updated',
	},
	'Note:': {
		translation: 'Note:',
	},
	'Note: ': {
		translation: 'Note: ',
	},
	'Note: Emailing is disabled while in trial.': {
		translation: 'Note: Emailing is disabled while in trial.',
	},
	'Note: For all other plan types, clients set the deduction schedule when they create the benefit plan.':
		{
			translation:
				'Note: For all other plan types, clients set the deduction schedule when they create the benefit plan.',
		},
	'Note: Only files that have been set up for signatures are available.': {
		translation:
			'Note: Only files that have been set up for signatures are available.',
	},
	'Note: Sharing your birthday lets your coworkers celebrate this awesome day with you!':
		{
			translation:
				'Note: Sharing your birthday lets your coworkers celebrate this awesome day with you!',
		},
	'Note: Sharing your birthday lets your coworkers see this information on their calendars':
		{
			translation:
				'Note: Sharing your birthday lets your coworkers see this information on their calendars',
		},
	'Note: The total compensation estimate is solely a hypothetical example based on current information and is not a forecast, promise, or guarantee of compensation or any type of compensation. This is for general informational purposes only and is not to be construed as legal, financial, or tax advice. Nothing herein is intended to create an offer or binding agreement of any nature.':
		{
			translation:
				'Note: The total compensation estimate is solely a hypothetical example based on current information and is not a forecast, promise, or guarantee of compensation or any type of compensation. This is for general informational purposes only and is not to be construed as legal, financial, or tax advice. Nothing herein is intended to create an offer or binding agreement of any nature.',
		},
	Notes: {
		translation: 'Notes',
	},
	'Notes:': {
		translation: 'Notes:',
	},
	'Notes: Date Added': {
		translation: 'Notes: Date Added',
	},
	'Notes: Entered By': {
		translation: 'Notes: Entered By',
	},
	'Notes: Note': {
		translation: 'Notes: Note',
	},
	'Nothing to Approve': {
		translation: 'Nothing to Approve',
	},
	'Nothing to install. No plugins required. Just grab a free trial account of OrgChart Now and configure the BambooHR connector to pull your BambooHR data into your OrgChart Now account.  To obtain an OrgChart Now account, please <a href="http://hr.bamboohr.com/orgchart-referral">click here</a>':
		{
			translation:
				'Nothing to install. No plugins required. Just grab a free trial account of OrgChart Now and configure the BambooHR connector to pull your BambooHR data into your OrgChart Now account.  To obtain an OrgChart Now account, please <a href=\\"http://hr.bamboohr.com/orgchart-referral\\">click here</a>',
		},
	'Nothing to report yet.': {
		translation: 'Nothing to report yet.',
	},
	'Nothing to save': {
		translation: 'Nothing to save',
	},
	'Nothing to see here...': {
		translation: 'Nothing to see here...',
	},
	'Nothing to see here...yet. Check back later.': {
		translation: 'Nothing to see here...yet. Check back later.',
	},
	'Nothing, I have all I need.': {
		translation: 'Nothing, I have all I need.',
	},
	'Notice Period': {
		translation: 'Notice Period',
	},
	'Notification registration deleted successfully.': {
		translation: 'Notification registration deleted successfully.',
	},
	Notifications: {
		translation: 'Notifications',
	},
	'Notifications for approvals are based on your pay day.': {
		translation: 'Notifications for approvals are based on your pay day.',
	},
	Notified: {
		translation: 'Notified',
	},
	'Notified Emails': {
		translation: 'Notified Emails',
	},
	'Notify people via email': {
		translation: 'Notify people via email',
	},
	Nov: {
		translation: 'Nov',
	},
	November: {
		translation: 'November',
	},
	Now: {
		translation: 'Now',
	},
	'Now help us match up your data with our fields.': {
		translation: 'Now help us match up your data with our fields.',
	},
	'Now it’s waiting on a signature from %1$s.': {
		translation: 'Now it’s waiting on a signature from %1$s.',
	},
	'Now it’s waiting on a signature from someone.': {
		translation: 'Now it’s waiting on a signature from someone.',
	},
	'Now just sit back, relax, and wait for the responses to start rolling in.': {
		translation:
			'Now just sit back, relax, and wait for the responses to start rolling in.',
	},
	'Now we’re talking! Thanks for your great feedback.': {
		translation: 'Now we’re talking! Thanks for your great feedback.',
	},
	'Now, When Should We Enable All This Cool Performance Stuff?': {
		translation: 'Now, When Should We Enable All This Cool Performance Stuff?',
	},
	'Now, check your email for a new link.': {
		translation: 'Now, check your email for a new link.',
	},
	"Now, check your email for instructions on resetting your password. If you still can't log in, contact your administrator.":
		{
			translation:
				"Now, check your email for instructions on resetting your password. If you still can't log in, contact your administrator.",
		},
	'Now, match up the field names in BambooHR with the columns from the import file.':
		{
			translation:
				'Now, match up the field names in BambooHR with the columns from the import file.',
		},
	'Now, match up the field names in BambooHR with the columns from the import file. Check the sample data on the right to make sure everything looks good.':
		{
			translation:
				'Now, match up the field names in BambooHR with the columns from the import file. Check the sample data on the right to make sure everything looks good.',
		},
	'Now, that you have integrated your Boomr account with BambooHR and successfully matched your employees, you can run powerful timesheet reports for hours that have been tracked and approved in Boomr. To do this, click on the "BambooHR" tab at the top of of the page. From here, click the Timesheets section of the left-hand menu to view your reports.':
		{
			translation:
				'Now, that you have integrated your Boomr account with BambooHR and successfully matched your employees, you can run powerful timesheet reports for hours that have been tracked and approved in Boomr. To do this, click on the \\"BambooHR\\" tab at the top of of the page. From here, click the Timesheets section of the left-hand menu to view your reports.',
		},
	Number: {
		translation: 'Number',
	},
	'Number format': {
		translation: 'Number format',
	},
	'Number of Employees': {
		translation: 'Number of Employees',
	},
	'Number of exemptions': {
		translation: 'Number of exemptions',
	},
	'Number of neutrals/detractors': {
		translation: 'Number of neutrals/detractors',
	},
	'Number of promoters': {
		translation: 'Number of promoters',
	},
	'Nursing License': {
		translation: 'Nursing License',
	},
	OK: {
		translation: 'OK',
	},
	'OK, %s will no longer be able to track time worked or access the timesheet.':
		{
			translation:
				'OK, %s will no longer be able to track time worked or access the timesheet.',
		},
	'OK, Got It': {
		translation: 'OK, Got It',
	},
	'OK, Thanks': {
		translation: 'OK, Thanks',
	},
	'OK, future emails will be sent to this address.': {
		translation: 'OK, future emails will be sent to this address.',
	},
	'OK, this employee’s information will not be synced with Bamboo Payroll.': {
		translation:
			'OK, this employee’s information will not be synced with Bamboo Payroll.',
	},
	'OOB Amount': {
		translation: 'OOB Amount',
	},
	OR: {
		translation: 'OR',
	},
	'OSHA Training': {
		translation: 'OSHA Training',
	},
	'OT Hours': {
		translation: 'OT Hours',
	},
	'OT Rate': {
		translation: 'OT Rate',
	},
	Objectives: {
		translation: 'Objectives',
	},
	Occupation: {
		translation: 'Occupation',
	},
	Oct: {
		translation: 'Oct',
	},
	October: {
		translation: 'October',
	},
	"Of course, in order to get paid, we need to know employees' tax withholding information":
		{
			translation:
				"Of course, in order to get paid, we need to know employees' tax withholding information",
		},
	Off: {
		translation: 'Off',
	},
	'Off Season Salary': {
		translation: 'Off Season Salary',
	},
	'Offboard via Remote': {
		translation: 'Offboard via Remote',
	},
	Offboarding: {
		translation: 'Offboarding',
	},
	'Offboarding Approved': {
		translation: 'Offboarding Approved',
	},
	'Offboarding Completed': {
		translation: 'Offboarding Completed',
	},
	'Offboarding Pending': {
		translation: 'Offboarding Pending',
	},
	'Offboarding Tab': {
		translation: 'Offboarding Tab',
	},
	'Offboarding Task': {
		translation: 'Offboarding Task',
	},
	'Offboarding Task for:': {
		translation: 'Offboarding Task for:',
	},
	'Offboarding Tasks': {
		translation: 'Offboarding Tasks',
	},
	'Offboarding task changed!': {
		translation: 'Offboarding task changed!',
	},
	'Offboarding task completed!': {
		translation: 'Offboarding task completed!',
	},
	'Offboarding task reopened!': {
		translation: 'Offboarding task reopened!',
	},
	'Offboarding templates and tasks': {
		translation: 'Offboarding templates and tasks',
	},
	Offer: {
		translation: 'Offer',
	},
	'Offer Details': {
		translation: 'Offer Details',
	},
	'Offer Email': {
		translation: 'Offer Email',
	},
	'Offer Email Content...': {
		translation: 'Offer Email Content...',
	},
	'Offer Email Subject...': {
		translation: 'Offer Email Subject...',
	},
	'Offer Expiration Date': {
		translation: 'Offer Expiration Date',
	},
	'Offer Expires %1$s (%2$s)': {
		translation: 'Offer Expires %1$s (%2$s)',
	},
	'Offer Expires %s (%s)': {
		translation: 'Offer Expires %s (%s)',
	},
	'Offer Letter': {
		translation: 'Offer Letter',
	},
	'Offer Letter Acceptance': {
		translation: 'Offer Letter Acceptance',
	},
	'Offer Letter Content...': {
		translation: 'Offer Letter Content...',
	},
	'Offer Letter Count': {
		translation: 'Offer Letter Count',
	},
	'Offer Letter Details': {
		translation: 'Offer Letter Details',
	},
	'Offer Letter Email': {
		translation: 'Offer Letter Email',
	},
	'Offer Letter Preview': {
		translation: 'Offer Letter Preview',
	},
	'Offer Letter Sent': {
		translation: 'Offer Letter Sent',
	},
	'Offer Letter Template not found': {
		translation: 'Offer Letter Template not found',
	},
	'Offer Letter not found': {
		translation: 'Offer Letter not found',
	},
	'Offer Letters': {
		translation: 'Offer Letters',
	},
	'Offer Pending!': {
		translation: 'Offer Pending!',
	},
	'Offer Placeholders': {
		translation: 'Offer Placeholders',
	},
	'Offer Sent': {
		translation: 'Offer Sent',
	},
	'Offer Signed': {
		translation: 'Offer Signed',
	},
	'Offer Templates': {
		translation: 'Offer Templates',
	},
	'Offer canceled for **{1}**': {
		translation: 'Offer canceled for **{1}**',
	},
	'Offer canceled for [**{1}**]': {
		translation: 'Offer canceled for [**{1}**]',
	},
	'Offer letter appears to no longer be valid. Another offer had been started or this one has been canceled.':
		{
			translation:
				'Offer letter appears to no longer be valid. Another offer had been started or this one has been canceled.',
		},
	'Offer letter appears to no longer be valid. Please check if offer has been canceled.':
		{
			translation:
				'Offer letter appears to no longer be valid. Please check if offer has been canceled.',
		},
	'Offer letter contains invalid image. Please try re-uploading or removing images.':
		{
			translation:
				'Offer letter contains invalid image. Please try re-uploading or removing images.',
		},
	'Offer template successfully saved.': {
		translation: 'Offer template successfully saved.',
	},
	'Offer was sent to {1} at {2} for **{3}**': {
		translation: 'Offer was sent to {1} at {2} for **{3}**',
	},
	'Offer was sent to {1} at {2} for [**{3}**]': {
		translation: 'Offer was sent to {1} at {2} for [**{3}**]',
	},
	'Offer was sent to {1} for **{3}**': {
		translation: 'Offer was sent to {1} for **{3}**',
	},
	'Offer was sent to {1} for [**{3}**]': {
		translation: 'Offer was sent to {1} for [**{3}**]',
	},
	'Offer(s) in Progress': {
		translation: 'Offer(s) in Progress',
	},
	'Offers have been sent to ': {
		translation: 'Offers have been sent to ',
	},
	'Offers have been sent to **{1}** and **{2}**.': {
		translation: 'Offers have been sent to **{1}** and **{2}**.',
	},
	Office: {
		translation: 'Office',
	},
	'Office Eligibility': {
		translation: 'Office Eligibility',
	},
	'Office Eligible Date': {
		translation: 'Office Eligible Date',
	},
	'Office Phone': {
		translation: 'Office Phone',
	},
	Offline: {
		translation: 'Offline',
	},
	"Oh no! That didn't work. Try again.": {
		translation: "Oh no! That didn't work. Try again.",
	},
	'Oh no... Sorry, there was a problem approving hours. Please try again.': {
		translation:
			'Oh no... Sorry, there was a problem approving hours. Please try again.',
	},
	"Oh, snaps! Where's my Apps?": {
		translation: "Oh, snaps! Where's my Apps?",
	},
	Ok: {
		translation: 'Ok',
	},
	'Ok thanks': {
		translation: 'Ok thanks',
	},
	'Ok, Continue': {
		translation: 'Ok, Continue',
	},
	'Ok, Got it': {
		translation: 'Ok, Got it',
	},
	"Ok, I'll set it up later": {
		translation: "Ok, I'll set it up later",
	},
	'Ok, Thanks': {
		translation: 'Ok, Thanks',
	},
	"Ok. Once your information is updated we'll transition to the new benefits system.":
		{
			translation:
				"Ok. Once your information is updated we'll transition to the new benefits system.",
		},
	Okay: {
		translation: 'Okay',
	},
	'Okay to commit survey (y/N)? ': {
		translation: 'Okay to commit survey (y/N)? ',
	},
	'Okay! You have successfully <strong>denied this request.</strong>': {
		translation:
			'Okay! You have successfully <strong>denied this request.</strong>',
	},
	'Okay, You have successfully denied this request.': {
		translation: 'Okay, You have successfully denied this request.',
	},
	'Okay, got it': {
		translation: 'Okay, got it',
	},
	'Okay, let’s help you get started…': {
		translation: 'Okay, let’s help you get started…',
	},
	'Okta brings identity management and HRM together into a unified system. Now HR and IT can work together more efficiently to bridge the employee lifecycle gap.':
		{
			translation:
				'Okta brings identity management and HRM together into a unified system. Now HR and IT can work together more efficiently to bridge the employee lifecycle gap.',
		},
	'Okta is the foundation for secure connections between people and technology. Our IT products uniquely use identity information to grant people access to applications on any device at any time, while still enforcing strong security protections. Our platform securely connects companies to their customers and partners. Today, thousands of organizations trust Okta to help them fulfill their missions as quickly as possible.':
		{
			translation:
				'Okta is the foundation for secure connections between people and technology. Our IT products uniquely use identity information to grant people access to applications on any device at any time, while still enforcing strong security protections. Our platform securely connects companies to their customers and partners. Today, thousands of organizations trust Okta to help them fulfill their missions as quickly as possible.',
		},
	Old: {
		translation: 'Old',
	},
	'Old Field Value': {
		translation: 'Old Field Value',
	},
	'Old Policy': {
		translation: 'Old Policy',
	},
	'Old Value': {
		translation: 'Old Value',
	},
	'Oldest first': {
		translation: 'Oldest first',
	},
	Omnigender: {
		translation: 'Omnigender',
	},
	On: {
		translation: 'On',
	},
	"On *{1}* of this year, any existing Variable Rate Health Plans that haven't been moved over to Health, Dental, Vision, or Supplemental will be removed from the system.":
		{
			translation:
				"On *{1}* of this year, any existing Variable Rate Health Plans that haven't been moved over to Health, Dental, Vision, or Supplemental will be removed from the system.",
		},
	'On Hold': {
		translation: 'On Hold',
	},
	'On paid holidays we pay hourly employees...': {
		translation: 'On paid holidays we pay hourly employees...',
	},
	'On the': {
		translation: 'On the',
	},
	'On the %1$s %2$s': {
		translation: 'On the %1$s %2$s',
	},
	'On the Company Apps Tab, click the "Edit" link to the right of the BambooHR icon. On the Configuration Tab, enter the first part of your BambooHR login URL and then click the Update button. Please do not enter your full BambooHR login URL. For example, if your full BambooHR URL is: https://bamboohrcs.bamboohr.com. For this section of the setup, only enter the very first part of the URL prior to the "bamboohr.com" portion. In the example above, this is "bamboohrcs".':
		{
			translation:
				'On the Company Apps Tab, click the \\"Edit\\" link to the right of the BambooHR icon. On the Configuration Tab, enter the first part of your BambooHR login URL and then click the Update button. Please do not enter your full BambooHR login URL. For example, if your full BambooHR URL is: https://bamboohrcs.bamboohr.com. For this section of the setup, only enter the very first part of the URL prior to the \\"bamboohr.com\\" portion. In the example above, this is \\"bamboohrcs\\".',
		},
	'On the first %s pay dates of the month': {
		translation: 'On the first %s pay dates of the month',
	},
	'On the last %1$s': {
		translation: 'On the last %1$s',
	},
	'On-Call PTO': {
		translation: 'On-Call PTO',
	},
	'On-Call Time Off': {
		translation: 'On-Call Time Off',
	},
	Onboarding: {
		translation: 'Onboarding',
	},
	'Onboarding Canceled': {
		translation: 'Onboarding Canceled',
	},
	'Onboarding Pending': {
		translation: 'Onboarding Pending',
	},
	'Onboarding Settings': {
		translation: 'Onboarding Settings',
	},
	'Onboarding Tab': {
		translation: 'Onboarding Tab',
	},
	'Onboarding Task': {
		translation: 'Onboarding Task',
	},
	'Onboarding Task for:': {
		translation: 'Onboarding Task for:',
	},
	'Onboarding Tasks': {
		translation: 'Onboarding Tasks',
	},
	'Onboarding at ': {
		translation: 'Onboarding at ',
	},
	'Onboarding task changed!': {
		translation: 'Onboarding task changed!',
	},
	'Onboarding task completed!': {
		translation: 'Onboarding task completed!',
	},
	'Onboarding task reopened!': {
		translation: 'Onboarding task reopened!',
	},
	'Onboarding templates and tasks': {
		translation: 'Onboarding templates and tasks',
	},
	'Once a candidate is hired in ApplicantPRO, view the candidate\'s information and navigate to the "Integrations" tab. Once on this tab, click the "Export" button. You will then receive a confirmation message and a link to view the new hire\'s information in BambooHR.':
		{
			translation:
				'Once a candidate is hired in ApplicantPRO, view the candidate\'s information and navigate to the \\"Integrations\\" tab. Once on this tab, click the \\"Export\\" button. You will then receive a confirmation message and a link to view the new hire\'s information in BambooHR.',
		},
	"Once a hire date has been saved for the Candidate in Newton, a pop-up window will appear allowing you to export the new hire sending the data directly into BambooHR. If you choose to Export Later, you can forward the Candidate's data into BambooHR from the Integration Menu. ":
		{
			translation:
				"Once a hire date has been saved for the Candidate in Newton, a pop-up window will appear allowing you to export the new hire sending the data directly into BambooHR. If you choose to Export Later, you can forward the Candidate's data into BambooHR from the Integration Menu. ",
		},
	'Once a review cycle is created you can select which employees need to be reviewed.  When you have assigned a review to an employee, you will be able to view/edit the review in BambooHR.':
		{
			translation:
				'Once a review cycle is created you can select which employees need to be reviewed.  When you have assigned a review to an employee, you will be able to view/edit the review in BambooHR.',
		},
	'Once deleted, API keys cannot be restored. Are you sure you want to delete this API Key?':
		{
			translation:
				'Once deleted, API keys cannot be restored. Are you sure you want to delete this API Key?',
		},
	'Once deleted, devices cannot be restored. Are you sure you want to delete this device?':
		{
			translation:
				'Once deleted, devices cannot be restored. Are you sure you want to delete this device?',
		},
	"Once deleted, we can't bring it back. However, you can always start over!": {
		translation:
			"Once deleted, we can't bring it back. However, you can always start over!",
	},
	'Once done, you can manage your GT Clocks integration here in BambooHR.': {
		translation:
			'Once done, you can manage your GT Clocks integration here in BambooHR.',
	},
	'Once every %1 days you can repost this job opening to the available job boards.':
		{
			translation:
				'Once every %1 days you can repost this job opening to the available job boards.',
		},
	'Once it is authenticated you will be able to use this bank account for payroll.':
		{
			translation:
				'Once it is authenticated you will be able to use this bank account for payroll.',
		},
	"Once it's gone, it's gone.": {
		translation: "Once it's gone, it's gone.",
	},
	'Once per day (at 10:10 pm Mountain Time) any changes made to employee records within BambooHR (or any new employee information added), will be automatically sent to BeneTrac. BeneTrac will review the data and determine if any of the "required" fields listed below have changed. If a required field has changed (or new data is available for a new employee), the information will appear in the BeneTrac system pending review queue for approval.':
		{
			translation:
				'Once per day (at 10:10 pm Mountain Time) any changes made to employee records within BambooHR (or any new employee information added), will be automatically sent to BeneTrac. BeneTrac will review the data and determine if any of the \\"required\\" fields listed below have changed. If a required field has changed (or new data is available for a new employee), the information will appear in the BeneTrac system pending review queue for approval.',
		},
	'Once the Objectives are created in Small Improvements the employee and manager will be able to see them in BambooHR.  They can also edit and give feedback within the Objectives tab.':
		{
			translation:
				'Once the Objectives are created in Small Improvements the employee and manager will be able to see them in BambooHR.  They can also edit and give feedback within the Objectives tab.',
		},
	'Once the integration has been set up between BambooHR and COMPAS, candidates and candidate information will automatically populate BambooHR when the new hire is accepted to the position.':
		{
			translation:
				'Once the integration has been set up between BambooHR and COMPAS, candidates and candidate information will automatically populate BambooHR when the new hire is accepted to the position.',
		},
	'Once the integration has been set up between BambooHR and COMPAS, users can choose to "Export to BambooHR" when a candidate becomes a new hire. The fields that are pushed over include First Name, Last Name, Work Email, Home Email, Work Phone, Home Phone, and Mobile Phone.':
		{
			translation:
				'Once the integration has been set up between BambooHR and COMPAS, users can choose to \\"Export to BambooHR\\" when a candidate becomes a new hire. The fields that are pushed over include First Name, Last Name, Work Email, Home Email, Work Phone, Home Phone, and Mobile Phone.',
		},
	'Once the integration is configured and your BambooHR and Cornerstone accounts are linked, BambooHR will act as the core system of record for the following data fields: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, and Job Title Change Date. Any updates to these fields in BambooHR will automatically update those fields in Cornerstone.':
		{
			translation:
				'Once the integration is configured and your BambooHR and Cornerstone accounts are linked, BambooHR will act as the core system of record for the following data fields: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, and Job Title Change Date. Any updates to these fields in BambooHR will automatically update those fields in Cornerstone.',
		},
	'Once the integration is enabled, employee data updates and approved time-off requests made in BambooHR will automatically be synced with NimbleSchedule within one hour.':
		{
			translation:
				'Once the integration is enabled, employee data updates and approved time-off requests made in BambooHR will automatically be synced with NimbleSchedule within one hour.',
		},
	'Once the refund has been accepted, our tax admin team will reach out to you to collect your bank account information.':
		{
			translation:
				'Once the refund has been accepted, our tax admin team will reach out to you to collect your bank account information.',
		},
	'Once this integration is configured, updates made in BambooHR will automatically be made in Performance Pro within 15 minutes.':
		{
			translation:
				'Once this integration is configured, updates made in BambooHR will automatically be made in Performance Pro within 15 minutes.',
		},
	"Once you complete the Payroll Verification process, we will start the setup of your account. If you haven't started that process yet, a member of our payroll team will reach out within the next few days to get you started. In the meantime, here is a brief outline of what to expect from the implementation process:":
		{
			translation:
				"Once you complete the Payroll Verification process, we will start the setup of your account. If you haven't started that process yet, a member of our payroll team will reach out within the next few days to get you started. In the meantime, here is a brief outline of what to expect from the implementation process:",
		},
	'Once you disable ACA Tracking, you will not be able to track or report on any ACA related fields in your account unless you re-enable ACA tracking in the future.':
		{
			translation:
				'Once you disable ACA Tracking, you will not be able to track or report on any ACA related fields in your account unless you re-enable ACA tracking in the future.',
		},
	'Once you get paid, your paystub will show up here.': {
		translation: 'Once you get paid, your paystub will show up here.',
	},
	'Once you have added the Performance Management module to your BambooHR account, you will then be able to enable Performance Reviews in your Settings area and configure everything you need to be able to get Performance Reviews up and running quickly. You can learn more about our Performance Management Module in our <a href="https://help.bamboohr.com/hc/en-us/categories/202555317-Performance">Help Center</a>.':
		{
			translation:
				'Once you have added the Performance Management module to your BambooHR account, you will then be able to enable Performance Reviews in your Settings area and configure everything you need to be able to get Performance Reviews up and running quickly. You can learn more about our Performance Management Module in our <a href=\\"https://help.bamboohr.com/hc/en-us/categories/202555317-Performance\\">Help Center</a>.',
		},
	'Once you have entered this information, click the blue Save button.': {
		translation:
			'Once you have entered this information, click the blue Save button.',
	},
	"Once you have started the integration in Checkr, click the “install” button below. Within 24 hours you'll be able to run background checks.":
		{
			translation:
				"Once you have started the integration in Checkr, click the “install” button below. Within 24 hours you'll be able to run background checks.",
		},
	'Once you make this change, you will no longer be the Account Owner.': {
		translation:
			'Once you make this change, you will no longer be the Account Owner.',
	},
	'Once you set up the proper configuration through the steps below, Maxwell Health will sync every hour with BambooHR to reflect any changes or updates to the data. For example, if an employee’s compensation or location is changed in BambooHR, when the sync runs automatically, it will update that information in Maxwell Health.':
		{
			translation:
				'Once you set up the proper configuration through the steps below, Maxwell Health will sync every hour with BambooHR to reflect any changes or updates to the data. For example, if an employee’s compensation or location is changed in BambooHR, when the sync runs automatically, it will update that information in Maxwell Health.',
		},
	"Once you've signed up you will be able to automatically post this to free job boards like Indeed and Glassdoor. Cool, huh?":
		{
			translation:
				"Once you've signed up you will be able to automatically post this to free job boards like Indeed and Glassdoor. Cool, huh?",
		},
	'Once you\'ve validated the data connection with BambooHR and are ready to import employee data from BambooHR, you can go to the "Payroll Processing" menu and navigate to the "Employee Import" area. You can then choose to either "Synchronize Data" if you\'re ready to import data from BambooHR, or you can choose to simply "Map Elements" which will allow you to go through the mapping wizard to ensure data fields are mapped properly.':
		{
			translation:
				'Once you\'ve validated the data connection with BambooHR and are ready to import employee data from BambooHR, you can go to the \\"Payroll Processing\\" menu and navigate to the \\"Employee Import\\" area. You can then choose to either \\"Synchronize Data\\" if you\'re ready to import data from BambooHR, or you can choose to simply \\"Map Elements\\" which will allow you to go through the mapping wizard to ensure data fields are mapped properly.',
		},
	"Once your account is created, you will get a basic tutorial on how to use all of Bitium's main features.  Bitium's support team will also gladly help you with additional setup, and give you customized tutorials to make sure you are getting the most out of Bitium.":
		{
			translation:
				"Once your account is created, you will get a basic tutorial on how to use all of Bitium's main features.  Bitium's support team will also gladly help you with additional setup, and give you customized tutorials to make sure you are getting the most out of Bitium.",
		},
	One: {
		translation: 'One',
	},
	'One File': {
		translation: 'One File',
	},
	'One Of': {
		translation: 'One Of',
	},
	'One of the addresses you are using appears to be invalid. Please update the address information and try again.':
		{
			translation:
				'One of the addresses you are using appears to be invalid. Please update the address information and try again.',
		},
	'One or more IDs are invalid for this employee and/or section': {
		translation: 'One or more IDs are invalid for this employee and/or section',
	},
	'One or more Ids are invalid for this employee and or section': {
		translation: 'One or more Ids are invalid for this employee and or section',
	},
	'One or more candidates have an attempted offer. A user with Offer Letter permissions is needed to delete.':
		{
			translation:
				'One or more candidates have an attempted offer. A user with Offer Letter permissions is needed to delete.',
		},
	'One or more candidates not found': {
		translation: 'One or more candidates not found',
	},
	'One or more employees already have that policy and accrual start date combination.':
		{
			translation:
				'One or more employees already have that policy and accrual start date combination.',
		},
	'One or more employees are missing a hire date.': {
		translation: 'One or more employees are missing a hire date.',
	},
	'One or more employees are missing hire dates.': {
		translation: 'One or more employees are missing hire dates.',
	},
	'One or more employees has too many feedback requests. Please try again.': {
		translation:
			'One or more employees has too many feedback requests. Please try again.',
	},
	'One or more files failed to upload for the following reasons:': {
		translation:
			'One or more files failed to upload for the following reasons:',
	},
	'One or more files failed to upload successfully.': {
		translation: 'One or more files failed to upload successfully.',
	},
	'One or more files failed to upload.': {
		translation: 'One or more files failed to upload.',
	},
	'One or more files will be removed from onboarding tasks, offboarding tasks, and offer letters.':
		{
			translation:
				'One or more files will be removed from onboarding tasks, offboarding tasks, and offer letters.',
		},
	'One or more files will be removed from onboarding tasks, offboarding tasks, offer letters, and company announcements.':
		{
			translation:
				'One or more files will be removed from onboarding tasks, offboarding tasks, offer letters, and company announcements.',
		},
	'One or more of the fields you have selected cannot be edited for a group so we have removed them from the selected fields list. Please use individual power edit to change these fields.':
		{
			translation:
				'One or more of the fields you have selected cannot be edited for a group so we have removed them from the selected fields list. Please use individual power edit to change these fields.',
		},
	"One or more of the report filters couldn't be applied.  Please review & update the report settings.":
		{
			translation:
				"One or more of the report filters couldn't be applied.  Please review & update the report settings.",
		},
	'One or more of the selected employees are inactive.': {
		translation: 'One or more of the selected employees are inactive.',
	},
	'One or more of the selected employees needs to have an active Pay Schedule.':
		{
			translation:
				'One or more of the selected employees needs to have an active Pay Schedule.',
		},
	'One or more report ids are not valid.': {
		translation: 'One or more report ids are not valid.',
	},
	'One or more request data are not valid.': {
		translation: 'One or more request data are not valid.',
	},
	'One pay date': {
		translation: 'One pay date',
	},
	'One time': {
		translation: 'One time',
	},
	'One way to keep our Assessments awesome is by keeping them short :)': {
		translation:
			'One way to keep our Assessments awesome is by keeping them short :)',
	},
	'One-time': {
		translation: 'One-time',
	},
	"OneLogin gives users the ability to launch all their web apps from OneLogin's single sign-on (SSO) portal or from the company's intranet. OneLogin gets enterprises up and running in minutes – literally.":
		{
			translation:
				"OneLogin gives users the ability to launch all their web apps from OneLogin's single sign-on (SSO) portal or from the company's intranet. OneLogin gets enterprises up and running in minutes – literally.",
		},
	'OneLogin uses SAML 2.0 to sign users into BambooHR, eliminating user-managed passwords and the risk of phishing.':
		{
			translation:
				'OneLogin uses SAML 2.0 to sign users into BambooHR, eliminating user-managed passwords and the risk of phishing.',
		},
	Online: {
		translation: 'Online',
	},
	'Online Training Library': {
		translation: 'Online Training Library',
	},
	'Only %s can install this app.': {
		translation: 'Only %s can install this app.',
	},
	'Only Select the {1} Candidates on this page.': {
		translation: 'Only Select the {1} Candidates on this page.',
	},
	'Only Shown in Dev/Stage': {
		translation: 'Only Shown in Dev/Stage',
	},
	'Only Some Employees': {
		translation: 'Only Some Employees',
	},
	'Only Some Employees...': {
		translation: 'Only Some Employees...',
	},
	'Only US employees can be included in payroll.': {
		translation: 'Only US employees can be included in payroll.',
	},
	'Only allow Google Single Sign-On': {
		translation: 'Only allow Google Single Sign-On',
	},
	'Only cascading goals can be company level goals.': {
		translation: 'Only cascading goals can be company level goals.',
	},
	'Only cascading goals can have a parent cascading goal.': {
		translation: 'Only cascading goals can have a parent cascading goal.',
	},
	'Only certain access levels': {
		translation: 'Only certain access levels',
	},
	'Only certain applications need this': {
		translation: 'Only certain applications need this',
	},
	'Only files of the types specified can be uploaded.': {
		translation: 'Only files of the types specified can be uploaded.',
	},
	'Only jobs with an AA/EEO Job Category can be included in this report.': {
		translation:
			'Only jobs with an AA/EEO Job Category can be included in this report.',
	},
	'Only one "Show History" toggle is allowed.': {
		translation: 'Only one "Show History" toggle is allowed.',
	},
	'Only one Access Level can be selected for this user because they are using our Webhook API. <a href="https://documentation.bamboohr.com/docs/webhooks-2">Learn more</a>':
		{
			translation:
				'Only one Access Level can be selected for this user because they are using our Webhook API. <a href="https://documentation.bamboohr.com/docs/webhooks-2">Learn more</a>',
		},
	'Only one Access Level can be selected for this user because they are using our Webhook API. <a href="https://documentation.bamboohr.com/docs/webhooks-api-permission-based">Learn more</a>':
		{
			translation:
				'Only one Access Level can be selected for this user because they are using our Webhook API. <a href=\\"https://documentation.bamboohr.com/docs/webhooks-api-permission-based\\">Learn more</a>',
		},
	'Only one account can have 100%s': {
		translation: 'Only one account can have 100%s',
	},
	'Only one assertion is supported': {
		translation: 'Only one assertion is supported',
	},
	'Only one can be checked': {
		translation: 'Only one can be checked',
	},
	'Only one group can have "Show History" checked.': {
		translation: 'Only one group can have "Show History" checked.',
	},
	'Only paid time off types can be included in payroll': {
		translation: 'Only paid time off types can be included in payroll',
	},
	'Only people with system permissions (Admin, etc.) to manage Job Openings can edit job and applicant info.':
		{
			translation:
				'Only people with system permissions (Admin, etc.) to manage Job Openings can edit job and applicant info.',
		},
	'Only people with system permissions (Full Admin, etc.) to manage Job Openings can edit job and applicant info.':
		{
			translation:
				'Only people with system permissions (Full Admin, etc.) to manage Job Openings can edit job and applicant info.',
		},
	'Only seen by Managers': {
		translation: 'Only seen by Managers',
	},
	'Only some people': {
		translation: 'Only some people',
	},
	'Only specific employees': {
		translation: 'Only specific employees',
	},
	'Only support admins can restore files and folders.': {
		translation: 'Only support admins can restore files and folders.',
	},
	'Only the last account can be 100%s': {
		translation: 'Only the last account can be 100%s',
	},
	'Only your account owner, %s, can install this paid integration.': {
		translation:
			'Only your account owner, %s, can install this paid integration.',
	},
	'Only your account owner, %s, can uninstall this integration.': {
		translation: 'Only your account owner, %s, can uninstall this integration.',
	},
	'Only your account owner, %s, can uninstall this paid integration.': {
		translation:
			'Only your account owner, %s, can uninstall this paid integration.',
	},
	'Ooh, this is better. But we’re sure you have a little bit more to add…': {
		translation:
			'Ooh, this is better. But we’re sure you have a little bit more to add…',
	},
	'Oops something went wrong': {
		translation: 'Oops something went wrong',
	},
	"Oops something went wrong and we couldn't get that file for upload. Please try uploading again":
		{
			translation:
				"Oops something went wrong and we couldn't get that file for upload. Please try uploading again",
		},
	"Oops something went wrong and we couldn't import your data. Please try again or contact support.":
		{
			translation:
				"Oops something went wrong and we couldn't import your data. Please try again or contact support.",
		},
	'Oops we are having trouble uploading files right now. Please try again in a few minutes':
		{
			translation:
				'Oops we are having trouble uploading files right now. Please try again in a few minutes',
		},
	"Oops we're having trouble downloading files right now. Please try again in a few minutes":
		{
			translation:
				"Oops we're having trouble downloading files right now. Please try again in a few minutes",
		},
	'Oops!  "%s" is a reserved folder name. Please choose another name for this folder.':
		{
			translation:
				'Oops!  \\"%s\\" is a reserved folder name. Please choose another name for this folder.',
		},
	'Oops!  There is already a folder named "%s".': {
		translation: 'Oops!  There is already a folder named \\"%s\\".',
	},
	'Oops!  There is already a tasklist named "%s".': {
		translation: 'Oops!  There is already a tasklist named \\"%s\\".',
	},
	'Oops! City is too long.': {
		translation: 'Oops! City is too long.',
	},
	'Oops! Double check the numbers you entered. If everything is correct please contact your administrator.':
		{
			translation:
				'Oops! Double check the numbers you entered. If everything is correct please contact your administrator.',
		},
	'Oops! Please enter %s before saving the Job Opening.': {
		translation: 'Oops! Please enter %s before saving the Job Opening.',
	},
	'Oops! Please enter a valid postal code before saving the Job Opening.': {
		translation:
			'Oops! Please enter a valid postal code before saving the Job Opening.',
	},
	'Oops! Please enter your email address and password in order to log in.': {
		translation:
			'Oops! Please enter your email address and password in order to log in.',
	},
	'Oops! Please enter your email address in order to log in.': {
		translation: 'Oops! Please enter your email address in order to log in.',
	},
	'Oops! Please enter your password in order to log in.': {
		translation: 'Oops! Please enter your password in order to log in.',
	},
	'Oops! Please limit your %s to ': {
		translation: 'Oops! Please limit your %s to ',
	},
	'Oops! Please limit your %s to 255 characters or less.': {
		translation: 'Oops! Please limit your %s to 255 characters or less.',
	},
	'Oops! Please limit your Description to 45000 characters or less.': {
		translation:
			'Oops! Please limit your Description to 45000 characters or less.',
	},
	'Oops! Please limit your description to 45000 characters or less.': {
		translation:
			'Oops! Please limit your description to 45000 characters or less.',
	},
	'Oops! Please save your new %s before saving the Job Opening.': {
		translation: 'Oops! Please save your new %s before saving the Job Opening.',
	},
	'Oops! Please select a Time Off import type': {
		translation: 'Oops! Please select a Time Off import type',
	},
	'Oops! Something is wrong with the data provided. Please check fields and try again.':
		{
			translation:
				'Oops! Something is wrong with the data provided. Please check fields and try again.',
		},
	"Oops! Something went wrong and we couldn't load your data. Try again.": {
		translation:
			"Oops! Something went wrong and we couldn't load your data. Try again.",
	},
	'Oops! Something went wrong saving your %1$s.  Please try again.': {
		translation:
			'Oops! Something went wrong saving your %1$s.  Please try again.',
	},
	'Oops! Something went wrong. Please try again later.': {
		translation: 'Oops! Something went wrong. Please try again later.',
	},
	'Oops! Something went wrong. Please try again.': {
		translation: 'Oops! Something went wrong. Please try again.',
	},
	"Oops! Sorry, but you don't seem to have access to request time off!": {
		translation:
			"Oops! Sorry, but you don't seem to have access to request time off!",
	},
	"Oops! Sorry, but you don't seem to have access to the Employee Directory!": {
		translation:
			"Oops! Sorry, but you don't seem to have access to the Employee Directory!",
	},
	'Oops! State/province is too long.': {
		translation: 'Oops! State/province is too long.',
	},
	'Oops! That file type is not valid. Must be CSV or XLS': {
		translation: 'Oops! That file type is not valid. Must be CSV or XLS',
	},
	"Oops! That time off type isn't available.": {
		translation: "Oops! That time off type isn't available.",
	},
	'Oops! The benefit file could not be stored correctly.': {
		translation: 'Oops! The benefit file could not be stored correctly.',
	},
	'Oops! The benefit file is not valid. Please check your file and try again.':
		{
			translation:
				'Oops! The benefit file is not valid. Please check your file and try again.',
		},
	'Oops! The custom approval could not be saved.': {
		translation: 'Oops! The custom approval could not be saved.',
	},
	'Oops! The file cannot be empty': {
		translation: 'Oops! The file cannot be empty',
	},
	'Oops! The import record is missing the required %s column.': {
		translation: 'Oops! The import record is missing the required %s column.',
	},
	'Oops! The minimum experience selected appears to be invalid.': {
		translation: 'Oops! The minimum experience selected appears to be invalid.',
	},
	'Oops! There is already a folder named "%s".': {
		translation: 'Oops! There is already a folder named \\"%s\\".',
	},
	'Oops! There is missing or incomplete compensation and/or job info for offer details.':
		{
			translation:
				'Oops! There is missing or incomplete compensation and/or job info for offer details.',
		},
	'Oops! There is missing or invalid candidate information.': {
		translation: 'Oops! There is missing or invalid candidate information.',
	},
	'Oops! There is missing position information.': {
		translation: 'Oops! There is missing position information.',
	},
	'Oops! There was a problem deleting "%1$s".': {
		translation: 'Oops! There was a problem deleting \\"%1$s\\".',
	},
	'Oops! There was a problem loading the fields. Try refreshing the page.': {
		translation:
			'Oops! There was a problem loading the fields. Try refreshing the page.',
	},
	'Oops! There was a problem loading the tabs. Try refreshing the page.': {
		translation:
			'Oops! There was a problem loading the tabs. Try refreshing the page.',
	},
	'Oops! This is awkward...': {
		translation: 'Oops! This is awkward...',
	},
	'Oops! This job is no longer open. Please try a different job opening.': {
		translation:
			'Oops! This job is no longer open. Please try a different job opening.',
	},
	'Oops! Unable to go over your limit of open jobs.': {
		translation: 'Oops! Unable to go over your limit of open jobs.',
	},
	'Oops! We are missing permissions to access Gusto. Will you Reauthorize?': {
		translation:
			'Oops! We are missing permissions to access Gusto. Will you Reauthorize?',
	},
	"Oops! We can't find this offer letter template.": {
		translation: "Oops! We can't find this offer letter template.",
	},
	"Oops! We can't process your request right now, please refresh the page and try again.":
		{
			translation:
				"Oops! We can't process your request right now, please refresh the page and try again.",
		},
	'Oops! We detected some invalid data.': {
		translation: 'Oops! We detected some invalid data.',
	},
	'Oops! We failed to create the default offer letter template.': {
		translation: 'Oops! We failed to create the default offer letter template.',
	},
	'Oops! We were unable to validate the form. Check your values and try again.':
		{
			translation:
				'Oops! We were unable to validate the form. Check your values and try again.',
		},
	"Oops! We're experiencing too many submissions right now. Please wait a little bit and try again.":
		{
			translation:
				"Oops! We're experiencing too many submissions right now. Please wait a little bit and try again.",
		},
	"Oops! We're missing the required hiring lead for this position.": {
		translation:
			"Oops! We're missing the required hiring lead for this position.",
	},
	"Oops! You don't have permission to view this request.": {
		translation: "Oops! You don't have permission to view this request.",
	},
	'Oops! Zipcode is too long.': {
		translation: 'Oops! Zipcode is too long.',
	},
	"Oops, Jobvite doesn't recognize your credentials. Please check the api key and secret.":
		{
			translation:
				"Oops, Jobvite doesn't recognize your credentials. Please check the api key and secret.",
		},
	'Oops, Something when wrong. Your request has not been completed.': {
		translation:
			'Oops, Something when wrong. Your request has not been completed.',
	},
	"Oops, That Won't Work...": {
		translation: "Oops, That Won't Work...",
	},
	"Oops, You don't have permission to do that.": {
		translation: "Oops, You don't have permission to do that.",
	},
	'Oops, an account owner must be an active user.  Check they are not terminated.':
		{
			translation:
				'Oops, an account owner must be an active user.  Check they are not terminated.',
		},
	'Oops, an account owner must be an active user. The account owner can be changed in Account Info in Settings.':
		{
			translation:
				'Oops, an account owner must be an active user. The account owner can be changed in Account Info in Settings.',
		},
	'Oops, could not validate date! Check date and try again': {
		translation: 'Oops, could not validate date! Check date and try again',
	},
	'Oops, did you want to save this question?': {
		translation: 'Oops, did you want to save this question?',
	},
	'Oops, please fill out all required fields': {
		translation: 'Oops, please fill out all required fields',
	},
	'Oops, please make sure the pay rate is in %1 before adding %2 to a pay schedule that syncs with BambooHR Payroll.':
		{
			translation:
				'Oops, please make sure the pay rate is in %1 before adding %2 to a pay schedule that syncs with BambooHR Payroll.',
		},
	'Oops, some files could not be uploaded.  Please try again.': {
		translation: 'Oops, some files could not be uploaded.  Please try again.',
	},
	'Oops, some files could not be uploaded. Please try again.': {
		translation: 'Oops, some files could not be uploaded. Please try again.',
	},
	'Oops, something happened! Could not restore that plan!': {
		translation: 'Oops, something happened! Could not restore that plan!',
	},
	'Oops, something went wrong and we could not delete this access level.': {
		translation:
			'Oops, something went wrong and we could not delete this access level.',
	},
	'Oops, something went wrong and we could not duplicate this access level.': {
		translation:
			'Oops, something went wrong and we could not duplicate this access level.',
	},
	'Oops, something went wrong!': {
		translation: 'Oops, something went wrong!',
	},
	'Oops, something went wrong! ': {
		translation: 'Oops, something went wrong! ',
	},
	'Oops, something went wrong.': {
		translation: 'Oops, something went wrong.',
	},
	"Oops, sorry that won't work...": {
		translation: "Oops, sorry that won't work...",
	},
	"Oops, that won't work...": {
		translation: "Oops, that won't work...",
	},
	"Oops, that's not a valid routing number": {
		translation: "Oops, that's not a valid routing number",
	},
	'Oops, the deposit amount should be a valid dollar amount.': {
		translation: 'Oops, the deposit amount should be a valid dollar amount.',
	},
	"Oops, there is a file in this folder that you don't have permission to delete.":
		{
			translation:
				"Oops, there is a file in this folder that you don't have permission to delete.",
		},
	"Oops, there is a folder or a file that you don't have permission to delete.":
		{
			translation:
				"Oops, there is a folder or a file that you don't have permission to delete.",
		},
	'Oops, there was a problem adding the Field.': {
		translation: 'Oops, there was a problem adding the Field.',
	},
	'Oops, there was a problem adding the Tab.': {
		translation: 'Oops, there was a problem adding the Tab.',
	},
	'Oops, there was a problem removing the Field.': {
		translation: 'Oops, there was a problem removing the Field.',
	},
	'Oops, there was a problem removing the Tab.': {
		translation: 'Oops, there was a problem removing the Tab.',
	},
	'Oops, there was a problem saving the tab order.': {
		translation: 'Oops, there was a problem saving the tab order.',
	},
	'Oops, there was a problem updating the fields. Please refresh the page.': {
		translation:
			'Oops, there was a problem updating the fields. Please refresh the page.',
	},
	'Oops, this access level is being used by another access level for self access and cannot be deleted.':
		{
			translation:
				'Oops, this access level is being used by another access level for self access and cannot be deleted.',
		},
	'Oops, this is not a valid SSN or it is a duplicate of another SSN in your account.':
		{
			translation:
				'Oops, this is not a valid SSN or it is a duplicate of another SSN in your account.',
		},
	'Oops, try again': {
		translation: 'Oops, try again',
	},
	'Oops, we are having trouble uploading files right now. Please try again in a few minutes.':
		{
			translation:
				'Oops, we are having trouble uploading files right now. Please try again in a few minutes.',
		},
	"Oops, you can't delete a read-only folder": {
		translation: "Oops, you can't delete a read-only folder",
	},
	"Oops, you can't delete this read-only folder.": {
		translation: "Oops, you can't delete this read-only folder.",
	},
	"Oops, you can't move files to a read-only folder": {
		translation: "Oops, you can't move files to a read-only folder",
	},
	"Oops, you can't rename a read-only folder": {
		translation: "Oops, you can't rename a read-only folder",
	},
	"Oops, you can't upload files to a read-only folder.": {
		translation: "Oops, you can't upload files to a read-only folder.",
	},
	"Oops, you don't have access to add new folders.": {
		translation: "Oops, you don't have access to add new folders.",
	},
	"Oops, you don't have access to delete files in this folder.": {
		translation: "Oops, you don't have access to delete files in this folder.",
	},
	"Oops, you don't have access to delete this folder.": {
		translation: "Oops, you don't have access to delete this folder.",
	},
	"Oops, you don't have access to edit files.": {
		translation: "Oops, you don't have access to edit files.",
	},
	"Oops, you don't have access to edit folder information.": {
		translation: "Oops, you don't have access to edit folder information.",
	},
	"Oops, you don't have access to share this file.": {
		translation: "Oops, you don't have access to share this file.",
	},
	"Oops, you don't have access to share this folder.": {
		translation: "Oops, you don't have access to share this folder.",
	},
	"Oops, you don't have access to some files.": {
		translation: "Oops, you don't have access to some files.",
	},
	"Oops, you don't have access to this folder": {
		translation: "Oops, you don't have access to this folder",
	},
	"Oops, you don't have access to this folder.": {
		translation: "Oops, you don't have access to this folder.",
	},
	"Oops, you don't have access to upload files to this assessment.": {
		translation:
			"Oops, you don't have access to upload files to this assessment.",
	},
	"Oops, you don't have access to upload files to this folder.": {
		translation: "Oops, you don't have access to upload files to this folder.",
	},
	"Oops, you don't have access to upload files to this goal.": {
		translation: "Oops, you don't have access to upload files to this goal.",
	},
	"Oops, you don't have permission to edit this user.": {
		translation: "Oops, you don't have permission to edit this user.",
	},
	'Oops. Please fix any incorrect time entries and try again.': {
		translation: 'Oops. Please fix any incorrect time entries and try again.',
	},
	'Oops. Something went wrong. Please try again.': {
		translation: 'Oops. Something went wrong. Please try again.',
	},
	'Oops. Something went wrong. Try contacting support if the problem persists.':
		{
			translation:
				'Oops. Something went wrong. Try contacting support if the problem persists.',
		},
	'Oops... Employee needs an email.': {
		translation: 'Oops... Employee needs an email.',
	},
	'Oops... Only your last account can have 100%1 of the remaining amount deposited into it.':
		{
			translation:
				'Oops... Only your last account can have 100%1 of the remaining amount deposited into it.',
		},
	'Oops... Only your last account can have 100%s of the remaining amount deposited into it.':
		{
			translation:
				'Oops... Only your last account can have 100%s of the remaining amount deposited into it.',
		},
	Open: {
		translation: 'Open',
	},
	'Open %1$s day': {
		translation: {
			one: 'Open %1$s day',
			other: 'Open %1$s days',
		},
	},
	'Open Draft': {
		translation: 'Open Draft',
	},
	'Open Job Postings': {
		translation: 'Open Job Postings',
	},
	'Open My Profile': {
		translation: 'Open My Profile',
	},
	'Open On': {
		translation: 'Open On',
	},
	'Open Payroll Setup Tour': {
		translation: 'Open Payroll Setup Tour',
	},
	'Open Positions': {
		translation: 'Open Positions',
	},
	'Open QuickBooks': {
		translation: 'Open QuickBooks',
	},
	'Opened %s (%s ago)': {
		translation: 'Opened %s (%s ago)',
	},
	'Opened Date': {
		translation: 'Opened Date',
	},
	'Opening Balance': {
		translation: 'Opening Balance',
	},
	'Opening balance': {
		translation: 'Opening balance',
	},
	'Opening balance import': {
		translation: 'Opening balance import',
	},
	'Opening balance is 0, no adjustment needed': {
		translation: 'Opening balance is 0, no adjustment needed',
	},
	'Opens in a new tab': {
		translation: 'Opens in a new tab',
	},
	Operations: {
		translation: 'Operations',
	},
	Operatives: {
		translation: 'Operatives',
	},
	'Option Price': {
		translation: 'Option Price',
	},
	Optional: {
		translation: 'Optional',
	},
	'Optional additional tabs': {
		translation: 'Optional additional tabs',
	},
	'Optional: Single Sign-on': {
		translation: 'Optional: Single Sign-on',
	},
	'Or only these people': {
		translation: 'Or only these people',
	},
	'Org Chart': {
		translation: 'Org Chart',
	},
	'Org Chart Issue': {
		translation: 'Org Chart Issue',
	},
	'Organize Variable Rate Health Plans': {
		translation: 'Organize Variable Rate Health Plans',
	},
	'Orientation Training': {
		translation: 'Orientation Training',
	},
	'Original Hire Date': {
		translation: 'Original Hire Date',
	},
	'Original request': {
		translation: 'Original request',
	},
	Other: {
		translation: 'Other',
	},
	'Other Activity on this Job': {
		translation: 'Other Activity on this Job',
	},
	'Other Benefit': {
		translation: 'Other Benefit',
	},
	'Other Degree': {
		translation: 'Other Degree',
	},
	'Other Garnishment': {
		translation: 'Other Garnishment',
	},
	'Other Garnishments': {
		translation: 'Other Garnishments',
	},
	'Other ID': {
		translation: 'Other ID',
	},
	'Other Income': {
		translation: 'Other Income',
	},
	'Other Instructions': {
		translation: 'Other Instructions',
	},
	'Other Language': {
		translation: 'Other Language',
	},
	'Other Loan Repayment': {
		translation: 'Other Loan Repayment',
	},
	'Other Post-Tax Deduction': {
		translation: 'Other Post-Tax Deduction',
	},
	'Other Post-Tax Non-Benefit Deduction': {
		translation: 'Other Post-Tax Non-Benefit Deduction',
	},
	'Other Pre-Tax Deduction': {
		translation: 'Other Pre-Tax Deduction',
	},
	'Other School': {
		translation: 'Other School',
	},
	'Other Type': {
		translation: 'Other Type',
	},
	'Other Wages and Deductions': {
		translation: 'Other Wages and Deductions',
	},
	'Other employment': {
		translation: 'Other employment',
	},
	'Other...': {
		translation: 'Other...',
	},
	'Other: {1}': {
		translation: 'Other: {1}',
	},
	Others: {
		translation: 'Others',
	},
	'Otherwise, we recommend continuing to add all of your Plans.': {
		translation: 'Otherwise, we recommend continuing to add all of your Plans.',
	},
	'Otherwise, you can still complete this step without adding direct deposit info for these employees':
		{
			translation:
				'Otherwise, you can still complete this step without adding direct deposit info for these employees',
		},
	'Our Electronic Signatures feature, available on the Professional platform, streamlines your processes, making experiences like onboarding or open enrollment more enjoyable while also keeping documents organized and easy to access. Save time by rounding up paperwork, money by ditching file cabinets, and trees by leaving them alone.':
		{
			translation:
				'Our Electronic Signatures feature, available on the Professional platform, streamlines your processes, making experiences like onboarding or open enrollment more enjoyable while also keeping documents organized and easy to access. Save time by rounding up paperwork, money by ditching file cabinets, and trees by leaving them alone.',
		},
	'Our goal is 100%% completion—each department is unique and everyone has valuable feedback. The survey will be open for one week.':
		{
			translation:
				'Our goal is 100%% completion—each department is unique and everyone has valuable feedback. The survey will be open for one week.',
		},
	'Our payroll tools and some reports are temporarily down.': {
		translation: 'Our payroll tools and some reports are temporarily down.',
	},
	'Out Until %s': {
		translation: 'Out Until %s',
	},
	'Outbound Api Call': {
		translation: 'Outbound Api Call',
	},
	'Over Qualified': {
		translation: 'Over Qualified',
	},
	'Overlapping entry': {
		translation: 'Overlapping entry',
	},
	'Overlapping timesheets found. Please contact support.': {
		translation: 'Overlapping timesheets found. Please contact support.',
	},
	Overtime: {
		translation: 'Overtime',
	},
	'Overtime (%1$sx)': {
		translation: 'Overtime (%1$sx)',
	},
	'Overtime Rate': {
		translation: 'Overtime Rate',
	},
	'Overtime Rate is required': {
		translation: 'Overtime Rate is required',
	},
	'Overtime State': {
		translation: 'Overtime State',
	},
	'Overtime Status': {
		translation: 'Overtime Status',
	},
	'Overtime Status cannot be empty.': {
		translation: 'Overtime Status cannot be empty.',
	},
	'Overtime Status is required': {
		translation: 'Overtime Status is required',
	},
	'Overtime Status is required.': {
		translation: 'Overtime Status is required.',
	},
	'Overtime Status must be selected as Exempt if the Pay Rate is $0.00.': {
		translation:
			'Overtime Status must be selected as Exempt if the Pay Rate is $0.00.',
	},
	'Overtime Status must be selected as Exempt if the Pay Type is Commission Only':
		{
			translation:
				'Overtime Status must be selected as Exempt if the Pay Type is Commission Only',
		},
	'Overtime Vacation Accrual': {
		translation: 'Overtime Vacation Accrual',
	},
	"Overtime Won't Be Calculated": {
		translation: "Overtime Won't Be Calculated",
	},
	'Overtime cannot be calculated for %1$s because their address does not include a US state.':
		{
			translation:
				'Overtime cannot be calculated for %1$s because their address does not include a US state.',
		},
	'Overtime cannot be calculated for addresses that do not include a US state.':
		{
			translation:
				'Overtime cannot be calculated for addresses that do not include a US state.',
		},
	'Overtime cannot be calculated for this day.': {
		translation: 'Overtime cannot be calculated for this day.',
	},
	'Overtime cannot be calculated for this employee because the location does not include a US state.':
		{
			translation:
				'Overtime cannot be calculated for this employee because the location does not include a US state.',
		},
	'Overtime can’t be calculated for international addresses.': {
		translation: 'Overtime can’t be calculated for international addresses.',
	},
	'Overtime can’t be calculated. The address is missing a state.': {
		translation:
			'Overtime can’t be calculated. The address is missing a state.',
	},
	'Overtime can’t be calculated. This employee’s address is missing a US state.':
		{
			translation:
				'Overtime can’t be calculated. This employee’s address is missing a US state.',
		},
	'Overtime can’t be calculated. This employee’s address is missing a state.': {
		translation:
			'Overtime can’t be calculated. This employee’s address is missing a state.',
	},
	'Overtime is not calculated for exempt employees.': {
		translation: 'Overtime is not calculated for exempt employees.',
	},
	'Overtime rate': {
		translation: 'Overtime rate',
	},
	"Overtime rate is either missing or has an invalid value for this employee's pay schedule. Please update to ensure amount is greater than 0 and currency code is USD.":
		{
			translation:
				"Overtime rate is either missing or has an invalid value for this employee's pay schedule. Please update to ensure amount is greater than 0 and currency code is USD.",
		},
	'Overtime rate is required and must be greater than 0 when on syncing pay schedule.':
		{
			translation:
				'Overtime rate is required and must be greater than 0 when on syncing pay schedule.',
		},
	'Overtime rate is required when pay type is Salary and overtime status is Non-Exempt on a syncing pay schedule.':
		{
			translation:
				'Overtime rate is required when pay type is Salary and overtime status is Non-Exempt on a syncing pay schedule.',
		},
	'Overtime rate is required, must be greater than 0, and have a valid currency code when on syncing pay schedule.':
		{
			translation:
				'Overtime rate is required, must be greater than 0, and have a valid currency code when on syncing pay schedule.',
		},
	'Overtime status must be selected as Exempt if pay rate is 0.': {
		translation: 'Overtime status must be selected as Exempt if pay rate is 0.',
	},
	Overview: {
		translation: 'Overview',
	},
	'Overwrite Approval': {
		translation: 'Overwrite Approval',
	},
	Owner: {
		translation: 'Owner',
	},
	'Owner + Key Contact': {
		translation: 'Owner + Key Contact',
	},
	'Owner or Admin': {
		translation: 'Owner or Admin',
	},
	'Owner or Admin + Toggle Enabled + Dashboard checked + Company in Dashboard Prototype':
		{
			translation:
				'Owner or Admin + Toggle Enabled + Dashboard checked + Company in Dashboard Prototype',
		},
	'Owner or Admin or Payroll Admin': {
		translation: 'Owner or Admin or Payroll Admin',
	},
	'Owner or Admin or Shared With': {
		translation: 'Owner or Admin or Shared With',
	},
	'Owner:': {
		translation: 'Owner:',
	},
	'Owner: %s': {
		translation: 'Owner: %s',
	},
	'PCR Nasal Swab': {
		translation: 'PCR Nasal Swab',
	},
	'PCR Saliva': {
		translation: 'PCR Saliva',
	},
	PDF: {
		translation: 'PDF',
	},
	'PDF Report': {
		translation: 'PDF Report',
	},
	'PEHP #': {
		translation: 'PEHP #',
	},
	'PFML NH': {
		translation: 'PFML NH',
	},
	'PFML VT': {
		translation: 'PFML VT',
	},
	PIN: {
		translation: 'PIN',
	},
	'PL/SQL Training': {
		translation: 'PL/SQL Training',
	},
	'PLEASE NOTE:': {
		translation: 'PLEASE NOTE:',
	},
	PREVIEWING: {
		translation: 'PREVIEWING',
	},
	'PROVIDED AS A PAPER CHECK': {
		translation: 'PROVIDED AS A PAPER CHECK',
	},
	'PROVIDED AS PAPER CHECK': {
		translation: 'PROVIDED AS PAPER CHECK',
	},
	PT: {
		translation: 'PT',
	},
	PTO: {
		translation: 'PTO',
	},
	'PTO Test': {
		translation: 'PTO Test',
	},
	'PTO/Vacation': {
		translation: 'PTO/Vacation',
	},
	'PTO/Vacation (Paid)': {
		translation: 'PTO/Vacation (Paid)',
	},
	Package: {
		translation: 'Package',
	},
	Packet: {
		translation: 'Packet',
	},
	'Packet Completed': {
		translation: 'Packet Completed',
	},
	'Packet Sent': {
		translation: 'Packet Sent',
	},
	'Packet Sent Datetime': {
		translation: 'Packet Sent Datetime',
	},
	Page: {
		translation: 'Page',
	},
	'Page Not Found': {
		translation: 'Page Not Found',
	},
	'Page Not Found (404 error)': {
		translation: 'Page Not Found (404 error)',
	},
	'Page does not exist.': {
		translation: 'Page does not exist.',
	},
	'Page orientation': {
		translation: 'Page orientation',
	},
	Pager: {
		translation: 'Pager',
	},
	Paid: {
		translation: 'Paid',
	},
	'Paid By': {
		translation: 'Paid By',
	},
	'Paid Family and Medical Leave New Hampshire': {
		translation: 'Paid Family and Medical Leave New Hampshire',
	},
	'Paid Family and Medical Leave Vermont': {
		translation: 'Paid Family and Medical Leave Vermont',
	},
	'Paid Per': {
		translation: 'Paid Per',
	},
	'Paid Per cannot be empty.': {
		translation: 'Paid Per cannot be empty.',
	},
	'Paid Per is required': {
		translation: 'Paid Per is required',
	},
	'Paid Per is required.': {
		translation: 'Paid Per is required.',
	},
	'Paid Time Off': {
		translation: 'Paid Time Off',
	},
	'Paid Time Off (PTO)': {
		translation: 'Paid Time Off (PTO)',
	},
	'Paid Time Off Types': {
		translation: 'Paid Time Off Types',
	},
	'Paid by Your Employer on Your Behalf': {
		translation: 'Paid by Your Employer on Your Behalf',
	},
	'Paid per': {
		translation: 'Paid per',
	},
	'Paid per and pay rate are both required when one or the other is provided.':
		{
			translation:
				'Paid per and pay rate are both required when one or the other is provided.',
		},
	"Paid per can't be blank": {
		translation: "Paid per can't be blank",
	},
	'Paid to': {
		translation: 'Paid to',
	},
	'Panel not Found.': {
		translation: 'Panel not Found.',
	},
	"Paper - I'd like to have a paper copy of my year end tax documents (W2 or 1099) mailed to my home address.":
		{
			translation:
				"Paper - I'd like to have a paper copy of my year end tax documents (W2 or 1099) mailed to my home address.",
		},
	'Paper Size': {
		translation: 'Paper Size',
	},
	'Paper money': {
		translation: 'Paper money',
	},
	'Paper size': {
		translation: 'Paper size',
	},
	'Paperless - I prefer to download and print my year end tax documents (W2 or 1099) by logging into BambooHR.':
		{
			translation:
				'Paperless - I prefer to download and print my year end tax documents (W2 or 1099) by logging into BambooHR.',
		},
	Paragraph: {
		translation: 'Paragraph',
	},
	'Paragraph Field': {
		translation: 'Paragraph Field',
	},
	Parking: {
		translation: 'Parking',
	},
	'Parking Space': {
		translation: 'Parking Space',
	},
	'Parking pass #': {
		translation: 'Parking pass #',
	},
	'Part-Time': {
		translation: 'Part-Time',
	},
	'Part-Time Eligible': {
		translation: 'Part-Time Eligible',
	},
	'Part-Time Ineligible': {
		translation: 'Part-Time Ineligible',
	},
	'Part-Time/Variable Hour (eligible for benefits)': {
		translation: 'Part-Time/Variable Hour (eligible for benefits)',
	},
	'Part-Time/Variable Hour (ineligible for benefits)': {
		translation: 'Part-Time/Variable Hour (ineligible for benefits)',
	},
	'Partially Vaccinated': {
		translation: 'Partially Vaccinated',
	},
	'Participating in Performance': {
		translation: 'Participating in Performance',
	},
	'Partner Details': {
		translation: 'Partner Details',
	},
	'Partner Name': {
		translation: 'Partner Name',
	},
	Partners: {
		translation: 'Partners',
	},
	"Party's Over!": {
		translation: "Party's Over!",
	},
	'Party’s over! There are no matching employees.': {
		translation: 'Party’s over! There are no matching employees.',
	},
	Passport: {
		translation: 'Passport',
	},
	'Passport ': {
		translation: 'Passport ',
	},
	'Passport Issuing Country': {
		translation: 'Passport Issuing Country',
	},
	'Passport Number': {
		translation: 'Passport Number',
	},
	'Passport Number can not be longer than 20 characters': {
		translation: 'Passport Number can not be longer than 20 characters',
	},
	'Passport: Expiry Date': {
		translation: 'Passport: Expiry Date',
	},
	'Passport: Issued Date': {
		translation: 'Passport: Issued Date',
	},
	Passports: {
		translation: 'Passports',
	},
	Password: {
		translation: 'Password',
	},
	'Password Challenge Question Responses': {
		translation: 'Password Challenge Question Responses',
	},
	'Password Requirements': {
		translation: 'Password Requirements',
	},
	'Password Requirements:': {
		translation: 'Password Requirements:',
	},
	'Password recovery link expired.': {
		translation: 'Password recovery link expired.',
	},
	'Password reset email was sent to %1$s': {
		translation: 'Password reset email was sent to %1$s',
	},
	"Passwords can not be changed when testing another user's account": {
		translation:
			"Passwords can not be changed when testing another user's account",
	},
	'Passwords can not be changed. Email and password login is disabled': {
		translation:
			'Passwords can not be changed. Email and password login is disabled',
	},
	'Passwords match': {
		translation: 'Passwords match',
	},
	'Passwords must be 8 characters with one number, one uppercase letter, and one lowercase letter.':
		{
			translation:
				'Passwords must be 8 characters with one number, one uppercase letter, and one lowercase letter.',
		},
	'Past Announcements': {
		translation: 'Past Announcements',
	},
	'Past Due': {
		translation: 'Past Due',
	},
	'Past Due.': {
		translation: 'Past Due.',
	},
	'Past due! Hurry though, you can still choose people to give feedback on your team.':
		{
			translation:
				'Past due! Hurry though, you can still choose people to give feedback on your team.',
		},
	'Past due! Hurry you can still choose people to give feedback on your team.':
		{
			translation:
				'Past due! Hurry you can still choose people to give feedback on your team.',
		},
	"Paste the embed code into your site's HTML where you want your job openings displayed. (You can also send it along to your awesome web developer and let the magic happen.)":
		{
			translation:
				"Paste the embed code into your site's HTML where you want your job openings displayed. (You can also send it along to your awesome web developer and let the magic happen.)",
		},
	Pay: {
		translation: 'Pay',
	},
	'Pay Amount': {
		translation: 'Pay Amount',
	},
	'Pay Band': {
		translation: 'Pay Band',
	},
	'Pay Calendar': {
		translation: 'Pay Calendar',
	},
	'Pay Code': {
		translation: 'Pay Code',
	},
	'Pay Cycle History': {
		translation: 'Pay Cycle History',
	},
	'Pay Cycle ID': {
		translation: 'Pay Cycle ID',
	},
	'Pay Cycle(s) Included in Summary': {
		translation: 'Pay Cycle(s) Included in Summary',
	},
	'Pay Date': {
		translation: 'Pay Date',
	},
	'Pay Date:': {
		translation: 'Pay Date:',
	},
	'Pay Date: ': {
		translation: 'Pay Date: ',
	},
	'Pay Frequency': {
		translation: 'Pay Frequency',
	},
	'Pay Group': {
		translation: 'Pay Group',
	},
	'Pay Group Name': {
		translation: 'Pay Group Name',
	},
	'Pay Groups': {
		translation: 'Pay Groups',
	},
	'Pay Info': {
		translation: 'Pay Info',
	},
	'Pay Info Tab Missing Data': {
		translation: 'Pay Info Tab Missing Data',
	},
	'Pay Per Hour': {
		translation: 'Pay Per Hour',
	},
	'Pay Period': {
		translation: 'Pay Period',
	},
	'Pay Period Begins': {
		translation: 'Pay Period Begins',
	},
	'Pay Period End Date': {
		translation: 'Pay Period End Date',
	},
	'Pay Period Ends': {
		translation: 'Pay Period Ends',
	},
	'Pay Period Total': {
		translation: 'Pay Period Total',
	},
	'Pay Period:': {
		translation: 'Pay Period:',
	},
	'Pay Range': {
		translation: 'Pay Range',
	},
	'Pay Rate': {
		translation: 'Pay Rate',
	},
	'Pay Rate and Period': {
		translation: 'Pay Rate and Period',
	},
	'Pay Rate cannot be empty.': {
		translation: 'Pay Rate cannot be empty.',
	},
	'Pay Rate is required': {
		translation: 'Pay Rate is required',
	},
	'Pay Rate must be equal to or greater than 0.': {
		translation: 'Pay Rate must be equal to or greater than 0.',
	},
	'Pay Rate, Paid Per': {
		translation: 'Pay Rate, Paid Per',
	},
	'Pay Schedule': {
		translation: 'Pay Schedule',
	},
	'Pay Schedule ID': {
		translation: 'Pay Schedule ID',
	},
	'Pay Schedule Options': {
		translation: 'Pay Schedule Options',
	},
	'Pay Schedule is required': {
		translation: 'Pay Schedule is required',
	},
	'Pay Schedule is required.': {
		translation: 'Pay Schedule is required.',
	},
	'Pay Schedules': {
		translation: 'Pay Schedules',
	},
	'Pay Type': {
		translation: 'Pay Type',
	},
	'Pay Type & Exempt': {
		translation: 'Pay Type & Exempt',
	},
	'Pay Type cannot be empty.': {
		translation: 'Pay Type cannot be empty.',
	},
	'Pay Type is required': {
		translation: 'Pay Type is required',
	},
	'Pay Type is required.': {
		translation: 'Pay Type is required.',
	},
	'Pay Types': {
		translation: 'Pay Types',
	},
	'Pay by Department': {
		translation: 'Pay by Department',
	},
	'Pay by Job Title': {
		translation: 'Pay by Job Title',
	},
	'Pay by Location': {
		translation: 'Pay by Location',
	},
	'Pay concessions': {
		translation: 'Pay concessions',
	},
	'Pay date': {
		translation: 'Pay date',
	},
	'Pay date adjusted for weekend or holiday': {
		translation: 'Pay date adjusted for weekend or holiday',
	},
	'Pay date for %1$s - %2$s': {
		translation: 'Pay date for %1$s - %2$s',
	},
	'Pay date successfully updated.': {
		translation: 'Pay date successfully updated.',
	},
	'Pay dates within three days cannot be changed': {
		translation: 'Pay dates within three days cannot be changed',
	},
	'Pay days are': {
		translation: 'Pay days are',
	},
	'Pay days cannot be before the period end date': {
		translation: 'Pay days cannot be before the period end date',
	},
	'Pay days cannot be on a bank holiday': {
		translation: 'Pay days cannot be on a bank holiday',
	},
	'Pay days cannot be on a weekend': {
		translation: 'Pay days cannot be on a weekend',
	},
	'Pay experience': {
		translation: 'Pay experience',
	},
	'Pay group ID': {
		translation: 'Pay group ID',
	},
	'Pay group id': {
		translation: 'Pay group id',
	},
	'Pay group was deleted.': {
		translation: 'Pay group was deleted.',
	},
	'Pay increase': {
		translation: 'Pay increase',
	},
	'Pay on the next business day': {
		translation: 'Pay on the next business day',
	},
	'Pay on the previous business day': {
		translation: 'Pay on the previous business day',
	},
	'Pay period': {
		translation: 'Pay period',
	},
	"Pay period can't be blank": {
		translation: "Pay period can't be blank",
	},
	'Pay periods end on the...': {
		translation: 'Pay periods end on the...',
	},
	'Pay periods end on...': {
		translation: 'Pay periods end on...',
	},
	'Pay periods ends on...': {
		translation: 'Pay periods ends on...',
	},
	'Pay periods per year:': {
		translation: 'Pay periods per year:',
	},
	'Pay rate': {
		translation: 'Pay rate',
	},
	'Pay rate and paid per should not be specified for commission-only employees':
		{
			translation:
				'Pay rate and paid per should not be specified for commission-only employees',
		},
	'Pay rate and paid per should not be specified for commisson-only employees':
		{
			translation:
				'Pay rate and paid per should not be specified for commisson-only employees',
		},
	'Pay rate is required and must be 0 or greater when on a syncing pay schedule.':
		{
			translation:
				'Pay rate is required and must be 0 or greater when on a syncing pay schedule.',
		},
	'Pay rate is required and must be greater than 0 when on a syncing pay schedule.':
		{
			translation:
				'Pay rate is required and must be greater than 0 when on a syncing pay schedule.',
		},
	'Pay rate is required and must be greater than 0 when on syncing pay schedule.':
		{
			translation:
				'Pay rate is required and must be greater than 0 when on syncing pay schedule.',
		},
	'Pay rate is required and must be greater than 0.': {
		translation: 'Pay rate is required and must be greater than 0.',
	},
	'Pay rate is required.': {
		translation: 'Pay rate is required.',
	},
	"Pay rate must be USD and can't be blank": {
		translation: "Pay rate must be USD and can't be blank",
	},
	'Pay rate must be equal to or greater than 0.': {
		translation: 'Pay rate must be equal to or greater than 0.',
	},
	'Pay schedule': {
		translation: 'Pay schedule',
	},
	"Pay schedule can't be blank": {
		translation: "Pay schedule can't be blank",
	},
	'Pay schedule is required': {
		translation: 'Pay schedule is required',
	},
	'Pay schedule required': {
		translation: 'Pay schedule required',
	},
	'Pay schedules': {
		translation: 'Pay schedules',
	},
	'Pay schedules and deduction frequencies': {
		translation: 'Pay schedules and deduction frequencies',
	},
	'Pay this employee through BambooHR Payroll': {
		translation: 'Pay this employee through BambooHR Payroll',
	},
	'Pay this holiday at the holiday rate': {
		translation: 'Pay this holiday at the holiday rate',
	},
	'Pay type': {
		translation: 'Pay type',
	},
	"Pay type can't be blank ie (Hourly, Salary)": {
		translation: "Pay type can't be blank ie (Hourly, Salary)",
	},
	'Pay type must be hourly or salary': {
		translation: 'Pay type must be hourly or salary',
	},
	'Pay type must be hourly or salary to include this employee in payroll.': {
		translation:
			'Pay type must be hourly or salary to include this employee in payroll.',
	},
	'Paycheck Date': {
		translation: 'Paycheck Date',
	},
	'Paycheck Total': {
		translation: 'Paycheck Total',
	},
	'Paycheck date is not set.': {
		translation: 'Paycheck date is not set.',
	},
	Payee: {
		translation: 'Payee',
	},
	'Payee Name': {
		translation: 'Payee Name',
	},
	'Payee Name: ': {
		translation: 'Payee Name: ',
	},
	Payees: {
		translation: 'Payees',
	},
	"Payees can also be added from an employee's Pay Info tab when adding a new non-benefit deduction":
		{
			translation:
				"Payees can also be added from an employee's Pay Info tab when adding a new non-benefit deduction",
		},
	Payer: {
		translation: 'Payer',
	},
	'Payment Information': {
		translation: 'Payment Information',
	},
	'Payments may take up to 12 hours to show up here.': {
		translation: 'Payments may take up to 12 hours to show up here.',
	},
	Payroll: {
		translation: 'Payroll',
	},
	'Payroll Admin': {
		translation: 'Payroll Admin',
	},
	'Payroll Admin (Non-Approver)': {
		translation: 'Payroll Admin (Non-Approver)',
	},
	'Payroll Admin Access Level': {
		translation: 'Payroll Admin Access Level',
	},
	'Payroll Admin Employee Access Level': {
		translation: 'Payroll Admin Employee Access Level',
	},
	'Payroll Admin Settings': {
		translation: 'Payroll Admin Settings',
	},
	'Payroll Admin or Manager for User': {
		translation: 'Payroll Admin or Manager for User',
	},
	'Payroll Admins have full access to payroll-related employee information and functions in BambooHR. This includes running payroll, approving timesheets, and updating employee information.':
		{
			translation:
				'Payroll Admins have full access to payroll-related employee information and functions in BambooHR. This includes running payroll, approving timesheets, and updating employee information.',
		},
	'Payroll Change': {
		translation: 'Payroll Change',
	},
	'Payroll Change Report': {
		translation: 'Payroll Change Report',
	},
	'Payroll Changes': {
		translation: 'Payroll Changes',
	},
	'Payroll Changes as of %1$s for %2$s': {
		translation: 'Payroll Changes as of %1$s for %2$s',
	},
	'Payroll Changes as of %s for %s': {
		translation: 'Payroll Changes as of %s for %s',
	},
	'Payroll Company Access': {
		translation: 'Payroll Company Access',
	},
	'Payroll Contact': {
		translation: 'Payroll Contact',
	},
	'Payroll Deduction': {
		translation: 'Payroll Deduction',
	},
	'Payroll Deduction Schedule': {
		translation: 'Payroll Deduction Schedule',
	},
	'Payroll Deductions Summary': {
		translation: 'Payroll Deductions Summary',
	},
	'Payroll Enrollment Group': {
		translation: 'Payroll Enrollment Group',
	},
	'Payroll Forms': {
		translation: 'Payroll Forms',
	},
	'Payroll Hours': {
		translation: 'Payroll Hours',
	},
	'Payroll Hours Detail': {
		translation: 'Payroll Hours Detail',
	},
	'Payroll Info Checkup': {
		translation: 'Payroll Info Checkup',
	},
	'Payroll Information': {
		translation: 'Payroll Information',
	},
	'Payroll Management': {
		translation: 'Payroll Management',
	},
	'Payroll Reports Only': {
		translation: 'Payroll Reports Only',
	},
	'Payroll Settings': {
		translation: 'Payroll Settings',
	},
	'Payroll Setup Tour': {
		translation: 'Payroll Setup Tour',
	},
	'Payroll Summary': {
		translation: 'Payroll Summary',
	},
	'Payroll Summary Report': {
		translation: 'Payroll Summary Report',
	},
	'Payroll Synced must be a boolean string value (yes/no, true/false)': {
		translation:
			'Payroll Synced must be a boolean string value (yes/no, true/false)',
	},
	'Payroll System': {
		translation: 'Payroll System',
	},
	'Payroll Tools': {
		translation: 'Payroll Tools',
	},
	'Payroll Update Summary': {
		translation: 'Payroll Update Summary',
	},
	'Payroll and benefits designed for modern businesses.<p></p><b>We do the heavy lifting</b></p>From filing all local, state, and federal payroll taxes to sending employee paystubs and W-2s, we’ve got you covered.</p><p></p><b>Everything under one roof</b></p>Payroll that integrates with benefits and workers’ comp so you can manage everything in one place.</p><p></p><b>World-class customer care</b></p><p>Our US-based care team of payroll and benefits experts are available by phone and email.</p>':
		{
			translation:
				'Payroll and benefits designed for modern businesses.<p></p><b>We do the heavy lifting</b></p>From filing all local, state, and federal payroll taxes to sending employee paystubs and W-2s, we’ve got you covered.</p><p></p><b>Everything under one roof</b></p>Payroll that integrates with benefits and workers’ comp so you can manage everything in one place.</p><p></p><b>World-class customer care</b></p><p>Our US-based care team of payroll and benefits experts are available by phone and email.</p>',
		},
	'Payroll due': {
		translation: 'Payroll due',
	},
	'Payroll will not be able to run for this user unless they have a valid Social Security Number.':
		{
			translation:
				'Payroll will not be able to run for this user unless they have a valid Social Security Number.',
		},
	Pays: {
		translation: 'Pays',
	},
	'Payscale Initialed': {
		translation: 'Payscale Initialed',
	},
	Paystub: {
		translation: 'Paystub',
	},
	'Paystub Detail': {
		translation: 'Paystub Detail',
	},
	'Paystub Detail Table': {
		translation: 'Paystub Detail Table',
	},
	'Paystub detail table': {
		translation: 'Paystub detail table',
	},
	'Paystub history table': {
		translation: 'Paystub history table',
	},
	Paystubs: {
		translation: 'Paystubs',
	},
	'Paystubs across': {
		translation: 'Paystubs across',
	},
	'Paystubs, pay history, direct deposit and W-4 information': {
		translation: 'Paystubs, pay history, direct deposit and W-4 information',
	},
	'Peek at the table below and match up the field names with the correct data from your file. Please check a few employees to make sure everything is lined up':
		{
			translation:
				'Peek at the table below and match up the field names with the correct data from your file. Please check a few employees to make sure everything is lined up',
		},
	'Peek at the table below and match up the field names with the correct data from your file. Please check a few employees to make sure everything is lined up.':
		{
			translation:
				'Peek at the table below and match up the field names with the correct data from your file. Please check a few employees to make sure everything is lined up.',
		},
	'Peer Feedback': {
		translation: 'Peer Feedback',
	},
	'Peer Feedback Schedule': {
		translation: 'Peer Feedback Schedule',
	},
	'Peer Feedback Status': {
		translation: 'Peer Feedback Status',
	},
	'Peer Feedback enabled': {
		translation: 'Peer Feedback enabled',
	},
	'Peer Feedback is Disabled For %1': {
		translation: 'Peer Feedback is Disabled For %1',
	},
	'Peer Feedback requests will be sent out on %1': {
		translation: 'Peer Feedback requests will be sent out on %1',
	},
	'Peer feedback will be triggered immediately upon confirmation. The timeline will be reset and subsequent peer feedback events will be rescheduled. Are you sure you want to trigger peer feedback for this customer?':
		{
			translation:
				'Peer feedback will be triggered immediately upon confirmation. The timeline will be reset and subsequent peer feedback events will be rescheduled. Are you sure you want to trigger peer feedback for this customer?',
		},
	'Peer feedback will happen every %1 months.': {
		translation: 'Peer feedback will happen every %1 months.',
	},
	'Peer feedback will happen every 3 months.': {
		translation: 'Peer feedback will happen every 3 months.',
	},
	Pending: {
		translation: 'Pending',
	},
	'Pending - Sign and upload your bank account authorization forms': {
		translation:
			'Pending - Sign and upload your bank account authorization forms',
	},
	'Pending - Sign and upload your company payroll forms': {
		translation: 'Pending - Sign and upload your company payroll forms',
	},
	'Pending - Verifying deposit amount': {
		translation: 'Pending - Verifying deposit amount',
	},
	'Pending Approval': {
		translation: 'Pending Approval',
	},
	'Pending approval': {
		translation: 'Pending approval',
	},
	'Pending step': {
		translation: 'Pending step',
	},
	'Pension plan (post-tax)': {
		translation: 'Pension plan (post-tax)',
	},
	'Pension plan (pre-tax)': {
		translation: 'Pension plan (pre-tax)',
	},
	People: {
		translation: 'People',
	},
	'People Without a Pay Raise': {
		translation: 'People Without a Pay Raise',
	},
	'People are still clocked in': {
		translation: 'People are still clocked in',
	},
	'People are still enrolled': {
		translation: 'People are still enrolled',
	},
	'People on %1 (%2)': {
		translation: 'People on %1 (%2)',
	},
	'People will see this name when requesting time off for the policies in this Category.':
		{
			translation:
				'People will see this name when requesting time off for the policies in this Category.',
		},
	'People you share this report with will see all eNPS data': {
		translation: 'People you share this report with will see all eNPS data',
	},
	Per: {
		translation: 'Per',
	},
	'Per Month': {
		translation: 'Per Month',
	},
	'Per Pay Period': {
		translation: 'Per Pay Period',
	},
	'Per hour worked': {
		translation: 'Per hour worked',
	},
	'Per pay period': {
		translation: 'Per pay period',
	},
	Percent: {
		translation: 'Percent',
	},
	'Percent Allocation': {
		translation: 'Percent Allocation',
	},
	'Percent Cap': {
		translation: 'Percent Cap',
	},
	'Percent State': {
		translation: 'Percent State',
	},
	Percentage: {
		translation: 'Percentage',
	},
	Performance: {
		translation: 'Performance',
	},
	'Performance Assessments enabled': {
		translation: 'Performance Assessments enabled',
	},
	'Performance Comments': {
		translation: 'Performance Comments',
	},
	'Performance Data': {
		translation: 'Performance Data',
	},
	'Performance Engagement': {
		translation: 'Performance Engagement',
	},
	'Performance Goals': {
		translation: 'Performance Goals',
	},
	'Performance Management': {
		translation: 'Performance Management',
	},
	'Performance Management (including Goals) enabled': {
		translation: 'Performance Management (including Goals) enabled',
	},
	'Performance Management enabled': {
		translation: 'Performance Management enabled',
	},
	'Performance Pro is designed by HR professionals, for companies that require a user-friendly, centralized online solution to streamline and improve employee development and bottom line company performance. Save time, increase productivity, and eliminate hassles when administering employee performance reviews.':
		{
			translation:
				'Performance Pro is designed by HR professionals, for companies that require a user-friendly, centralized online solution to streamline and improve employee development and bottom line company performance. Save time, increase productivity, and eliminate hassles when administering employee performance reviews.',
		},
	'Performance Review 1st Quarter Rating': {
		translation: 'Performance Review 1st Quarter Rating',
	},
	'Performance Review 2nd Quarter Rating': {
		translation: 'Performance Review 2nd Quarter Rating',
	},
	'Performance Review 3rd Quarter Rating': {
		translation: 'Performance Review 3rd Quarter Rating',
	},
	'Performance Review 4th Quarter Rating': {
		translation: 'Performance Review 4th Quarter Rating',
	},
	'Performance Review Due': {
		translation: 'Performance Review Due',
	},
	'Performance Review Settings have been successfully updated.': {
		translation: 'Performance Review Settings have been successfully updated.',
	},
	'Performance Reviews': {
		translation: 'Performance Reviews',
	},
	'Performance Settings': {
		translation: 'Performance Settings',
	},
	'Performance Setup': {
		translation: 'Performance Setup',
	},
	'Performance Timeline Preview': {
		translation: 'Performance Timeline Preview',
	},
	'Performance Value': {
		translation: 'Performance Value',
	},
	'Performance and Culture': {
		translation: 'Performance and Culture',
	},
	'Performance is Disabled For %1': {
		translation: 'Performance is Disabled For %1',
	},
	'Performance reviews': {
		translation: 'Performance reviews',
	},
	'Performance reviews are broken. At least, they were. We fixed a few things like huge time commitments, weak results, and infrequency. Then we added meaningful feedback and better ways to measure performance and engagement. The result? Innovative (dare we say, enjoyable?) employee performance management.':
		{
			translation:
				'Performance reviews are broken. At least, they were. We fixed a few things like huge time commitments, weak results, and infrequency. Then we added meaningful feedback and better ways to measure performance and engagement. The result? Innovative (dare we say, enjoyable?) employee performance management.',
		},
	'Performance reviews are broken. At least, they were. We fixed a few things like huge time commitments, weak results, and infrequency. Then we added meaningful feedback and better ways to measure performance and engagement. The result? Innovative (dare we say, enjoyable?) performance management.':
		{
			translation:
				'Performance reviews are broken. At least, they were. We fixed a few things like huge time commitments, weak results, and infrequency. Then we added meaningful feedback and better ways to measure performance and engagement. The result? Innovative (dare we say, enjoyable?) performance management.',
		},
	'Performance settings have been successfully saved.': {
		translation: 'Performance settings have been successfully saved.',
	},
	Period: {
		translation: 'Period',
	},
	'Period End': {
		translation: 'Period End',
	},
	'Period Ends': {
		translation: 'Period Ends',
	},
	'Period Start': {
		translation: 'Period Start',
	},
	'Permanent Resident': {
		translation: 'Permanent Resident',
	},
	'Permission Denied': {
		translation: 'Permission Denied',
	},
	'Permission Groups': {
		translation: 'Permission Groups',
	},
	'Permission Groups - %1$s': {
		translation: 'Permission Groups - %1$s',
	},
	'Permission denied': {
		translation: 'Permission denied',
	},
	'Permission failed': {
		translation: 'Permission failed',
	},
	Permissioned: {
		translation: 'Permissioned',
	},
	Permissions: {
		translation: 'Permissions',
	},
	'Permissions for %s have been changed to "%s"': {
		translation: 'Permissions for %s have been changed to \\"%s\\"',
	},
	'Permissions for %s have been changed to "%s" and "%s"': {
		translation:
			'Permissions for %s have been changed to \\"%s\\" and \\"%s\\"',
	},
	'Permissions for %s have been changed to "%s", "%s" and %s more groups.': {
		translation:
			'Permissions for %s have been changed to \\"%s\\", \\"%s\\" and %s more groups.',
	},
	'Permissions for %s have been changed to "%s", "%s" and 1 more group.': {
		translation:
			'Permissions for %s have been changed to \\"%s\\", \\"%s\\" and 1 more group.',
	},
	'Persistent Access': {
		translation: 'Persistent Access',
	},
	Personal: {
		translation: 'Personal',
	},
	'Personal Acct #': {
		translation: 'Personal Acct #',
	},
	'Personal Bank Name': {
		translation: 'Personal Bank Name',
	},
	'Personal Data may be included in your inputs and outputs.': {
		translation: 'Personal Data may be included in your inputs and outputs.',
	},
	'Personal Email Address': {
		translation: 'Personal Email Address',
	},
	'Personal Feed': {
		translation: 'Personal Feed',
	},
	'Personal Info': {
		translation: 'Personal Info',
	},
	'Personal Information': {
		translation: 'Personal Information',
	},
	'Personal Motivators': {
		translation: 'Personal Motivators',
	},
	'Personal Routing #': {
		translation: 'Personal Routing #',
	},
	'Personal Time': {
		translation: 'Personal Time',
	},
	'Personal Time (10-month salary)': {
		translation: 'Personal Time (10-month salary)',
	},
	'Personal Time (11-month salary)': {
		translation: 'Personal Time (11-month salary)',
	},
	'Personal Time (12-month salary)': {
		translation: 'Personal Time (12-month salary)',
	},
	'Personal Trainer License': {
		translation: 'Personal Trainer License',
	},
	'Personalized payroll system setup and configuration': {
		translation: 'Personalized payroll system setup and configuration',
	},
	'Pfizer-BioNTech': {
		translation: 'Pfizer-BioNTech',
	},
	'Phew, we made it!': {
		translation: 'Phew, we made it!',
	},
	'Philosophical Beliefs': {
		translation: 'Philosophical Beliefs',
	},
	Phone: {
		translation: 'Phone',
	},
	'Phone Number': {
		translation: 'Phone Number',
	},
	'Phone Number (this is entered into the Home Phone field of BambooHR)': {
		translation:
			'Phone Number (this is entered into the Home Phone field of BambooHR)',
	},
	'Phone Screened': {
		translation: 'Phone Screened',
	},
	'Phone Support': {
		translation: 'Phone Support',
	},
	'Phone number': {
		translation: 'Phone number',
	},
	'Phone, Email & Chat': {
		translation: 'Phone, Email & Chat',
	},
	Photo: {
		translation: 'Photo',
	},
	'Photo successfully removed': {
		translation: 'Photo successfully removed',
	},
	'Physical Address': {
		translation: 'Physical Address',
	},
	'Pick a date.': {
		translation: 'Pick a date.',
	},
	'Pick a date. The current value is %1$s.': {
		translation: 'Pick a date. The current value is %1$s.',
	},
	Piece: {
		translation: 'Piece',
	},
	'Piece rate': {
		translation: 'Piece rate',
	},
	'Pin to top': {
		translation: 'Pin to top',
	},
	Pinterest: {
		translation: 'Pinterest',
	},
	'Pinterest URL': {
		translation: 'Pinterest URL',
	},
	'Place of Birth': {
		translation: 'Place of Birth',
	},
	'Placeholder Removed...': {
		translation: 'Placeholder Removed...',
	},
	'Placement for adoption': {
		translation: 'Placement for adoption',
	},
	Plan: {
		translation: 'Plan',
	},
	'Plan %s saved successfully': {
		translation: 'Plan %s saved successfully',
	},
	'Plan Access': {
		translation: 'Plan Access',
	},
	'Plan Category': {
		translation: 'Plan Category',
	},
	'Plan Costs': {
		translation: 'Plan Costs',
	},
	'Plan Coverages': {
		translation: 'Plan Coverages',
	},
	'Plan Details': {
		translation: 'Plan Details',
	},
	'Plan End Date': {
		translation: 'Plan End Date',
	},
	'Plan Ended': {
		translation: 'Plan Ended',
	},
	'Plan Ends': {
		translation: 'Plan Ends',
	},
	'Plan Expired': {
		translation: 'Plan Expired',
	},
	'Plan Expired for %s': {
		translation: 'Plan Expired for %s',
	},
	'Plan Expired for %s on %s': {
		translation: 'Plan Expired for %s on %s',
	},
	'Plan Name': {
		translation: 'Plan Name',
	},
	'Plan Start Date': {
		translation: 'Plan Start Date',
	},
	'Plan Starts': {
		translation: 'Plan Starts',
	},
	'Plan Status': {
		translation: 'Plan Status',
	},
	'Plan Type': {
		translation: 'Plan Type',
	},
	'Plan Type ID': {
		translation: 'Plan Type ID',
	},
	'Plan URL': {
		translation: 'Plan URL',
	},
	'Plan Year Election Summary': {
		translation: 'Plan Year Election Summary',
	},
	'Plan currently disabled': {
		translation: 'Plan currently disabled',
	},
	'Plan deleted successfully': {
		translation: 'Plan deleted successfully',
	},
	'Plan end date': {
		translation: 'Plan end date',
	},
	'Plan start date': {
		translation: 'Plan start date',
	},
	'Plan with ID of %1$d does not exist!': {
		translation: 'Plan with ID of %1$d does not exist!',
	},
	'Plan/Deduction Name': {
		translation: 'Plan/Deduction Name',
	},
	'Plan/Deduction Type': {
		translation: 'Plan/Deduction Type',
	},
	'PlanSource is dedicated to getting you pumped up and prepared to take full advantage of everything our solution has to offer. Our customers and partners can get training in many ways: recorded sessions, webinars, videos and GuideMe On-Demand Learning. GuideMe features on-demand training and self-paced walkthroughs for HR administrators built directly into the PlanSource experience. GuideMe appears as a constant, unobtrusive widget in the PlanSource system, acting as a tutor for benefit administrators. GuideMe also offers field-level help, feature notifications, powerful search tools, videos and other resources. GuideMe speeds up the learning curve, making onboarding new administrators quick and efficient.':
		{
			translation:
				'PlanSource is dedicated to getting you pumped up and prepared to take full advantage of everything our solution has to offer. Our customers and partners can get training in many ways: recorded sessions, webinars, videos and GuideMe On-Demand Learning. GuideMe features on-demand training and self-paced walkthroughs for HR administrators built directly into the PlanSource experience. GuideMe appears as a constant, unobtrusive widget in the PlanSource system, acting as a tutor for benefit administrators. GuideMe also offers field-level help, feature notifications, powerful search tools, videos and other resources. GuideMe speeds up the learning curve, making onboarding new administrators quick and efficient.',
		},
	Plans: {
		translation: 'Plans',
	},
	'Plans visible on BambooHR.com': {
		translation: 'Plans visible on BambooHR.com',
	},
	'Plansource RelayState': {
		translation: 'Plansource RelayState',
	},
	Platform: {
		translation: 'Platform',
	},
	Playground: {
		translation: 'Playground',
	},
	"Please <span class='bold'> select %s job opening to remove.</span>": {
		translation: {
			one: "Please <span class='bold'> select %s job opening to remove.</span>",
			other:
				"Please <span class='bold'> select %s job openings to remove.</span>",
		},
	},
	'Please Arrive by...': {
		translation: 'Please Arrive by...',
	},
	'Please Choose A Time Off Type': {
		translation: 'Please Choose A Time Off Type',
	},
	'Please Choose A Valid Date Range': {
		translation: 'Please Choose A Valid Date Range',
	},
	'Please Provide Feedback about': {
		translation: 'Please Provide Feedback about',
	},
	'Please Provide Feedback about %s': {
		translation: 'Please Provide Feedback about %s',
	},
	'Please Review these Documents': {
		translation: 'Please Review these Documents',
	},
	'Please accept the the terms of service to continue.': {
		translation: 'Please accept the the terms of service to continue.',
	},
	'Please add a term to be searched': {
		translation: 'Please add a term to be searched',
	},
	'Please add a valid folder name': {
		translation: 'Please add a valid folder name',
	},
	'Please add additional info...': {
		translation: 'Please add additional info...',
	},
	"Please add any office locations you may have, or add 'off-site' if you'd like.  This will be very helpful to you as will be able to run your reports based on location.":
		{
			translation:
				"Please add any office locations you may have, or add 'off-site' if you'd like.  This will be very helpful to you as will be able to run your reports based on location.",
		},
	'Please add the information listed below before adding tasks.': {
		translation: 'Please add the information listed below before adding tasks.',
	},
	"Please answer the following questions and we'll send out a quick introduction email to the people you'll be working with.":
		{
			translation:
				"Please answer the following questions and we'll send out a quick introduction email to the people you'll be working with.",
		},
	'Please be sure to complete these updates by *{1}*.': {
		translation: 'Please be sure to complete these updates by *{1}*.',
	},
	'Please be sure to look for the next opportunity to answer the survey.': {
		translation:
			'Please be sure to look for the next opportunity to answer the survey.',
	},
	'Please be sure to select who can make this type of request.': {
		translation: 'Please be sure to select who can make this type of request.',
	},
	'Please change your filter and try again.': {
		translation: 'Please change your filter and try again.',
	},
	'Please check and make sure your anniversary reminders are within one year': {
		translation:
			'Please check and make sure your anniversary reminders are within one year',
	},
	'Please check back as we will most certainly be looking': {
		translation: 'Please check back as we will most certainly be looking',
	},
	'Please check back as we will most certainly be looking for great people to join our team in the future.':
		{
			translation:
				'Please check back as we will most certainly be looking for great people to join our team in the future.',
		},
	'Please check that the candidate’s email address is valid.': {
		translation: 'Please check that the candidate’s email address is valid.',
	},
	"Please check this box when you're all set, just so we know we're all on the same page":
		{
			translation:
				"Please check this box when you're all set, just so we know we're all on the same page",
		},
	'Please check with your BambooHR Administrator or ': {
		translation: 'Please check with your BambooHR Administrator or ',
	},
	'Please choose a Compensation Effective Date at least two days after the start of the previous entry.':
		{
			translation:
				'Please choose a Compensation Effective Date at least two days after the start of the previous entry.',
		},
	'Please choose a completion date between %1$s and today.': {
		translation: 'Please choose a completion date between %1$s and today.',
	},
	'Please choose a date at least two days after the start of the previous entry.':
		{
			translation:
				'Please choose a date at least two days after the start of the previous entry.',
		},
	'Please choose a different peer to provide feedback.': {
		translation: 'Please choose a different peer to provide feedback.',
	},
	'Please choose a different person to provide feedback.': {
		translation: 'Please choose a different person to provide feedback.',
	},
	'Please choose a due date in order to send a notification on or before the due date.':
		{
			translation:
				'Please choose a due date in order to send a notification on or before the due date.',
		},
	'Please choose a new hiring lead:': {
		translation: 'Please choose a new hiring lead:',
	},
	'Please choose a valid number for the Assignment Notification "days before the due date" value.':
		{
			translation:
				'Please choose a valid number for the Assignment Notification \\"days before the due date\\" value.',
		},
	'Please choose an option for allowing employee document uploads': {
		translation:
			'Please choose an option for allowing employee document uploads',
	},
	'Please choose at least one document to be signed.': {
		translation: 'Please choose at least one document to be signed.',
	},
	'Please choose at least one form to sign': {
		translation: 'Please choose at least one form to sign',
	},
	'Please choose at least one recipient': {
		translation: 'Please choose at least one recipient',
	},
	'Please click the confirmation button in the email to continue.': {
		translation:
			'Please click the confirmation button in the email to continue.',
	},
	'Please complete all tasks before continuing.': {
		translation: 'Please complete all tasks before continuing.',
	},
	'Please complete by': {
		translation: 'Please complete by',
	},
	'Please complete the following new employee form and add your profile photo.':
		{
			translation:
				'Please complete the following new employee form and add your profile photo.',
		},
	"Please complete the following tasks and we'll be able to get you up and running quickly.":
		{
			translation:
				"Please complete the following tasks and we'll be able to get you up and running quickly.",
		},
	"Please complete the tasks below and we'll be able to get you up and running quickly.":
		{
			translation:
				"Please complete the tasks below and we'll be able to get you up and running quickly.",
		},
	'Please complete your assessment by': {
		translation: 'Please complete your assessment by',
	},
	'Please contact BambooHR\'s Customer Service Department at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a> or by calling 1-866-387-9595.':
		{
			translation:
				'Please contact BambooHR\'s Customer Service Department at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a> or by calling 1-866-387-9595.',
		},
	"Please contact BambooHR's Customer Service Department at support@bamboohr.com or by calling 1-866-387-9595.":
		{
			translation:
				"Please contact BambooHR's Customer Service Department at support@bamboohr.com or by calling 1-866-387-9595.",
		},
	'Please contact BambooHR\'s Customer Service Department at support@bamboohr.com or by calling 1-866-387-9595. To learn more about Newton and to setup an account, please <a href="http://hr.bamboohr.com/newton-referral/">click here</a>':
		{
			translation:
				'Please contact BambooHR\'s Customer Service Department at support@bamboohr.com or by calling 1-866-387-9595. To learn more about Newton and to setup an account, please <a href=\\"http://hr.bamboohr.com/newton-referral/\\">click here</a>',
		},
	'Please contact the BambooHR Customer Service Department to enable the integration. BambooHR will work directly with Jobvite to sync the two systems together. Please allow up to 48 hours for the setup to be completed. To learn more about Jobvite and to setup an account, please <a href="http://hr.bamboohr.com/jobvite-referral/">click here</a>':
		{
			translation:
				'Please contact the BambooHR Customer Service Department to enable the integration. BambooHR will work directly with Jobvite to sync the two systems together. Please allow up to 48 hours for the setup to be completed. To learn more about Jobvite and to setup an account, please <a href=\\"http://hr.bamboohr.com/jobvite-referral/\\">click here</a>',
		},
	"Please contact the BambooHR support team at <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or call 1-866-387-9595 to enable this app.":
		{
			translation:
				"Please contact the BambooHR support team at <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or call 1-866-387-9595 to enable this app.",
		},
	'Please contact your Jobvite representative for additional information.': {
		translation:
			'Please contact your Jobvite representative for additional information.',
	},
	'Please contact your account owner, %s, to uninstall this integration.': {
		translation:
			'Please contact your account owner, %s, to uninstall this integration.',
	},
	"Please contact your company's BambooHR Administrator.": {
		translation: "Please contact your company's BambooHR Administrator.",
	},
	'Please contact your payroll rep if you have any questions.': {
		translation: 'Please contact your payroll rep if you have any questions.',
	},
	'Please correct the following: SSO Login URL and x.509 Certificate.': {
		translation:
			'Please correct the following: SSO Login URL and x.509 Certificate.',
	},
	'Please correct the following: SSO Login URL.': {
		translation: 'Please correct the following: SSO Login URL.',
	},
	'Please correct the following: x.509 Certificate.': {
		translation: 'Please correct the following: x.509 Certificate.',
	},
	'Please double check to ensure that the Pay Type matches the Paid Per selection.':
		{
			translation:
				'Please double check to ensure that the Pay Type matches the Paid Per selection.',
		},
	'Please double check to ensure that the pay type matches the paid per selection.':
		{
			translation:
				'Please double check to ensure that the pay type matches the paid per selection.',
		},
	'Please email [payrollimp@bamboohr.com] and we will help you complete your bank account verification.':
		{
			translation:
				'Please email [payrollimp@bamboohr.com] and we will help you complete your bank account verification.',
		},
	'Please email our support team at payrollhelp@bamboohr.com and they will be happy to help you get your bank account set up.':
		{
			translation:
				'Please email our support team at payrollhelp@bamboohr.com and they will be happy to help you get your bank account set up.',
		},
	'Please ensure this user has valid dates in the job and employment status history tables before adding them to this pay schedule.':
		{
			translation:
				'Please ensure this user has valid dates in the job and employment status history tables before adding them to this pay schedule.',
		},
	'Please enter a BeneTrac status': {
		translation: 'Please enter a BeneTrac status',
	},
	'Please enter a Subject': {
		translation: 'Please enter a Subject',
	},
	'Please enter a category name.': {
		translation: 'Please enter a category name.',
	},
	'Please enter a comment': {
		translation: 'Please enter a comment',
	},
	'Please enter a comment with your file attachment': {
		translation: 'Please enter a comment with your file attachment',
	},
	'Please enter a company code and pay periods per year': {
		translation: 'Please enter a company code and pay periods per year',
	},
	'Please enter a date in the format: "%s"': {
		translation: 'Please enter a date in the format: \\"%s\\"',
	},
	'Please enter a first name': {
		translation: 'Please enter a first name',
	},
	'Please enter a last name': {
		translation: 'Please enter a last name',
	},
	'Please enter a message body for this announcement.': {
		translation: 'Please enter a message body for this announcement.',
	},
	'Please enter a name for the applicant status': {
		translation: 'Please enter a name for the applicant status',
	},
	'Please enter a name for the new applicant status': {
		translation: 'Please enter a name for the new applicant status',
	},
	'Please enter a name for the new category.': {
		translation: 'Please enter a name for the new category.',
	},
	'Please enter a name for the new item': {
		translation: 'Please enter a name for the new item',
	},
	'Please enter a name for the new list.': {
		translation: 'Please enter a name for the new list.',
	},
	'Please enter a name for the report': {
		translation: 'Please enter a name for the report',
	},
	'Please enter a name for the time off type': {
		translation: 'Please enter a name for the time off type',
	},
	'Please enter a name for this alert': {
		translation: 'Please enter a name for this alert',
	},
	'Please enter a name for this alert.': {
		translation: 'Please enter a name for this alert.',
	},
	'Please enter a name for this file.': {
		translation: 'Please enter a name for this file.',
	},
	'Please enter a name for this folder.': {
		translation: 'Please enter a name for this folder.',
	},
	'Please enter a name for this item.': {
		translation: 'Please enter a name for this item.',
	},
	'Please enter a name for your custom site address': {
		translation: 'Please enter a name for your custom site address',
	},
	'Please enter a name.': {
		translation: 'Please enter a name.',
	},
	'Please enter a new name for the category': {
		translation: 'Please enter a new name for the category',
	},
	'Please enter a new name for the category.': {
		translation: 'Please enter a new name for the category.',
	},
	'Please enter a new name for the link': {
		translation: 'Please enter a new name for the link',
	},
	'Please enter a new name for the link.': {
		translation: 'Please enter a new name for the link.',
	},
	'Please enter a password': {
		translation: 'Please enter a password',
	},
	'Please enter a password.': {
		translation: 'Please enter a password.',
	},
	'Please enter a positive whole number for the interval.': {
		translation: 'Please enter a positive whole number for the interval.',
	},
	'Please enter a review date.': {
		translation: 'Please enter a review date.',
	},
	'Please enter a start date for this compensation level.': {
		translation: 'Please enter a start date for this compensation level.',
	},
	'Please enter a tasklist name.': {
		translation: 'Please enter a tasklist name.',
	},
	'Please enter a valid BeneTrac status': {
		translation: 'Please enter a valid BeneTrac status',
	},
	'Please enter a valid HTTPS URL.': {
		translation: 'Please enter a valid HTTPS URL.',
	},
	'Please enter a valid LinkedIn url': {
		translation: 'Please enter a valid LinkedIn url',
	},
	'Please enter a valid SSN': {
		translation: 'Please enter a valid SSN',
	},
	'Please enter a valid URL starting with http://': {
		translation: 'Please enter a valid URL starting with http://',
	},
	'Please enter a valid URL.': {
		translation: 'Please enter a valid URL.',
	},
	'Please enter a valid US Zip code.': {
		translation: 'Please enter a valid US Zip code.',
	},
	'Please enter a valid birth date': {
		translation: 'Please enter a valid birth date',
	},
	'Please enter a valid credit card number.': {
		translation: 'Please enter a valid credit card number.',
	},
	'Please enter a valid date': {
		translation: 'Please enter a valid date',
	},
	'Please enter a valid date (ISO).': {
		translation: 'Please enter a valid date (ISO).',
	},
	'Please enter a valid date.': {
		translation: 'Please enter a valid date.',
	},
	'Please enter a valid effective date': {
		translation: 'Please enter a valid effective date',
	},
	'Please enter a valid email address.': {
		translation: 'Please enter a valid email address.',
	},
	'Please enter a valid folder name.': {
		translation: 'Please enter a valid folder name.',
	},
	'Please enter a valid hire date': {
		translation: 'Please enter a valid hire date',
	},
	'Please enter a valid number or remove any leading zeros.': {
		translation: 'Please enter a valid number or remove any leading zeros.',
	},
	'Please enter a valid number.': {
		translation: 'Please enter a valid number.',
	},
	'Please enter a valid time of day, of the form 12:00am, or select a time from the dropdown.':
		{
			translation:
				'Please enter a valid time of day, of the form 12:00am, or select a time from the dropdown.',
		},
	'Please enter a valid work or home email for this employee before resetting the password.':
		{
			translation:
				'Please enter a valid work or home email for this employee before resetting the password.',
		},
	'Please enter a valid zip code. For users paid by TRAX Payroll, zip codes can be formatted as (#####) or (#####-####).':
		{
			translation:
				'Please enter a valid zip code. For users paid by TRAX Payroll, zip codes can be formatted as (#####) or (#####-####).',
		},
	'Please enter a valid zip code. Zip codes can be formatted as (#####) or (#####-####).':
		{
			translation:
				'Please enter a valid zip code. Zip codes can be formatted as (#####) or (#####-####).',
		},
	'Please enter a value for %s.': {
		translation: 'Please enter a value for %s.',
	},
	'Please enter a value greater than or equal to %s.': {
		translation: 'Please enter a value greater than or equal to %s.',
	},
	'Please enter a value less than or equal to %s.': {
		translation: 'Please enter a value less than or equal to %s.',
	},
	'Please enter a value with a valid extension.': {
		translation: 'Please enter a value with a valid extension.',
	},
	'Please enter a value with only alphabetic characters.': {
		translation: 'Please enter a value with only alphabetic characters.',
	},
	'Please enter all required fields.': {
		translation: 'Please enter all required fields.',
	},
	'Please enter an URL for this webhook to post to.': {
		translation: 'Please enter an URL for this webhook to post to.',
	},
	'Please enter an email address': {
		translation: 'Please enter an email address',
	},
	'Please enter an employment status': {
		translation: 'Please enter an employment status',
	},
	'Please enter at least %1 characters.': {
		translation: 'Please enter at least %1 characters.',
	},
	'Please enter at least %s characters.': {
		translation: 'Please enter at least %s characters.',
	},
	'Please enter at least one value to be updated': {
		translation: 'Please enter at least one value to be updated',
	},
	'Please enter at least one value to be updated.': {
		translation: 'Please enter at least one value to be updated.',
	},
	'Please enter brief a description of the event in the "what" field': {
		translation:
			'Please enter brief a description of the event in the \\"what\\" field',
	},
	'Please enter no more than %1 characters.': {
		translation: 'Please enter no more than %1 characters.',
	},
	'Please enter no more than %1 digits.': {
		translation: 'Please enter no more than %1 digits.',
	},
	'Please enter no more than %s characters.': {
		translation: 'Please enter no more than %s characters.',
	},
	'Please enter only digits.': {
		translation: 'Please enter only digits.',
	},
	'Please enter pay type, pay rate, and exempt': {
		translation: 'Please enter pay type, pay rate, and exempt',
	},
	'Please enter pay type, pay rate, and overtime status': {
		translation: 'Please enter pay type, pay rate, and overtime status',
	},
	'Please enter pay type, pay rate, and overtime status.': {
		translation: 'Please enter pay type, pay rate, and overtime status.',
	},
	'Please enter the Token ID and Token Secret that you generated after you installed the "BambooHR TBA" and "BambooHR Custom 1W Role for TBA" bundles.':
		{
			translation:
				'Please enter the Token ID and Token Secret that you generated after you installed the \\"BambooHR TBA\\" and \\"BambooHR Custom 1W Role for TBA\\" bundles.',
		},
	'Please enter the completed date for this training': {
		translation: 'Please enter the completed date for this training',
	},
	"Please enter the key and secret you got from visiting %sCornerstone's provisioning page%s":
		{
			translation:
				"Please enter the key and secret you got from visiting %sCornerstone's provisioning page%s",
		},
	'Please enter the name of your company': {
		translation: 'Please enter the name of your company',
	},
	'Please enter the same value again.': {
		translation: 'Please enter the same value again.',
	},
	'Please enter values into the form to change your password.': {
		translation: 'Please enter values into the form to change your password.',
	},
	'Please enter which field(s) for this webhook to monitor.': {
		translation: 'Please enter which field(s) for this webhook to monitor.',
	},
	'Please enter which field(s) for this webhook to post.': {
		translation: 'Please enter which field(s) for this webhook to post.',
	},
	'Please enter your email.': {
		translation: 'Please enter your email.',
	},
	'Please enter your first name.': {
		translation: 'Please enter your first name.',
	},
	'Please enter your last name.': {
		translation: 'Please enter your last name.',
	},
	'Please fill out all passport fields.': {
		translation: 'Please fill out all passport fields.',
	},
	'Please fix the following errors when including employee in payroll: ': {
		translation:
			'Please fix the following errors when including employee in payroll: ',
	},
	'Please fix the following errors: ': {
		translation: 'Please fix the following errors: ',
	},
	'Please fix this field.': {
		translation: 'Please fix this field.',
	},
	'Please go back and review and approve any potential changes.': {
		translation: 'Please go back and review and approve any potential changes.',
	},
	'Please include a publish date that is within 30 days.': {
		translation: 'Please include a publish date that is within 30 days.',
	},
	'Please keep in mind that for this integration to function, the Employee # field from BambooHR MUST MATCH the "Employee Code" field within SwipeClock&reg;. When a new employee is added into BambooHR, please be sure to enter an Employee # and then this data will automatically be copied into SwipeClock&reg; when the employee is created there. For updating existing employees (individuals existing already in both systems), if the Employee # and Employee Code field values do not match, it will result in duplicate entries being created within SwipeClock&reg; rather than existing data being updated.':
		{
			translation:
				'Please keep in mind that for this integration to function, the Employee # field from BambooHR MUST MATCH the \\"Employee Code\\" field within SwipeClock&reg;. When a new employee is added into BambooHR, please be sure to enter an Employee # and then this data will automatically be copied into SwipeClock&reg; when the employee is created there. For updating existing employees (individuals existing already in both systems), if the Employee # and Employee Code field values do not match, it will result in duplicate entries being created within SwipeClock&reg; rather than existing data being updated.',
		},
	'Please log in to enable google single sign-on, so that Bamboo can be configured to work with your Google Apps account.':
		{
			translation:
				'Please log in to enable google single sign-on, so that Bamboo can be configured to work with your Google Apps account.',
		},
	'Please make a new date selection that is further out in the future.': {
		translation:
			'Please make a new date selection that is further out in the future.',
	},
	'Please make sure the Remote integration is enabled and try again.': {
		translation:
			'Please make sure the Remote integration is enabled and try again.',
	},
	'Please make sure to sign required documents and attach the requested file(s) to complete this task':
		{
			translation:
				'Please make sure to sign required documents and attach the requested file(s) to complete this task',
		},
	'Please make sure your passwords match.': {
		translation: 'Please make sure your passwords match.',
	},
	'Please name this folder before continuing.': {
		translation: 'Please name this folder before continuing.',
	},
	'Please note': {
		translation: 'Please note',
	},
	'Please note that Jobvite charges a monthly usage fee for this integration.':
		{
			translation:
				'Please note that Jobvite charges a monthly usage fee for this integration.',
		},
	'Please note that due to additional custom development required, Cornerstone charges a one-time fee for the setup of the SSO function.':
		{
			translation:
				'Please note that due to additional custom development required, Cornerstone charges a one-time fee for the setup of the SSO function.',
		},
	'Please note, any new employees will be imported into the Instant Payroll system as "Pending" employees and you will need to use the "Pending" employee wizard to complete each employee before they can be paid.':
		{
			translation:
				'Please note, any new employees will be imported into the Instant Payroll system as \\"Pending\\" employees and you will need to use the \\"Pending\\" employee wizard to complete each employee before they can be paid.',
		},
	'Please note: This will not remove benefit history for this item.': {
		translation:
			'Please note: This will not remove benefit history for this item.',
	},
	'Please pick a date in the future.': {
		translation: 'Please pick a date in the future.',
	},
	'Please provide Peer Feedback about %s': {
		translation: 'Please provide Peer Feedback about %s',
	},
	'Please provide feedback about': {
		translation: 'Please provide feedback about',
	},
	'Please provide feedback about %1.': {
		translation: 'Please provide feedback about %1.',
	},
	'Please provide feedback about %s': {
		translation: 'Please provide feedback about %s',
	},
	'Please reload this page to try opting in again.': {
		translation: 'Please reload this page to try opting in again.',
	},
	'Please remember that the <strong>Time Entry ID</strong>, <strong>Rate Type </strong>(REG, OT), <strong>Hours Worked</strong>, and <strong>Hours Worked Date</strong> are required fields for each employee in the import.':
		{
			translation:
				'Please remember that the <strong>Time Entry ID</strong>, <strong>Rate Type </strong>(REG, OT), <strong>Hours Worked</strong>, and <strong>Hours Worked Date</strong> are required fields for each employee in the import.',
		},
	'Please request the file again.': {
		translation: 'Please request the file again.',
	},
	'Please review the selected dependents for benefit plan %s.': {
		translation: 'Please review the selected dependents for benefit plan %s.',
	},
	'Please save the new category.': {
		translation: 'Please save the new category.',
	},
	'Please see our AI Addendum in the %s and our %s.': {
		translation: 'Please see our AI Addendum in the %s and our %s.',
	},
	'Please select a Benefit Group that has deductions %s bi-weekly. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s bi-weekly. %s',
	},
	'Please select a Benefit Group that has deductions %s every day. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s every day. %s',
	},
	'Please select a Benefit Group that has deductions %s every month. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s every month. %s',
	},
	'Please select a Benefit Group that has deductions %s every week. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s every week. %s',
	},
	'Please select a Benefit Group that has deductions %s every year. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s every year. %s',
	},
	'Please select a Benefit Group that has deductions %s quarterly. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s quarterly. %s',
	},
	'Please select a Benefit Group that has deductions %s semi-annually. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s semi-annually. %s',
	},
	'Please select a Benefit Group that has deductions %s semi-monthly. %s': {
		translation:
			'Please select a Benefit Group that has deductions %s semi-monthly. %s',
	},
	'Please select a CSV file to import.': {
		translation: 'Please select a CSV file to import.',
	},
	'Please select a benefit group that matches Pay Schedule': {
		translation: 'Please select a benefit group that matches Pay Schedule',
	},
	'Please select a category': {
		translation: 'Please select a category',
	},
	"Please select a code from the employee's assigned payroll account (%1$s)": {
		translation:
			"Please select a code from the employee's assigned payroll account (%1$s)",
	},
	'Please select a date range before running the %1$s': {
		translation: 'Please select a date range before running the %1$s',
	},
	'Please select a file to upload': {
		translation: 'Please select a file to upload',
	},
	'Please select a folder.': {
		translation: 'Please select a folder.',
	},
	'Please select a name for you plan': {
		translation: 'Please select a name for you plan',
	},
	'Please select a new EIN': {
		translation: 'Please select a new EIN',
	},
	'Please select a new hiring lead before deleting this employee': {
		translation:
			'Please select a new hiring lead before deleting this employee',
	},
	'Please select a person for each option in the additional signers area': {
		translation:
			'Please select a person for each option in the additional signers area',
	},
	'Please select a start date for your new plan': {
		translation: 'Please select a start date for your new plan',
	},
	'Please select a training title and a completion date': {
		translation: 'Please select a training title and a completion date',
	},
	'Please select a valid employment status for this user': {
		translation: 'Please select a valid employment status for this user',
	},
	'Please select an active code': {
		translation: 'Please select an active code',
	},
	'Please select an employee and fields to edit': {
		translation: 'Please select an employee and fields to edit',
	},
	'Please select an employee.': {
		translation: 'Please select an employee.',
	},
	'Please select an output format': {
		translation: 'Please select an output format',
	},
	'Please select at least one field': {
		translation: 'Please select at least one field',
	},
	'Please select at least one field for this report': {
		translation: 'Please select at least one field for this report',
	},
	'Please select one of the following Benefit Groups that match your Pay Period of %1$s':
		{
			translation:
				'Please select one of the following Benefit Groups that match your Pay Period of %1$s',
		},
	'Please select one of the following Benefit Groups that match your Pay Schedule of %1$s':
		{
			translation:
				'Please select one of the following Benefit Groups that match your Pay Schedule of %1$s',
		},
	'Please select one or more employees to download the forms for.': {
		translation:
			'Please select one or more employees to download the forms for.',
	},
	'Please select one or more forms to output': {
		translation: 'Please select one or more forms to output',
	},
	'Please select only 35 employees at a time to download the forms in one file for':
		{
			translation:
				'Please select only 35 employees at a time to download the forms in one file for',
		},
	'Please select only 35 employees at a time to download the forms in one file for.':
		{
			translation:
				'Please select only 35 employees at a time to download the forms in one file for.',
		},
	'Please select people to provide Peer Feedback on members of your team. You will be able to see the feedback once it’s completed.':
		{
			translation:
				'Please select people to provide Peer Feedback on members of your team. You will be able to see the feedback once it’s completed.',
		},
	"Please select people to provide feedback on members of your team. You will be able to see the feedback once it's completed.":
		{
			translation:
				"Please select people to provide feedback on members of your team. You will be able to see the feedback once it's completed.",
		},
	'Please select someone to send the email to.': {
		translation: 'Please select someone to send the email to.',
	},
	'Please select the type of plan that you would like to create.': {
		translation:
			'Please select the type of plan that you would like to create.',
	},
	'Please select which training was completed': {
		translation: 'Please select which training was completed',
	},
	'Please sign required documents to complete this task (where it says "Sign Now").':
		{
			translation:
				'Please sign required documents to complete this task (where it says \\"Sign Now\\").',
		},
	'Please specify a valid highest education.': {
		translation: 'Please specify a valid highest education.',
	},
	'Please submit a valid email address': {
		translation: 'Please submit a valid email address',
	},
	'Please take a moment to %1sanswer the following question about %2s%3s': {
		translation: {
			one: 'Please take a moment to %1sanswer the following question about %2s%3s',
			other:
				'Please take a moment to %1sanswer the following questions about %2s%3s',
		},
	},
	'Please take a moment to %1sanswer the following two questions about %2s%3s':
		{
			translation:
				'Please take a moment to %1sanswer the following two questions about %2s%3s',
		},
	'Please take a moment to answer the following question about %1s': {
		translation: {
			one: 'Please take a moment to answer the following question about %1s',
			other: 'Please take a moment to answer the following questions about %1s',
		},
	},
	'Please take a moment to complete your assessment of %1.': {
		translation: 'Please take a moment to complete your assessment of %1.',
	},
	'Please take a moment to configure access for users from your Google Apps account to BambooHR. You can perform this step at a later date by clicking on permissions in the upper right corner.':
		{
			translation:
				'Please take a moment to configure access for users from your Google Apps account to BambooHR. You can perform this step at a later date by clicking on permissions in the upper right corner.',
		},
	'Please take a moment to sign this document.': {
		translation: 'Please take a moment to sign this document.',
	},
	'Please take a quick moment to <b>select people to give feedback about your team members.</b> This will help give you insight on what each person does well and where you can help them improve.':
		{
			translation:
				'Please take a quick moment to <b>select people to give feedback about your team members.</b> This will help give you insight on what each person does well and where you can help them improve.',
		},
	"Please take a second to look through the changes that are being made so that you don't have any surprises.":
		{
			translation:
				"Please take a second to look through the changes that are being made so that you don't have any surprises.",
		},
	'Please try adjusting your date range.': {
		translation: 'Please try adjusting your date range.',
	},
	'Please try adjusting your selected dates.': {
		translation: 'Please try adjusting your selected dates.',
	},
	'Please try saving your pay schedule again or make a new selection.': {
		translation:
			'Please try saving your pay schedule again or make a new selection.',
	},
	'Please type "RESET" to continue': {
		translation: 'Please type \\"RESET\\" to continue',
	},
	'Please type %1$s to confirm deleting these files': {
		translation: 'Please type %1$s to confirm deleting these files',
	},
	'Please type %1$s to confirm deleting this employee': {
		translation: 'Please type %1$s to confirm deleting this employee',
	},
	'Please type %1$s to confirm deleting this folder': {
		translation: 'Please type %1$s to confirm deleting this folder',
	},
	'Please type %1$s to confirm deleting this position': {
		translation: 'Please type %1$s to confirm deleting this position',
	},
	'Please type the word "DELETE" to continue.': {
		translation: 'Please type the word \\"DELETE\\" to continue.',
	},
	'Please upload a .csv, .xls, .xlsx or a .txt file type.': {
		translation: 'Please upload a .csv, .xls, .xlsx or a .txt file type.',
	},
	'Please upload a file.': {
		translation: 'Please upload a file.',
	},
	'Please upload an .XML file type': {
		translation: 'Please upload an .XML file type',
	},
	'Please upload either a .csv, .txt, .xls, or .xlsx file type': {
		translation: 'Please upload either a .csv, .txt, .xls, or .xlsx file type',
	},
	'Please upload either a .csv, .xls, or .xlsx file type': {
		translation: 'Please upload either a .csv, .xls, or .xlsx file type',
	},
	'Please use a new password. Re-using old passwords is not recommended.': {
		translation:
			'Please use a new password. Re-using old passwords is not recommended.',
	},
	'Please use a valid LinkedIn url': {
		translation: 'Please use a valid LinkedIn url',
	},
	'Please verify this is correct.': {
		translation: 'Please verify this is correct.',
	},
	'Please verify your password': {
		translation: 'Please verify your password',
	},
	'Please wait while we securely process your payment.': {
		translation: 'Please wait while we securely process your payment.',
	},
	'Please, double check that you are uploading the right file to the right company.':
		{
			translation:
				'Please, double check that you are uploading the right file to the right company.',
		},
	'Point-In-Time Report': {
		translation: 'Point-In-Time Report',
	},
	'Point-in-Time': {
		translation: 'Point-in-Time',
	},
	Policy: {
		translation: 'Policy',
	},
	'Policy #': {
		translation: 'Policy #',
	},
	'Policy Assigned': {
		translation: 'Policy Assigned',
	},
	'Policy Exp.': {
		translation: 'Policy Exp.',
	},
	'Policy Flags': {
		translation: 'Policy Flags',
	},
	'Policy Name': {
		translation: 'Policy Name',
	},
	'Policy Saved Successfully': {
		translation: 'Policy Saved Successfully',
	},
	'Policy Unassigned Successfully': {
		translation: 'Policy Unassigned Successfully',
	},
	'Policy assignment import': {
		translation: 'Policy assignment import',
	},
	'Policy effective date is before employee hire date': {
		translation: 'Policy effective date is before employee hire date',
	},
	Polygender: {
		translation: 'Polygender',
	},
	Popover: {
		translation: 'Popover',
	},
	Portrait: {
		translation: 'Portrait',
	},
	Position: {
		translation: 'Position',
	},
	'Position is invalid': {
		translation: 'Position is invalid',
	},
	Positive: {
		translation: 'Positive',
	},
	Post: {
		translation: 'Post',
	},
	'Post Code': {
		translation: 'Post Code',
	},
	'Post Comment': {
		translation: 'Post Comment',
	},
	'Post Var': {
		translation: 'Post Var',
	},
	'Post this job to:': {
		translation: 'Post this job to:',
	},
	'Post to URL: ': {
		translation: 'Post to URL: ',
	},
	'Post-Tax': {
		translation: 'Post-Tax',
	},
	'Post-tax': {
		translation: 'Post-tax',
	},
	'Postal / Zip': {
		translation: 'Postal / Zip',
	},
	'Postal Code': {
		translation: 'Postal Code',
	},
	'Postal/Zip': {
		translation: 'Postal/Zip',
	},
	Postcode: {
		translation: 'Postcode',
	},
	'Posting Title': {
		translation: 'Posting Title',
	},
	'Posting Views': {
		translation: 'Posting Views',
	},
	'Potential Bonus': {
		translation: 'Potential Bonus',
	},
	'Potential Problems': {
		translation: 'Potential Problems',
	},
	'Potential Problems:': {
		translation: 'Potential Problems:',
	},
	'Potential issues with data.': {
		translation: 'Potential issues with data.',
	},
	'Power Edit': {
		translation: 'Power Edit',
	},
	'Power Edit All': {
		translation: 'Power Edit All',
	},
	'Power Edit Benefits': {
		translation: 'Power Edit Benefits',
	},
	'Power Edit Employees': {
		translation: 'Power Edit Employees',
	},
	'Power Tools 1': {
		translation: 'Power Tools 1',
	},
	'Power Tools 1 Date': {
		translation: 'Power Tools 1 Date',
	},
	'Power Tools 2': {
		translation: 'Power Tools 2',
	},
	'Power Tools 2 Date': {
		translation: 'Power Tools 2 Date',
	},
	'Powerd by': {
		translation: 'Powerd by',
	},
	'Powered by': {
		translation: 'Powered by',
	},
	'Powered by QuickBooks': {
		translation: 'Powered by QuickBooks',
	},
	'Powered by Remote': {
		translation: 'Powered by Remote',
	},
	'Powered by%1$s': {
		translation: 'Powered by%1$s',
	},
	'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="//www.bamboohr.com/img/footer-logo.png" alt="BambooHR"/></a>':
		{
			translation:
				'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="//www.bamboohr.com/img/footer-logo.png" alt="BambooHR"/></a>',
		},
	'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="/images/footer-logo.png" alt="BambooHR"/></a>':
		{
			translation:
				'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="/images/footer-logo.png" alt="BambooHR"/></a>',
		},
	'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="https://resources.bamboohr.com/images/footer-logo.png" alt="BambooHR - HR software"/></a>':
		{
			translation:
				'Powered by<a href="http://www.bamboohr.com" target="_blank" rel="noopener external nofollow noreferrer"><img src="https://resources.bamboohr.com/images/footer-logo.png" alt="BambooHR - HR software"/></a>',
		},
	'Pre-Hire Drug Test': {
		translation: 'Pre-Hire Drug Test',
	},
	'Pre-Populated Forms': {
		translation: 'Pre-Populated Forms',
	},
	'Pre-Tax': {
		translation: 'Pre-Tax',
	},
	'Pre-Termination Employment Status': {
		translation: 'Pre-Termination Employment Status',
	},
	'Prefer Not to Say': {
		translation: 'Prefer Not to Say',
	},
	'Preferred Name': {
		translation: 'Preferred Name',
	},
	'Preferred fields saved': {
		translation: 'Preferred fields saved',
	},
	'Preparing document for printing...': {
		translation: 'Preparing document for printing...',
	},
	'Preseason PPW': {
		translation: 'Preseason PPW',
	},
	'Preseason Pay': {
		translation: 'Preseason Pay',
	},
	'Preseason Special': {
		translation: 'Preseason Special',
	},
	Present: {
		translation: 'Present',
	},
	'Press ctrl+c or command+c to copy the link': {
		translation: 'Press ctrl+c or command+c to copy the link',
	},
	'Press return to quickly add multiple names': {
		translation: 'Press return to quickly add multiple names',
	},
	'Press return to quickly add multiple statuses.': {
		translation: 'Press return to quickly add multiple statuses.',
	},
	'Press return to quickly add multiple tasks.': {
		translation: 'Press return to quickly add multiple tasks.',
	},
	'Press save... and be on your integrated way!': {
		translation: 'Press save... and be on your integrated way!',
	},
	Prev: {
		translation: 'Prev',
	},
	Preview: {
		translation: 'Preview',
	},
	'Preview "Get to Know You" Email': {
		translation: 'Preview \\"Get to Know You\\" Email',
	},
	'Preview & Save': {
		translation: 'Preview & Save',
	},
	'Preview & Send': {
		translation: 'Preview & Send',
	},
	'Preview Application': {
		translation: 'Preview Application',
	},
	'Preview BambooHR as %1': {
		translation: 'Preview BambooHR as %1',
	},
	'Preview Changes': {
		translation: 'Preview Changes',
	},
	'Preview Email': {
		translation: 'Preview Email',
	},
	'Preview Form': {
		translation: 'Preview Form',
	},
	'Preview Job Listing': {
		translation: 'Preview Job Listing',
	},
	'Preview Offer & Send': {
		translation: 'Preview Offer & Send',
	},
	'Preview Pay Calendar': {
		translation: 'Preview Pay Calendar',
	},
	'Preview Performance Schedule': {
		translation: 'Preview Performance Schedule',
	},
	'Preview Survey Email': {
		translation: 'Preview Survey Email',
	},
	'Preview Template': {
		translation: 'Preview Template',
	},
	'Preview Your Changes': {
		translation: 'Preview Your Changes',
	},
	'Preview as This User': {
		translation: 'Preview as This User',
	},
	'Preview of Get to Know You Email': {
		translation: 'Preview of Get to Know You Email',
	},
	'Previewing New Hire Packet for:': {
		translation: 'Previewing New Hire Packet for:',
	},
	'Previewing offer letter for': {
		translation: 'Previewing offer letter for',
	},
	Previous: {
		translation: 'Previous',
	},
	'Previous Access Level': {
		translation: 'Previous Access Level',
	},
	'Previous Month': {
		translation: 'Previous Month',
	},
	'Previous Offers': {
		translation: 'Previous Offers',
	},
	'Previous Page': {
		translation: 'Previous Page',
	},
	'Previous Pay': {
		translation: 'Previous Pay',
	},
	'Previous Pay Per': {
		translation: 'Previous Pay Per',
	},
	'Previous Pay Period': {
		translation: 'Previous Pay Period',
	},
	'Previous Question': {
		translation: 'Previous Question',
	},
	'Previous Step': {
		translation: 'Previous Step',
	},
	'Previous and Next Buttons': {
		translation: 'Previous and Next Buttons',
	},
	'Previous page': {
		translation: 'Previous page',
	},
	'Previous pay': {
		translation: 'Previous pay',
	},
	'Previous: %1': {
		translation: 'Previous: %1',
	},
	'Previously Sold With': {
		translation: 'Previously Sold With',
	},
	'Primary Contact': {
		translation: 'Primary Contact',
	},
	'Primary Language': {
		translation: 'Primary Language',
	},
	'Primary Mailing/Filing': {
		translation: 'Primary Mailing/Filing',
	},
	'Primary care provider': {
		translation: 'Primary care provider',
	},
	'Primary payment method expiration notice': {
		translation: 'Primary payment method expiration notice',
	},
	Print: {
		translation: 'Print',
	},
	'Print Application': {
		translation: 'Print Application',
	},
	'Print Forms': {
		translation: 'Print Forms',
	},
	'Print file': {
		translation: 'Print file',
	},
	'Prior Year W2/K1': {
		translation: 'Prior Year W2/K1',
	},
	'Privacy Policy': {
		translation: 'Privacy Policy',
	},
	'Private (Internal) Integration': {
		translation: 'Private (Internal) Integration',
	},
	'Private (Internal) User': {
		translation: 'Private (Internal) User',
	},
	'Private (Mobile) User': {
		translation: 'Private (Mobile) User',
	},
	'Private Mobile': {
		translation: 'Private Mobile',
	},
	'Pro rata': {
		translation: 'Pro rata',
	},
	'Probation End Date': {
		translation: 'Probation End Date',
	},
	Proceed: {
		translation: 'Proceed',
	},
	'Processed Date': {
		translation: 'Processed Date',
	},
	'Processing - Company Name: ': {
		translation: 'Processing - Company Name: ',
	},
	'Processing&hellip;': {
		translation: 'Processing&hellip;',
	},
	Product: {
		translation: 'Product',
	},
	'Product Manager': {
		translation: 'Product Manager',
	},
	'Product Timeline': {
		translation: 'Product Timeline',
	},
	'Product Update': {
		translation: 'Product Update',
	},
	'Product Updates': {
		translation: 'Product Updates',
	},
	Production: {
		translation: 'Production',
	},
	'Professional Development': {
		translation: 'Professional Development',
	},
	Professionals: {
		translation: 'Professionals',
	},
	'Profile Photo': {
		translation: 'Profile Photo',
	},
	'Profile Photo Uploader ': {
		translation: 'Profile Photo Uploader ',
	},
	'Profile Photo for': {
		translation: 'Profile Photo for',
	},
	'Profile Photo for %1$s': {
		translation: 'Profile Photo for %1$s',
	},
	'Profile Pic for': {
		translation: 'Profile Pic for',
	},
	'Profile photo for ': {
		translation: 'Profile photo for ',
	},
	Progress: {
		translation: 'Progress',
	},
	'Progress Successfully Updated': {
		translation: 'Progress Successfully Updated',
	},
	'Progress will be saved as you go.': {
		translation: 'Progress will be saved as you go.',
	},
	ProgressiveLoader: {
		translation: 'ProgressiveLoader',
	},
	Project: {
		translation: 'Project',
	},
	'Project %1$s was successfully archived.': {
		translation: 'Project %1$s was successfully archived.',
	},
	'Project %1$s was successfully deleted.': {
		translation: 'Project %1$s was successfully deleted.',
	},
	'Project %1$s was successfully unarchived.': {
		translation: 'Project %1$s was successfully unarchived.',
	},
	'Project %1$s was successfully updated.': {
		translation: 'Project %1$s was successfully updated.',
	},
	'Project Hours': {
		translation: 'Project Hours',
	},
	'Project Name': {
		translation: 'Project Name',
	},
	"Project Name can't be an empty string": {
		translation: "Project Name can't be an empty string",
	},
	'Project Pay Allocation': {
		translation: 'Project Pay Allocation',
	},
	'Project Pay Allocations: Comment': {
		translation: 'Project Pay Allocations: Comment',
	},
	'Project Pay Allocations: End Ymd': {
		translation: 'Project Pay Allocations: End Ymd',
	},
	'Project Pay Allocations: Percent Allocation': {
		translation: 'Project Pay Allocations: Percent Allocation',
	},
	'Project Pay Allocations: Project or Task Name': {
		translation: 'Project Pay Allocations: Project or Task Name',
	},
	'Project Pay Allocations: Ymd': {
		translation: 'Project Pay Allocations: Ymd',
	},
	'Project Pay Rate Effective Date cannot be empty': {
		translation: 'Project Pay Rate Effective Date cannot be empty',
	},
	"Project Pay Rate can't be an empty string": {
		translation: "Project Pay Rate can't be an empty string",
	},
	'Project Pay Rate cannot be empty': {
		translation: 'Project Pay Rate cannot be empty',
	},
	'Project Pay Rate must be greater than 0.': {
		translation: 'Project Pay Rate must be greater than 0.',
	},
	'Project Pay Rate must be in USD.': {
		translation: 'Project Pay Rate must be in USD.',
	},
	'Project Pay Rates': {
		translation: 'Project Pay Rates',
	},
	'Project Pay Rates must be of a valid payroll currency for this pay schedule':
		{
			translation:
				'Project Pay Rates must be of a valid payroll currency for this pay schedule',
		},
	'Project Pay Rates: Comment': {
		translation: 'Project Pay Rates: Comment',
	},
	'Project Pay Rates: End Date': {
		translation: 'Project Pay Rates: End Date',
	},
	'Project Pay Rates: Pay Rate': {
		translation: 'Project Pay Rates: Pay Rate',
	},
	'Project Pay Rates: Project or Task Name': {
		translation: 'Project Pay Rates: Project or Task Name',
	},
	'Project Pay Rates: Start Date': {
		translation: 'Project Pay Rates: Start Date',
	},
	'Project Status': {
		translation: 'Project Status',
	},
	'Project Tracking': {
		translation: 'Project Tracking',
	},
	'Project name already exists, project names must be unique.': {
		translation: 'Project name already exists, project names must be unique.',
	},
	'Project or Task Name': {
		translation: 'Project or Task Name',
	},
	'Project set to **{1}**': {
		translation: 'Project set to **{1}**',
	},
	'Project updated from **{1}** to **{2}**': {
		translation: 'Project updated from **{1}** to **{2}**',
	},
	'Project updated to **{1}**': {
		translation: 'Project updated to **{1}**',
	},
	'Project » Task': {
		translation: 'Project » Task',
	},
	'Project/Task': {
		translation: 'Project/Task',
	},
	'Projected sales': {
		translation: 'Projected sales',
	},
	Projects: {
		translation: 'Projects',
	},
	'Projects/Tasks': {
		translation: 'Projects/Tasks',
	},
	'Promo Video': {
		translation: 'Promo Video',
	},
	Promoter: {
		translation: 'Promoter',
	},
	'Promoter Tags': {
		translation: 'Promoter Tags',
	},
	Promoters: {
		translation: 'Promoters',
	},
	'Promoters (9-10)': {
		translation: 'Promoters (9-10)',
	},
	'Promoters (Rated 9-10)': {
		translation: 'Promoters (Rated 9-10)',
	},
	'Promoters’ most liked tags by number of survey responses. We calculate the eNPS for each tag and display the trend over time.':
		{
			translation:
				'Promoters’ most liked tags by number of survey responses. We calculate the eNPS for each tag and display the trend over time.',
		},
	Promotion: {
		translation: 'Promotion',
	},
	Pronouns: {
		translation: 'Pronouns',
	},
	'Proof of Vaccination Provided': {
		translation: 'Proof of Vaccination Provided',
	},
	Prorate: {
		translation: 'Prorate',
	},
	Prorated: {
		translation: 'Prorated',
	},
	'Prorated vs. Full Amount': {
		translation: 'Prorated vs. Full Amount',
	},
	'Protected Identity Data (Sensitive)': {
		translation: 'Protected Identity Data (Sensitive)',
	},
	'Provide Feedback': {
		translation: 'Provide Feedback',
	},
	'Provide Peer Feedback': {
		translation: 'Provide Peer Feedback',
	},
	'Provide your API key and account subdomain from BambooHR': {
		translation: 'Provide your API key and account subdomain from BambooHR',
	},
	Province: {
		translation: 'Province',
	},
	'Proxima Nova Fix': {
		translation: 'Proxima Nova Fix',
	},
	'Pssst... %1$sAdd a holiday%2$s to set up your holiday pay multiplier.': {
		translation:
			'Pssst... %1$sAdd a holiday%2$s to set up your holiday pay multiplier.',
	},
	'Pssst... %s already exists in BambooHR. Esignature documents (including the signed offer) have been (or will be, once complete) copied over to the employee documents tab.':
		{
			translation:
				'Pssst... %s already exists in BambooHR. Esignature documents (including the signed offer) have been (or will be, once complete) copied over to the employee documents tab.',
		},
	'Pssst... the Benefits and Goals widgets will show if there is an active item in them. The What’s Happening widget always shows.':
		{
			translation:
				'Pssst... the Benefits and Goals widgets will show if there is an active item in them. The What’s Happening widget always shows.',
		},
	'Pssst... the Benefits, Goals, and Training widgets will show if there is an active item in them. The What’s Happening widget always shows.':
		{
			translation:
				'Pssst... the Benefits, Goals, and Training widgets will show if there is an active item in them. The What’s Happening widget always shows.',
		},
	'Pssst...we will add this text to the end of your email. It’s important stuff!':
		{
			translation:
				'Pssst...we will add this text to the end of your email. It’s important stuff!',
		},
	'Pssst… Hit enter to quickly add multiple tasks': {
		translation: 'Pssst… Hit enter to quickly add multiple tasks',
	},
	"Psst! We noticed you're using Internet Explorer": {
		translation: "Psst! We noticed you're using Internet Explorer",
	},
	'Psst... Just so you know, Peer Feedback is hidden from {1}.': {
		translation: 'Psst... Just so you know, Peer Feedback is hidden from {1}.',
	},
	Publish: {
		translation: 'Publish',
	},
	'Publish & Email': {
		translation: 'Publish & Email',
	},
	'Publish And Email': {
		translation: 'Publish And Email',
	},
	'Published by %1$s': {
		translation: 'Published by %1$s',
	},
	'Published by [{1}]': {
		translation: 'Published by [{1}]',
	},
	'Published by:': {
		translation: 'Published by:',
	},
	'Pulse Survey Setup': {
		translation: 'Pulse Survey Setup',
	},
	'Pulse Surveys': {
		translation: 'Pulse Surveys',
	},
	'Purchase Premium Job Ads': {
		translation: 'Purchase Premium Job Ads',
	},
	'Put on Hold': {
		translation: 'Put on Hold',
	},
	Q1: {
		translation: 'Q1',
	},
	Q2: {
		translation: 'Q2',
	},
	Q3: {
		translation: 'Q3',
	},
	Q4: {
		translation: 'Q4',
	},
	'QA Tester': {
		translation: 'QA Tester',
	},
	'QC Fee Waived': {
		translation: 'QC Fee Waived',
	},
	QTD: {
		translation: 'QTD',
	},
	'Qualifying Life Event Date': {
		translation: 'Qualifying Life Event Date',
	},
	'Qualifying Life Event Type': {
		translation: 'Qualifying Life Event Type',
	},
	'Qualifying Life Events': {
		translation: 'Qualifying Life Events',
	},
	"Quality time off will improve employees' performance.": {
		translation: "Quality time off will improve employees' performance.",
	},
	Quarter: {
		translation: 'Quarter',
	},
	Quarterly: {
		translation: 'Quarterly',
	},
	'Quarterly (send on the 1st day of January, April, July, and October)': {
		translation:
			'Quarterly (send on the 1st day of January, April, July, and October)',
	},
	'Quarterly Dates': {
		translation: 'Quarterly Dates',
	},
	'Quarterly Security Training': {
		translation: 'Quarterly Security Training',
	},
	'Quarterly Training': {
		translation: 'Quarterly Training',
	},
	'Query Lists of Fields, Tables and Lists.': {
		translation: 'Query Lists of Fields, Tables and Lists.',
	},
	Question: {
		translation: 'Question',
	},
	'Question 1 Answer': {
		translation: 'Question 1 Answer',
	},
	'Question 1 Comments': {
		translation: 'Question 1 Comments',
	},
	'Question 10 Answer': {
		translation: 'Question 10 Answer',
	},
	'Question 10 Comments': {
		translation: 'Question 10 Comments',
	},
	'Question 11 Answer': {
		translation: 'Question 11 Answer',
	},
	'Question 11 Comments': {
		translation: 'Question 11 Comments',
	},
	'Question 12 Answer': {
		translation: 'Question 12 Answer',
	},
	'Question 12 Comments': {
		translation: 'Question 12 Comments',
	},
	'Question 13 Answer': {
		translation: 'Question 13 Answer',
	},
	'Question 13 Comments': {
		translation: 'Question 13 Comments',
	},
	'Question 14 Answer': {
		translation: 'Question 14 Answer',
	},
	'Question 15 Answer': {
		translation: 'Question 15 Answer',
	},
	'Question 17 Answer': {
		translation: 'Question 17 Answer',
	},
	'Question 18 Answer': {
		translation: 'Question 18 Answer',
	},
	'Question 19 Answer': {
		translation: 'Question 19 Answer',
	},
	'Question 2 Answer': {
		translation: 'Question 2 Answer',
	},
	'Question 2 Comments': {
		translation: 'Question 2 Comments',
	},
	'Question 20 Answer': {
		translation: 'Question 20 Answer',
	},
	'Question 20 Comments': {
		translation: 'Question 20 Comments',
	},
	'Question 21 Answer': {
		translation: 'Question 21 Answer',
	},
	'Question 21 Comments': {
		translation: 'Question 21 Comments',
	},
	'Question 22 Answer': {
		translation: 'Question 22 Answer',
	},
	'Question 23 Answer': {
		translation: 'Question 23 Answer',
	},
	'Question 23 Comments': {
		translation: 'Question 23 Comments',
	},
	'Question 3 Answer': {
		translation: 'Question 3 Answer',
	},
	'Question 3 Comments': {
		translation: 'Question 3 Comments',
	},
	'Question 4 Answer': {
		translation: 'Question 4 Answer',
	},
	'Question 4 Comments': {
		translation: 'Question 4 Comments',
	},
	'Question 5 Answer': {
		translation: 'Question 5 Answer',
	},
	'Question 5 Comments': {
		translation: 'Question 5 Comments',
	},
	'Question 6 Answer': {
		translation: 'Question 6 Answer',
	},
	'Question 6 Comments': {
		translation: 'Question 6 Comments',
	},
	'Question 7 Answer': {
		translation: 'Question 7 Answer',
	},
	'Question 7 Comments': {
		translation: 'Question 7 Comments',
	},
	'Question 8 Answer': {
		translation: 'Question 8 Answer',
	},
	'Question 8 Comments': {
		translation: 'Question 8 Comments',
	},
	'Question 9 Answer': {
		translation: 'Question 9 Answer',
	},
	'Question 9 Comments': {
		translation: 'Question 9 Comments',
	},
	'Question Required?': {
		translation: 'Question Required?',
	},
	'Question {1} of {2}': {
		translation: 'Question {1} of {2}',
	},
	Questioning: {
		translation: 'Questioning',
	},
	'Questions about file access?': {
		translation: 'Questions about file access?',
	},
	'Questions for Manager:': {
		translation: 'Questions for Manager:',
	},
	'Questions?': {
		translation: 'Questions?',
	},
	'Quick access to the directory': {
		translation: 'Quick access to the directory',
	},
	'Quick add': {
		translation: 'Quick add',
	},
	'Quick question...': {
		translation: 'Quick question...',
	},
	'Quickly import basic employee data from an XML file.': {
		translation: 'Quickly import basic employee data from an XML file.',
	},
	'Quickly import basic employee data into your account. If you want to import history tables (Job Information, Employment Status, and Compensation) or any custom tables, <a data-bi-id="import-example-basic" href="/manage/import/history/">go here</a>.':
		{
			translation:
				'Quickly import basic employee data into your account. If you want to import history tables (Job Information, Employment Status, and Compensation) or any custom tables, <a data-bi-id="import-example-basic" href="/manage/import/history/">go here</a>.',
		},
	'Quickly import data for history tables (Job Information, Employment Status, and Compensation) or custom tables into your account. If you want to import basic employee data, <a href="/manage/import/">go here</a>.':
		{
			translation:
				'Quickly import data for history tables (Job Information, Employment Status, and Compensation) or custom tables into your account. If you want to import basic employee data, <a href="/manage/import/">go here</a>.',
		},
	'R/R MED #': {
		translation: 'R/R MED #',
	},
	'R/R MED NV #': {
		translation: 'R/R MED NV #',
	},
	RESET: {
		translation: 'RESET',
	},
	'RN License': {
		translation: 'RN License',
	},
	RSA: {
		translation: 'RSA',
	},
	RSU: {
		translation: 'RSU',
	},
	Race: {
		translation: 'Race',
	},
	'Race or Ethnicity': {
		translation: 'Race or Ethnicity',
	},
	'Race/Ethnicity': {
		translation: 'Race/Ethnicity',
	},
	'Radio Group': {
		translation: 'Radio Group',
	},
	'Radius Environment': {
		translation: 'Radius Environment',
	},
	"Radius Worldwide's OverSeas Connect International Payroll platform now integrates with BambooHR by pulling critical employee data from BambooHR and pushing it into OverSeas Connect in near real-time.":
		{
			translation:
				"Radius Worldwide's OverSeas Connect International Payroll platform now integrates with BambooHR by pulling critical employee data from BambooHR and pushing it into OverSeas Connect in near real-time.",
		},
	'Rail Equipment 1': {
		translation: 'Rail Equipment 1',
	},
	'Rail Equipment 1 Date': {
		translation: 'Rail Equipment 1 Date',
	},
	'Rail Equipment 2': {
		translation: 'Rail Equipment 2',
	},
	'Rail Equipment 2 Date': {
		translation: 'Rail Equipment 2 Date',
	},
	'Raise date': {
		translation: 'Raise date',
	},
	'Random Drug Test': {
		translation: 'Random Drug Test',
	},
	'Range updated to start at $1%s and end at $2%s': {
		translation: 'Range updated to start at $1%s and end at $2%s',
	},
	Rate: {
		translation: 'Rate',
	},
	'Rate History': {
		translation: 'Rate History',
	},
	'Rate Type': {
		translation: 'Rate Type',
	},
	'Rate must be above %1$s%2$s': {
		translation: 'Rate must be above %1$s%2$s',
	},
	'Rate must be below %1$s%2$s': {
		translation: 'Rate must be below %1$s%2$s',
	},
	'Rate must be between %1$s%2$s and %3$s%4$s': {
		translation: 'Rate must be between %1$s%2$s and %3$s%4$s',
	},
	'Rated %s:': {
		translation: 'Rated %s:',
	},
	Rating: {
		translation: 'Rating',
	},
	'Rating Options for Question #%1': {
		translation: 'Rating Options for Question #%1',
	},
	'Rating Options for Question #%s:': {
		translation: 'Rating Options for Question #%s:',
	},
	'Rating saved! Care to comment on this update? (optional)': {
		translation: 'Rating saved! Care to comment on this update? (optional)',
	},
	'Rating set to': {
		translation: 'Rating set to',
	},
	'Raw Score': {
		translation: 'Raw Score',
	},
	'Re-enter Password': {
		translation: 'Re-enter Password',
	},
	'Re: ': {
		translation: 'Re: ',
	},
	'Reach out to %s to have them install it. Once installed, you can post paid promoted job ads on LinkedIn whenever you create a Job Opening.':
		{
			translation:
				'Reach out to %s to have them install it. Once installed, you can post paid promoted job ads on LinkedIn whenever you create a Job Opening.',
		},
	'Reach out to %s to look at pricing and install the integration. Once this app is installed you can set up your journal entry report in Settings.':
		{
			translation:
				'Reach out to %s to look at pricing and install the integration. Once this app is installed you can set up your journal entry report in Settings.',
		},
	'Reach out to %s to uninstall this integration.': {
		translation: 'Reach out to %s to uninstall this integration.',
	},
	'React Form': {
		translation: 'React Form',
	},
	Reactivate: {
		translation: 'Reactivate',
	},
	'Reactivate %1$s?': {
		translation: 'Reactivate %1$s?',
	},
	'Reactivate Plan': {
		translation: 'Reactivate Plan',
	},
	'Read Full DPA': {
		translation: 'Read Full DPA',
	},
	'Ready for Payroll!': {
		translation: 'Ready for Payroll!',
	},
	'Ready for a fresh start?': {
		translation: 'Ready for a fresh start?',
	},
	'Ready for a fresh start? This will remove all of the demo data in this account along with anything that you may have added.  Are you sure that you want to remove this information?':
		{
			translation:
				'Ready for a fresh start? This will remove all of the demo data in this account along with anything that you may have added.  Are you sure that you want to remove this information?',
		},
	'Ready to Invite': {
		translation: 'Ready to Invite',
	},
	'Ready to go? Just select a job opening to see the goods.': {
		translation: 'Ready to go? Just select a job opening to see the goods.',
	},
	'Ready to run background checks directly from BambooHR? Log in or create an account at ':
		{
			translation:
				'Ready to run background checks directly from BambooHR? Log in or create an account at ',
		},
	'Ready to start collecting your employees’ feedback?': {
		translation: 'Ready to start collecting your employees’ feedback?',
	},
	'Real-Time Updates': {
		translation: 'Real-Time Updates',
	},
	Reason: {
		translation: 'Reason',
	},
	'Reason:': {
		translation: 'Reason:',
	},
	'Reassign Direct Reports to': {
		translation: 'Reassign Direct Reports to',
	},
	Reauthorize: {
		translation: 'Reauthorize',
	},
	Rebuild: {
		translation: 'Rebuild',
	},
	'Receive notifications of new time off requests and timesheet approvals (managers only)':
		{
			translation:
				'Receive notifications of new time off requests and timesheet approvals (managers only)',
		},
	'Receive occasional system generated messages from BambooHR': {
		translation: 'Receive occasional system generated messages from BambooHR',
	},
	'Receiving Feedback': {
		translation: 'Receiving Feedback',
	},
	'Receiving Feedback From': {
		translation: 'Receiving Feedback From',
	},
	Recent: {
		translation: 'Recent',
	},
	'Recent Addresses': {
		translation: 'Recent Addresses',
	},
	'Recent changes to our database require that you login again using your reseller account.':
		{
			translation:
				'Recent changes to our database require that you login again using your reseller account.',
		},
	'Recently Separated Veteran': {
		translation: 'Recently Separated Veteran',
	},
	Recipients: {
		translation: 'Recipients',
	},
	Recognition: {
		translation: 'Recognition',
	},
	'Recognizes my value? Help me do my best work? If I got a job offer elsewhere? How engaged? Does well? Could improve?':
		{
			translation:
				'Recognizes my value? Help me do my best work? If I got a job offer elsewhere? How engaged? Does well? Could improve?',
		},
	'Recommendation due date must be within cycle dates.': {
		translation: 'Recommendation due date must be within cycle dates.',
	},
	'Record New': {
		translation: 'Record New',
	},
	'Record Time Off': {
		translation: 'Record Time Off',
	},
	'Record a Completed Training': {
		translation: 'Record a Completed Training',
	},
	'Record a Training': {
		translation: 'Record a Training',
	},
	'Record not found': {
		translation: 'Record not found',
	},
	'Record not found.': {
		translation: 'Record not found.',
	},
	'Record not imported: Employee ID required': {
		translation: 'Record not imported: Employee ID required',
	},
	'Record not imported: Employee coverage must be included in import': {
		translation:
			'Record not imported: Employee coverage must be included in import',
	},
	'Records were removed where you lacked permissions to the filter field for the employee.':
		{
			translation:
				'Records were removed where you lacked permissions to the filter field for the employee.',
		},
	'Recruit status': {
		translation: 'Recruit status',
	},
	'Recruited by': {
		translation: 'Recruited by',
	},
	Recruiter: {
		translation: 'Recruiter',
	},
	'Reduction in hours': {
		translation: 'Reduction in hours',
	},
	'Reduction of working hours': {
		translation: 'Reduction of working hours',
	},
	'Reference Date': {
		translation: 'Reference Date',
	},
	References: {
		translation: 'References',
	},
	'References (Name, Company and Contact Info': {
		translation: 'References (Name, Company and Contact Info',
	},
	'References (Name, Company, and Contact Info)': {
		translation: 'References (Name, Company, and Contact Info)',
	},
	Referral: {
		translation: 'Referral',
	},
	'Referred By': {
		translation: 'Referred By',
	},
	'Referred by': {
		translation: 'Referred by',
	},
	'Referred by (Name)': {
		translation: 'Referred by (Name)',
	},
	Refresh: {
		translation: 'Refresh',
	},
	'Refund Notice': {
		translation: 'Refund Notice',
	},
	'Refund Summary': {
		translation: 'Refund Summary',
	},
	'Reg Hours': {
		translation: 'Reg Hours',
	},
	'Reg Rate': {
		translation: 'Reg Rate',
	},
	'Regarding %1$s': {
		translation: 'Regarding %1$s',
	},
	'Regenerate API': {
		translation: 'Regenerate API',
	},
	'Regional Manager': {
		translation: 'Regional Manager',
	},
	Regrettable: {
		translation: 'Regrettable',
	},
	'Regrettable or Non-Regrettable': {
		translation: 'Regrettable or Non-Regrettable',
	},
	'Regrettable vs Non-regrettable': {
		translation: 'Regrettable vs Non-regrettable',
	},
	Regular: {
		translation: 'Regular',
	},
	Rehire: {
		translation: 'Rehire',
	},
	'Rehire Date': {
		translation: 'Rehire Date',
	},
	'Rehire Employee': {
		translation: 'Rehire Employee',
	},
	'Rehire Employee...': {
		translation: 'Rehire Employee...',
	},
	'Rehire?:': {
		translation: 'Rehire?:',
	},
	Reimbursement: {
		translation: 'Reimbursement',
	},
	'Reimbursement Plan': {
		translation: 'Reimbursement Plan',
	},
	Relationship: {
		translation: 'Relationship',
	},
	'Relationship Coverage Amount': {
		translation: 'Relationship Coverage Amount',
	},
	'Relationship Enrollment Status': {
		translation: 'Relationship Enrollment Status',
	},
	Relationships: {
		translation: 'Relationships',
	},
	'Release Preview': {
		translation: 'Release Preview',
	},
	Religion: {
		translation: 'Religion',
	},
	Religious: {
		translation: 'Religious',
	},
	'Religious Affiliation': {
		translation: 'Religious Affiliation',
	},
	'Religious Beliefs': {
		translation: 'Religious Beliefs',
	},
	'Religious or Philosophical Beliefs': {
		translation: 'Religious or Philosophical Beliefs',
	},
	Relocated: {
		translation: 'Relocated',
	},
	Relocation: {
		translation: 'Relocation',
	},
	'Remaining Balance': {
		translation: 'Remaining Balance',
	},
	'Remaining balance': {
		translation: 'Remaining balance',
	},
	"Remember when you were a kid and saved up for candy? If you spent this whole paycheck on tootsie rolls you would be able to buy about %1$s pounds of them (at $3.43 per pound). Don't tell your dentist.":
		{
			translation:
				"Remember when you were a kid and saved up for candy? If you spent this whole paycheck on tootsie rolls you would be able to buy about %1$s pounds of them (at $3.43 per pound). Don't tell your dentist.",
		},
	'Remember, %1$sthese feeds are NOT password protected%2$s, so if you feel the link has been shared with the wrong person you can regenerate the link below.':
		{
			translation:
				'Remember, %1$sthese feeds are NOT password protected%2$s, so if you feel the link has been shared with the wrong person you can regenerate the link below.',
		},
	'Remember, Employees can only be in one Group at a time.': {
		translation: 'Remember, Employees can only be in one Group at a time.',
	},
	'Remind All Pending': {
		translation: 'Remind All Pending',
	},
	Reminder: {
		translation: 'Reminder',
	},
	'Reminder Email': {
		translation: 'Reminder Email',
	},
	'Reminder Sent': {
		translation: 'Reminder Sent',
	},
	'Reminders for this document will be sent with the New Hire Packet.': {
		translation:
			'Reminders for this document will be sent with the New Hire Packet.',
	},
	'Reminders have been sent out to all active employees who still need to sign the %1.':
		{
			translation:
				'Reminders have been sent out to all active employees who still need to sign the %1.',
		},
	'Remittance ID': {
		translation: 'Remittance ID',
	},
	'Remittance ID can be found on the Income Withholding for Support Form. We need this to process the child support payment.':
		{
			translation:
				'Remittance ID can be found on the Income Withholding for Support Form. We need this to process the child support payment.',
		},
	Remote: {
		translation: 'Remote',
	},
	'Remote EOR integration is not enabled': {
		translation: 'Remote EOR integration is not enabled',
	},
	'Remote Location': {
		translation: 'Remote Location',
	},
	'Remote Worker': {
		translation: 'Remote Worker',
	},
	'Remote access is not available when using Log In As functionality': {
		translation:
			'Remote access is not available when using Log In As functionality',
	},
	'Remote integration already installed.': {
		translation: 'Remote integration already installed.',
	},
	'Remote integration is not installed.': {
		translation: 'Remote integration is not installed.',
	},
	Remove: {
		translation: 'Remove',
	},
	'Remove Advanced Approval': {
		translation: 'Remove Advanced Approval',
	},
	'Remove Billing Contact': {
		translation: 'Remove Billing Contact',
	},
	'Remove Coverage Option': {
		translation: 'Remove Coverage Option',
	},
	'Remove File': {
		translation: 'Remove File',
	},
	'Remove Folder': {
		translation: 'Remove Folder',
	},
	'Remove History Item': {
		translation: 'Remove History Item',
	},
	'Remove Inbox Tasks': {
		translation: 'Remove Inbox Tasks',
	},
	'Remove Level': {
		translation: 'Remove Level',
	},
	'Remove Plan': {
		translation: 'Remove Plan',
	},
	'Remove Plan from This Group': {
		translation: 'Remove Plan from This Group',
	},
	'Remove Ratings': {
		translation: 'Remove Ratings',
	},
	'Remove Status': {
		translation: 'Remove Status',
	},
	'Remove User From "%1$s"': {
		translation: 'Remove User From \\"%1$s\\"',
	},
	'Remove all items': {
		translation: 'Remove all items',
	},
	'Remove from History': {
		translation: 'Remove from History',
	},
	'Remove from folder': {
		translation: 'Remove from folder',
	},
	'Remove from history': {
		translation: 'Remove from history',
	},
	'Remove highlighted items': {
		translation: 'Remove highlighted items',
	},
	'Remove photo': {
		translation: 'Remove photo',
	},
	'Remove...': {
		translation: 'Remove...',
	},
	'Removed from %s on %s': {
		translation: 'Removed from %s on %s',
	},
	'Removed from for %s': {
		translation: 'Removed from for %s',
	},
	'Removed project **{1}**': {
		translation: 'Removed project **{1}**',
	},
	'Removed report from folder': {
		translation: 'Removed report from folder',
	},
	Rename: {
		translation: 'Rename',
	},
	'Rename File': {
		translation: 'Rename File',
	},
	'Rename Folder': {
		translation: 'Rename Folder',
	},
	'Rename Selected Category': {
		translation: 'Rename Selected Category',
	},
	'Rename Selected Tasklist': {
		translation: 'Rename Selected Tasklist',
	},
	'Rename column data for this report': {
		translation: 'Rename column data for this report',
	},
	'Rename this Category': {
		translation: 'Rename this Category',
	},
	'Rename...': {
		translation: 'Rename...',
	},
	'Rename…': {
		translation: 'Rename…',
	},
	'Renewed Trainings': {
		translation: 'Renewed Trainings',
	},
	Renewing: {
		translation: 'Renewing',
	},
	'Reorder Categories': {
		translation: 'Reorder Categories',
	},
	'Reorder Fields': {
		translation: 'Reorder Fields',
	},
	'Reorder Fields for All Employees': {
		translation: 'Reorder Fields for All Employees',
	},
	'Reorder Lists': {
		translation: 'Reorder Lists',
	},
	'Reorder Tabs': {
		translation: 'Reorder Tabs',
	},
	'Repeat survey every': {
		translation: 'Repeat survey every',
	},
	'Repeats on': {
		translation: 'Repeats on',
	},
	Replace: {
		translation: 'Replace',
	},
	Reply: {
		translation: 'Reply',
	},
	'Reply to %1$s': {
		translation: 'Reply to %1$s',
	},
	'Reply to {1}': {
		translation: 'Reply to {1}',
	},
	'Report Includes': {
		translation: 'Report Includes',
	},
	'Report Name': {
		translation: 'Report Name',
	},
	'Report deleted': {
		translation: 'Report deleted',
	},
	'Report not Found.': {
		translation: 'Report not Found.',
	},
	'Report saved': {
		translation: 'Report saved',
	},
	'Reportable on the W-2?': {
		translation: 'Reportable on the W-2?',
	},
	'Reported To': {
		translation: 'Reported To',
	},
	'Reported to': {
		translation: 'Reported to',
	},
	Reporting: {
		translation: 'Reporting',
	},
	'Reporting to': {
		translation: 'Reporting to',
	},
	Reports: {
		translation: 'Reports',
	},
	'Reports Deleted': {
		translation: 'Reports Deleted',
	},
	'Reports Directly to %1$s': {
		translation: 'Reports Directly to %1$s',
	},
	'Reports To': {
		translation: 'Reports To',
	},
	'Reports To Title': {
		translation: 'Reports To Title',
	},
	'Reports to': {
		translation: 'Reports to',
	},
	'Reports to Manager': {
		translation: 'Reports to Manager',
	},
	'Reports to Master Panda': {
		translation: 'Reports to Master Panda',
	},
	'Reports to Title': {
		translation: 'Reports to Title',
	},
	'Reports: Signed Document Details': {
		translation: 'Reports: Signed Document Details',
	},
	'Reports: Signed Document Details - ': {
		translation: 'Reports: Signed Document Details - ',
	},
	'Reports: Signed Documents': {
		translation: 'Reports: Signed Documents',
	},
	'Repost Job Opening': {
		translation: 'Repost Job Opening',
	},
	'Repost this job opening to %1.': {
		translation: 'Repost this job opening to %1.',
	},
	'Request Canceled': {
		translation: 'Request Canceled',
	},
	'Request Comments': {
		translation: 'Request Comments',
	},
	'Request Deleted': {
		translation: 'Request Deleted',
	},
	'Request Denied': {
		translation: 'Request Denied',
	},
	'Request E-Signatures and Set Up Templates': {
		translation: 'Request E-Signatures and Set Up Templates',
	},
	'Request E-Signatures and Setup Templates': {
		translation: 'Request E-Signatures and Setup Templates',
	},
	'Request E-signature': {
		translation: 'Request E-signature',
	},
	'Request Feedback': {
		translation: 'Request Feedback',
	},
	'Request Info': {
		translation: 'Request Info',
	},
	'Request New Link': {
		translation: 'Request New Link',
	},
	'Request Right Signature': {
		translation: 'Request Right Signature',
	},
	'Request Signature': {
		translation: 'Request Signature',
	},
	'Request Signatures': {
		translation: 'Request Signatures',
	},
	'Request Time Off': {
		translation: 'Request Time Off',
	},
	'Request Time Off Amounts': {
		translation: 'Request Time Off Amounts',
	},
	'Request Time Off from Your Phone': {
		translation: 'Request Time Off from Your Phone',
	},
	'Request Time off': {
		translation: 'Request Time off',
	},
	'Request a Change': {
		translation: 'Request a Change',
	},
	'Request a Contract Amendment': {
		translation: 'Request a Contract Amendment',
	},
	'Request a New Custom Field': {
		translation: 'Request a New Custom Field',
	},
	'Request a New Link': {
		translation: 'Request a New Link',
	},
	'Request a Personalized Demo': {
		translation: 'Request a Personalized Demo',
	},
	'Request cannot span more than a year and start date must come before end date!':
		{
			translation:
				'Request cannot span more than a year and start date must come before end date!',
		},
	'Request e-signature': {
		translation: 'Request e-signature',
	},
	'Request feedback from...': {
		translation: 'Request feedback from...',
	},
	'Request for ${date}': {
		translation: 'Request for ${date}',
	},
	'Request for %1': {
		translation: 'Request for %1',
	},
	'Request has been sent. We will reach out soon by email to upgrade your BambooHR file storage.':
		{
			translation:
				'Request has been sent. We will reach out soon by email to upgrade your BambooHR file storage.',
		},
	'Request the required account information including your BeneTrac Site ID from your BeneTrac account representative.':
		{
			translation:
				'Request the required account information including your BeneTrac Site ID from your BeneTrac account representative.',
		},
	'Request time off and check your balances.': {
		translation: 'Request time off and check your balances.',
	},
	'Request time off from your phone': {
		translation: 'Request time off from your phone',
	},
	RequestData: {
		translation: 'RequestData',
	},
	Requested: {
		translation: 'Requested',
	},
	'Requested Date': {
		translation: 'Requested Date',
	},
	'Requested by': {
		translation: 'Requested by',
	},
	'Requested by %1$s %2$s': {
		translation: 'Requested by %1$s %2$s',
	},
	'Requested by %1$s %2$s regarding %3$s': {
		translation: 'Requested by %1$s %2$s regarding %3$s',
	},
	"Requester's Profile Pic": {
		translation: "Requester's Profile Pic",
	},
	'Requesting %1$s %2$s of %3$s.': {
		translation: 'Requesting %1$s %2$s of %3$s.',
	},
	Requests: {
		translation: 'Requests',
	},
	'Requests currently in this approval will remain so until their requests are approved or denied.':
		{
			translation:
				'Requests currently in this approval will remain so until their requests are approved or denied.',
		},
	'Requests for feedback must be sent before': {
		translation: 'Requests for feedback must be sent before',
	},
	'Requests must be less than 10 years': {
		translation: 'Requests must be less than 10 years',
	},
	'Require a file to be uploaded before the task can be completed': {
		translation:
			'Require a file to be uploaded before the task can be completed',
	},
	'Require employee location when clocking in and out.': {
		translation: 'Require employee location when clocking in and out.',
	},
	Required: {
		translation: 'Required',
	},
	'Required Annual Trainings': {
		translation: 'Required Annual Trainings',
	},
	'Required Bank Forms': {
		translation: 'Required Bank Forms',
	},
	'Required Date': {
		translation: 'Required Date',
	},
	'Required Field': {
		translation: 'Required Field',
	},
	'Required Forms': {
		translation: 'Required Forms',
	},
	'Required one-time': {
		translation: 'Required one-time',
	},
	'Required?': {
		translation: 'Required?',
	},
	'Requirements for Dashboard: Owner or Admin, Toggle enabled, & company part of beta group':
		{
			translation:
				'Requirements for Dashboard: Owner or Admin, Toggle enabled, & company part of beta group',
		},
	'Requirements for InsightsGrid: Owner or Admin, Toggle enabled, & company part of beta group':
		{
			translation:
				'Requirements for InsightsGrid: Owner or Admin, Toggle enabled, & company part of beta group',
		},
	'Requires Access to All Active Time Off Categories': {
		translation: 'Requires Access to All Active Time Off Categories',
	},
	'Requires Access to All Time Off Categories': {
		translation: 'Requires Access to All Time Off Categories',
	},
	'Requires Ask BambooHR to be enabled': {
		translation: 'Requires Ask BambooHR to be enabled',
	},
	Rerun: {
		translation: 'Rerun',
	},
	'Rerun All': {
		translation: 'Rerun All',
	},
	'Resellers must have a user': {
		translation: 'Resellers must have a user',
	},
	Resend: {
		translation: 'Resend',
	},
	'Resend Email': {
		translation: 'Resend Email',
	},
	'Resend New Hire Packet to': {
		translation: 'Resend New Hire Packet to',
	},
	'Resend Offer': {
		translation: 'Resend Offer',
	},
	'Resend Packet': {
		translation: 'Resend Packet',
	},
	'Reserve Payment Required': {
		translation: 'Reserve Payment Required',
	},
	Reset: {
		translation: 'Reset',
	},
	'Reset 2-Step Login': {
		translation: 'Reset 2-Step Login',
	},
	'Reset All Benefit Settings': {
		translation: 'Reset All Benefit Settings',
	},
	'Reset All Benefits Settings': {
		translation: 'Reset All Benefits Settings',
	},
	'Reset Inbox Tasks': {
		translation: 'Reset Inbox Tasks',
	},
	'Reset Inbox Tasks (preserve older review periods)': {
		translation: 'Reset Inbox Tasks (preserve older review periods)',
	},
	'Reset Password': {
		translation: 'Reset Password',
	},
	'Reset Reminders (Currently: %1$s)': {
		translation: 'Reset Reminders (Currently: %1$s)',
	},
	'Reset Tracking': {
		translation: 'Reset Tracking',
	},
	'Reset URL': {
		translation: 'Reset URL',
	},
	'Reset User 2-Step Login': {
		translation: 'Reset User 2-Step Login',
	},
	'Reset User Passwords': {
		translation: 'Reset User Passwords',
	},
	"Reset User's Password": {
		translation: "Reset User's Password",
	},
	'Reset Your Password to Continue.': {
		translation: 'Reset Your Password to Continue.',
	},
	'Reset negative time off balances to 0 hours on carryover date': {
		translation:
			'Reset negative time off balances to 0 hours on carryover date',
	},
	'Reset password for %1$s?': {
		translation: 'Reset password for %1$s?',
	},
	'Reset to Default': {
		translation: 'Reset to Default',
	},
	'Reset your password': {
		translation: 'Reset your password',
	},
	'Resetting will let you start over by tracking changes from this point forward. A history of prior changes will be lost.':
		{
			translation:
				'Resetting will let you start over by tracking changes from this point forward. A history of prior changes will be lost.',
		},
	'Residence (last 5 yrs.)': {
		translation: 'Residence (last 5 yrs.)',
	},
	'Resident Tax State': {
		translation: 'Resident Tax State',
	},
	'Residential address': {
		translation: 'Residential address',
	},
	'Resignation (Voluntary)': {
		translation: 'Resignation (Voluntary)',
	},
	'Resize crop box with arrow keys. Hold shift to resize faster.': {
		translation:
			'Resize crop box with arrow keys. Hold shift to resize faster.',
	},
	Response: {
		translation: {
			one: 'Response',
			other: 'Total Responses',
		},
	},
	'Response Rate Information': {
		translation: 'Response Rate Information',
	},
	'Response row did not validate properly - field count is incorrect': {
		translation:
			'Response row did not validate properly - field count is incorrect',
	},
	Responses: {
		translation: 'Responses',
	},
	'Restore Default Approval': {
		translation: 'Restore Default Approval',
	},
	'Restore Default Approval?': {
		translation: 'Restore Default Approval?',
	},
	'Restore User': {
		translation: 'Restore User',
	},
	'Restore failed, could not drop company db': {
		translation: 'Restore failed, could not drop company db',
	},
	'Restore failed, restored to restore point: ': {
		translation: 'Restore failed, restored to restore point: ',
	},
	'Restoring the default approval will overwrite any changes you have made to this approval. Sure you want to do this?':
		{
			translation:
				'Restoring the default approval will overwrite any changes you have made to this approval. Sure you want to do this?',
		},
	"Restoring these files would cause you to exceed your plan's storage limit.":
		{
			translation:
				"Restoring these files would cause you to exceed your plan's storage limit.",
		},
	Result: {
		translation: 'Result',
	},
	'Result of Hours Import on %1': {
		translation: 'Result of Hours Import on %1',
	},
	Results: {
		translation: 'Results',
	},
	Resume: {
		translation: 'Resume',
	},
	Retired: {
		translation: 'Retired',
	},
	Retirement: {
		translation: 'Retirement',
	},
	'Retirement Plan': {
		translation: 'Retirement Plan',
	},
	'Retirement plan (post-tax)': {
		translation: 'Retirement plan (post-tax)',
	},
	'Retirement plan for government workers (post-tax)': {
		translation: 'Retirement plan for government workers (post-tax)',
	},
	'Retirement plan for government workers (pre-tax)': {
		translation: 'Retirement plan for government workers (pre-tax)',
	},
	'Return To Ancillary Charges Importer': {
		translation: 'Return To Ancillary Charges Importer',
	},
	'Return To Benefit Import': {
		translation: 'Return To Benefit Import',
	},
	'Return with honor.': {
		translation: 'Return with honor.',
	},
	Returned: {
		translation: 'Returned',
	},
	'Review & Sign': {
		translation: 'Review & Sign',
	},
	'Review Answers': {
		translation: 'Review Answers',
	},
	'Review Cycle': {
		translation: 'Review Cycle',
	},
	'Review Date': {
		translation: 'Review Date',
	},
	'Review Period': {
		translation: 'Review Period',
	},
	'Review Period End': {
		translation: 'Review Period End',
	},
	'Review Period Frequency': {
		translation: 'Review Period Frequency',
	},
	'Review Period Start': {
		translation: 'Review Period Start',
	},
	'Review Schedule': {
		translation: 'Review Schedule',
	},
	'Review period cannot be an impromptu type.': {
		translation: 'Review period cannot be an impromptu type.',
	},
	'Review period must be current and open, or already past.': {
		translation: 'Review period must be current and open, or already past.',
	},
	'Review period must be current and open.': {
		translation: 'Review period must be current and open.',
	},
	'Review periods are %1 months long, then repeat.': {
		translation: 'Review periods are %1 months long, then repeat.',
	},
	'Review resumes, email candidates, and more with the BambooHR Hiring app.': {
		translation:
			'Review resumes, email candidates, and more with the BambooHR Hiring app.',
	},
	'Review your benefit information': {
		translation: 'Review your benefit information',
	},
	'Review your billing information and make a payment': {
		translation: 'Review your billing information and make a payment',
	},
	Reviewed: {
		translation: 'Reviewed',
	},
	Reviewer: {
		translation: 'Reviewer',
	},
	'Revise Offer': {
		translation: 'Revise Offer',
	},
	Revised: {
		translation: 'Revised',
	},
	'Revised offer was sent to {1} at {2} for **{3}**': {
		translation: 'Revised offer was sent to {1} at {2} for **{3}**',
	},
	'Revised offer was sent to {1} at {2} for [**{3}**]': {
		translation: 'Revised offer was sent to {1} at {2} for [**{3}**]',
	},
	'Revised offer was sent to {1} for **{3}**': {
		translation: 'Revised offer was sent to {1} for **{3}**',
	},
	'Revised offer was sent to {1} for [**{3}**]': {
		translation: 'Revised offer was sent to {1} for [**{3}**]',
	},
	'Right axis for chart': {
		translation: 'Right axis for chart',
	},
	RightSignature: {
		translation: 'RightSignature',
	},
	'RightSignature account:': {
		translation: 'RightSignature account:',
	},
	"RightSignature is the easiest, fastest way to get onboarding paperwork, handbook acknowledgements, and any document signed online with a legally binding e-signature. Your employees fill out and sign the documents online in any web browser, or even on a mobile device. No printing, no faxing, no hassle. Documents can be sent for signature directly from inside BambooHR, even merging employee data into the document. Real-time statistics provide visibility into each employee's signing status, and completed documents are attached to the employee file.":
		{
			translation:
				"RightSignature is the easiest, fastest way to get onboarding paperwork, handbook acknowledgements, and any document signed online with a legally binding e-signature. Your employees fill out and sign the documents online in any web browser, or even on a mobile device. No printing, no faxing, no hassle. Documents can be sent for signature directly from inside BambooHR, even merging employee data into the document. Real-time statistics provide visibility into each employee's signing status, and completed documents are attached to the employee file.",
		},
	'Rock Star': {
		translation: 'Rock Star',
	},
	Role: {
		translation: 'Role',
	},
	'Routing #': {
		translation: 'Routing #',
	},
	'Routing Number': {
		translation: 'Routing Number',
	},
	'Routing Number:': {
		translation: 'Routing Number:',
	},
	'Row #': {
		translation: 'Row #',
	},
	'Row deletion': {
		translation: 'Row deletion',
	},
	'Row number': {
		translation: 'Row number',
	},
	'Rule of thumb?': {
		translation: 'Rule of thumb?',
	},
	Run: {
		translation: 'Run',
	},
	'Run Migrations': {
		translation: 'Run Migrations',
	},
	'Run Payroll': {
		translation: 'Run Payroll',
	},
	'Run Query': {
		translation: 'Run Query',
	},
	'Run Report': {
		translation: 'Run Report',
	},
	'Run your first payroll with help from a dedicated payroll specialist': {
		translation:
			'Run your first payroll with help from a dedicated payroll specialist',
	},
	'S.S.O.P. Trainer': {
		translation: 'S.S.O.P. Trainer',
	},
	'SAML Certificate: This can be found under the Security Tab and then the SAML Tab within OneLogin. Be sure to copy the entire certificate including the "BEGIN CERTIFICATE" and "END CERTIFICATE" lines.':
		{
			translation:
				'SAML Certificate: This can be found under the Security Tab and then the SAML Tab within OneLogin. Be sure to copy the entire certificate including the \\"BEGIN CERTIFICATE\\" and \\"END CERTIFICATE\\" lines.',
		},
	SEI: {
		translation: 'SEI',
	},
	'SHRM Certification': {
		translation: 'SHRM Certification',
	},
	SIN: {
		translation: 'SIN',
	},
	SMS: {
		translation: 'SMS',
	},
	SSN: {
		translation: 'SSN',
	},
	'SSN cannot be empty': {
		translation: 'SSN cannot be empty',
	},
	'SSN is invalid or required': {
		translation: 'SSN is invalid or required',
	},
	'SSN is required': {
		translation: 'SSN is required',
	},
	'SSN must be a valid SSN': {
		translation: 'SSN must be a valid SSN',
	},
	'SSN must be unique': {
		translation: 'SSN must be unique',
	},
	'SSN or EIN is required': {
		translation: 'SSN or EIN is required',
	},
	'SSO Login URL': {
		translation: 'SSO Login URL',
	},
	'SSO URL: This can be found under the Apps Tab within OneLogin and then by editing the BambooHR App. You will then click on the Single Sign-on Tab to locate the URL.':
		{
			translation:
				'SSO URL: This can be found under the Apps Tab within OneLogin and then by editing the BambooHR App. You will then click on the Single Sign-on Tab to locate the URL.',
		},
	'SSO capability with OneLogin is enabled in both OneLogin and in BambooHR.': {
		translation:
			'SSO capability with OneLogin is enabled in both OneLogin and in BambooHR.',
	},
	'Safe Harbor Match': {
		translation: 'Safe Harbor Match',
	},
	'Safety Policies & Procedures': {
		translation: 'Safety Policies & Procedures',
	},
	'Safety Training': {
		translation: 'Safety Training',
	},
	'Safety Training 1': {
		translation: 'Safety Training 1',
	},
	'Safety Training 1 Date': {
		translation: 'Safety Training 1 Date',
	},
	'Safety Training 2': {
		translation: 'Safety Training 2',
	},
	'Safety Training 2 Date': {
		translation: 'Safety Training 2 Date',
	},
	'Safety Training 3': {
		translation: 'Safety Training 3',
	},
	'Safety Training 3 Date': {
		translation: 'Safety Training 3 Date',
	},
	'Safety Training 4': {
		translation: 'Safety Training 4',
	},
	'Safety Training 4 Date': {
		translation: 'Safety Training 4 Date',
	},
	'Safety Training 5': {
		translation: 'Safety Training 5',
	},
	'Safety Training 5 Date': {
		translation: 'Safety Training 5 Date',
	},
	'Safety Training 6': {
		translation: 'Safety Training 6',
	},
	'Safety Training 6 Date': {
		translation: 'Safety Training 6 Date',
	},
	'Safety Training 7': {
		translation: 'Safety Training 7',
	},
	'Safety Training 7 Date': {
		translation: 'Safety Training 7 Date',
	},
	'Salaried employees cannot be paid per hour.': {
		translation: 'Salaried employees cannot be paid per hour.',
	},
	Salary: {
		translation: 'Salary',
	},
	'Salary Band': {
		translation: 'Salary Band',
	},
	'Salary History': {
		translation: 'Salary History',
	},
	'Salary Increase': {
		translation: 'Salary Increase',
	},
	'Salary Non-Exempt': {
		translation: 'Salary Non-Exempt',
	},
	'Salary non-exempt': {
		translation: 'Salary non-exempt',
	},
	Sales: {
		translation: 'Sales',
	},
	'Sales Director': {
		translation: 'Sales Director',
	},
	'Sales Rep': {
		translation: 'Sales Rep',
	},
	'Sales Rep (optional)': {
		translation: 'Sales Rep (optional)',
	},
	'Sales Team Lead': {
		translation: 'Sales Team Lead',
	},
	'Sales Trainer': {
		translation: 'Sales Trainer',
	},
	'Sales Workers': {
		translation: 'Sales Workers',
	},
	'Sales projected': {
		translation: 'Sales projected',
	},
	'Salesforce Info ID has been updated.': {
		translation: 'Salesforce Info ID has been updated.',
	},
	'Salesforce Payroll Info ID': {
		translation: 'Salesforce Payroll Info ID',
	},
	'Salesforce Payroll Info ID: %1$s': {
		translation: 'Salesforce Payroll Info ID: %1$s',
	},
	'Salt Lake City, Utah': {
		translation: 'Salt Lake City, Utah',
	},
	'Sample Data': {
		translation: 'Sample Data',
	},
	'Sample data': {
		translation: 'Sample data',
	},
	Saturday: {
		translation: 'Saturday',
	},
	Saturdays: {
		translation: 'Saturdays',
	},
	Save: {
		translation: 'Save',
	},
	'Save & Add %1$s': {
		translation: 'Save & Add %1$s',
	},
	'Save & Close': {
		translation: 'Save & Close',
	},
	'Save & Continue': {
		translation: 'Save & Continue',
	},
	'Save & Continue »': {
		translation: 'Save & Continue »',
	},
	'Save & Create New Hire Packet': {
		translation: 'Save & Create New Hire Packet',
	},
	'Save & Finish': {
		translation: 'Save & Finish',
	},
	'Save & Finish Later': {
		translation: 'Save & Finish Later',
	},
	'Save & Finish »': {
		translation: 'Save & Finish »',
	},
	'Save & Send Later': {
		translation: 'Save & Send Later',
	},
	'Save Access Level': {
		translation: 'Save Access Level',
	},
	'Save Anyway': {
		translation: 'Save Anyway',
	},
	'Save Benefit Group': {
		translation: 'Save Benefit Group',
	},
	'Save Change': {
		translation: 'Save Change',
	},
	'Save Changes': {
		translation: 'Save Changes',
	},
	'Save Comment': {
		translation: 'Save Comment',
	},
	'Save Draft': {
		translation: 'Save Draft',
	},
	'Save Group & Add Plans': {
		translation: 'Save Group & Add Plans',
	},
	'Save Job Opening': {
		translation: 'Save Job Opening',
	},
	'Save Partner': {
		translation: 'Save Partner',
	},
	'Save Password': {
		translation: 'Save Password',
	},
	'Save Plan': {
		translation: 'Save Plan',
	},
	'Save Settings': {
		translation: 'Save Settings',
	},
	'Save Task': {
		translation: 'Save Task',
	},
	'Save Template': {
		translation: 'Save Template',
	},
	'Save and Finish': {
		translation: 'Save and Finish',
	},
	'Save and Finish Later': {
		translation: 'Save and Finish Later',
	},
	'Save in Employee Folder': {
		translation: 'Save in Employee Folder',
	},
	'Save some time': {
		translation: 'Save some time',
	},
	'Save successful': {
		translation: 'Save successful',
	},
	'Save time to...': {
		translation: 'Save time to...',
	},
	'Save time, reduce errors, and virtually eliminate double entry with an integrated payroll experience from BambooHR':
		{
			translation:
				'Save time, reduce errors, and virtually eliminate double entry with an integrated payroll experience from BambooHR',
		},
	'Save to Timesheet': {
		translation: 'Save to Timesheet',
	},
	'Save your password': {
		translation: 'Save your password',
	},
	'Saved to Timesheet': {
		translation: 'Saved to Timesheet',
	},
	Saving: {
		translation: 'Saving',
	},
	'Saving your changes will remove this document from one or more offer letter templates':
		{
			translation:
				'Saving your changes will remove this document from one or more offer letter templates',
		},
	'Saving your changes will remove this document from one or more offer letter templates.':
		{
			translation:
				'Saving your changes will remove this document from one or more offer letter templates.',
		},
	Savings: {
		translation: 'Savings',
	},
	'Scanning and upload complete.': {
		translation: 'Scanning and upload complete.',
	},
	'Scanning and uploading the file.': {
		translation: 'Scanning and uploading the file.',
	},
	Schedule: {
		translation: 'Schedule',
	},
	'Schedule Interview': {
		translation: 'Schedule Interview',
	},
	'Schedule Kick-Off': {
		translation: 'Schedule Kick-Off',
	},
	'Schedule Kick-off': {
		translation: 'Schedule Kick-off',
	},
	'Schedule Notification': {
		translation: 'Schedule Notification',
	},
	'Schedule Phone Screen': {
		translation: 'Schedule Phone Screen',
	},
	'Schedule Recurring Email': {
		translation: 'Schedule Recurring Email',
	},
	'Schedule Start Date': {
		translation: 'Schedule Start Date',
	},
	'Schedule Time Tracking': {
		translation: 'Schedule Time Tracking',
	},
	'Schedule Time Tracking Demo': {
		translation: 'Schedule Time Tracking Demo',
	},
	'Schedule Time Tracking?': {
		translation: 'Schedule Time Tracking?',
	},
	'Schedule a Personal Demo': {
		translation: 'Schedule a Personal Demo',
	},
	Scheduled: {
		translation: 'Scheduled',
	},
	'Scheduled Alert Dates': {
		translation: 'Scheduled Alert Dates',
	},
	'Scheduled to be sent': {
		translation: 'Scheduled to be sent',
	},
	'Scheduled to begin tracking %1$s': {
		translation: 'Scheduled to begin tracking %1$s',
	},
	School: {
		translation: 'School',
	},
	'School start date': {
		translation: 'School start date',
	},
	Score: {
		translation: 'Score',
	},
	'Scroll down to the HRIS section and click the Connect button next to BambooHR':
		{
			translation:
				'Scroll down to the HRIS section and click the Connect button next to BambooHR',
		},
	Search: {
		translation: 'Search',
	},
	'Search All Employees': {
		translation: 'Search All Employees',
	},
	'Search Fields': {
		translation: 'Search Fields',
	},
	'Search by name, title, department, etc...': {
		translation: 'Search by name, title, department, etc...',
	},
	'Search filter clear button': {
		translation: 'Search filter clear button',
	},
	'Search for coworkers and their contact info.': {
		translation: 'Search for coworkers and their contact info.',
	},
	'Search...': {
		translation: 'Search...',
	},
	Seasonal: {
		translation: 'Seasonal',
	},
	'Sec. 125': {
		translation: 'Sec. 125',
	},
	'Second Contract': {
		translation: 'Second Contract',
	},
	'Second Contract Salary': {
		translation: 'Second Contract Salary',
	},
	'Second Dose': {
		translation: 'Second Dose',
	},
	'Second car': {
		translation: 'Second car',
	},
	'Second language': {
		translation: 'Second language',
	},
	'Secondary Job Title': {
		translation: 'Secondary Job Title',
	},
	'Secondary Language': {
		translation: 'Secondary Language',
	},
	'Section 125': {
		translation: 'Section 125',
	},
	'Section 125 (pre-tax)': {
		translation: 'Section 125 (pre-tax)',
	},
	'Section 125 - Pre-Tax': {
		translation: 'Section 125 - Pre-Tax',
	},
	'Section 132 (pre-tax)': {
		translation: 'Section 132 (pre-tax)',
	},
	'Section header': {
		translation: 'Section header',
	},
	'Secure Download Link': {
		translation: 'Secure Download Link',
	},
	'Secure files are only available for a limited time. Contact the sender if you still need access.':
		{
			translation:
				'Secure files are only available for a limited time. Contact the sender if you still need access.',
		},
	Security: {
		translation: 'Security',
	},
	'Security Assertion Markup Language (SAML) is an XML-based open standard data format for exchanging authentication and authorization data between parties, in particular, between an identity provider and a service provider.':
		{
			translation:
				'Security Assertion Markup Language (SAML) is an XML-based open standard data format for exchanging authentication and authorization data between parties, in particular, between an identity provider and a service provider.',
		},
	'Security clearance level': {
		translation: 'Security clearance level',
	},
	'See About Other Employees': {
		translation: 'See About Other Employees',
	},
	'See About Themselves': {
		translation: 'See About Themselves',
	},
	'See About other Employees': {
		translation: 'See About other Employees',
	},
	'See Applicant': {
		translation: 'See Applicant',
	},
	'See Applicants': {
		translation: 'See Applicants',
	},
	'See Comments': {
		translation: 'See Comments',
	},
	'See Current Openings': {
		translation: 'See Current Openings',
	},
	'See My Assessment': {
		translation: 'See My Assessment',
	},
	'See Offer Documents': {
		translation: 'See Offer Documents',
	},
	'See Own Information': {
		translation: 'See Own Information',
	},
	'See Signed Offer': {
		translation: 'See Signed Offer',
	},
	'See all Job Openings': {
		translation: 'See all Job Openings',
	},
	'See all tags': {
		translation: 'See all tags',
	},
	'See company policy for details': {
		translation: 'See company policy for details',
	},
	'See here for more details.': {
		translation: 'See here for more details.',
	},
	'See less': {
		translation: 'See less',
	},
	'See more': {
		translation: 'See more',
	},
	'See old version': {
		translation: 'See old version',
	},
	'See old versions': {
		translation: 'See old versions',
	},
	'See on Home': {
		translation: 'See on Home',
	},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/forums/20617107-Simplepay-ca-Payroll-Processing-Time-Attendance-" target="_blank" rel="noopener noreferrer">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/forums/20617107-Simplepay-ca-Payroll-Processing-Time-Attendance-\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216830437-How-does-ApplicantPRO-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830437-How-does-ApplicantPRO-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216830487-How-does-BeneTrac-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830487-How-does-BeneTrac-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216830597-How-does-Jazz-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830597-How-does-Jazz-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216830697-How-does-TraxPayroll-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830697-How-does-TraxPayroll-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216830837-Jobvite">clicking here</a>':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216830837-Jobvite\\">clicking here</a>',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831147-How-does-HiringThing-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831147-How-does-HiringThing-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831297-How-does-Performance-Pro-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831297-How-does-Performance-Pro-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831337-How-does-SwipeClock-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831337-How-does-SwipeClock-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831367-How-does-OneLogin-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831367-How-does-OneLogin-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831407-How-does-CATS-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831407-How-does-CATS-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831477-How-does-NetSuite-Integrate-with-BambooHR-">clicking here</a>':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831477-How-does-NetSuite-Integrate-with-BambooHR-\\">clicking here</a>',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831587-How-does-OrgChart-Now-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831587-How-does-OrgChart-Now-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831827-How-does-Bitium-Integrate-with-BambooHR-">clicking here</a>':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831827-How-does-Bitium-Integrate-with-BambooHR-\\">clicking here</a>',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216831957-How-does-NimbleSchedule-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216831957-How-does-NimbleSchedule-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/216835537-How-does-Maxwell-Health-Integrate-with-BambooHR-">clicking here</a>.':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/216835537-How-does-Maxwell-Health-Integrate-with-BambooHR-\\">clicking here</a>.',
		},
	'See our Help Center articles about this integration by <a href="https://help.bamboohr.com/hc/en-us/articles/225082068-How-does-Newton-Integrate-with-BambooHR-">clicking here</a>':
		{
			translation:
				'See our Help Center articles about this integration by <a href=\\"https://help.bamboohr.com/hc/en-us/articles/225082068-How-does-Newton-Integrate-with-BambooHR-\\">clicking here</a>',
		},
	'See our current job openings': {
		translation: 'See our current job openings',
	},
	'See the report': {
		translation: 'See the report',
	},
	'See the trend after your next survey': {
		translation: 'See the trend after your next survey',
	},
	'See their own information': {
		translation: 'See their own information',
	},
	'See their own time off balance information': {
		translation: 'See their own time off balance information',
	},
	"See what's missing so you can take action. There's nothing better than complete data!":
		{
			translation:
				"See what's missing so you can take action. There's nothing better than complete data!",
		},
	'See which company benefits you are enrolled in.': {
		translation: 'See which company benefits you are enrolled in.',
	},
	'See whos in in the following ': {
		translation: 'See whos in in the following ',
	},
	'See whos out in the following ': {
		translation: 'See whos out in the following ',
	},
	'See ya later.': {
		translation: 'See ya later.',
	},
	'See you soon.': {
		translation: 'See you soon.',
	},
	'Seed Database!': {
		translation: 'Seed Database!',
	},
	Select: {
		translation: 'Select',
	},
	'Select "**Open**" to post this job on [{1}].': {
		translation: 'Select \\"**Open**\\" to post this job on [{1}].',
	},
	'Select "<strong>Open</strong>" to post this job on %s.': {
		translation: 'Select \\"<strong>Open</strong>\\" to post this job on %s.',
	},
	'Select "Manually Updated Balance" if you prefer to keep this employee\'s accrual balance up to date by manually adjusting it periodically.':
		{
			translation:
				'Select \\"Manually Updated Balance\\" if you prefer to keep this employee\'s accrual balance up to date by manually adjusting it periodically.',
		},
	'Select "None" if you prefer to track the amount used instead of available balance. (e.g. Flexible, Jury Duty, Unlimited, etc.)':
		{
			translation:
				'Select \\"None\\" if you prefer to track the amount used instead of available balance. (e.g. Flexible, Jury Duty, Unlimited, etc.)',
		},
	'Select %s File': {
		translation: 'Select %s File',
	},
	'Select All Files': {
		translation: 'Select All Files',
	},
	'Select BambooHR': {
		translation: 'Select BambooHR',
	},
	'Select Benefits': {
		translation: 'Select Benefits',
	},
	'Select Collection Method': {
		translation: 'Select Collection Method',
	},
	'Select Company': {
		translation: 'Select Company',
	},
	'Select Date': {
		translation: 'Select Date',
	},
	'Select Date Range': {
		translation: 'Select Date Range',
	},
	'Select Employees': {
		translation: 'Select Employees',
	},
	'Select Employment Statuses where Employees always work at least 30 hours per week.':
		{
			translation:
				'Select Employment Statuses where Employees always work at least 30 hours per week.',
		},
	'Select Employment Statuses where Employees’ hours vary, but often exceed 30 hours per week.':
		{
			translation:
				'Select Employment Statuses where Employees’ hours vary, but often exceed 30 hours per week.',
		},
	'Select Fields': {
		translation: 'Select Fields',
	},
	'Select File...': {
		translation: 'Select File...',
	},
	'Select Groups': {
		translation: 'Select Groups',
	},
	'Select Job Opening': {
		translation: 'Select Job Opening',
	},
	'Select Job Titles': {
		translation: 'Select Job Titles',
	},
	'Select Manager': {
		translation: 'Select Manager',
	},
	'Select Month': {
		translation: 'Select Month',
	},
	'Select New Dates': {
		translation: 'Select New Dates',
	},
	'Select New Expiration Date': {
		translation: 'Select New Expiration Date',
	},
	'Select Pay Period': {
		translation: 'Select Pay Period',
	},
	'Select Pay Schedule': {
		translation: 'Select Pay Schedule',
	},
	'Select People to Provide Peer Feedback on Your Team': {
		translation: 'Select People to Provide Peer Feedback on Your Team',
	},
	'Select Periods': {
		translation: 'Select Periods',
	},
	'Select Plans': {
		translation: 'Select Plans',
	},
	'Select Policy Flag(s)': {
		translation: 'Select Policy Flag(s)',
	},
	'Select Project/Task': {
		translation: 'Select Project/Task',
	},
	'Select Refund Method': {
		translation: 'Select Refund Method',
	},
	'Select Some Options': {
		translation: 'Select Some Options',
	},
	'Select W-4': {
		translation: 'Select W-4',
	},
	'Select Year': {
		translation: 'Select Year',
	},
	'Select Your Information': {
		translation: 'Select Your Information',
	},
	'Select a Benefit Group': {
		translation: 'Select a Benefit Group',
	},
	'Select a Color': {
		translation: 'Select a Color',
	},
	'Select a Company/EIN for this pay schedule': {
		translation: 'Select a Company/EIN for this pay schedule',
	},
	'Select a Different File...': {
		translation: 'Select a Different File...',
	},
	'Select a Job Opening': {
		translation: 'Select a Job Opening',
	},
	'Select a Pay Group...': {
		translation: 'Select a Pay Group...',
	},
	'Select a Plan': {
		translation: 'Select a Plan',
	},
	'Select a Status': {
		translation: 'Select a Status',
	},
	'Select a Survey': {
		translation: 'Select a Survey',
	},
	'Select a date at least %1 months from the last eNPS survey.': {
		translation: 'Select a date at least %1 months from the last eNPS survey.',
	},
	'Select a field': {
		translation: 'Select a field',
	},
	'Select a file for %1$s to sign': {
		translation: 'Select a file for %1$s to sign',
	},
	'Select a name for your copied plan.': {
		translation: 'Select a name for your copied plan.',
	},
	'Select a name for your duplicated plan': {
		translation: 'Select a name for your duplicated plan',
	},
	'Select a pay schedule to see the goods.': {
		translation: 'Select a pay schedule to see the goods.',
	},
	'Select a table': {
		translation: 'Select a table',
	},
	'Select a theme that fits well with your brand to help your employees feel more at home in BambooHR.':
		{
			translation:
				'Select a theme that fits well with your brand to help your employees feel more at home in BambooHR.',
		},
	'Select a value': {
		translation: 'Select a value',
	},
	'Select all items': {
		translation: 'Select all items',
	},
	'Select all rows': {
		translation: 'Select all rows',
	},
	'Select all that apply': {
		translation: 'Select all that apply',
	},
	'Select all {1} Candidates.': {
		translation: 'Select all {1} Candidates.',
	},
	'Select an Import Type': {
		translation: 'Select an Import Type',
	},
	'Select an action first...': {
		translation: 'Select an action first...',
	},
	'Select an area to customize access.': {
		translation: 'Select an area to customize access.',
	},
	'Select any others that apply:': {
		translation: 'Select any others that apply:',
	},
	'Select employee info to display': {
		translation: 'Select employee info to display',
	},
	'Select employee personal and job information is pushed from BambooHR to Netsuite within one minute of being added or updated in BambooHR.':
		{
			translation:
				'Select employee personal and job information is pushed from BambooHR to Netsuite within one minute of being added or updated in BambooHR.',
		},
	'Select highlighted items': {
		translation: 'Select highlighted items',
	},
	'Select payroll user for enrollment contact': {
		translation: 'Select payroll user for enrollment contact',
	},
	'Select people to provide feedback on your team': {
		translation: 'Select people to provide feedback on your team',
	},
	'Select row %s': {
		translation: 'Select row %s',
	},
	'Select the "BambooHR" option under the "Integrate" section': {
		translation:
			'Select the \\"BambooHR\\" option under the \\"Integrate\\" section',
	},
	'Select the Benefit Groups this plan will apply to': {
		translation: 'Select the Benefit Groups this plan will apply to',
	},
	'Select the Employees you would like to add to this Group.': {
		translation: 'Select the Employees you would like to add to this Group.',
	},
	"Select the Employees you'd like to add to %1$s:": {
		translation: "Select the Employees you'd like to add to %1$s:",
	},
	'Select the File': {
		translation: 'Select the File',
	},
	'Select the Plans you would like to apply to this group.': {
		translation: 'Select the Plans you would like to apply to this group.',
	},
	'Select the benefit that you would like to edit.': {
		translation: 'Select the benefit that you would like to edit.',
	},
	'Select the benefits that you would like to edit.': {
		translation: 'Select the benefits that you would like to edit.',
	},
	'Select the employee fields you would like to report on.': {
		translation: 'Select the employee fields you would like to report on.',
	},
	'Select the employees who are eligible for %1:': {
		translation: 'Select the employees who are eligible for %1:',
	},
	"Select the employees you'd like to add": {
		translation: "Select the employees you'd like to add",
	},
	"Select the employees you'd like to edit": {
		translation: "Select the employees you'd like to edit",
	},
	'Select the file you want to import': {
		translation: 'Select the file you want to import',
	},
	"Select the payroll information you'd like": {
		translation: "Select the payroll information you'd like",
	},
	"Select the plan you'd like to add to this Benefit Group": {
		translation: "Select the plan you'd like to add to this Benefit Group",
	},
	'Select the statuses that you would like to restore to the hiring workflow. These will be restored to their original position.':
		{
			translation:
				'Select the statuses that you would like to restore to the hiring workflow. These will be restored to their original position.',
		},
	'Select the type of alert:': {
		translation: 'Select the type of alert:',
	},
	'Select to use single rate but file as married': {
		translation: 'Select to use single rate but file as married',
	},
	'Select when %1 will start tracking time.': {
		translation: 'Select when %1 will start tracking time.',
	},
	'Select when %1$s will start tracking time.': {
		translation: 'Select when %1$s will start tracking time.',
	},
	'Select when the first payroll deduction happens ': {
		translation: 'Select when the first payroll deduction happens ',
	},
	'Select when the first payroll deduction happens relative to the benefit effective date.':
		{
			translation:
				'Select when the first payroll deduction happens relative to the benefit effective date.',
		},
	'Select which employees will be using time tracking.': {
		translation: 'Select which employees will be using time tracking.',
	},
	"Select who you'd like to add to %1": {
		translation: "Select who you'd like to add to %1",
	},
	"Select who you'd like to enable Time Tracking for:": {
		translation: "Select who you'd like to enable Time Tracking for:",
	},
	"Select who you'd like to send the alert to:": {
		translation: "Select who you'd like to send the alert to:",
	},
	Selected: {
		translation: 'Selected',
	},
	'Selected Employees': {
		translation: 'Selected Employees',
	},
	'Selected Fields': {
		translation: 'Selected Fields',
	},
	'Selected Plans': {
		translation: 'Selected Plans',
	},
	'Selected child coverage amount does not match percentage of employee coverage for benefit plan %s.':
		{
			translation:
				'Selected child coverage amount does not match percentage of employee coverage for benefit plan %s.',
		},
	'Selected child coverage amount is not within the min/max range for benefit plan %s.':
		{
			translation:
				'Selected child coverage amount is not within the min/max range for benefit plan %s.',
		},
	'Selected employee coverage amount is not within the min/max range for benefit plan %s.':
		{
			translation:
				'Selected employee coverage amount is not within the min/max range for benefit plan %s.',
		},
	'Selected employees': {
		translation: 'Selected employees',
	},
	'Selected items': {
		translation: 'Selected items',
	},
	'Selected spouse coverage amount does not match percentage of employee coverage for benefit plan %s.':
		{
			translation:
				'Selected spouse coverage amount does not match percentage of employee coverage for benefit plan %s.',
		},
	'Selected spouse coverage amount is not within the min/max range for benefit plan %s.':
		{
			translation:
				'Selected spouse coverage amount is not within the min/max range for benefit plan %s.',
		},
	'Selecting an end date in the past will unenroll %1$s employees.': {
		translation:
			'Selecting an end date in the past will unenroll %1$s employees.',
	},
	'Selecting an end date in the past will unenroll %1$s employees. Are you sure you want to do this?':
		{
			translation:
				'Selecting an end date in the past will unenroll %1$s employees. Are you sure you want to do this?',
		},
	'Selecting an end date in the past will unenroll %s employees': {
		translation: 'Selecting an end date in the past will unenroll %s employees',
	},
	'Selecting an end date in the past will unenroll 1 employee': {
		translation: 'Selecting an end date in the past will unenroll 1 employee',
	},
	'Selecting an end date in the past will unenroll 1 employee.': {
		translation: 'Selecting an end date in the past will unenroll 1 employee.',
	},
	'Selecting an end date in the past will unenroll 1 employee. Are you sure you want to do this?':
		{
			translation:
				'Selecting an end date in the past will unenroll 1 employee. Are you sure you want to do this?',
		},
	'Selecting multiple levels will give this person the combined permissions of the selected levels.':
		{
			translation:
				'Selecting multiple levels will give this person the combined permissions of the selected levels.',
		},
	Self: {
		translation: 'Self',
	},
	'Self & Manager Assessment': {
		translation: 'Self & Manager Assessment',
	},
	'Self Assessment': {
		translation: 'Self Assessment',
	},
	'Self Assessment Questions:': {
		translation: 'Self Assessment Questions:',
	},
	'Self Assessment will show here once completed.': {
		translation: 'Self Assessment will show here once completed.',
	},
	'Self and Manager Assessments': {
		translation: 'Self and Manager Assessments',
	},
	'Self-Schedule Link': {
		translation: 'Self-Schedule Link',
	},
	'Self-service access': {
		translation: 'Self-service access',
	},
	'Semantic Layer was not able to recognize all the requested fields.': {
		translation:
			'Semantic Layer was not able to recognize all the requested fields.',
	},
	'Semi-annually': {
		translation: 'Semi-annually',
	},
	'Semi-monthly': {
		translation: 'Semi-monthly',
	},
	Send: {
		translation: 'Send',
	},
	'Send "Get to Know You" email to:': {
		translation: 'Send \\"Get to Know You\\" email to:',
	},
	'Send Alerts at': {
		translation: 'Send Alerts at',
	},
	'Send Anyway': {
		translation: 'Send Anyway',
	},
	'Send Approvals to ': {
		translation: 'Send Approvals to ',
	},
	'Send Email': {
		translation: 'Send Email',
	},
	'Send Emails': {
		translation: 'Send Emails',
	},
	'Send Feedback Requests': {
		translation: 'Send Feedback Requests',
	},
	'Send New Hire Packet': {
		translation: 'Send New Hire Packet',
	},
	'Send New Invite': {
		translation: 'Send New Invite',
	},
	'Send Offer Letter': {
		translation: 'Send Offer Letter',
	},
	'Send Packet': {
		translation: 'Send Packet',
	},
	'Send Recommendations to ': {
		translation: 'Send Recommendations to ',
	},
	'Send Reminder': {
		translation: 'Send Reminder',
	},
	'Send Request': {
		translation: 'Send Request',
	},
	'Send Signature Request': {
		translation: 'Send Signature Request',
	},
	'Send To': {
		translation: 'Send To',
	},
	'Send a New Hire Packet': {
		translation: 'Send a New Hire Packet',
	},
	'Send a reminder': {
		translation: 'Send a reminder',
	},
	'Send a reminder %s in advance': {
		translation: 'Send a reminder %s in advance',
	},
	'Send a signature request to:': {
		translation: 'Send a signature request to:',
	},
	'Send a welcome message in Slack to matched employees': {
		translation: 'Send a welcome message in Slack to matched employees',
	},
	'Send alert when uploaded to folder...': {
		translation: 'Send alert when uploaded to folder...',
	},
	'Send alerts at': {
		translation: 'Send alerts at',
	},
	'Send an Email': {
		translation: 'Send an Email',
	},
	'Send an Email to {1}': {
		translation: 'Send an Email to {1}',
	},
	'Send and Manage Offer Letters': {
		translation: 'Send and Manage Offer Letters',
	},
	'Send announcement to:': {
		translation: 'Send announcement to:',
	},
	'Send documents for signature': {
		translation: 'Send documents for signature',
	},
	'Send documents to multiple employees all at once': {
		translation: 'Send documents to multiple employees all at once',
	},
	'Send email reminders right from BambooHR for outstanding signature requests':
		{
			translation:
				'Send email reminders right from BambooHR for outstanding signature requests',
		},
	'Send from a company leader to get more responses.': {
		translation: 'Send from a company leader to get more responses.',
	},
	'Send me a paper copy of my tax documents at the end of each year.': {
		translation:
			'Send me a paper copy of my tax documents at the end of each year.',
	},
	'Send me an alert on the %s.': {
		translation: 'Send me an alert on the %s.',
	},
	'Send me an alert on the **{1} date**': {
		translation: 'Send me an alert on the **{1} date**',
	},
	'Send me an alert on the **{1}**.': {
		translation: 'Send me an alert on the **{1}**.',
	},
	'Send me an alert on the <strong class="normal" id="dateDescriptor">date</strong>.':
		{
			translation:
				'Send me an alert on the <strong class=\\"normal\\" id=\\"dateDescriptor\\">date</strong>.',
		},
	'Send out multiple documents to sign in one packet, or send them out individually':
		{
			translation:
				'Send out multiple documents to sign in one packet, or send them out individually',
		},
	'Send tasks for this new employee to complete. You can attach documents for them to review and sign if needed.':
		{
			translation:
				'Send tasks for this new employee to complete. You can attach documents for them to review and sign if needed.',
		},
	'Send this alert to...': {
		translation: 'Send this alert to...',
	},
	'Send this new employee a new hire packet': {
		translation: 'Send this new employee a new hire packet',
	},
	'Send to': {
		translation: 'Send to',
	},
	'Send to ': {
		translation: 'Send to ',
	},
	'Send to Payroll': {
		translation: 'Send to Payroll',
	},
	'Send to all employees on': {
		translation: 'Send to all employees on',
	},
	'Send to me': {
		translation: 'Send to me',
	},
	'Send us a message...': {
		translation: 'Send us a message...',
	},
	'Send your journal entry report straight to your accounting software': {
		translation:
			'Send your journal entry report straight to your accounting software',
	},
	'Sender Extension': {
		translation: 'Sender Extension',
	},
	'Sender First Name': {
		translation: 'Sender First Name',
	},
	'Sender Job Title': {
		translation: 'Sender Job Title',
	},
	'Sender Last Name': {
		translation: 'Sender Last Name',
	},
	'Sender Phone': {
		translation: 'Sender Phone',
	},
	'Sending...': {
		translation: 'Sending...',
	},
	'Senior Developer': {
		translation: 'Senior Developer',
	},
	'Senior Executive': {
		translation: 'Senior Executive',
	},
	'Senior Manager/Supervisor': {
		translation: 'Senior Manager/Supervisor',
	},
	Sent: {
		translation: 'Sent',
	},
	'Sent By Me': {
		translation: 'Sent By Me',
	},
	'Sent Requests': {
		translation: 'Sent Requests',
	},
	'Sent To': {
		translation: 'Sent To',
	},
	'Sent by me': {
		translation: 'Sent by me',
	},
	'Sent every day': {
		translation: {
			one: 'Sent every day',
			other: 'Sent every %1$s days',
		},
	},
	'Sent every month': {
		translation: {
			one: 'Sent every month',
			other: 'Sent every %1$s months',
		},
	},
	'Sent every week': {
		translation: {
			one: 'Sent every week',
			other: 'Sent every %1$s weeks',
		},
	},
	'Sent to %1$s on %2$s': {
		translation: 'Sent to %1$s on %2$s',
	},
	'Sent to all employees on %1%2%3.': {
		translation: 'Sent to all employees on %1%2%3.',
	},
	Sep: {
		translation: 'Sep',
	},
	'Separate Files': {
		translation: 'Separate Files',
	},
	September: {
		translation: 'September',
	},
	'Serial #': {
		translation: 'Serial #',
	},
	'Serial Number': {
		translation: 'Serial Number',
	},
	'Service Account ID': {
		translation: 'Service Account ID',
	},
	'Service Workers': {
		translation: 'Service Workers',
	},
	'Set Access Level': {
		translation: 'Set Access Level',
	},
	'Set Access on all %1$s Fields': {
		translation: 'Set Access on all %1$s Fields',
	},
	'Set Access on all **{1}** Fields': {
		translation: 'Set Access on all **{1}** Fields',
	},
	'Set Access on all current and future folders': {
		translation: 'Set Access on all current and future folders',
	},
	'Set Date': {
		translation: 'Set Date',
	},
	'Set Default Value': {
		translation: 'Set Default Value',
	},
	'Set Up Payees': {
		translation: 'Set Up Payees',
	},
	'Set Up Performance': {
		translation: 'Set Up Performance',
	},
	'Set Up Template': {
		translation: 'Set Up Template',
	},
	'Set all fields to No Access to hide the %1$s tab.': {
		translation: 'Set all fields to No Access to hide the %1$s tab.',
	},
	'Set by Safe Harbor rules': {
		translation: 'Set by Safe Harbor rules',
	},
	"Set the status to: <span class='statusLiteral'>%s</span>": {
		translation: "Set the status to: <span class='statusLiteral'>%s</span>",
	},
	'Set to "Not Hired Because..." status while in %2%1%3.': {
		translation: 'Set to \\"Not Hired Because...\\" status while in %2%1%3.',
	},
	'Set up EEO-1 Categories': {
		translation: 'Set up EEO-1 Categories',
	},
	'Set up Time Off': {
		translation: 'Set up Time Off',
	},
	'Set up an Offer Template in Settings': {
		translation: 'Set up an Offer Template in Settings',
	},
	'Set up specific approval paths by:': {
		translation: 'Set up specific approval paths by:',
	},
	'Set up your timesheet, holiday pay, and overtime preferences.': {
		translation:
			'Set up your timesheet, holiday pay, and overtime preferences.',
	},
	'Set what Payroll Admins can see about themselves.': {
		translation: 'Set what Payroll Admins can see about themselves.',
	},
	"Set your employees up to create and track their own goals, allow managers to assess and request feedback about their direct reports. Let's get going.":
		{
			translation:
				"Set your employees up to create and track their own goals, allow managers to assess and request feedback about their direct reports. Let's get going.",
		},
	"Set your employees up to create and track their own goals, allow managers to request peer reviews and assess their direct reports. Let's get going.":
		{
			translation:
				"Set your employees up to create and track their own goals, allow managers to request peer reviews and assess their direct reports. Let's get going.",
		},
	'Setting Access Level for': {
		translation: 'Setting Access Level for',
	},
	'Setting has been saved.': {
		translation: 'Setting has been saved.',
	},
	'Setting this accrual policy to "Flexible" will clear this employee\'s %1$s balance.':
		{
			translation:
				'Setting this accrual policy to \\"Flexible\\" will clear this employee\'s %1$s balance.',
		},
	'Setting this policy to "None" will clear this employee\'s %1$s balance.': {
		translation:
			'Setting this policy to \\"None\\" will clear this employee\'s %1$s balance.',
	},
	'Setting up a Bitium account is simple. Simply follow the steps below to create a free account and start managing your apps (including BambooHR) in one place.':
		{
			translation:
				'Setting up a Bitium account is simple. Simply follow the steps below to create a free account and start managing your apps (including BambooHR) in one place.',
		},
	Settings: {
		translation: 'Settings',
	},
	Setup: {
		translation: 'Setup',
	},
	'Setup Checklist': {
		translation: 'Setup Checklist',
	},
	'Setup Company': {
		translation: 'Setup Company',
	},
	'Setup Google': {
		translation: 'Setup Google',
	},
	'Setup Microsoft Calendar': {
		translation: 'Setup Microsoft Calendar',
	},
	'Setup Performance': {
		translation: 'Setup Performance',
	},
	'Setup Teams': {
		translation: 'Setup Teams',
	},
	'Setup Trial': {
		translation: 'Setup Trial',
	},
	'Setup Trial Peer Feedback': {
		translation: 'Setup Trial Peer Feedback',
	},
	'Setup Zoom': {
		translation: 'Setup Zoom',
	},
	'Sexual Harassment Training': {
		translation: 'Sexual Harassment Training',
	},
	'Sexual Orientation': {
		translation: 'Sexual Orientation',
	},
	Share: {
		translation: 'Share',
	},
	'Share %1': {
		translation: 'Share %1',
	},
	'Share %1 Folder': {
		translation: 'Share %1 Folder',
	},
	'Share %1$s Folder': {
		translation: 'Share %1$s Folder',
	},
	'Share Folder': {
		translation: 'Share Folder',
	},
	'Share Goal': {
		translation: 'Share Goal',
	},
	'Share Job Posting': {
		translation: 'Share Job Posting',
	},
	'Share Now': {
		translation: 'Share Now',
	},
	'Share Report': {
		translation: 'Share Report',
	},
	'Share Selected Document': {
		translation: 'Share Selected Document',
	},
	'Share These File(s) with Individuals or Groups': {
		translation: 'Share These File(s) with Individuals or Groups',
	},
	'Share With Employee': {
		translation: 'Share With Employee',
	},
	'Share With Employees': {
		translation: 'Share With Employees',
	},
	'Share my birthday with others': {
		translation: 'Share my birthday with others',
	},
	'Share these File(s) with all Employees': {
		translation: 'Share these File(s) with all Employees',
	},
	'Share these File(s) with the Employee': {
		translation: 'Share these File(s) with the Employee',
	},
	'Share these file(s) with all Employees': {
		translation: 'Share these file(s) with all Employees',
	},
	'Share this File with all Employees': {
		translation: 'Share this File with all Employees',
	},
	'Share this Folder with all Employees': {
		translation: 'Share this Folder with all Employees',
	},
	'Share this Report': {
		translation: 'Share this Report',
	},
	'Share this file': {
		translation: 'Share this file',
	},
	'Share this file with all employees': {
		translation: 'Share this file with all employees',
	},
	'Share this goal': {
		translation: 'Share this goal',
	},
	"Share what's on your mind! Make sure you add a comment.": {
		translation: "Share what's on your mind! Make sure you add a comment.",
	},
	'Share with groups or individuals': {
		translation: 'Share with groups or individuals',
	},
	'Share...': {
		translation: 'Share...',
	},
	Shared: {
		translation: 'Shared',
	},
	'Shared Report': {
		translation: 'Shared Report',
	},
	'Shared with Me': {
		translation: 'Shared with Me',
	},
	'Shared with me': {
		translation: 'Shared with me',
	},
	'Share…': {
		translation: 'Share…',
	},
	'She/her': {
		translation: 'She/her',
	},
	'She/they': {
		translation: 'She/they',
	},
	Shift: {
		translation: 'Shift',
	},
	'Shift Differentials': {
		translation: 'Shift Differentials',
	},
	'Shirt Size': {
		translation: 'Shirt Size',
	},
	'Shirt size': {
		translation: 'Shirt size',
	},
	'Short (M, F, etc.)': {
		translation: 'Short (M, F, etc.)',
	},
	'Short Term Disability': {
		translation: 'Short Term Disability',
	},
	'Short Term Disability 2026': {
		translation: 'Short Term Disability 2026',
	},
	'Short description of what you will accomplish and how.': {
		translation: 'Short description of what you will accomplish and how.',
	},
	'Should Employees be able to see their own information?': {
		translation: 'Should Employees be able to see their own information?',
	},
	'Should employees be able to create and track goals?': {
		translation: 'Should employees be able to create and track goals?',
	},
	'Should you need help or have questions about this feature, please contact our Support Hero\'s at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a>.':
		{
			translation:
				'Should you need help or have questions about this feature, please contact our Support Hero\'s at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a>.',
		},
	'Should you need help or have questions about this module, please contact our Support Hero\'s at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a>.':
		{
			translation:
				'Should you need help or have questions about this module, please contact our Support Hero\'s at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a>.',
		},
	Show: {
		translation: 'Show',
	},
	'Show %d More...': {
		translation: 'Show %d More...',
	},
	'Show All Fields': {
		translation: 'Show All Fields',
	},
	'Show Answers': {
		translation: 'Show Answers',
	},
	'Show Archived': {
		translation: 'Show Archived',
	},
	'Show Benchmarking': {
		translation: 'Show Benchmarking',
	},
	'Show Benefit History': {
		translation: 'Show Benefit History',
	},
	'Show Changes': {
		translation: 'Show Changes',
	},
	'Show History': {
		translation: 'Show History',
	},
	'Show Import Details': {
		translation: 'Show Import Details',
	},
	'Show Jobs': {
		translation: 'Show Jobs',
	},
	'Show Links on': {
		translation: 'Show Links on',
	},
	'Show Me': {
		translation: 'Show Me',
	},
	'Show Only Misalignments': {
		translation: 'Show Only Misalignments',
	},
	'Show Terminated Employees': {
		translation: 'Show Terminated Employees',
	},
	'Show Tooltip': {
		translation: 'Show Tooltip',
	},
	'Show all %1 people out %2': {
		translation: 'Show all %1 people out %2',
	},
	'Show all %1 people out next %2': {
		translation: 'Show all %1 people out next %2',
	},
	'Show all %1 people out the rest of %2': {
		translation: 'Show all %1 people out the rest of %2',
	},
	'Show all %1 people out today': {
		translation: 'Show all %1 people out today',
	},
	'Show all %1 people out tomorrow': {
		translation: 'Show all %1 people out tomorrow',
	},
	'Show as from': {
		translation: 'Show as from',
	},
	"Show currency code <span style='color:#777; font-size:13px'>(e.g. %s)</span>":
		{
			translation:
				"Show currency code <span style='color:#777; font-size:13px'>(e.g. %s)</span>",
		},
	'Show expanded gender options': {
		translation: 'Show expanded gender options',
	},
	'Show import details': {
		translation: 'Show import details',
	},
	'Show me': {
		translation: 'Show me',
	},
	'Show me how to create an accrual policy': {
		translation: 'Show me how to create an accrual policy',
	},
	'Show more': {
		translation: 'Show more',
	},
	'Show on Calendar': {
		translation: 'Show on Calendar',
	},
	'Show on Org Chart:': {
		translation: 'Show on Org Chart:',
	},
	'Show only currently clocked in': {
		translation: 'Show only currently clocked in',
	},
	'Show only misalignments': {
		translation: 'Show only misalignments',
	},
	'Show only paid time off categories': {
		translation: 'Show only paid time off categories',
	},
	'Show only paid time off types': {
		translation: 'Show only paid time off types',
	},
	'Show this name on the calendar': {
		translation: 'Show this name on the calendar',
	},
	'Show what the company pays for each benefit': {
		translation: 'Show what the company pays for each benefit',
	},
	'Show...': {
		translation: 'Show...',
	},
	Showing: {
		translation: 'Showing',
	},
	'Showing %1$s': {
		translation: 'Showing %1$s',
	},
	'Showing %1$s and %2$s': {
		translation: 'Showing %1$s and %2$s',
	},
	'Showing %s company': {
		translation: {
			one: 'Showing %s company',
			other: 'Showing %s companies',
		},
	},
	'Showing %s-%s of %s': {
		translation: 'Showing %s-%s of %s',
	},
	'Showing Symptoms': {
		translation: 'Showing Symptoms',
	},
	'Showing all employee info changes since the last pay period': {
		translation: 'Showing all employee info changes since the last pay period',
	},
	'Showing all employee info changes since the last pay period (ending %1$s)': {
		translation:
			'Showing all employee info changes since the last pay period (ending %1$s)',
	},
	'Shut Down': {
		translation: 'Shut Down',
	},
	Sick: {
		translation: 'Sick',
	},
	'Sick Full Time': {
		translation: 'Sick Full Time',
	},
	'Sick Full-Time': {
		translation: 'Sick Full-Time',
	},
	'Sick Leave': {
		translation: 'Sick Leave',
	},
	'Sick Leave Afghan National': {
		translation: 'Sick Leave Afghan National',
	},
	'Sick Policy': {
		translation: 'Sick Policy',
	},
	'Sick Time': {
		translation: 'Sick Time',
	},
	'Sick Time (10/11-month salary)': {
		translation: 'Sick Time (10/11-month salary)',
	},
	'Sick Time (12-month salary)': {
		translation: 'Sick Time (12-month salary)',
	},
	'Sick time (working)': {
		translation: 'Sick time (working)',
	},
	'Sick/Illness': {
		translation: 'Sick/Illness',
	},
	'Sick/Personal': {
		translation: 'Sick/Personal',
	},
	'Sick/Personal Days (Unpaid)': {
		translation: 'Sick/Personal Days (Unpaid)',
	},
	'Sign Now': {
		translation: 'Sign Now',
	},
	'Sign Up Now': {
		translation: 'Sign Up Now',
	},
	'Sign Up Now and Get Full Access to:': {
		translation: 'Sign Up Now and Get Full Access to:',
	},
	'Sign Up for BambooHR': {
		translation: 'Sign Up for BambooHR',
	},
	'Sign into your management dashboard on Boomr.com and select "Integrations" from the drop down menu in the top right corner.':
		{
			translation:
				'Sign into your management dashboard on Boomr.com and select \\"Integrations\\" from the drop down menu in the top right corner.',
		},
	'Sign the required authorization forms for %1$s below': {
		translation: 'Sign the required authorization forms for %1$s below',
	},
	'Sign-on Bonus': {
		translation: 'Sign-on Bonus',
	},
	'Sign-on Bonus Amount': {
		translation: 'Sign-on Bonus Amount',
	},
	Signature: {
		translation: 'Signature',
	},
	'Signature %s': {
		translation: 'Signature %s',
	},
	'Signature Field': {
		translation: 'Signature Field',
	},
	'Signature Optional': {
		translation: 'Signature Optional',
	},
	'Signature Reminder': {
		translation: 'Signature Reminder',
	},
	'Signature Request': {
		translation: 'Signature Request',
	},
	'Signature Request Failed': {
		translation: 'Signature Request Failed',
	},
	'Signature Request for %1$s': {
		translation: 'Signature Request for %1$s',
	},
	'Signature Required': {
		translation: 'Signature Required',
	},
	'Signature Setup': {
		translation: 'Signature Setup',
	},
	'Signature Templates': {
		translation: 'Signature Templates',
	},
	'Signature report': {
		translation: 'Signature report',
	},
	'Signature request canceled': {
		translation: 'Signature request canceled',
	},
	'Signature request has been sent to %1$s.': {
		translation: 'Signature request has been sent to %1$s.',
	},
	'Signature requests expire after 180 days.': {
		translation: 'Signature requests expire after 180 days.',
	},
	'Signature requests have been sent to %1$s and %2$s.': {
		translation: 'Signature requests have been sent to %1$s and %2$s.',
	},
	'Signature requests have been sent to %1$s, %2$s, %3$s & %4$d more...': {
		translation:
			'Signature requests have been sent to %1$s, %2$s, %3$s & %4$d more...',
	},
	'Signature requests have been sent to %1$s, %2$s, and %3$s.': {
		translation: 'Signature requests have been sent to %1$s, %2$s, and %3$s.',
	},
	'Signature setup is only available for PDF, DOC, and DOCX documents.': {
		translation:
			'Signature setup is only available for PDF, DOC, and DOCX documents.',
	},
	'Signature templates need to have the employee as the first signer and can only have specific people as additional signers in order to be added to an offer.':
		{
			translation:
				'Signature templates need to have the employee as the first signer and can only have specific people as additional signers in order to be added to an offer.',
		},
	'Signature templates that are a part of an offer template need to have the employee as the first signer and can only have specific people as additional signers.':
		{
			translation:
				'Signature templates that are a part of an offer template need to have the employee as the first signer and can only have specific people as additional signers.',
		},
	Signatures: {
		translation: 'Signatures',
	},
	'Signatures are not available for files over 10 MB.': {
		translation: 'Signatures are not available for files over 10 MB.',
	},
	Signed: {
		translation: 'Signed',
	},
	'Signed Documents': {
		translation: 'Signed Documents',
	},
	'Signed!': {
		translation: 'Signed!',
	},
	'Signers Pending': {
		translation: 'Signers Pending',
	},
	'Signers pending': {
		translation: 'Signers pending',
	},
	'Signing Bonus': {
		translation: 'Signing Bonus',
	},
	'Signing Order': {
		translation: 'Signing Order',
	},
	'Simple IRA (pre-tax)': {
		translation: 'Simple IRA (pre-tax)',
	},
	"Simplepay.ca is Canada's payroll 2.0 specifically designed and priced for small / medium businesses and accounting professionals.":
		{
			translation:
				"Simplepay.ca is Canada's payroll 2.0 specifically designed and priced for small / medium businesses and accounting professionals.",
		},
	'Simplified 401(k) for small orgs or self-employed (post-tax)': {
		translation: 'Simplified 401(k) for small orgs or self-employed (post-tax)',
	},
	'Simply <a href="https://marketrate.payscale.com/af/default.aspx?af=2967" target="_new">click here</a>, log in, and run your salary reports.':
		{
			translation:
				'Simply <a href=\\"https://marketrate.payscale.com/af/default.aspx?af=2967\\" target=\\"_new\\">click here</a>, log in, and run your salary reports.',
		},
	'Simply click on the "Install" button. That\'s it.': {
		translation: 'Simply click on the \\"Install\\" button. That\'s it.',
	},
	'Simply enable Google Single Sign-On and any users of your BambooHR account will then have the option of logging in with Google on their login screen.':
		{
			translation:
				'Simply enable Google Single Sign-On and any users of your BambooHR account will then have the option of logging in with Google on their login screen.',
		},
	'Simply enable Microsoft Single Sign-On and any users of your BambooHR account will then have the option of logging in with Microsoft on their login screen.':
		{
			translation:
				'Simply enable Microsoft Single Sign-On and any users of your BambooHR account will then have the option of logging in with Microsoft on their login screen.',
		},
	'Simply enable QuickBooks Online Payroll Single Sign-On and any users of your BambooHR account will then have the option of logging in with QuickBooks on their login screen.':
		{
			translation:
				'Simply enable QuickBooks Online Payroll Single Sign-On and any users of your BambooHR account will then have the option of logging in with QuickBooks on their login screen.',
		},
	'Sin must be unique': {
		translation: 'Sin must be unique',
	},
	'Since %s': {
		translation: 'Since %s',
	},
	'Since the deadline for this review period is so close, you will not be able to request feedback from anyone else until the next review period.':
		{
			translation:
				'Since the deadline for this review period is so close, you will not be able to request feedback from anyone else until the next review period.',
		},
	'Since there are no goals in progress, there are no past due goals either.': {
		translation:
			'Since there are no goals in progress, there are no past due goals either.',
	},
	'Since tracking started in %1': {
		translation: 'Since tracking started in %1',
	},
	'Since we don’t know what hours you will be working in the future we can’t calculate your future balance.':
		{
			translation:
				'Since we don’t know what hours you will be working in the future we can’t calculate your future balance.',
		},
	"Since you're approving this request out of turn, the other approvers listed below will be bypassed, and the request will be complete.":
		{
			translation:
				"Since you're approving this request out of turn, the other approvers listed below will be bypassed, and the request will be complete.",
		},
	"Since you're denying this request out of turn, the other approvers listed below will be bypassed, and the request will be complete.":
		{
			translation:
				"Since you're denying this request out of turn, the other approvers listed below will be bypassed, and the request will be complete.",
		},
	"Since you're using the Payroll feature, we will use the company information that you've set up in Payroll settings to populate the employer section of each employee's 1095-C.":
		{
			translation:
				"Since you're using the Payroll feature, we will use the company information that you've set up in Payroll settings to populate the employer section of each employee's 1095-C.",
		},
	Single: {
		translation: 'Single',
	},
	'Single Daily Entry': {
		translation: 'Single Daily Entry',
	},
	'Single Sign-on settings updated': {
		translation: 'Single Sign-on settings updated',
	},
	'Single entry for the whole day': {
		translation: 'Single entry for the whole day',
	},
	'Single line text': {
		translation: 'Single line text',
	},
	'Single, or Married Filing Separately': {
		translation: 'Single, or Married Filing Separately',
	},
	Sister: {
		translation: 'Sister',
	},
	'Site Address': {
		translation: 'Site Address',
	},
	'Site code': {
		translation: 'Site code',
	},
	'Six months': {
		translation: 'Six months',
	},
	Size: {
		translation: 'Size',
	},
	'Size: Largest First': {
		translation: 'Size: Largest First',
	},
	'Size: Smallest First': {
		translation: 'Size: Smallest First',
	},
	Skip: {
		translation: 'Skip',
	},
	'Skip This for Now': {
		translation: 'Skip This for Now',
	},
	Skipped: {
		translation: 'Skipped',
	},
	'Skipped syncing [%s] with invalid username: [%s]': {
		translation: 'Skipped syncing %s with invalid username: %s',
	},
	Skype: {
		translation: 'Skype',
	},
	'Skype Username': {
		translation: 'Skype Username',
	},
	'Slack Settings Page': {
		translation: 'Slack Settings Page',
	},
	'Slack Step 1': {
		translation: 'Slack Step 1',
	},
	'Slack Step 2': {
		translation: 'Slack Step 2',
	},
	'Slack cannot be installed from GreenHouse at this time.': {
		translation: 'Slack cannot be installed from GreenHouse at this time.',
	},
	"Small Improvements integrates with BambooHR's API to provide a seamless connection. Changes to employee information managed in BambooHR can be automatically detected and updated within Small Improvements, and reporting features for Small Improvements are available directly through the BambooHR Reports interface.":
		{
			translation:
				"Small Improvements integrates with BambooHR's API to provide a seamless connection. Changes to employee information managed in BambooHR can be automatically detected and updated within Small Improvements, and reporting features for Small Improvements are available directly through the BambooHR Reports interface.",
		},
	'Small Improvements offers deep integration with BambooHR, so you never have to enter employee data twice. It also integrates with OneLogin for SSO. Conduct painless performance reviews. Collect 360 degree feedback from your coworkers. Track and share your goals. Create quick surveys on how to improve. Provide continuous feedback and coaching. Share company news and success stories easily. Pretty, web-based, hosted and affordable. Free 10 user license available!':
		{
			translation:
				'Small Improvements offers deep integration with BambooHR, so you never have to enter employee data twice. It also integrates with OneLogin for SSO. Conduct painless performance reviews. Collect 360 degree feedback from your coworkers. Track and share your goals. Create quick surveys on how to improve. Provide continuous feedback and coaching. Share company news and success stories easily. Pretty, web-based, hosted and affordable. Free 10 user license available!',
		},
	'Smallest first': {
		translation: 'Smallest first',
	},
	Smoker: {
		translation: 'Smoker',
	},
	'Snapshot failed to create: ': {
		translation: 'Snapshot failed to create: ',
	},
	'Snuggle up': {
		translation: 'Snuggle up',
	},
	'So what do you think?': {
		translation: 'So what do you think?',
	},
	"So, let's get you up and running.": {
		translation: "So, let's get you up and running.",
	},
	'Social Links': {
		translation: 'Social Links',
	},
	'Social Media Marketer': {
		translation: 'Social Media Marketer',
	},
	'Social Security Number': {
		translation: 'Social Security Number',
	},
	'Social security number': {
		translation: 'Social security number',
	},
	Software: {
		translation: 'Software',
	},
	'Software Engineer': {
		translation: 'Software Engineer',
	},
	'Software Implementation Specialist': {
		translation: 'Software Implementation Specialist',
	},
	'Some College': {
		translation: 'Some College',
	},
	'Some Employees': {
		translation: 'Some Employees',
	},
	'Some Employees Scheduled on their Future Start Dates': {
		translation: 'Some Employees Scheduled on their Future Start Dates',
	},
	'Some Employees weren’t Enabled Now': {
		translation: 'Some Employees weren’t Enabled Now',
	},
	'Some Employees weren’t Rescheduled': {
		translation: 'Some Employees weren’t Rescheduled',
	},
	'Some Employees weren’t Scheduled on the Selected Date': {
		translation: 'Some Employees weren’t Scheduled on the Selected Date',
	},
	'Some Person': {
		translation: 'Some Person',
	},
	'Some data was not saved.  You must enter a date for each status change.': {
		translation:
			'Some data was not saved.  You must enter a date for each status change.',
	},
	'Some dependents in your benefit elections are no longer available. Please go back and reset your elections for the following benefit plans: %s.':
		{
			translation:
				'Some dependents in your benefit elections are no longer available. Please go back and reset your elections for the following benefit plans: %s.',
		},
	'Some employees are still clocked in.': {
		translation: 'Some employees are still clocked in.',
	},
	'Some fields did not have corresponding values for company: ': {
		translation: 'Some fields did not have corresponding values for company: ',
	},
	'Some fields did not match up automatically. To ignore these fields please select "Do not import" from the dropdown':
		{
			translation:
				'Some fields did not match up automatically. To ignore these fields please select \\"Do not import\\" from the dropdown',
		},
	'Some fields in the import file could not be mapped to corresponding fields in the system. ':
		{
			translation:
				'Some fields in the import file could not be mapped to corresponding fields in the system. ',
		},
	'Some hours have been recently edited.': {
		translation: 'Some hours have been recently edited.',
	},
	'Some rows were not imported. The following rows had errors: ': {
		translation: 'Some rows were not imported. The following rows had errors: ',
	},
	'Some rows were not imported. The following rows had errors: %s  See import results below for more information.':
		{
			translation:
				'Some rows were not imported. The following rows had errors: %s  See import results below for more information.',
		},
	'Some rows were not imported. The following rows had errors: %s. See import results below for more information.':
		{
			translation:
				'Some rows were not imported. The following rows had errors: %s. See import results below for more information.',
		},
	'Someone chose not to sign this document.': {
		translation: 'Someone chose not to sign this document.',
	},
	"Something doesn't seem right, please check that all required fields are filled in.":
		{
			translation:
				"Something doesn't seem right, please check that all required fields are filled in.",
		},
	'Something happened trying to delete your training.': {
		translation: 'Something happened trying to delete your training.',
	},
	'Something is not right with the training record you submitted.': {
		translation:
			'Something is not right with the training record you submitted.',
	},
	'Something on our side prevented your file(s) from uploading. Please give it another try.':
		{
			translation:
				'Something on our side prevented your file(s) from uploading. Please give it another try.',
		},
	'Something was wrong with your request. (': {
		translation: 'Something was wrong with your request. (',
	},
	'Something went wrong': {
		translation: 'Something went wrong',
	},
	'Something went wrong and we could not resend the approval email. Try again?':
		{
			translation:
				'Something went wrong and we could not resend the approval email. Try again?',
		},
	'Something went wrong trying to save this record.': {
		translation: 'Something went wrong trying to save this record.',
	},
	'Something went wrong when duplicating a report.': {
		translation: 'Something went wrong when duplicating a report.',
	},
	'Something went wrong when manipulating a report folder.': {
		translation: 'Something went wrong when manipulating a report folder.',
	},
	'Something went wrong when trying to delete reports': {
		translation: 'Something went wrong when trying to delete reports',
	},
	'Something went wrong when updating the report owner.': {
		translation: 'Something went wrong when updating the report owner.',
	},
	'Something went wrong while attempting to assign feedback.': {
		translation: 'Something went wrong while attempting to assign feedback.',
	},
	'Something went wrong while attempting to summarize feedback.': {
		translation: 'Something went wrong while attempting to summarize feedback.',
	},
	'Something went wrong while loading the file.': {
		translation: 'Something went wrong while loading the file.',
	},
	'Something went wrong with email validation!': {
		translation: 'Something went wrong with email validation!',
	},
	'Something went wrong with the downgrade. Please refresh this page and try again.':
		{
			translation:
				'Something went wrong with the downgrade. Please refresh this page and try again.',
		},
	'Something went wrong with the network connection. Please give it another try.':
		{
			translation:
				'Something went wrong with the network connection. Please give it another try.',
		},
	'Something went wrong!': {
		translation: 'Something went wrong!',
	},
	"Something went wrong, we've been notified and will be looking into this": {
		translation:
			"Something went wrong, we've been notified and will be looking into this",
	},
	'Something went wrong.': {
		translation: 'Something went wrong.',
	},
	'Something went wrong. Could not save your Training.': {
		translation: 'Something went wrong. Could not save your Training.',
	},
	'Something went wrong. Could not update your Training.': {
		translation: 'Something went wrong. Could not update your Training.',
	},
	'Something went wrong. Please try again.': {
		translation: 'Something went wrong. Please try again.',
	},
	'Something went wrong. Try again in a few moments.': {
		translation: 'Something went wrong. Try again in a few moments.',
	},
	'Something went wrong. Try submitting again in a few moments.': {
		translation: 'Something went wrong. Try submitting again in a few moments.',
	},
	'Somewhat Agree': {
		translation: 'Somewhat Agree',
	},
	'Somewhat Disagree': {
		translation: 'Somewhat Disagree',
	},
	Son: {
		translation: 'Son',
	},
	'Soonest first': {
		translation: 'Soonest first',
	},
	'Sorry we could not delete this access level.': {
		translation: 'Sorry we could not delete this access level.',
	},
	'Sorry we could not duplicate this access level.': {
		translation: 'Sorry we could not duplicate this access level.',
	},
	'Sorry we were unable to generate a preview for that file.': {
		translation: 'Sorry we were unable to generate a preview for that file.',
	},
	"Sorry!  You can't view this report because it hasn't been shared with you.":
		{
			translation:
				"Sorry!  You can't view this report because it hasn't been shared with you.",
		},
	"Sorry! I couldn't find any names resembling `%1$s`!": {
		translation: "Sorry! I couldn't find any names resembling `%1$s`!",
	},
	"Sorry! I couldn't find any names resembling `%1$s`.": {
		translation: "Sorry! I couldn't find any names resembling `%1$s`.",
	},
	"Sorry! I couldn't find the `%1$s` %2$s.": {
		translation: "Sorry! I couldn't find the `%1$s` %2$s.",
	},
	'Sorry! You aren’t currently listed as an employee in BambooHR so you can’t access time off.':
		{
			translation:
				'Sorry! You aren’t currently listed as an employee in BambooHR so you can’t access time off.',
		},
	"Sorry! You can't view this report because it hasn't been shared with you.": {
		translation:
			"Sorry! You can't view this report because it hasn't been shared with you.",
	},
	'Sorry! Your company isn’t currently managing time off within BambooHR.': {
		translation:
			'Sorry! Your company isn’t currently managing time off within BambooHR.',
	},
	'Sorry, This task has already been completed.': {
		translation: 'Sorry, This task has already been completed.',
	},
	'Sorry, a document on this task needs to be signed first. Click into the task for more detail.':
		{
			translation:
				'Sorry, a document on this task needs to be signed first. Click into the task for more detail.',
		},
	'Sorry, but ': {
		translation: 'Sorry, but ',
	},
	'Sorry, company names are limited to 80 characters.': {
		translation: 'Sorry, company names are limited to 80 characters.',
	},
	"Sorry, for some reason we weren't able to save your changes to the New Hire Packet. Try it again?":
		{
			translation:
				"Sorry, for some reason we weren't able to save your changes to the New Hire Packet. Try it again?",
		},
	'Sorry, it looks like we are missing some critical pieces of your template. Please try again':
		{
			translation:
				'Sorry, it looks like we are missing some critical pieces of your template. Please try again',
		},
	'Sorry, it looks like your email to %1$s was never received. It may be due to a lot of replies on a long email thread, or the amount of text or visual elements included. Please adjust your email and try again.':
		{
			translation:
				'Sorry, it looks like your email to %1$s was never received. It may be due to a lot of replies on a long email thread, or the amount of text or visual elements included. Please adjust your email and try again.',
		},
	'Sorry, missing required message, email message, or subject field. Please try again.':
		{
			translation:
				'Sorry, missing required message, email message, or subject field. Please try again.',
		},
	"Sorry, no results for '%1$s'.": {
		translation: "Sorry, no results for '%1$s'.",
	},
	'Sorry, no results were found.': {
		translation: 'Sorry, no results were found.',
	},
	'Sorry, one or more candidates have been moved or deleted. Please remove any candidates that have been moved or deleted and try again.':
		{
			translation:
				'Sorry, one or more candidates have been moved or deleted. Please remove any candidates that have been moved or deleted and try again.',
		},
	"Sorry, something went awry and we weren't able to clock you in. Try again?":
		{
			translation:
				"Sorry, something went awry and we weren't able to clock you in. Try again?",
		},
	"Sorry, something went awry and we weren't able to clock you out. Try again?":
		{
			translation:
				"Sorry, something went awry and we weren't able to clock you out. Try again?",
		},
	'Sorry, something went wrong. Please try again.': {
		translation: 'Sorry, something went wrong. Please try again.',
	},
	'Sorry, something went wrong. Try giving it another shot?': {
		translation: 'Sorry, something went wrong. Try giving it another shot?',
	},
	"Sorry, that doesn't really exist.": {
		translation: "Sorry, that doesn't really exist.",
	},
	"Sorry, that doesn't really exists.": {
		translation: "Sorry, that doesn't really exists.",
	},
	'Sorry, that doesn’t really exist.': {
		translation: 'Sorry, that doesn’t really exist.',
	},
	"Sorry, that password doesn't look right. Try it again?": {
		translation: "Sorry, that password doesn't look right. Try it again?",
	},
	"Sorry, that's not a valid Routing Number": {
		translation: "Sorry, that's not a valid Routing Number",
	},
	"Sorry, the resource you've requested appears to belong to someone else.": {
		translation:
			"Sorry, the resource you've requested appears to belong to someone else.",
	},
	'Sorry, the survey requested was invalid. Try again?': {
		translation: 'Sorry, the survey requested was invalid. Try again?',
	},
	"Sorry, there aren't any records that match your filter criteria.": {
		translation:
			"Sorry, there aren't any records that match your filter criteria.",
	},
	"Sorry, there was a little glitch trying to save the applicant's rating. Try it again?":
		{
			translation:
				"Sorry, there was a little glitch trying to save the applicant's rating. Try it again?",
		},
	'Sorry, there was a problem loading calendar events. Try it again?': {
		translation:
			'Sorry, there was a problem loading calendar events. Try it again?',
	},
	'Sorry, there was a problem posting your announcement. Try it again?': {
		translation:
			'Sorry, there was a problem posting your announcement. Try it again?',
	},
	'Sorry, this Job Opening is no longer available.': {
		translation: 'Sorry, this Job Opening is no longer available.',
	},
	'Sorry, this candidate has been moved or deleted. Please refresh your page.':
		{
			translation:
				'Sorry, this candidate has been moved or deleted. Please refresh your page.',
		},
	"Sorry, this doesn't exist anymore.": {
		translation: "Sorry, this doesn't exist anymore.",
	},
	'Sorry, this job is not currently accepting applications.': {
		translation: 'Sorry, this job is not currently accepting applications.',
	},
	'Sorry, this offer is no longer available.': {
		translation: 'Sorry, this offer is no longer available.',
	},
	'Sorry, this page is no longer available.': {
		translation: 'Sorry, this page is no longer available.',
	},
	'Sorry, unable to verify account': {
		translation: 'Sorry, unable to verify account',
	},
	'Sorry, we are unable to process an image. Please check that all images are added via the menu and not copy pasted.':
		{
			translation:
				'Sorry, we are unable to process an image. Please check that all images are added via the menu and not copy pasted.',
		},
	"Sorry, we can't delete values with employees associated.": {
		translation: "Sorry, we can't delete values with employees associated.",
	},
	'Sorry, we can’t accept the ".%s" file format. Make sure you’re selecting the right file and try again.':
		{
			translation:
				'Sorry, we can’t accept the \\".%s\\" file format. Make sure you’re selecting the right file and try again.',
		},
	'Sorry, we can’t cancel this New Hire Packet because it has already been completed.':
		{
			translation:
				'Sorry, we can’t cancel this New Hire Packet because it has already been completed.',
		},
	'Sorry, we can’t provide a preview for this file.': {
		translation: 'Sorry, we can’t provide a preview for this file.',
	},
	'Sorry, we can’t send emails to duplicate addresses. Remove the duplicates and give it another try.':
		{
			translation:
				'Sorry, we can’t send emails to duplicate addresses. Remove the duplicates and give it another try.',
		},
	'Sorry, we could not delete the report folder.': {
		translation: 'Sorry, we could not delete the report folder.',
	},
	'Sorry, we could not remove Total Rewards profiles': {
		translation: 'Sorry, we could not remove Total Rewards profiles',
	},
	"Sorry, we couldn't complete the update.": {
		translation: "Sorry, we couldn't complete the update.",
	},
	'Sorry, we no longer support SVGs. Please remove any SVGs and try again.': {
		translation:
			'Sorry, we no longer support SVGs. Please remove any SVGs and try again.',
	},
	'Sorry, we were unable to delete the %1$s tag.': {
		translation: 'Sorry, we were unable to delete the %1$s tag.',
	},
	'Sorry, we were unable to save the template. Please remove invalid placeholders and try again.':
		{
			translation:
				'Sorry, we were unable to save the template. Please remove invalid placeholders and try again.',
		},
	'Sorry, we were unable to save the template. Please try again.': {
		translation:
			'Sorry, we were unable to save the template. Please try again.',
	},
	'Sorry, we were unable to send the email. Please try again.': {
		translation: 'Sorry, we were unable to send the email. Please try again.',
	},
	'Sorry, we were unable to store the interview request data. Please try again.':
		{
			translation:
				'Sorry, we were unable to store the interview request data. Please try again.',
		},
	"Sorry, we're having trouble getting your tax information.": {
		translation: "Sorry, we're having trouble getting your tax information.",
	},
	"Sorry, you can't complete this task without first attaching a file.": {
		translation:
			"Sorry, you can't complete this task without first attaching a file.",
	},
	"Sorry, you can't request more than 10 years off.": {
		translation: "Sorry, you can't request more than 10 years off.",
	},
	"Sorry, you can't send more than %1 emails at once. Please deselect some people and try again.":
		{
			translation:
				"Sorry, you can't send more than %1 emails at once. Please deselect some people and try again.",
		},
	'Sorry, you can’t sign this document in preview mode.': {
		translation: 'Sorry, you can’t sign this document in preview mode.',
	},
	'Sorry, you can’t sign this document until %1$s has finished filling it out.':
		{
			translation:
				'Sorry, you can’t sign this document until %1$s has finished filling it out.',
		},
	'Sorry, you can’t sign this document until someone has finished filling it out.':
		{
			translation:
				'Sorry, you can’t sign this document until someone has finished filling it out.',
		},
	"Sorry, you don't have permission needed to do that.": {
		translation: "Sorry, you don't have permission needed to do that.",
	},
	"Sorry, you don't have permission to complete this task": {
		translation: "Sorry, you don't have permission to complete this task",
	},
	"Sorry, you don't have permission to delete a contact from this employee.": {
		translation:
			"Sorry, you don't have permission to delete a contact from this employee.",
	},
	"Sorry, you don't have permission to do that.": {
		translation: "Sorry, you don't have permission to do that.",
	},
	"Sorry, you don't have permissions to update this candidate.": {
		translation: "Sorry, you don't have permissions to update this candidate.",
	},
	"Sorry, you don't have the tool needed to do that.": {
		translation: "Sorry, you don't have the tool needed to do that.",
	},
	'Sorry, you need access to your company directory in order to use the BambooHR Chrome Extension':
		{
			translation:
				'Sorry, you need access to your company directory in order to use the BambooHR Chrome Extension',
		},
	'Sorry, you need to be a billing contact to view that page.': {
		translation: 'Sorry, you need to be a billing contact to view that page.',
	},
	'Sorry, your announcement is too big (over 27,000 characters) to email, so it has not been posted or emailed. You can still post it, but it can’t be emailed.':
		{
			translation:
				'Sorry, your announcement is too big (over 27,000 characters) to email, so it has not been posted or emailed. You can still post it, but it can’t be emailed.',
		},
	'Sorry, your reply to the hiring team was not delivered. The reply window for this conversation has expired (%d days from receipt). Please reach out to the hiring team directly if you need to continue the conversation.':
		{
			translation:
				'Sorry, your reply to the hiring team was not delivered. The reply window for this conversation has expired (%d days from receipt). Please reach out to the hiring team directly if you need to continue the conversation.',
		},
	'Sorry.  This row can not be deleted because there is a change request for it that is waiting for approval.':
		{
			translation:
				'Sorry.  This row can not be deleted because there is a change request for it that is waiting for approval.',
		},
	'Sorry. You currently do not have permission to do that.': {
		translation: 'Sorry. You currently do not have permission to do that.',
	},
	'Sorry. Your Netsuite account or token credentials appear to be invalid. Please try again.':
		{
			translation:
				'Sorry. Your Netsuite account or token credentials appear to be invalid. Please try again.',
		},
	'Sorry... you can only repost every %1 days. You have %1 days to go.': {
		translation:
			'Sorry... you can only repost every %1 days. You have %1 days to go.',
	},
	'Sort Results': {
		translation: 'Sort Results',
	},
	'Sort by': {
		translation: 'Sort by',
	},
	'Sort by ': {
		translation: 'Sort by ',
	},
	Sortable: {
		translation: 'Sortable',
	},
	'Sorting Order:': {
		translation: 'Sorting Order:',
	},
	'Sounds Good': {
		translation: 'Sounds Good',
	},
	"Sounds Good! We'll ask again in a week.": {
		translation: "Sounds Good! We'll ask again in a week.",
	},
	"Sounds Good! We'll ask again in two weeks.": {
		translation: "Sounds Good! We'll ask again in two weeks.",
	},
	Source: {
		translation: 'Source',
	},
	'Source Name': {
		translation: 'Source Name',
	},
	'Source already exists.': {
		translation: 'Source already exists.',
	},
	'Source has been deleted.': {
		translation: 'Source has been deleted.',
	},
	'Source has been updated.': {
		translation: 'Source has been updated.',
	},
	Spanish: {
		translation: 'Spanish',
	},
	'Specific Date': {
		translation: 'Specific Date',
	},
	'Specific Person': {
		translation: 'Specific Person',
	},
	'Specific Person must be an active user': {
		translation: 'Specific Person must be an active user',
	},
	'Specific people': {
		translation: 'Specific people',
	},
	"Spot the holes in your data so you can see what's missing and take action. There's nothing better than complete data.":
		{
			translation:
				"Spot the holes in your data so you can see what's missing and take action. There's nothing better than complete data.",
		},
	'Spot the holes in your data!': {
		translation: 'Spot the holes in your data!',
	},
	Spouse: {
		translation: 'Spouse',
	},
	'Spouse Coverage Amount': {
		translation: 'Spouse Coverage Amount',
	},
	'Spouse coverage amount specified but the plan does not support spouse or domestic partner coverage for benefit plan %s.':
		{
			translation:
				'Spouse coverage amount specified but the plan does not support spouse or domestic partner coverage for benefit plan %s.',
		},
	'Spouse coverage amount specified but we could not find your spouse or domestic partner for benefit plan %s.':
		{
			translation:
				'Spouse coverage amount specified but we could not find your spouse or domestic partner for benefit plan %s.',
		},
	'Spouse/DP Coverage Amount': {
		translation: 'Spouse/DP Coverage Amount',
	},
	'Sr. Director of Learning': {
		translation: 'Sr. Director of Learning',
	},
	'Sr. Director of Marketing': {
		translation: 'Sr. Director of Marketing',
	},
	'Sr. Director of Product': {
		translation: 'Sr. Director of Product',
	},
	'Sr. Director of Sales': {
		translation: 'Sr. Director of Sales',
	},
	'Sr. Director of UI/UX': {
		translation: 'Sr. Director of UI/UX',
	},
	'Sr. HR Administrator': {
		translation: 'Sr. HR Administrator',
	},
	'Sr. Manager of UI': {
		translation: 'Sr. Manager of UI',
	},
	'St of WA Labor': {
		translation: 'St of WA Labor',
	},
	'Staff/shift scheduling': {
		translation: 'Staff/shift scheduling',
	},
	Stage: {
		translation: 'Stage',
	},
	'Standard (Composite rate)': {
		translation: 'Standard (Composite rate)',
	},
	'Standard Fields': {
		translation: 'Standard Fields',
	},
	'Standard Holidays': {
		translation: 'Standard Holidays',
	},
	'Standard Hours Per Week': {
		translation: 'Standard Hours Per Week',
	},
	'Standard Reports': {
		translation: 'Standard Reports',
	},
	'Standard Vacation Policy': {
		translation: 'Standard Vacation Policy',
	},
	'Standard holidays were successfully copied to %1$d.': {
		translation: 'Standard holidays were successfully copied to %1$d.',
	},
	Start: {
		translation: 'Start',
	},
	'Start & End Times': {
		translation: 'Start & End Times',
	},
	'Start Date': {
		translation: 'Start Date',
	},
	"Start Date can't be an empty string": {
		translation: "Start Date can't be an empty string",
	},
	'Start Feedback': {
		translation: 'Start Feedback',
	},
	'Start Feedback On': {
		translation: 'Start Feedback On',
	},
	'Start Peer Feedback': {
		translation: 'Start Peer Feedback',
	},
	'Start Peer Feedback For A Manager': {
		translation: 'Start Peer Feedback For A Manager',
	},
	'Start Peer Feedback For the Entire Company': {
		translation: 'Start Peer Feedback For the Entire Company',
	},
	'Start Time': {
		translation: 'Start Time',
	},
	'Start Tracking Changes': {
		translation: 'Start Tracking Changes',
	},
	'Start With': {
		translation: 'Start With',
	},
	'Start an email conversation with %s.': {
		translation: 'Start an email conversation with %s.',
	},
	'Start and end date cannot be the same day.': {
		translation: 'Start and end date cannot be the same day.',
	},
	'Start at top': {
		translation: 'Start at top',
	},
	'Start by adding new items here.': {
		translation: 'Start by adding new items here.',
	},
	'Start by setting up your time off policies.': {
		translation: 'Start by setting up your time off policies.',
	},
	'Start by uploading files to this folder.': {
		translation: 'Start by uploading files to this folder.',
	},
	'Start date': {
		translation: 'Start date',
	},
	'Start date must be before end date.': {
		translation: 'Start date must be before end date.',
	},
	'Start date must be in the format mm-dd-yyyy or mm/dd/yyyy.': {
		translation: 'Start date must be in the format mm-dd-yyyy or mm/dd/yyyy.',
	},
	'Start new sync job': {
		translation: 'Start new sync job',
	},
	'Start of ': {
		translation: 'Start of ',
	},
	'Start of Next Year': {
		translation: 'Start of Next Year',
	},
	'Start sending alerts': {
		translation: 'Start sending alerts',
	},
	'Start some commentary on %1.': {
		translation: 'Start some commentary on %1.',
	},
	'Start some commentary on %s.': {
		translation: 'Start some commentary on %s.',
	},
	'Start typing a name': {
		translation: 'Start typing a name',
	},
	'Start using BambooHR with Maxwell Health to easily manage your employee data and benefits together. This integration will keep BambooHR as your system of record for all employee data including demographic and payroll information, and Maxwell Health as your system of record for all the benefits offered to them.':
		{
			translation:
				'Start using BambooHR with Maxwell Health to easily manage your employee data and benefits together. This integration will keep BambooHR as your system of record for all employee data including demographic and payroll information, and Maxwell Health as your system of record for all the benefits offered to them.',
		},
	'Start with': {
		translation: 'Start with',
	},
	'Start/End': {
		translation: 'Start/End',
	},
	'Started %1': {
		translation: 'Started %1',
	},
	'Started on': {
		translation: 'Started on',
	},
	'Started sending at': {
		translation: 'Started sending at',
	},
	Starting: {
		translation: 'Starting',
	},
	'Starting %1': {
		translation: 'Starting %1',
	},
	'Starting *{1}* you will be able to see who is completing their Performance Assessments.':
		{
			translation:
				'Starting *{1}* you will be able to see who is completing their Performance Assessments.',
		},
	'Starting On': {
		translation: 'Starting On',
	},
	'Starting on': {
		translation: 'Starting on',
	},
	Starts: {
		translation: 'Starts',
	},
	'Starts %1$s': {
		translation: 'Starts %1$s',
	},
	'Starts Today': {
		translation: 'Starts Today',
	},
	State: {
		translation: 'State',
	},
	'State EIN': {
		translation: 'State EIN',
	},
	'State Exempt': {
		translation: 'State Exempt',
	},
	'State Expiration': {
		translation: 'State Expiration',
	},
	'State Filing Status': {
		translation: 'State Filing Status',
	},
	'State ID': {
		translation: 'State ID',
	},
	'State Issued ID Number': {
		translation: 'State Issued ID Number',
	},
	'State Tax Withholding': {
		translation: 'State Tax Withholding',
	},
	'State Tax Withholding Location': {
		translation: 'State Tax Withholding Location',
	},
	'State Tax Withholding State': {
		translation: 'State Tax Withholding State',
	},
	'State Tax Withholding Type': {
		translation: 'State Tax Withholding Type',
	},
	'State Tax Withholding information has been saved.': {
		translation: 'State Tax Withholding information has been saved.',
	},
	'State Tax Work Address Type': {
		translation: 'State Tax Work Address Type',
	},
	'State UI Exempt': {
		translation: 'State UI Exempt',
	},
	'State UI Tax Exempt': {
		translation: 'State UI Tax Exempt',
	},
	'State UI Work In': {
		translation: 'State UI Work In',
	},
	'State UI tax exempt': {
		translation: 'State UI tax exempt',
	},
	'State Unemployment Insurance': {
		translation: 'State Unemployment Insurance',
	},
	'State Unemployment Insurance Tax Exempt': {
		translation: 'State Unemployment Insurance Tax Exempt',
	},
	'State Unemployment Insurance Type': {
		translation: 'State Unemployment Insurance Type',
	},
	'State W-4 Withholding': {
		translation: 'State W-4 Withholding',
	},
	'State W-4 Withholding Information': {
		translation: 'State W-4 Withholding Information',
	},
	'State Where Employee Lives': {
		translation: 'State Where Employee Lives',
	},
	'State Withholding': {
		translation: 'State Withholding',
	},
	'State Withholding & Unemployment Insurance': {
		translation: 'State Withholding & Unemployment Insurance',
	},
	'State Withholding Type': {
		translation: 'State Withholding Type',
	},
	'State Withholdings': {
		translation: 'State Withholdings',
	},
	'State Work In': {
		translation: 'State Work In',
	},
	'State abbr.': {
		translation: 'State abbr.',
	},
	'State and Country must be a valid combination': {
		translation: 'State and Country must be a valid combination',
	},
	'State cannot be empty': {
		translation: 'State cannot be empty',
	},
	'State is required': {
		translation: 'State is required',
	},
	'State must be one of the 50 United States or D.C.': {
		translation: 'State must be one of the 50 United States or D.C.',
	},
	'State/Province': {
		translation: 'State/Province',
	},
	'State: %1$s': {
		translation: 'State: %1$s',
	},
	Status: {
		translation: 'Status',
	},
	'Status Group': {
		translation: 'Status Group',
	},
	'Status History Item ID': {
		translation: 'Status History Item ID',
	},
	'Status Name': {
		translation: 'Status Name',
	},
	'Status as of %1$s': {
		translation: 'Status as of %1$s',
	},
	'Status saved! Care to comment on this update? (optional)': {
		translation: 'Status saved! Care to comment on this update? (optional)',
	},
	'Status set to **{1}**': {
		translation: 'Status set to **{1}**',
	},
	'Status:': {
		translation: 'Status:',
	},
	'Stay on top of your trainings and certifications.': {
		translation: 'Stay on top of your trainings and certifications.',
	},
	Step_one: {
		translation: 'Step',
	},
	Step_other: {
		translation: '',
	},
	'Step %1 of %2': {
		translation: 'Step %1 of %2',
	},
	'Step 1 - Install the BambooHR app in your Slack workspace': {
		translation: 'Step 1 - Install the BambooHR app in your Slack workspace',
	},
	'Step 1: Connection Info': {
		translation: 'Step 1: Connection Info',
	},
	'Step 1: Log in to a Checkr account': {
		translation: 'Step 1: Log in to a Checkr account',
	},
	'Step 1: Log in to a Cronofy account': {
		translation: 'Step 1: Log in to a Cronofy account',
	},
	'Step 2: Authorize and Install the integration in your BambooHR account': {
		translation:
			'Step 2: Authorize and Install the integration in your BambooHR account',
	},
	'Step 2: Install the Checkr integration here in BambooHR': {
		translation: 'Step 2: Install the Checkr integration here in BambooHR',
	},
	'Step 2: Install the Cronofy integration here in BambooHR': {
		translation: 'Step 2: Install the Cronofy integration here in BambooHR',
	},
	'Step 2: Role Mapping': {
		translation: 'Step 2: Role Mapping',
	},
	'Step 3: Initial Sync': {
		translation: 'Step 3: Initial Sync',
	},
	'Step child': {
		translation: 'Step child',
	},
	'Steps to Setup': {
		translation: 'Steps to Setup',
	},
	'Steps to setup provisioning:': {
		translation: 'Steps to setup provisioning:',
	},
	'Still Have Questions?': {
		translation: 'Still Have Questions?',
	},
	'Still Needed': {
		translation: 'Still Needed',
	},
	'Still allow username & password login': {
		translation: 'Still allow username & password login',
	},
	'Still clocked in': {
		translation: 'Still clocked in',
	},
	'Still have questions?': {
		translation: 'Still have questions?',
	},
	'Still in the Running': {
		translation: 'Still in the Running',
	},
	Stock: {
		translation: 'Stock',
	},
	'Stock Option': {
		translation: 'Stock Option',
	},
	'Stock Options': {
		translation: 'Stock Options',
	},
	'Stock Options: # Options Granted': {
		translation: 'Stock Options: # Options Granted',
	},
	'Stock Options: Comments': {
		translation: 'Stock Options: Comments',
	},
	'Stock Options: Grant Date': {
		translation: 'Stock Options: Grant Date',
	},
	'Stock Options: Option Price': {
		translation: 'Stock Options: Option Price',
	},
	'Stock Options: Plan': {
		translation: 'Stock Options: Plan',
	},
	'Stock Options: Vesting Date': {
		translation: 'Stock Options: Vesting Date',
	},
	Storage: {
		translation: 'Storage',
	},
	'Storage Type': {
		translation: 'Storage Type',
	},
	'Storage Upgrade': {
		translation: 'Storage Upgrade',
	},
	'Stored Filters': {
		translation: 'Stored Filters',
	},
	'Streamlined workflow': {
		translation: 'Streamlined workflow',
	},
	'Street 1': {
		translation: 'Street 1',
	},
	'Street 2': {
		translation: 'Street 2',
	},
	'Street 2 (Optional)': {
		translation: 'Street 2 (Optional)',
	},
	'Street Address': {
		translation: 'Street Address',
	},
	'Street Address 1': {
		translation: 'Street Address 1',
	},
	'Street Address 2': {
		translation: 'Street Address 2',
	},
	'Street, City, State/Province, Zip/Postal': {
		translation: 'Street, City, State/Province, Zip/Postal',
	},
	'Strike Price': {
		translation: 'Strike Price',
	},
	'Strongly Agree': {
		translation: 'Strongly Agree',
	},
	'Strongly Disagree': {
		translation: 'Strongly Disagree',
	},
	'Style Guide': {
		translation: 'Style Guide',
	},
	Subdomain: {
		translation: 'Subdomain',
	},
	'Subdomain: This is the very first part only of your BambooHR login URL. For example, if I log into my BambooHR account by going to https://bamboohrcs.bamboohr.com, then my subdomain is "bamboohrcs"':
		{
			translation:
				'Subdomain: This is the very first part only of your BambooHR login URL. For example, if I log into my BambooHR account by going to https://bamboohrcs.bamboohr.com, then my subdomain is \\"bamboohrcs\\"',
		},
	Subject: {
		translation: 'Subject',
	},
	'Subject (1)': {
		translation: 'Subject (1)',
	},
	'Subject (2)': {
		translation: 'Subject (2)',
	},
	'Subject (3)': {
		translation: 'Subject (3)',
	},
	'Subject (4)': {
		translation: 'Subject (4)',
	},
	'Subject Too Long.': {
		translation: 'Subject Too Long.',
	},
	'Subject is too long.': {
		translation: 'Subject is too long.',
	},
	'Subject line is too long.': {
		translation: 'Subject line is too long.',
	},
	'Subject:': {
		translation: 'Subject:',
	},
	'Submission Checklist': {
		translation: 'Submission Checklist',
	},
	'Submission successful, candidate has been added.': {
		translation: 'Submission successful, candidate has been added.',
	},
	Submit: {
		translation: 'Submit',
	},
	'Submit Answers': {
		translation: 'Submit Answers',
	},
	'Submit Application': {
		translation: 'Submit Application',
	},
	'Submit Assessment': {
		translation: 'Submit Assessment',
	},
	'Submit Feedback': {
		translation: 'Submit Feedback',
	},
	'Submit Request': {
		translation: 'Submit Request',
	},
	'Submit Valid Emails': {
		translation: 'Submit Valid Emails',
	},
	'Submit a Payroll Support Request': {
		translation: 'Submit a Payroll Support Request',
	},
	'Submit a Support Request': {
		translation: 'Submit a Support Request',
	},
	'Submit a Valid Email': {
		translation: 'Submit a Valid Email',
	},
	'Submit new time off requests for review and approval': {
		translation: 'Submit new time off requests for review and approval',
	},
	Submitted: {
		translation: 'Submitted',
	},
	'Subscriber SSN': {
		translation: 'Subscriber SSN',
	},
	'Subscriber or Internal Status': {
		translation: 'Subscriber or Internal Status',
	},
	Subscribers: {
		translation: 'Subscribers',
	},
	'Subscribers by Employee Count': {
		translation: 'Subscribers by Employee Count',
	},
	Subtract: {
		translation: 'Subtract',
	},
	Subtracted: {
		translation: 'Subtracted',
	},
	Success: {
		translation: 'Success',
	},
	'Success Rep': {
		translation: 'Success Rep',
	},
	'Success!': {
		translation: 'Success!',
	},
	'Success! Email confirmed.': {
		translation: 'Success! Email confirmed.',
	},
	"Success! Now you’re ready to experience how easy it is to prepare and run payroll with BambooHR and Gusto working together! As you use this integration, it's important that you only use BambooHR as your system of record, which will always keep your employee information in Gusto up to date.":
		{
			translation:
				"Success! Now you’re ready to experience how easy it is to prepare and run payroll with BambooHR and Gusto working together! As you use this integration, it's important that you only use BambooHR as your system of record, which will always keep your employee information in Gusto up to date.",
		},
	'Success! The %1$s tag has been created!': {
		translation: 'Success! The %1$s tag has been created!',
	},
	'Success! The %1$s tag has been deleted!': {
		translation: 'Success! The %1$s tag has been deleted!',
	},
	'Success! The tag has been updated!': {
		translation: 'Success! The tag has been updated!',
	},
	'Success! The time entry has been deleted.': {
		translation: 'Success! The time entry has been deleted.',
	},
	'Successfully added a %s email for %s': {
		translation: 'Successfully added a %s email for %s',
	},
	'Successfully added an email for 1 employee': {
		translation: {
			one: 'Successfully added an email for 1 employee',
			other: 'Successfully added emails for %d employees',
		},
	},
	'Successfully added an item from template': {
		translation: {
			one: 'Successfully added an item from template',
			other: 'Successfully added %1$s items from template',
		},
	},
	'Successfully added the new task': {
		translation: 'Successfully added the new task',
	},
	'Successfully converted %1$s from days to hours': {
		translation: 'Successfully converted %1$s from days to hours',
	},
	'Successfully converted %1$s from hours to days': {
		translation: 'Successfully converted %1$s from hours to days',
	},
	'Successfully enrolled. Other ': {
		translation: 'Successfully enrolled. Other ',
	},
	'Successfully imported %d employee from Cornerstone.': {
		translation: {
			one: 'Successfully imported %d employee from Cornerstone.',
			other: 'Successfully imported %d employees from Cornerstone.',
		},
	},
	'Successfully removed scheduled change.': {
		translation: 'Successfully removed scheduled change.',
	},
	'Successfully removed scheduled change. Any waives tied to this change have also been removed.':
		{
			translation:
				'Successfully removed scheduled change. Any waives tied to this change have also been removed.',
		},
	'Successfully saved your company information': {
		translation: 'Successfully saved your company information',
	},
	'Successfully sent you another verification email.': {
		translation: 'Successfully sent you another verification email.',
	},
	'Successfully subscribed to time tracking.': {
		translation: 'Successfully subscribed to time tracking.',
	},
	'Successfully updated employee benefit group': {
		translation: 'Successfully updated employee benefit group',
	},
	'Successfully updated the task': {
		translation: 'Successfully updated the task',
	},
	'Suggested address': {
		translation: 'Suggested address',
	},
	Suggestions: {
		translation: 'Suggestions',
	},
	Summary: {
		translation: 'Summary',
	},
	'Summary:': {
		translation: 'Summary:',
	},
	'Summer Pay': {
		translation: 'Summer Pay',
	},
	'Summer Salary': {
		translation: 'Summer Salary',
	},
	'Summer Special': {
		translation: 'Summer Special',
	},
	Sunday: {
		translation: 'Sunday',
	},
	Sundays: {
		translation: 'Sundays',
	},
	Supervisor: {
		translation: 'Supervisor',
	},
	'Supervisor Assessment': {
		translation: 'Supervisor Assessment',
	},
	'Supervisor EID': {
		translation: 'Supervisor EID',
	},
	'Supervisor ID': {
		translation: 'Supervisor ID',
	},
	'Supervisor email': {
		translation: 'Supervisor email',
	},
	'Supervisor name': {
		translation: 'Supervisor name',
	},
	Supplemental: {
		translation: 'Supplemental',
	},
	'Supplemental Health': {
		translation: 'Supplemental Health',
	},
	'Supplemental Health Plan': {
		translation: 'Supplemental Health Plan',
	},
	'Support Admins do not have permission to SSO to this Outside URL': {
		translation:
			'Support Admins do not have permission to SSO to this Outside URL',
	},
	'Support Rep': {
		translation: 'Support Rep',
	},
	'Support Request Details': {
		translation: 'Support Request Details',
	},
	Survey: {
		translation: 'Survey',
	},
	'Survey Completion - %1%2': {
		translation: 'Survey Completion - %1%2',
	},
	'Survey Date: ': {
		translation: 'Survey Date: ',
	},
	'Survey Launch': {
		translation: 'Survey Launch',
	},
	'Survey Period': {
		translation: 'Survey Period',
	},
	'Survey Period is Now Closed': {
		translation: 'Survey Period is Now Closed',
	},
	'Survey Responses': {
		translation: 'Survey Responses',
	},
	'Survey closes %1%2%3 %4 %5.': {
		translation: 'Survey closes %1%2%3 %4 %5.',
	},
	'Survey responses limited to: ': {
		translation: 'Survey responses limited to: ',
	},
	'Survey will close 5 business days after %1.': {
		translation: 'Survey will close 5 business days after %1.',
	},
	'Survey will close 6 business days after %1.': {
		translation: 'Survey will close 6 business days after %1.',
	},
	'Surveys can only be sent out every %1 months.': {
		translation: 'Surveys can only be sent out every %1 months.',
	},
	Suspended: {
		translation: 'Suspended',
	},
	Sweater: {
		translation: 'Sweater',
	},
	'SwipeClock synchronization enabled.': {
		translation: 'SwipeClock synchronization enabled.',
	},
	'SwipeClock synchronization has been suspended.': {
		translation: 'SwipeClock synchronization has been suspended.',
	},
	'SwipeClock&reg; integrates with BambooHR through our API. Employee information from within BambooHR is automatically pushed to SwipeClock&reg; so the two systems stay in sync.':
		{
			translation:
				'SwipeClock&reg; integrates with BambooHR through our API. Employee information from within BambooHR is automatically pushed to SwipeClock&reg; so the two systems stay in sync.',
		},
	"SwipeClock® is an online time and attendance solution for businesses, both large and small. It defines practicality in today's timekeeping industry, offering simple hardware setup, exceptional user-ease, and affordability to businesses of all sizes. Through SwipeClock’s web-based service, employers can automate the process of collecting and calculating time card data for payroll, and payroll providers can automate the process of collecting timekeeping data while increasing revenue generated from their payroll package.":
		{
			translation:
				"SwipeClock® is an online time and attendance solution for businesses, both large and small. It defines practicality in today's timekeeping industry, offering simple hardware setup, exceptional user-ease, and affordability to businesses of all sizes. Through SwipeClock’s web-based service, employers can automate the process of collecting and calculating time card data for payroll, and payroll providers can automate the process of collecting timekeeping data while increasing revenue generated from their payroll package.",
		},
	'Sydney, Australia': {
		translation: 'Sydney, Australia',
	},
	Sync: {
		translation: 'Sync',
	},
	'Sync All Data': {
		translation: 'Sync All Data',
	},
	'Sync Errors:': {
		translation: 'Sync Errors:',
	},
	'Sync Locations': {
		translation: 'Sync Locations',
	},
	'Sync To ClearBenefits': {
		translation: 'Sync To ClearBenefits',
	},
	'Sync in progress': {
		translation: 'Sync in progress',
	},
	'Sync to a Payroll System': {
		translation: 'Sync to a Payroll System',
	},
	'Sync your interviews to your calendar.': {
		translation: 'Sync your interviews to your calendar.',
	},
	'Synced With': {
		translation: 'Synced With',
	},
	Synchronization: {
		translation: 'Synchronization',
	},
	Synchronize: {
		translation: 'Synchronize',
	},
	'Synchronize Now': {
		translation: 'Synchronize Now',
	},
	'Synchronizing Employees: After the initial importing/exporting of employees has occurred, if a change to a record is made within BambooHR, customers can come to the Synchronize Employees box and a button will be provided for them to synchronize and update any new information within Simplepay.ca.':
		{
			translation:
				'Synchronizing Employees: After the initial importing/exporting of employees has occurred, if a change to a record is made within BambooHR, customers can come to the Synchronize Employees box and a button will be provided for them to synchronize and update any new information within Simplepay.ca.',
		},
	Syncing: {
		translation: 'Syncing',
	},
	'Syncing %d employee to Cornerstone.': {
		translation: {
			one: 'Syncing %d employee to Cornerstone.',
			other: 'Syncing %d employees to Cornerstone.',
		},
	},
	'Syncing Data...': {
		translation: 'Syncing Data...',
	},
	'Syncing to Cornerstone may take some time. You will receive an email when the sync is complete.':
		{
			translation:
				'Syncing to Cornerstone may take some time. You will receive an email when the sync is complete.',
		},
	'System Integration': {
		translation: 'System Integration',
	},
	'System User': {
		translation: 'System User',
	},
	'Systems Genius': {
		translation: 'Systems Genius',
	},
	'T-Shirt Size': {
		translation: 'T-Shirt Size',
	},
	'T-shirt': {
		translation: 'T-shirt',
	},
	'T-shirt size': {
		translation: 'T-shirt size',
	},
	'TAKE-HOME PAY': {
		translation: 'TAKE-HOME PAY',
	},
	TAXES: {
		translation: 'TAXES',
	},
	'TB Test': {
		translation: 'TB Test',
	},
	TN1: {
		translation: 'TN1',
	},
	'TOTAL GROSS PAY': {
		translation: 'TOTAL GROSS PAY',
	},
	'TRAVE MED #': {
		translation: 'TRAVE MED #',
	},
	"TRAXPayroll offers small and medium-sized businesses a proven system that delivers trouble-free payroll processing and tax filing, as well as other employer services Premium Only Plans (Section 125) and Workers' Compensation Premium Payment Service…all with timeliness, precision and unmatched convenience. And all at a very affordable price.":
		{
			translation:
				"TRAXPayroll offers small and medium-sized businesses a proven system that delivers trouble-free payroll processing and tax filing, as well as other employer services Premium Only Plans (Section 125) and Workers' Compensation Premium Payment Service…all with timeliness, precision and unmatched convenience. And all at a very affordable price.",
		},
	Tab: {
		translation: 'Tab',
	},
	'Tab name is required': {
		translation: 'Tab name is required',
	},
	'Tab name must not have more than 40 characters': {
		translation: 'Tab name must not have more than 40 characters',
	},
	'Table of excess wage data': {
		translation: 'Table of excess wage data',
	},
	'Table of local W2 data': {
		translation: 'Table of local W2 data',
	},
	'Table of pay cycle history data': {
		translation: 'Table of pay cycle history data',
	},
	'Table of state W2 data': {
		translation: 'Table of state W2 data',
	},
	Tables: {
		translation: 'Tables',
	},
	'Tabs changed successfully. Refreshing the page!': {
		translation: 'Tabs changed successfully. Refreshing the page!',
	},
	Tags: {
		translation: 'Tags',
	},
	'Tags - Dislikes': {
		translation: 'Tags - Dislikes',
	},
	'Tags - Likes': {
		translation: 'Tags - Likes',
	},
	'Take Company Offline': {
		translation: 'Take Company Offline',
	},
	'Take a New Snapshot': {
		translation: 'Take a New Snapshot',
	},
	'Take a few minutes to complete your Self Assessment.': {
		translation: 'Take a few minutes to complete your Self Assessment.',
	},
	"Take a look at any steps that aren't checked off over there on the left": {
		translation:
			"Take a look at any steps that aren't checked off over there on the left",
	},
	'Take a look at the address bar when you are logged in to BambooHR (or ask a colleague, since you are not logged in). The text just before .bamboohr.com is your domain.':
		{
			translation:
				'Take a look at the address bar when you are logged in to BambooHR (or ask a colleague, since you are not logged in). The text just before .bamboohr.com is your domain.',
		},
	'Take a look.': {
		translation: 'Take a look.',
	},
	'Take a moment to complete your Employee Assessments.': {
		translation: 'Take a moment to complete your Employee Assessments.',
	},
	'Take a moment to double check that everything looks ok.': {
		translation: 'Take a moment to double check that everything looks ok.',
	},
	'Take a moment to double check that your employees have the correct employment and ACA status.':
		{
			translation:
				'Take a moment to double check that your employees have the correct employment and ACA status.',
		},
	'Take a moment to provide feedback about your coworkers.': {
		translation: 'Take a moment to provide feedback about your coworkers.',
	},
	'Take a moment to review your benefit plans and employee benefit groups and ensure everybody is in the right group and all your plan deductions are accurate':
		{
			translation:
				'Take a moment to review your benefit plans and employee benefit groups and ensure everybody is in the right group and all your plan deductions are accurate',
		},
	'Take a moment to select peers to give feedback about your team members.': {
		translation:
			'Take a moment to select peers to give feedback about your team members.',
	},
	'Take a moment to select people to give feedback about your team members.': {
		translation:
			'Take a moment to select people to give feedback about your team members.',
	},
	'Take a peek at your job listing.': {
		translation: 'Take a peek at your job listing.',
	},
	'Take luck!': {
		translation: 'Take luck!',
	},
	'Take me Home': {
		translation: 'Take me Home',
	},
	'Take me there': {
		translation: 'Take me there',
	},
	'Talent Pools': {
		translation: 'Talent Pools',
	},
	'Talk to your HR Administrator to see if they can dig it up.': {
		translation: 'Talk to your HR Administrator to see if they can dig it up.',
	},
	Tardy: {
		translation: 'Tardy',
	},
	Task: {
		translation: 'Task',
	},
	'Task Added Successfully': {
		translation: 'Task Added Successfully',
	},
	'Task Completed': {
		translation: 'Task Completed',
	},
	'Task List': {
		translation: 'Task List',
	},
	'Task Name': {
		translation: 'Task Name',
	},
	'Task completed!': {
		translation: 'Task completed!',
	},
	'Task name already exists for the project, project task names must be unique.':
		{
			translation:
				'Task name already exists for the project, project task names must be unique.',
		},
	'Task name is too long, must be 50 characters or fewer.': {
		translation: 'Task name is too long, must be 50 characters or fewer.',
	},
	'Task reopened.': {
		translation: 'Task reopened.',
	},
	Tasklist: {
		translation: 'Tasklist',
	},
	'Tasklist item updated!': {
		translation: 'Tasklist item updated!',
	},
	'Tasklist name': {
		translation: 'Tasklist name',
	},
	Tasks: {
		translation: 'Tasks',
	},
	'Tasks to Complete': {
		translation: 'Tasks to Complete',
	},
	'Tasks: Assigned To': {
		translation: 'Tasks: Assigned To',
	},
	'Tasks: Category': {
		translation: 'Tasks: Category',
	},
	'Tasks: Completed': {
		translation: 'Tasks: Completed',
	},
	'Tasks: Completed Date': {
		translation: 'Tasks: Completed Date',
	},
	'Tasks: Due Date': {
		translation: 'Tasks: Due Date',
	},
	'Tasks: Task name': {
		translation: 'Tasks: Task name',
	},
	'Tasks: Tasklist': {
		translation: 'Tasks: Tasklist',
	},
	'Tax Balance': {
		translation: 'Tax Balance',
	},
	'Tax Balance Details': {
		translation: 'Tax Balance Details',
	},
	'Tax Balances Details': {
		translation: 'Tax Balances Details',
	},
	'Tax Collection': {
		translation: 'Tax Collection',
	},
	'Tax Collection Approval': {
		translation: 'Tax Collection Approval',
	},
	'Tax Details': {
		translation: 'Tax Details',
	},
	'Tax Document Delivery': {
		translation: 'Tax Document Delivery',
	},
	'Tax Documents': {
		translation: 'Tax Documents',
	},
	'Tax File Number': {
		translation: 'Tax File Number',
	},
	'Tax Filing Status': {
		translation: 'Tax Filing Status',
	},
	'Tax ID': {
		translation: 'Tax ID',
	},
	'Tax ID is not a vaild format for the selected tax type.': {
		translation: 'Tax ID is not a vaild format for the selected tax type.',
	},
	'Tax Info Change': {
		translation: 'Tax Info Change',
	},
	'Tax Information Changes': {
		translation: 'Tax Information Changes',
	},
	'Tax Levies': {
		translation: 'Tax Levies',
	},
	'Tax Levy': {
		translation: 'Tax Levy',
	},
	'Tax Rate': {
		translation: 'Tax Rate',
	},
	'Tax Refund': {
		translation: 'Tax Refund',
	},
	'Tax State': {
		translation: 'Tax State',
	},
	'Tax States *Unemployment State': {
		translation: 'Tax States *Unemployment State',
	},
	'Tax Type': {
		translation: 'Tax Type',
	},
	'Tax Type is required': {
		translation: 'Tax Type is required',
	},
	'Tax Type/ID': {
		translation: 'Tax Type/ID',
	},
	'Tax Withholding': {
		translation: 'Tax Withholding',
	},
	'Tax Withholding information for %1$s has been saved.': {
		translation: 'Tax Withholding information for %1$s has been saved.',
	},
	'Tax agencies are responsible for returning funds from amended tax filings. The money is typically returned via check.  You may need to reach out to the agency to request the refund after the amendment is filed.':
		{
			translation:
				'Tax agencies are responsible for returning funds from amended tax filings. The money is typically returned via check.  You may need to reach out to the agency to request the refund after the amendment is filed.',
		},
	'Tax filing status': {
		translation: 'Tax filing status',
	},
	'Tax type can be updated with the [employment status].': {
		translation: 'Tax type can be updated with the [employment status].',
	},
	'Taxable Wage': {
		translation: 'Taxable Wage',
	},
	Taxes: {
		translation: 'Taxes',
	},
	'Taxes Collected': {
		translation: 'Taxes Collected',
	},
	Teacher: {
		translation: 'Teacher',
	},
	"Teacher's Holidays": {
		translation: "Teacher's Holidays",
	},
	"Teacher's Vacation Policy": {
		translation: "Teacher's Vacation Policy",
	},
	Team: {
		translation: 'Team',
	},
	'Team Bar Chart': {
		translation: 'Team Bar Chart',
	},
	'Team already exists': {
		translation: 'Team already exists',
	},
	'Team not found': {
		translation: 'Team not found',
	},
	Teams: {
		translation: 'Teams',
	},
	'Technical Recruiter': {
		translation: 'Technical Recruiter',
	},
	Technicians: {
		translation: 'Technicians',
	},
	'Tell us a little about yourself:': {
		translation: 'Tell us a little about yourself:',
	},
	'Tell us more. Is it . . .': {
		translation: 'Tell us more. Is it . . .',
	},
	'Template Imported Successfully': {
		translation: 'Template Imported Successfully',
	},
	'Template Name': {
		translation: 'Template Name',
	},
	'Template was restored to defaults.': {
		translation: 'Template was restored to defaults.',
	},
	'Temporary ZIP code': {
		translation: 'Temporary ZIP code',
	},
	'Temporary address': {
		translation: 'Temporary address',
	},
	'Temporary address 2': {
		translation: 'Temporary address 2',
	},
	'Temporary city': {
		translation: 'Temporary city',
	},
	'Temporary state': {
		translation: 'Temporary state',
	},
	Tenure: {
		translation: 'Tenure',
	},
	'Terminate Coverage': {
		translation: 'Terminate Coverage',
	},
	'Terminate Employee...': {
		translation: 'Terminate Employee...',
	},
	'Terminate Employees': {
		translation: 'Terminate Employees',
	},
	'Terminate Employment': {
		translation: 'Terminate Employment',
	},
	'Terminate Employment for: ': {
		translation: 'Terminate Employment for: ',
	},
	Terminated: {
		translation: 'Terminated',
	},
	'Terminated Employees': {
		translation: 'Terminated Employees',
	},
	'Terminated coverage for %s': {
		translation: 'Terminated coverage for %s',
	},
	'Terminated coverage for %s on %s': {
		translation: 'Terminated coverage for %s on %s',
	},
	Termination: {
		translation: 'Termination',
	},
	'Termination (Involuntary)': {
		translation: 'Termination (Involuntary)',
	},
	'Termination Comment': {
		translation: 'Termination Comment',
	},
	'Termination Date': {
		translation: 'Termination Date',
	},
	'Termination Date: %s': {
		translation: 'Termination Date: %s',
	},
	'Termination Effective': {
		translation: 'Termination Effective',
	},
	'Termination Reason': {
		translation: 'Termination Reason',
	},
	'Termination Type': {
		translation: 'Termination Type',
	},
	'Termination Type & Regrettable or Non-Regrettable': {
		translation: 'Termination Type & Regrettable or Non-Regrettable',
	},
	'Termination date': {
		translation: 'Termination date',
	},
	'Termination entered on %1$s and set to termination date of %2$s': {
		translation:
			'Termination entered on %1$s and set to termination date of %2$s',
	},
	'Termination from %1$s coverage effective.': {
		translation: 'Termination from %1$s coverage effective.',
	},
	'Termination from %1$s entered on %2$s and set to termination date of %3$s.':
		{
			translation:
				'Termination from %1$s entered on %2$s and set to termination date of %3$s.',
		},
	'Termination from Employee Pays %1$s and Company Pays %2$s effective.': {
		translation:
			'Termination from Employee Pays %1$s and Company Pays %2$s effective.',
	},
	'Termination of CHIP': {
		translation: 'Termination of CHIP',
	},
	'Termination of Medicaid': {
		translation: 'Termination of Medicaid',
	},
	'Termination of employment - Involuntary': {
		translation: 'Termination of employment - Involuntary',
	},
	'Termination of employment - Voluntary': {
		translation: 'Termination of employment - Voluntary',
	},
	'Termination or Resignation': {
		translation: 'Termination or Resignation',
	},
	Terminations: {
		translation: 'Terminations',
	},
	'Terms of Service': {
		translation: 'Terms of Service',
	},
	'Test Date': {
		translation: 'Test Date',
	},
	'Test Report': {
		translation: 'Test Report',
	},
	'Test SSO': {
		translation: 'Test SSO',
	},
	'Test Single Sign-on': {
		translation: 'Test Single Sign-on',
	},
	'Test Submit': {
		translation: 'Test Submit',
	},
	'Test Type': {
		translation: 'Test Type',
	},
	'Test the connection. Once the number of employees looks accurate click save.':
		{
			translation:
				'Test the connection. Once the number of employees looks accurate click save.',
		},
	Testing: {
		translation: 'Testing',
	},
	'Testing Reason': {
		translation: 'Testing Reason',
	},
	'Testing Tracker': {
		translation: 'Testing Tracker',
	},
	'Testing Tracker: Comments': {
		translation: 'Testing Tracker: Comments',
	},
	'Testing Tracker: Confirmed by HR': {
		translation: 'Testing Tracker: Confirmed by HR',
	},
	'Testing Tracker: Office Eligibility': {
		translation: 'Testing Tracker: Office Eligibility',
	},
	'Testing Tracker: Results': {
		translation: 'Testing Tracker: Results',
	},
	'Testing Tracker: Test Date': {
		translation: 'Testing Tracker: Test Date',
	},
	'Testing Tracker: Test Type': {
		translation: 'Testing Tracker: Test Type',
	},
	'Testing Tracker: Testing Reason': {
		translation: 'Testing Tracker: Testing Reason',
	},
	Text: {
		translation: 'Text',
	},
	'Text Field': {
		translation: 'Text Field',
	},
	'Text Response': {
		translation: 'Text Response',
	},
	'Text about Google SCIM How it works': {
		translation: 'Text about Google SCIM How it works',
	},
	'Text about Jump Cloud SCIM How it works': {
		translation: 'Text about Jump Cloud SCIM How it works',
	},
	'Text about JumpCloud SCIM How it works': {
		translation: 'Text about JumpCloud SCIM How it works',
	},
	'Thank You': {
		translation: 'Thank You',
	},
	'Thank you for entering the deposit amount. We will': {
		translation: 'Thank you for entering the deposit amount. We will',
	},
	'Thank you for your interest.': {
		translation: 'Thank you for your interest.',
	},
	'Thank you.': {
		translation: 'Thank you.',
	},
	'Thanks a bunch for trying out BambooHR!': {
		translation: 'Thanks a bunch for trying out BambooHR!',
	},
	'Thanks for checking out our job openings. See something that interests you? Apply here.':
		{
			translation:
				'Thanks for checking out our job openings. See something that interests you? Apply here.',
		},
	'Thanks for dropping in.': {
		translation: 'Thanks for dropping in.',
	},
	'Thanks for letting us know.': {
		translation: 'Thanks for letting us know.',
	},
	'Thanks for your feedback!': {
		translation: 'Thanks for your feedback!',
	},
	"Thanks for your interest in BambooHR's Employee Satisfaction with eNPS®": {
		translation:
			"Thanks for your interest in BambooHR's Employee Satisfaction with eNPS®",
	},
	"Thanks for your interest in BambooHR's Performance Management": {
		translation:
			"Thanks for your interest in BambooHR's Performance Management",
	},
	"Thanks for your interest in BambooHR's Time Tracking": {
		translation: "Thanks for your interest in BambooHR's Time Tracking",
	},
	'Thanks for your interest in our TRAXPayroll integration.': {
		translation: 'Thanks for your interest in our TRAXPayroll integration.',
	},
	'Thanks so much for your feedback!': {
		translation: 'Thanks so much for your feedback!',
	},
	'Thanks to BambooHR, our small admin group has more time to connect with our teams and be proactive in building a transparent, supportive culture across our offices worldwide.':
		{
			translation:
				'Thanks to BambooHR, our small admin group has more time to connect with our teams and be proactive in building a transparent, supportive culture across our offices worldwide.',
		},
	'Thanks!': {
		translation: 'Thanks!',
	},
	"Thanks, I'm Done": {
		translation: "Thanks, I'm Done",
	},
	"Thanks, I'm done.": {
		translation: "Thanks, I'm done.",
	},
	'Thanks, inflation.': {
		translation: 'Thanks, inflation.',
	},
	'That Project/Task is not a valid option': {
		translation: 'That Project/Task is not a valid option',
	},
	'That action cannot be performed while previewing a packet.': {
		translation: 'That action cannot be performed while previewing a packet.',
	},
	'That date is already set. To make an adjustment, select a different date.': {
		translation:
			'That date is already set. To make an adjustment, select a different date.',
	},
	'That domain is already in use.': {
		translation: 'That domain is already in use.',
	},
	"That employee or policy doesn't exist.": {
		translation: "That employee or policy doesn't exist.",
	},
	"That employee training doesn't exist": {
		translation: "That employee training doesn't exist",
	},
	"That employee training doesn't exist.": {
		translation: "That employee training doesn't exist.",
	},
	'That option is not a valid Citizenship': {
		translation: 'That option is not a valid Citizenship',
	},
	'That option is not a valid Compensation Change Reason': {
		translation: 'That option is not a valid Compensation Change Reason',
	},
	'That option is not a valid Country': {
		translation: 'That option is not a valid Country',
	},
	'That option is not a valid Department': {
		translation: 'That option is not a valid Department',
	},
	'That option is not a valid Division': {
		translation: 'That option is not a valid Division',
	},
	'That option is not a valid Employment Status': {
		translation: 'That option is not a valid Employment Status',
	},
	'That option is not a valid Ethnicity': {
		translation: 'That option is not a valid Ethnicity',
	},
	'That option is not a valid FLSA Code': {
		translation: 'That option is not a valid FLSA Code',
	},
	'That option is not a valid Gender': {
		translation: 'That option is not a valid Gender',
	},
	'That option is not a valid Gender Identity': {
		translation: 'That option is not a valid Gender Identity',
	},
	'That option is not a valid Job Title': {
		translation: 'That option is not a valid Job Title',
	},
	'That option is not a valid Location': {
		translation: 'That option is not a valid Location',
	},
	'That option is not a valid Marital Status': {
		translation: 'That option is not a valid Marital Status',
	},
	'That option is not a valid Nationality': {
		translation: 'That option is not a valid Nationality',
	},
	'That option is not a valid Pay Schedule': {
		translation: 'That option is not a valid Pay Schedule',
	},
	'That option is not a valid Pronoun': {
		translation: 'That option is not a valid Pronoun',
	},
	'That option is not a valid Reports To': {
		translation: 'That option is not a valid Reports To',
	},
	'That option is not a valid Status': {
		translation: 'That option is not a valid Status',
	},
	'That option is not a valid Tax Type': {
		translation: 'That option is not a valid Tax Type',
	},
	'That option is not a valid Termination Reason': {
		translation: 'That option is not a valid Termination Reason',
	},
	'That option is not a valid Termination Type': {
		translation: 'That option is not a valid Termination Type',
	},
	'That option is not a valid Veteran Status': {
		translation: 'That option is not a valid Veteran Status',
	},
	'That option is not a valid for Eligible for Rehire': {
		translation: 'That option is not a valid for Eligible for Rehire',
	},
	'That option is not a valid for Regrettable Termination': {
		translation: 'That option is not a valid for Regrettable Termination',
	},
	'That option is not valid Overtime Status': {
		translation: 'That option is not valid Overtime Status',
	},
	'That request has already been approved.': {
		translation: 'That request has already been approved.',
	},
	'That request has already been completed.': {
		translation: 'That request has already been completed.',
	},
	'That request was canceled.': {
		translation: 'That request was canceled.',
	},
	"That row can't be deleted because the employee has an invalid SSN": {
		translation:
			"That row can't be deleted because the employee has an invalid SSN",
	},
	'That time off request has already been approved or denied': {
		translation: 'That time off request has already been approved or denied',
	},
	'That user is not presently enabled': {
		translation: 'That user is not presently enabled',
	},
	"That's a sweet tooth": {
		translation: "That's a sweet tooth",
	},
	"That's all of them. There's nothing left to add here.": {
		translation: "That's all of them. There's nothing left to add here.",
	},
	'The ': {
		translation: 'The ',
	},
	'The "%1$s" access level is locked and cannot be deleted.': {
		translation: 'The \\"%1$s\\" access level is locked and cannot be deleted.',
	},
	'The "%1$s" access level is locked and cannot be edited.': {
		translation: 'The \\"%1$s\\" access level is locked and cannot be edited.',
	},
	'The "Get to Know You" answers will be hidden for %s.': {
		translation: 'The \\"Get to Know You\\" answers will be hidden for %s.',
	},
	'The %1 %2 Folder is Empty': {
		translation: 'The %1 %2 Folder is Empty',
	},
	'The %1$s field is read-only because of the solution provider: ': {
		translation:
			'The %1$s field is read-only because of the solution provider: ',
	},
	'The %1$sNew Hire Packet for %3$s%2$s was successfully sent to %1$s%4$s%2$s.':
		{
			translation:
				'The %1$sNew Hire Packet for %3$s%2$s was successfully sent to %1$s%4$s%2$s.',
		},
	'The %s field is a required field and is either empty or cannot be found': {
		translation:
			'The %s field is a required field and is either empty or cannot be found',
	},
	'The %s file folder has been shared with you.': {
		translation: 'The %s file folder has been shared with you.',
	},
	'The %s pay group is too long. Pay group names must be less that 256 characters long.':
		{
			translation:
				'The %s pay group is too long. Pay group names must be less that 256 characters long.',
		},
	'The %s pay group name is already in use.': {
		translation: 'The %s pay group name is already in use.',
	},
	'The %s report folder has been shared with you.': {
		translation: 'The %s report folder has been shared with you.',
	},
	'The %s was added successfully.': {
		translation: 'The %s was added successfully.',
	},
	'The 10th day of the month': {
		translation: 'The 10th day of the month',
	},
	'The 11th day of the month': {
		translation: 'The 11th day of the month',
	},
	'The 12th day of the month': {
		translation: 'The 12th day of the month',
	},
	'The 13th day of the month': {
		translation: 'The 13th day of the month',
	},
	'The 14th day of the month': {
		translation: 'The 14th day of the month',
	},
	'The 15th day of the month': {
		translation: 'The 15th day of the month',
	},
	'The 16th day of the month': {
		translation: 'The 16th day of the month',
	},
	'The 17th day of the month': {
		translation: 'The 17th day of the month',
	},
	'The 18th day of the month': {
		translation: 'The 18th day of the month',
	},
	'The 19th day of the month': {
		translation: 'The 19th day of the month',
	},
	'The 1st day of the month': {
		translation: 'The 1st day of the month',
	},
	'The 20th day of the month': {
		translation: 'The 20th day of the month',
	},
	'The 21st day of the month': {
		translation: 'The 21st day of the month',
	},
	'The 22nd day of the month': {
		translation: 'The 22nd day of the month',
	},
	'The 23rd day of the month': {
		translation: 'The 23rd day of the month',
	},
	'The 24th day of the month': {
		translation: 'The 24th day of the month',
	},
	'The 25th day of the month': {
		translation: 'The 25th day of the month',
	},
	'The 26th day of the month': {
		translation: 'The 26th day of the month',
	},
	'The 27th day of the month': {
		translation: 'The 27th day of the month',
	},
	'The 28th day of the month': {
		translation: 'The 28th day of the month',
	},
	'The 2nd day of the month': {
		translation: 'The 2nd day of the month',
	},
	'The 3rd day of the month': {
		translation: 'The 3rd day of the month',
	},
	'The 4th day of the month': {
		translation: 'The 4th day of the month',
	},
	'The 5th day of the month': {
		translation: 'The 5th day of the month',
	},
	'The 6th day of the month': {
		translation: 'The 6th day of the month',
	},
	'The 7th day of the month': {
		translation: 'The 7th day of the month',
	},
	'The 8th day of the month': {
		translation: 'The 8th day of the month',
	},
	'The 9th day of the month': {
		translation: 'The 9th day of the month',
	},
	'The Account': {
		translation: 'The Account',
	},
	'The Account Owner is the only person that can...': {
		translation: 'The Account Owner is the only person that can...',
	},
	'The Address Line 1 is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Address Line 1 is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Address Line 2 is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Address Line 2 is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Alert has been saved': {
		translation: 'The Alert has been saved',
	},
	'The BambooHR Slack Integration is already connected to another company. (If you wish to connect the BambooHR Slack Integration to this company, please uninstall and reinstall the BambooHR Slack Integration.':
		{
			translation:
				'The BambooHR Slack Integration is already connected to another company. (If you wish to connect the BambooHR Slack Integration to this company, please uninstall and reinstall the BambooHR Slack Integration.',
		},
	'The BambooHR Slack Integration is already connected to this company': {
		translation:
			'The BambooHR Slack Integration is already connected to this company',
	},
	'The Basics': {
		translation: 'The Basics',
	},
	'The Birth Date is outside the accepted date range': {
		translation: 'The Birth Date is outside the accepted date range',
	},
	'The City is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The City is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Company': {
		translation: 'The Company',
	},
	'The Company Information form is invalid.': {
		translation: 'The Company Information form is invalid.',
	},
	'The Compensation Effective Date cannot be empty': {
		translation: 'The Compensation Effective Date cannot be empty',
	},
	'The Compensation Effective Date is outside the accepted date range': {
		translation:
			'The Compensation Effective Date is outside the accepted date range',
	},
	'The Compensation Effective Date must be before the end date.': {
		translation: 'The Compensation Effective Date must be before the end date.',
	},
	'The Compensation End Date is outside the accepted date range': {
		translation: 'The Compensation End Date is outside the accepted date range',
	},
	'The Dead Letter Queue is empty.': {
		translation: 'The Dead Letter Queue is empty.',
	},
	'The Department is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Department is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Division is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Division is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Effective Date cannot be before the Plan Start Date.': {
		translation: 'The Effective Date cannot be before the Plan Start Date.',
	},
	'The Employee Number is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Employee Number is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Employee Training Record with the ID: %1$d does not exist': {
		translation:
			'The Employee Training Record with the ID: %1$d does not exist',
	},
	'The Employer section of your 1095-C exports will be populated with company information found ':
		{
			translation:
				'The Employer section of your 1095-C exports will be populated with company information found ',
		},
	'The Employment Status Effective Date is outside the accepted date range': {
		translation:
			'The Employment Status Effective Date is outside the accepted date range',
	},
	'The Employment Status is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Employment Status is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Employment Status was added successfully.': {
		translation: 'The Employment Status was added successfully.',
	},
	'The Field Type you requested is not valid.': {
		translation: 'The Field Type you requested is not valid.',
	},
	'The First Name is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The First Name is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Hire Date is outside the accepted date range': {
		translation: 'The Hire Date is outside the accepted date range',
	},
	'The IRS W4 withholding form has changed': {
		translation: 'The IRS W4 withholding form has changed',
	},
	'The IRS has provided a handy %1$swithholding calculator%2$s to help you figure out what to elect.':
		{
			translation:
				'The IRS has provided a handy %1$swithholding calculator%2$s to help you figure out what to elect.',
		},
	"The IRS has specific designations for employment status. Choose the ACA status that best fits each of your employment statuses. Don't worry, you can change these later in Settings >> Employee Fields >> Employment Status.":
		{
			translation:
				"The IRS has specific designations for employment status. Choose the ACA status that best fits each of your employment statuses. Don't worry, you can change these later in Settings >> Employee Fields >> Employment Status.",
		},
	'The Job Information Effective Date cannot be empty': {
		translation: 'The Job Information Effective Date cannot be empty',
	},
	'The Job Information Effective Date is outside the accepted date range': {
		translation:
			'The Job Information Effective Date is outside the accepted date range',
	},
	'The Job Opening was successfully deleted.': {
		translation: 'The Job Opening was successfully deleted.',
	},
	'The Last Name is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Last Name is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Last name is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Last name is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Location is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Location is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The National Id is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The National Id is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The New Hire Packet will be deleted and %s will no longer be able to access it.':
		{
			translation:
				'The New Hire Packet will be deleted and %s will no longer be able to access it.',
		},
	'The New Hire Packet will be sent to this email address.': {
		translation: 'The New Hire Packet will be sent to this email address.',
	},
	'The Nin is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Nin is not a valid length. The value must be between %1$s and %2$s characters',
		},
	"The Org Chart is no longer accessible in the reports sections. You can view it under the <a href='/employees/orgchart.php'>Employees</a> section.":
		{
			translation:
				"The Org Chart is no longer accessible in the reports sections. You can view it under the <a href='/employees/orgchart.php'>Employees</a> section.",
		},
	'The Original Hire Date is outside the accepted date range': {
		translation: 'The Original Hire Date is outside the accepted date range',
	},
	'The Overtime rate currency must be in USD when on a syncing pay schedule.': {
		translation:
			'The Overtime rate currency must be in USD when on a syncing pay schedule.',
	},
	'The PTO settings have been reset.': {
		translation: 'The PTO settings have been reset.',
	},
	'The Path to Payroll': {
		translation: 'The Path to Payroll',
	},
	'The PaysSymbol property is not valid': {
		translation: 'The PaysSymbol property is not valid',
	},
	'The PaysSymbol property must be set': {
		translation: 'The PaysSymbol property must be set',
	},
	'The Project Pay Rate Effective Date and End Date cannot be the same value': {
		translation:
			'The Project Pay Rate Effective Date and End Date cannot be the same value',
	},
	'The Project Pay Rate Effective Date is outside the accepted date range': {
		translation:
			'The Project Pay Rate Effective Date is outside the accepted date range',
	},
	'The Project Pay Rate End Date is outside the accepted date range': {
		translation:
			'The Project Pay Rate End Date is outside the accepted date range',
	},
	'The Project Pay Rate End Date must come after the Project Pay Rate Effective Date':
		{
			translation:
				'The Project Pay Rate End Date must come after the Project Pay Rate Effective Date',
		},
	'The Project/Task cannot be empty': {
		translation: 'The Project/Task cannot be empty',
	},
	'The Subject and Body both need to be filled out': {
		translation: 'The Subject and Body both need to be filled out',
	},
	'The Subject must be less than 200 characters': {
		translation: 'The Subject must be less than 200 characters',
	},
	'The TRAXPayroll safe harbor match setting will apply to your current and future 401(k) and Roth 401(k) plans.':
		{
			translation:
				'The TRAXPayroll safe harbor match setting will apply to your current and future 401(k) and Roth 401(k) plans.',
		},
	'The Tax ID must be entered in the exact format supplied by the state, including any dashes, spaces, numbers and/or letters.':
		{
			translation:
				'The Tax ID must be entered in the exact format supplied by the state, including any dashes, spaces, numbers and/or letters.',
		},
	'The URL is currently %1$s.': {
		translation: 'The URL is currently %1$s.',
	},
	'The Webhook was successfully deleted.': {
		translation: 'The Webhook was successfully deleted.',
	},
	'The Zipcode is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The Zipcode is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The Zipcode is not in a valid format': {
		translation: 'The Zipcode is not in a valid format',
	},
	'The access level has been duplicated': {
		translation: 'The access level has been duplicated',
	},
	'The account must have a "Job" tab in order to enable the Advantage Payroll app.':
		{
			translation:
				'The account must have a \\"Job\\" tab in order to enable the Advantage Payroll app.',
		},
	'The account must have a "Job" tab in order to enable the ClearBenefits/Benu app.':
		{
			translation:
				'The account must have a \\"Job\\" tab in order to enable the ClearBenefits/Benu app.',
		},
	'The account owner cannot be set to inactive': {
		translation: 'The account owner cannot be set to inactive',
	},
	'The account owner cannot be set to terminated.': {
		translation: 'The account owner cannot be set to terminated.',
	},
	"The accrual start date cannot be before the employee's hire date": {
		translation:
			"The accrual start date cannot be before the employee's hire date",
	},
	'The accrual start date is invalid for one or more employees.': {
		translation: 'The accrual start date is invalid for one or more employees.',
	},
	'The accrual start date is invalid.': {
		translation: 'The accrual start date is invalid.',
	},
	"The accrual start date must be on or after this employee's hire date of %1":
		{
			translation:
				"The accrual start date must be on or after this employee's hire date of %1",
		},
	"The accuracy or retention of the data in the customer's account.": {
		translation:
			"The accuracy or retention of the data in the customer's account.",
	},
	'The address entered is a bit different from what we show as the standard address':
		{
			translation:
				'The address entered is a bit different from what we show as the standard address',
		},
	'The address provided is not valid.': {
		translation: 'The address provided is not valid.',
	},
	'The alert has been deleted.': {
		translation: 'The alert has been deleted.',
	},
	'The alert has been saved.': {
		translation: 'The alert has been saved.',
	},
	'The answers %s provided will be hidden from other employees.': {
		translation: 'The answers %s provided will be hidden from other employees.',
	},
	'The answers %s provided will no longer be hidden from other employees.': {
		translation:
			'The answers %s provided will no longer be hidden from other employees.',
	},
	'The answers to the "Get to Know You" questions will be hidden for %1$s.': {
		translation:
			'The answers to the \\"Get to Know You\\" questions will be hidden for %1$s.',
	},
	"The bad guys are getting pretty good at getting into things they shouldn't. 2-Step Login adds another layer of security to protect your account. When enabled, Bamboo access will require a password and a code generated from an authenticator app.":
		{
			translation:
				"The bad guys are getting pretty good at getting into things they shouldn't. 2-Step Login adds another layer of security to protect your account. When enabled, Bamboo access will require a password and a code generated from an authenticator app.",
		},
	'The beneficial ownership information is invalid.': {
		translation: 'The beneficial ownership information is invalid.',
	},
	'The benefit plan Id provided is not valid.': {
		translation: 'The benefit plan Id provided is not valid.',
	},
	'The benefitPlanId is not valid': {
		translation: 'The benefitPlanId is not valid',
	},
	'The bonus has been changed since you last reconciled it.': {
		translation: 'The bonus has been changed since you last reconciled it.',
	},
	'The candidate has requested to no longer receive these emails.': {
		translation:
			'The candidate has requested to no longer receive these emails.',
	},
	'The candidate requested to no longer receive these emails.': {
		translation: 'The candidate requested to no longer receive these emails.',
	},
	"The candidate's email service provider has prevented delivery. We'll keep trying.":
		{
			translation:
				"The candidate's email service provider has prevented delivery. We'll keep trying.",
		},
	'The category was saved.': {
		translation: 'The category was saved.',
	},
	'The change takes effect immediately.': {
		translation: 'The change takes effect immediately.',
	},
	'The child coverage amount must be at least zero for benefit plan %s.': {
		translation:
			'The child coverage amount must be at least zero for benefit plan %s.',
	},
	'The child coverage amount should be a multiple of the coverage increment value for benefit plan %s.':
		{
			translation:
				'The child coverage amount should be a multiple of the coverage increment value for benefit plan %s.',
		},
	'The child coverage is not within the min/max range for benefit plan %s.': {
		translation:
			'The child coverage is not within the min/max range for benefit plan %s.',
	},
	'The clock out time is before the clock in time.': {
		translation: 'The clock out time is before the clock in time.',
	},
	'The comment is not a valid length. The value must be between %1$s and %2$s characters':
		{
			translation:
				'The comment is not a valid length. The value must be between %1$s and %2$s characters',
		},
	'The comment made with the rating (including any replies) will also be deleted.':
		{
			translation:
				'The comment made with the rating (including any replies) will also be deleted.',
		},
	'The comment made with the rating (including any replies) will be deleted. The rating will also reset to what it was previously.':
		{
			translation:
				'The comment made with the rating (including any replies) will be deleted. The rating will also reset to what it was previously.',
		},
	'The comment made with the status (including any replies) will also be deleted.':
		{
			translation:
				'The comment made with the status (including any replies) will also be deleted.',
		},
	'The comment made with the status (including any replies) will be deleted. The status will also reset to what it was previously.':
		{
			translation:
				'The comment made with the status (including any replies) will be deleted. The status will also reset to what it was previously.',
		},
	'The commission has been changed since you last reconciled it.': {
		translation:
			'The commission has been changed since you last reconciled it.',
	},
	'The company data has been changed.': {
		translation: 'The company data has been changed.',
	},
	'The company direction or purpose was better defined.': {
		translation: 'The company direction or purpose was better defined.',
	},
	'The company matches employee contributions dollar-for-dollar up to 3%% of compensations, and 50 cents on the dollar of contributions between 3–5%% of compensation.':
		{
			translation:
				'The company matches employee contributions dollar-for-dollar up to 3%% of compensations, and 50 cents on the dollar of contributions between 3–5%% of compensation.',
		},
	'The company setting does not allow editing or deleting of history line items.':
		{
			translation:
				'The company setting does not allow editing or deleting of history line items.',
		},
	'The company was created successfully': {
		translation: 'The company was created successfully',
	},
	'The company will match your contribution %1 dollar-for-dollar up to 3%3 %2 of your compensation, and %1 50 cents on the dollar of your contribution between 3-5%3 %2 of your compensation.':
		{
			translation:
				'The company will match your contribution %1 dollar-for-dollar up to 3%3 %2 of your compensation, and %1 50 cents on the dollar of your contribution between 3-5%3 %2 of your compensation.',
		},
	'The company will match your contribution dollar-for-dollar up to 3% of your compensation, and 50 cents on the dollar of your contribution between 3-5% of your compensation.':
		{
			translation:
				'The company will match your contribution dollar-for-dollar up to 3% of your compensation, and 50 cents on the dollar of your contribution between 3-5% of your compensation.',
		},
	'The company will match your contribution dollar-for-dollar up to 3%% of your compensation, and 50 cents on the dollar of your contribution between 3-5%% of your compensation.':
		{
			translation:
				'The company will match your contribution dollar-for-dollar up to 3%% of your compensation, and 50 cents on the dollar of your contribution between 3-5%% of your compensation.',
		},
	'The company will reimburse up to…': {
		translation: 'The company will reimburse up to…',
	},
	'The companyId in the filter criteria does not match the current company': {
		translation:
			'The companyId in the filter criteria does not match the current company',
	},
	'The currency amount must be greater than 0 when employee is on a syncing pay schedule':
		{
			translation:
				'The currency amount must be greater than 0 when employee is on a syncing pay schedule',
		},
	'The currency amount must be greater than or equal to 0 when employee is on a syncing pay schedule':
		{
			translation:
				'The currency amount must be greater than or equal to 0 when employee is on a syncing pay schedule',
		},
	'The currency amount provided is not valid': {
		translation: 'The currency amount provided is not valid',
	},
	'The currency amount provided is not valid.': {
		translation: 'The currency amount provided is not valid.',
	},
	'The currency code provided is not valid': {
		translation: 'The currency code provided is not valid',
	},
	'The currency code provided is not valid.': {
		translation: 'The currency code provided is not valid.',
	},
	'The current balance for %1$s is %2$s day': {
		translation: {
			one: 'The current balance for %1$s is %2$s day',
			other: 'The current balance for %1$s is %2$s days',
		},
	},
	'The current balance for %1$s is %2$s hour': {
		translation: {
			one: 'The current balance for %1$s is %2$s hour',
			other: 'The current balance for %1$s is %2$s hours',
		},
	},
	"The current birthdate on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current birthdate on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current employee number on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current employee number on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current first name on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current first name on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current gender on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current gender on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current hire date on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current hire date on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current home email on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current home email on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current marital status on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current marital status on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current ssn on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current ssn on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	"The current ssn or ein on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current ssn or ein on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	'The current survey status was not expected.': {
		translation: 'The current survey status was not expected.',
	},
	"The current work email on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule":
		{
			translation:
				"The current work email on the employee's profile is invalid and must be addressed before being added to a syncing pay schedule",
		},
	'The custom approval template was not found.': {
		translation: 'The custom approval template was not found.',
	},
	'The custom approval was not found.': {
		translation: 'The custom approval was not found.',
	},
	'The custom coverage name is not unique for the benefit plan.': {
		translation: 'The custom coverage name is not unique for the benefit plan.',
	},
	'The custom coverage name is not unique for this benefit plan. Please try again.':
		{
			translation:
				'The custom coverage name is not unique for this benefit plan. Please try again.',
		},
	'The data benchmarking agreement cannot be updated to the specified status. Agreement Id: ':
		{
			translation:
				'The data benchmarking agreement cannot be updated to the specified status. Agreement Id: ',
		},
	'The data changed on Gusto and is out of sync. Please try again.': {
		translation:
			'The data changed on Gusto and is out of sync. Please try again.',
	},
	'The database encountered an error': {
		translation: 'The database encountered an error',
	},
	'The database encountered an error, please try again.': {
		translation: 'The database encountered an error, please try again.',
	},
	'The date selected is not valid': {
		translation: 'The date selected is not valid',
	},
	'The deadline for submitting this feedback is': {
		translation: 'The deadline for submitting this feedback is',
	},
	'The deduction type ID provided can not be used with this benefit plan type.':
		{
			translation:
				'The deduction type ID provided can not be used with this benefit plan type.',
		},
	'The deduction type id must be a number or null.': {
		translation: 'The deduction type id must be a number or null.',
	},
	'The deductionCode is not valid': {
		translation: 'The deductionCode is not valid',
	},
	'The department `%1$s` was not found.': {
		translation: 'The department `%1$s` was not found.',
	},
	'The department is not valid for the employee’s current or future pay schedule.':
		{
			translation:
				'The department is not valid for the employee’s current or future pay schedule.',
		},
	'The deposit amount entered is not correct. Please contact BambooHR Payroll Support.':
		{
			translation:
				'The deposit amount entered is not correct. Please contact BambooHR Payroll Support.',
		},
	'The deposit amount entered is not correct. You can attempt %s more time(s)':
		{
			translation:
				'The deposit amount entered is not correct. You can attempt %s more time(s)',
		},
	'The division is not valid for the employee’s current or future pay schedule.':
		{
			translation:
				'The division is not valid for the employee’s current or future pay schedule.',
		},
	'The double time rate is $%1.': {
		translation: 'The double time rate is $%1.',
	},
	'The e-Signatures in this document will become invalid once deleted.': {
		translation:
			'The e-Signatures in this document will become invalid once deleted.',
	},
	'The eNPS Scale': {
		translation: 'The eNPS Scale',
	},
	'The eNPS range is from -100 to +100.': {
		translation: 'The eNPS range is from -100 to +100.',
	},
	'The earliest is due': {
		translation: 'The earliest is due',
	},
	'The effective date is outside the accepted date range.': {
		translation: 'The effective date is outside the accepted date range.',
	},
	'The email is on its way! We will let you know when the client confirms it is ok to sweep the funds.':
		{
			translation:
				'The email is on its way! We will let you know when the client confirms it is ok to sweep the funds.',
		},
	'The email or password you entered is invalid.': {
		translation: 'The email or password you entered is invalid.',
	},
	'The email you entered does not match any user in BambooHR. Please contact your administrator to enable access.':
		{
			translation:
				'The email you entered does not match any user in BambooHR. Please contact your administrator to enable access.',
		},
	'The employee ID submitted does not exist': {
		translation: 'The employee ID submitted does not exist',
	},
	'The employee can now be viewed and updated within BambooHR.': {
		translation: 'The employee can now be viewed and updated within BambooHR.',
	},
	'The employee cannot report to themselves': {
		translation: 'The employee cannot report to themselves',
	},
	'The employee coverage amount must be greater than zero for benefit plan %s.':
		{
			translation:
				'The employee coverage amount must be greater than zero for benefit plan %s.',
		},
	'The employee coverage amount should be a multiple of the coverage increment value for benefit plan %s.':
		{
			translation:
				'The employee coverage amount should be a multiple of the coverage increment value for benefit plan %s.',
		},
	'The employee directory filter type provided is not valid.': {
		translation: 'The employee directory filter type provided is not valid.',
	},
	"The employee hasn't clocked in yet.": {
		translation: "The employee hasn't clocked in yet.",
	},
	'The employee is currently clocked out.': {
		translation: 'The employee is currently clocked out.',
	},
	'The employee is not enrolled in the benefit plan to take this deduction': {
		translation:
			'The employee is not enrolled in the benefit plan to take this deduction',
	},
	'The employee is not enrolled in the benefit plan update this memo': {
		translation:
			'The employee is not enrolled in the benefit plan update this memo',
	},
	'The employee number must be a number (%s)': {
		translation: 'The employee number must be a number (%s)',
	},
	'The employee number must be alphanumeric.': {
		translation: 'The employee number must be alphanumeric.',
	},
	'The employee number must be numeric.': {
		translation: 'The employee number must be numeric.',
	},
	'The employee was successfully deleted.': {
		translation: 'The employee was successfully deleted.',
	},
	"The employee's benefit group's pay period must match the pay period.": {
		translation:
			"The employee's benefit group's pay period must match the pay period.",
	},
	"The employee's direct deposit account information has been updated": {
		translation:
			"The employee's direct deposit account information has been updated",
	},
	'The employee/update_benefit_memo API can only be used to update an employee defined contribution plan':
		{
			translation:
				'The employee/update_benefit_memo API can only be used to update an employee defined contribution plan',
		},
	'The employeeId is not valid': {
		translation: 'The employeeId is not valid',
	},
	'The employeeId must be set': {
		translation: 'The employeeId must be set',
	},
	'The employees location, division or department is not valid with trax syncing pay schedules':
		{
			translation:
				'The employees location, division or department is not valid with trax syncing pay schedules',
		},
	'The end date is not valid.': {
		translation: 'The end date is not valid.',
	},
	'The end date must be after the start date': {
		translation: 'The end date must be after the start date',
	},
	'The end date must come after the start date.': {
		translation: 'The end date must come after the start date.',
	},
	'The enroll customer in payroll request was sent successfully': {
		translation: 'The enroll customer in payroll request was sent successfully',
	},
	'The export will take a while to complete.': {
		translation: 'The export will take a while to complete.',
	},
	'The field has too many characters.': {
		translation: 'The field has too many characters.',
	},
	'The file export you requested does not exist.': {
		translation: 'The file export you requested does not exist.',
	},
	'The file has been successfully deleted.': {
		translation: {
			one: 'The file has been successfully deleted.',
			other: '%d files deleted successfully.',
		},
	},
	'The file has been successfully uploaded.': {
		translation: {
			one: 'The file has been successfully uploaded.',
			other: 'The files have been successfully uploaded.',
		},
	},
	"The file won't be accessible to anyone with the link.": {
		translation: "The file won't be accessible to anyone with the link.",
	},
	'The file you are uploading is way bigger than we are expecting!': {
		translation:
			'The file you are uploading is way bigger than we are expecting!',
	},
	'The file you uploaded is not compatible!': {
		translation: 'The file you uploaded is not compatible!',
	},
	"The filter didn't save. Please try again in a moment.": {
		translation: "The filter didn't save. Please try again in a moment.",
	},
	'The first payroll deduction happens **{1}** {2} **{3}** the benefit effective date.':
		{
			translation:
				'The first payroll deduction happens **{1}** {2} **{3}** the benefit effective date.',
		},
	'The following employees couldn’t be updated because they are inactive or have no access:':
		{
			translation:
				'The following employees couldn’t be updated because they are inactive or have no access:',
		},
	'The following employees have not been rescheduled because they don’t have a current compensation date or their start date is outside the date you chose. These start dates can be altered individually in the employee record.':
		{
			translation:
				'The following employees have not been rescheduled because they don’t have a current compensation date or their start date is outside the date you chose. These start dates can be altered individually in the employee record.',
		},
	'The following employees haven’t been scheduled on your selected date because their hire and compensation dates don’t align or their start date is outside the date you chose. You can see their time tracking status below. Individual start dates can be altered individually in the employee record.':
		{
			translation:
				'The following employees haven’t been scheduled on your selected date because their hire and compensation dates don’t align or their start date is outside the date you chose. You can see their time tracking status below. Individual start dates can be altered individually in the employee record.',
		},
	'The following employees haven’t started working so they can’t start time tracking yet. You can see their time tracking status below. Individual start dates can be changed in their employee record.':
		{
			translation:
				'The following employees haven’t started working so they can’t start time tracking yet. You can see their time tracking status below. Individual start dates can be changed in their employee record.',
		},
	'The following employees haven’t started working yet so we’ll start them on their hire date. You can change this in their employee record or back in time tracking settings.':
		{
			translation:
				'The following employees haven’t started working yet so we’ll start them on their hire date. You can change this in their employee record or back in time tracking settings.',
		},
	'The following fields can be added to this approval form. Please note that fields used in other default approvals (i.e. Job Info, Compensation, and Employment Status Approvals) cannot be added and will be missing from the list below.':
		{
			translation:
				'The following fields can be added to this approval form. Please note that fields used in other default approvals (i.e. Job Info, Compensation, and Employment Status Approvals) cannot be added and will be missing from the list below.',
		},
	'The following fields cannot be blank: %s': {
		translation: 'The following fields cannot be blank: %s',
	},
	'The following file types are not allowed: ': {
		translation: 'The following file types are not allowed: ',
	},
	'The following files are too large: ': {
		translation: 'The following files are too large: ',
	},
	"The following information is used in determining what URL the webhook sends information to when an employee's information is changed.":
		{
			translation:
				"The following information is used in determining what URL the webhook sends information to when an employee's information is changed.",
		},
	"The following items couldn't be added because the employee is inactive or has no access:":
		{
			translation:
				"The following items couldn't be added because the employee is inactive or has no access:",
		},
	'The full dataset is not shown due to the filter applied to the custom report.':
		{
			translation:
				'The full dataset is not shown due to the filter applied to the custom report.',
		},
	'The import was completed successfully.': {
		translation: 'The import was completed successfully.',
	},
	'The import was successful, but there were some invalid records.': {
		translation:
			'The import was successful, but there were some invalid records.',
	},
	'The integration between BambooHR and the Bridge LMS is installed and configured by your Bridge Implementation Consultant.':
		{
			translation:
				'The integration between BambooHR and the Bridge LMS is installed and configured by your Bridge Implementation Consultant.',
		},
	'The intro email has been sent, the survey will be sent out on %1$s.': {
		translation:
			'The intro email has been sent, the survey will be sent out on %1$s.',
	},
	'The last day of the month': {
		translation: 'The last day of the month',
	},
	'The latest change to this field is waiting for approval. Click to go to the original request.':
		{
			translation:
				'The latest change to this field is waiting for approval. Click to go to the original request.',
		},
	'The legal text cannot be more than %s characters.': {
		translation: 'The legal text cannot be more than %s characters.',
	},
	'The location is not valid for the employee’s current or future pay schedule.':
		{
			translation:
				'The location is not valid for the employee’s current or future pay schedule.',
		},
	'The location, department, or division is not valid for the employee’s current or future pay schedule.':
		{
			translation:
				'The location, department, or division is not valid for the employee’s current or future pay schedule.',
		},
	'The main BambooHR Content': {
		translation: 'The main BambooHR Content',
	},
	'The manager assessment has already been completed and cannot be skipped.': {
		translation:
			'The manager assessment has already been completed and cannot be skipped.',
	},
	"The manager currently doesn't have access to BambooHR and can't complete the assessment.":
		{
			translation:
				"The manager currently doesn't have access to BambooHR and can't complete the assessment.",
		},
	'The manager you select will receive an email and inbox task to assign peer feedback to their direct reports that have not already been assigned.':
		{
			translation:
				'The manager you select will receive an email and inbox task to assign peer feedback to their direct reports that have not already been assigned.',
		},
	'The maximum file size you can upload is 20 MB.': {
		translation: 'The maximum file size you can upload is 20 MB.',
	},
	'The meet ACA minimum value is not valid': {
		translation: 'The meet ACA minimum value is not valid',
	},
	'The memoCode is not valid': {
		translation: 'The memoCode is not valid',
	},
	'The minimum Essential Coverage value is not valid': {
		translation: 'The minimum Essential Coverage value is not valid',
	},
	'The more detail you can add, the better. Watch this meter as you type...': {
		translation:
			'The more detail you can add, the better. Watch this meter as you type...',
	},
	'The name for this type cannot be "Regular", "Overtime", "Other", or "Holiday"':
		{
			translation:
				'The name for this type cannot be \\"Regular\\", \\"Overtime\\", \\"Other\\", or \\"Holiday\\"',
		},
	'The name for this type cannot be more than %1$s characters': {
		translation: 'The name for this type cannot be more than %1$s characters',
	},
	'The name of this task is too long': {
		translation: 'The name of this task is too long',
	},
	'The next reminder will be emailed to Employees and Managers on %1.': {
		translation:
			'The next reminder will be emailed to Employees and Managers on %1.',
	},
	'The next review date cannot be in the past.': {
		translation: 'The next review date cannot be in the past.',
	},
	'The next review date cannot be more than a year in the future.': {
		translation:
			'The next review date cannot be more than a year in the future.',
	},
	'The next review due date must not be in the past.': {
		translation: 'The next review due date must not be in the past.',
	},
	'The offer history will be permanently deleted and %1$s will no longer be able to see the current version.':
		{
			translation:
				'The offer history will be permanently deleted and %1$s will no longer be able to see the current version.',
		},
	'The offer history will be permanently deleted and %s$s will no longer be able to see the current version.':
		{
			translation:
				'The offer history will be permanently deleted and %s$s will no longer be able to see the current version.',
		},
	'The offer letter will be sent to this email address.': {
		translation: 'The offer letter will be sent to this email address.',
	},
	'The offer will be permanently deleted and %1$s will no longer be able to see it.':
		{
			translation:
				'The offer will be permanently deleted and %1$s will no longer be able to see it.',
		},
	'The offer will be permanently deleted and %s$s will no longer be able to see it.':
		{
			translation:
				'The offer will be permanently deleted and %s$s will no longer be able to see it.',
		},
	'The old address will no longer work or redirect to the new address.': {
		translation:
			'The old address will no longer work or redirect to the new address.',
	},
	'The oldest was due': {
		translation: 'The oldest was due',
	},
	'The only allowed file extensions are: %s': {
		translation: 'The only allowed file extensions are: %s',
	},
	'The only allowed image file extensions are: %s': {
		translation: 'The only allowed image file extensions are: %s',
	},
	'The overtime rate currency must be in USD when on a syncing pay schedule.': {
		translation:
			'The overtime rate currency must be in USD when on a syncing pay schedule.',
	},
	'The passion, drive, and engagement an employee brings to their role.': {
		translation:
			'The passion, drive, and engagement an employee brings to their role.',
	},
	"The pay group's pay frequency must match the benefit group's pay frequency.":
		{
			translation:
				"The pay group's pay frequency must match the benefit group's pay frequency.",
		},
	"The pay period must match the benefit group's pay frequency.": {
		translation: "The pay period must match the benefit group's pay frequency.",
	},
	'The pay rate currency must be a valid number when on a syncing pay schedule.':
		{
			translation:
				'The pay rate currency must be a valid number when on a syncing pay schedule.',
		},
	'The pay rate currency must be in USD when on a syncing pay schedule': {
		translation:
			'The pay rate currency must be in USD when on a syncing pay schedule',
	},
	'The pay rate currency must be in USD when on a syncing pay schedule.': {
		translation:
			'The pay rate currency must be in USD when on a syncing pay schedule.',
	},
	'The pay rate currency must be in USD when the employee is in a pay schedule that is included in payroll.':
		{
			translation:
				'The pay rate currency must be in USD when the employee is in a pay schedule that is included in payroll.',
		},
	"The pay schedule is not valid with the employee's value for address 1": {
		translation:
			"The pay schedule is not valid with the employee's value for address 1",
	},
	"The pay schedule is not valid with the employee's value for address 2": {
		translation:
			"The pay schedule is not valid with the employee's value for address 2",
	},
	"The pay schedule is not valid with the employee's value for city": {
		translation:
			"The pay schedule is not valid with the employee's value for city",
	},
	"The pay schedule is not valid with the employee's value for country": {
		translation:
			"The pay schedule is not valid with the employee's value for country",
	},
	"The pay schedule is not valid with the employee's value for state": {
		translation:
			"The pay schedule is not valid with the employee's value for state",
	},
	"The pay schedule is not valid with the employee's value for zipcode": {
		translation:
			"The pay schedule is not valid with the employee's value for zipcode",
	},
	'The pays property must be numeric': {
		translation: 'The pays property must be numeric',
	},
	'The pays property must be set': {
		translation: 'The pays property must be set',
	},
	'The pending signature for %1$s has been cancelled': {
		translation: 'The pending signature for %1$s has been cancelled',
	},
	'The photo was cropped': {
		translation: 'The photo was cropped',
	},
	"The plan you tried to copy doesn't exist": {
		translation: "The plan you tried to copy doesn't exist",
	},
	'The policy was deleted successfully.': {
		translation: 'The policy was deleted successfully.',
	},
	'The project and/or task must be an active project and task.': {
		translation: 'The project and/or task must be an active project and task.',
	},
	'The proposed Project Pay Rate entry must not overlap the dates of an existing row.':
		{
			translation:
				'The proposed Project Pay Rate entry must not overlap the dates of an existing row.',
		},
	'The proposed compensation dates overlap the dates in an existing row.': {
		translation:
			'The proposed compensation dates overlap the dates in an existing row.',
	},
	'The proposed dates overlap the dates in an existing row.': {
		translation: 'The proposed dates overlap the dates in an existing row.',
	},
	"The report can't be viewed in the requested format.": {
		translation: "The report can't be viewed in the requested format.",
	},
	"The report you requested doesn't exist.": {
		translation: "The report you requested doesn't exist.",
	},
	'The report you requested doesnt exist.': {
		translation: 'The report you requested doesnt exist.',
	},
	'The request to retrieve payroll specialist was sent successfully.': {
		translation:
			'The request to retrieve payroll specialist was sent successfully.',
	},
	'The request to retrieve the payroll specialist was sent and failed.': {
		translation:
			'The request to retrieve the payroll specialist was sent and failed.',
	},
	'The request was sent and failed.': {
		translation: 'The request was sent and failed.',
	},
	'The request was sent successfully. A Payroll Specialist will reach out to the selected payroll contact.':
		{
			translation:
				'The request was sent successfully. A Payroll Specialist will reach out to the selected payroll contact.',
		},
	'The requested error could not be found.': {
		translation: 'The requested error could not be found.',
	},
	'The requested policy and accrual start date are already saved.': {
		translation:
			'The requested policy and accrual start date are already saved.',
	},
	'The requested policy is the same as the existing policy and the accrual start date is the same as the existing accrual start date.':
		{
			translation:
				'The requested policy is the same as the existing policy and the accrual start date is the same as the existing accrual start date.',
		},
	'The requested policy is the same as the existing policy.': {
		translation: 'The requested policy is the same as the existing policy.',
	},
	'The requested report could not be found.': {
		translation: 'The requested report could not be found.',
	},
	'The requested report folder was not found.': {
		translation: 'The requested report folder was not found.',
	},
	'The requested send date and time is not in the future, the scheduled time to send has already passed, or the email is not scheduled':
		{
			translation:
				'The requested send date and time is not in the future, the scheduled time to send has already passed, or the email is not scheduled',
		},
	'The rest of %1': {
		translation: 'The rest of %1',
	},
	'The same ratings options will be used for both self and manager assessment':
		{
			translation:
				'The same ratings options will be used for both self and manager assessment',
		},
	"The security of the customer's Account.": {
		translation: "The security of the customer's Account.",
	},
	"The selected benefit group doesn't match the pay frequency set in the pay group.":
		{
			translation:
				"The selected benefit group doesn't match the pay frequency set in the pay group.",
		},
	'The selected start date must come before the end date. Please try again.': {
		translation:
			'The selected start date must come before the end date. Please try again.',
	},
	'The selected unemployment state is different than the resident tax state.': {
		translation:
			'The selected unemployment state is different than the resident tax state.',
	},
	'The signature request for %1 has been canceled.': {
		translation: 'The signature request for %1 has been canceled.',
	},
	'The silenced field is required and must be a boolean': {
		translation: 'The silenced field is required and must be a boolean',
	},
	'The spouse coverage amount must be at least zero for benefit plan %s.': {
		translation:
			'The spouse coverage amount must be at least zero for benefit plan %s.',
	},
	'The spouse coverage amount should be a multiple of the coverage increment value for benefit plan %s.':
		{
			translation:
				'The spouse coverage amount should be a multiple of the coverage increment value for benefit plan %s.',
		},
	'The spouse coverage is not within the min/max range for benefit plan %s.': {
		translation:
			'The spouse coverage is not within the min/max range for benefit plan %s.',
	},
	'The start date and end date cannot be the same.': {
		translation: 'The start date and end date cannot be the same.',
	},
	'The start date is not valid.': {
		translation: 'The start date is not valid.',
	},
	'The start date must be before the end date': {
		translation: 'The start date must be before the end date',
	},
	'The start date must be before the end date.': {
		translation: 'The start date must be before the end date.',
	},
	'The start date must be on or before the end date': {
		translation: 'The start date must be on or before the end date',
	},
	'The start date must be on or before the end date.': {
		translation: 'The start date must be on or before the end date.',
	},
	"The start date you've entered is in a different quarter.": {
		translation: "The start date you've entered is in a different quarter.",
	},
	"The state you select for this option should generally be paid to the employee's work state, but there are exceptions!":
		{
			translation:
				"The state you select for this option should generally be paid to the employee's work state, but there are exceptions!",
		},
	'The survey was sent on %1%3%2 (%4) and closes on %1%5%2 (%6) %7.': {
		translation:
			'The survey was sent on %1%3%2 (%4) and closes on %1%5%2 (%6) %7.',
	},
	'The survey will be administered through BambooHR and the results are completely anonymous (emails or IP addresses will not be captured). Please be thoughtful, honest, and candid when you complete the survey.':
		{
			translation:
				'The survey will be administered through BambooHR and the results are completely anonymous (emails or IP addresses will not be captured). Please be thoughtful, honest, and candid when you complete the survey.',
		},
	'The ticket provided is invalid, please try again or contact support.': {
		translation:
			'The ticket provided is invalid, please try again or contact support.',
	},
	'The time off category was deleted successfully.': {
		translation: 'The time off category was deleted successfully.',
	},
	'The time off has been changed since you last reconciled it': {
		translation: 'The time off has been changed since you last reconciled it',
	},
	'The time off has been changed since you last reconciled it.': {
		translation: 'The time off has been changed since you last reconciled it.',
	},
	'The time off request has been canceled.': {
		translation: 'The time off request has been canceled.',
	},
	'The time off request record was not found.': {
		translation: 'The time off request record was not found.',
	},
	'The time off request was canceled.': {
		translation: 'The time off request was canceled.',
	},
	'The time off request was resubmitted for approval.': {
		translation: 'The time off request was resubmitted for approval.',
	},
	'The time off request was updated.': {
		translation: 'The time off request was updated.',
	},
	'The time off type was deleted successfully.': {
		translation: 'The time off type was deleted successfully.',
	},
	'The type cannot be null': {
		translation: 'The type cannot be null',
	},
	'The type must be set to "paid" to be included in payroll': {
		translation: 'The type must be set to \\"paid\\" to be included in payroll',
	},
	'The user does not exist': {
		translation: 'The user does not exist',
	},
	'The user for %s has been updated.': {
		translation: 'The user for %s has been updated.',
	},
	'The user has been successfully deleted': {
		translation: 'The user has been successfully deleted',
	},
	"The world of benefits is changing. So, to stay on top of things, we’re updating our benefits. It may take a few minutes to change, but we promise it'll be worth making the change. Here are a few of the improvements:":
		{
			translation:
				"The world of benefits is changing. So, to stay on top of things, we’re updating our benefits. It may take a few minutes to change, but we promise it'll be worth making the change. Here are a few of the improvements:",
		},
	'The zip code is not valid for a trax syncing pay schedule, please use a zip code with five digits (#####) or five digits + dash + four digits (#####-####)':
		{
			translation:
				'The zip code is not valid for a trax syncing pay schedule, please use a zip code with five digits (#####) or five digits + dash + four digits (#####-####)',
		},

	'The {1} {2} Folder is Empty': {
		translation: 'The {1} {2} Folder is Empty',
	},
	'The “Get to Know You” questions and the employee responses will show in this space.':
		{
			translation:
				'The “Get to Know You” questions and the employee responses will show in this space.',
		},
	'Then by': {
		translation: 'Then by',
	},
	"There are %1$d employees with duplicate Employee numbers. After syncing the other employees, we'll give you a link to a simple tool where you can resolve the conflicts.":
		{
			translation:
				"There are %1$d employees with duplicate Employee numbers. After syncing the other employees, we'll give you a link to a simple tool where you can resolve the conflicts.",
		},
	"There are %1$s employees missing a hire date. After syncing the other employees, we'll give you a link to a simple tool where you can enter the missing data.":
		{
			translation:
				"There are %1$s employees missing a hire date. After syncing the other employees, we'll give you a link to a simple tool where you can enter the missing data.",
		},
	'There are %s active employees in the benefit group. Please remove them.': {
		translation:
			'There are %s active employees in the benefit group. Please remove them.',
	},
	'There are already feedback requests pending for an employee from one or more users. Please try again.':
		{
			translation:
				'There are already feedback requests pending for an employee from one or more users. Please try again.',
		},
	"There are changes to this employee's contacts that are waiting for approval. Those changes must be approved or declined before deleting.":
		{
			translation:
				"There are changes to this employee's contacts that are waiting for approval. Those changes must be approved or declined before deleting.",
		},
	"There are changes to this employee's education that are waiting for approval. Those changes must be approved or declined before deleting.":
		{
			translation:
				"There are changes to this employee's education that are waiting for approval. Those changes must be approved or declined before deleting.",
		},
	'There are conflicting entries that already exist.': {
		translation: 'There are conflicting entries that already exist.',
	},
	'There are currently no goals in progress.': {
		translation: 'There are currently no goals in progress.',
	},
	'There are currently no goals set.': {
		translation: 'There are currently no goals set.',
	},
	"There are invalid or missing fields from the employee's profile that must be addressed to be used with a Trax syncing pay schedule.":
		{
			translation:
				"There are invalid or missing fields from the employee's profile that must be addressed to be used with a Trax syncing pay schedule.",
		},
	'There are no %1$s changes as of %2$s for %3$s': {
		translation: 'There are no %1$s changes as of %2$s for %3$s',
	},
	'There are no %1$s tasks for %2$s yet.': {
		translation: 'There are no %1$s tasks for %2$s yet.',
	},
	'There are no %1$s tasks for this employee.': {
		translation: 'There are no %1$s tasks for this employee.',
	},
	'There are no %s requests for %s.': {
		translation: 'There are no %s requests for %s.',
	},
	'There are no %s requests.': {
		translation: 'There are no %s requests.',
	},
	'There are no Employees with completed Manager Assessments that match your filter.':
		{
			translation:
				'There are no Employees with completed Manager Assessments that match your filter.',
		},
	'There are no active deductions.': {
		translation: 'There are no active deductions.',
	},
	'There are no application questions for %s.': {
		translation: 'There are no application questions for %s.',
	},
	'There are no application questions or references for %s.': {
		translation: 'There are no application questions or references for %s.',
	},
	'There are no completed goals for that date range.': {
		translation: 'There are no completed goals for that date range.',
	},
	'There are no employees in this Pay Schedule missing required payroll info.':
		{
			translation:
				'There are no employees in this Pay Schedule missing required payroll info.',
		},
	'There are no employees that match your selected filter options. Please change your filter and try again.':
		{
			translation:
				'There are no employees that match your selected filter options. Please change your filter and try again.',
		},
	'There are no filters for this type of field.': {
		translation: 'There are no filters for this type of field.',
	},
	'There are no inactive deductions.': {
		translation: 'There are no inactive deductions.',
	},
	'There are no matches for "{1}".': {
		translation: 'There are no matches for "{1}".',
	},
	'There are no matches%1for "%2".': {
		translation: 'There are no matches%1for \\"%2\\".',
	},
	'There are no matching employees.': {
		translation: 'There are no matching employees.',
	},
	'There are no new items to add': {
		translation: 'There are no new items to add',
	},
	'There are no new template items to add': {
		translation: 'There are no new template items to add',
	},
	'There are no onboarding tasks for this employee.': {
		translation: 'There are no onboarding tasks for this employee.',
	},
	'There are no participants in this review period': {
		translation: 'There are no participants in this review period',
	},
	'There are no paystubs for this period': {
		translation: 'There are no paystubs for this period',
	},
	'There are no recent exports for this company': {
		translation: 'There are no recent exports for this company',
	},
	'There are no reconciled changes<br /> as of <strong>%s</strong> for <strong>%s</strong>':
		{
			translation:
				'There are no reconciled changes<br /> as of <strong>%s</strong> for <strong>%s</strong>',
		},
	'There are no references for %s.': {
		translation: 'There are no references for %s.',
	},
	'There are no reordering options for the %s section.': {
		translation: 'There are no reordering options for the %s section.',
	},
	'There are no tags that match your selected filter options. Please change your filter and try again.':
		{
			translation:
				'There are no tags that match your selected filter options. Please change your filter and try again.',
		},
	'There are no time off types': {
		translation: 'There are no time off types',
	},
	'There are no unreconciled changes<br /> as of <strong>%s</strong> for <strong>%s</strong>':
		{
			translation:
				'There are no unreconciled changes<br /> as of <strong>%s</strong> for <strong>%s</strong>',
		},
	'There are no users in this group that are able to sign this document.': {
		translation:
			'There are no users in this group that are able to sign this document.',
	},
	"There aren't any active links for this document.": {
		translation: "There aren't any active links for this document.",
	},
	"There aren't any employees tracking time right now.": {
		translation: "There aren't any employees tracking time right now.",
	},
	"There aren't any employees with this Access Level yet.": {
		translation: "There aren't any employees with this Access Level yet.",
	},
	"There aren't any feedback requests in this date range": {
		translation: "There aren't any feedback requests in this date range",
	},
	"There aren't any mid-quarter sweeps waiting for approval.": {
		translation: "There aren't any mid-quarter sweeps waiting for approval.",
	},
	"There aren't any mid-quarter sweeps.": {
		translation: "There aren't any mid-quarter sweeps.",
	},
	'There aren’t any mid-quarter sweeps ready to verify.': {
		translation: 'There aren’t any mid-quarter sweeps ready to verify.',
	},
	'There aren’t any mid-quarter sweeps that have been approved.': {
		translation: 'There aren’t any mid-quarter sweeps that have been approved.',
	},
	"There haven't been any payroll info changes since the last pay period (ending %1$s) for employees matching your filters.":
		{
			translation:
				"There haven't been any payroll info changes since the last pay period (ending %1$s) for employees matching your filters.",
		},
	"There haven't been any payroll info changes since the last pay period for employees matching your filters.":
		{
			translation:
				"There haven't been any payroll info changes since the last pay period for employees matching your filters.",
		},
	'There is %d employee in the queue to be synchronized.': {
		translation: {
			one: 'There is %d employee in the queue to be synchronized.',
			other: 'There are %d employees in the queue to be synchronized.',
		},
	},
	'There is *%1$s person* in today ': {
		translation: {
			one: 'There is *%1$s person* in today ',
			other: 'There are *%1$s people* in today ',
		},
	},
	'There is *%1$s person* out today ': {
		translation: {
			one: 'There is *%1$s person* out today ',
			other: 'There are *%1$s people* out today ',
		},
	},
	'There is a charge of $10 per garnishment per pay cycle': {
		translation: 'There is a charge of $10 per garnishment per pay cycle',
	},
	'There is a holiday that falls on a weekend this year. You may wish to change the observance date.':
		{
			translation:
				'There is a holiday that falls on a weekend this year. You may wish to change the observance date.',
		},
	'There is a problem with this email address.': {
		translation: 'There is a problem with this email address.',
	},
	'There is already an employee with this %1 in the system. Are you sure you want to create another one?':
		{
			translation:
				'There is already an employee with this %1 in the system. Are you sure you want to create another one?',
		},
	'There is already an employee with this SIN in the system.': {
		translation: 'There is already an employee with this SIN in the system.',
	},
	'There is already an employee with this SSN in the system.': {
		translation: 'There is already an employee with this SSN in the system.',
	},
	'There is already an offer letter out to this email address.': {
		translation: 'There is already an offer letter out to this email address.',
	},
	'There is an error with this candidate: <br/>%s': {
		translation: {
			one: 'There is an error with this candidate: <br/>%s',
			other: 'There are errors with this candidate: <br/>%s',
		},
	},
	'There is an error with your application: <br/>%s': {
		translation: {
			one: 'There is an error with your application: <br/>%s',
			other: 'There are errors with your application: <br/>%s',
		},
	},
	'There is no %s history for %s.': {
		translation: 'There is no %s history for %s.',
	},
	'There is no %s history.': {
		translation: 'There is no %s history.',
	},
	'There is no BambooHR user for the account you chose.': {
		translation: 'There is no BambooHR user for the account you chose.',
	},
	'There is no cover letter for %s.': {
		translation: 'There is no cover letter for %s.',
	},
	'There is no cover letter or application questions for %s.': {
		translation: 'There is no cover letter or application questions for %s.',
	},
	'There is no cover letter or references for %s.': {
		translation: 'There is no cover letter or references for %s.',
	},
	'There is no cover letter, application questions, or references for %s.': {
		translation:
			'There is no cover letter, application questions, or references for %s.',
	},
	'There is no limit to the number of %s you can carry over': {
		translation: 'There is no limit to the number of %s you can carry over',
	},
	'There is no resume for %s.': {
		translation: 'There is no resume for %s.',
	},
	'There is no resume or application questions for %s.': {
		translation: 'There is no resume or application questions for %s.',
	},
	'There is no resume or cover letter for %s.': {
		translation: 'There is no resume or cover letter for %s.',
	},
	'There is no resume or references for %s.': {
		translation: 'There is no resume or references for %s.',
	},
	'There is no resume, application questions, or references for %s.': {
		translation:
			'There is no resume, application questions, or references for %s.',
	},
	'There is no resume, cover letter, application questions, or references for %s.':
		{
			translation:
				'There is no resume, cover letter, application questions, or references for %s.',
		},
	'There is no resume, cover letter, or application questions for %s.': {
		translation:
			'There is no resume, cover letter, or application questions for %s.',
	},
	'There is no resume, cover letter, or references for %s.': {
		translation: 'There is no resume, cover letter, or references for %s.',
	},
	'There is no timesheet for this pay period.': {
		translation: 'There is no timesheet for this pay period.',
	},
	'There is nothing to see here... yet.': {
		translation: 'There is nothing to see here... yet.',
	},
	"There isn't any required info to show here.": {
		translation: "There isn't any required info to show here.",
	},
	'There may be additional tax settings for you for this state. Get in touch with your HR admin for more information.':
		{
			translation:
				'There may be additional tax settings for you for this state. Get in touch with your HR admin for more information.',
		},
	'There seems to be a problem deleting that entry. Please try again.': {
		translation:
			'There seems to be a problem deleting that entry. Please try again.',
	},
	'There was a problem': {
		translation: 'There was a problem',
	},
	'There was a problem authenticating with Gusto. Please reauthorize and try again.':
		{
			translation:
				'There was a problem authenticating with Gusto. Please reauthorize and try again.',
		},
	'There was a problem closing this sweep.': {
		translation: 'There was a problem closing this sweep.',
	},
	'There was a problem closing your goal.': {
		translation: 'There was a problem closing your goal.',
	},
	'There was a problem connecting to cornerstone. Please check that everything is working.':
		{
			translation:
				'There was a problem connecting to cornerstone. Please check that everything is working.',
		},
	'There was a problem creating survey responses from ': {
		translation: 'There was a problem creating survey responses from ',
	},
	'There was a problem creating this company. Please try again': {
		translation: 'There was a problem creating this company. Please try again',
	},
	'There was a problem deleting a milestone.': {
		translation: 'There was a problem deleting a milestone.',
	},
	'There was a problem deleting those reports...': {
		translation: 'There was a problem deleting those reports...',
	},
	'There was a problem deleting your goal file.': {
		translation: 'There was a problem deleting your goal file.',
	},
	'There was a problem downloading the file.': {
		translation: 'There was a problem downloading the file.',
	},
	'There was a problem getting the currency list': {
		translation: 'There was a problem getting the currency list',
	},
	'There was a problem importing the data for this row.': {
		translation: 'There was a problem importing the data for this row.',
	},
	'There was a problem loading the event details.': {
		translation: 'There was a problem loading the event details.',
	},
	'There was a problem logging in with this browser. You might want to try a different browser to login. If you continue to see this message, contact <a href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem logging in with this browser. You might want to try a different browser to login. If you continue to see this message, contact <a href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem opening your goal.': {
		translation: 'There was a problem opening your goal.',
	},
	'There was a problem performing this action. Please try again or contact support.':
		{
			translation:
				'There was a problem performing this action. Please try again or contact support.',
		},
	'There was a problem previewing the packet': {
		translation: 'There was a problem previewing the packet',
	},
	'There was a problem previewing your changes, please try again': {
		translation:
			'There was a problem previewing your changes, please try again',
	},
	'There was a problem processing the date.': {
		translation: 'There was a problem processing the date.',
	},
	'There was a problem removing your photo': {
		translation: 'There was a problem removing your photo',
	},
	'There was a problem saving your Assessment.': {
		translation: 'There was a problem saving your Assessment.',
	},
	'There was a problem saving your Assessment. Please try again later.': {
		translation:
			'There was a problem saving your Assessment. Please try again later.',
	},
	'There was a problem saving your Assessment. The text you\'ve entered may be too long. If you continue to see this message, please contact <a class="jade-Alert__inlineLink" href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem saving your Assessment. The text you\'ve entered may be too long. If you continue to see this message, please contact <a class=\\"jade-Alert__inlineLink\\" href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem saving your assessment. Please try again later.': {
		translation:
			'There was a problem saving your assessment. Please try again later.',
	},
	'There was a problem saving your assessment. The text you have entered may be too long. If you continue to see this message, please contact <a class="jade-Alert__inlineLink" href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem saving your assessment. The text you have entered may be too long. If you continue to see this message, please contact <a class=\\"jade-Alert__inlineLink\\" href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem saving your assessment. The text you\'ve entered may be too long. If you continue to see this message, please contact <a class="jade-Alert__inlineLink" href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem saving your assessment. The text you\'ve entered may be too long. If you continue to see this message, please contact <a class=\\"jade-Alert__inlineLink\\" href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem saving your data. Please make your changes and try again.':
		{
			translation:
				'There was a problem saving your data. Please make your changes and try again.',
		},
	'There was a problem saving your data. Please make your changes and try again. If you continue to see this message, contact %ssupport%s':
		{
			translation:
				'There was a problem saving your data. Please make your changes and try again. If you continue to see this message, contact %ssupport%s',
		},
	'There was a problem saving your data. Please make your changes and try again. If you continue to see this message, contact <a href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem saving your data. Please make your changes and try again. If you continue to see this message, contact <a href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem saving your data. Please try again. If you continue to see this message, contact %ssupport%s':
		{
			translation:
				'There was a problem saving your data. Please try again. If you continue to see this message, contact %ssupport%s',
		},
	'There was a problem saving your document.': {
		translation: 'There was a problem saving your document.',
	},
	'There was a problem saving your follow up note.': {
		translation: 'There was a problem saving your follow up note.',
	},
	'There was a problem saving your signing.': {
		translation: 'There was a problem saving your signing.',
	},
	'There was a problem setting up your account to work with Google Apps. Please contact <a href="mailto:support@bamboohr.com">support</a> for help.':
		{
			translation:
				'There was a problem setting up your account to work with Google Apps. Please contact <a href=\\"mailto:support@bamboohr.com\\">support</a> for help.',
		},
	"There was a problem setting up your account to work with Google Apps. Please contact <a href='mailto:support@bamboohr.com'>support</a> for help.":
		{
			translation:
				"There was a problem setting up your account to work with Google Apps. Please contact <a href='mailto:support@bamboohr.com'>support</a> for help.",
		},
	'There was a problem sharing your goal.': {
		translation: 'There was a problem sharing your goal.',
	},
	'There was a problem trying to delete all benefit plans and employee enrollments.':
		{
			translation:
				'There was a problem trying to delete all benefit plans and employee enrollments.',
		},
	'There was a problem trying to include ': {
		translation: 'There was a problem trying to include ',
	},
	'There was a problem updating your goal file(s).': {
		translation: 'There was a problem updating your goal file(s).',
	},
	'There was a problem updating your goal progress.': {
		translation: 'There was a problem updating your goal progress.',
	},
	'There was a problem updating your goal.': {
		translation: 'There was a problem updating your goal.',
	},
	'There was a problem updating your plan file(s).': {
		translation: 'There was a problem updating your plan file(s).',
	},
	'There was a problem uploading this file.': {
		translation: 'There was a problem uploading this file.',
	},
	'There was a problem uploading your file(s).': {
		translation: 'There was a problem uploading your file(s).',
	},
	'There was a problem uploading your file.': {
		translation: 'There was a problem uploading your file.',
	},
	'There was a problem uploading your photo': {
		translation: 'There was a problem uploading your photo',
	},
	'There was a problem validating CSRF token. If you continue to see this message, contact <a href="mailto:support@bamboohr.com">support</a>.':
		{
			translation:
				'There was a problem validating CSRF token. If you continue to see this message, contact <a href=\\"mailto:support@bamboohr.com\\">support</a>.',
		},
	'There was a problem validating your edits, please try again': {
		translation: 'There was a problem validating your edits, please try again',
	},
	'There was a problem with the company id.': {
		translation: 'There was a problem with the company id.',
	},
	'There was a problem with the data you provided.': {
		translation: 'There was a problem with the data you provided.',
	},
	'There was a problem with the file upload. The file could not be processed.':
		{
			translation:
				'There was a problem with the file upload. The file could not be processed.',
		},
	'There was a problem with this file.': {
		translation: 'There was a problem with this file.',
	},
	'There was a problem, please try again': {
		translation: 'There was a problem, please try again',
	},
	'There was a problem. Please set up your company again.': {
		translation: 'There was a problem. Please set up your company again.',
	},
	'There was a problem. Please try again or contact support': {
		translation: 'There was a problem. Please try again or contact support',
	},
	'There was a problem. Please try again or contact support.': {
		translation: 'There was a problem. Please try again or contact support.',
	},
	'There was a system error. Please try again.': {
		translation: 'There was a system error. Please try again.',
	},
	'There was an error applying this checklist to %s': {
		translation: 'There was an error applying this checklist to %s',
	},
	'There was an error cancelling the time tracking trial.': {
		translation: 'There was an error cancelling the time tracking trial.',
	},
	'There was an error connecting to your NetSuite account. Please try again.': {
		translation:
			'There was an error connecting to your NetSuite account. Please try again.',
	},
	'There was an error cropping the photo': {
		translation: 'There was an error cropping the photo',
	},
	'There was an error cropping your logo image file': {
		translation: 'There was an error cropping your logo image file',
	},
	'There was an error deleting the category': {
		translation: 'There was an error deleting the category',
	},
	'There was an error deleting the pay group.': {
		translation: 'There was an error deleting the pay group.',
	},
	'There was an error deleting the pay schedule. Please check all the information and try again.':
		{
			translation:
				'There was an error deleting the pay schedule. Please check all the information and try again.',
		},
	'There was an error deleting this benefit history record': {
		translation: 'There was an error deleting this benefit history record',
	},
	'There was an error deleting your question': {
		translation: 'There was an error deleting your question',
	},
	'There was an error disabling ACA Tracking': {
		translation: 'There was an error disabling ACA Tracking',
	},
	'There was an error downloading the timesheet. Please close this tab and try again later.':
		{
			translation:
				'There was an error downloading the timesheet. Please close this tab and try again later.',
		},
	'There was an error during the bank verification process. Please contact BambooHR Payroll Support':
		{
			translation:
				'There was an error during the bank verification process. Please contact BambooHR Payroll Support',
		},
	'There was an error enabling ACA Tracking': {
		translation: 'There was an error enabling ACA Tracking',
	},
	'There was an error getting plan details.': {
		translation: 'There was an error getting plan details.',
	},
	'There was an error getting the account owner.': {
		translation: 'There was an error getting the account owner.',
	},
	'There was an error getting timezone information': {
		translation: 'There was an error getting timezone information',
	},
	'There was an error handling your request.': {
		translation: 'There was an error handling your request.',
	},
	'There was an error installing GT Clocks.': {
		translation: 'There was an error installing GT Clocks.',
	},
	'There was an error loading this document. Please inform the sender to update the esignature template and try sending again.':
		{
			translation:
				'There was an error loading this document. Please inform the sender to update the esignature template and try sending again.',
		},
	'There was an error logging you in.': {
		translation: 'There was an error logging you in.',
	},
	'There was an error looking up the Inbox item you requested.': {
		translation: 'There was an error looking up the Inbox item you requested.',
	},
	'There was an error previewing as this user.': {
		translation: 'There was an error previewing as this user.',
	},
	'There was an error previewing this template': {
		translation: 'There was an error previewing this template',
	},
	'There was an error processing this request.': {
		translation: 'There was an error processing this request.',
	},
	'There was an error processing your request': {
		translation: 'There was an error processing your request',
	},
	'There was an error processing your request.': {
		translation: 'There was an error processing your request.',
	},
	'There was an error processing your request. It appears that email address is already in use.':
		{
			translation:
				'There was an error processing your request. It appears that email address is already in use.',
		},
	'There was an error processing your request. Please try again later.': {
		translation:
			'There was an error processing your request. Please try again later.',
	},
	'There was an error renaming the category.': {
		translation: 'There was an error renaming the category.',
	},
	'There was an error resending the offer letter. Try refreshing the page': {
		translation:
			'There was an error resending the offer letter. Try refreshing the page',
	},
	'There was an error resetting the password. Please try again.': {
		translation: 'There was an error resetting the password. Please try again.',
	},
	'There was an error retrieving your time off settings. Please try again.': {
		translation:
			'There was an error retrieving your time off settings. Please try again.',
	},
	'There was an error running the report.': {
		translation: 'There was an error running the report.',
	},
	'There was an error saving the New Hire Packet, please try again': {
		translation:
			'There was an error saving the New Hire Packet, please try again',
	},
	'There was an error saving the contact date. Please try again in a few minutes.':
		{
			translation:
				'There was an error saving the contact date. Please try again in a few minutes.',
		},
	'There was an error saving the deadline. Please try again in a few minutes.':
		{
			translation:
				'There was an error saving the deadline. Please try again in a few minutes.',
		},
	'There was an error saving the pay schedule. Please check all the information and try again.':
		{
			translation:
				'There was an error saving the pay schedule. Please check all the information and try again.',
		},
	'There was an error saving the policy. Please check all the information and try again':
		{
			translation:
				'There was an error saving the policy. Please check all the information and try again',
		},
	'There was an error saving the time off settings. Please check all the information and try again.':
		{
			translation:
				'There was an error saving the time off settings. Please check all the information and try again.',
		},
	'There was an error saving this company information': {
		translation: 'There was an error saving this company information',
	},
	'There was an error saving your comments. Please try again in a few minutes.':
		{
			translation:
				'There was an error saving your comments. Please try again in a few minutes.',
		},
	'There was an error saving your data': {
		translation: 'There was an error saving your data',
	},
	'There was an error saving your task. Please try again.': {
		translation: 'There was an error saving your task. Please try again.',
	},
	'There was an error saving your tax documents delivery preference. Please try again.':
		{
			translation:
				'There was an error saving your tax documents delivery preference. Please try again.',
		},
	'There was an error sending your report.': {
		translation: 'There was an error sending your report.',
	},
	'There was an error starting the time tracking trial.': {
		translation: 'There was an error starting the time tracking trial.',
	},
	'There was an error subscribing to time tracking.': {
		translation: 'There was an error subscribing to time tracking.',
	},
	'There was an error updating status to %s.': {
		translation: 'There was an error updating status to %s.',
	},
	'There was an error updating statuses to %s.': {
		translation: 'There was an error updating statuses to %s.',
	},
	'There was an error when trying to delete this report.': {
		translation: 'There was an error when trying to delete this report.',
	},
	'There was an error while sorting plans': {
		translation: 'There was an error while sorting plans',
	},
	'There was an error while trying to save your data': {
		translation: 'There was an error while trying to save your data',
	},
	'There was an error while trying to save your note. Try again later.': {
		translation:
			'There was an error while trying to save your note. Try again later.',
	},
	'There was an error with Total Rewards.': {
		translation: 'There was an error with Total Rewards.',
	},
	'There was an error with the "%1$s" custom field.  Please contact support.': {
		translation:
			'There was an error with the \\"%1$s\\" custom field.  Please contact support.',
	},
	'There was an issue creating your account please contact us directly at sales@bamboohr.com':
		{
			translation:
				'There was an issue creating your account please contact us directly at sales@bamboohr.com',
		},
	'There was an issue disabling notifications. Please try again.': {
		translation:
			'There was an issue disabling notifications. Please try again.',
	},
	'There was an issue enabling notifications. Please try again.': {
		translation: 'There was an issue enabling notifications. Please try again.',
	},
	'There was an issue with this approver. Please cancel this request and resubmit a new request.':
		{
			translation:
				'There was an issue with this approver. Please cancel this request and resubmit a new request.',
		},
	'There was no employee turnover during the selected time period.': {
		translation:
			'There was no employee turnover during the selected time period.',
	},
	"There wasn't any time tracking activity on this day": {
		translation: "There wasn't any time tracking activity on this day",
	},
	'There were errors during the import. No rows were imported. ': {
		translation: 'There were errors during the import. No rows were imported. ',
	},
	'There were errors with your application: <br/>%s': {
		translation: 'There were errors with your application: <br/>%s',
	},
	'There were some changes made to your goals.': {
		translation: 'There were some changes made to your goals.',
	},
	"There's a better way to Bamboo": {
		translation: "There's a better way to Bamboo",
	},
	"There's a better way to Bamboo.": {
		translation: "There's a better way to Bamboo.",
	},
	"There's a newer version of this offer available.": {
		translation: "There's a newer version of this offer available.",
	},
	"There's nothing here yet!": {
		translation: "There's nothing here yet!",
	},
	"There's nothing here.": {
		translation: "There's nothing here.",
	},
	"There's nothing to see here.": {
		translation: "There's nothing to see here.",
	},
	"There's nothing to see here...": {
		translation: "There's nothing to see here...",
	},
	"There's nothing to see here... yet.": {
		translation: "There's nothing to see here... yet.",
	},
	'These Employees’ ACA Status will be set to “Non-Assessment.“': {
		translation: 'These Employees’ ACA Status will be set to “Non-Assessment.“',
	},
	'These answers will be hidden from other employees.': {
		translation: 'These answers will be hidden from other employees.',
	},
	'These answers will be hidden from the "Welcome to %1$s" email and won\'t be shown on the welcome widget on Home.':
		{
			translation:
				'These answers will be hidden from the \\"Welcome to %1$s\\" email and won\'t be shown on the welcome widget on Home.',
		},
	'These answers will be hidden from the "Welcome to %s" email and won\'t be shown on the welcome widget on Home.':
		{
			translation:
				'These answers will be hidden from the \\"Welcome to %s\\" email and won\'t be shown on the welcome widget on Home.',
		},
	"These answers will be hidden from the %1Welcome to %2%3%4 email and won't be shown on the welcome widget on Home.":
		{
			translation:
				"These answers will be hidden from the %1Welcome to %2%3%4 email and won't be shown on the welcome widget on Home.",
		},
	'These answers will be seen in the %1Welcome to %2%3 email.': {
		translation: 'These answers will be seen in the %1Welcome to %2%3 email.',
	},
	'These answers will be shown on the %1Welcome to %2%3%4 email and the welcome widget on Home.':
		{
			translation:
				'These answers will be shown on the %1Welcome to %2%3%4 email and the welcome widget on Home.',
		},
	'These are our fully supported browsers': {
		translation: 'These are our fully supported browsers',
	},
	'These are our fully supported browsers.': {
		translation: 'These are our fully supported browsers.',
	},
	'These are the apps that you can install directly from BambooHR, but there are many more available in the [BambooHR Marketplace]':
		{
			translation:
				'These are the apps that you can install directly from BambooHR, but there are many more available in the [BambooHR Marketplace]',
		},
	"These candidates can't be moved while offer(s) are still in progress.": {
		translation:
			"These candidates can't be moved while offer(s) are still in progress.",
	},
	'These changes help us to record important information that will be useful for %1$sACA%2$s.':
		{
			translation:
				'These changes help us to record important information that will be useful for %1$sACA%2$s.',
		},
	'These changes will go into effect the next time you run payroll.': {
		translation:
			'These changes will go into effect the next time you run payroll.',
	},
	'These changes will go into effect two pay dates from today.': {
		translation: 'These changes will go into effect two pay dates from today.',
	},
	"These employees don't have a manager": {
		translation: "These employees don't have a manager",
	},
	'These employees have some trainings that need to be renewed soon. You can see which trainings need to be renewed below:':
		{
			translation:
				'These employees have some trainings that need to be renewed soon. You can see which trainings need to be renewed below:',
		},
	'These employees need to be assigned a pay group. You can update many empoyees at once using the [power edit tool]. This is especially useful if many employees will be set to the same pay group.':
		{
			translation:
				'These employees need to be assigned a pay group. You can update many empoyees at once using the [power edit tool]. This is especially useful if many employees will be set to the same pay group.',
		},
	'These forms are required so we can get your company set up to run payroll with BambooHR Payroll.':
		{
			translation:
				'These forms are required so we can get your company set up to run payroll with BambooHR Payroll.',
		},
	'These people do not have access to all the columns in this report. These columns will be hidden from their view.':
		{
			translation:
				'These people do not have access to all the columns in this report. These columns will be hidden from their view.',
		},
	'These questions and responses are originally from %s. They are only visible to those with permissions to manage job openings in BambooHR (like you!).':
		{
			translation:
				'These questions and responses are originally from %s. They are only visible to those with permissions to manage job openings in BambooHR (like you!).',
		},
	'These two values cannot be the same.': {
		translation: 'These two values cannot be the same.',
	},
	'These values cannot be the same.': {
		translation: 'These values cannot be the same.',
	},
	'These values must be different.': {
		translation: 'These values must be different.',
	},
	'These values must be the same.': {
		translation: 'These values must be the same.',
	},
	'They **will not be deleted from Bamboo Payroll**, but will be marked as inactive and not included in future payrolls.':
		{
			translation:
				'They **will not be deleted from Bamboo Payroll**, but will be marked as inactive and not included in future payrolls.',
		},
	"They don't work on holidays and are paid their normal daily rate.": {
		translation:
			"They don't work on holidays and are paid their normal daily rate.",
	},
	'They only get paid if they work on a holiday.': {
		translation: 'They only get paid if they work on a holiday.',
	},
	'They will be able to login to BambooHR using the access level you choose.': {
		translation:
			'They will be able to login to BambooHR using the access level you choose.',
	},
	'They will no longer have access to this group.': {
		translation: 'They will no longer have access to this group.',
	},
	'They will not show on the %1Welcome to %2%3 email or on the welcome widget on Home.':
		{
			translation:
				'They will not show on the %1Welcome to %2%3 email or on the welcome widget on Home.',
		},
	"They won't have access and will not be able to login to BambooHR.": {
		translation:
			"They won't have access and will not be able to login to BambooHR.",
	},
	'They/them': {
		translation: 'They/them',
	},
	'This %sCANNOT%s be undone.': {
		translation: 'This %sCANNOT%s be undone.',
	},
	'This **CANNOT** be undone.': {
		translation: 'This **CANNOT** be undone.',
	},
	'This Access Level can access the information below for': {
		translation: 'This Access Level can access the information below for',
	},
	'This Access Level will only be able to see their own information.': {
		translation:
			'This Access Level will only be able to see their own information.',
	},
	'This Assessment is Not Yet Available': {
		translation: 'This Assessment is Not Yet Available',
	},
	'This BambooHR account has been canceled.': {
		translation: 'This BambooHR account has been canceled.',
	},
	'This Department already exists.': {
		translation: 'This Department already exists.',
	},
	'This Employment Type already exists.': {
		translation: 'This Employment Type already exists.',
	},
	'This File Is No Longer Available': {
		translation: 'This File Is No Longer Available',
	},
	'This File is No Longer Available': {
		translation: 'This File is No Longer Available',
	},
	'This Folder is Empty': {
		translation: 'This Folder is Empty',
	},
	'This Holiday is for...': {
		translation: 'This Holiday is for...',
	},
	'This Location already exists.': {
		translation: 'This Location already exists.',
	},
	'This NIN is already being used.': {
		translation: 'This NIN is already being used.',
	},
	'This National ID is already being used.': {
		translation: 'This National ID is already being used.',
	},
	'This Pay Period': {
		translation: 'This Pay Period',
	},
	'This QuickBooks Online Payroll account is already linked to a BambooHR account. Please reach out to support@bamboohr.com for help.':
		{
			translation:
				'This QuickBooks Online Payroll account is already linked to a BambooHR account. Please reach out to support@bamboohr.com for help.',
		},
	'This Request No Longer Exists': {
		translation: 'This Request No Longer Exists',
	},
	'This SIN is already being used.': {
		translation: 'This SIN is already being used.',
	},
	'This SSN is already being used.': {
		translation: 'This SSN is already being used.',
	},
	'This Week': {
		translation: 'This Week',
	},
	'This access level is locked and can not be deleted': {
		translation: 'This access level is locked and can not be deleted',
	},
	'This account is temporarily suspended.': {
		translation: 'This account is temporarily suspended.',
	},
	"This action can't be undone.": {
		translation: "This action can't be undone.",
	},
	'This action cannot be undone.': {
		translation: 'This action cannot be undone.',
	},
	'This action has serious data security implications.': {
		translation: 'This action has serious data security implications.',
	},
	'This action would normally be available to this user.  It has been disabled while you preview.':
		{
			translation:
				'This action would normally be available to this user.  It has been disabled while you preview.',
		},
	'This action would normally be available to this user. It has been disabled while you preview.':
		{
			translation:
				'This action would normally be available to this user. It has been disabled while you preview.',
		},
	'This alert will include...': {
		translation: 'This alert will include...',
	},
	'This announcement will include...': {
		translation: 'This announcement will include...',
	},
	"This app allows the semi-auto configuration of webhooks in your BambooHR account so that Radius' OverSeas Connect is notified anytime an employee record is added, updated, terminated, or deleted in BambooHR. This will then trigger a sync event by Radius to ensure updated data is brought over from BambooHR and is updated in OverSeas Connect.":
		{
			translation:
				"This app allows the semi-auto configuration of webhooks in your BambooHR account so that Radius' OverSeas Connect is notified anytime an employee record is added, updated, terminated, or deleted in BambooHR. This will then trigger a sync event by Radius to ensure updated data is brought over from BambooHR and is updated in OverSeas Connect.",
		},
	'This app is pending installation by a BambooHR Admin': {
		translation: 'This app is pending installation by a BambooHR Admin',
	},
	'This app must be installed directly by Customer Service.  To have the app uninstalled at any time, please contact <a href="mailto:support@bamboohr.com">support@bamboohr.com</a>.':
		{
			translation:
				'This app must be installed directly by Customer Service.  To have the app uninstalled at any time, please contact <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a>.',
		},
	"This applicant doesn't exist in BambooHR": {
		translation: "This applicant doesn't exist in BambooHR",
	},
	'This application has field values that triggered our spam detection.': {
		translation:
			'This application has field values that triggered our spam detection.',
	},
	'This assessment cannot be cancelled.': {
		translation: 'This assessment cannot be cancelled.',
	},
	'This assessment is complete. Answers are hidden while previewing as another user.':
		{
			translation:
				'This assessment is complete. Answers are hidden while previewing as another user.',
		},
	'This available time off is calculated based on hours worked.': {
		translation: 'This available time off is calculated based on hours worked.',
	},
	'This benefit plan for the benefit group has been deleted.': {
		translation: 'This benefit plan for the benefit group has been deleted.',
	},
	'This birth date is an invalid birth date. Birth date must be later than 1900-01-01 and less than today.':
		{
			translation:
				'This birth date is an invalid birth date. Birth date must be later than 1900-01-01 and less than today.',
		},
	"This bot's flux capacitor is half broken.": {
		translation: "This bot's flux capacitor is half broken.",
	},
	'This can also be used to easily load all your employee data into Maxwell Health for the first time. The integration will be set up on the Maxwell platform."':
		{
			translation:
				'This can also be used to easily load all your employee data into Maxwell Health for the first time. The integration will be set up on the Maxwell platform.\\"',
		},
	'This change will effect all employees that are currently scheduled to start time tracking.':
		{
			translation:
				'This change will effect all employees that are currently scheduled to start time tracking.',
		},
	'This comment has replies. Are you sure you want to delete this comment and all its files and replies?':
		{
			translation:
				'This comment has replies. Are you sure you want to delete this comment and all its files and replies?',
		},
	'This comment has replies. Are you sure you want to delete this comment and all its replies?':
		{
			translation:
				'This comment has replies. Are you sure you want to delete this comment and all its replies?',
		},
	"This company doesn't have any managers, or you don't have the required permissions.":
		{
			translation:
				"This company doesn't have any managers, or you don't have the required permissions.",
		},
	"This company doesn't have any peer feedback review periods, or you don't have the required permissions.":
		{
			translation:
				"This company doesn't have any peer feedback review periods, or you don't have the required permissions.",
		},
	"This company doesn't have any review periods.": {
		translation: "This company doesn't have any review periods.",
	},
	'This company has additional contractual obligations. Please contact our legal team if there is ever a question regarding:':
		{
			translation:
				'This company has additional contractual obligations. Please contact our legal team if there is ever a question regarding:',
		},
	'This company has peer feedback disabled.': {
		translation: 'This company has peer feedback disabled.',
	},
	'This company has performance disabled.': {
		translation: 'This company has performance disabled.',
	},
	'This company is already connected to a different Slack installation. (If you wish to use this company on a different Slack integration, please uninstall and reinstall the BambooHR Slack Integration.':
		{
			translation:
				'This company is already connected to a different Slack installation. (If you wish to use this company on a different Slack integration, please uninstall and reinstall the BambooHR Slack Integration.',
		},
	'This company is not available. Please try again later, or contact Support for help.':
		{
			translation:
				'This company is not available. Please try again later, or contact Support for help.',
		},
	'This configuration is not compatible with BambooHR.': {
		translation: 'This configuration is not compatible with BambooHR.',
	},
	'This contact has already been deleted.': {
		translation: 'This contact has already been deleted.',
	},
	'This currency must be %1.': {
		translation: 'This currency must be %1.',
	},
	'This date is determined by the Start Date': {
		translation: 'This date is determined by the Start Date',
	},
	'This determines how much you will withhold from your paycheck for federal taxes.':
		{
			translation:
				'This determines how much you will withhold from your paycheck for federal taxes.',
		},
	'This determines how much you will withhold from your paycheck for state taxes.':
		{
			translation:
				'This determines how much you will withhold from your paycheck for state taxes.',
		},
	'This determines what information they will be able to see about themselves.':
		{
			translation:
				'This determines what information they will be able to see about themselves.',
		},
	'This document has already been signed, but it’s still processing. Check back in a few minutes.':
		{
			translation:
				'This document has already been signed, but it’s still processing. Check back in a few minutes.',
		},
	'This document is already signed. Removing it will cancel the request and discard the signed document.':
		{
			translation:
				'This document is already signed. Removing it will cancel the request and discard the signed document.',
		},
	'This document is included with an offer, no need for a reminder.': {
		translation:
			'This document is included with an offer, no need for a reminder.',
	},
	'This document is waiting for a signature from %1$s.': {
		translation: 'This document is waiting for a signature from %1$s.',
	},
	'This document is waiting for a signature.': {
		translation: 'This document is waiting for a signature.',
	},
	'This document will also require signatures from:': {
		translation: 'This document will also require signatures from:',
	},
	'This download file link expires after 24 hours.': {
		translation: 'This download file link expires after 24 hours.',
	},
	'This edit will be applied to all responses it is associated with.': {
		translation:
			'This edit will be applied to all responses it is associated with.',
	},
	'This email address already exists, please choose another one.': {
		translation:
			'This email address already exists, please choose another one.',
	},
	'This email address is already being used': {
		translation: 'This email address is already being used',
	},
	'This email address is already being used by another employee or user, please enter a different one':
		{
			translation:
				'This email address is already being used by another employee or user, please enter a different one',
		},
	'This email address is already being used by another employee or user.': {
		translation:
			'This email address is already being used by another employee or user.',
	},
	'This email address is invalid': {
		translation: 'This email address is invalid',
	},
	'This email introduces the survey, encourages honest feedback, and assures anonymity. An email with the actual survey will be sent one day after this email.':
		{
			translation:
				'This email introduces the survey, encourages honest feedback, and assures anonymity. An email with the actual survey will be sent one day after this email.',
		},
	'This email is already being used by an employee in this company.  Please update or delete the employee.':
		{
			translation:
				'This email is already being used by an employee in this company.  Please update or delete the employee.',
		},
	'This email is already being used.': {
		translation: 'This email is already being used.',
	},
	"This email template has a placeholder for %sDepartment%s in it, but the job opening doesn't have a department listed. You may need to adjust the text around where it was removed so it still makes sense.":
		{
			translation:
				"This email template has a placeholder for %sDepartment%s in it, but the job opening doesn't have a department listed. You may need to adjust the text around where it was removed so it still makes sense.",
		},
	"This email template has a placeholder for *Department* in it, but the job opening doesn't have a department listed. You may need to adjust the text around where it was removed so it still makes sense.":
		{
			translation:
				"This email template has a placeholder for *Department* in it, but the job opening doesn't have a department listed. You may need to adjust the text around where it was removed so it still makes sense.",
		},
	'This email template will automatically be sent to applicants when they submit an application.':
		{
			translation:
				'This email template will automatically be sent to applicants when they submit an application.',
		},
	'This email will be sent to the Payroll Contact for approval.': {
		translation: 'This email will be sent to the Payroll Contact for approval.',
	},
	'This employee can not be synced with payroll.': {
		translation: 'This employee can not be synced with payroll.',
	},
	'This employee does not have a benefit history': {
		translation: 'This employee does not have a benefit history',
	},
	'This employee does not have access to one or more of the benefits that you have selected.':
		{
			translation:
				'This employee does not have access to one or more of the benefits that you have selected.',
		},
	"This employee doesn't have a hire date": {
		translation: "This employee doesn't have a hire date",
	},
	"This employee doesn't match the deduction frequency that is set for this group.":
		{
			translation:
				"This employee doesn't match the deduction frequency that is set for this group.",
		},
	'This employee has not been assigned to a location.': {
		translation: 'This employee has not been assigned to a location.',
	},
	"This employee is currently synced with payroll, but the compensation's currency is not a valid for payroll.":
		{
			translation:
				"This employee is currently synced with payroll, but the compensation's currency is not a valid for payroll.",
		},
	'This employee is inactive, to update their Compensation table they must have an active employment status.':
		{
			translation:
				'This employee is inactive, to update their Compensation table they must have an active employment status.',
		},
	'This employee is inactive, to update their Employment Status table they must have an active employment status.':
		{
			translation:
				'This employee is inactive, to update their Employment Status table they must have an active employment status.',
		},
	'This employee is inactive, to update their Job Information table they must have an active employment status.':
		{
			translation:
				'This employee is inactive, to update their Job Information table they must have an active employment status.',
		},
	'This employee is missing a hire date.': {
		translation: 'This employee is missing a hire date.',
	},
	'This employee is not part of a syncing pay schedule': {
		translation: 'This employee is not part of a syncing pay schedule',
	},
	'This employee needs to have a pay schedule before being enrolled.': {
		translation:
			'This employee needs to have a pay schedule before being enrolled.',
	},
	'This employee number is already being used': {
		translation: 'This employee number is already being used',
	},
	'This employee number is already being used by another employee or user.': {
		translation:
			'This employee number is already being used by another employee or user.',
	},
	'This employee number is already being used by another employee, please enter a different one':
		{
			translation:
				'This employee number is already being used by another employee, please enter a different one',
		},
	'This employee number is already being used.': {
		translation: 'This employee number is already being used.',
	},
	"This employee's current pay schedule should not be moved to the past.": {
		translation:
			"This employee's current pay schedule should not be moved to the past.",
	},
	"This employee's home email address will be updated": {
		translation: "This employee's home email address will be updated",
	},
	"This employee's pay schedule is not compatible with the value for department":
		{
			translation:
				"This employee's pay schedule is not compatible with the value for department",
		},
	"This employee's pay schedule is not compatible with the value for division":
		{
			translation:
				"This employee's pay schedule is not compatible with the value for division",
		},
	"This employee's pay schedule isn't compatible with the value for department":
		{
			translation:
				"This employee's pay schedule isn't compatible with the value for department",
		},
	"This employee's pay schedule isn't compatible with the value for division": {
		translation:
			"This employee's pay schedule isn't compatible with the value for division",
	},
	"This employee's pay schedule isn't compatible with the value for employment status.":
		{
			translation:
				"This employee's pay schedule isn't compatible with the value for employment status.",
		},
	"This employee's pay schedule isn't compatible with the value for job location":
		{
			translation:
				"This employee's pay schedule isn't compatible with the value for job location",
		},
	"This employee's pay schedule isn't compatible with the value for paid per.":
		{
			translation:
				"This employee's pay schedule isn't compatible with the value for paid per.",
		},
	"This employee's pay schedule isn't compatible with the value for pay type.":
		{
			translation:
				"This employee's pay schedule isn't compatible with the value for pay type.",
		},
	"This employee's pay schedule isn't compatible with this value.": {
		translation:
			"This employee's pay schedule isn't compatible with this value.",
	},
	"This employee's self-service access is assigned by their current access level.":
		{
			translation:
				"This employee's self-service access is assigned by their current access level.",
		},
	'This exceeds the limit of external emails that a file can be shared with.': {
		translation:
			'This exceeds the limit of external emails that a file can be shared with.',
	},
	"This feature allows you to automatically fill in sections of your form using your employee's information.":
		{
			translation:
				"This feature allows you to automatically fill in sections of your form using your employee's information.",
		},
	"This feedback can't be assigned.": {
		translation: "This feedback can't be assigned.",
	},
	'This field can accept %1 more characters.': {
		translation: 'This field can accept %1 more characters.',
	},
	'This field is no longer available and can be removed by editing and resaving the report.':
		{
			translation:
				'This field is no longer available and can be removed by editing and resaving the report.',
		},
	'This field is required': {
		translation: 'This field is required',
	},
	'This field is required.': {
		translation: 'This field is required.',
	},
	"This file can't be previewed at this time. You can download the original file here:":
		{
			translation:
				"This file can't be previewed at this time. You can download the original file here:",
		},
	'This file contains a virus and could not be downloaded.': {
		translation: 'This file contains a virus and could not be downloaded.',
	},
	'This file could not be processed, try uploading it again.': {
		translation: 'This file could not be processed, try uploading it again.',
	},
	'This file has been deleted and is no longer available for signatures.': {
		translation:
			'This file has been deleted and is no longer available for signatures.',
	},
	'This file is an e-Signature document and will become invalid once this file is deleted.':
		{
			translation:
				'This file is an e-Signature document and will become invalid once this file is deleted.',
		},
	'This file is an e-Signature template, any in-progress signatures will not be removed.':
		{
			translation:
				'This file is an e-Signature template, any in-progress signatures will not be removed.',
		},
	'This file is gone': {
		translation: 'This file is gone',
	},
	'This file is no longer available': {
		translation: 'This file is no longer available',
	},
	'This file type is not allowed:': {
		translation: 'This file type is not allowed:',
	},
	'This file will be available for download until **{1}** and can only be **downloaded one time**.':
		{
			translation:
				'This file will be available for download until **{1}** and can only be **downloaded one time**.',
		},
	'This file will be available for download until **{1}**.': {
		translation: 'This file will be available for download until **{1}**.',
	},
	'This file will be removed from onboarding tasks, offboarding tasks, and offer letters.':
		{
			translation:
				'This file will be removed from onboarding tasks, offboarding tasks, and offer letters.',
		},
	'This file will be removed from onboarding tasks, offboarding tasks, offer letters, and company announcements.':
		{
			translation:
				'This file will be removed from onboarding tasks, offboarding tasks, offer letters, and company announcements.',
		},
	'This file will have the <b>same sharing permissions</b> as the selected folder':
		{
			translation:
				'This file will have the <b>same sharing permissions</b> as the selected folder',
		},
	'This folder and files will be deleted from every employee, not just %1.': {
		translation:
			'This folder and files will be deleted from every employee, not just %1.',
	},
	'This folder is currently feeling kinda empty inside.': {
		translation: 'This folder is currently feeling kinda empty inside.',
	},
	'This folder is looking pretty empty…': {
		translation: 'This folder is looking pretty empty…',
	},
	'This folder may contain sensitive and confidential information. Consider who needs to view or edit this information before providing access.':
		{
			translation:
				'This folder may contain sensitive and confidential information. Consider who needs to view or edit this information before providing access.',
		},
	'This goal has already been deleted.': {
		translation: 'This goal has already been deleted.',
	},
	'This has already been completed or you may not have access to view it.': {
		translation:
			'This has already been completed or you may not have access to view it.',
	},
	'This hire date is an invalid hire date. Hire date must be later than 1900-01-01 and less than 3 years in the future':
		{
			translation:
				'This hire date is an invalid hire date. Hire date must be later than 1900-01-01 and less than 3 years in the future',
		},
	'This holiday falls on a weekend this year. You may wish to change the observance date.':
		{
			translation:
				'This holiday falls on a weekend this year. You may wish to change the observance date.',
		},
	'This info is required to pay this employee through BambooHR Payroll.': {
		translation:
			'This info is required to pay this employee through BambooHR Payroll.',
	},
	'This info is required to pay this employee through TRAXPayroll.': {
		translation:
			'This info is required to pay this employee through TRAXPayroll.',
	},
	'This information needs to be added by %1$s (next payroll date), or %2$s won’t be paid.':
		{
			translation:
				'This information needs to be added by %1$s (next payroll date), or %2$s won’t be paid.',
		},
	'This information will be used to fill part 1 of your 1095-C forms and can be edited under ACA Settings.':
		{
			translation:
				'This information will be used to fill part 1 of your 1095-C forms and can be edited under ACA Settings.',
		},
	'This information will not be used as selection criteria. If you\'d rather not share this information, feel free to select "Decline to Answer".':
		{
			translation:
				'This information will not be used as selection criteria. If you\'d rather not share this information, feel free to select \\"Decline to Answer\\".',
		},
	'This integrated app can be enabled by clicking the "Install" button for this app and configuring the appropraite settings. A Cornerstone CSB account is required for this integration to work.':
		{
			translation:
				'This integrated app can be enabled by clicking the \\"Install\\" button for this app and configuring the appropraite settings. A Cornerstone CSB account is required for this integration to work.',
		},
	'This integration can be installed but requires additional configuration by the BambooHR and BeneTrac support teams.':
		{
			translation:
				'This integration can be installed but requires additional configuration by the BambooHR and BeneTrac support teams.',
		},
	'This integration enables users to use BambooHR’s most popular features without leaving Slack.':
		{
			translation:
				'This integration enables users to use BambooHR’s most popular features without leaving Slack.',
		},
	'This integration is enabled by generating an API key in BambooHR and saving that information in the CATS system so the two systems can connect.':
		{
			translation:
				'This integration is enabled by generating an API key in BambooHR and saving that information in the CATS system so the two systems can connect.',
		},
	'This integration is enabled by the HRN Performance Solutions Client Support team.':
		{
			translation:
				'This integration is enabled by the HRN Performance Solutions Client Support team.',
		},
	'This integration keeps Cornerstone up to date by pushing updates of the following information from BambooHR to Cornerstone: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, Job Title Change Date':
		{
			translation:
				'This integration keeps Cornerstone up to date by pushing updates of the following information from BambooHR to Cornerstone: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, Job Title Change Date',
		},
	'This integration keeps Cornerstone up to date by pushing updates of the following information from BambooHR to Cornerstone: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, Job Title Change Date. Optionally, Single Sign-On (SSO) can be enabled between BambooHR and Cornerstone.':
		{
			translation:
				'This integration keeps Cornerstone up to date by pushing updates of the following information from BambooHR to Cornerstone: First Name, Last Name, Hire Date, Work Email, Job Title, Reporting To, Status, Employee #, Job Title Change Date. Optionally, Single Sign-On (SSO) can be enabled between BambooHR and Cornerstone.',
		},
	"This integration needs to be enabled by BambooHR's Customer Service Department. Please contact us at support@bamboohr.com or by calling 1-866-387-9595.":
		{
			translation:
				"This integration needs to be enabled by BambooHR's Customer Service Department. Please contact us at support@bamboohr.com or by calling 1-866-387-9595.",
		},
	'This integration provides users with a seamless, integrated database with minimal setup and automatic operation. With this integration, updates made from within BambooHR sync automatically with Performance Pro every 15 minutes.':
		{
			translation:
				'This integration provides users with a seamless, integrated database with minimal setup and automatic operation. With this integration, updates made from within BambooHR sync automatically with Performance Pro every 15 minutes.',
		},
	'This integration provides users with a seamless, integrated experience when using Slack with BambooHR.':
		{
			translation:
				'This integration provides users with a seamless, integrated experience when using Slack with BambooHR.',
		},
	'This integration pulls new hires from Jobvite automatically every four hours. Any employees updated in BambooHR will also be updated automatically in Jobvite every evening at 10pm.':
		{
			translation:
				'This integration pulls new hires from Jobvite automatically every four hours. Any employees updated in BambooHR will also be updated automatically in Jobvite every evening at 10pm.',
		},
	'This integration requires authorizing your BambooHR account to access your Gusto account.':
		{
			translation:
				'This integration requires authorizing your BambooHR account to access your Gusto account.',
		},
	'This integration requires authorizing your BambooHR account to access your RightSignature account.':
		{
			translation:
				'This integration requires authorizing your BambooHR account to access your RightSignature account.',
		},
	'This integration syncs employee demographic data as well as approved time off request information from BambooHR on an hourly basis.':
		{
			translation:
				'This integration syncs employee demographic data as well as approved time off request information from BambooHR on an hourly basis.',
		},
	'This integration syncs new hire data automatically from HiringThing to BambooHR when a candidtate is "Hired" in HiringThing while in the Applicant Viewer area of the application. Once a candidate is "Hired" they will be added as a new employee in your BambooHR account within 1 minute.':
		{
			translation:
				'This integration syncs new hire data automatically from HiringThing to BambooHR when a candidtate is \\"Hired\\" in HiringThing while in the Applicant Viewer area of the application. Once a candidate is \\"Hired\\" they will be added as a new employee in your BambooHR account within 1 minute.',
		},
	'This integration will be removed.': {
		translation: 'This integration will be removed.',
	},
	'This is a one-way integration from BambooHR to NimbleSchedule.': {
		translation:
			'This is a one-way integration from BambooHR to NimbleSchedule.',
	},
	'This is a paid time off type': {
		translation: 'This is a paid time off type',
	},
	'This is a workflow to facilitate the approval process of Time Off Requests.':
		{
			translation:
				'This is a workflow to facilitate the approval process of Time Off Requests.',
		},
	'This is a workflow to facilitate the approval process of information updates.':
		{
			translation:
				'This is a workflow to facilitate the approval process of information updates.',
		},
	'This is a workflow to facilitate the approval process.': {
		translation: 'This is a workflow to facilitate the approval process.',
	},
	'This is an old offer': {
		translation: 'This is an old offer',
	},
	'This is done by choosing the Employee Access Level.': {
		translation: 'This is done by choosing the Employee Access Level.',
	},
	'This is gold, Jerry! Gold!': {
		translation: 'This is gold, Jerry! Gold!',
	},
	'This is looking kind of empty': {
		translation: 'This is looking kind of empty',
	},
	'This is not the page you are looking for.': {
		translation: 'This is not the page you are looking for.',
	},
	'This is not your request. Beep. Boop.': {
		translation: 'This is not your request. Beep. Boop.',
	},
	'This is required for most applications.': {
		translation: 'This is required for most applications.',
	},
	'This is required for new applications.': {
		translation: 'This is required for new applications.',
	},
	'This is required for..': {
		translation: 'This is required for..',
	},
	'This is required for...': {
		translation: 'This is required for...',
	},
	'This is the email the candidate will receive notifying them of their offer.':
		{
			translation:
				'This is the email the candidate will receive notifying them of their offer.',
		},
	'This is the information that is used to populate the Employer section of your 1095-C exports.':
		{
			translation:
				'This is the information that is used to populate the Employer section of your 1095-C exports.',
		},
	'This is the only available pay frequency.': {
		translation: 'This is the only available pay frequency.',
	},
	'This is the only tax type for %1$s': {
		translation: 'This is the only tax type for %1$s',
	},
	'This is the person %1 should contact if they have questions.': {
		translation: 'This is the person %1 should contact if they have questions.',
	},
	'This is the person %1$s should contact if they have questions.': {
		translation:
			'This is the person %1$s should contact if they have questions.',
	},
	'This is the person %s should contact if they have questions.': {
		translation: 'This is the person %s should contact if they have questions.',
	},
	"This is the time over which a person's performance is evaluated in each assessment.":
		{
			translation:
				"This is the time over which a person's performance is evaluated in each assessment.",
		},
	'This is usually given to you by the lender when someone has multiple loans at the same lender':
		{
			translation:
				'This is usually given to you by the lender when someone has multiple loans at the same lender',
		},
	'This is waiting on a signature from %1$s.': {
		translation: 'This is waiting on a signature from %1$s.',
	},
	'This is waiting on a signature from <a class="MsgListing__textUserLink" href="/employees/employee.php?id=%1$s">%2$s</a>.':
		{
			translation:
				'This is waiting on a signature from <a class="MsgListing__textUserLink" href="/employees/employee.php?id=%1$s">%2$s</a>.',
		},
	'This is what BambooHR looks like for *{1}*': {
		translation: 'This is what BambooHR looks like for *{1}*',
	},
	'This is what you elected to withhold from your paychecks for tax purposes. Talk to your HR admin if you would like to make a change.':
		{
			translation:
				'This is what you elected to withhold from your paychecks for tax purposes. Talk to your HR admin if you would like to make a change.',
		},
	'This is what you elected to withhold from your paychecks htmlFor tax purposes. Talk to your HR admin if you would like to make a change.':
		{
			translation:
				'This is what you elected to withhold from your paychecks htmlFor tax purposes. Talk to your HR admin if you would like to make a change.',
		},
	'This is where you would be able to download all job info (not available while in trial).':
		{
			translation:
				'This is where you would be able to download all job info (not available while in trial).',
		},
	"This isn't a valid SSN.": {
		translation: "This isn't a valid SSN.",
	},
	'This job is not open. %1$sEdit this job opening%2$s to change its status.': {
		translation:
			'This job is not open. %1$sEdit this job opening%2$s to change its status.',
	},
	'This job will be re-posted, but it can take up to 24 hours to appear on job boards, so hang tight!':
		{
			translation:
				'This job will be re-posted, but it can take up to 24 hours to appear on job boards, so hang tight!',
		},
	'This list includes active users currently in the Full Admin group.': {
		translation:
			'This list includes active users currently in the Full Admin group.',
	},
	'This location is for remote employees': {
		translation: 'This location is for remote employees',
	},
	'This location is used by at least one active job opening, and job openings require an address.':
		{
			translation:
				'This location is used by at least one active job opening, and job openings require an address.',
		},
	"This makes us sad, and it's why you're seeing this": {
		translation: "This makes us sad, and it's why you're seeing this",
	},
	"This makes us sad, and it's why you're seeing this.": {
		translation: "This makes us sad, and it's why you're seeing this.",
	},
	"This may be a temporary issue that will be resolved soon. If it's not, let your HR admin know.":
		{
			translation:
				"This may be a temporary issue that will be resolved soon. If it's not, let your HR admin know.",
		},
	'This means everything should work, but things may look a little funky': {
		translation:
			'This means everything should work, but things may look a little funky',
	},
	'This means everything should work, but things may look a little funky.': {
		translation:
			'This means everything should work, but things may look a little funky.',
	},
	'This method requires a non-empty training type ID.': {
		translation: 'This method requires a non-empty training type ID.',
	},
	'This might take a while': {
		translation: 'This might take a while',
	},
	'This must be a future date.': {
		translation: 'This must be a future date.',
	},
	'This must be today or a future date.': {
		translation: 'This must be today or a future date.',
	},
	'This name already exists': {
		translation: 'This name already exists',
	},
	'This name can be anything. It is just a way for you to keep track of your different API Keys.':
		{
			translation:
				'This name can be anything. It is just a way for you to keep track of your different API Keys.',
		},
	"This name can be anything. It's just a way for you to keep track of your API Keys.":
		{
			translation:
				"This name can be anything. It's just a way for you to keep track of your API Keys.",
		},
	'This name is already being used on another deduction.': {
		translation: 'This name is already being used on another deduction.',
	},
	'This name is already being used.': {
		translation: 'This name is already being used.',
	},
	'This name is not in use.': {
		translation: 'This name is not in use.',
	},
	'This page has been deprecated': {
		translation: 'This page has been deprecated',
	},
	'This page has requested the day off.': {
		translation: 'This page has requested the day off.',
	},
	'This pay period': {
		translation: 'This pay period',
	},
	'This pay schedule isn’t compatible with a couple other fields.': {
		translation:
			'This pay schedule isn’t compatible with a couple other fields.',
	},
	"This peer feedback can't be assigned.": {
		translation: "This peer feedback can't be assigned.",
	},
	'This period': {
		translation: 'This period',
	},
	'This person isn’t eligible for this benefit plan.': {
		translation: 'This person isn’t eligible for this benefit plan.',
	},
	"This person's Employee Access Level will change from %1$s to %2$s": {
		translation:
			"This person's Employee Access Level will change from %1$s to %2$s",
	},
	"This person's Employee Access Level will change from **{1}** to **{2}**": {
		translation:
			"This person's Employee Access Level will change from **{1}** to **{2}**",
	},
	'This plan has a mismatching deduction offset rule. Please contact support': {
		translation:
			'This plan has a mismatching deduction offset rule. Please contact support',
	},
	"This plan has expired. So it's kind of pointless to add it to benefit groups.":
		{
			translation:
				"This plan has expired. So it's kind of pointless to add it to benefit groups.",
		},
	'This plan has not been applied to any groups.': {
		translation: 'This plan has not been applied to any groups.',
	},
	"This policy doesn't exist": {
		translation: "This policy doesn't exist",
	},
	'This policy has levels that accrue time off based on hours worked.': {
		translation:
			'This policy has levels that accrue time off based on hours worked.',
	},
	'This question is no longer available to candidates': {
		translation: 'This question is no longer available to candidates',
	},
	'This question was archived and is no longer visible on job openings': {
		translation:
			'This question was archived and is no longer visible on job openings',
	},
	'This question was available to candidates %1-%2': {
		translation: 'This question was available to candidates %1-%2',
	},
	'This question was updated on %1 and is no longer visible on the job opening':
		{
			translation:
				'This question was updated on %1 and is no longer visible on the job opening',
		},
	'This report cannot be shared': {
		translation: 'This report cannot be shared',
	},
	'This report contains the pay schedule field.': {
		translation: 'This report contains the pay schedule field.',
	},
	'This report has been copied.': {
		translation: 'This report has been copied.',
	},
	"This report identifies areas that need attention. If data is missing, some reports won't be accurate.":
		{
			translation:
				"This report identifies areas that need attention. If data is missing, some reports won't be accurate.",
		},
	'This report is not enabled.': {
		translation: 'This report is not enabled.',
	},
	'This report is not visible to this user': {
		translation: 'This report is not visible to this user',
	},
	'This report is shared with that group through a folder. You can change the sharing permissions within the folder.':
		{
			translation:
				'This report is shared with that group through a folder. You can change the sharing permissions within the folder.',
		},
	'This report is shared with that group through the %1$s folder. You can change the sharing permissions within the folder.':
		{
			translation:
				'This report is shared with that group through the %1$s folder. You can change the sharing permissions within the folder.',
		},
	'This report is shared with that group through the folders %1$s. You can change the sharing permissions within each folder.':
		{
			translation:
				'This report is shared with that group through the folders %1$s. You can change the sharing permissions within each folder.',
		},
	'This report is shared with that user through a folder. You can change the sharing permissions within the folder.':
		{
			translation:
				'This report is shared with that user through a folder. You can change the sharing permissions within the folder.',
		},
	'This report is shared with that user through the %1$s folder. You can change the sharing permissions within the folder.':
		{
			translation:
				'This report is shared with that user through the %1$s folder. You can change the sharing permissions within the folder.',
		},
	'This report is shared with that user through the folders %1$s. You can change the sharing permissions within each folder.':
		{
			translation:
				'This report is shared with that user through the folders %1$s. You can change the sharing permissions within each folder.',
		},
	'This report may take a while to load. Filter results or remove fields to reduce your load times.':
		{
			translation:
				'This report may take a while to load. Filter results or remove fields to reduce your load times.',
		},
	'This report will have the <b>same sharing permissions</b> as the selected folder':
		{
			translation:
				'This report will have the <b>same sharing permissions</b> as the selected folder',
		},
	'This report will have the same sharing permissions <br/>as the selected folder.':
		{
			translation:
				'This report will have the same sharing permissions <br/>as the selected folder.',
		},
	'This report will not be shared with these people. Standard Reports require access to all fields in the report. These people do not have access to one or more fields used in this report.':
		{
			translation:
				'This report will not be shared with these people. Standard Reports require access to all fields in the report. These people do not have access to one or more fields used in this report.',
		},
	'This report will show you which employees may need to have tax adjustments made, based on year-to-date information':
		{
			translation:
				'This report will show you which employees may need to have tax adjustments made, based on year-to-date information',
		},
	'This request for feedback has been canceled.': {
		translation: 'This request for feedback has been canceled.',
	},
	'This request for peer feedback has been canceled.': {
		translation: 'This request for peer feedback has been canceled.',
	},
	'This request has already been deleted.': {
		translation: 'This request has already been deleted.',
	},
	'This request to assign feedback has been canceled.': {
		translation: 'This request to assign feedback has been canceled.',
	},
	'This request to assign peer feedback has been canceled.': {
		translation: 'This request to assign peer feedback has been canceled.',
	},
	'This request was made before hours-per-day could be defined.': {
		translation: 'This request was made before hours-per-day could be defined.',
	},
	'This request will cause an enrollment to last for just one day': {
		translation:
			'This request will cause an enrollment to last for just one day',
	},
	'This request will leave %1$s with %2$s %3$s': {
		translation: 'This request will leave %1$s with %2$s %3$s',
	},
	'This request will leave %1s with %2s %3s': {
		translation: 'This request will leave %1s with %2s %3s',
	},
	"This resume can't be previewed at this time. You can download the original file here:":
		{
			translation:
				"This resume can't be previewed at this time. You can download the original file here:",
		},
	'This returns all enabled employee directory fields for all active employees regardless of other scopes!':
		{
			translation:
				'This returns all enabled employee directory fields for all active employees regardless of other scopes!',
		},
	'This row cannot be deleted because of requirements from the solution provider: ':
		{
			translation:
				'This row cannot be deleted because of requirements from the solution provider: ',
		},
	'This row cannot be deleted because the employee has an invalid SSN': {
		translation:
			'This row cannot be deleted because the employee has an invalid SSN',
	},
	'This row cannot be deleted because the location, department, or division is invalid with a syncing pay schedule.':
		{
			translation:
				'This row cannot be deleted because the location, department, or division is invalid with a syncing pay schedule.',
		},
	'This row has invalid data or is missing data required for import.': {
		translation:
			'This row has invalid data or is missing data required for import.',
	},
	"This row's values are empty": {
		translation: "This row's values are empty",
	},
	'This shows all views of the public job posting page for this job, including views from repeat visitors.':
		{
			translation:
				'This shows all views of the public job posting page for this job, including views from repeat visitors.',
		},
	'This shows how all candidates to this job opening have progressed through the status workflow.':
		{
			translation:
				'This shows how all candidates to this job opening have progressed through the status workflow.',
		},
	'This shows the average amount of time candidates have been in an active status for this job. The lower you can get this, the better.':
		{
			translation:
				'This shows the average amount of time candidates have been in an active status for this job. The lower you can get this, the better.',
		},
	'This shows where all inactive candidates ended up in your status workflow.':
		{
			translation:
				'This shows where all inactive candidates ended up in your status workflow.',
		},
	'This signature request has been canceled by the sender.': {
		translation: 'This signature request has been canceled by the sender.',
	},
	'This signature request has been partially completed and is waiting on other signers. Removing it will cancel the request and discard the partially-signed document.':
		{
			translation:
				'This signature request has been partially completed and is waiting on other signers. Removing it will cancel the request and discard the partially-signed document.',
		},
	'This site has been taken down for maintenance. Questions? %1$sEmail us%2$s':
		{
			translation:
				'This site has been taken down for maintenance. Questions? %1$sEmail us%2$s',
		},
	'This site is protected by reCAPTCHA and the [Google Privacy Policy](1) and [Terms of Service](2) apply.':
		{
			translation:
				'This site is protected by reCAPTCHA and the [Google Privacy Policy](1) and [Terms of Service](2) apply.',
		},
	'This status is already set for one of the orders.': {
		translation: 'This status is already set for one of the orders.',
	},
	'This step is to make sure all your benefit information is in good shape before it is integrated into payroll.':
		{
			translation:
				'This step is to make sure all your benefit information is in good shape before it is integrated into payroll.',
		},
	'This step is to make sure all your employee deduction information is in good shape before it is integrated into payroll.':
		{
			translation:
				'This step is to make sure all your employee deduction information is in good shape before it is integrated into payroll.',
		},
	'This table does not allow editing': {
		translation: 'This table does not allow editing',
	},
	'This task is no longer available, probably because it was deleted.': {
		translation:
			'This task is no longer available, probably because it was deleted.',
	},
	'This tax type has already been added.': {
		translation: 'This tax type has already been added.',
	},
	'This time entry has a note associated with it. You will lose the note if you continue.':
		{
			translation:
				'This time entry has a note associated with it. You will lose the note if you continue.',
		},
	"This time off request was previously approved. It has already been deducted from the employee's available balance.":
		{
			translation:
				"This time off request was previously approved. It has already been deducted from the employee's available balance.",
		},
	'This time off type has a policy that accrues time off based on hours worked.':
		{
			translation:
				'This time off type has a policy that accrues time off based on hours worked.',
		},
	'This time off type is currently disabled. It cannot be requested or reported on.':
		{
			translation:
				'This time off type is currently disabled. It cannot be requested or reported on.',
		},
	'This time off type must be activated to be included in payroll': {
		translation:
			'This time off type must be activated to be included in payroll',
	},
	'This time off type must track time in hours': {
		translation: 'This time off type must track time in hours',
	},
	"This tool is for importing BambooHR Payroll ancillary charges. Successful import actions will be stored in the company's ancillary charges table and used for billing.":
		{
			translation:
				"This tool is for importing BambooHR Payroll ancillary charges. Successful import actions will be stored in the company's ancillary charges table and used for billing.",
		},
	"This tool is for importing employee W4 federal tax withholding information. Successful import actions will be stored in the company's employee federal tax withholdings table.":
		{
			translation:
				"This tool is for importing employee W4 federal tax withholding information. Successful import actions will be stored in the company's employee federal tax withholdings table.",
		},
	'This tool is for importing employee benefits information. Successful import actions will be reflected in the employee benefit history (Benefits tab), including comments.':
		{
			translation:
				'This tool is for importing employee benefits information. Successful import actions will be reflected in the employee benefit history (Benefits tab), including comments.',
		},
	"This tool is for importing employee direct deposit information. Successful import actions will be stored in the company's employee direct deposit accounts table.":
		{
			translation:
				"This tool is for importing employee direct deposit information. Successful import actions will be stored in the company's employee direct deposit accounts table.",
		},
	'This total is calculated by finding the number of employees that were offered coverage for each day of the month.':
		{
			translation:
				'This total is calculated by finding the number of employees that were offered coverage for each day of the month.',
		},
	'This training is required for...': {
		translation: 'This training is required for...',
	},
	'This type is currently disabled': {
		translation: 'This type is currently disabled',
	},
	'This updates tasks that are currently assigned to employees.': {
		translation: 'This updates tasks that are currently assigned to employees.',
	},
	'This url is invalid': {
		translation: 'This url is invalid',
	},
	'This user cannot be deleted': {
		translation: 'This user cannot be deleted',
	},
	'This user has no access to BambooHR and cannot be previewed': {
		translation: 'This user has no access to BambooHR and cannot be previewed',
	},
	'This user is the Owner. For security reasons, we cannot change the employee the Owner is associated with. Please contact %1$ssupport%2$s to change the Owner of this account.':
		{
			translation:
				'This user is the Owner. For security reasons, we cannot change the employee the Owner is associated with. Please contact %1$ssupport%2$s to change the Owner of this account.',
		},
	"This user isn't in a benefit group that includes this benefit.": {
		translation:
			"This user isn't in a benefit group that includes this benefit.",
	},
	'This user was deleted after this request was completed.': {
		translation: 'This user was deleted after this request was completed.',
	},
	'This value is invalid for this field type': {
		translation: 'This value is invalid for this field type',
	},
	'This value is not a number': {
		translation: 'This value is not a number',
	},
	'This value is not a percentage': {
		translation: 'This value is not a percentage',
	},
	'This value is not valid.': {
		translation: 'This value is not valid.',
	},
	'This value must be a whole number': {
		translation: 'This value must be a whole number',
	},
	'This version of the question is no longer available to candidates': {
		translation:
			'This version of the question is no longer available to candidates',
	},
	'This version of the question was available to candidates between %1-%2': {
		translation:
			'This version of the question was available to candidates between %1-%2',
	},
	'This was approved at %1$s (%2$s day ago)': {
		translation: {
			one: 'This was approved at %1$s (%2$s day ago)',
			other: 'This was approved at %1$s (%2$s days ago)',
		},
	},
	'This was approved at %1$s (%2$s hour ago)': {
		translation: {
			one: 'This was approved at %1$s (%2$s hour ago)',
			other: 'This was approved at %1$s (%2$s hours ago)',
		},
	},
	'This was approved on %1$s': {
		translation: 'This was approved on %1$s',
	},
	'This was completed at %1$s (%2$s day ago)': {
		translation: {
			one: 'This was completed at %1$s (%2$s day ago)',
			other: 'This was completed at %1$s (%2$s days ago)',
		},
	},
	'This was completed at %1$s (%2$s hour ago)': {
		translation: {
			one: 'This was completed at %1$s (%2$s hour ago)',
			other: 'This was completed at %1$s (%2$s hours ago)',
		},
	},
	'This was completed on %1$s': {
		translation: 'This was completed on %1$s',
	},
	'This was completed on %1$s.': {
		translation: 'This was completed on %1$s.',
	},
	'This was denied at %1$s (%2$s day ago)': {
		translation: {
			one: 'This was denied at %1$s (%2$s day ago)',
			other: 'This was denied at %1$s (%2$s days ago)',
		},
	},
	'This was denied at %1$s (%2$s hour ago)': {
		translation: {
			one: 'This was denied at %1$s (%2$s hour ago)',
			other: 'This was denied at %1$s (%2$s hours ago)',
		},
	},
	'This was denied on %1$s': {
		translation: 'This was denied on %1$s',
	},
	'This will be posted to the comments feed on each candidate.': {
		translation: 'This will be posted to the comments feed on each candidate.',
	},
	'This will be posted to the comments feed.': {
		translation: 'This will be posted to the comments feed.',
	},
	'This will change the due date of the assessments and may affect the peer feedback schedule. It will not affect goal due dates. Notifications about assessments will be reset and sent according to this updated schedule.':
		{
			translation:
				'This will change the due date of the assessments and may affect the peer feedback schedule. It will not affect goal due dates. Notifications about assessments will be reset and sent according to this updated schedule.',
		},
	'This will change the due date of the assessments but will not affect any other dates (e.g. goal due dates). Notifications about assessments will be reset and sent according to this updated schedule.':
		{
			translation:
				'This will change the due date of the assessments but will not affect any other dates (e.g. goal due dates). Notifications about assessments will be reset and sent according to this updated schedule.',
		},
	'This will delete all department-specific approvals and this approval will become a single approval path for the whole company.':
		{
			translation:
				'This will delete all department-specific approvals and this approval will become a single approval path for the whole company.',
		},
	'This will delete all division-specific approvals and this approval will become a single approval path for the whole company.':
		{
			translation:
				'This will delete all division-specific approvals and this approval will become a single approval path for the whole company.',
		},
	'This will delete all location-specific approvals and this approval will become a single approval path for the whole company.':
		{
			translation:
				'This will delete all location-specific approvals and this approval will become a single approval path for the whole company.',
		},
	'This will delete this folder and its contents for %1all employees%2.': {
		translation:
			'This will delete this folder and its contents for %1all employees%2.',
	},
	'This will delete this folder for %1all employees%2.': {
		translation: 'This will delete this folder for %1all employees%2.',
	},
	'This will ensure we have the most up-to-date information.': {
		translation: 'This will ensure we have the most up-to-date information.',
	},
	'This will help us to calculate the employee cost when you add this plan to a benefit group.':
		{
			translation:
				'This will help us to calculate the employee cost when you add this plan to a benefit group.',
		},
	'This will help you get ready for payroll autosync': {
		translation: 'This will help you get ready for payroll autosync',
	},
	'This will mark this step as complete': {
		translation: 'This will mark this step as complete',
	},
	'This will not change any existing balances or accruals.%s To make corrections, please email %s support@bamboohr.com %s':
		{
			translation:
				'This will not change any existing balances or accruals.%s To make corrections, please email %s support@bamboohr.com %s',
		},
	'This will open a survery in a new tab': {
		translation: 'This will open a survery in a new tab',
	},
	'This will overwrite your changes.': {
		translation: 'This will overwrite your changes.',
	},
	'This will remove all of the demo data in this account along with anything that you may have added. Are you sure that you want to remove this information?':
		{
			translation:
				'This will remove all of the demo data in this account along with anything that you may have added. Are you sure that you want to remove this information?',
		},
	'This will remove form 8655 and require that the customer upload it again.': {
		translation:
			'This will remove form 8655 and require that the customer upload it again.',
	},
	'This will remove the current balance': {
		translation: 'This will remove the current balance',
	},
	'This will replace the previous offer.': {
		translation: 'This will replace the previous offer.',
	},
	'This will take about 5—10 minutes.': {
		translation: 'This will take about 5—10 minutes.',
	},
	'This will take effect at the start of the next pay period. There will be some days noted on the next timesheet where overtime cannot be calculated.':
		{
			translation:
				'This will take effect at the start of the next pay period. There will be some days noted on the next timesheet where overtime cannot be calculated.',
		},
	'This will walk you through everything you need to do to get BambooHR Payroll up and running':
		{
			translation:
				'This will walk you through everything you need to do to get BambooHR Payroll up and running',
		},
	Three: {
		translation: 'Three',
	},
	'Through the BambooHR Slack app, employees will be able to: ': {
		translation: 'Through the BambooHR Slack app, employees will be able to: ',
	},
	'Thumbs Down Comment': {
		translation: 'Thumbs Down Comment',
	},
	'Thumbs Down Reason: Less Helpful Than It Could Be': {
		translation: 'Thumbs Down Reason: Less Helpful Than It Could Be',
	},
	'Thumbs Down Reason: Not Entirely Correct': {
		translation: 'Thumbs Down Reason: Not Entirely Correct',
	},
	'Thumbs Down Reason: Potentially Harmful': {
		translation: 'Thumbs Down Reason: Potentially Harmful',
	},
	Thursday: {
		translation: 'Thursday',
	},
	Thursdays: {
		translation: 'Thursdays',
	},
	Time: {
		translation: 'Time',
	},
	'Time Entry Id': {
		translation: 'Time Entry Id',
	},
	'Time Off': {
		translation: 'Time Off',
	},
	'Time Off & Calendar': {
		translation: 'Time Off & Calendar',
	},
	'Time Off Balance Alert': {
		translation: 'Time Off Balance Alert',
	},
	'Time Off Balance Report': {
		translation: 'Time Off Balance Report',
	},
	'Time Off Balance as of <strong>%s</strong>': {
		translation: 'Time Off Balance as of <strong>%s</strong>',
	},
	'Time Off Balances': {
		translation: 'Time Off Balances',
	},
	'Time Off Balances (Hours)': {
		translation: 'Time Off Balances (Hours)',
	},
	'Time Off Balances Report': {
		translation: 'Time Off Balances Report',
	},
	'Time Off Balances as of ': {
		translation: 'Time Off Balances as of ',
	},
	'Time Off Balances as of **': {
		translation: 'Time Off Balances as of **',
	},
	'Time Off Balances as of <strong>%s</strong>': {
		translation: 'Time Off Balances as of <strong>%s</strong>',
	},
	'Time Off Category': {
		translation: 'Time Off Category',
	},
	'Time Off History': {
		translation: 'Time Off History',
	},
	'Time Off Import': {
		translation: 'Time Off Import',
	},
	'Time Off Import Templates': {
		translation: 'Time Off Import Templates',
	},
	'Time Off Import...': {
		translation: 'Time Off Import...',
	},
	'Time Off Importer': {
		translation: 'Time Off Importer',
	},
	'Time Off Policies': {
		translation: 'Time Off Policies',
	},
	'Time Off Request': {
		translation: 'Time Off Request',
	},
	'Time Off Request Calendar': {
		translation: 'Time Off Request Calendar',
	},
	'Time Off Requests': {
		translation: 'Time Off Requests',
	},
	'Time Off Schedule': {
		translation: 'Time Off Schedule',
	},
	'Time Off Schedule Report': {
		translation: 'Time Off Schedule Report',
	},
	'Time Off Start Date': {
		translation: 'Time Off Start Date',
	},
	'Time Off Taken': {
		translation: 'Time Off Taken',
	},
	'Time Off Totals': {
		translation: 'Time Off Totals',
	},
	'Time Off Totals (Days)': {
		translation: 'Time Off Totals (Days)',
	},
	'Time Off Totals (Hours)': {
		translation: 'Time Off Totals (Hours)',
	},
	'Time Off Tracking': {
		translation: 'Time Off Tracking',
	},
	'Time Off Type': {
		translation: 'Time Off Type',
	},
	'Time Off Type ID required': {
		translation: 'Time Off Type ID required',
	},
	'Time Off Types': {
		translation: 'Time Off Types',
	},
	'Time Off Types included in payroll must be in hours': {
		translation: 'Time Off Types included in payroll must be in hours',
	},
	'Time Off Used': {
		translation: 'Time Off Used',
	},
	'Time Off Used Report': {
		translation: 'Time Off Used Report',
	},
	'Time Tracking': {
		translation: 'Time Tracking',
	},
	'Time Tracking Checklist': {
		translation: 'Time Tracking Checklist',
	},
	'Time Tracking Employee Notification': {
		translation: 'Time Tracking Employee Notification',
	},
	'Time Tracking Employees': {
		translation: 'Time Tracking Employees',
	},
	'Time Tracking Enabled': {
		translation: 'Time Tracking Enabled',
	},
	'Time Tracking Groups': {
		translation: 'Time Tracking Groups',
	},
	'Time Tracking Settings': {
		translation: 'Time Tracking Settings',
	},
	'Time Tracking Settings have been successfully saved.': {
		translation: 'Time Tracking Settings have been successfully saved.',
	},
	'Time Tracking Setup - Add Employees': {
		translation: 'Time Tracking Setup - Add Employees',
	},
	'Time Tracking Setup - Locations': {
		translation: 'Time Tracking Setup - Locations',
	},
	'Time Tracking Setup - Pay Schedules': {
		translation: 'Time Tracking Setup - Pay Schedules',
	},
	'Time Tracking Setup Checklist': {
		translation: 'Time Tracking Setup Checklist',
	},
	'Time Tracking Start Date': {
		translation: 'Time Tracking Start Date',
	},
	'Time Tracking Status': {
		translation: 'Time Tracking Status',
	},
	'Time Tracking Summary': {
		translation: 'Time Tracking Summary',
	},
	'Time Tracking Trial has been cancelled.': {
		translation: 'Time Tracking Trial has been cancelled.',
	},
	'Time Tracking Trial has been started.': {
		translation: 'Time Tracking Trial has been started.',
	},
	'Time Tracking Trial was cancelled. But for Internal Customers the tool must be removed from Greenhouse.':
		{
			translation:
				'Time Tracking Trial was cancelled. But for Internal Customers the tool must be removed from Greenhouse.',
		},
	'Time Tracking adds hourly time management and reporting to the award-winning BambooHR experience, helping you reduce payroll errors and compliance risks with self-service time entry, approvals, automated reminders, automatic overtime calculations, and accurate payroll reporting.':
		{
			translation:
				'Time Tracking adds hourly time management and reporting to the award-winning BambooHR experience, helping you reduce payroll errors and compliance risks with self-service time entry, approvals, automated reminders, automatic overtime calculations, and accurate payroll reporting.',
		},
	'Time Tracking has been disabled for the selected employees.': {
		translation: 'Time Tracking has been disabled for the selected employees.',
	},
	'Time Tracking has been enabled for the selected employees.': {
		translation: 'Time Tracking has been enabled for the selected employees.',
	},
	'Time Tracking has been enabled!': {
		translation: 'Time Tracking has been enabled!',
	},
	'Time Tracking is not enabled.': {
		translation: 'Time Tracking is not enabled.',
	},
	'Time Tracking is scheduled to begin!': {
		translation: 'Time Tracking is scheduled to begin!',
	},
	'Time accrued': {
		translation: 'Time accrued',
	},
	'Time at Current Pay': {
		translation: 'Time at Current Pay',
	},
	'Time before that': {
		translation: 'Time before that',
	},
	'Time entry added for **{1}**': {
		translation: 'Time entry added for **{1}**',
	},
	'Time entry updated from **{1}** to **{2}**': {
		translation: 'Time entry updated from **{1}** to **{2}**',
	},
	'Time for a swim': {
		translation: 'Time for a swim',
	},
	'Time logged to this project is...': {
		translation: 'Time logged to this project is...',
	},
	'Time logged to this task is...': {
		translation: 'Time logged to this task is...',
	},
	'Time off': {
		translation: 'Time off',
	},
	"Time off cancellations cannot be made when previewing another user's account":
		{
			translation:
				"Time off cancellations cannot be made when previewing another user's account",
		},
	'Time off category not found': {
		translation: 'Time off category not found',
	},
	'Time off history item removed successfully': {
		translation: 'Time off history item removed successfully',
	},
	'Time off item updated successfully.': {
		translation: 'Time off item updated successfully.',
	},
	'Time off policies in this Category are paid policies': {
		translation: 'Time off policies in this Category are paid policies',
	},
	'Time off request for **{1}**\n has already been **{2} by {3}**.': {
		translation:
			'Time off request for **{1}**\n has already been **{2} by {3}**.',
	},
	'Time off request for **{1}**\n has already been **{2}**.': {
		translation: 'Time off request for **{1}**\n has already been **{2}**.',
	},
	'Time off request for {1}\n has already been {2} by {3}.': {
		translation: 'Time off request for {1}\n has already been {2} by {3}.',
	},
	'Time off request for {1}\n has already been {2}.': {
		translation: 'Time off request for {1}\n has already been {2}.',
	},
	'Time off request for\n**{1}** has been **{2}**': {
		translation: 'Time off request for\n**{1}** has been **{2}**',
	},
	'Time off request for\n{1} has been {2}': {
		translation: 'Time off request for\n{1} has been {2}',
	},
	'Time off request not found': {
		translation: 'Time off request not found',
	},
	'Time off request not found.': {
		translation: 'Time off request not found.',
	},
	'Time off request not specified.': {
		translation: 'Time off request not specified.',
	},
	'Time off request was successfully %1$s': {
		translation: 'Time off request was successfully %1$s',
	},
	'Time off request was successfully approved': {
		translation: 'Time off request was successfully approved',
	},
	'Time off request was successfully denied': {
		translation: 'Time off request was successfully denied',
	},
	"Time off requests can not be edited when testing another user's account": {
		translation:
			"Time off requests can not be edited when testing another user's account",
	},
	"Time off requests can not be initiated when testing another user's account":
		{
			translation:
				"Time off requests can not be initiated when testing another user's account",
		},
	'Time off requests import': {
		translation: 'Time off requests import',
	},
	'Time off schedule': {
		translation: 'Time off schedule',
	},
	'Time off type': {
		translation: 'Time off type',
	},
	'Time off type not found': {
		translation: 'Time off type not found',
	},
	'Time scheduled': {
		translation: 'Time scheduled',
	},
	'Time taken (YTD)': {
		translation: 'Time taken (YTD)',
	},
	'Time to Hire': {
		translation: 'Time to Hire',
	},
	'Time to Hire - Last 6 Months': {
		translation: 'Time to Hire - Last 6 Months',
	},
	'Time to Hire Details': {
		translation: 'Time to Hire Details',
	},
	'Time with %1': {
		translation: 'Time with %1',
	},
	'Time with Company': {
		translation: 'Time with Company',
	},
	'Time with Current Title': {
		translation: 'Time with Current Title',
	},
	'Time with {1}': {
		translation: 'Time with {1}',
	},
	"Time's up!": {
		translation: "Time's up!",
	},
	Timeline: {
		translation: 'Timeline',
	},
	'Times sent': {
		translation: 'Times sent',
	},
	Timesheet: {
		translation: 'Timesheet',
	},
	'Timesheet Change History': {
		translation: 'Timesheet Change History',
	},
	'Timesheet Detail': {
		translation: 'Timesheet Detail',
	},
	'Timesheet Entries': {
		translation: 'Timesheet Entries',
	},
	'Timesheet Tab': {
		translation: 'Timesheet Tab',
	},
	'Timesheet already approved': {
		translation: 'Timesheet already approved',
	},
	'Timesheet history for %1$s': {
		translation: 'Timesheet history for %1$s',
	},
	'Timesheet hours were successfully approved': {
		translation: 'Timesheet hours were successfully approved',
	},
	'Timesheet hours, weekly summary, pay period totals': {
		translation: 'Timesheet hours, weekly summary, pay period totals',
	},
	'Timesheet not found': {
		translation: 'Timesheet not found',
	},
	'Timesheet sent for approval': {
		translation: 'Timesheet sent for approval',
	},
	'Timesheet tab is only visible for employees with time tracking enabled.': {
		translation:
			'Timesheet tab is only visible for employees with time tracking enabled.',
	},
	Timesheets: {
		translation: 'Timesheets',
	},
	'Timesheets are open for approval at midnight on the last day of the pay period.':
		{
			translation:
				'Timesheets are open for approval at midnight on the last day of the pay period.',
		},
	'Timesheets must be approved by...': {
		translation: 'Timesheets must be approved by...',
	},
	Timezone: {
		translation: 'Timezone',
	},
	'Tips to make sure your logo looks great': {
		translation: 'Tips to make sure your logo looks great',
	},
	Title: {
		translation: 'Title',
	},
	'Title Change': {
		translation: 'Title Change',
	},
	To: {
		translation: 'To',
	},
	"To add them, go to the **employee's profile, then to their Pay Info tab** (read more about this in the [help article])":
		{
			translation:
				"To add them, go to the **employee's profile, then to their Pay Info tab** (read more about this in the [help article])",
		},
	'To comply with government Equal Employment Opportunity and Affirmative Action reporting regulations, we are requesting (but NOT requiring) that you provide this personal data.':
		{
			translation:
				'To comply with government Equal Employment Opportunity and Affirmative Action reporting regulations, we are requesting (but NOT requiring) that you provide this personal data.',
		},
	'To continue, this employee needs a work or home email.': {
		translation: 'To continue, this employee needs a work or home email.',
	},
	'To create the bookmark, press Ctrl/Cmd + D.': {
		translation: 'To create the bookmark, press Ctrl/Cmd + D.',
	},
	'To delete a previously imported record, add the Time Entry ID from the previous record and type "delete" in the Delete column. This will delete all data for the record with the same ID.':
		{
			translation:
				'To delete a previously imported record, add the Time Entry ID from the previous record and type \\"delete\\" in the Delete column. This will delete all data for the record with the same ID.',
		},
	'To embed job openings on your website...': {
		translation: 'To embed job openings on your website...',
	},
	'To embed your job openings on your own website...': {
		translation: 'To embed your job openings on your own website...',
	},
	'To enable access, this employee needs to be active and have a valid work or home email.':
		{
			translation:
				'To enable access, this employee needs to be active and have a valid work or home email.',
		},
	'To enable self-service access, this employee needs to have a valid work or home email.':
		{
			translation:
				'To enable self-service access, this employee needs to have a valid work or home email.',
		},
	'To enable this feature give us a call. %s': {
		translation: 'To enable this feature give us a call. %s',
	},
	'To enable time tracking the employee must be active, belong to an access level, and have an active pay schedule':
		{
			translation:
				'To enable time tracking the employee must be active, belong to an access level, and have an active pay schedule',
		},
	'To enable time tracking you must first select a pay schedule for this employee.':
		{
			translation:
				'To enable time tracking you must first select a pay schedule for this employee.',
		},
	'To finish connecting your BambooHR account to GT Clocks, just click the "Install" button and that will begin the authorization process.':
		{
			translation:
				'To finish connecting your BambooHR account to GT Clocks, just click the "Install" button and that will begin the authorization process.',
		},
	'To fix this, you can either %s close one of your open %s positions or you can give %s us a call to upgrade.%s %s':
		{
			translation:
				'To fix this, you can either %s close one of your open %s positions or you can give %s us a call to upgrade.%s %s',
		},
	'To fix this, you can either close one of your open positions or you can give us a call to upgrade. %s':
		{
			translation:
				'To fix this, you can either close one of your open positions or you can give us a call to upgrade. %s',
		},
	"To get access to the BambooHR ATS, you'll need to upgrade to the Professional Edition of BambooHR which includes this feature.":
		{
			translation:
				"To get access to the BambooHR ATS, you'll need to upgrade to the Professional Edition of BambooHR which includes this feature.",
		},
	'To give you the data you need in this report, we need to know the right EEO categories for your job titles. If necessary, you can edit your job titles in [settings].':
		{
			translation:
				'To give you the data you need in this report, we need to know the right EEO categories for your job titles. If necessary, you can edit your job titles in [settings].',
		},
	'To give you the data you need, we need to know the right EEO categories for your job titles.':
		{
			translation:
				'To give you the data you need, we need to know the right EEO categories for your job titles.',
		},
	'To import employees to be included in payroll, all required fields must be submitted including a valid pay schedule.':
		{
			translation:
				'To import employees to be included in payroll, all required fields must be submitted including a valid pay schedule.',
		},
	"To install %s you must first <a class='uninstallSso' data-constant='%s'>Uninstall %s</a>":
		{
			translation:
				"To install %s you must first <a class='uninstallSso' data-constant='%s'>Uninstall %s</a>",
		},
	'To integrate %s with %s, please complete the following and click Save.': {
		translation:
			'To integrate %s with %s, please complete the following and click Save.',
	},
	'To integrate your BambooHR account with SwipeClock® we need a few pieces of information:':
		{
			translation:
				'To integrate your BambooHR account with SwipeClock® we need a few pieces of information:',
		},
	'To learn more about Advantage Payroll and to setup an account, please <a href="http://hr.bamboohr.com/advantage-referral/">click here</a>':
		{
			translation:
				'To learn more about Advantage Payroll and to setup an account, please <a href=\\"http://hr.bamboohr.com/advantage-referral/\\">click here</a>',
		},
	'To learn more about ApplicantPRO and to setup an account, please <a href="http://hr.bamboohr.com/applicantpro-referral/ ">click here</a>':
		{
			translation:
				'To learn more about ApplicantPRO and to setup an account, please <a href=\\"http://hr.bamboohr.com/applicantpro-referral/ \\">click here</a>',
		},
	'To learn more about BeneTrac and to setup an account, please <a href="http://hr.bamboohr.com/benetrac-referral/">click here</a>':
		{
			translation:
				'To learn more about BeneTrac and to setup an account, please <a href=\\"http://hr.bamboohr.com/benetrac-referral/\\">click here</a>',
		},
	'To learn more about Bitium and to setup an account, please <a href="http://hr.bamboohr.com/bitium-referral/">click here</a>':
		{
			translation:
				'To learn more about Bitium and to setup an account, please <a href=\\"http://hr.bamboohr.com/bitium-referral/\\">click here</a>',
		},
	'To learn more about CATS and to setup an account, please <a href="http://hr.bamboohr.com/cats-referral/">click here</a>':
		{
			translation:
				'To learn more about CATS and to setup an account, please <a href=\\"http://hr.bamboohr.com/cats-referral/\\">click here</a>',
		},
	'To learn more about Cornerstone OnDemand CSB and to setup an account, please <a href="http://hr.bamboohr.com/cornerstone-referral/">click here</a>':
		{
			translation:
				'To learn more about Cornerstone OnDemand CSB and to setup an account, please <a href=\\"http://hr.bamboohr.com/cornerstone-referral/\\">click here</a>',
		},
	'To learn more about HiringThing and to setup an account, please <a href="http://hr.bamboohr.com/hiringthing-referral/">click here</a>':
		{
			translation:
				'To learn more about HiringThing and to setup an account, please <a href=\\"http://hr.bamboohr.com/hiringthing-referral/\\">click here</a>',
		},
	'To learn more about Jazz and to setup an account, please <a href="http://hr.bamboohr.com/jazz-referral/">click here.</a>':
		{
			translation:
				'To learn more about Jazz and to setup an account, please <a href=\\"http://hr.bamboohr.com/jazz-referral/\\">click here.</a>',
		},
	'To learn more about Jobber and to setup an account, please <a href="%s" target="_blank"rel="noopener noreferrer">click here</a>.':
		{
			translation:
				'To learn more about Jobber and to setup an account, please <a href=\\"%s\\" target=\\"_blank\\"rel=\\"noopener noreferrer\\">click here</a>.',
		},
	'To learn more about Newton and to setup an account, please <a href="%s" target="_blank" rel="noopener noreferrer">click here</a>.':
		{
			translation:
				'To learn more about Newton and to setup an account, please <a href=\\"%s\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">click here</a>.',
		},
	'To learn more about NimbleSchedule and to setup an account, please <a href="http://hr.bamboohr.com/nimbleschedule-referral">click here</a>':
		{
			translation:
				'To learn more about NimbleSchedule and to setup an account, please <a href=\\"http://hr.bamboohr.com/nimbleschedule-referral\\">click here</a>',
		},
	'To learn more about OneLogin and to setup an account, please <a href="%s" target="_blank" rel="noopener noreferrer">click here</a>.':
		{
			translation:
				'To learn more about OneLogin and to setup an account, please <a href=\\"%s\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">click here</a>.',
		},
	'To learn more about PerformancePro and to setup an account, please <a href="http://hr.bamboohr.com/performancepro-referral/">click here</a>':
		{
			translation:
				'To learn more about PerformancePro and to setup an account, please <a href=\\"http://hr.bamboohr.com/performancepro-referral/\\">click here</a>',
		},
	'To learn more about RightSignature and to setup an account, please <a href="http://hr.bamboohr.com/rightsignature-referral/">click here</a>':
		{
			translation:
				'To learn more about RightSignature and to setup an account, please <a href=\\"http://hr.bamboohr.com/rightsignature-referral/\\">click here</a>',
		},
	'To learn more about SimplePay.ca and to setup an account, please <a href="%s" target="_blank" rel="noopener noreferrer">click here</a>.':
		{
			translation:
				'To learn more about SimplePay.ca and to setup an account, please <a href=\\"%s\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">click here</a>.',
		},
	'To learn more about Small Improvements and to setup an account, please <a href="http://hr.bamboohr.com/smallimprovement-referral/">click here</a>':
		{
			translation:
				'To learn more about Small Improvements and to setup an account, please <a href=\\"http://hr.bamboohr.com/smallimprovement-referral/\\">click here</a>',
		},
	'To learn more about SwipeClock® and to setup an account, please <a href="http://hr.bamboohr.com/swipeclock-referral/">click here</a>':
		{
			translation:
				'To learn more about SwipeClock® and to setup an account, please <a href=\\"http://hr.bamboohr.com/swipeclock-referral/\\">click here</a>',
		},
	'To learn more about TRAXPayroll and to setup an account, please <a href="http://hr.bamboohr.com/traxpayroll-referral/">click here</a>':
		{
			translation:
				'To learn more about TRAXPayroll and to setup an account, please <a href=\\"http://hr.bamboohr.com/traxpayroll-referral/\\">click here</a>',
		},
	'To learn more about iApplicants and to setup an account, please <a href="%s" target="_blank" rel="noopener noreferrer">click here</a>.':
		{
			translation:
				'To learn more about iApplicants and to setup an account, please <a href=\\"%s\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">click here</a>.',
		},
	'To log into TRAXPayroll from BambooHR as an administrator, click on the "Run Payroll" link in the Links widget on your BambooHR Home. This will then log you into TRAXPayroll\'s administrative dashboard. From here, click on the "Remote Link" tab in order to review and approve pending information updates from BambooHR.':
		{
			translation:
				'To log into TRAXPayroll from BambooHR as an administrator, click on the \\"Run Payroll\\" link in the Links widget on your BambooHR Home. This will then log you into TRAXPayroll\'s administrative dashboard. From here, click on the \\"Remote Link\\" tab in order to review and approve pending information updates from BambooHR.',
		},
	'To login to PlanSource the user must be an employee': {
		translation: 'To login to PlanSource the user must be an employee',
	},
	'To make it easier for employees to fill out time off requests we present default hours for days requested. Employees can always adjust the number when they submit a request.':
		{
			translation:
				'To make it easier for employees to fill out time off requests we present default hours for days requested. Employees can always adjust the number when they submit a request.',
		},
	"To make sure you've added everything, it may be useful to look back through a few recent paystubs":
		{
			translation:
				"To make sure you've added everything, it may be useful to look back through a few recent paystubs",
		},
	'To perform an initial sync of data, please click only one of the buttons below. "Export to Cornerstone" is for existing BambooHR customers with no employee data in their cornerstone account. "Import from Cornerstone" is for existing Cornerstone customers with no employee data in their BambooHR account.':
		{
			translation:
				'To perform an initial sync of data, please click only one of the buttons below. \\"Export to Cornerstone\\" is for existing BambooHR customers with no employee data in their cornerstone account. \\"Import from Cornerstone\\" is for existing Cornerstone customers with no employee data in their BambooHR account.',
		},
	"To price a job it's simple. Really! After following the link and logging in , there are three distinct steps:":
		{
			translation:
				"To price a job it's simple. Really! After following the link and logging in , there are three distinct steps:",
		},
	'To start off, we need to know who will be paid through BambooHR Payroll': {
		translation:
			'To start off, we need to know who will be paid through BambooHR Payroll',
	},
	"To turn this on the employee needs an email and we don't detect an email on the page. Click %s here %s to add.":
		{
			translation:
				"To turn this on the employee needs an email and we don't detect an email on the page. Click %s here %s to add.",
		},
	"To turn this on the employee needs an email and we don't detect an email on the page. Click [here] to add.":
		{
			translation:
				"To turn this on the employee needs an email and we don't detect an email on the page. Click [here] to add.",
		},
	'To:': {
		translation: 'To:',
	},
	Tobacco: {
		translation: 'Tobacco',
	},
	Today: {
		translation: 'Today',
	},
	'Today %1': {
		translation: 'Today %1',
	},
	'Today at': {
		translation: 'Today at',
	},
	'Today at %1$s': {
		translation: 'Today at %1$s',
	},
	'Today is your last day': {
		translation: 'Today is your last day',
	},
	"Today's Date": {
		translation: "Today's Date",
	},
	"Today's date": {
		translation: "Today's date",
	},
	'Toggle Jade': {
		translation: 'Toggle Jade',
	},
	'Token ID': {
		translation: 'Token ID',
	},
	'Token Secret': {
		translation: 'Token Secret',
	},
	Tomorrow: {
		translation: {
			one: 'Tomorrow',
			other: '%s days',
		},
	},
	'Tomorrow %1': {
		translation: 'Tomorrow %1',
	},
	'Too many failed attempts. Your account has been locked. Please try again in %d minutes':
		{
			translation:
				'Too many failed attempts. Your account has been locked. Please try again in %d minutes',
		},
	'Too many password reset requests in a given amount of time': {
		translation: 'Too many password reset requests in a given amount of time',
	},
	Tools: {
		translation: 'Tools',
	},
	Tooltip: {
		translation: 'Tooltip',
	},
	'Top 5 Dislikes': {
		translation: 'Top 5 Dislikes',
	},
	'Top 5 Dislikes Over Time': {
		translation: 'Top 5 Dislikes Over Time',
	},
	'Top 5 Likes': {
		translation: 'Top 5 Likes',
	},
	'Top 5 Likes Over Time': {
		translation: 'Top 5 Likes Over Time',
	},
	'Top axis for chart': {
		translation: 'Top axis for chart',
	},
	Topics: {
		translation: 'Topics',
	},
	'Topics Over Time': {
		translation: 'Topics Over Time',
	},
	'Topics that neutrals and detractors disliked most often.': {
		translation: 'Topics that neutrals and detractors disliked most often.',
	},
	Total: {
		translation: 'Total',
	},
	'Total %1': {
		translation: 'Total %1',
	},
	'Total (Gross) Earnings': {
		translation: 'Total (Gross) Earnings',
	},
	'Total (Hours)': {
		translation: 'Total (Hours)',
	},
	'Total 30 Days Turnover': {
		translation: 'Total 30 Days Turnover',
	},
	'Total ACA Full Time Employee': {
		translation: 'Total ACA Full Time Employee',
	},
	'Total ACA Full Time Employees': {
		translation: 'Total ACA Full Time Employees',
	},
	'Total Balance': {
		translation: 'Total Balance',
	},
	'Total Candidates': {
		translation: 'Total Candidates',
	},
	'Total Compensation': {
		translation: 'Total Compensation',
	},
	'Total Cost': {
		translation: 'Total Cost',
	},
	'Total Cost must be greater than 0.': {
		translation: 'Total Cost must be greater than 0.',
	},
	'Total Cost must be greater than or equal to 0.': {
		translation: 'Total Cost must be greater than or equal to 0.',
	},
	'Total Days Used': {
		translation: 'Total Days Used',
	},
	'Total Declined to Answer': {
		translation: 'Total Declined to Answer',
	},
	'Total Deductions': {
		translation: 'Total Deductions',
	},
	'Total Earnings': {
		translation: 'Total Earnings',
	},
	'Total Employee': {
		translation: 'Total Employee',
	},
	'Total Employees': {
		translation: 'Total Employees',
	},
	'Total Female': {
		translation: 'Total Female',
	},
	'Total Gross Earnings': {
		translation: 'Total Gross Earnings',
	},
	'Total Gross Pay': {
		translation: 'Total Gross Pay',
	},
	'Total Hours': {
		translation: 'Total Hours',
	},
	'Total Hours Used': {
		translation: 'Total Hours Used',
	},
	'Total Hours Worked': {
		translation: 'Total Hours Worked',
	},
	'Total Job Applicants': {
		translation: 'Total Job Applicants',
	},
	'Total Job Candidates': {
		translation: 'Total Job Candidates',
	},
	'Total Male': {
		translation: 'Total Male',
	},
	'Total Monthly Cost (Employee + Company)': {
		translation: 'Total Monthly Cost (Employee + Company)',
	},
	'Total Non-Taxable Earnings': {
		translation: 'Total Non-Taxable Earnings',
	},
	'Total Paid by Your Employer': {
		translation: 'Total Paid by Your Employer',
	},
	'Total Payoff Amount': {
		translation: 'Total Payoff Amount',
	},
	'Total Rewards': {
		translation: 'Total Rewards',
	},
	'Total Signups': {
		translation: 'Total Signups',
	},
	'Total Subscribers': {
		translation: 'Total Subscribers',
	},
	'Total Taxable Earnings': {
		translation: 'Total Taxable Earnings',
	},
	'Total Taxes': {
		translation: 'Total Taxes',
	},
	'Total Taxes Paid': {
		translation: 'Total Taxes Paid',
	},
	'Total Time: %1': {
		translation: 'Total Time: %1',
	},
	'Total Turnover': {
		translation: 'Total Turnover',
	},
	"Total attachment size right now is %s. For emails, it's best to keep it under 10MB.":
		{
			translation:
				"Total attachment size right now is %s. For emails, it's best to keep it under 10MB.",
		},
	'Total: ': {
		translation: 'Total: ',
	},
	TotalUsed: {
		translation: 'TotalUsed',
	},
	Totals: {
		translation: 'Totals',
	},
	'Track Time in...': {
		translation: 'Track Time in...',
	},
	'Track and maintain job information for your employees.': {
		translation: 'Track and maintain job information for your employees.',
	},
	'Track the status of documents within BambooHR to see whose signatures are still outstanding and who has completed the signature request':
		{
			translation:
				'Track the status of documents within BambooHR to see whose signatures are still outstanding and who has completed the signature request',
		},
	'Traditional retirement plan (pre-tax)': {
		translation: 'Traditional retirement plan (pre-tax)',
	},
	Training: {
		translation: 'Training',
	},
	'Training 1': {
		translation: 'Training 1',
	},
	'Training 1 Date': {
		translation: 'Training 1 Date',
	},
	'Training 2': {
		translation: 'Training 2',
	},
	'Training 2 Date': {
		translation: 'Training 2 Date',
	},
	'Training 3': {
		translation: 'Training 3',
	},
	'Training 3 Date': {
		translation: 'Training 3 Date',
	},
	'Training 4': {
		translation: 'Training 4',
	},
	'Training 4 Date': {
		translation: 'Training 4 Date',
	},
	'Training 5': {
		translation: 'Training 5',
	},
	'Training 5 Date': {
		translation: 'Training 5 Date',
	},
	'Training Calendar': {
		translation: 'Training Calendar',
	},
	'Training Calendar & Library': {
		translation: 'Training Calendar & Library',
	},
	'Training Category': {
		translation: 'Training Category',
	},
	'Training History': {
		translation: 'Training History',
	},
	'Training Library': {
		translation: 'Training Library',
	},
	'Training Manager': {
		translation: 'Training Manager',
	},
	'Training Name': {
		translation: 'Training Name',
	},
	'Training Not Complete': {
		translation: 'Training Not Complete',
	},
	'Training Settings': {
		translation: 'Training Settings',
	},
	'Training Type': {
		translation: 'Training Type',
	},
	'Training Type ID must be an integer. "%1$s" not recognized.': {
		translation:
			'Training Type ID must be an integer. \\"%1$s\\" not recognized.',
	},
	'Training Type Id cannot be empty': {
		translation: 'Training Type Id cannot be empty',
	},
	'Training Type with the ID: %1$d does not exist': {
		translation: 'Training Type with the ID: %1$d does not exist',
	},
	'Training is %1$s': {
		translation: 'Training is %1$s',
	},
	'Training must be completed within %s of hire': {
		translation: 'Training must be completed within %s of hire',
	},
	'Training tool is not enabled for this company': {
		translation: 'Training tool is not enabled for this company',
	},
	Trainings: {
		translation: 'Trainings',
	},
	Trans: {
		translation: 'Trans',
	},
	'Transaction Method': {
		translation: 'Transaction Method',
	},
	'Translate List Values': {
		translation: 'Translate List Values',
	},
	'Translation of Custom Fields': {
		translation: 'Translation of Custom Fields',
	},
	'Translation request failed': {
		translation: 'Translation request failed',
	},
	'Translation successfully updated.': {
		translation: 'Translation successfully updated.',
	},
	Translations: {
		translation: 'Translations',
	},
	Trial: {
		translation: 'Trial',
	},
	'Trial account notice': {
		translation: 'Trial account notice',
	},
	'Trial was extended': {
		translation: 'Trial was extended',
	},
	'Truck #': {
		translation: 'Truck #',
	},
	'Try Again': {
		translation: 'Try Again',
	},
	'Try adding or removing filters.': {
		translation: 'Try adding or removing filters.',
	},
	'Try again in a bit.': {
		translation: 'Try again in a bit.',
	},
	'Try running another report now': {
		translation: 'Try running another report now',
	},
	'Try searching for another name, phone number, email, job opening, etc...': {
		translation:
			'Try searching for another name, phone number, email, job opening, etc...',
	},
	'Try searching for another name, title, department, division, or location...':
		{
			translation:
				'Try searching for another name, title, department, division, or location...',
		},
	'Try searching for another report name or category': {
		translation: 'Try searching for another report name or category',
	},
	'Try selecting a different status...': {
		translation: 'Try selecting a different status...',
	},
	'Try your search again or click the button below to search across all employees.':
		{
			translation:
				'Try your search again or click the button below to search across all employees.',
		},
	Tuesday: {
		translation: 'Tuesday',
	},
	Tuesdays: {
		translation: 'Tuesdays',
	},
	'Turn off Email Updates': {
		translation: 'Turn off Email Updates',
	},
	'Turn off eNPS': {
		translation: 'Turn off eNPS',
	},
	'Turn on Email Updates': {
		translation: 'Turn on Email Updates',
	},
	'Turn on Google Single Sign-On for your company to make getting into BambooHR a piece of cake':
		{
			translation:
				'Turn on Google Single Sign-On for your company to make getting into BambooHR a piece of cake',
		},
	'Turn this %sON%s to allow basic employee access to do things like request time off and access the company directory.':
		{
			translation:
				'Turn this %sON%s to allow basic employee access to do things like request time off and access the company directory.',
		},
	'Turning on these features is simply for tracking and reporting purposes—you will still need to file with the IRS for ACA compliance.':
		{
			translation:
				'Turning on these features is simply for tracking and reporting purposes—you will still need to file with the IRS for ACA compliance.',
		},
	Turnover: {
		translation: 'Turnover',
	},
	'Turnover Details': {
		translation: 'Turnover Details',
	},
	'Turnover Rate': {
		translation: 'Turnover Rate',
	},
	'Turnover Report': {
		translation: 'Turnover Report',
	},
	'Turnover rate': {
		translation: 'Turnover rate',
	},
	Turnovers: {
		translation: 'Turnovers',
	},
	'Turnovers by %s': {
		translation: 'Turnovers by %s',
	},
	'Twice a month': {
		translation: 'Twice a month',
	},
	'Twice a year': {
		translation: 'Twice a year',
	},
	Twitter: {
		translation: 'Twitter',
	},
	'Twitter Feed': {
		translation: 'Twitter Feed',
	},
	'Twitter ID': {
		translation: 'Twitter ID',
	},
	'Twitter Username': {
		translation: 'Twitter Username',
	},
	Two: {
		translation: 'Two',
	},
	'Two Jobs': {
		translation: 'Two Jobs',
	},
	'Two Party': {
		translation: 'Two Party',
	},
	'Two Spirit': {
		translation: 'Two Spirit',
	},
	'Two new tabs will be added with this integration - Performance Reviews and Objectives.':
		{
			translation:
				'Two new tabs will be added with this integration - Performance Reviews and Objectives.',
		},
	'Two or More Races': {
		translation: 'Two or More Races',
	},
	'Two pay dates': {
		translation: 'Two pay dates',
	},
	Type: {
		translation: 'Type',
	},
	'Type "%1$s" to continue': {
		translation: 'Type \\"%1$s\\" to continue',
	},
	'Type "%1$s" to remove this group': {
		translation: 'Type \\"%1$s\\" to remove this group',
	},
	'Type "%1$s" to remove this plan': {
		translation: 'Type \\"%1$s\\" to remove this plan',
	},
	'Type "%1$s%2$s%3$s" to continue': {
		translation: 'Type \\"%1$s%2$s%3$s\\" to continue',
	},
	'Type "DELETE" to Continue': {
		translation: 'Type \\"DELETE\\" to Continue',
	},
	'Type "DELETE" to remove this event': {
		translation: 'Type \\"DELETE\\" to remove this event',
	},
	'Type "RESET" to continue.': {
		translation: 'Type \\"RESET\\" to continue.',
	},
	'Type %1 to permanently remove the folder and its files for all employees.': {
		translation:
			'Type %1 to permanently remove the folder and its files for all employees.',
	},
	'Type %1 to permanently%2 remove the folder.': {
		translation: 'Type %1 to permanently%2 remove the folder.',
	},
	'Type %1$s to Continue': {
		translation: 'Type %1$s to Continue',
	},
	'Type %1$s to continue': {
		translation: 'Type %1$s to continue',
	},
	'Type %1$s to permanently remove the folder and its files.': {
		translation: 'Type %1$s to permanently remove the folder and its files.',
	},
	'Type %1$s to remove this benefit group': {
		translation: 'Type %1$s to remove this benefit group',
	},
	'Type %1$s to remove this plan': {
		translation: 'Type %1$s to remove this plan',
	},
	'Type (1)': {
		translation: 'Type (1)',
	},
	'Type (2)': {
		translation: 'Type (2)',
	},
	'Type (3)': {
		translation: 'Type (3)',
	},
	'Type (4)': {
		translation: 'Type (4)',
	},
	'Type **"Delete"** to continue.': {
		translation: 'Type **\\"Delete\\"** to continue.',
	},
	'Type **"{1}"** to continue.': {
		translation: 'Type **\\"{1}\\"** to continue.',
	},
	'Type **“Delete”** to permanently delete this job opening.': {
		translation: 'Type **“Delete”** to permanently delete this job opening.',
	},
	'Type **“{1}”** to permanently remove {2} candidates.': {
		translation: 'Type **“{1}”** to permanently remove {2} candidates.',
	},
	'Type Name': {
		translation: 'Type Name',
	},
	'Type a field name...': {
		translation: 'Type a field name...',
	},
	'Type in your initials': {
		translation: 'Type in your initials',
	},
	'Type in your name...': {
		translation: 'Type in your name...',
	},
	'Type of Departure': {
		translation: 'Type of Departure',
	},
	'Type or paste the full offer letter details below. Drag in placeholders to be filled when the offer letter is sent.':
		{
			translation:
				'Type or paste the full offer letter details below. Drag in placeholders to be filled when the offer letter is sent.',
		},
	'Type or paste the full offer letter text here...': {
		translation: 'Type or paste the full offer letter text here...',
	},
	'Type the name of an employee, department, location, or email address.': {
		translation:
			'Type the name of an employee, department, location, or email address.',
	},
	'Type the name of one or more employees.': {
		translation: 'Type the name of one or more employees.',
	},
	'Type your email here...': {
		translation: 'Type your email here...',
	},
	'Type your email message here...': {
		translation: 'Type your email message here...',
	},
	'Type your initials...': {
		translation: 'Type your initials...',
	},
	'Type your name...': {
		translation: 'Type your name...',
	},
	'Type your subject line here': {
		translation: 'Type your subject line here',
	},
	'Type your subject line here...': {
		translation: 'Type your subject line here...',
	},
	'Type:': {
		translation: 'Type:',
	},
	'U.S. Citizen': {
		translation: 'U.S. Citizen',
	},
	'UDOT PE Due': {
		translation: 'UDOT PE Due',
	},
	'UHC - Critical Illness': {
		translation: 'UHC - Critical Illness',
	},
	'UI Work In': {
		translation: 'UI Work In',
	},
	'UK Private Medical Insurance (PMI)': {
		translation: 'UK Private Medical Insurance (PMI)',
	},
	'UMIA #': {
		translation: 'UMIA #',
	},
	'UMIA expiration': {
		translation: 'UMIA expiration',
	},
	'UPIN #': {
		translation: 'UPIN #',
	},
	'URL for feed created.': {
		translation: 'URL for feed created.',
	},
	'URL for feed has been deleted.': {
		translation: 'URL for feed has been deleted.',
	},
	'URL for feed has been reset.': {
		translation: 'URL for feed has been reset.',
	},
	'URL length exceeded %1$s character limit': {
		translation: 'URL length exceeded %1$s character limit',
	},
	'US Health Insurance - FSA Eligible': {
		translation: 'US Health Insurance - FSA Eligible',
	},
	'US Health Insurance - HSA Eligible': {
		translation: 'US Health Insurance - HSA Eligible',
	},
	'UT state license #': {
		translation: 'UT state license #',
	},
	'UT state license expiration': {
		translation: 'UT state license expiration',
	},
	'UT state license issued': {
		translation: 'UT state license issued',
	},
	UX: {
		translation: 'UX',
	},
	'UX Designer': {
		translation: 'UX Designer',
	},
	'Uh Oh! There was an error. Please try again or contact BambooHR support.': {
		translation:
			'Uh Oh! There was an error. Please try again or contact BambooHR support.',
	},
	'Uh Oh! There was an error. Please try again.': {
		translation: 'Uh Oh! There was an error. Please try again.',
	},
	"Uh Oh! You don't have access to delete all the files in this folder": {
		translation:
			"Uh Oh! You don't have access to delete all the files in this folder",
	},
	'Uh Oh, We weren’t able to retrieve the occupation codes. Try refreshing the page.':
		{
			translation:
				'Uh Oh, We weren’t able to retrieve the occupation codes. Try refreshing the page.',
		},
	"Uh oh! It looks like you didn't select a file to upload. Please try again.":
		{
			translation:
				"Uh oh! It looks like you didn't select a file to upload. Please try again.",
		},
	'Uh oh! There was an error syncing the data.': {
		translation: 'Uh oh! There was an error syncing the data.',
	},
	'Uh oh! This will leave you with a negative balance. Are you sure you want to submit this request?':
		{
			translation:
				'Uh oh! This will leave you with a negative balance. Are you sure you want to submit this request?',
		},
	"Uh oh! You don't have permission to do that!": {
		translation: "Uh oh! You don't have permission to do that!",
	},
	'Uh oh! You need to install Benetrac to complete this action': {
		translation: 'Uh oh! You need to install Benetrac to complete this action',
	},
	'Uh oh, it looks like this offer letter is too long to send. Try reducing the length and sending again.':
		{
			translation:
				'Uh oh, it looks like this offer letter is too long to send. Try reducing the length and sending again.',
		},
	'Uh oh, it looks like this offer letter is too long. Try reducing the length and saving again.':
		{
			translation:
				'Uh oh, it looks like this offer letter is too long. Try reducing the length and saving again.',
		},
	'Uh oh, looks like a duplicate request. Try again.': {
		translation: 'Uh oh, looks like a duplicate request. Try again.',
	},
	'Uh oh, something went wrong while cancelling the assessment.': {
		translation: 'Uh oh, something went wrong while cancelling the assessment.',
	},
	'Uh oh, something went wrong with your demo request. Try again?': {
		translation:
			'Uh oh, something went wrong with your demo request. Try again?',
	},
	'Uh oh, something went wrong.': {
		translation: 'Uh oh, something went wrong.',
	},
	'Uh oh, something went wrong.  Please try again or contact support@bamboohr.com':
		{
			translation:
				'Uh oh, something went wrong.  Please try again or contact support@bamboohr.com',
		},
	'Uh oh, something went wrong. Please try again or contact support@bamboohr.com':
		{
			translation:
				'Uh oh, something went wrong. Please try again or contact support@bamboohr.com',
		},
	'Uh oh, something went wrong. Please try again.': {
		translation: 'Uh oh, something went wrong. Please try again.',
	},
	'Uh oh, we are unable to finalize the offer letter due to a malformed or missing email address. Please try again or contact support@bamboohr.com':
		{
			translation:
				'Uh oh, we are unable to finalize the offer letter due to a malformed or missing email address. Please try again or contact support@bamboohr.com',
		},
	'Uh oh, we are unable to finalize the offer letter. Please try again or contact support@bamboohr.com':
		{
			translation:
				'Uh oh, we are unable to finalize the offer letter. Please try again or contact support@bamboohr.com',
		},
	'Uh oh. Check for invalid email addresses as well as email addresses that are already in use.':
		{
			translation:
				'Uh oh. Check for invalid email addresses as well as email addresses that are already in use.',
		},
	'Uh oh. Looks like your demo data didn’t clear. Please try again, or call us at 866-387-9595 for help.':
		{
			translation:
				'Uh oh. Looks like your demo data didn’t clear. Please try again, or call us at 866-387-9595 for help.',
		},
	'Uh oh. Something went wrong loading this tab. Try again?': {
		translation: 'Uh oh. Something went wrong loading this tab. Try again?',
	},
	'Uh oh. Something went wrong. Please try again.': {
		translation: 'Uh oh. Something went wrong. Please try again.',
	},
	'Uh oh... we had trouble refreshing your timesheet. Try refreshing the page?':
		{
			translation:
				'Uh oh... we had trouble refreshing your timesheet. Try refreshing the page?',
		},
	'Uh oh...something went wrong getting the Remittance ID. Please try again later.':
		{
			translation:
				'Uh oh...something went wrong getting the Remittance ID. Please try again later.',
		},
	'Uh oh...something went wrong linking your account to Plaid. Please try again later.':
		{
			translation:
				'Uh oh...something went wrong linking your account to Plaid. Please try again later.',
		},
	'Uh oh...something went wrong removing Form 8655. Please remove it manually.':
		{
			translation:
				'Uh oh...something went wrong removing Form 8655. Please remove it manually.',
		},
	'Uh oh...something went wrong retrieving your company information. Please try again.':
		{
			translation:
				'Uh oh...something went wrong retrieving your company information. Please try again.',
		},
	'Uh oh...something went wrong retrieving your paystub history data. Please try again.':
		{
			translation:
				'Uh oh...something went wrong retrieving your paystub history data. Please try again.',
		},
	'Uh oh...something went wrong saving the new deduction name. Please try again.':
		{
			translation:
				'Uh oh...something went wrong saving the new deduction name. Please try again.',
		},
	'Uh oh...something went wrong saving your company information. Please try again.':
		{
			translation:
				'Uh oh...something went wrong saving your company information. Please try again.',
		},
	'Uh oh...something went wrong updating codes and rates. Please try again.': {
		translation:
			'Uh oh...something went wrong updating codes and rates. Please try again.',
	},
	'Uh oh...something went wrong updating your account. Please try again.': {
		translation:
			'Uh oh...something went wrong updating your account. Please try again.',
	},
	'Uh oh...something went wrong uploading your files. Please try again.': {
		translation:
			'Uh oh...something went wrong uploading your files. Please try again.',
	},
	'Uh oh...something went wrong validating your EIN. Please try again.': {
		translation:
			'Uh oh...something went wrong validating your EIN. Please try again.',
	},
	"Uh oh...something went wrong, and the payee wasn't saved. Try it again?": {
		translation:
			"Uh oh...something went wrong, and the payee wasn't saved. Try it again?",
	},
	"Uh oh...something went wrong, and your note wasn't saved. Try it again?": {
		translation:
			"Uh oh...something went wrong, and your note wasn't saved. Try it again?",
	},
	"Uh oh...something went wrong, and your time wasn't saved. Try it again?": {
		translation:
			"Uh oh...something went wrong, and your time wasn't saved. Try it again?",
	},
	'Uh oh...something went wrong. Please try again later': {
		translation: 'Uh oh...something went wrong. Please try again later',
	},
	'Uh oh...something went wrong. Please try again later.': {
		translation: 'Uh oh...something went wrong. Please try again later.',
	},
	'Uh oh...something went wrong. Please try again.': {
		translation: 'Uh oh...something went wrong. Please try again.',
	},
	'Uh oh...there was an error uploading your document. Please try again later.':
		{
			translation:
				'Uh oh...there was an error uploading your document. Please try again later.',
		},
	'Uh oh...this deduction name already exists for this deduction type.': {
		translation:
			'Uh oh...this deduction name already exists for this deduction type.',
	},
	'Uh, oh! this will give you a negative balance. Are you sure you want to submit this request?':
		{
			translation:
				'Uh, oh! this will give you a negative balance. Are you sure you want to submit this request?',
		},
	'Uh-oh, You Need Permission': {
		translation: 'Uh-oh, You Need Permission',
	},
	'Uh-oh, something went wrong.': {
		translation: 'Uh-oh, something went wrong.',
	},
	"Uh-oh, we can't send this for approval.": {
		translation: "Uh-oh, we can't send this for approval.",
	},
	'Uh-oh.  Something went wrong.': {
		translation: 'Uh-oh.  Something went wrong.',
	},
	'Uh-oh. Something went wrong, please try again!': {
		translation: 'Uh-oh. Something went wrong, please try again!',
	},
	'Uh-oh. Something went wrong, please try this again later.': {
		translation: 'Uh-oh. Something went wrong, please try this again later.',
	},
	'Uh-oh. Something went wrong.': {
		translation: 'Uh-oh. Something went wrong.',
	},
	'Unable to Download File': {
		translation: 'Unable to Download File',
	},
	'Unable to add candidates to talent pool, please try again.': {
		translation: 'Unable to add candidates to talent pool, please try again.',
	},
	'Unable to add collaborators to talent pool, please try again.': {
		translation:
			'Unable to add collaborators to talent pool, please try again.',
	},
	'Unable to add default status. Please try again.': {
		translation: 'Unable to add default status. Please try again.',
	},
	'Unable to add job opening, please try again.': {
		translation: 'Unable to add job opening, please try again.',
	},
	'Unable to add task(s) due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.':
		{
			translation:
				'Unable to add task(s) due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.',
		},
	'Unable to copy benefit group. A benefit group ID must be provided.': {
		translation:
			'Unable to copy benefit group. A benefit group ID must be provided.',
	},
	'Unable to copy benefit group. The benefit group ID provided is not found.': {
		translation:
			'Unable to copy benefit group. The benefit group ID provided is not found.',
	},
	'Unable to create a new talent pool, please try again.': {
		translation: 'Unable to create a new talent pool, please try again.',
	},
	'Unable to create task due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.':
		{
			translation:
				'Unable to create task due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.',
		},
	'Unable to delete applicant status. Please try again.': {
		translation: 'Unable to delete applicant status. Please try again.',
	},
	'Unable to delete candidates from talent pool, please try again.': {
		translation:
			'Unable to delete candidates from talent pool, please try again.',
	},
	'Unable to delete contacts now that you my friend are no longer onboarding.':
		{
			translation:
				'Unable to delete contacts now that you my friend are no longer onboarding.',
		},
	'Unable to delete talent pool, please try again.': {
		translation: 'Unable to delete talent pool, please try again.',
	},
	'Unable to delete the plan from the benefit group.': {
		translation: 'Unable to delete the plan from the benefit group.',
	},
	'Unable to edit applicant status. Please try again.': {
		translation: 'Unable to edit applicant status. Please try again.',
	},
	'Unable to edit candidate talent pools, please try again.': {
		translation: 'Unable to edit candidate talent pools, please try again.',
	},
	'Unable to extract data from file. Please be sure the file is not empty and follows the candidate importer template.':
		{
			translation:
				'Unable to extract data from file. Please be sure the file is not empty and follows the candidate importer template.',
		},
	'Unable to find Benefit Group List.  Please contact Suppport': {
		translation: 'Unable to find Benefit Group List.  Please contact Suppport',
	},
	'Unable to generate Remote magic link. There is a problem with your Remote App Installation':
		{
			translation:
				'Unable to generate Remote magic link. There is a problem with your Remote App Installation',
		},
	'Unable to get application filter.': {
		translation: 'Unable to get application filter.',
	},
	'Unable to get application filters.': {
		translation: 'Unable to get application filters.',
	},
	'Unable to get talent pools for candidate': {
		translation: 'Unable to get talent pools for candidate',
	},
	'Unable to interpet file.  Please make sure your .txt are in UTF-16LE encoding':
		{
			translation:
				'Unable to interpet file.  Please make sure your .txt are in UTF-16LE encoding',
		},
	'Unable to interpret file.  Please make sure your .csv files are in UTF-8 encoding':
		{
			translation:
				'Unable to interpret file.  Please make sure your .csv files are in UTF-8 encoding',
		},
	'Unable to load Candidate Information. Please try again.': {
		translation: 'Unable to load Candidate Information. Please try again.',
	},
	'Unable to load application custom questions and answers': {
		translation: 'Unable to load application custom questions and answers',
	},
	'Unable to load application emails': {
		translation: 'Unable to load application emails',
	},
	'Unable to load application files': {
		translation: 'Unable to load application files',
	},
	'Unable to load application list': {
		translation: 'Unable to load application list',
	},
	'Unable to load application movements': {
		translation: 'Unable to load application movements',
	},
	'Unable to load application notes': {
		translation: 'Unable to load application notes',
	},
	'Unable to load application offer letter': {
		translation: 'Unable to load application offer letter',
	},
	'Unable to load applications for candidate': {
		translation: 'Unable to load applications for candidate',
	},
	'Unable to load form fields. Please try again.': {
		translation: 'Unable to load form fields. Please try again.',
	},
	'Unable to load the Job Information. Please try again.': {
		translation: 'Unable to load the Job Information. Please try again.',
	},
	'Unable to load the template data. If the issue persists, please contact support.':
		{
			translation:
				'Unable to load the template data. If the issue persists, please contact support.',
		},
	'Unable to load this announcement.': {
		translation: 'Unable to load this announcement.',
	},
	'Unable to login with those NetSuite credentials. Please check the username and password, and ensure the user has the administrator role.':
		{
			translation:
				'Unable to login with those NetSuite credentials. Please check the username and password, and ensure the user has the administrator role.',
		},
	'Unable to login with those NetSuite credentials. Please ensure the user has the administrator role.':
		{
			translation:
				'Unable to login with those NetSuite credentials. Please ensure the user has the administrator role.',
		},
	'Unable to login with those NetSuite credentials. Please verify your username, password, and account info.':
		{
			translation:
				'Unable to login with those NetSuite credentials. Please verify your username, password, and account info.',
		},
	'Unable to move training.': {
		translation: 'Unable to move training.',
	},
	'Unable to open file %s. Please try again': {
		translation: 'Unable to open file %s. Please try again',
	},
	"Unable to open file '%s' Please try again": {
		translation: "Unable to open file '%s' Please try again",
	},
	'Unable to perform requested benefit action': {
		translation: 'Unable to perform requested benefit action',
	},
	'Unable to preview the requested file. If the issue persists, please contact support.':
		{
			translation:
				'Unable to preview the requested file. If the issue persists, please contact support.',
		},
	'Unable to process files. Please try again.': {
		translation: 'Unable to process files. Please try again.',
	},
	'Unable to process payload, please try again.': {
		translation: 'Unable to process payload, please try again.',
	},
	'Unable to process request, the scheduled send date and time has past': {
		translation:
			'Unable to process request, the scheduled send date and time has past',
	},
	'Unable to process request, we were unable to cancel sending the emails': {
		translation:
			'Unable to process request, we were unable to cancel sending the emails',
	},
	'Unable to read logo image file': {
		translation: 'Unable to read logo image file',
	},
	'Unable to remove collaborator from talent pool, please try again.': {
		translation:
			'Unable to remove collaborator from talent pool, please try again.',
	},
	'Unable to remove the current employment status for this employee because they are on a syncing pay schedule':
		{
			translation:
				'Unable to remove the current employment status for this employee because they are on a syncing pay schedule',
		},
	'Unable to remove the employment status for this employee because they are on a syncing pay schedule':
		{
			translation:
				'Unable to remove the employment status for this employee because they are on a syncing pay schedule',
		},
	'Unable to request feedback from this person.': {
		translation: 'Unable to request feedback from this person.',
	},
	'Unable to retrieve benefit groups': {
		translation: 'Unable to retrieve benefit groups',
	},
	'Unable to retrieve information needed for requested action': {
		translation: 'Unable to retrieve information needed for requested action',
	},
	'Unable to retrieve or create an impromptu review period.': {
		translation: 'Unable to retrieve or create an impromptu review period.',
	},
	'Unable to retrieve question revision history, please try again.': {
		translation:
			'Unable to retrieve question revision history, please try again.',
	},
	'Unable to retrieve the file content from the database.': {
		translation: 'Unable to retrieve the file content from the database.',
	},
	'Unable to save applicant status. Please try again.': {
		translation: 'Unable to save applicant status. Please try again.',
	},
	'Unable to save applicant status. The name is invalid.': {
		translation: 'Unable to save applicant status. The name is invalid.',
	},
	'Unable to save applicant status. The name is too long.': {
		translation: 'Unable to save applicant status. The name is too long.',
	},
	'Unable to save applicant status. The status_group_id is not valid.': {
		translation:
			'Unable to save applicant status. The status_group_id is not valid.',
	},
	'Unable to save application filters.': {
		translation: 'Unable to save application filters.',
	},
	'Unable to save translation. Please try again.': {
		translation: 'Unable to save translation. Please try again.',
	},
	'Unable to save user flag.': {
		translation: 'Unable to save user flag.',
	},
	'Unable to select this pay group. This is not a valid Pay Group. Please contact an administrator to check into this Pay Group.':
		{
			translation:
				'Unable to select this pay group. This is not a valid Pay Group. Please contact an administrator to check into this Pay Group.',
		},
	'Unable to send email.': {
		translation: 'Unable to send email.',
	},
	'Unable to send emails while company is in trial': {
		translation: 'Unable to send emails while company is in trial',
	},
	'Unable to send offer letter to a candidate who has been deleted.': {
		translation:
			'Unable to send offer letter to a candidate who has been deleted.',
	},
	'Unable to set status.': {
		translation: 'Unable to set status.',
	},
	'Unable to sign offer letter. This offer contains an image that is inaccessible. Please reach out for a new offer.':
		{
			translation:
				'Unable to sign offer letter. This offer contains an image that is inaccessible. Please reach out for a new offer.',
		},
	'Unable to store offer letter at the moment. Please try signing again.': {
		translation:
			'Unable to store offer letter at the moment. Please try signing again.',
	},
	'Unable to sync with QuickBooks.': {
		translation: 'Unable to sync with QuickBooks.',
	},
	'Unable to update assessment publish date.': {
		translation: 'Unable to update assessment publish date.',
	},
	'Unable to update employee benefit group': {
		translation: 'Unable to update employee benefit group',
	},
	'Unable to update employee policy. Manual policy does not exist for the specified category.':
		{
			translation:
				'Unable to update employee policy. Manual policy does not exist for the specified category.',
		},
	'Unable to update job opening, please try again.': {
		translation: 'Unable to update job opening, please try again.',
	},
	'Unable to update sort order': {
		translation: 'Unable to update sort order',
	},
	'Unable to update sort order.': {
		translation: 'Unable to update sort order.',
	},
	'Unable to update tab order': {
		translation: 'Unable to update tab order',
	},
	'Unable to update talent pool, please try again.': {
		translation: 'Unable to update talent pool, please try again.',
	},
	'Unable to update task due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.':
		{
			translation:
				'Unable to update task due to insufficient storage space for attached eSignature documents. Please contact BambooHR support for assistance.',
		},
	'Unable to update your settings.': {
		translation: 'Unable to update your settings.',
	},
	'Unable to upload an empty file. Are you sure you selected the correct file?':
		{
			translation:
				'Unable to upload an empty file. Are you sure you selected the correct file?',
		},
	'Unable upload an empty file.': {
		translation: 'Unable to upload an empty file.',
	},
	Unarchive: {
		translation: 'Unarchive',
	},
	Unassigned: {
		translation: 'Unassigned',
	},
	Uncategorize: {
		translation: 'Uncategorize',
	},
	Unchecked: {
		translation: 'Unchecked',
	},
	'Uncompleted Changes': {
		translation: 'Uncompleted Changes',
	},
	'Uncompleted Payroll Changes': {
		translation: 'Uncompleted Payroll Changes',
	},
	Under: {
		translation: 'Under',
	},
	'Under 18': {
		translation: 'Under 18',
	},
	'Under 19': {
		translation: 'Under 19',
	},
	'Under 21': {
		translation: 'Under 21',
	},
	'Under Performer': {
		translation: 'Under Performer',
	},
	Undo: {
		translation: 'Undo',
	},
	'Undo Changes': {
		translation: 'Undo Changes',
	},
	'Unemployment Insurance': {
		translation: 'Unemployment Insurance',
	},
	'Unemployment Insurance Location': {
		translation: 'Unemployment Insurance Location',
	},
	'Unemployment Insurance State': {
		translation: 'Unemployment Insurance State',
	},
	'Unemployment State': {
		translation: 'Unemployment State',
	},
	'Unformatted .csv': {
		translation: 'Unformatted .csv',
	},
	'Unfortunately you\'re only able to choose to hide the "Get to Know You" answers before the start date. Maybe next time?':
		{
			translation:
				'Unfortunately you\'re only able to choose to hide the \\"Get to Know You\\" answers before the start date. Maybe next time?',
		},
	"Unfortunately, %1$s hasn't quite kept up with modern web technology, and that prevents us from delivering the best experience":
		{
			translation:
				"Unfortunately, %1$s hasn't quite kept up with modern web technology, and that prevents us from delivering the best experience",
		},
	"Unfortunately, %1$s hasn't quite kept up with modern web technology, and that prevents us from delivering the best experience.":
		{
			translation:
				"Unfortunately, %1$s hasn't quite kept up with modern web technology, and that prevents us from delivering the best experience.",
		},
	'Unfortunately, we are not hiring at this time.': {
		translation: 'Unfortunately, we are not hiring at this time.',
	},
	Uninstall: {
		translation: 'Uninstall',
	},
	'Unit Type': {
		translation: 'Unit Type',
	},
	'United States': {
		translation: 'United States',
	},
	'United Way Donation': {
		translation: 'United Way Donation',
	},
	Units: {
		translation: 'Units',
	},
	Unknown: {
		translation: 'Unknown',
	},
	'Unknown Service Provider': {
		translation: 'Unknown Service Provider',
	},
	'Unknown Service Provider: ': {
		translation: 'Unknown Service Provider: ',
	},
	'Unknown custom approval': {
		translation: 'Unknown custom approval',
	},
	'Unknown error occurred whilst setting up BambooHR Slack Integration': {
		translation:
			'Unknown error occurred whilst setting up BambooHR Slack Integration',
	},
	'Unknown snapshot bundle': {
		translation: 'Unknown snapshot bundle',
	},
	'Unknown time off type': {
		translation: 'Unknown time off type',
	},
	'Unlawful Harassment': {
		translation: 'Unlawful Harassment',
	},
	'Unlawful Harrassment': {
		translation: 'Unlawful Harrassment',
	},
	Unlimited: {
		translation: 'Unlimited',
	},
	'Unlimited Custom Reports': {
		translation: 'Unlimited Custom Reports',
	},
	'Unlimited Email Alerts': {
		translation: 'Unlimited Email Alerts',
	},
	'Unlock Assessment': {
		translation: 'Unlock Assessment',
	},
	Unpaid: {
		translation: 'Unpaid',
	},
	Unpin: {
		translation: 'Unpin',
	},
	'Unrecognized Date': {
		translation: 'Unrecognized Date',
	},
	Unshare: {
		translation: 'Unshare',
	},
	'Unshare Selected Document': {
		translation: 'Unshare Selected Document',
	},
	Unspecified: {
		translation: 'Unspecified',
	},
	Unsuspend: {
		translation: 'Unsuspend',
	},
	'Until next time.': {
		translation: 'Until next time.',
	},
	'Unverified Address': {
		translation: 'Unverified Address',
	},
	'Up one Level': {
		translation: 'Up one Level',
	},
	'Up to %s every %s': {
		translation: 'Up to %s every %s',
	},
	'Up to...': {
		translation: 'Up to...',
	},
	'Up, up, and away': {
		translation: 'Up, up, and away',
	},
	Upcoming: {
		translation: 'Upcoming',
	},
	'Upcoming Employees': {
		translation: 'Upcoming Employees',
	},
	'Upcoming Time Off': {
		translation: 'Upcoming Time Off',
	},
	'Upcoming Training': {
		translation: 'Upcoming Training',
	},
	'Upcoming pay schedules for the next year': {
		translation: 'Upcoming pay schedules for the next year',
	},
	Update: {
		translation: 'Update',
	},
	'Update %s': {
		translation: 'Update %s',
	},
	'Update Address': {
		translation: 'Update Address',
	},
	'Update Benefit Plan Type': {
		translation: 'Update Benefit Plan Type',
	},
	'Update Benefit Plans': {
		translation: 'Update Benefit Plans',
	},
	'Update Billing Contacts': {
		translation: 'Update Billing Contacts',
	},
	'Update Calendar Event': {
		translation: 'Update Calendar Event',
	},
	'Update Codes & Rates': {
		translation: 'Update Codes & Rates',
	},
	'Update Compensation': {
		translation: 'Update Compensation',
	},
	'Update Direct Deposit': {
		translation: 'Update Direct Deposit',
	},
	'Update Employee Data': {
		translation: 'Update Employee Data',
	},
	'Update Info': {
		translation: 'Update Info',
	},
	'Update Information Field': {
		translation: 'Update Information Field',
	},
	'Update Job Information': {
		translation: 'Update Job Information',
	},
	'Update Missing Payroll Info': {
		translation: 'Update Missing Payroll Info',
	},
	'Update My Benefits': {
		translation: 'Update My Benefits',
	},
	'Update Note': {
		translation: 'Update Note',
	},
	'Update Plan': {
		translation: 'Update Plan',
	},
	'Update Project or Note': {
		translation: 'Update Project or Note',
	},
	'Update Random Google Meeting': {
		translation: 'Update Random Google Meeting',
	},
	'Update Random Teams Meeting': {
		translation: 'Update Random Teams Meeting',
	},
	'Update Status': {
		translation: 'Update Status',
	},
	'Update Time Entry': {
		translation: 'Update Time Entry',
	},
	'Update Time Off Request': {
		translation: 'Update Time Off Request',
	},
	'Update Your Information': {
		translation: 'Update Your Information',
	},
	'Update Zoom Meeting': {
		translation: 'Update Zoom Meeting',
	},
	'Update existing employee tasklist items.': {
		translation: 'Update existing employee tasklist items.',
	},
	'Update existing employees (based on Employee #)': {
		translation: 'Update existing employees (based on Employee #)',
	},
	'Update existing employees based on Employee # (feature not yet available)': {
		translation:
			'Update existing employees based on Employee # (feature not yet available)',
	},
	"Update on Your Team's Goals": {
		translation: "Update on Your Team's Goals",
	},
	'Update the data that syncs in BambooHR since it will be considered the system of record. For other data in fields that BambooHR doesn’t sync, update it in Gusto. We’ll continue to improve the integration to sync more data to make it an even better integration.':
		{
			translation:
				'Update the data that syncs in BambooHR since it will be considered the system of record. For other data in fields that BambooHR doesn’t sync, update it in Gusto. We’ll continue to improve the integration to sync more data to make it an even better integration.',
		},
	'Update the email address or...': {
		translation: 'Update the email address or...',
	},
	'Update their garnishment to a different payee to be able to delete %1$s.': {
		translation:
			'Update their garnishment to a different payee to be able to delete %1$s.',
	},
	'Update your existing plans': {
		translation: 'Update your existing plans',
	},
	Updated: {
		translation: 'Updated',
	},
	'Updated By': {
		translation: 'Updated By',
	},
	'Updated Date': {
		translation: 'Updated Date',
	},
	'Updated request': {
		translation: 'Updated request',
	},
	'Updated:': {
		translation: 'Updated:',
	},
	'Updates in BambooHR will automatically sync with your Gusto data.': {
		translation:
			'Updates in BambooHR will automatically sync with your Gusto data.',
	},
	'Updating ACA Tracking': {
		translation: 'Updating ACA Tracking',
	},
	'Updating Status for': {
		translation: 'Updating Status for',
	},
	'Updating Status for:': {
		translation: 'Updating Status for:',
	},
	Upgrade: {
		translation: 'Upgrade',
	},
	'Upgrade Requested': {
		translation: 'Upgrade Requested',
	},
	'Upgrade Storage': {
		translation: 'Upgrade Storage',
	},
	'Upgrade your subscription to add more access levels': {
		translation: 'Upgrade your subscription to add more access levels',
	},
	'Upgrade, downgrade or change billing information': {
		translation: 'Upgrade, downgrade or change billing information',
	},
	'Upgrading your file storage starts when we reach out to you with an email.':
		{
			translation:
				'Upgrading your file storage starts when we reach out to you with an email.',
		},
	'Upgrading your file storage starts when we reach out to your account owner with an email.':
		{
			translation:
				'Upgrading your file storage starts when we reach out to your account owner with an email.',
		},
	Upload: {
		translation: 'Upload',
	},
	'Upload Bank Account Forms': {
		translation: 'Upload Bank Account Forms',
	},
	'Upload Covid-19 Documents': {
		translation: 'Upload Covid-19 Documents',
	},
	'Upload Document': {
		translation: 'Upload Document',
	},
	'Upload File': {
		translation: 'Upload File',
	},
	'Upload Files': {
		translation: 'Upload Files',
	},
	'Upload Signed Forms': {
		translation: 'Upload Signed Forms',
	},
	'Upload Your Logo': {
		translation: 'Upload Your Logo',
	},
	'Upload a file to get started': {
		translation: 'Upload a file to get started',
	},
	'Upload succeeded': {
		translation: 'Upload succeeded',
	},
	'Upload your Company Files here': {
		translation: 'Upload your Company Files here',
	},
	'Upload your Logo': {
		translation: 'Upload your Logo',
	},
	'Upload your completed company payroll forms': {
		translation: 'Upload your completed company payroll forms',
	},
	'Upload your credentials file (.json) from Google:': {
		translation: 'Upload your credentials file (.json) from Google:',
	},
	'Upload your data as a CSV file.  We\'ve created a <a href="employee_direct_deposit_example.php">template file</a> as a reference.':
		{
			translation:
				'Upload your data as a CSV file.  We\'ve created a <a href=\\"employee_direct_deposit_example.php\\">template file</a> as a reference.',
		},
	'Upload your data as a CSV file.  We\'ve created a <a href="employee_federal_tax_withholdings_example.php">template file</a> as a reference.':
		{
			translation:
				'Upload your data as a CSV file.  We\'ve created a <a href=\\"employee_federal_tax_withholdings_example.php\\">template file</a> as a reference.',
		},
	'Upload your data as a CSV file.  We\'ve created a <a href="example.php">template file</a> as a reference.':
		{
			translation:
				'Upload your data as a CSV file.  We\'ve created a <a href=\\"example.php\\">template file</a> as a reference.',
		},
	"Upload your data as a CSV file. We've created a %1$stemplate file%2$s as a reference.":
		{
			translation:
				"Upload your data as a CSV file. We've created a %1$stemplate file%2$s as a reference.",
		},
	'Upload your data as a TXT, CSV, XLS, XLSX, or Flatfile JSON file.  We\'ve created a <a data-bi-id="import-example-template" href="/manage/import/example.php">template file</a> as a reference.':
		{
			translation:
				'Upload your data as a TXT, CSV, XLS, XLSX, or Flatfile JSON file.  We\'ve created a <a data-bi-id="import-example-template" href="/manage/import/example.php">template file</a> as a reference.',
		},
	'Upload your data as a TXT, CSV, XLS, or XLSX file.  We\'ve created a <a data-bi-id="import-example-template" href="/manage/import/example.php">template file</a> as a reference.':
		{
			translation:
				'Upload your data as a TXT, CSV, XLS, or XLSX file.  We\'ve created a <a data-bi-id="import-example-template" href="/manage/import/example.php">template file</a> as a reference.',
		},
	'Upload your employee hour data as a CSV file.': {
		translation: 'Upload your employee hour data as a CSV file.',
	},
	'Upload your signed bank account authorization forms': {
		translation: 'Upload your signed bank account authorization forms',
	},
	'Upload your signed bank authorization forms': {
		translation: 'Upload your signed bank authorization forms',
	},
	Uploaded: {
		translation: 'Uploaded',
	},
	'Uploading Photo...': {
		translation: 'Uploading Photo...',
	},
	'Uploading the file "%s" would cause you to exceed your plan\'s storage limit. Get in touch your BambooHR administrator for help.':
		{
			translation:
				'Uploading the file \\"%s\\" would cause you to exceed your plan\'s storage limit. Get in touch your BambooHR administrator for help.',
		},
	"Uploading the file '%1$s' would cause you to exceed your plan's storage limit. Contact your system administrator for assistance.":
		{
			translation:
				"Uploading the file '%1$s' would cause you to exceed your plan's storage limit. Contact your system administrator for assistance.",
		},
	'Uploading...': {
		translation: 'Uploading...',
	},
	'Upon review': {
		translation: 'Upon review',
	},
	Uppercase: {
		translation: 'Uppercase',
	},
	'Use Browser Default': {
		translation: 'Use Browser Default',
	},
	'Use Data Cleaner': {
		translation: 'Use Data Cleaner',
	},
	'Use Defaults': {
		translation: 'Use Defaults',
	},
	'Use Different Bank Account': {
		translation: 'Use Different Bank Account',
	},
	'Use Hire Date': {
		translation: 'Use Hire Date',
	},
	'Use Preferred Name When Available': {
		translation: 'Use Preferred Name When Available',
	},
	'Use Project Tracking to assign billable and non-billable hours to jobs, clients, projects, tasks or whatever else your organization needs to track and report time on.':
		{
			translation:
				'Use Project Tracking to assign billable and non-billable hours to jobs, clients, projects, tasks or whatever else your organization needs to track and report time on.',
		},
	'Use TRAXPayroll Safe Harbor Match': {
		translation: 'Use TRAXPayroll Safe Harbor Match',
	},
	"Use TRAXPayroll's safe harbor rule for employer match": {
		translation: "Use TRAXPayroll's safe harbor rule for employer match",
	},
	'Use a modern browser to avoid a degraded experience': {
		translation: 'Use a modern browser to avoid a degraded experience',
	},
	'Use current employee information for filters': {
		translation: 'Use current employee information for filters',
	},
	'Use it or lose it by Carryover Date.': {
		translation: 'Use it or lose it by Carryover Date.',
	},
	'Use it or lose it by this day.': {
		translation: 'Use it or lose it by this day.',
	},
	'Use recent address': {
		translation: 'Use recent address',
	},
	'Use the quick search or click an available field to add it to the report.': {
		translation:
			'Use the quick search or click an available field to add it to the report.',
	},
	'Use the quick search or select available fields to edit.': {
		translation: 'Use the quick search or select available fields to edit.',
	},
	'Use this information to wire funds:': {
		translation: 'Use this information to wire funds:',
	},
	'Use your Zoom account to host interviews.': {
		translation: 'Use your Zoom account to host interviews.',
	},
	Used: {
		translation: 'Used',
	},
	'Used %1$s of PTO': {
		translation: 'Used %1$s of PTO',
	},
	'Used (-)': {
		translation: 'Used (-)',
	},
	'Used This Period': {
		translation: 'Used This Period',
	},
	'Used YTD': {
		translation: 'Used YTD',
	},
	'Used for ADP exports': {
		translation: 'Used for ADP exports',
	},
	User: {
		translation: 'User',
	},
	'User Access Levels': {
		translation: 'User Access Levels',
	},
	'User Email Address': {
		translation: 'User Email Address',
	},
	'User Flag saved.': {
		translation: 'User Flag saved.',
	},
	'User Group': {
		translation: 'User Group',
	},
	'User ID': {
		translation: 'User ID',
	},
	'User Id of the user who authorized the application': {
		translation: 'User Id of the user who authorized the application',
	},
	'User Integration': {
		translation: 'User Integration',
	},
	'User List': {
		translation: 'User List',
	},
	'User Permissioned Webhooks': {
		translation: 'User Permissioned Webhooks',
	},
	'User attempted to assign feedback using an Inbox item that is not actionable.':
		{
			translation:
				'User attempted to assign feedback using an Inbox item that is not actionable.',
		},
	'User does not have a Remote Account': {
		translation: 'User does not have a Remote Account',
	},
	'User does not have permission to access Remote': {
		translation: 'User does not have permission to access Remote',
	},
	'User does not have permission to view Remote users': {
		translation: 'User does not have permission to view Remote users',
	},
	'User group is not assignable': {
		translation: 'User group is not assignable',
	},
	'User must set an email to post to LinkedIn': {
		translation: 'User must set an email to post to LinkedIn',
	},
	'User permissioned webhooks are created and configured through the API. These require a user API key and have the same access level as the user it is assigned to.':
		{
			translation:
				'User permissioned webhooks are created and configured through the API. These require a user API key and have the same access level as the user it is assigned to.',
		},
	'User was not found': {
		translation: 'User was not found',
	},
	'User was not found.': {
		translation: 'User was not found.',
	},
	Username: {
		translation: 'Username',
	},
	'Users can click the "Log in with Google" button when logging into BambooHR which will allow them to use their existing Google accounts login. If the user is already logged in to their Google accounts on their computer they will automatically be logged in to BambooHR when they click on the "Log in with Google" button.':
		{
			translation:
				'Users can click the \\"Log in with Google\\" button when logging into BambooHR which will allow them to use their existing Google accounts login. If the user is already logged in to their Google accounts on their computer they will automatically be logged in to BambooHR when they click on the \\"Log in with Google\\" button.',
		},
	'Users can click the "Log in with Microsoft" button when logging into BambooHR which will allow them to use their existing Microsoft accounts login. If the user is already logged in to their Microsoft accounts on their computer they will automatically be logged in to BambooHR when they click on the "Log in with Microsoft" button.':
		{
			translation:
				'Users can click the \\"Log in with Microsoft\\" button when logging into BambooHR which will allow them to use their existing Microsoft accounts login. If the user is already logged in to their Microsoft accounts on their computer they will automatically be logged in to BambooHR when they click on the \\"Log in with Microsoft\\" button.',
		},
	'Users can click the "Log in with QuickBooks" button when logging into BambooHR which will allow them to use their existing QuickBooks account login. If the user is already logged in to their QuickBooks account on their computer they will automatically be logged in to BambooHR when they click on the "Log in with QuickBooks" button.':
		{
			translation:
				'Users can click the "Log in with QuickBooks" button when logging into BambooHR which will allow them to use their existing QuickBooks account login. If the user is already logged in to their QuickBooks account on their computer they will automatically be logged in to BambooHR when they click on the "Log in with QuickBooks" button.',
		},
	'Users have been imported successfully': {
		translation: 'Users have been imported successfully',
	},
	'Users in this group have access to only view payroll reports.': {
		translation:
			'Users in this group have access to only view payroll reports.',
	},
	'Users in this group have full access to payroll-related employee information and functions in BambooHR except approving payroll. Including running payroll, view payroll reports, approving timesheets, and updating employee information.':
		{
			translation:
				'Users in this group have full access to payroll-related employee information and functions in BambooHR except approving payroll. Including running payroll, view payroll reports, approving timesheets, and updating employee information.',
		},
	'Users will be able to use Google Single Sign-On or username & password to login. ':
		{
			translation:
				'Users will be able to use Google Single Sign-On or username & password to login. ',
		},
	'Utilize the Payroll Changes report to quickly retrieve information regarding data changes to core payroll-related fields in a CSV format (as required by ADP for any importing into their system).':
		{
			translation:
				'Utilize the Payroll Changes report to quickly retrieve information regarding data changes to core payroll-related fields in a CSV format (as required by ADP for any importing into their system).',
		},
	VIN: {
		translation: 'VIN',
	},
	'VP Customer Success': {
		translation: 'VP Customer Success',
	},
	'VP Learning and Development': {
		translation: 'VP Learning and Development',
	},
	'VP of Customer Success': {
		translation: 'VP of Customer Success',
	},
	'VP of IT': {
		translation: 'VP of IT',
	},
	'VP of Marketing': {
		translation: 'VP of Marketing',
	},
	'VP of People': {
		translation: 'VP of People',
	},
	'VP of Product': {
		translation: 'VP of Product',
	},
	'VP of Sales': {
		translation: 'VP of Sales',
	},
	'VP of UI Design': {
		translation: 'VP of UI Design',
	},
	'Vac - FT': {
		translation: 'Vac - FT',
	},
	Vacation: {
		translation: 'Vacation',
	},
	'Vacation 1-2': {
		translation: 'Vacation 1-2',
	},
	'Vacation 2': {
		translation: 'Vacation 2',
	},
	'Vacation 2 weeks': {
		translation: 'Vacation 2 weeks',
	},
	'Vacation 3': {
		translation: 'Vacation 3',
	},
	'Vacation 3 weeks': {
		translation: 'Vacation 3 weeks',
	},
	'Vacation 3-4': {
		translation: 'Vacation 3-4',
	},
	'Vacation 4 weeks': {
		translation: 'Vacation 4 weeks',
	},
	'Vacation 5-6': {
		translation: 'Vacation 5-6',
	},
	'Vacation Accrual': {
		translation: 'Vacation Accrual',
	},
	'Vacation Afghan National': {
		translation: 'Vacation Afghan National',
	},
	'Vacation Expat': {
		translation: 'Vacation Expat',
	},
	'Vacation Full Time': {
		translation: 'Vacation Full Time',
	},
	'Vacation Full-Time': {
		translation: 'Vacation Full-Time',
	},
	'Vacation Leave': {
		translation: 'Vacation Leave',
	},
	'Vacation Office': {
		translation: 'Vacation Office',
	},
	'Vacation Part Time': {
		translation: 'Vacation Part Time',
	},
	Vaccinated: {
		translation: 'Vaccinated',
	},
	'Vaccination Exemptions': {
		translation: 'Vaccination Exemptions',
	},
	'Vaccination Exemptions: Comments': {
		translation: 'Vaccination Exemptions: Comments',
	},
	'Vaccination Exemptions: Exemption Date': {
		translation: 'Vaccination Exemptions: Exemption Date',
	},
	'Vaccination Exemptions: Exemption Documentation Collected': {
		translation: 'Vaccination Exemptions: Exemption Documentation Collected',
	},
	'Vaccination Exemptions: Exemption Reason': {
		translation: 'Vaccination Exemptions: Exemption Reason',
	},
	'Vaccination History': {
		translation: 'Vaccination History',
	},
	'Vaccination History: Administration Date': {
		translation: 'Vaccination History: Administration Date',
	},
	'Vaccination History: Date Verified': {
		translation: 'Vaccination History: Date Verified',
	},
	'Vaccination History: Dosage': {
		translation: 'Vaccination History: Dosage',
	},
	'Vaccination History: Office Eligible Date': {
		translation: 'Vaccination History: Office Eligible Date',
	},
	'Vaccination History: Vaccination Status': {
		translation: 'Vaccination History: Vaccination Status',
	},
	'Vaccination History: Vaccine Received': {
		translation: 'Vaccination History: Vaccine Received',
	},
	'Vaccination History: Verified': {
		translation: 'Vaccination History: Verified',
	},
	'Vaccination Status': {
		translation: 'Vaccination Status',
	},
	'Vaccine Received': {
		translation: 'Vaccine Received',
	},
	'Validate Employee Benefit Data': {
		translation: 'Validate Employee Benefit Data',
	},
	'Validate Employee Benefit Data(new)': {
		translation: 'Validate Employee Benefit Data(new)',
	},
	Validating: {
		translation: 'Validating',
	},
	'Validating...': {
		translation: 'Validating...',
	},
	'Validation error, the send date and time is not in the future': {
		translation:
			'Validation error, the send date and time is not in the future',
	},
	Value: {
		translation: 'Value',
	},
	'Value must be between %1 and %2 characters long.': {
		translation: 'Value must be between %1 and %2 characters long.',
	},
	'Value must be between %1 and %2.': {
		translation: 'Value must be between %1 and %2.',
	},
	'Value must be greater than %1.': {
		translation: 'Value must be greater than %1.',
	},
	'Value must be greater than 0': {
		translation: 'Value must be greater than 0',
	},
	'Value must be greater than or equal to %1.': {
		translation: 'Value must be greater than or equal to %1.',
	},
	'Value must be less than %1.': {
		translation: 'Value must be less than %1.',
	},
	'Value must be less than or equal to %1.': {
		translation: 'Value must be less than or equal to %1.',
	},
	'Value must not start with a 0.': {
		translation: 'Value must not start with a 0.',
	},
	'Values:': {
		translation: 'Values:',
	},
	'Vancouver, Canada': {
		translation: 'Vancouver, Canada',
	},
	'Variable (e.g. Age-based rate)': {
		translation: 'Variable (e.g. Age-based rate)',
	},
	'Variable Rate Health': {
		translation: 'Variable Rate Health',
	},
	'Variable Rate Health Plan': {
		translation: 'Variable Rate Health Plan',
	},
	'Variable plans are no longer allowed as a type. Please use isVariable': {
		translation:
			'Variable plans are no longer allowed as a type. Please use isVariable',
	},
	'Variable values': {
		translation: 'Variable values',
	},
	'Vehicle Identification Number': {
		translation: 'Vehicle Identification Number',
	},
	'Vehicle Serial Number': {
		translation: 'Vehicle Serial Number',
	},
	Verified: {
		translation: 'Verified',
	},
	'Verify & Send Email': {
		translation: 'Verify & Send Email',
	},
	'Verify Account': {
		translation: 'Verify Account',
	},
	'Verify Employee Benefit Data': {
		translation: 'Verify Employee Benefit Data',
	},
	"Verify Employees' Employment Status": {
		translation: "Verify Employees' Employment Status",
	},
	'Verify Information': {
		translation: 'Verify Information',
	},
	'Verify Time & Clock Out': {
		translation: 'Verify Time & Clock Out',
	},
	'Verify Your Business Locations': {
		translation: 'Verify Your Business Locations',
	},
	'Verify Your Pay Schedules': {
		translation: 'Verify Your Pay Schedules',
	},
	'Verify and Finish': {
		translation: 'Verify and Finish',
	},
	'Verify bank account': {
		translation: 'Verify bank account',
	},
	'Verify the deposit amount to complete setup for %1$s below': {
		translation: 'Verify the deposit amount to complete setup for %1$s below',
	},
	'Verifying Deposit Amount': {
		translation: 'Verifying Deposit Amount',
	},
	'Verifying deposit amount': {
		translation: 'Verifying deposit amount',
	},
	'Version:': {
		translation: 'Version:',
	},
	'Very Likely': {
		translation: 'Very Likely',
	},
	'Very Unlikely': {
		translation: 'Very Unlikely',
	},
	'Vesting Complete Date': {
		translation: 'Vesting Complete Date',
	},
	'Vesting Date': {
		translation: 'Vesting Date',
	},
	'Vesting Months': {
		translation: 'Vesting Months',
	},
	'Vesting Period': {
		translation: 'Vesting Period',
	},
	'Vesting Schedule': {
		translation: 'Vesting Schedule',
	},
	'Vesting Schedule is either missing or is not supported': {
		translation: 'Vesting Schedule is either missing or is not supported',
	},
	'Vesting Start Date': {
		translation: 'Vesting Start Date',
	},
	Veteran: {
		translation: 'Veteran',
	},
	'Veteran Status': {
		translation: 'Veteran Status',
	},
	'Veterans Status': {
		translation: 'Veterans Status',
	},
	'Via Android App': {
		translation: 'Via Android App',
	},
	'Via iOS App': {
		translation: 'Via iOS App',
	},
	'Video Jones Test': {
		translation: 'Video Jones Test',
	},
	Videographer: {
		translation: 'Videographer',
	},
	View: {
		translation: 'View',
	},
	'View %s': {
		translation: 'View %s',
	},
	'View %s Information': {
		translation: 'View %s Information',
	},
	'View & Download': {
		translation: 'View & Download',
	},
	'View Announcement': {
		translation: 'View Announcement',
	},
	'View BambooHR as': {
		translation: 'View BambooHR as',
	},
	'View Benefit Settings': {
		translation: 'View Benefit Settings',
	},
	'View Benefits': {
		translation: 'View Benefits',
	},
	'View Benefits (ess users)': {
		translation: 'View Benefits (ess users)',
	},
	'View Benefits Administration Reports': {
		translation: 'View Benefits Administration Reports',
	},
	'View Careers Website': {
		translation: 'View Careers Website',
	},
	'View Comments': {
		translation: 'View Comments',
	},
	'View Details': {
		translation: 'View Details',
	},
	'View Feedback': {
		translation: 'View Feedback',
	},
	'View Files': {
		translation: 'View Files',
	},
	'View Folder': {
		translation: 'View Folder',
	},
	'View Full Job Description': {
		translation: 'View Full Job Description',
	},
	'View Full Report': {
		translation: 'View Full Report',
	},
	'View Group': {
		translation: 'View Group',
	},
	'View Import Results': {
		translation: 'View Import Results',
	},
	'View Inbox': {
		translation: 'View Inbox',
	},
	'View Job Description': {
		translation: 'View Job Description',
	},
	'View Job Information': {
		translation: 'View Job Information',
	},
	'View Less': {
		translation: 'View Less',
	},
	'View More': {
		translation: 'View More',
	},
	'View My Benefits': {
		translation: 'View My Benefits',
	},
	'View My Goals': {
		translation: 'View My Goals',
	},
	'View My Info': {
		translation: 'View My Info',
	},
	'View My Training': {
		translation: 'View My Training',
	},
	'View Offer': {
		translation: 'View Offer',
	},
	'View Offer ': {
		translation: 'View Offer ',
	},
	'View Offer Letter': {
		translation: 'View Offer Letter',
	},
	'View Only': {
		translation: 'View Only',
	},
	"View Other Employees' ": {
		translation: "View Other Employees' ",
	},
	'View Payroll Changes': {
		translation: 'View Payroll Changes',
	},
	'View Payroll Reports': {
		translation: 'View Payroll Reports',
	},
	'View Paystub': {
		translation: 'View Paystub',
	},
	'View Personal Information': {
		translation: 'View Personal Information',
	},
	'View Previous Assessment': {
		translation: 'View Previous Assessment',
	},
	'View Report': {
		translation: 'View Report',
	},
	'View Resume': {
		translation: 'View Resume',
	},
	'View Signed Document': {
		translation: 'View Signed Document',
	},
	'View Time Off': {
		translation: 'View Time Off',
	},
	'View Time Off Policy': {
		translation: 'View Time Off Policy',
	},
	'View Time Off Types': {
		translation: 'View Time Off Types',
	},
	'View Timesheet': {
		translation: 'View Timesheet',
	},
	'View Training': {
		translation: 'View Training',
	},
	'View Zendesk Ticket': {
		translation: 'View Zendesk Ticket',
	},
	'View and Adjust Alert Dates': {
		translation: 'View and Adjust Alert Dates',
	},
	'View and create the reports you need.': {
		translation: 'View and create the reports you need.',
	},
	'View benefits': {
		translation: 'View benefits',
	},
	'View in Calendar': {
		translation: 'View in Calendar',
	},
	'View in Cronofy': {
		translation: 'View in Cronofy',
	},
	'View in Inbox': {
		translation: 'View in Inbox',
	},
	"View information about other employees from the Employee Directory and Who's Out calendar":
		{
			translation:
				"View information about other employees from the Employee Directory and Who's Out calendar",
		},
	'View less': {
		translation: 'View less',
	},
	'View pay stub': {
		translation: 'View pay stub',
	},
	'View state of form with Sticky Footer and edit state.': {
		translation: 'View state of form with Sticky Footer and edit state.',
	},
	'View timesheet': {
		translation: 'View timesheet',
	},
	"View who's out calendar": {
		translation: "View who's out calendar",
	},
	'View your Benefit Settings': {
		translation: 'View your Benefit Settings',
	},
	'View your paystubs and pay information.': {
		translation: 'View your paystubs and pay information.',
	},
	Viewed: {
		translation: 'Viewed',
	},
	'Viewing New Hire Packet for:': {
		translation: 'Viewing New Hire Packet for:',
	},
	'Viewing offer letter for': {
		translation: 'Viewing offer letter for',
	},
	'Viewing sample data.': {
		translation: 'Viewing sample data.',
	},
	Views: {
		translation: 'Views',
	},
	'Virus Detected': {
		translation: 'Virus Detected',
	},
	Visa: {
		translation: 'Visa',
	},
	'Visa Information': {
		translation: 'Visa Information',
	},
	'Visa:Date': {
		translation: 'Visa:Date',
	},
	Vision: {
		translation: 'Vision',
	},
	'Vision Insurance': {
		translation: 'Vision Insurance',
	},
	'Vision Insurance 2025': {
		translation: 'Vision Insurance 2025',
	},
	'Vision Plan': {
		translation: 'Vision Plan',
	},
	Visitors: {
		translation: 'Visitors',
	},
	Vitals: {
		translation: 'Vitals',
	},
	'Voila! You see your report!': {
		translation: 'Voila! You see your report!',
	},
	'Voluntary Life': {
		translation: 'Voluntary Life',
	},
	'Voluntary Life Plan': {
		translation: 'Voluntary Life Plan',
	},
	'Voluntary Life Plan 2026': {
		translation: 'Voluntary Life Plan 2026',
	},
	'Voluntary termination of employment': {
		translation: 'Voluntary termination of employment',
	},
	'W-4': {
		translation: 'W-4',
	},
	'W-4 Allowances': {
		translation: 'W-4 Allowances',
	},
	'W-4 Withholding': {
		translation: 'W-4 Withholding',
	},
	W2: {
		translation: 'W2',
	},
	'W2 Validation Issues': {
		translation: 'W2 Validation Issues',
	},
	'WA Dept Labor &': {
		translation: 'WA Dept Labor &',
	},
	'WARNING: This page allows you to CLEAR ALL DATA from your company. Only make use of this feature if you do not need any of the data currently showing inside your BambooHR database.':
		{
			translation:
				'WARNING: This page allows you to CLEAR ALL DATA from your company. Only make use of this feature if you do not need any of the data currently showing inside your BambooHR database.',
		},
	'WH Work In': {
		translation: 'WH Work In',
	},
	'WY state license #': {
		translation: 'WY state license #',
	},
	'WY state license expiration': {
		translation: 'WY state license expiration',
	},
	'WY state license issued': {
		translation: 'WY state license issued',
	},
	'Wage Base': {
		translation: 'Wage Base',
	},
	'Wage Info Change': {
		translation: 'Wage Info Change',
	},
	'Wage Information Changes': {
		translation: 'Wage Information Changes',
	},
	'Wage frequency': {
		translation: 'Wage frequency',
	},
	'Wages and Witholdings': {
		translation: 'Wages and Witholdings',
	},
	'Wait a Second': {
		translation: 'Wait a Second',
	},
	'Wait. Before you continue': {
		translation: 'Wait. Before you continue',
	},
	Waiting: {
		translation: 'Waiting',
	},
	'Waiting for Feedback from...': {
		translation: 'Waiting for Feedback from...',
	},
	'Waiting for Tax ID': {
		translation: 'Waiting for Tax ID',
	},
	'Waiting for approval': {
		translation: 'Waiting for approval',
	},
	'Waiting for approval from %1$s': {
		translation: 'Waiting for approval from %1$s',
	},
	Waive: {
		translation: 'Waive',
	},
	Waived: {
		translation: 'Waived',
	},
	'Waived %s': {
		translation: 'Waived %s',
	},
	'Waived %s on %s': {
		translation: 'Waived %s on %s',
	},
	'Wandered a bit too far, have we?': {
		translation: 'Wandered a bit too far, have we?',
	},
	'Want a quick eNPS refresher? Just watch this video from BambooHR.': {
		translation:
			'Want a quick eNPS refresher? Just watch this video from BambooHR.',
	},
	'Want to learn how to create a new job posting or how to rate an applicant? Check out the tutorial videos and articles in our help center <a href="https://help.bamboohr.com/hc/en-us/categories/202555197-Hiring-Onboarding-Offboarding">here</a>.':
		{
			translation:
				'Want to learn how to create a new job posting or how to rate an applicant? Check out the tutorial videos and articles in our help center <a href=\\"https://help.bamboohr.com/hc/en-us/categories/202555197-Hiring-Onboarding-Offboarding\\">here</a>.',
		},
	'Want to request more than two? No problem! You can always request more later from the employee’s profile page.':
		{
			translation:
				'Want to request more than two? No problem! You can always request more later from the employee’s profile page.',
		},
	'Want to schedule interviews right inside BambooHR ATS? Log in or create an account at ':
		{
			translation:
				'Want to schedule interviews right inside BambooHR ATS? Log in or create an account at ',
		},
	'Warning: One of these files has a virus.': {
		translation: {
			one: 'Warning: One of these files has a virus.',
			other: 'Warning: Some of these files have a virus.',
		},
	},
	Was: {
		translation: 'Was',
	},
	'Was: ': {
		translation: 'Was: ',
	},
	"Water in the US costs around $1.50 per 1,000 gallons (if you aren't buying the bottled type.) With this check, you have enough money to fill %1$s olympic sized swimming pools.":
		{
			translation:
				"Water in the US costs around $1.50 per 1,000 gallons (if you aren't buying the bottled type.) With this check, you have enough money to fill %1$s olympic sized swimming pools.",
		},
	'We analyzed your employees’ responses and tagged each one with the topics they mentioned. Pretty cool, huh?':
		{
			translation:
				'We analyzed your employees’ responses and tagged each one with the topics they mentioned. Pretty cool, huh?',
		},
	'We analyzed your employees’ responses and tagged the topics that promoters liked most often.':
		{
			translation:
				'We analyzed your employees’ responses and tagged the topics that promoters liked most often.',
		},
	'We are excited that you are joining us here at %1$s': {
		translation: 'We are excited that you are joining us here at %1$s',
	},
	'We are excited that you are joining us here at %1$s.': {
		translation: 'We are excited that you are joining us here at %1$s.',
	},
	'We are happy to have %1$s%2$s %3$s%4$s join us as %5$s%6$s%7$s.': {
		translation:
			'We are happy to have %1$s%2$s %3$s%4$s join us as %5$s%6$s%7$s.',
	},
	'We are happy to have %1$s%2$s %3$s%4$s join us.': {
		translation: 'We are happy to have %1$s%2$s %3$s%4$s join us.',
	},
	'We are having trouble connecting to this company db right now. Please check back in a few minutes and if this persists contact IT Operations.':
		{
			translation:
				'We are having trouble connecting to this company db right now. Please check back in a few minutes and if this persists contact IT Operations.',
		},
	'We are making some changes to BambooHR that will make it easier to track ACA data per employee.':
		{
			translation:
				'We are making some changes to BambooHR that will make it easier to track ACA data per employee.',
		},
	'We are making some changes to BambooHR that will make it easier to track ACA data per employee. But in order to complete these changes, we need you to choose an ACA status for each of your employment statuses.':
		{
			translation:
				'We are making some changes to BambooHR that will make it easier to track ACA data per employee. But in order to complete these changes, we need you to choose an ACA status for each of your employment statuses.',
		},
	'We are working on generating a preview for this file. Please check back later.':
		{
			translation:
				'We are working on generating a preview for this file. Please check back later.',
		},
	"We aren't sure which review period you'd like to see.": {
		translation: "We aren't sure which review period you'd like to see.",
	},
	'We can almost hear the Cha-Ching! already.': {
		translation: 'We can almost hear the Cha-Ching! already.',
	},
	"We can't calculate overtime for %1$s because a home address state isn't set.":
		{
			translation:
				"We can't calculate overtime for %1$s because a home address state isn't set.",
		},
	"We can't calculate overtime for %1$s because a location isn't set.": {
		translation:
			"We can't calculate overtime for %1$s because a location isn't set.",
	},
	"We can't calculate overtime for %1$s because a state isn't set.": {
		translation:
			"We can't calculate overtime for %1$s because a state isn't set.",
	},
	"We can't collect and pay garnishments until payees are entered": {
		translation:
			"We can't collect and pay garnishments until payees are entered",
	},
	"We can't collect and pay garnishments until payees are entered.": {
		translation:
			"We can't collect and pay garnishments until payees are entered.",
	},
	'We can\'t display this content since you don\'t have access to the "%1s" field for all employees.':
		{
			translation:
				'We can\'t display this content since you don\'t have access to the \\"%1s\\" field for all employees.',
		},
	"We can't do automatic eligibility this way, so when you have new employees of this type you'll have to manually manage their eligibility and cost rules in your Benefits settings.":
		{
			translation:
				"We can't do automatic eligibility this way, so when you have new employees of this type you'll have to manually manage their eligibility and cost rules in your Benefits settings.",
		},
	"We can't filter on Job Opening since you don't have permissions to manage job openings.":
		{
			translation:
				"We can't filter on Job Opening since you don't have permissions to manage job openings.",
		},
	"We can't find a match for the address entered for %1$s": {
		translation: "We can't find a match for the address entered for %1$s",
	},
	"We can't wait for you to start.": {
		translation: "We can't wait for you to start.",
	},
	"We can't wait to have you as part of the team! Until then, please get in touch if you need copies of your offer documents or have any other questions.":
		{
			translation:
				"We can't wait to have you as part of the team! Until then, please get in touch if you need copies of your offer documents or have any other questions.",
		},
	"We can't wait to have you as part of the team! Until then, please get in touch with %s if you need copies of your offer documents or have any other questions.":
		{
			translation:
				"We can't wait to have you as part of the team! Until then, please get in touch with %s if you need copies of your offer documents or have any other questions.",
		},
	'We cannot complete this action because you have invalid information in the request. Please fix the information and try again.':
		{
			translation:
				'We cannot complete this action because you have invalid information in the request. Please fix the information and try again.',
		},
	'We cannot complete this action because you have overlapping dates or dates missing in your Compensation table. Please fix those dates and try again.':
		{
			translation:
				'We cannot complete this action because you have overlapping dates or dates missing in your Compensation table. Please fix those dates and try again.',
		},
	'We cannot renew your expired credentials. Please restart the process.': {
		translation:
			'We cannot renew your expired credentials. Please restart the process.',
	},
	'We cannot sync your employee data until it has been updated to align with Gusto requirements.':
		{
			translation:
				'We cannot sync your employee data until it has been updated to align with Gusto requirements.',
		},
	'We can’t accept the ".%s" file format. Make sure you’re selecting the right file(s) and try again.':
		{
			translation:
				'We can’t accept the \\".%s\\" file format. Make sure you’re selecting the right file(s) and try again.',
		},
	'We can’t display your pay info because we can’t connect to your payroll provider.':
		{
			translation:
				'We can’t display your pay info because we can’t connect to your payroll provider.',
		},
	'We could not archive %1$s, try again?': {
		translation: 'We could not archive %1$s, try again?',
	},
	'We could not find the record in the database.': {
		translation: 'We could not find the record in the database.',
	},
	'We could not save your training.': {
		translation: 'We could not save your training.',
	},
	'We could not unarchive %1$s, try again?': {
		translation: 'We could not unarchive %1$s, try again?',
	},
	'We could not update this project, try again?': {
		translation: 'We could not update this project, try again?',
	},
	'We couldn\'t filter on "%1s" because you don\'t have permission to view it.':
		{
			translation:
				'We couldn\'t filter on \\"%1s\\" because you don\'t have permission to view it.',
		},
	"We couldn't find that location. Please try again.": {
		translation: "We couldn't find that location. Please try again.",
	},
	"We couldn't find that pay schedule to delete it. Please try again.": {
		translation:
			"We couldn't find that pay schedule to delete it. Please try again.",
	},
	"We couldn't find that time off type": {
		translation: "We couldn't find that time off type",
	},
	"We couldn't find the report you asked for.": {
		translation: "We couldn't find the report you asked for.",
	},
	"We couldn't find the review period you asked for.": {
		translation: "We couldn't find the review period you asked for.",
	},
	'We couldn\'t sort on "%1s" because you don\'t have permission to view it.': {
		translation:
			'We couldn\'t sort on \\"%1s\\" because you don\'t have permission to view it.',
	},
	"We couldn't store the attachment.": {
		translation: "We couldn't store the attachment.",
	},
	'We currently have no open positions.': {
		translation: 'We currently have no open positions.',
	},
	'We do this to ensure your information is safe and secure.': {
		translation: 'We do this to ensure your information is safe and secure.',
	},
	'We do this to make sure your information is safe and secure.': {
		translation: 'We do this to make sure your information is safe and secure.',
	},
	"We don't know how to open that file": {
		translation: "We don't know how to open that file",
	},
	"We don't see anyone in *{1}* that matches your search.": {
		translation: "We don't see anyone in *{1}* that matches your search.",
	},
	"We don't see anyone that matches that status.": {
		translation: "We don't see anyone that matches that status.",
	},
	"We don't see anyone that matches your search.": {
		translation: "We don't see anyone that matches your search.",
	},
	"We don't see job openings that match that status.": {
		translation: "We don't see job openings that match that status.",
	},
	"We don't want there to be any surprises. Choose when you would like to kick off performance. Employees won't see anything in Bamboo until it kicks off.":
		{
			translation:
				"We don't want there to be any surprises. Choose when you would like to kick off performance. Employees won't see anything in Bamboo until it kicks off.",
		},
	'We don’t have enough data to show you now, but after your second Employee Satisfaction survey we’ll display the trend of your score. Stay tuned—this just gets better and better!':
		{
			translation:
				'We don’t have enough data to show you now, but after your second Employee Satisfaction survey we’ll display the trend of your score. Stay tuned—this just gets better and better!',
		},
	'We don’t include different currencies when calculating increases, so widgets/reports may be slightly inaccurate.':
		{
			translation:
				'We don’t include different currencies when calculating increases, so widgets/reports may be slightly inaccurate.',
		},
	'We don’t see any reports that match your search': {
		translation: 'We don’t see any reports that match your search',
	},
	'We don’t want there to be any surprises. Choose when you would like to kick off performance. Employees won’t see anything in Bamboo until it kicks off.':
		{
			translation:
				'We don’t want there to be any surprises. Choose when you would like to kick off performance. Employees won’t see anything in Bamboo until it kicks off.',
		},
	'We had a problem saving a custom question answer. Answer is too long.': {
		translation:
			'We had a problem saving a custom question answer. Answer is too long.',
	},
	'We had a problem saving your application. Please try again.': {
		translation: 'We had a problem saving your application. Please try again.',
	},
	'We had trouble updating the new pay dates because it schedules your next pay date within 3 business days of today.':
		{
			translation:
				'We had trouble updating the new pay dates because it schedules your next pay date within 3 business days of today.',
		},
	'We had trouble updating the new pay dates.': {
		translation: 'We had trouble updating the new pay dates.',
	},
	"We have detected that you have %d inactive employee who isn't terminated. Terminate inactive employees to ensure accurate data.":
		{
			translation: {
				one: "We have detected that you have %d inactive employee who isn't terminated. Terminate inactive employees to ensure accurate data.",
				other:
					"We have detected that you have %d inactive employees who aren't terminated. Terminate inactive employees to ensure accurate data.",
			},
		},
	'We have lost communication with Gusto. Please try again later.': {
		translation:
			'We have lost communication with Gusto. Please try again later.',
	},
	'We have some good news.': {
		translation: 'We have some good news.',
	},
	'We have successfully linked to your Cornerstone account. You can change the credentials below.':
		{
			translation:
				'We have successfully linked to your Cornerstone account. You can change the credentials below.',
		},
	'We have successfully linked to your NetSuite account. You can change the credentials below.':
		{
			translation:
				'We have successfully linked to your NetSuite account. You can change the credentials below.',
		},
	'We just ask that you acknowledge that they will be receiving paper checks': {
		translation:
			'We just ask that you acknowledge that they will be receiving paper checks',
	},
	'We just need a few details to install Single Sign-On (SSO).': {
		translation: 'We just need a few details to install Single Sign-On (SSO).',
	},
	'We just need to know how you define your current benefit groups.': {
		translation:
			'We just need to know how you define your current benefit groups.',
	},
	'We just sent you another verification email.': {
		translation: 'We just sent you another verification email.',
	},
	'We need a little more information to collect and pay garnishments': {
		translation:
			'We need a little more information to collect and pay garnishments',
	},
	'We need a little more information to collect and pay garnishments.': {
		translation:
			'We need a little more information to collect and pay garnishments.',
	},
	'We need to know where to send the moola': {
		translation: 'We need to know where to send the moola',
	},
	'We need to make sure your information in BambooHR is in tip-top shape before we can enable BambooHR Payroll':
		{
			translation:
				'We need to make sure your information in BambooHR is in tip-top shape before we can enable BambooHR Payroll',
		},
	'We need your approval to collect additional funds. Please review the details below to understand why we are making the request.':
		{
			translation:
				'We need your approval to collect additional funds. Please review the details below to understand why we are making the request.',
		},
	'We need your help converting some of the pay distribution amounts of your enrolled employees.':
		{
			translation:
				'We need your help converting some of the pay distribution amounts of your enrolled employees.',
		},
	'We need your help to set up your new benefits tracking.': {
		translation: 'We need your help to set up your new benefits tracking.',
	},
	'We need your permission to verify and make withdrawals and deposits to your bank account.':
		{
			translation:
				'We need your permission to verify and make withdrawals and deposits to your bank account.',
		},
	'We only support a single company. We auto selected: ': {
		translation: 'We only support a single company. We auto selected: ',
	},
	'We really want to know.': {
		translation: 'We really want to know.',
	},
	"We recommend adding all of your company's plans first": {
		translation: "We recommend adding all of your company's plans first",
	},
	"We recommend adding the URL of your Plan's find-a-dentist page or another page that you think would be most useful to your employees.":
		{
			translation:
				"We recommend adding the URL of your Plan's find-a-dentist page or another page that you think would be most useful to your employees.",
		},
	"We recommend adding the URL of your Plan's find-a-doctor page or another page that you think would be most useful to your employees.":
		{
			translation:
				"We recommend adding the URL of your Plan's find-a-doctor page or another page that you think would be most useful to your employees.",
		},
	"We recommend adding the URL of your Plan's find-an-optometrist page or another page that you think would be most useful to your employees.":
		{
			translation:
				"We recommend adding the URL of your Plan's find-an-optometrist page or another page that you think would be most useful to your employees.",
		},
	'We recommend adding the URL that your employees use to access their account information or another page that you think would be most useful.':
		{
			translation:
				'We recommend adding the URL that your employees use to access their account information or another page that you think would be most useful.',
		},
	'We removed the %sDepartment%s placeholder from your email.': {
		translation: 'We removed the %sDepartment%s placeholder from your email.',
	},
	'We removed the *Department* placeholder from your email.': {
		translation: 'We removed the *Department* placeholder from your email.',
	},
	'We sent a small deposit to your %1$s %2$s account and retrieved it in 1 withdrawal':
		{
			translation:
				'We sent a small deposit to your %1$s %2$s account and retrieved it in 1 withdrawal',
		},
	'We suggest moving employees to a new %1$s before deleting this one.': {
		translation:
			'We suggest moving employees to a new %1$s before deleting this one.',
	},
	'We suggest moving employees to a new pay schedule before deleting this one.':
		{
			translation:
				'We suggest moving employees to a new pay schedule before deleting this one.',
		},
	'We tried to send an email to this address, but it came back as invalid.': {
		translation:
			'We tried to send an email to this address, but it came back as invalid.',
	},
	'We updated the Employee Tax Type to a value that matches the employment status.':
		{
			translation:
				'We updated the Employee Tax Type to a value that matches the employment status.',
		},
	'We updated the Employee Tax Type to a value that matches this status.': {
		translation:
			'We updated the Employee Tax Type to a value that matches this status.',
	},
	'We use Plaid to securely link your bank account to BambooHR. [Learn more]': {
		translation:
			'We use Plaid to securely link your bank account to BambooHR. [Learn more]',
	},
	'We use cookies to make your experience more delicious. By continuing to use BambooHR, you agree to our use of cookies in accordance with our %1privacy policy%2':
		{
			translation:
				'We use cookies to make your experience more delicious. By continuing to use BambooHR, you agree to our use of cookies in accordance with our %1privacy policy%2',
		},
	'We use the employee’s location to calculate standard overtime rules based on state, territory, and province rules. Double check that all your addresses are accurate.':
		{
			translation:
				'We use the employee’s location to calculate standard overtime rules based on state, territory, and province rules. Double check that all your addresses are accurate.',
		},
	'We use the location information to calculate overtime based on state regulations.':
		{
			translation:
				'We use the location information to calculate overtime based on state regulations.',
		},
	'We want to help you understand how your Employee Net Promoter Score compares to other BambooHR customers. To do this, we are asking customers to share their anonymized eNPS results.':
		{
			translation:
				'We want to help you understand how your Employee Net Promoter Score compares to other BambooHR customers. To do this, we are asking customers to share their anonymized eNPS results.',
		},
	'We want to make sure that you are ready to go on your first day.': {
		translation:
			'We want to make sure that you are ready to go on your first day.',
	},
	'We want to make your transition a smooth one.': {
		translation: 'We want to make your transition a smooth one.',
	},
	'We were unable to change your account owner. Contact us at support@bamboohr.com':
		{
			translation:
				'We were unable to change your account owner. Contact us at support@bamboohr.com',
		},
	'We were unable to delete your pay schedule. Please try again.': {
		translation:
			'We were unable to delete your pay schedule. Please try again.',
	},
	'We were unable to find your time off type. Please try again.': {
		translation: 'We were unable to find your time off type. Please try again.',
	},
	'We were unable to locate the assessment.': {
		translation: 'We were unable to locate the assessment.',
	},
	'We were unable to locate this file. Please try again.': {
		translation: 'We were unable to locate this file. Please try again.',
	},
	'We were unable to locate this folder. Please try again.': {
		translation: 'We were unable to locate this folder. Please try again.',
	},
	'We were unable to log you in directly to that company.': {
		translation: 'We were unable to log you in directly to that company.',
	},
	'We were unable to process this request and are working to resolve the issue.':
		{
			translation:
				'We were unable to process this request and are working to resolve the issue.',
		},
	'We were unable to rename this read-only file.': {
		translation: 'We were unable to rename this read-only file.',
	},
	'We were unable to save Direct Deposit Information': {
		translation: 'We were unable to save Direct Deposit Information',
	},
	'We were unable to save Employee Tax States.': {
		translation: 'We were unable to save Employee Tax States.',
	},
	'We were unable to save Tax Document Delivery Preference': {
		translation: 'We were unable to save Tax Document Delivery Preference',
	},
	'We were unable to save Tax Withholding': {
		translation: 'We were unable to save Tax Withholding',
	},
	'We were unable to save you Unemployment State': {
		translation: 'We were unable to save you Unemployment State',
	},
	'We were unable to save your pay schedule. Please try again.': {
		translation: 'We were unable to save your pay schedule. Please try again.',
	},
	'We were unable to send your verification email.': {
		translation: 'We were unable to send your verification email.',
	},
	'We were unable to update plan cost. Has it been deleted?': {
		translation: 'We were unable to update plan cost. Has it been deleted?',
	},
	'We were unable to update the access level': {
		translation: 'We were unable to update the access level',
	},
	'We were unable to validate your email request.': {
		translation: 'We were unable to validate your email request.',
	},
	"We weren't able to assign your feedback at this time. Please try again.": {
		translation:
			"We weren't able to assign your feedback at this time. Please try again.",
	},
	"We weren't able to assign your peer feedback. Please try again.": {
		translation:
			"We weren't able to assign your peer feedback. Please try again.",
	},
	'We will be contacting you shortly to schedule a personal demo.': {
		translation:
			'We will be contacting you shortly to schedule a personal demo.',
	},
	'We will be in touch to schedule a personal demo.': {
		translation: 'We will be in touch to schedule a personal demo.',
	},
	"We will be unable to send to %s because they don't have an email address in the system.":
		{
			translation:
				"We will be unable to send to %s because they don't have an email address in the system.",
		},
	'We will restore all vital enrollment information for each employee including coverage levels, enrollment status, contribution amounts, and effective dates.':
		{
			translation:
				'We will restore all vital enrollment information for each employee including coverage levels, enrollment status, contribution amounts, and effective dates.',
		},
	'We will send a small deposit to your account. You will see a deposit from "BambooHR Payroll Services, LLC".  Once the deposit appears in your bank account, come back and enter the amount to verify your account.':
		{
			translation:
				'We will send a small deposit to your account. You will see a deposit from \\"BambooHR Payroll Services, LLC\\".  Once the deposit appears in your bank account, come back and enter the amount to verify your account.',
		},
	'We will send a small deposit to your account. You will see a deposit from "BambooHR Payroll Services, LLC". Once the deposit appears in your bank account, come back and enter the amount to verify your account.':
		{
			translation:
				'We will send a small deposit to your account. You will see a deposit from \\"BambooHR Payroll Services, LLC\\". Once the deposit appears in your bank account, come back and enter the amount to verify your account.',
		},
	"We'll be able to show you updates after you run your first payroll.": {
		translation:
			"We'll be able to show you updates after you run your first payroll.",
	},
	"We'll be in touch soon to schedule a demo.": {
		translation: "We'll be in touch soon to schedule a demo.",
	},
	"We'll email this report to": {
		translation: "We'll email this report to",
	},
	"We'll help you assign an ACA status to each of your employment statuses.": {
		translation:
			"We'll help you assign an ACA status to each of your employment statuses.",
	},
	"We'll leave this setting off until you're ready to add payees to your existing garnishments.":
		{
			translation:
				"We'll leave this setting off until you're ready to add payees to your existing garnishments.",
		},
	"We'll let {1} know the request has been canceled.": {
		translation: "We'll let {1} know the request has been canceled.",
	},
	"We'll open a new window so you can finish the installation at Google Apps Marketplace. We'll still be here when you're done.":
		{
			translation:
				"We'll open a new window so you can finish the installation at Google Apps Marketplace. We'll still be here when you're done.",
		},
	"We'll show you all of the employee info changes since the last pay period.":
		{
			translation:
				"We'll show you all of the employee info changes since the last pay period.",
		},
	"We'll show you the history of all the candidates for the job opening; where they got stuck, where they ended up, all of it.":
		{
			translation:
				"We'll show you the history of all the candidates for the job opening; where they got stuck, where they ended up, all of it.",
		},
	"We'll show you the history of all the hours logged to a project; what tasks were worked on, billable or non-billable, all of it.":
		{
			translation:
				"We'll show you the history of all the hours logged to a project; what tasks were worked on, billable or non-billable, all of it.",
		},
	"We'll use the data you've already entered, and ": {
		translation: "We'll use the data you've already entered, and ",
	},
	"We'll use this to clearly differentiate multiple loans for the same person when exporting data to the provider":
		{
			translation:
				"We'll use this to clearly differentiate multiple loans for the same person when exporting data to the provider",
		},
	"We'll walk you through everything you need to do to get BambooHR Payroll up and running":
		{
			translation:
				"We'll walk you through everything you need to do to get BambooHR Payroll up and running",
		},
	"We're excited for you to start using it. Check out what comes next.": {
		translation:
			"We're excited for you to start using it. Check out what comes next.",
	},
	"We're excited to have you join the team here at %1$s": {
		translation: "We're excited to have you join the team here at %1$s",
	},
	"We're excited to have you join the team here at %1$s.": {
		translation: "We're excited to have you join the team here at %1$s.",
	},
	"We're excited to have you join the team.": {
		translation: "We're excited to have you join the team.",
	},
	"We're getting your payroll all setup.": {
		translation: "We're getting your payroll all setup.",
	},
	"We're glad to hear you're likely to recommend %1. What makes this place so great?":
		{
			translation:
				"We're glad to hear you're likely to recommend %1. What makes this place so great?",
		},
	"We're keeping all the data you already have, and employee enrollments won't change":
		{
			translation:
				"We're keeping all the data you already have, and employee enrollments won't change",
		},
	"We're looking forward to having \n you here at {1}.": {
		translation: "We're looking forward to having \n you here at {1}.",
	},
	"We're looking forward to having you here at {1}.": {
		translation: "We're looking forward to having you here at {1}.",
	},
	"We're now sending information about your employees to NetSuite. In the future, Bamboo will send changes as they happen to Netsuite.":
		{
			translation:
				"We're now sending information about your employees to NetSuite. In the future, Bamboo will send changes as they happen to Netsuite.",
		},
	"We're preparing your export, it should begin downloading in two shakes of a panda paw...":
		{
			translation:
				"We're preparing your export, it should begin downloading in two shakes of a panda paw...",
		},
	"We're sorry.  We were unable to obtain permission to access your RightSignature account.":
		{
			translation:
				"We're sorry.  We were unable to obtain permission to access your RightSignature account.",
		},
	"We're sorry. Our records indicate that we have no backup for that benefit plan.":
		{
			translation:
				"We're sorry. Our records indicate that we have no backup for that benefit plan.",
		},
	"We're sorry. Our records indicate that you do not have permission to recover that benefit plan.":
		{
			translation:
				"We're sorry. Our records indicate that you do not have permission to recover that benefit plan.",
		},
	"We're sorry. There was an error with your consent request. Please try again.":
		{
			translation:
				"We're sorry. There was an error with your consent request. Please try again.",
		},
	"We're sorry. We could not verify your email.": {
		translation: "We're sorry. We could not verify your email.",
	},
	"We're sorry. Your request has expired. Please try again.": {
		translation: "We're sorry. Your request has expired. Please try again.",
	},
	"We're sorry. Your request parameters are invalid. Please try again.": {
		translation:
			"We're sorry. Your request parameters are invalid. Please try again.",
	},
	"We're sorry. Your request was missing required parameters. Please try again.":
		{
			translation:
				"We're sorry. Your request was missing required parameters. Please try again.",
		},
	"We're syncing your change with Bamboo Payroll. This can sometimes take a minute or so.":
		{
			translation:
				"We're syncing your change with Bamboo Payroll. This can sometimes take a minute or so.",
		},
	"We're syncing your change with BambooHR Payroll, This can sometimes take a minute or so":
		{
			translation:
				"We're syncing your change with BambooHR Payroll, This can sometimes take a minute or so",
		},
	"We're working on it.": {
		translation: "We're working on it.",
	},
	"We've built a better-than-you're-expecting integration with TRAXPayroll to provide a seamless payroll experience that automatically syncs all of your employee and company info in real-time":
		{
			translation:
				"We've built a better-than-you're-expecting integration with TRAXPayroll to provide a seamless payroll experience that automatically syncs all of your employee and company info in real-time",
		},
	'We\'ve created a <a href="/time_tracking/import/example">template file</a> for you to use as a reference.':
		{
			translation:
				'We\'ve created a <a href="/time_tracking/import/example">template file</a> for you to use as a reference.',
		},
	"We've created a [template file](1) specifically for importing people that will be included in payroll.":
		{
			translation:
				"We've created a [template file](1) specifically for importing people that will be included in payroll.",
		},
	"We've emailed you a copy of your signed offer letter, but make sure you download copies of the documents below since they will not be emailed to you. We can't wait to have you as a part of the team!":
		{
			translation:
				"We've emailed you a copy of your signed offer letter, but make sure you download copies of the documents below since they will not be emailed to you. We can't wait to have you as a part of the team!",
		},
	"We've emailed you a copy of your signed offer letter, please get in touch with %s if you have any questions. We can't wait to have you as a part of the team!":
		{
			translation:
				"We've emailed you a copy of your signed offer letter, please get in touch with %s if you have any questions. We can't wait to have you as a part of the team!",
		},
	"We've emailed you a copy of your signed offer letter. We can't wait to have you as a part of the team!":
		{
			translation:
				"We've emailed you a copy of your signed offer letter. We can't wait to have you as a part of the team!",
		},
	"We've included some helpful information and ask that you complete this new employee packet so you can hit the ground running on your first day.":
		{
			translation:
				"We've included some helpful information and ask that you complete this new employee packet so you can hit the ground running on your first day.",
		},
	"We've made changes to our <a href='https://www.bamboohr.com/terms-of-service/'>Terms of Service</a>, By continuing to use BambooHR you agree to these changes.":
		{
			translation:
				"We've made changes to our <a href='https://www.bamboohr.com/terms-of-service/'>Terms of Service</a>, By continuing to use BambooHR you agree to these changes.",
		},
	"We've made it easy to keep your employees up-to-date in Bridge with a near real-time data integration from BambooHR . When an employee is created, updated, or deleted in BambooHR an employee will be automatically created, updated, or deleted in Bridge appropriately.":
		{
			translation:
				"We've made it easy to keep your employees up-to-date in Bridge with a near real-time data integration from BambooHR . When an employee is created, updated, or deleted in BambooHR an employee will be automatically created, updated, or deleted in Bridge appropriately.",
		},
	"We've made it super easy to import your new hires from %s.<br/> To get started, simply click Browse to find the file you exported from %s, then click Import. It's that easy!":
		{
			translation:
				"We've made it super easy to import your new hires from %s.<br/> To get started, simply click Browse to find the file you exported from %s, then click Import. It's that easy!",
		},
	"We've made some changes to how plans are organized, and it's important that we put yours in the right place. Take a couple of seconds to select the plans types below.":
		{
			translation:
				"We've made some changes to how plans are organized, and it's important that we put yours in the right place. Take a couple of seconds to select the plans types below.",
		},
	"We've sent a verification email to *{1}*. Please click the confirmation button in the email to continue.":
		{
			translation:
				"We've sent a verification email to *{1}*. Please click the confirmation button in the email to continue.",
		},
	"We've sent a verification email to:": {
		translation: "We've sent a verification email to:",
	},
	Weather: {
		translation: 'Weather',
	},
	'Web Designer': {
		translation: 'Web Designer',
	},
	'Webhook Name': {
		translation: 'Webhook Name',
	},
	'Webhook Types': {
		translation: 'Webhook Types',
	},
	'Webhook type': {
		translation: 'Webhook type',
	},
	Webhooks: {
		translation: 'Webhooks',
	},
	'Webhooks allow you to monitor changes made in BambooHR. BambooHR will watch for changes in fields you specify and post information to a URL of your choice.':
		{
			translation:
				'Webhooks allow you to monitor changes made in BambooHR. BambooHR will watch for changes in fields you specify and post information to a URL of your choice.',
		},
	'Website, Blog or Portfolio': {
		translation: 'Website, Blog or Portfolio',
	},
	'Website, Blog, Portfolio': {
		translation: 'Website, Blog, Portfolio',
	},
	'Website, Blog, Portfolio, etc.': {
		translation: 'Website, Blog, Portfolio, etc.',
	},
	'Website, Blog, or Portfolio': {
		translation: 'Website, Blog, or Portfolio',
	},
	'Website:': {
		translation: 'Website:',
	},
	Wednesday: {
		translation: 'Wednesday',
	},
	Wednesdays: {
		translation: 'Wednesdays',
	},
	Week: {
		translation: 'Week',
	},
	'Week ending': {
		translation: 'Week ending',
	},
	'Week(s)': {
		translation: 'Week(s)',
	},
	Weekends: {
		translation: 'Weekends',
	},
	Weekly: {
		translation: 'Weekly',
	},
	'Weekly (send each Monday)': {
		translation: 'Weekly (send each Monday)',
	},
	'Weekly Logins': {
		translation: 'Weekly Logins',
	},
	Weeks: {
		translation: 'Weeks',
	},
	Weight: {
		translation: 'Weight',
	},
	Welcome: {
		translation: 'Welcome',
	},
	'Welcome Aboard, %1$s': {
		translation: 'Welcome Aboard, %1$s',
	},
	'Welcome Aboard, {1}!': {
		translation: 'Welcome Aboard, {1}!',
	},
	'Welcome Back,': {
		translation: 'Welcome Back,',
	},
	'Welcome Back, Login to Continue': {
		translation: 'Welcome Back, Login to Continue',
	},
	'Welcome Back. Login to Continue': {
		translation: 'Welcome Back. Login to Continue',
	},
	'Welcome New Hires': {
		translation: 'Welcome New Hires',
	},
	'Welcome Our Newest Team Member': {
		translation: 'Welcome Our Newest Team Member',
	},
	'Welcome email has been restored to default': {
		translation: 'Welcome email has been restored to default',
	},
	'Welcome email updates have been saved': {
		translation: 'Welcome email updates have been saved',
	},
	'Welcome to ': {
		translation: 'Welcome to ',
	},
	'Welcome to %1': {
		translation: 'Welcome to %1',
	},
	'Welcome to %1$s': {
		translation: 'Welcome to %1$s',
	},
	'Welcome to Bamboo Payroll': {
		translation: 'Welcome to Bamboo Payroll',
	},
	'Welcome to the club!': {
		translation: 'Welcome to the club!',
	},
	'Welcome {1}!': {
		translation: 'Welcome {1}!',
	},
	'Welcome, %1!': {
		translation: 'Welcome, %1!',
	},
	'Welcome, %1$s': {
		translation: 'Welcome, %1$s',
	},
	'Welcome, %1$s.': {
		translation: 'Welcome, %1$s.',
	},
	"Well done! Everyone's in a Pay Group.": {
		translation: "Well done! Everyone's in a Pay Group.",
	},
	"Well this is embarrassing... I can't find that employee's information!": {
		translation:
			"Well this is embarrassing... I can't find that employee's information!",
	},
	'Well, darn.  Something went wrong while creating the PDF report.': {
		translation:
			'Well, darn.  Something went wrong while creating the PDF report.',
	},
	'Well, this is awkward.': {
		translation: 'Well, this is awkward.',
	},
	'Western States': {
		translation: 'Western States',
	},
	'We’ll go through and check for differences in employee and company data between BambooHR and TRAXPayroll and you can tell us which to keep':
		{
			translation:
				'We’ll go through and check for differences in employee and company data between BambooHR and TRAXPayroll and you can tell us which to keep',
		},
	'We’ll show you all employees in that pay schedule that are missing required info for payroll.':
		{
			translation:
				'We’ll show you all employees in that pay schedule that are missing required info for payroll.',
		},
	'We’ll show you all of the employee info changes since the last pay period.':
		{
			translation:
				'We’ll show you all of the employee info changes since the last pay period.',
		},
	'We’re Making Benefits more Beneficial': {
		translation: 'We’re Making Benefits more Beneficial',
	},
	'We’re having some trouble on our end. Please try again later.': {
		translation:
			'We’re having some trouble on our end. Please try again later.',
	},
	'We’re wiping the slate clean.': {
		translation: 'We’re wiping the slate clean.',
	},
	What: {
		translation: 'What',
	},
	'What Can People with this Access Level Do?': {
		translation: 'What Can People with this Access Level Do?',
	},
	'What Can People with this Access Level See?': {
		translation: 'What Can People with this Access Level See?',
	},
	'What People Dislike': {
		translation: 'What People Dislike',
	},
	'What People Like': {
		translation: 'What People Like',
	},
	'What You Were Paid, and What For': {
		translation: 'What You Were Paid, and What For',
	},
	'What are benefit groups?': {
		translation: 'What are benefit groups?',
	},
	'What are some things %s does well as a manager?': {
		translation: 'What are some things %s does well as a manager?',
	},
	'What are some things %s does well?': {
		translation: 'What are some things %s does well?',
	},
	'What are some things I do well?': {
		translation: 'What are some things I do well?',
	},
	'What are some things [Name] does well?': {
		translation: 'What are some things [Name] does well?',
	},
	'What are some things employees do well?': {
		translation: 'What are some things employees do well?',
	},
	'What are some things this person does well? How could they improve?': {
		translation:
			'What are some things this person does well? How could they improve?',
	},
	'What are the <span class="semibold">Total Monthly Costs</span> for this plan? (Employee + Company)':
		{
			translation:
				'What are the <span class=\\"semibold\\">Total Monthly Costs</span> for this plan? (Employee + Company)',
		},
	'What are the Total Monthly Costs for this plan? (Employee + Company cost)': {
		translation:
			'What are the Total Monthly Costs for this plan? (Employee + Company cost)',
	},
	"What are you crazy? You can't upload files on a backup.": {
		translation: "What are you crazy? You can't upload files on a backup.",
	},
	'What changes could %1 make to be a better place to work?': {
		translation: 'What changes could %1 make to be a better place to work?',
	},
	'What changes could %1 make to become a better place to work?': {
		translation: 'What changes could %1 make to become a better place to work?',
	},
	'What changes could %1$s make to be a better place to work?': {
		translation: 'What changes could %1$s make to be a better place to work?',
	},
	'What changes could %1$s make to become a better place to work?': {
		translation:
			'What changes could %1$s make to become a better place to work?',
	},
	'What coverage options are available on this plan?': {
		translation: 'What coverage options are available on this plan?',
	},
	'What data needs to be exported?': {
		translation: 'What data needs to be exported?',
	},
	'What does this customer need help with?': {
		translation: 'What does this customer need help with?',
	},
	'What exactly is a non-employee user?': {
		translation: 'What exactly is a non-employee user?',
	},
	'What fields do you want to monitor?': {
		translation: 'What fields do you want to monitor?',
	},
	'What fields do you want to post?': {
		translation: 'What fields do you want to post?',
	},
	'What format should the data be in?': {
		translation: 'What format should the data be in?',
	},
	'What is the cost per pay period': {
		translation: 'What is the cost per pay period',
	},
	"What is the employee's perceived value contribution?": {
		translation: "What is the employee's perceived value contribution?",
	},
	'What makes %1 such a great place to work?': {
		translation: 'What makes %1 such a great place to work?',
	},
	'What makes %1$s such a great place to work?': {
		translation: 'What makes %1$s such a great place to work?',
	},
	'What should move to the new profile?': {
		translation: 'What should move to the new profile?',
	},
	'What should move to the new profiles?': {
		translation: 'What should move to the new profiles?',
	},
	'What they can see:': {
		translation: 'What they can see:',
	},
	'What this Access Level Can Do': {
		translation: 'What this Access Level Can Do',
	},
	'What this Access Level Can See': {
		translation: 'What this Access Level Can See',
	},
	'What would have the greatest impact on my ability to do my best work more often?':
		{
			translation:
				'What would have the greatest impact on my ability to do my best work more often?',
		},
	'What would help me do my best work more often?': {
		translation: 'What would help me do my best work more often?',
	},
	'What would help me do my best work most often?': {
		translation: 'What would help me do my best work most often?',
	},
	"What's This For?": {
		translation: "What's This For?",
	},
	"What's happening at %1": {
		translation: "What's happening at %1",
	},
	"What's my BambooHR domain?": {
		translation: "What's my BambooHR domain?",
	},
	"What's my domain?": {
		translation: "What's my domain?",
	},
	"What's this?": {
		translation: "What's this?",
	},
	"What's wrong?": {
		translation: "What's wrong?",
	},
	When: {
		translation: 'When',
	},
	'When & Where': {
		translation: 'When & Where',
	},
	'When a candidate is hired in Newton, his or her information can be sent via the API into BambooHR and an employee record will be created automatically. This all happens with just the click of a button!':
		{
			translation:
				'When a candidate is hired in Newton, his or her information can be sent via the API into BambooHR and an employee record will be created automatically. This all happens with just the click of a button!',
		},
	'When a change is made in BambooHR, the changes are automatically sent to BeneTrac.':
		{
			translation:
				'When a change is made in BambooHR, the changes are automatically sent to BeneTrac.',
		},
	'When accruals happen': {
		translation: 'When accruals happen',
	},
	'When an applicant has been hired, this integration allows you to push the information over to BambooHR where a new employee record is created and the following data is automatically populated: First Name, Last Name, Address, City, State, Zip Code, Home Phone, Home Email, Job Title (will only sync if the title name is already an option available for selection in the drop-down field within BambooHR).':
		{
			translation:
				'When an applicant has been hired, this integration allows you to push the information over to BambooHR where a new employee record is created and the following data is automatically populated: First Name, Last Name, Address, City, State, Zip Code, Home Phone, Home Email, Job Title (will only sync if the title name is already an option available for selection in the drop-down field within BambooHR).',
		},
	'When an employee transitions from Level 1 to Level 2 during the accrual period, %1sLevel 2 accruals kick in right away.%2s':
		{
			translation:
				'When an employee transitions from Level 1 to Level 2 during the accrual period, %1sLevel 2 accruals kick in right away.%2s',
		},
	'When an employee transitions from Level 1 to Level 2 during the accrual period, *Level 2 accruals kick in right away.*':
		{
			translation:
				'When an employee transitions from Level 1 to Level 2 during the accrual period, *Level 2 accruals kick in right away.*',
		},
	'When an information update to an existing employee is made within BambooHR, we automatically compare the data between BambooHR and TraxPayroll and then send an update request which appears on the Remote Link tab. You can apply the changes to the TraxPayroll data from the main synchronization screen, or, you can click to "Edit" the information and only make selective changes. Once the changes sent over from BambooHR have been approved, the employee record within TraxPayroll will be automatically updated accordingly.':
		{
			translation:
				'When an information update to an existing employee is made within BambooHR, we automatically compare the data between BambooHR and TraxPayroll and then send an update request which appears on the Remote Link tab. You can apply the changes to the TraxPayroll data from the main synchronization screen, or, you can click to \\"Edit\\" the information and only make selective changes. Once the changes sent over from BambooHR have been approved, the employee record within TraxPayroll will be automatically updated accordingly.',
		},
	'When can people start creating goals in Bamboo?': {
		translation: 'When can people start creating goals in Bamboo?',
	},
	'When completed, the signed document will be saved to the ': {
		translation: 'When completed, the signed document will be saved to the ',
	},
	'When do new employees become eligible?': {
		translation: 'When do new employees become eligible?',
	},
	'When do you want time tracking to start?': {
		translation: 'When do you want time tracking to start?',
	},
	'When do you want to be alerted?': {
		translation: 'When do you want to be alerted?',
	},
	'When does first payroll deduction happen?': {
		translation: 'When does first payroll deduction happen?',
	},
	'When does the first payroll deduction happen?': {
		translation: 'When does the first payroll deduction happen?',
	},
	'When individual users connect their Greenhouse accounts to BambooHR, they are able to push certain data fields (Name, Email, Phone #, Start Date, Resume, Cover Letter, Offer Letter, and Job Title) to BambooHR upon marking a candidate as "Hired" in Greenhouse.':
		{
			translation:
				'When individual users connect their Greenhouse accounts to BambooHR, they are able to push certain data fields (Name, Email, Phone #, Start Date, Resume, Cover Letter, Offer Letter, and Job Title) to BambooHR upon marking a candidate as \\"Hired\\" in Greenhouse.',
		},
	'When is the first assessment due?': {
		translation: 'When is the first assessment due?',
	},
	'When it is marked manually': {
		translation: 'When it is marked manually',
	},
	'When its marked manually': {
		translation: 'When its marked manually',
	},
	'When logged into CATS, view the record of the candidate you would like to export over into BambooHR. On this overview page, click the "Log an Activity" button. Select the option for "Placed". A BambooHR checkbox will then appear to the right of the Change Status section of your window. Ensure that the box is checked, and then click the blue Save button. The employee will be marked in CATS as "Placed" and their information will be exported over to BambooHR, automatically creating a new employee record for them in the BambooHR system.':
		{
			translation:
				'When logged into CATS, view the record of the candidate you would like to export over into BambooHR. On this overview page, click the \\"Log an Activity\\" button. Select the option for \\"Placed\\". A BambooHR checkbox will then appear to the right of the Change Status section of your window. Ensure that the box is checked, and then click the blue Save button. The employee will be marked in CATS as \\"Placed\\" and their information will be exported over to BambooHR, automatically creating a new employee record for them in the BambooHR system.',
		},
	'When marking a training renewable, you must also specify frequency': {
		translation:
			'When marking a training renewable, you must also specify frequency',
	},
	'When should the data be sent?': {
		translation: 'When should the data be sent?',
	},
	'When should the first %s payroll deduction happen?': {
		translation: 'When should the first %s payroll deduction happen?',
	},
	'When should this alert be sent?': {
		translation: 'When should this alert be sent?',
	},
	'When should we prompt managers to request feedback?': {
		translation: 'When should we prompt managers to request feedback?',
	},
	'When should we prompt managers to request peer feedback?': {
		translation: 'When should we prompt managers to request peer feedback?',
	},
	'When should you have clocked out?': {
		translation: 'When should you have clocked out?',
	},
	'When synchronization is turned on, BambooHR will send changes or new employees to SwipeClock.':
		{
			translation:
				'When synchronization is turned on, BambooHR will send changes or new employees to SwipeClock.',
		},
	'When synchronization is turned on, BambooHR will send selected information about new employees or changes to existing employees to Cloud Identity.':
		{
			translation:
				'When synchronization is turned on, BambooHR will send selected information about new employees or changes to existing employees to Cloud Identity.',
		},
	'When the client would like to conduct a survey they will select the questionnaire in their system and push "Start Measuring" to send to employees synced from BambooHR. Results will be displayed on the dashboard.':
		{
			translation:
				'When the client would like to conduct a survey they will select the questionnaire in their system and push \\"Start Measuring\\" to send to employees synced from BambooHR. Results will be displayed on the dashboard.',
		},
	'When this tool is enabled, it will make the assessment due in seven days and peer feedback will begin two days from now. Additionally, the account owner will be set to the top of the Org Chart. This makes it so the account owner can understand the entire review process in a short amount of time. The company must have someone with the title of CEO for this tool to work.':
		{
			translation:
				'When this tool is enabled, it will make the assessment due in seven days and peer feedback will begin two days from now. Additionally, the account owner will be set to the top of the Org Chart. This makes it so the account owner can understand the entire review process in a short amount of time. The company must have someone with the title of CEO for this tool to work.',
		},
	'When viewing the Candidate record, click the "Hired" icon in the menu bar and enter a Start Date. Saving this change will trigger a pop-up menu where you can choose to export the employee to BambooHR (see next step). A Candidate MUST have a status of "Hired" within Newton before his or her data can be exported to BambooHR.':
		{
			translation:
				'When viewing the Candidate record, click the \\"Hired\\" icon in the menu bar and enter a Start Date. Saving this change will trigger a pop-up menu where you can choose to export the employee to BambooHR (see next step). A Candidate MUST have a status of \\"Hired\\" within Newton before his or her data can be exported to BambooHR.',
		},
	'When will these changes take effect?': {
		translation: 'When will these changes take effect?',
	},
	'When will this Benefit Group become eligible for the *{1}* plan?': {
		translation:
			'When will this Benefit Group become eligible for the *{1}* plan?',
	},
	'When will this Benefit Group become eligible for this Plan?': {
		translation: 'When will this Benefit Group become eligible for this Plan?',
	},
	'When will this tax end?': {
		translation: 'When will this tax end?',
	},
	'When would you like to share your completed assessment?': {
		translation: 'When would you like to share your completed assessment?',
	},
	'When would you like your data to be sent?': {
		translation: 'When would you like your data to be sent?',
	},
	'When you add a new employee to BambooHR, the information will be sent over to TraxPayroll for approval. Once the information has been approved, then the new employee record will be created within TraxPayroll automatically and the fields will be populated with the information received from BambooHR. You will then be taken through the new employee wizard within TraxPayroll to confirm the information. To add a new employee in this manner, view the Remote Link Tab within TraxPayroll and click the "Add New" link on the Employee Synchronization Tab.':
		{
			translation:
				'When you add a new employee to BambooHR, the information will be sent over to TraxPayroll for approval. Once the information has been approved, then the new employee record will be created within TraxPayroll automatically and the fields will be populated with the information received from BambooHR. You will then be taken through the new employee wizard within TraxPayroll to confirm the information. To add a new employee in this manner, view the Remote Link Tab within TraxPayroll and click the \\"Add New\\" link on the Employee Synchronization Tab.',
		},
	'When you add the plan, we will ask you when employees in this Group will become eligible, as well as the employee cost for each coverage option.':
		{
			translation:
				'When you add the plan, we will ask you when employees in this Group will become eligible, as well as the employee cost for each coverage option.',
		},
	'When you cancel group setup you will lose any information that you have entered for this group.':
		{
			translation:
				'When you cancel group setup you will lose any information that you have entered for this group.',
		},
	'When you cancel import setup you will lose any information that you have entered.':
		{
			translation:
				'When you cancel import setup you will lose any information that you have entered.',
		},
	'When you cancel plan setup you will lose any information that you have entered for this plan.':
		{
			translation:
				'When you cancel plan setup you will lose any information that you have entered for this plan.',
		},
	'When you cancel plan setup, you will lose any information that you have entered for this plan.':
		{
			translation:
				'When you cancel plan setup, you will lose any information that you have entered for this plan.',
		},
	'When you choose another template your progress on the current offer will be lost.':
		{
			translation:
				'When you choose another template your progress on the current offer will be lost.',
		},
	"When you export to BambooHR, the following fields will be moved over and a new employee record will be created in BambooHR. You will be able to link directly into the new employee's record within BambooHR to enter additional information about the employee.":
		{
			translation:
				"When you export to BambooHR, the following fields will be moved over and a new employee record will be created in BambooHR. You will be able to link directly into the new employee's record within BambooHR to enter additional information about the employee.",
		},
	Where: {
		translation: 'Where',
	},
	'Where are we, Venus? Please enter 24 hours or fewer.': {
		translation: 'Where are we, Venus? Please enter 24 hours or fewer.',
	},
	'Where do we send garnishment payments?': {
		translation: 'Where do we send garnishment payments?',
	},
	'Where should the data be posted?': {
		translation: 'Where should the data be posted?',
	},
	'Where will you post/share this link?': {
		translation: 'Where will you post/share this link?',
	},
	"Whether to transfer the customer's data to a different data center.": {
		translation:
			"Whether to transfer the customer's data to a different data center.",
	},
	"Whether you're a small to medium-sized business owner with payroll processing, tax filing or HR management needs, or an accounting professional looking for the best payroll service for your clients, we have a comprehensive and affordable payroll solution for you.":
		{
			translation:
				"Whether you're a small to medium-sized business owner with payroll processing, tax filing or HR management needs, or an accounting professional looking for the best payroll service for your clients, we have a comprehensive and affordable payroll solution for you.",
		},
	'Which Access Level should apply?': {
		translation: 'Which Access Level should apply?',
	},
	'Which Employee Access Level should Payroll Admins have?': {
		translation: 'Which Employee Access Level should Payroll Admins have?',
	},
	'Which Fridays?': {
		translation: 'Which Fridays?',
	},
	'Which Mondays?': {
		translation: 'Which Mondays?',
	},
	'Which Saturdays?': {
		translation: 'Which Saturdays?',
	},
	'Which Sundays?': {
		translation: 'Which Sundays?',
	},
	'Which Thursdays?': {
		translation: 'Which Thursdays?',
	},
	'Which Tuesdays?': {
		translation: 'Which Tuesdays?',
	},
	'Which Wednesdays?': {
		translation: 'Which Wednesdays?',
	},
	'Which countries would you like to copy standard holidays from?': {
		translation:
			'Which countries would you like to copy standard holidays from?',
	},
	'Which employee did you mean?': {
		translation: 'Which employee did you mean?',
	},
	'Which employees are eligible?': {
		translation: 'Which employees are eligible?',
	},
	'Which employees would you like to edit benefits for?': {
		translation: 'Which employees would you like to edit benefits for?',
	},
	'Which employees would you like to include in this Benefit Group?': {
		translation:
			'Which employees would you like to include in this Benefit Group?',
	},
	'Which employees would you like to make changes for?': {
		translation: 'Which employees would you like to make changes for?',
	},
	'Which features would you like to include in performance management?': {
		translation:
			'Which features would you like to include in performance management?',
	},
	'Which fields do you want to send to Cloud Identity?': {
		translation: 'Which fields do you want to send to Cloud Identity?',
	},
	'Which fields do you want to send to JumpCloud?': {
		translation: 'Which fields do you want to send to JumpCloud?',
	},
	'Which holidays pay at the holiday rate?': {
		translation: 'Which holidays pay at the holiday rate?',
	},
	'Which managers you are starting Peer Feedback for?': {
		translation: 'Which managers are you starting Peer Feedback for?',
	},
	'Which peer feedback review periods do you want to delete?': {
		translation: 'Which peer feedback review periods do you want to delete?',
	},
	'Which review periods do you want to delete?': {
		translation: 'Which review periods do you want to delete?',
	},
	'Which type of plan would you like to add?': {
		translation: 'Which type of plan would you like to add?',
	},
	'Which types are collected and paid by TRAX Payroll?': {
		translation: 'Which types are collected and paid by TRAX Payroll?',
	},
	'Which types are collected and paid by TRAXPayroll?': {
		translation: 'Which types are collected and paid by TRAXPayroll?',
	},
	White: {
		translation: 'White',
	},
	'Who can approve information updates for an employee?': {
		translation: 'Who can approve information updates for an employee?',
	},
	'Who can approve requests for an employee?': {
		translation: 'Who can approve requests for an employee?',
	},
	'Who can approve these requests?': {
		translation: 'Who can approve these requests?',
	},
	'Who can approve time off requests for an employee?': {
		translation: 'Who can approve time off requests for an employee?',
	},
	'Who can log time to this project?': {
		translation: 'Who can log time to this project?',
	},
	'Who can make this type of request?': {
		translation: 'Who can make this type of request?',
	},
	'Who can view Applicants': {
		translation: 'Who can view Applicants',
	},
	'Who can view candidates?': {
		translation: 'Who can view candidates?',
	},
	'Who else will be out?': {
		translation: 'Who else will be out?',
	},
	'Who has access': {
		translation: 'Who has access',
	},
	'Who needs to complete this?': {
		translation: 'Who needs to complete this?',
	},
	'Who referred you for this position?': {
		translation: 'Who referred you for this position?',
	},
	'Who to Contact': {
		translation: 'Who to Contact',
	},
	'Who will approve employee timesheets?': {
		translation: 'Who will approve employee timesheets?',
	},
	'Who will be participating in performance management?': {
		translation: 'Who will be participating in performance management?',
	},
	'Who will receive the export?': {
		translation: 'Who will receive the export?',
	},
	'Who would you like to add to %1$s?': {
		translation: 'Who would you like to add to %1$s?',
	},
	'Who would you like to make a Full Admin?': {
		translation: 'Who would you like to make a Full Admin?',
	},
	'Who would you like to make a Payroll Admin?': {
		translation: 'Who would you like to make a Payroll Admin?',
	},
	"Who's Out": {
		translation: "Who's Out",
	},
	"Who's in charge here? In order to view the org chart, make sure your top level doesn't report to anyone else.":
		{
			translation:
				"Who's in charge here? In order to view the org chart, make sure your top level doesn't report to anyone else.",
		},
	"Who's out": {
		translation: "Who's out",
	},
	'Whoa . . . some people will have 5 or more peer feedback requests.': {
		translation:
			'Whoa . . . some people will have 5 or more peer feedback requests.',
	},
	'Whoa, This Could Have Consequences...': {
		translation: 'Whoa, This Could Have Consequences...',
	},
	'Whoa, something changed': {
		translation: 'Whoa, something changed',
	},
	'Whoa, this is a big file (a little too big). The maximum file size you can upload is 20 MB.':
		{
			translation:
				'Whoa, this is a big file (a little too big). The maximum file size you can upload is 20 MB.',
		},
	'Whoa. Try entering time like %s or 1:30.': {
		translation: 'Whoa. Try entering time like %s or 1:30.',
	},
	'Whoa... {1} will have 5 or more feedback requests.': {
		translation: 'Whoa... {1} will have 5 or more feedback requests.',
	},
	Whoops: {
		translation: 'Whoops',
	},
	"Whoops!  It looks like we weren't able to do what you wanted.": {
		translation:
			"Whoops!  It looks like we weren't able to do what you wanted.",
	},
	'Whoops! Address line is required.': {
		translation: 'Whoops! Address line is required.',
	},
	'Whoops! Answers are required.': {
		translation: 'Whoops! Answers are required.',
	},
	'Whoops! City is required.': {
		translation: 'Whoops! City is required.',
	},
	'Whoops! College is required.': {
		translation: 'Whoops! College is required.',
	},
	'Whoops! Cover letter is required. Try uploading the cover letter.': {
		translation:
			'Whoops! Cover letter is required. Try uploading the cover letter.',
	},
	'Whoops! Date Available is required.': {
		translation: 'Whoops! Date Available is required.',
	},
	'Whoops! Desired Salary is required.': {
		translation: 'Whoops! Desired Salary is required.',
	},
	'Whoops! Email is required.': {
		translation: 'Whoops! Email is required.',
	},
	'Whoops! First Name is required.': {
		translation: 'Whoops! First Name is required.',
	},
	'Whoops! Highest Education is required.': {
		translation: 'Whoops! Highest Education is required.',
	},
	'Whoops! Last Name is required.': {
		translation: 'Whoops! Last Name is required.',
	},
	'Whoops! Linkedin URL is required.': {
		translation: 'Whoops! Linkedin URL is required.',
	},
	'Whoops! Looks like something went wrong on our side. Sorry about that. Give it another shot?':
		{
			translation:
				'Whoops! Looks like something went wrong on our side. Sorry about that. Give it another shot?',
		},
	'Whoops! Looks like the org chart tool is not enabled for your organization. Check with the administrator at your organization.':
		{
			translation:
				'Whoops! Looks like the org chart tool is not enabled for your organization. Check with the administrator at your organization.',
		},
	"Whoops! Looks like you don't have access to the org chart. Check with the administrator at your organization.":
		{
			translation:
				"Whoops! Looks like you don't have access to the org chart. Check with the administrator at your organization.",
		},
	'Whoops! Pay rate must be greater than 0.': {
		translation: 'Whoops! Pay rate must be greater than 0.',
	},
	'Whoops! Phone is required.': {
		translation: 'Whoops! Phone is required.',
	},
	'Whoops! Postal / Zip is required.': {
		translation: 'Whoops! Postal / Zip is required.',
	},
	'Whoops! References are required.': {
		translation: 'Whoops! References are required.',
	},
	'Whoops! Referred By is required.': {
		translation: 'Whoops! Referred By is required.',
	},
	'Whoops! Resume is required. Try uploading the resume.': {
		translation: 'Whoops! Resume is required. Try uploading the resume.',
	},
	'Whoops! Some important information is missing.': {
		translation: 'Whoops! Some important information is missing.',
	},
	'Whoops! Something went wrong trying to get this resource.': {
		translation: 'Whoops! Something went wrong trying to get this resource.',
	},
	'Whoops! State / Province is required.': {
		translation: 'Whoops! State / Province is required.',
	},
	'Whoops! That email is already being used. Please try another.': {
		translation:
			'Whoops! That email is already being used. Please try another.',
	},
	'Whoops! The pay rate must be in USD.': {
		translation: 'Whoops! The pay rate must be in USD.',
	},
	'Whoops! Twitter Username is required.': {
		translation: 'Whoops! Twitter Username is required.',
	},
	"Whoops! We couldn't find some information for the requested template.": {
		translation:
			"Whoops! We couldn't find some information for the requested template.",
	},
	'Whoops! Website URL is required.': {
		translation: 'Whoops! Website URL is required.',
	},
	'Whoops! You already have a task by that name.': {
		translation: 'Whoops! You already have a task by that name.',
	},
	'Whoops, something on our side prevented your file from uploading. Please give it another try.':
		{
			translation:
				'Whoops, something on our side prevented your file from uploading. Please give it another try.',
		},
	'Whoops, this task requires a file to be uploaded to it before it can be completed.':
		{
			translation:
				'Whoops, this task requires a file to be uploaded to it before it can be completed.',
		},
	'Whoops, try to keep it under 128 characters': {
		translation: 'Whoops, try to keep it under 128 characters',
	},
	'Whoops, try to keep it under 128 characters.': {
		translation: 'Whoops, try to keep it under 128 characters.',
	},
	'Whoops... A field is stretched past the edge of the page.': {
		translation: 'Whoops... A field is stretched past the edge of the page.',
	},
	'Whoops... All passport fields are required!': {
		translation: 'Whoops... All passport fields are required!',
	},
	'Whoops... At least one change is required before you can continue.': {
		translation:
			'Whoops... At least one change is required before you can continue.',
	},
	'Whoops... Before moving on you need to select which specific person you would like.':
		{
			translation:
				'Whoops... Before moving on you need to select which specific person you would like.',
		},
	"Whoops... It looks like you haven't correctly filled out a date field.": {
		translation:
			"Whoops... It looks like you haven't correctly filled out a date field.",
	},
	"Whoops... It looks like you haven't correctly filled out all of the fields.":
		{
			translation:
				"Whoops... It looks like you haven't correctly filled out all of the fields.",
		},
	"Whoops... It looks like you haven't filled out all of the required fields.":
		{
			translation:
				"Whoops... It looks like you haven't filled out all of the required fields.",
		},
	'Whoops... No worries.  Job Description is a required field.  Please enter a description.':
		{
			translation:
				'Whoops... No worries.  Job Description is a required field.  Please enter a description.',
		},
	'Whoops... No worries. Please complete all required fields and try again.': {
		translation:
			'Whoops... No worries. Please complete all required fields and try again.',
	},
	'Whoops... No worries. Please fix any missing or incorrect information and try again.':
		{
			translation:
				'Whoops... No worries. Please fix any missing or incorrect information and try again.',
		},
	'Whoops... No worries. Please make sure each garnishment has a Remittance ID, and try again.':
		{
			translation:
				'Whoops... No worries. Please make sure each garnishment has a Remittance ID, and try again.',
		},
	'Whoops... No worries. Please make sure each garnishment has a payee selected, and try again.':
		{
			translation:
				'Whoops... No worries. Please make sure each garnishment has a payee selected, and try again.',
		},
	'Whoops... Please enter a valid birthdate.': {
		translation: 'Whoops... Please enter a valid birthdate.',
	},
	'Whoops... Please enter a valid hire date. Hire date is required for employee eligibility verification.':
		{
			translation:
				'Whoops... Please enter a valid hire date. Hire date is required for employee eligibility verification.',
		},
	'Whoops... Please enter a valid hire date. Hire date is required for employee verification.':
		{
			translation:
				'Whoops... Please enter a valid hire date. Hire date is required for employee verification.',
		},
	'Whoops... Please enter a valid zip code.': {
		translation: 'Whoops... Please enter a valid zip code.',
	},
	'Whoops... Please enter at least one email address. Email address is required for employee eligibility verification.':
		{
			translation:
				'Whoops... Please enter at least one email address. Email address is required for employee eligibility verification.',
		},
	'Whoops... Please fix the first name.': {
		translation: 'Whoops... Please fix the first name.',
	},
	'Whoops... Please fix the last name.': {
		translation: 'Whoops... Please fix the last name.',
	},
	'Whoops... Please select a valid country!': {
		translation: 'Whoops... Please select a valid country!',
	},
	"Whoops... Something doesn't look quite right. Please double check your date.":
		{
			translation:
				"Whoops... Something doesn't look quite right. Please double check your date.",
		},
	'Whoops... The Effective Date cannot be before the Plan Start Date.': {
		translation:
			'Whoops... The Effective Date cannot be before the Plan Start Date.',
	},
	'Whoops... The expiration date must be a valid date!': {
		translation: 'Whoops... The expiration date must be a valid date!',
	},
	'Whoops... The issued date must be a valid date!': {
		translation: 'Whoops... The issued date must be a valid date!',
	},
	'Whoops... The issued date must be before the expiration date!': {
		translation:
			'Whoops... The issued date must be before the expiration date!',
	},
	'Whoops... The last four digits of the credit card number cannot exceed four characters!':
		{
			translation:
				'Whoops... The last four digits of the credit card number cannot exceed four characters!',
		},
	'Whoops... The passport number must be less than 20 characters!': {
		translation:
			'Whoops... The passport number must be less than 20 characters!',
	},
	'Whoops... There was a problem adding the new option.': {
		translation: 'Whoops... There was a problem adding the new option.',
	},
	'Whoops... There was a problem previewing the Application.': {
		translation: 'Whoops... There was a problem previewing the Application.',
	},
	'Whoops... There was a problem rehiring %1%2%3!': {
		translation: 'Whoops... There was a problem rehiring %1%2%3!',
	},
	'Whoops... There was a problem trying to remove this advanced approval path.':
		{
			translation:
				'Whoops... There was a problem trying to remove this advanced approval path.',
		},
	'Whoops... There was a problem trying to remove this advanced approval.': {
		translation:
			'Whoops... There was a problem trying to remove this advanced approval.',
	},
	'Whoops... There was a problem trying to save this advanced approval.': {
		translation:
			'Whoops... There was a problem trying to save this advanced approval.',
	},
	'Whoops... There was a problem trying to save your changes. Please try again.':
		{
			translation:
				'Whoops... There was a problem trying to save your changes. Please try again.',
		},
	'Whoops... There were some errors with your form. Please fix the highlighted fields.':
		{
			translation:
				'Whoops... There were some errors with your form. Please fix the highlighted fields.',
		},
	"Whoops... We don't accept blank names.": {
		translation: "Whoops... We don't accept blank names.",
	},
	"Whoops... We don't accept empty names.": {
		translation: "Whoops... We don't accept empty names.",
	},
	"Whoops... We don't accept names for list values that contain the | symbol.":
		{
			translation:
				"Whoops... We don't accept names for list values that contain the | symbol.",
		},
	"Whoops... We don't accept names for list values that look like HTML.": {
		translation:
			"Whoops... We don't accept names for list values that look like HTML.",
	},
	'Whoops... You must select at least one filter item per category.': {
		translation:
			'Whoops... You must select at least one filter item per category.',
	},
	'Whoops... You need to add at least one field for the primary employee to complete.':
		{
			translation:
				'Whoops... You need to add at least one field for the primary employee to complete.',
		},
	'Whoops... You need to add at least one field.': {
		translation: 'Whoops... You need to add at least one field.',
	},
	'Whoops... Your Goal is missing a Due Date. Please add a due date and try again.':
		{
			translation:
				'Whoops... Your Goal is missing a Due Date. Please add a due date and try again.',
		},
	'Whoops... Your Goal is missing a Name. Please add a name and try again.': {
		translation:
			'Whoops... Your Goal is missing a Name. Please add a name and try again.',
	},
	'Whoops... Your goal is missing a due date. Please add a due date and try again.':
		{
			translation:
				'Whoops... Your goal is missing a due date. Please add a due date and try again.',
		},
	'Whoops... Your goal is missing a name. Please add a name and try again.': {
		translation:
			'Whoops... Your goal is missing a name. Please add a name and try again.',
	},
	'Whoops... something went wrong. Please try again.': {
		translation: 'Whoops... something went wrong. Please try again.',
	},
	"Whoops... tasks with signature documents can't be added while an employee is inactive or has no access. Please adjust the task or status and try again.":
		{
			translation:
				"Whoops... tasks with signature documents can't be added while an employee is inactive or has no access. Please adjust the task or status and try again.",
		},
	"Whoops... we couldn't remove this item for you": {
		translation: "Whoops... we couldn't remove this item for you",
	},
	'Whoops...no worries. Please make sure the phone number below has 10 digits.':
		{
			translation:
				'Whoops...no worries. Please make sure the phone number below has 10 digits.',
		},
	'Whoops...please fill out all required fields and try again.': {
		translation: 'Whoops...please fill out all required fields and try again.',
	},
	'Whoops...please make sure your file is a PDF': {
		translation: 'Whoops...please make sure your file is a PDF',
	},
	'Whoops...something went wrong adding a deduction name. Please try again later.':
		{
			translation:
				'Whoops...something went wrong adding a deduction name. Please try again later.',
		},
	'Whoops...something went wrong deleting this deduction name. Please try again.':
		{
			translation:
				'Whoops...something went wrong deleting this deduction name. Please try again.',
		},
	'Whoops...something went wrong editing the deduction name. Please try again later.':
		{
			translation:
				'Whoops...something went wrong editing the deduction name. Please try again later.',
		},
	'Whoops...something went wrong reactivating this deduction name. Please try again.':
		{
			translation:
				'Whoops...something went wrong reactivating this deduction name. Please try again.',
		},
	'Whoops...something went wrong. Please try again.': {
		translation: 'Whoops...something went wrong. Please try again.',
	},
	'Why are you moving %s?': {
		translation: 'Why are you moving %s?',
	},
	'Why are you moving these candidates?': {
		translation: 'Why are you moving these candidates?',
	},
	'Why are you moving {1}?': {
		translation: 'Why are you moving {1}?',
	},
	"Why can't I change this?": {
		translation: "Why can't I change this?",
	},
	"Why can't I select some types?": {
		translation: "Why can't I select some types?",
	},
	'Widget Container': {
		translation: 'Widget Container',
	},
	Wife: {
		translation: 'Wife',
	},
	'Will be eligible for %s on %s': {
		translation: 'Will be eligible for %s on %s',
	},
	'Will be eligible on %s': {
		translation: 'Will be eligible on %s',
	},
	'Will be enrolled in %s on %s': {
		translation: 'Will be enrolled in %s on %s',
	},
	'Will be enrolled on %s': {
		translation: 'Will be enrolled on %s',
	},
	'Will be ineligible for %s on %s': {
		translation: 'Will be ineligible for %s on %s',
	},
	'Will be ineligible on %s': {
		translation: 'Will be ineligible on %s',
	},
	'Will be sent for approval on %s': {
		translation: 'Will be sent for approval on %s',
	},
	'Will be sent to all employees on %1%2%3.': {
		translation: 'Will be sent to all employees on %1%2%3.',
	},
	'Will be terminated on %s': {
		translation: 'Will be terminated on %s',
	},
	'Will be updated on %s': {
		translation: 'Will be updated on %s',
	},
	'Will be waived on %s': {
		translation: 'Will be waived on %s',
	},
	'Will be withdrawn on %s': {
		translation: 'Will be withdrawn on %s',
	},
	'Will only appear for employees included in payroll.': {
		translation: 'Will only appear for employees included in payroll.',
	},
	'Will only apply for employees included in payroll.': {
		translation: 'Will only apply for employees included in payroll.',
	},
	'Windows Live Messenger': {
		translation: 'Windows Live Messenger',
	},
	'Wire Transfer': {
		translation: 'Wire Transfer',
	},
	"Wish %s well. I'll be able to find a better replacement pretty easily.": {
		translation:
			"Wish %s well. I'll be able to find a better replacement pretty easily.",
	},
	"Wish them well. We'd be able to find a better replacement pretty easily.": {
		translation:
			"Wish [Name] well. I'll be able to find a better replacement pretty easily.",
	},
	'With Bitium, companies can manage all of their apps and users in one centralized place.  Features include single sign-on, simple provisioning of apps to new employees for faster onboarding and offboarding, visibility into employee app usage, collaboration with coworkers inside of apps, and lots more. Admins can sync users from BambooHR directly into Bitium, and Bitium also integrates with authentication systems like Active Directory, LDAP, or Google Apps. Get valuable insight into the security of corporate passwords and can protect company accounts with SAML integration, audit logs, IP whitelisting, and other security features.':
		{
			translation:
				'With Bitium, companies can manage all of their apps and users in one centralized place.  Features include single sign-on, simple provisioning of apps to new employees for faster onboarding and offboarding, visibility into employee app usage, collaboration with coworkers inside of apps, and lots more. Admins can sync users from BambooHR directly into Bitium, and Bitium also integrates with authentication systems like Active Directory, LDAP, or Google Apps. Get valuable insight into the security of corporate passwords and can protect company accounts with SAML integration, audit logs, IP whitelisting, and other security features.',
		},
	'With JumpCloud SCIM Provisioning installed, BambooHR will send selected information about new employees or changes to existing employees to JumpCloud.':
		{
			translation:
				'With JumpCloud SCIM Provisioning installed, BambooHR will send selected information about new employees or changes to existing employees to JumpCloud.',
		},
	'With great power comes great responsibility. Please review carefully to ensure that these are the updates you want.':
		{
			translation:
				'With great power comes great responsibility. Please review carefully to ensure that these are the updates you want.',
		},
	'With our E-Signatures, you can get forms to your employees in seconds while tracking their progress until completion by running a report to determine which documents are signed and which are still pending.':
		{
			translation:
				'With our E-Signatures, you can get forms to your employees in seconds while tracking their progress until completion by running a report to determine which documents are signed and which are still pending.',
		},
	'With the Boomr integration enabled, customers will be able to choose which employees from BambooHR will sync into Boomr by either creating new employees in Boomr, or matching them to existing employees in Boomr. The integration keeps those matched employees updated from BambooHR on a daily basis ensuring that any new hires, terminations, or changes in BambooHR to any synced fields will be updated in Boomr. Employees use Boomr on their own smartphone or tablet to securely track when and where they are working. Boomr will then provide real-time reports of hours worked for employees that are matched between Boomr and BambooHR.':
		{
			translation:
				'With the Boomr integration enabled, customers will be able to choose which employees from BambooHR will sync into Boomr by either creating new employees in Boomr, or matching them to existing employees in Boomr. The integration keeps those matched employees updated from BambooHR on a daily basis ensuring that any new hires, terminations, or changes in BambooHR to any synced fields will be updated in Boomr. Employees use Boomr on their own smartphone or tablet to securely track when and where they are working. Boomr will then provide real-time reports of hours worked for employees that are matched between Boomr and BambooHR.',
		},
	'With the addition of %1$sBenefit Groups%2$s you can easily assign people to different benefit packages.':
		{
			translation:
				'With the addition of %1$sBenefit Groups%2$s you can easily assign people to different benefit packages.',
		},
	Withdraw: {
		translation: 'Withdraw',
	},
	'Withdrawal Date': {
		translation: 'Withdrawal Date',
	},
	'Withdrawal Effective': {
		translation: 'Withdrawal Effective',
	},
	'Withdrawal entered on %1$s and set to withdrawal date of %2$s': {
		translation:
			'Withdrawal entered on %1$s and set to withdrawal date of %2$s',
	},
	'Withdrawal from %1$s coverage effective.': {
		translation: 'Withdrawal from %1$s coverage effective.',
	},
	'Withdrawal from %1$s entered on %2$s and set to withdrawal date of %3$s.': {
		translation:
			'Withdrawal from %1$s entered on %2$s and set to withdrawal date of %3$s.',
	},
	'Withdrawal from Employee Pays %1$s and Company Pays %2$s effective.': {
		translation:
			'Withdrawal from Employee Pays %1$s and Company Pays %2$s effective.',
	},
	'Withdrawn from %s': {
		translation: 'Withdrawn from %s',
	},
	'Withdrawn from %s on %s': {
		translation: 'Withdrawn from %s on %s',
	},
	Withdrew: {
		translation: 'Withdrew',
	},
	Withholding: {
		translation: 'Withholding',
	},
	'Wondering how your eNPS compares?': {
		translation: 'Wondering how your eNPS compares?',
	},
	Work: {
		translation: 'Work',
	},
	'Work #': {
		translation: 'Work #',
	},
	'Work Email': {
		translation: 'Work Email',
	},
	'Work Email is required': {
		translation: 'Work Email is required',
	},
	'Work Email must be a valid email and unique': {
		translation: 'Work Email must be a valid email and unique',
	},
	'Work Email or Home Email': {
		translation: 'Work Email or Home Email',
	},
	'Work Ext': {
		translation: 'Work Ext',
	},
	'Work Ext.': {
		translation: 'Work Ext.',
	},
	'Work In': {
		translation: 'Work In',
	},
	'Work In Tax State': {
		translation: 'Work In Tax State',
	},
	'Work In Tax Unemployment State': {
		translation: 'Work In Tax Unemployment State',
	},
	'Work Location': {
		translation: 'Work Location',
	},
	'Work Phone': {
		translation: 'Work Phone',
	},
	'Work Quality': {
		translation: 'Work Quality',
	},
	'Work Tax State': {
		translation: 'Work Tax State',
	},
	'Work cell': {
		translation: 'Work cell',
	},
	'Work email is invalid': {
		translation: 'Work email is invalid',
	},
	'Work hours in a day need to be between 1 and 24': {
		translation: 'Work hours in a day need to be between 1 and 24',
	},
	'Work phone + ext.': {
		translation: 'Work phone + ext.',
	},
	'Work that better fits my strengths.': {
		translation: 'Work that better fits my strengths.',
	},
	'Work week starts on...': {
		translation: 'Work week starts on...',
	},
	'Worked Holidays': {
		translation: 'Worked Holidays',
	},
	"Worker's Comp": {
		translation: "Worker's Comp",
	},
	"Workers' Comp": {
		translation: "Workers' Comp",
	},
	"Workers' Comp Classification": {
		translation: "Workers' Comp Classification",
	},
	'Workflow settings update encountered an error.': {
		translation: 'Workflow settings update encountered an error.',
	},
	'Workflow settings updated.': {
		translation: 'Workflow settings updated.',
	},
	Workflows: {
		translation: 'Workflows',
	},
	'Working from home during COVID-19': {
		translation: 'Working from home during COVID-19',
	},
	'Works more than 30 hrs per week': {
		translation: 'Works more than 30 hrs per week',
	},
	'Works two jobs or spouse works?': {
		translation: 'Works two jobs or spouse works?',
	},
	'Workspace Admin stuff...': {
		translation: 'Workspace Admin stuff...',
	},
	'Would you like to reactivate %1$s?': {
		translation: 'Would you like to reactivate %1$s?',
	},
	'Write is used to add items to lists': {
		translation: 'Write is used to add items to lists',
	},
	Writer: {
		translation: 'Writer',
	},
	YTD: {
		translation: 'YTD',
	},
	'YTD Net': {
		translation: 'YTD Net',
	},
	Year: {
		translation: 'Year',
	},
	'Year to Date': {
		translation: 'Year to Date',
	},
	'Year to date': {
		translation: 'Year to date',
	},
	'Year to date, as of ': {
		translation: 'Year to date, as of ',
	},
	'Year-to-Date': {
		translation: 'Year-to-Date',
	},
	'Year-to-date': {
		translation: 'Year-to-date',
	},
	'Year:': {
		translation: 'Year:',
	},
	Yearly: {
		translation: 'Yearly',
	},
	Years: {
		translation: 'Years',
	},
	'Years Experience': {
		translation: 'Years Experience',
	},
	'Years of Service': {
		translation: 'Years of Service',
	},
	'Years of Service Report': {
		translation: 'Years of Service Report',
	},
	Yes: {
		translation: 'Yes',
	},
	'Yes ': {
		translation: 'Yes ',
	},
	'Yes (Most common)': {
		translation: 'Yes (Most common)',
	},
	'Yes (most common)': {
		translation: 'Yes (most common)',
	},
	'Yes / No': {
		translation: 'Yes / No',
	},
	'Yes, %s Answers': {
		translation: 'Yes, %s Answers',
	},
	'Yes, Allow Access': {
		translation: 'Yes, Allow Access',
	},
	'Yes, Approve All Hours': {
		translation: 'Yes, Approve All Hours',
	},
	'Yes, Cancel': {
		translation: 'Yes, Cancel',
	},
	'Yes, Cancel Offer %1': {
		translation: 'Yes, Cancel Offer %1',
	},
	'Yes, Cancel Offer Setup': {
		translation: 'Yes, Cancel Offer Setup',
	},
	'Yes, Cancel Request': {
		translation: 'Yes, Cancel Request',
	},
	'Yes, Cancel Setup': {
		translation: 'Yes, Cancel Setup',
	},
	'Yes, Cancel Signature Request': {
		translation: 'Yes, Cancel Signature Request',
	},
	'Yes, Change Date': {
		translation: 'Yes, Change Date',
	},
	'Yes, Change My Access Level': {
		translation: 'Yes, Change My Access Level',
	},
	'Yes, Change Permissions': {
		translation: 'Yes, Change Permissions',
	},
	'Yes, Clear Data': {
		translation: 'Yes, Clear Data',
	},
	'Yes, Continue': {
		translation: 'Yes, Continue',
	},
	'Yes, Delete %s': {
		translation: 'Yes, Delete %s',
	},
	'Yes, Delete All': {
		translation: 'Yes, Delete All',
	},
	'Yes, Delete Comment': {
		translation: 'Yes, Delete Comment',
	},
	'Yes, Delete Contact': {
		translation: 'Yes, Delete Contact',
	},
	'Yes, Delete Dependent': {
		translation: 'Yes, Delete Dependent',
	},
	'Yes, Delete Direct Deposit': {
		translation: 'Yes, Delete Direct Deposit',
	},
	'Yes, Delete Education': {
		translation: 'Yes, Delete Education',
	},
	'Yes, Delete Entry': {
		translation: 'Yes, Delete Entry',
	},
	'Yes, Delete Event': {
		translation: 'Yes, Delete Event',
	},
	'Yes, Delete Folder': {
		translation: 'Yes, Delete Folder',
	},
	'Yes, Delete Group': {
		translation: 'Yes, Delete Group',
	},
	'Yes, Delete Peer Feedback': {
		translation: 'Yes, Delete Peer Feedback',
	},
	'Yes, Delete Plan': {
		translation: 'Yes, Delete Plan',
	},
	'Yes, Delete Rating': {
		translation: 'Yes, Delete Rating',
	},
	'Yes, Delete Reports': {
		translation: 'Yes, Delete Reports',
	},
	'Yes, Delete Review Periods': {
		translation: 'Yes, Delete Review Periods',
	},
	'Yes, Delete Status': {
		translation: 'Yes, Delete Status',
	},
	'Yes, Delete This': {
		translation: 'Yes, Delete This',
	},
	'Yes, Delete This Item': {
		translation: 'Yes, Delete This Item',
	},
	'Yes, Delete it': {
		translation: 'Yes, Delete it',
	},
	'Yes, Delete this Employee': {
		translation: 'Yes, Delete this Employee',
	},
	'Yes, Disable ACA': {
		translation: 'Yes, Disable ACA',
	},
	'Yes, Disable It': {
		translation: 'Yes, Disable It',
	},
	'Yes, Disable Link': {
		translation: 'Yes, Disable Link',
	},
	'Yes, Disable Time Tracking': {
		translation: 'Yes, Disable Time Tracking',
	},
	'Yes, Enable Time Tracking': {
		translation: 'Yes, Enable Time Tracking',
	},
	'Yes, End Plan': {
		translation: 'Yes, End Plan',
	},
	'Yes, Exit Form': {
		translation: 'Yes, Exit Form',
	},
	'Yes, Exit Setup': {
		translation: 'Yes, Exit Setup',
	},
	'Yes, I have a disability (or previously had a disability)': {
		translation: 'Yes, I have a disability (or previously had a disability)',
	},
	'Yes, I want to run a special termination payroll in order to pay the employee their last check on the spot.':
		{
			translation:
				'Yes, I want to run a special termination payroll in order to pay the employee their last check on the spot.',
		},
	'Yes, Reactivate Plan': {
		translation: 'Yes, Reactivate Plan',
	},
	'Yes, Remove Coverage': {
		translation: 'Yes, Remove Coverage',
	},
	'Yes, Remove Document': {
		translation: 'Yes, Remove Document',
	},
	'Yes, Remove Plan': {
		translation: 'Yes, Remove Plan',
	},
	'Yes, Remove User': {
		translation: 'Yes, Remove User',
	},
	'Yes, Request These Dates': {
		translation: 'Yes, Request These Dates',
	},
	'Yes, Rerun': {
		translation: 'Yes, Rerun',
	},
	'Yes, Reset Tracking': {
		translation: 'Yes, Reset Tracking',
	},
	'Yes, Save Schedule': {
		translation: 'Yes, Save Schedule',
	},
	'Yes, Save Start Date': {
		translation: 'Yes, Save Start Date',
	},
	'Yes, Send Request': {
		translation: 'Yes, Send Request',
	},
	'Yes, Setup Trial': {
		translation: 'Yes, Setup Trial',
	},
	'Yes, Start Feedback': {
		translation: 'Yes, Start Feedback',
	},
	'Yes, Start Peer Feedback': {
		translation: 'Yes, Start Peer Feedback',
	},
	'Yes, Take Company Offline': {
		translation: 'Yes, Take Company Offline',
	},
	'Yes, This is Correct': {
		translation: 'Yes, This is Correct',
	},
	'Yes, Uninstall This': {
		translation: 'Yes, Uninstall This',
	},
	'Yes, Upload The File': {
		translation: 'Yes, Upload The File',
	},
	'Yes, disable it': {
		translation: 'Yes, disable it',
	},
	'Yes, overwrite my changes': {
		translation: 'Yes, overwrite my changes',
	},
	'Yes, reportable': {
		translation: 'Yes, reportable',
	},
	'Yes, send email': {
		translation: 'Yes, send email',
	},
	'Yes, turn off eNPS': {
		translation: 'Yes, turn off eNPS',
	},
	'Yes, we do': {
		translation: 'Yes, we do',
	},
	"Yes. We'd still like to see how it works.": {
		translation: "Yes. We'd still like to see how it works.",
	},
	Yesterday: {
		translation: 'Yesterday',
	},
	'Yesterday at': {
		translation: 'Yesterday at',
	},
	'Yesterday at %1$s': {
		translation: 'Yesterday at %1$s',
	},
	Yoink: {
		translation: 'Yoink',
	},
	You: {
		translation: 'You',
	},
	'You Approved!': {
		translation: 'You Approved!',
	},
	'You Attached': {
		translation: 'You Attached',
	},
	'You Currently Have no Company Files in BambooHR': {
		translation: 'You Currently Have no Company Files in BambooHR',
	},
	"You Didn't Pay Any Taxes On": {
		translation: "You Didn't Pay Any Taxes On",
	},
	"You Didn't Pay Any Taxes On:": {
		translation: "You Didn't Pay Any Taxes On:",
	},
	'You Paid Taxes On': {
		translation: 'You Paid Taxes On',
	},
	'You Paid Taxes On:': {
		translation: 'You Paid Taxes On:',
	},
	'You Pay': {
		translation: 'You Pay',
	},
	'You accrue %s %s %s': {
		translation: 'You accrue %s %s %s',
	},
	'You already answered %1 to this, but you can change it if you’d like. ': {
		translation:
			'You already answered %1 to this, but you can change it if you’d like. ',
	},
	'You already signed that document.': {
		translation: 'You already signed that document.',
	},
	'You answer a couple of questions that help define where you recruit talent from (or lose them to!), like what industry you’re in and where a role is located.':
		{
			translation:
				'You answer a couple of questions that help define where you recruit talent from (or lose them to!), like what industry you’re in and where a role is located.',
		},
	'You answer a few detailed questions about the role, like years of experience, any specific required skills or certifications, whether there are management responsibilities, etc.':
		{
			translation:
				'You answer a few detailed questions about the role, like years of experience, any specific required skills or certifications, whether there are management responsibilities, etc.',
		},
	'You approved this at %1$s': {
		translation: 'You approved this at %1$s',
	},
	'You approved this at %1$s (%2$s day ago)': {
		translation: {
			one: 'You approved this at %1$s (%2$s day ago)',
			other: 'You approved this at %1$s (%2$s days ago)',
		},
	},
	'You approved this at %1$s (%2$s hour ago)': {
		translation: {
			one: 'You approved this at %1$s (%2$s hour ago)',
			other: 'You approved this at %1$s (%2$s hours ago)',
		},
	},
	'You approved this on %1$s': {
		translation: 'You approved this on %1$s',
	},
	'You are about to delete all assessments and peer feedback for the following review periods:':
		{
			translation:
				'You are about to delete all assessments and peer feedback for the following review periods:',
		},
	'You are about to delete peer feedback for the following review periods:': {
		translation:
			'You are about to delete peer feedback for the following review periods:',
	},
	'You are about to set the payroll deduction schedule for all benefit plans.':
		{
			translation:
				'You are about to set the payroll deduction schedule for all benefit plans.',
		},
	'You are about to set the payroll deduction schedule for these benefit plan types:':
		{
			translation:
				'You are about to set the payroll deduction schedule for these benefit plan types:',
		},
	'You are currently previewing as another User. Refresh this page or discontinue previewing on another open tab':
		{
			translation:
				'You are currently previewing as another User. Refresh this page or discontinue previewing on another open tab',
		},
	'You are enrolled in %1$s benefit plan': {
		translation: {
			one: 'You are enrolled in %1$s benefit plan',
			other: 'You are enrolled in %1$s benefit plans',
		},
	},
	'You are granting access to run payroll, approve timesheets, and update payroll-related employee information for all employees.':
		{
			translation:
				'You are granting access to run payroll, approve timesheets, and update payroll-related employee information for all employees.',
		},
	'You are logged in on behalf of another user.': {
		translation: 'You are logged in on behalf of another user.',
	},
	'You are logged into %1$s on behalf of %2$s.': {
		translation: 'You are logged into %1$s on behalf of %2$s.',
	},
	'You are logged into %1$s.': {
		translation: 'You are logged into %1$s.',
	},
	'You are missing the following required fields: ': {
		translation: 'You are missing the following required fields: ',
	},
	'You are not allowed to modify this folder': {
		translation: 'You are not allowed to modify this folder',
	},
	'You are not allowed to upload a file of this type: ': {
		translation: 'You are not allowed to upload a file of this type: ',
	},
	'You are not authorized to access this service.': {
		translation: 'You are not authorized to access this service.',
	},
	'You are not currently authorized to use the BambooHR app': {
		translation: 'You are not currently authorized to use the BambooHR app',
	},
	'You are not permitted to issue this request.': {
		translation: 'You are not permitted to issue this request.',
	},
	'You are not yet authorized for the BambooHR app:': {
		translation: 'You are not yet authorized for the BambooHR app:',
	},
	'You are now authorized for the BambooHR app!': {
		translation: 'You are now authorized for the BambooHR app!',
	},
	'You are now enabling a Slack integration with Ask BambooHR. You will need to have enabled our AI features prior to having access to our AI features through Slack.':
		{
			translation:
				'You are now enabling a Slack integration with Ask BambooHR. You will need to have enabled our AI features prior to having access to our AI features through Slack.',
		},
	'You are now logged in to the BambooHR Chrome Extension!': {
		translation: 'You are now logged in to the BambooHR Chrome Extension!',
	},
	'You are now logged out.': {
		translation: 'You are now logged out.',
	},
	'You are requesting time off for %1$s%2$s%3$s to %1$s%4$s.%3$s%5$s Please select new dates.':
		{
			translation:
				'You are requesting time off for %1$s%2$s%3$s to %1$s%4$s.%3$s%5$s Please select new dates.',
		},
	'You are requesting time off for %1$s%2$s%3$s to %4$s%5$s%6$s.': {
		translation:
			'You are requesting time off for %1$s%2$s%3$s to %4$s%5$s%6$s.',
	},
	'You are responsible for verifying tax IDs, pay frequencies, and rate are correct':
		{
			translation:
				'You are responsible for verifying tax IDs, pay frequencies, and rate are correct',
		},
	'You are responsible for verifying that tax IDs, pay frequencies, and rates are correct':
		{
			translation:
				'You are responsible for verifying that tax IDs, pay frequencies, and rates are correct',
		},
	'You are starting Peer Feedback for these managers:': {
		translation: 'You are starting Peer Feedback for these managers:',
	},
	'You are using %s of your %s available open job openings.': {
		translation: 'You are using %s of your %s available open job openings.',
	},
	'You assigned an offboarding task for %1$s to %2$s.': {
		translation: 'You assigned an offboarding task for %1$s to %2$s.',
	},
	'You assigned an offboarding task to %1$s.': {
		translation: 'You assigned an offboarding task to %1$s.',
	},
	'You assigned an onboarding task for %1$s to %2$s.': {
		translation: 'You assigned an onboarding task for %1$s to %2$s.',
	},
	'You assigned an onboarding task to %1$s.': {
		translation: 'You assigned an onboarding task to %1$s.',
	},
	"You can access your company's HR site at:": {
		translation: "You can access your company's HR site at:",
	},
	'You can add a maximum of 10 custom tags in order to maintain the accuracy of the eNPS report.':
		{
			translation:
				'You can add a maximum of 10 custom tags in order to maintain the accuracy of the eNPS report.',
		},
	'You can add an email address for %s to begin exchanging emails here.': {
		translation:
			'You can add an email address for %s to begin exchanging emails here.',
	},
	'You can add this user to multiple access levels': {
		translation: 'You can add this user to multiple access levels',
	},
	'You can also check out the [deductions summary report]': {
		translation: 'You can also check out the [deductions summary report]',
	},
	'You can also email us at <a href="mailto:support@bamboohr.com">support@bamboohr.com</a> or call 1-866-387-9595.':
		{
			translation:
				'You can also email us at <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a> or call 1-866-387-9595.',
		},
	'You can also give each third party application their own access key.': {
		translation:
			'You can also give each third party application their own access key.',
	},
	'You can also read our support documentation for this integration by clicking the link below.':
		{
			translation:
				'You can also read our support documentation for this integration by clicking the link below.',
		},
	'You can always download and view it on your computer.': {
		translation: 'You can always download and view it on your computer.',
	},
	'You can carry over up to %s %s': {
		translation: 'You can carry over up to %s %s',
	},
	'You can change this anytime in Settings >> Employee Fields >> Employment Status.':
		{
			translation:
				'You can change this anytime in Settings >> Employee Fields >> Employment Status.',
		},
	'You can change your filter for the next review period %1here%2.': {
		translation:
			'You can change your filter for the next review period %1here%2.',
	},
	'You can choose to %1 them again any time before %2 starts (%3).': {
		translation:
			'You can choose to %1 them again any time before %2 starts (%3).',
	},
	'You can choose to auto-post this job to other job sites.': {
		translation: 'You can choose to auto-post this job to other job sites.',
	},
	'You can choose to group results by a specific field (this is optional).': {
		translation:
			'You can choose to group results by a specific field (this is optional).',
	},
	'You can close this and continue on with you day': {
		translation: 'You can close this and continue on with you day',
	},
	'You can continue and make another request, but we just wanted to let you know.':
		{
			translation:
				'You can continue and make another request, but we just wanted to let you know.',
		},
	'You can continue to use this policy as is. However, to edit this policy you must <br/>select when accruals happen for all Accrual Levels by selecting it here.':
		{
			translation:
				'You can continue to use this policy as is. However, to edit this policy you must <br/>select when accruals happen for all Accrual Levels by selecting it here.',
		},
	'You can create another packet up to 14 days after the hire date.': {
		translation:
			'You can create another packet up to 14 days after the hire date.',
	},
	'You can do that later.': {
		translation: 'You can do that later.',
	},
	'You can download them in just a moment.': {
		translation: 'You can download them in just a moment.',
	},
	'You can download your': {
		translation: 'You can download your',
	},
	'You can either:': {
		translation: 'You can either:',
	},
	"You can even enter future dates and we'll use our time machine to calculate projected balances.":
		{
			translation:
				"You can even enter future dates and we'll use our time machine to calculate projected balances.",
		},
	'You can have multiple API keys associated with a user at the same time.': {
		translation:
			'You can have multiple API keys associated with a user at the same time.',
	},
	"You can hide these answers if there's something here that you'd prefer not be shared.":
		{
			translation:
				"You can hide these answers if there's something here that you'd prefer not be shared.",
		},
	'You can insert these into the email and they will be replaced with the actual values when the email is sent.':
		{
			translation:
				'You can insert these into the email and they will be replaced with the actual values when the email is sent.',
		},
	'You can insert these into the template and they will be replaced with the actual values when the offer letter is created.':
		{
			translation:
				'You can insert these into the template and they will be replaced with the actual values when the offer letter is created.',
		},
	'You can insert these into the template and they will be replaced with the actual values when the offer letter is sent.':
		{
			translation:
				'You can insert these into the template and they will be replaced with the actual values when the offer letter is sent.',
		},
	'You can leave a comment if you would like to.': {
		translation: 'You can leave a comment if you would like to.',
	},
	'You can leave a comment on it if you would like to.': {
		translation: 'You can leave a comment on it if you would like to.',
	},
	'You can look forward to a more straightforward and intuitive way to manage benefits, including:':
		{
			translation:
				'You can look forward to a more straightforward and intuitive way to manage benefits, including:',
		},
	"You can look through the scheduled alert dates below and change any dates that don't match up with your company's pay dates.":
		{
			translation:
				"You can look through the scheduled alert dates below and change any dates that don't match up with your company's pay dates.",
		},
	'You can move on to the next step.': {
		translation: 'You can move on to the next step.',
	},
	'You can not assign an employee with an invalid SSN to this pay schedule': {
		translation:
			'You can not assign an employee with an invalid SSN to this pay schedule',
	},
	'You can not assign an employee with an invalid or empty SSN to this pay schedule':
		{
			translation:
				'You can not assign an employee with an invalid or empty SSN to this pay schedule',
		},
	'You can not change the deduction type ID of a benefit plan if people are currently enrolled in the benefit plan.':
		{
			translation:
				'You can not change the deduction type ID of a benefit plan if people are currently enrolled in the benefit plan.',
		},
	'You can not delete some of these reports': {
		translation: 'You can not delete some of these reports',
	},
	'You can not manage these reports': {
		translation: 'You can not manage these reports',
	},
	'You can not set Safe Harbor to true for this deduction Type ID.': {
		translation:
			'You can not set Safe Harbor to true for this deduction Type ID.',
	},
	'You can not set both the benefitPlanId or the deductionCode property': {
		translation:
			'You can not set both the benefitPlanId or the deductionCode property',
	},
	'You can not set both the benefitPlanId or the memoCode property': {
		translation:
			'You can not set both the benefitPlanId or the memoCode property',
	},
	'You can not update a benefit group via the importer if the employee is part of a benefit group.':
		{
			translation:
				'You can not update a benefit group via the importer if the employee is part of a benefit group.',
		},
	'You can not update a benefit group via the importer.': {
		translation: 'You can not update a benefit group via the importer.',
	},
	'You can now continue to the Bamboo Help Center.': {
		translation: 'You can now continue to the Bamboo Help Center.',
	},
	'You can now request signatures.': {
		translation: 'You can now request signatures.',
	},
	'You can only delete a Payroll Admin access level through this method for now':
		{
			translation:
				'You can only delete a Payroll Admin access level through this method for now',
		},
	'You can only have four direct deposit accounts': {
		translation: 'You can only have four direct deposit accounts',
	},
	'You can only have four direct deposit accounts.': {
		translation: 'You can only have four direct deposit accounts.',
	},
	'You can opt out at any time in the Employee Satisfaction (eNPS) Settings page.':
		{
			translation:
				'You can opt out at any time in the Employee Satisfaction (eNPS) Settings page.',
		},
	'You can request feedback up until {1}.': {
		translation: 'You can request feedback up until {1}.',
	},
	'You can request signatures from the Files tab': {
		translation: 'You can request signatures from the Files tab',
	},
	'You can review all your benefit information in [benefit settings].': {
		translation:
			'You can review all your benefit information in [benefit settings].',
	},
	'You can review the answers and choose to show them again any time before the hire date from the [Onboarding Tab].':
		{
			translation:
				'You can review the answers and choose to show them again any time before the hire date from the [Onboarding Tab].',
		},
	'You can review the answers and choose to show them again anytime before the hire date from the':
		{
			translation:
				'You can review the answers and choose to show them again anytime before the hire date from the',
		},
	"You can select a pay schedule by editing the compensation information on this employee's Job tab.":
		{
			translation:
				"You can select a pay schedule by editing the compensation information on this employee's Job tab.",
		},
	'You can set different approval paths by location, division, or department.':
		{
			translation:
				'You can set different approval paths by location, division, or department.',
		},
	'You can set this to "None" if you want to only track time used (e.g. Flexible/Unlimited, Jury Duty, etc.) or “Manually Updated Balance” if you don\'t want this time off type to automatically accrue.':
		{
			translation:
				'You can set this to \\"None\\" if you want to only track time used (e.g. Flexible/Unlimited, Jury Duty, etc.) or “Manually Updated Balance” if you don\'t want this time off type to automatically accrue.',
		},
	"You can set this to “None” if you want to only track time used (e.g. Flexible/Unlimited, Jury Duty, etc.) or “Manually Updated Balance” if you don't want this time off type to automatically accrue.":
		{
			translation:
				"You can set this to “None” if you want to only track time used (e.g. Flexible/Unlimited, Jury Duty, etc.) or “Manually Updated Balance” if you don't want this time off type to automatically accrue.",
		},
	'You can set up templates of any documents you wish employees to sign in RightSignature. In BambooHR you can send those documents out through the Action button on an employee profile, the Action button in a report or from the RightSignature section in the Tools tab.':
		{
			translation:
				'You can set up templates of any documents you wish employees to sign in RightSignature. In BambooHR you can send those documents out through the Action button on an employee profile, the Action button in a report or from the RightSignature section in the Tools tab.',
		},
	'You can set up this alert to be sent out on the same day as your payroll.': {
		translation:
			'You can set up this alert to be sent out on the same day as your payroll.',
	},
	'You can share web sites with other employees. These links will show up on the BambooHR Home if enabled for that group. Click and drag links to set the order.':
		{
			translation:
				'You can share web sites with other employees. These links will show up on the BambooHR Home if enabled for that group. Click and drag links to set the order.',
		},
	'You can then set the sync frequency with Jobber, and whether or not employees may be removed from Jobber when they become inactive in BambooHR':
		{
			translation:
				'You can then set the sync frequency with Jobber, and whether or not employees may be removed from Jobber when they become inactive in BambooHR',
		},
	'You can use the direct deposit importer tool if you have a lot of employees to update (get in touch with your payroll implementation rep to learn more about this)':
		{
			translation:
				'You can use the direct deposit importer tool if you have a lot of employees to update (get in touch with your payroll implementation rep to learn more about this)',
		},
	"You can't Bamboo Login or Login As to Company.": {
		translation: "You can't Bamboo Login or Login As to Company.",
	},
	"You can't be clocked in because your timesheet has already been approved.": {
		translation:
			"You can't be clocked in because your timesheet has already been approved.",
	},
	"You can't be clocked in right now": {
		translation: "You can't be clocked in right now",
	},
	"You can't change the New or Hired row.": {
		translation: "You can't change the New or Hired row.",
	},
	"You can't clock in in the future.": {
		translation: "You can't clock in in the future.",
	},
	"You can't disable time tracking while previewing as another user.": {
		translation:
			"You can't disable time tracking while previewing as another user.",
	},
	"You can't do that": {
		translation: "You can't do that",
	},
	"You can't do that while previewing as another user": {
		translation: "You can't do that while previewing as another user",
	},
	"You can't do that while previewing as someone else": {
		translation: "You can't do that while previewing as someone else",
	},
	"You can't do this while previewing.": {
		translation: "You can't do this while previewing.",
	},
	"You can't edit pay schedule fields when it is included in payroll.": {
		translation:
			"You can't edit pay schedule fields when it is included in payroll.",
	},
	"You can't edit pay schedule fields when tied to 1 or more employees.": {
		translation:
			"You can't edit pay schedule fields when tied to 1 or more employees.",
	},
	"You can't edit pay schedule fields when tied to time tracking data.": {
		translation:
			"You can't edit pay schedule fields when tied to time tracking data.",
	},
	"You can't edit the original codes and rates. [Add new codes and rates here].":
		{
			translation:
				"You can't edit the original codes and rates. [Add new codes and rates here].",
		},
	"You can't enable time tracking while previewing as another user.": {
		translation:
			"You can't enable time tracking while previewing as another user.",
	},
	"You can't include the type in payroll while it's inactive": {
		translation: "You can't include the type in payroll while it's inactive",
	},
	"You can't perform that action on a future timesheet.": {
		translation: "You can't perform that action on a future timesheet.",
	},
	"You can't remove the New or Hired row.": {
		translation: "You can't remove the New or Hired row.",
	},
	"You can't request more than 10 years off.": {
		translation: "You can't request more than 10 years off.",
	},
	"You can't send Employee Satisfaction surveys in the trial account of BambooHR.":
		{
			translation:
				"You can't send Employee Satisfaction surveys in the trial account of BambooHR.",
		},
	"You can't upload any more files because you are over your plan's storage limit. Get in touch your BambooHR administrator for help.":
		{
			translation:
				"You can't upload any more files because you are over your plan's storage limit. Get in touch your BambooHR administrator for help.",
		},
	"You can't upload files on a backup.": {
		translation: "You can't upload files on a backup.",
	},
	"You can't view the report because Peer Feedback isn't enabled.": {
		translation:
			"You can't view the report because Peer Feedback isn't enabled.",
	},
	"You can't view the report because Performance Assessments aren't enabled.": {
		translation:
			"You can't view the report because Performance Assessments aren't enabled.",
	},
	"You can't view the report because Performance Management (including Goals) isn't enabled.":
		{
			translation:
				"You can't view the report because Performance Management (including Goals) isn't enabled.",
		},
	"You can't view the report because Performance Management isn't enabled.": {
		translation:
			"You can't view the report because Performance Management isn't enabled.",
	},
	"You can't view the report because feedback isn't enabled.": {
		translation: "You can't view the report because feedback isn't enabled.",
	},
	'You canceled this document.': {
		translation: 'You canceled this document.',
	},
	'You cannot add more than %1$s types in payroll': {
		translation: 'You cannot add more than %1$s types in payroll',
	},
	'You cannot assign policies while previewing.': {
		translation: 'You cannot assign policies while previewing.',
	},
	'You cannot change this location to remote until you adjust the location on the job opening(s).':
		{
			translation:
				'You cannot change this location to remote until you adjust the location on the job opening(s).',
		},
	'You cannot delete all pay schedules. You are required to have at least one pay schedule.':
		{
			translation:
				'You cannot delete all pay schedules. You are required to have at least one pay schedule.',
		},
	'You cannot delete an admin access level': {
		translation: 'You cannot delete an admin access level',
	},
	'You cannot delete the owner.': {
		translation: 'You cannot delete the owner.',
	},
	'You cannot disable the owner': {
		translation: 'You cannot disable the owner',
	},
	'You cannot disable yourself': {
		translation: 'You cannot disable yourself',
	},
	'You cannot duplicate an admin access level': {
		translation: 'You cannot duplicate an admin access level',
	},
	'You cannot edit this field with your current permissions.': {
		translation: 'You cannot edit this field with your current permissions.',
	},
	'You cannot exclude this pay schedule from payroll -- you must delete it and create a new one instead.':
		{
			translation:
				'You cannot exclude this pay schedule from payroll -- you must delete it and create a new one instead.',
		},
	'You cannot include this pay schedule in payroll.': {
		translation: 'You cannot include this pay schedule in payroll.',
	},
	'You cannot log hours when previewing as another user.': {
		translation: 'You cannot log hours when previewing as another user.',
	},
	'You cannot login to this company. As a Reseller Admin you must login from the reseller administrator portal.':
		{
			translation:
				'You cannot login to this company. As a Reseller Admin you must login from the reseller administrator portal.',
		},
	'You cannot move this folder into the selected folder': {
		translation: 'You cannot move this folder into the selected folder',
	},
	'You cannot preview a support admin.': {
		translation: 'You cannot preview a support admin.',
	},
	'You cannot restore some of these files from this employee profile.': {
		translation:
			'You cannot restore some of these files from this employee profile.',
	},
	'You cannot set ID when adding a list_value item.': {
		translation: 'You cannot set ID when adding a list_value item.',
	},
	'You cannot write more then %1 characters!': {
		translation: 'You cannot write more then %1 characters!',
	},
	'You can’t edit the original tax rate. [Add a new rate here.]': {
		translation: 'You can’t edit the original tax rate. [Add a new rate here.]',
	},
	'You can’t edit these options because this pay schedule is included in payroll, otherwise things would get messy.':
		{
			translation:
				'You can’t edit these options because this pay schedule is included in payroll, otherwise things would get messy.',
		},
	'You can’t edit these options because this pay schedule is included in time tracking tracking, otherwise things would get messy.':
		{
			translation:
				'You can’t edit these options because this pay schedule is included in time tracking, otherwise things would get messy.',
		},
	'You can’t edit these options because this pay schedule is included in time tracking, otherwise things would get messy.':
		{
			translation:
				'You can’t edit these options because this pay schedule is included in time tracking, otherwise things would get messy.',
		},
	'You can’t edit these options because this pay schedule is used by at least one employee, otherwise things would get messy.':
		{
			translation:
				'You can’t edit these options because this pay schedule is used by at least one employee, otherwise things would get messy.',
		},
	'You can’t edit this info because this pay schedule is associated to time tracking data, otherwise things would get messy.':
		{
			translation:
				'You can’t edit this info because this pay schedule is associated to time tracking data, otherwise things would get messy.',
		},
	'You can’t edit this info because this pay schedule is currently applied to at least one employee and things would get messy.':
		{
			translation:
				'You can’t edit this info because this pay schedule is currently applied to at least one employee and things would get messy.',
		},
	'You chose not to sign this document.': {
		translation: 'You chose not to sign this document.',
	},
	'You commit to wiring the above amount within 2-3 business days. Our wire information will be provided after your approval.':
		{
			translation:
				'You commit to wiring the above amount within 2-3 business days. Our wire information will be provided after your approval.',
		},
	'You completed this at %1$s': {
		translation: 'You completed this at %1$s',
	},
	'You completed this at %1$s (%2$s day ago)': {
		translation: {
			one: 'You completed this at %1$s (%2$s day ago)',
			other: 'You completed this at %1$s (%2$s days ago)',
		},
	},
	'You completed this at %1$s (%2$s hour ago)': {
		translation: {
			one: 'You completed this at %1$s (%2$s hour ago)',
			other: 'You completed this at %1$s (%2$s hours ago)',
		},
	},
	'You completed this on %1$s': {
		translation: 'You completed this on %1$s',
	},
	'You denied this at %1$s': {
		translation: 'You denied this at %1$s',
	},
	'You denied this at %1$s (%2$s day ago)': {
		translation: {
			one: 'You denied this at %1$s (%2$s day ago)',
			other: 'You denied this at %1$s (%2$s days ago)',
		},
	},
	'You denied this at %1$s (%2$s hour ago)': {
		translation: {
			one: 'You denied this at %1$s (%2$s hour ago)',
			other: 'You denied this at %1$s (%2$s hours ago)',
		},
	},
	'You denied this on %1$s': {
		translation: 'You denied this on %1$s',
	},
	'You do not have access to `%1$s`.': {
		translation: 'You do not have access to `%1$s`.',
	},
	'You do not have access to add or update users': {
		translation: 'You do not have access to add or update users',
	},
	'You do not have access to create a report': {
		translation: 'You do not have access to create a report',
	},
	'You do not have access to custom access levels': {
		translation: 'You do not have access to custom access levels',
	},
	'You do not have access to edit or create reports. Please contact your account admin with questions.':
		{
			translation:
				'You do not have access to edit or create reports. Please contact your account admin with questions.',
		},
	'You do not have access to getting user data': {
		translation: 'You do not have access to getting user data',
	},
	'You do not have access to reporting': {
		translation: 'You do not have access to reporting',
	},
	'You do not have access to that field.': {
		translation: 'You do not have access to that field.',
	},
	'You do not have access to that resource': {
		translation: 'You do not have access to that resource',
	},
	'You do not have access to the given report': {
		translation: 'You do not have access to the given report',
	},
	"You do not have access to this employee's files": {
		translation: "You do not have access to this employee's files",
	},
	'You do not have access to training categories': {
		translation: 'You do not have access to training categories',
	},
	'You do not have access to training file data': {
		translation: 'You do not have access to training file data',
	},
	'You do not have access to training file section data': {
		translation: 'You do not have access to training file section data',
	},
	'You do not have access to view files in this section for this employee': {
		translation:
			'You do not have access to view files in this section for this employee',
	},
	'You do not have access.': {
		translation: 'You do not have access.',
	},
	'You do not have custom access levels enabled for your company.': {
		translation:
			'You do not have custom access levels enabled for your company.',
	},
	'You do not have permission for that resource': {
		translation: 'You do not have permission for that resource',
	},
	'You do not have permission for uploading files': {
		translation: 'You do not have permission for uploading files',
	},
	'You do not have permission to SSO to this Outside URL': {
		translation: 'You do not have permission to SSO to this Outside URL',
	},
	'You do not have permission to access the specified training type': {
		translation:
			'You do not have permission to access the specified training type',
	},
	'You do not have permission to access this resource.': {
		translation: 'You do not have permission to access this resource.',
	},
	'You do not have permission to access webhooks': {
		translation: 'You do not have permission to access webhooks',
	},
	'You do not have permission to add a new user': {
		translation: 'You do not have permission to add a new user',
	},
	'You do not have permission to assign feedback for this employee.': {
		translation:
			'You do not have permission to assign feedback for this employee.',
	},
	'You do not have permission to attach that file.': {
		translation: 'You do not have permission to attach that file.',
	},
	'You do not have permission to change "%1$s"': {
		translation: 'You do not have permission to change \\"%1$s\\"',
	},
	'You do not have permission to complete this goal.': {
		translation: 'You do not have permission to complete this goal.',
	},
	'You do not have permission to complete this task.': {
		translation: 'You do not have permission to complete this task.',
	},
	'You do not have permission to complete this training': {
		translation: 'You do not have permission to complete this training',
	},
	'You do not have permission to delete a file.': {
		translation: 'You do not have permission to delete a file.',
	},
	'You do not have permission to delete that file.': {
		translation: 'You do not have permission to delete that file.',
	},
	'You do not have permission to delete this access level': {
		translation: 'You do not have permission to delete this access level',
	},
	'You do not have permission to delete this access levels': {
		translation: 'You do not have permission to delete this access levels',
	},
	'You do not have permission to delete this report.': {
		translation: 'You do not have permission to delete this report.',
	},
	'You do not have permission to delete this training': {
		translation: 'You do not have permission to delete this training',
	},
	'You do not have permission to delete this training.': {
		translation: 'You do not have permission to delete this training.',
	},
	'You do not have permission to delete this user.': {
		translation: 'You do not have permission to delete this user.',
	},
	'You do not have permission to do that.': {
		translation: 'You do not have permission to do that.',
	},
	'You do not have permission to do this!': {
		translation: 'You do not have permission to do this!',
	},
	'You do not have permission to duplicate access levels': {
		translation: 'You do not have permission to duplicate access levels',
	},
	"You do not have permission to edit this goal's file attachments.": {
		translation:
			"You do not have permission to edit this goal's file attachments.",
	},
	'You do not have permission to edit this goal.': {
		translation: 'You do not have permission to edit this goal.',
	},
	'You do not have permission to edit this training.': {
		translation: 'You do not have permission to edit this training.',
	},
	'You do not have permission to edit this!': {
		translation: 'You do not have permission to edit this!',
	},
	'You do not have permission to import into time tracking.': {
		translation: 'You do not have permission to import into time tracking.',
	},
	'You do not have permission to manage errors': {
		translation: 'You do not have permission to manage errors',
	},
	'You do not have permission to manage the employee tab.': {
		translation: 'You do not have permission to manage the employee tab.',
	},
	'You do not have permission to preview other users': {
		translation: 'You do not have permission to preview other users',
	},
	"You do not have permission to reset this user's password.": {
		translation: "You do not have permission to reset this user's password.",
	},
	'You do not have permission to see this resource.': {
		translation: 'You do not have permission to see this resource.',
	},
	'You do not have permission to see/generate summarized feedback.': {
		translation:
			'You do not have permission to see/generate summarized feedback.',
	},
	'You do not have permission to silence errors': {
		translation: 'You do not have permission to silence errors',
	},
	'You do not have permission to submit this assessment.': {
		translation: 'You do not have permission to submit this assessment.',
	},
	'You do not have permission to terminate this employee': {
		translation: 'You do not have permission to terminate this employee',
	},
	'You do not have permission to update this webhook': {
		translation: 'You do not have permission to update this webhook',
	},
	'You do not have permission to update user': {
		translation: 'You do not have permission to update user',
	},
	'You do not have permission to upload employee documents': {
		translation: 'You do not have permission to upload employee documents',
	},
	'You do not have permission to validate LinkedIn locations.': {
		translation: 'You do not have permission to validate LinkedIn locations.',
	},
	'You do not have permission to view cascading goal options.': {
		translation: 'You do not have permission to view cascading goal options.',
	},
	'You do not have permission to view company training settings': {
		translation: 'You do not have permission to view company training settings',
	},
	'You do not have permission to view errors': {
		translation: 'You do not have permission to view errors',
	},
	'You do not have permission to view some or all of the fields in this report.':
		{
			translation:
				'You do not have permission to view some or all of the fields in this report.',
		},
	'You do not have permission to view some or all of the fields in this report.<br/> (':
		{
			translation:
				'You do not have permission to view some or all of the fields in this report.<br/> (',
		},
	'You do not have permission to view that': {
		translation: 'You do not have permission to view that',
	},
	'You do not have permission to view this esignature document': {
		translation: 'You do not have permission to view this esignature document',
	},
	'You do not have permission to view this esignature document.': {
		translation: 'You do not have permission to view this esignature document.',
	},
	'You do not have permission to view this goal.': {
		translation: 'You do not have permission to view this goal.',
	},
	'You do not have permission to view this page.': {
		translation: 'You do not have permission to view this page.',
	},
	'You do not have permission to view this training.': {
		translation: 'You do not have permission to view this training.',
	},
	'You do not have permission to view training types': {
		translation: 'You do not have permission to view training types',
	},
	'You do not have permission to view training types.': {
		translation: 'You do not have permission to view training types.',
	},
	'You do not have permission to view trainings.': {
		translation: 'You do not have permission to view trainings.',
	},
	'You do not have permission.': {
		translation: 'You do not have permission.',
	},
	'You do not have permissions': {
		translation: 'You do not have permissions',
	},
	'You do not have permissions to add a base level folder': {
		translation: 'You do not have permissions to add a base level folder',
	},
	'You do not have permissions to delete this Job Opening since one or more candidates have an attempted offer letter.':
		{
			translation:
				'You do not have permissions to delete this Job Opening since one or more candidates have an attempted offer letter.',
		},
	'You do not have permissions to delete this Job Opening.': {
		translation: 'You do not have permissions to delete this Job Opening.',
	},
	'You do not have permissions to edit the folder': {
		translation: 'You do not have permissions to edit the folder',
	},
	'You do not have permissions to edit these files': {
		translation: 'You do not have permissions to edit these files',
	},
	'You do not have permissions to modify a default folder': {
		translation: 'You do not have permissions to modify a default folder',
	},
	'You do not have permissions to move this folder': {
		translation: 'You do not have permissions to move this folder',
	},
	'You do not have sufficient permissions for this': {
		translation: 'You do not have sufficient permissions for this',
	},
	'You do not have the Small Improvements tool enabled to be able to view this report':
		{
			translation:
				'You do not have the Small Improvements tool enabled to be able to view this report',
		},
	'You do not have the necessary permission to handle this report.': {
		translation:
			'You do not have the necessary permission to handle this report.',
	},
	'You do not have the necessary permissions': {
		translation: 'You do not have the necessary permissions',
	},
	'You do not have the necessary permissions to access data benchmarking agreements.':
		{
			translation:
				'You do not have the necessary permissions to access data benchmarking agreements.',
		},
	'You do not have the necessary permissions to delete reports': {
		translation: 'You do not have the necessary permissions to delete reports',
	},
	'You do not have the necessary permissions to make changes to the specified report folder.':
		{
			translation:
				'You do not have the necessary permissions to make changes to the specified report folder.',
		},
	'You do not have the necessary permissions to view the specified report folder.':
		{
			translation:
				'You do not have the necessary permissions to view the specified report folder.',
		},
	'You do not have the necessary permissions.': {
		translation: 'You do not have the necessary permissions.',
	},
	"You don't currently have any active time off types.": {
		translation: "You don't currently have any active time off types.",
	},
	"You don't currently have any benefit groups that match this pay schedule. If you continue, this employee will not have any benefits applied":
		{
			translation:
				"You don't currently have any benefit groups that match this pay schedule. If you continue, this employee will not have any benefits applied",
		},
	"You don't currently have any trainings.": {
		translation: "You don't currently have any trainings.",
	},
	"You don't currently have anything on this tab.": {
		translation: "You don't currently have anything on this tab.",
	},
	"You don't have access to benefit settings, so there's nothing we can show you. Sorry!":
		{
			translation:
				"You don't have access to benefit settings, so there's nothing we can show you. Sorry!",
		},
	"You don't have access to custom approvals": {
		translation: "You don't have access to custom approvals",
	},
	"You don't have access to edit this report.": {
		translation: "You don't have access to edit this report.",
	},
	"You don't have access to manage sharing for this report.": {
		translation: "You don't have access to manage sharing for this report.",
	},
	"You don't have access to manage sharing for this report. (psst...Are you previewing as another user?)":
		{
			translation:
				"You don't have access to manage sharing for this report. (psst...Are you previewing as another user?)",
		},
	"You don't have access to modify sharing for this folder.": {
		translation: "You don't have access to modify sharing for this folder.",
	},
	"You don't have access to that": {
		translation: "You don't have access to that",
	},
	"You don't have access to this custom approval": {
		translation: "You don't have access to this custom approval",
	},
	"You don't have access to view any ACA benefit plans, so there's nothing we can show you.  Sorry!":
		{
			translation:
				"You don't have access to view any ACA benefit plans, so there's nothing we can show you.  Sorry!",
		},
	"You don't have access to view any benefit plans, so there's nothing we can show you.  Sorry!":
		{
			translation:
				"You don't have access to view any benefit plans, so there's nothing we can show you.  Sorry!",
		},
	"You don't have access to view the information in this section.": {
		translation:
			"You don't have access to view the information in this section.",
	},
	"You don't have access to view this field.": {
		translation: "You don't have access to view this field.",
	},
	"You don't have access to view this file.": {
		translation: "You don't have access to view this file.",
	},
	"You don't have access to view this report, so there's nothing we can show you. Sorry!":
		{
			translation:
				"You don't have access to view this report, so there's nothing we can show you. Sorry!",
		},
	"You don't have access, so there's nothing we can show you. Sorry!": {
		translation:
			"You don't have access, so there's nothing we can show you. Sorry!",
	},
	"You don't have any Direct Deposit accounts set up.": {
		translation: "You don't have any Direct Deposit accounts set up.",
	},
	"You don't have any Goals for the current review period.": {
		translation: "You don't have any Goals for the current review period.",
	},
	"You don't have any apps installed ... yet.": {
		translation: "You don't have any apps installed ... yet.",
	},
	"You don't have any benefit groups that match this pay period. If you continue, this employee will not have any benefits applied.":
		{
			translation:
				"You don't have any benefit groups that match this pay period. If you continue, this employee will not have any benefits applied.",
		},
	"You don't have any benefit groups that match this pay schedule. If you continue, this employee will not have any benefits applied.":
		{
			translation:
				"You don't have any benefit groups that match this pay schedule. If you continue, this employee will not have any benefits applied.",
		},
	"You don't have any billing contacts yet": {
		translation: "You don't have any billing contacts yet",
	},
	'You don\'t have any candidates set to a "Not Hired Because..." status.': {
		translation:
			'You don\'t have any candidates set to a \\"Not Hired Because...\\" status.',
	},
	"You don't have any candidates yet. Here's hoping!": {
		translation: "You don't have any candidates yet. Here's hoping!",
	},
	"You don't have any completed goals.": {
		translation: "You don't have any completed goals.",
	},
	"You don't have any departments enabled.": {
		translation: "You don't have any departments enabled.",
	},
	"You don't have any divisions enabled.": {
		translation: "You don't have any divisions enabled.",
	},
	"You don't have any employment statuses set up in BambooHR.": {
		translation: "You don't have any employment statuses set up in BambooHR.",
	},
	"You don't have any goals in progress.": {
		translation: "You don't have any goals in progress.",
	},
	"You don't have any locations enabled.": {
		translation: "You don't have any locations enabled.",
	},
	"You don't have any notifications at the moment...": {
		translation: "You don't have any notifications at the moment...",
	},
	"You don't have any pay schedules set up. Add them in settings.": {
		translation:
			"You don't have any pay schedules set up. Add them in settings.",
	},
	"You don't have any payees set up yet. You can add one now.": {
		translation: "You don't have any payees set up yet. You can add one now.",
	},
	"You don't have any projects set up.": {
		translation: "You don't have any projects set up.",
	},
	"You don't have any types to calculate balances for.": {
		translation: "You don't have any types to calculate balances for.",
	},
	"You don't have permission": {
		translation: "You don't have permission",
	},
	"You don't have permission for power edit": {
		translation: "You don't have permission for power edit",
	},
	"You don't have permission to access LinkedIn settings.": {
		translation: "You don't have permission to access LinkedIn settings.",
	},
	"You don't have permission to change the policy for one or more employees.": {
		translation:
			"You don't have permission to change the policy for one or more employees.",
	},
	"You don't have permission to close a goal for this employee.": {
		translation: "You don't have permission to close a goal for this employee.",
	},
	"You don't have permission to close this goal.": {
		translation: "You don't have permission to close this goal.",
	},
	"You don't have permission to create a goal for this employee.": {
		translation:
			"You don't have permission to create a goal for this employee.",
	},
	"You don't have permission to create an impromptu assessment for the requested employee.":
		{
			translation:
				"You don't have permission to create an impromptu assessment for the requested employee.",
		},
	"You don't have permission to delete this goal file.": {
		translation: "You don't have permission to delete this goal file.",
	},
	"You don't have permission to delete this goal.": {
		translation: "You don't have permission to delete this goal.",
	},
	"You don't have permission to delete this request, or it has already been deleted.":
		{
			translation:
				"You don't have permission to delete this request, or it has already been deleted.",
		},
	"You don't have permission to delete this request.": {
		translation: "You don't have permission to delete this request.",
	},
	"You don't have permission to do that": {
		translation: "You don't have permission to do that",
	},
	"You don't have permission to do that.": {
		translation: "You don't have permission to do that.",
	},
	"You don't have permission to download this file.": {
		translation: "You don't have permission to download this file.",
	},
	"You don't have permission to edit this assessment.": {
		translation: "You don't have permission to edit this assessment.",
	},
	"You don't have permission to make that change.": {
		translation: "You don't have permission to make that change.",
	},
	"You don't have permission to open this goal.": {
		translation: "You don't have permission to open this goal.",
	},
	"You don't have permission to perform a Bamboo Login!": {
		translation: "You don't have permission to perform a Bamboo Login!",
	},
	"You don't have permission to publish this assessment.": {
		translation: "You don't have permission to publish this assessment.",
	},
	"You don't have permission to save this assessment.": {
		translation: "You don't have permission to save this assessment.",
	},
	"You don't have permission to see that page.": {
		translation: "You don't have permission to see that page.",
	},
	"You don't have permission to see this employee": {
		translation: "You don't have permission to see this employee",
	},
	"You don't have permission to set this user to an Employee Access Level": {
		translation:
			"You don't have permission to set this user to an Employee Access Level",
	},
	"You don't have permission to skip this assessment.": {
		translation: "You don't have permission to skip this assessment.",
	},
	"You don't have permission to submit this assessment.": {
		translation: "You don't have permission to submit this assessment.",
	},
	"You don't have permission to unlock this assessment.": {
		translation: "You don't have permission to unlock this assessment.",
	},
	"You don't have permission to update this goal.": {
		translation: "You don't have permission to update this goal.",
	},
	"You don't have permission to upload files to this assessment.": {
		translation:
			"You don't have permission to upload files to this assessment.",
	},
	"You don't have permission to view any history types": {
		translation: "You don't have permission to view any history types",
	},
	'You don\'t have permission to view the report because it requires access to the "%1s" app, which your company doesn\'t have.':
		{
			translation:
				'You don\'t have permission to view the report because it requires access to the \\"%1s\\" app, which your company doesn\'t have.',
		},
	'You don\'t have permission to view the report because it requires access to the "%1s" tool, which your company doesn\'t have.':
		{
			translation:
				'You don\'t have permission to view the report because it requires access to the \\"%1s\\" tool, which your company doesn\'t have.',
		},
	"You don't have permission to view the report because it requires access to view other employees' \"%1s\" page, which you don't have.":
		{
			translation:
				"You don't have permission to view the report because it requires access to view other employees' \\\"%1s\\\" page, which you don't have.",
		},
	'You don\'t have permission to view the report, because it requires access to "%1s", which you don\'t have.':
		{
			translation:
				'You don\'t have permission to view the report, because it requires access to \\"%1s\\", which you don\'t have.',
		},
	'You don\'t have permission to view the report, because it requires access to "bob", which you don\'t have.':
		{
			translation:
				'You don\'t have permission to view the report, because it requires access to "bob", which you don\'t have.',
		},
	'You don\'t have permission to view the report, because it requires access to the "%1s" field, which you don\'t have.':
		{
			translation:
				'You don\'t have permission to view the report, because it requires access to the \\"%1s\\" field, which you don\'t have.',
		},
	"You don't have permission to view the report, because no survey has been completed yet":
		{
			translation:
				"You don't have permission to view the report, because no survey has been completed yet",
		},
	"You don't have permission to view the report, because you are not an admin or owner.":
		{
			translation:
				"You don't have permission to view the report, because you are not an admin or owner.",
		},
	"You don't have permission to view the report, because you are not an admin or payroll admin.":
		{
			translation:
				"You don't have permission to view the report, because you are not an admin or payroll admin.",
		},
	"You don't have permission.": {
		translation: "You don't have permission.",
	},
	"You don't have permissions to access that Field Type for this Employee.": {
		translation:
			"You don't have permissions to access that Field Type for this Employee.",
	},
	"You don't have permissions to access this file": {
		translation: "You don't have permissions to access this file",
	},
	"You don't have the required permissions.": {
		translation: "You don't have the required permissions.",
	},
	"You don't have the time off feature enabled": {
		translation: "You don't have the time off feature enabled",
	},
	'You don’t have any Direct Deposit accounts set up.': {
		translation: 'You don’t have any Direct Deposit accounts set up.',
	},
	'You dragged in multiple files, but only one can be added here. Make sure the file you intended to add got uploaded.':
		{
			translation:
				'You dragged in multiple files, but only one can be added here. Make sure the file you intended to add got uploaded.',
		},
	'You enter the title you’re interested in and PayScale offers a set of prioritized matches. You select the one that looks closest to what your role does.':
		{
			translation:
				'You enter the title you’re interested in and PayScale offers a set of prioritized matches. You select the one that looks closest to what your role does.',
		},
	'You entered the wrong value for the current password.': {
		translation: 'You entered the wrong value for the current password.',
	},
	'You entered: `%1$s`.': {
		translation: 'You entered: `%1$s`.',
	},
	'You got paid! Take a look at your paystub for your %1 paycheck.': {
		translation:
			'You got paid! Take a look at your paystub for your %1 paycheck.',
	},
	'You have %1 %2 requests to review.': {
		translation: 'You have %1 %2 requests to review.',
	},
	'You have %1 %2 tasks.': {
		translation: 'You have %1 %2 tasks.',
	},
	'You have %1 Information Update requests to review.': {
		translation: 'You have %1 Information Update requests to review.',
	},
	'You have %1 Time Off Requests to review.': {
		translation: 'You have %1 Time Off Requests to review.',
	},
	'You have %1 applicants for the %2 opening.': {
		translation: 'You have %1 applicants for the %2 opening.',
	},
	'You have %1 documents waiting for your signature.': {
		translation: 'You have %1 documents waiting for your signature.',
	},
	'You have %1 timesheets waiting for approval.': {
		translation: 'You have %1 timesheets waiting for approval.',
	},
	'You have %1$s active employees in this Pay Group': {
		translation: 'You have %1$s active employees in this Pay Group',
	},
	'You have %1$s in this %2$s.': {
		translation: 'You have %1$s in this %2$s.',
	},
	'You have %1$s%2$s%3$s in this %4$s.': {
		translation: 'You have %1$s%2$s%3$s in this %4$s.',
	},
	'You have %1s%2s active employee%3s in this Pay Group.': {
		translation: 'You have %1s%2s active employee%3s in this Pay Group.',
	},
	'You have %1s%2s active employees%3s in this Pay Group.': {
		translation: 'You have %1s%2s active employees%3s in this Pay Group.',
	},
	'You have **{1} active employee** with this pay schedule.': {
		translation: 'You have **{1} active employee** with this pay schedule.',
	},
	'You have **{1} active employees** with this pay schedule.': {
		translation: 'You have **{1} active employees** with this pay schedule.',
	},
	'You have *{1}*': {
		translation: 'You have *{1}*',
	},
	'You have a goal due today': {
		translation: 'You have a goal due today',
	},
	'You have a new email from %1.': {
		translation: 'You have a new email from %1.',
	},
	'You have already added the maximum number of %1$s custom tags.': {
		translation:
			'You have already added the maximum number of %1$s custom tags.',
	},
	'You have already added the maximum number of 10 custom tags.': {
		translation: 'You have already added the maximum number of 10 custom tags.',
	},
	'You have already assigned feedback. Here are the assignments you made before.':
		{
			translation:
				'You have already assigned feedback. Here are the assignments you made before.',
		},
	'You have already assigned peer feedback. Here are the assignments you made before.':
		{
			translation:
				'You have already assigned peer feedback. Here are the assignments you made before.',
		},
	'You have an offer from %1$s!': {
		translation: 'You have an offer from %1$s!',
	},
	'You have approvals set up for the %1$s"%2$s"%3$s %4$s. Outstanding approvals will be honored; future approvals will follow the "All other %5$ss" flow.':
		{
			translation:
				'You have approvals set up for the %1$s\\"%2$s\\"%3$s %4$s. Outstanding approvals will be honored; future approvals will follow the \\"All other %5$ss\\" flow.',
		},
	'You have benefit plans ending soon': {
		translation: 'You have benefit plans ending soon',
	},
	'You have disabled notifications for one person.': {
		translation: 'You have disabled notifications for one person.',
	},
	'You have enabled notifications for one person.': {
		translation: 'You have enabled notifications for one person.',
	},
	'You have entered an invalid email address or password. Please try again.': {
		translation:
			'You have entered an invalid email address or password. Please try again.',
	},
	'You have new emails.': {
		translation: 'You have new emails.',
	},
	'You have no permission to access this data.': {
		translation: 'You have no permission to access this data.',
	},
	'You have not created any plans yet.': {
		translation: 'You have not created any plans yet.',
	},
	'You have not saved your changes. Do you want to discard your changes?': {
		translation:
			'You have not saved your changes. Do you want to discard your changes?',
	},
	'You have not selected anyone to provide Peer Feedback for %1 people on your team. You will not receive any feedback for these people.':
		{
			translation:
				'You have not selected anyone to provide Peer Feedback for %1 people on your team. You will not receive any feedback for these people.',
		},
	'You have not selected anyone to provide feedback for {1} people on your team. You will not receive any feedback for these people.':
		{
			translation:
				'You have not selected anyone to provide feedback for {1} people on your team. You will not receive any feedback for these people.',
		},
	'You have reached the limit of favorite reports.': {
		translation: 'You have reached the limit of favorite reports.',
	},
	'You have reached your limit of open positions.': {
		translation: 'You have reached your limit of open positions.',
	},
	'You have reported a Qualifying Life Event': {
		translation: 'You have reported a Qualifying Life Event',
	},
	'You have shared this file with <b>%s</b> , <b>%s</b>, <b>%s</b>  .': {
		translation:
			'You have shared this file with <b>%s</b> , <b>%s</b>, <b>%s</b>  .',
	},
	'You have shared this file with <b>%s</b> and <b>%s</b> .': {
		translation: 'You have shared this file with <b>%s</b> and <b>%s</b> .',
	},
	'You have shared this file with <b>%s</b>,<b>%s</b>,<b>%s</b> and %s more...':
		{
			translation:
				'You have shared this file with <b>%s</b>,<b>%s</b>,<b>%s</b> and %s more...',
		},
	'You have shared this file with <b>%s</b>.': {
		translation: 'You have shared this file with <b>%s</b>.',
	},
	'You have shared this file with <b>All Employees</b>.': {
		translation: 'You have shared this file with <b>All Employees</b>.',
	},
	'You have shared this folder with <b>%s</b> , <b>%s</b>, <b>%s</b>  .': {
		translation:
			'You have shared this folder with <b>%s</b> , <b>%s</b>, <b>%s</b>  .',
	},
	'You have shared this folder with <b>%s</b> and <b>%s</b> .': {
		translation: 'You have shared this folder with <b>%s</b> and <b>%s</b> .',
	},
	'You have shared this folder with <b>%s</b>,<b>%s</b>,<b>%s</b> and %s more...':
		{
			translation:
				'You have shared this folder with <b>%s</b>,<b>%s</b>,<b>%s</b> and %s more...',
		},
	'You have shared this folder with <b>%s</b>.': {
		translation: 'You have shared this folder with <b>%s</b>.',
	},
	'You have shared this folder with <b>All Employees</b>.': {
		translation: 'You have shared this folder with <b>All Employees</b>.',
	},
	'You have shared this position with <b>%1$s</b> , <b>%2$s</b>, <b>%3$s</b>.':
		{
			translation:
				'You have shared this position with <b>%1$s</b> , <b>%2$s</b>, <b>%3$s</b>.',
		},
	'You have shared this position with <b>%1$s</b> and <b>%2$s</b>.': {
		translation:
			'You have shared this position with <b>%1$s</b> and <b>%2$s</b>.',
	},
	'You have shared this position with <b>%1$s</b>,<b>%2$s</b>,<b>%3$s</b> and %4$s more...':
		{
			translation:
				'You have shared this position with <b>%1$s</b>,<b>%2$s</b>,<b>%3$s</b> and %4$s more...',
		},
	'You have shared this position with <b>%1$s</b>.': {
		translation: 'You have shared this position with <b>%1$s</b>.',
	},
	'You have shared this report with <b>%s</b> and <b>%s</b>.': {
		translation: 'You have shared this report with <b>%s</b> and <b>%s</b>.',
	},
	'You have shared this report with <b>%s</b>, <b>%s</b>, <b>%s</b>, and %s more.':
		{
			translation:
				'You have shared this report with <b>%s</b>, <b>%s</b>, <b>%s</b>, and %s more.',
		},
	'You have shared this report with <b>%s</b>, <b>%s</b>, and <b>%s</b>.': {
		translation:
			'You have shared this report with <b>%s</b>, <b>%s</b>, and <b>%s</b>.',
	},
	'You have shared this report with <b>%s</b>.': {
		translation: 'You have shared this report with <b>%s</b>.',
	},
	'You have signed this document.': {
		translation: 'You have signed this document.',
	},
	'You have successfully recorded time off.': {
		translation: 'You have successfully recorded time off.',
	},
	'You have successfully shared the goal!': {
		translation: 'You have successfully shared the goal!',
	},
	'You have successfully shared this page!': {
		translation: 'You have successfully shared this page!',
	},
	'You have successfully updated the report schedule notification.': {
		translation:
			'You have successfully updated the report schedule notification.',
	},
	'You have too many job openings in ATS.': {
		translation: 'You have too many job openings in ATS.',
	},
	"You haven't added any %1s fields yet": {
		translation: "You haven't added any %1s fields yet",
	},
	"You haven't added any employees yet.": {
		translation: "You haven't added any employees yet.",
	},
	"You haven't been paid yet this year.": {
		translation: "You haven't been paid yet this year.",
	},
	"You haven't created any benefit groups that match this employee's pay frequency.":
		{
			translation:
				"You haven't created any benefit groups that match this employee's pay frequency.",
		},
	"You haven't created any reports yet.": {
		translation: "You haven't created any reports yet.",
	},
	"You haven't had any candidates for this job opening yet. Check back once you do to see how they progress through your job statuses.":
		{
			translation:
				"You haven't had any candidates for this job opening yet. Check back once you do to see how they progress through your job statuses.",
		},
	"You haven't installed any.": {
		translation: "You haven't installed any.",
	},
	"You haven't saved your changes": {
		translation: "You haven't saved your changes",
	},
	"You haven't saved your changes. Your changes will be lost if you navigate away from this page without saving.":
		{
			translation:
				"You haven't saved your changes. Your changes will be lost if you navigate away from this page without saving.",
		},
	"You haven't set up any benefit groups yet, but that's okay.": {
		translation: "You haven't set up any benefit groups yet, but that's okay.",
	},
	'You hit getGoalSettings': {
		translation: 'You hit getGoalSettings',
	},
	'You hit saveGoalSettings.': {
		translation: 'You hit saveGoalSettings.',
	},
	'You may also optionally configure Single Sign-On (SSO) with Cornerstone by entering your Cornerstone Company Name (SSO capability may have an additional cost).':
		{
			translation:
				'You may also optionally configure Single Sign-On (SSO) with Cornerstone by entering your Cornerstone Company Name (SSO capability may have an additional cost).',
		},
	'You may change the date of the next request for feedback once the current one ends.':
		{
			translation:
				'You may change the date of the next request for feedback once the current one ends.',
		},
	'You may continue to use IE%1, but you may run into issues that we will not fix.':
		{
			translation:
				'You may continue to use IE%1, but you may run into issues that we will not fix.',
		},
	'You may have conflicting records that need to be reconciled': {
		translation: 'You may have conflicting records that need to be reconciled',
	},
	'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing <a href="mailto:support@bamboohr.com">support@bamboohr.com</a> or calling 1-866-387-9595.':
		{
			translation:
				'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a> or calling 1-866-387-9595.',
		},
	'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing <a href="support@bamboohr.com">support@bamboohr.com</a> or calling 1-866-387-9595.':
		{
			translation:
				'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing <a href=\\"support@bamboohr.com\\">support@bamboohr.com</a> or calling 1-866-387-9595.',
		},
	'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing support@bamboohr.com or calling 1-866-387-9595.':
		{
			translation:
				'You may install this application yourself following the Steps to Install below, or you may contact our Customer Service Department by emailing support@bamboohr.com or calling 1-866-387-9595.',
		},
	"You may install this application yourself following the Steps to Install below, or you may contact the BambooHR Customer Service Department by emailing <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or calling 1-866-387-9595.":
		{
			translation:
				"You may install this application yourself following the Steps to Install below, or you may contact the BambooHR Customer Service Department by emailing <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or calling 1-866-387-9595.",
		},
	'You may install this application yourself following the steps below to install or contact Okta Customer Service at <a href="mailto:support@okta.com">support@okta.com</a>.':
		{
			translation:
				'You may install this application yourself following the steps below to install or contact Okta Customer Service at <a href=\\"mailto:support@okta.com\\">support@okta.com</a>.',
		},
	'You may lose some information': {
		translation: 'You may lose some information',
	},
	'You may lose some information.': {
		translation: 'You may lose some information.',
	},
	'You may not log in. There are multiple users with that same email address. Please contact <a href="mailto:support@bamboohr.com">support@bamboohr.com</a>':
		{
			translation:
				'You may not log in. There are multiple users with that same email address. Please contact <a href=\\"mailto:support@bamboohr.com\\">support@bamboohr.com</a>',
		},
	'You may not log in. This employee email has been disabled. Please contact your administrator to enable access.':
		{
			translation:
				'You may not log in. This employee email has been disabled. Please contact your administrator to enable access.',
		},
	'You may want to bookmark this baby.': {
		translation: 'You may want to bookmark this baby.',
	},
	'You must be a BambooHR admin for ': {
		translation: 'You must be a BambooHR admin for ',
	},
	'You must be within an active review period to send a feedback request.': {
		translation:
			'You must be within an active review period to send a feedback request.',
	},
	'You must choose a payroll to sync with.': {
		translation: 'You must choose a payroll to sync with.',
	},
	'You must choose, but choose wisely… This action cannot be undone.': {
		translation:
			'You must choose, but choose wisely… This action cannot be undone.',
	},
	'You must enable payroll first.': {
		translation: 'You must enable payroll first.',
	},
	'You must enter a new name for this Department': {
		translation: 'You must enter a new name for this Department',
	},
	'You must enter a new name for this Employment Type': {
		translation: 'You must enter a new name for this Employment Type',
	},
	'You must enter a new name for this Location': {
		translation: 'You must enter a new name for this Location',
	},
	'You must enter a new option to the list.': {
		translation: 'You must enter a new option to the list.',
	},
	'You must enter a valid id': {
		translation: 'You must enter a valid id',
	},
	'You must first select an employment status.': {
		translation: 'You must first select an employment status.',
	},
	'You must have a valid Employment Status and Effective Date because Trax Integration is enabled':
		{
			translation:
				'You must have a valid Employment Status and Effective Date because Trax Integration is enabled',
		},
	'You must have a valid Final Pay Date because Trax Integration is enabled': {
		translation:
			'You must have a valid Final Pay Date because Trax Integration is enabled',
	},
	'You must have a valid Overtime Status because Trax Integration is enabled': {
		translation:
			'You must have a valid Overtime Status because Trax Integration is enabled',
	},
	'You must have a valid Pay Type and Pay Rate because Trax Integration is enabled':
		{
			translation:
				'You must have a valid Pay Type and Pay Rate because Trax Integration is enabled',
		},
	'You must have a valid Pay Type, Pay Rate and Overtime Status because Trax Integration is enabled':
		{
			translation:
				'You must have a valid Pay Type, Pay Rate and Overtime Status because Trax Integration is enabled',
		},
	'You must have a valid division, department and location because Trax Integration is enabled':
		{
			translation:
				'You must have a valid division, department and location because Trax Integration is enabled',
		},
	'You must have a valid division, department and location because Trax Integration is enabled on a current or future pay schedule':
		{
			translation:
				'You must have a valid division, department and location because Trax Integration is enabled on a current or future pay schedule',
		},
	'You must have a valid location because Trax Integration is enabled': {
		translation:
			'You must have a valid location because Trax Integration is enabled',
	},
	'You must have at least one employee access level.': {
		translation: 'You must have at least one employee access level.',
	},
	'You must have at least one pay schedule or else things get wacky.': {
		translation:
			'You must have at least one pay schedule or else things get wacky.',
	},
	'You must include a name for your new coverage level.': {
		translation: 'You must include a name for your new coverage level.',
	},
	'You must pass both a benefit group id and a plan id.': {
		translation: 'You must pass both a benefit group id and a plan id.',
	},
	'You must provide a date to publish this assessment.': {
		translation: 'You must provide a date to publish this assessment.',
	},
	'You must select a date to publish this assessment.': {
		translation: 'You must select a date to publish this assessment.',
	},
	'You must select a future end date to reactivate this plan.': {
		translation: 'You must select a future end date to reactivate this plan.',
	},
	'You must select a location or indicate if you are adding a new location.': {
		translation:
			'You must select a location or indicate if you are adding a new location.',
	},
	'You must select a matching benefit group to update this employee.': {
		translation:
			'You must select a matching benefit group to update this employee.',
	},
	'You must select at least one person': {
		translation: 'You must select at least one person',
	},
	'You must set ID when updating a ListValue item.': {
		translation: 'You must set ID when updating a ListValue item.',
	},
	'You must set a label for a new list_value item.': {
		translation: 'You must set a label for a new list_value item.',
	},
	'You must set a list ID for a new list_value item.': {
		translation: 'You must set a list ID for a new list_value item.',
	},
	'You must supply a user to assign feedback to.': {
		translation: 'You must supply a user to assign feedback to.',
	},
	'You must uninstall %1$s before installing %2$s': {
		translation: 'You must uninstall %1$s before installing %2$s',
	},
	'You must uninstall %s before installing Google Single Sign-on': {
		translation:
			'You must uninstall %s before installing Google Single Sign-on',
	},
	'You must upload at least one file before submitting.': {
		translation: 'You must upload at least one file before submitting.',
	},
	'You need to complete your company information before setting up a bank account.':
		{
			translation:
				'You need to complete your company information before setting up a bank account.',
		},
	'You need to link a bank account to %1$s below': {
		translation: 'You need to link a bank account to %1$s below',
	},
	'You need to select one or more employees to disable.': {
		translation: 'You need to select one or more employees to disable.',
	},
	'You need to select one or more employees to enable.': {
		translation: 'You need to select one or more employees to enable.',
	},
	"You need to set this employee's hire date.": {
		translation: "You need to set this employee's hire date.",
	},
	"You need to set this employee's hire date. <a href='/employees/employee.php?id=":
		{
			translation:
				"You need to set this employee's hire date. <a href='/employees/employee.php?id=",
		},
	'You need to set up your payroll bank account': {
		translation: 'You need to set up your payroll bank account',
	},
	'You need to sign the required payroll forms for %1$s below': {
		translation: 'You need to sign the required payroll forms for %1$s below',
	},
	'You probably want to get paid, right? Add an account for your direct deposit...':
		{
			translation:
				'You probably want to get paid, right? Add an account for your direct deposit...',
		},
	'You requested %1$s day of %2$s for %3$s.': {
		translation: {
			one: 'You requested %1$s day of %2$s for %3$s.',
			other: 'You requested %1$s days of %2$s for %3$s.',
		},
	},
	'You requested %1$s hour of %2$s for %3$s.': {
		translation: {
			one: 'You requested %1$s hour of %2$s for %3$s.',
			other: 'You requested %1$s hours of %2$s for %3$s.',
		},
	},
	'You requested a %1$s Change for %2$s.': {
		translation: 'You requested a %1$s Change for %2$s.',
	},
	'You requested an %1$s Change for %2$s.': {
		translation: 'You requested an %1$s Change for %2$s.',
	},
	'You requested an update to your personal information.': {
		translation: 'You requested an update to your personal information.',
	},
	'You requested time off for %1$s.': {
		translation: 'You requested time off for %1$s.',
	},
	'You should ask some people for signatures.': {
		translation: 'You should ask some people for signatures.',
	},
	'You should look at adjusting their reporting structure to make sure the org chart displays correctly.':
		{
			translation:
				'You should look at adjusting their reporting structure to make sure the org chart displays correctly.',
		},
	'You signed this at %1$s': {
		translation: 'You signed this at %1$s',
	},
	'You signed this at %1$s (%2$s day ago)': {
		translation: {
			one: 'You signed this at %1$s (%2$s day ago)',
			other: 'You signed this at %1$s (%2$s days ago)',
		},
	},
	'You signed this at %1$s (%2$s hour ago)': {
		translation: {
			one: 'You signed this at %1$s (%2$s hour ago)',
			other: 'You signed this at %1$s (%2$s hours ago)',
		},
	},
	'You signed this on %1$s': {
		translation: 'You signed this on %1$s',
	},
	'You successfully moved %1$s to %2$s': {
		translation: 'You successfully moved %1$s to %2$s',
	},
	'You successfully moved this Candidate to a new position.': {
		translation: 'You successfully moved this Candidate to a new position.',
	},
	'You successfully updated %1$s applicants': {
		translation: 'You successfully updated %1$s applicants',
	},
	'You successfully updated the status for %1$s': {
		translation: 'You successfully updated the status for %1$s',
	},
	'You were clocked in elsewhere %1$s.': {
		translation: 'You were clocked in elsewhere %1$s.',
	},
	'You were clocked out elsewhere %1$s.': {
		translation: 'You were clocked out elsewhere %1$s.',
	},
	'You will be able to send feedback requests after {1}.': {
		translation: 'You will be able to send feedback requests after {1}.',
	},
	'You will be redirected back to your management dashboard, where a new tab titled "BambooHR" has been added to your main menu. Go to the BambooHR tab, and click Settings to see a list of employees has been pulled from BambooHR. Match these employees to the correct employee name in Boomr. This ensures that hours tracked in Boomr are accurately matched to the correct employee in BambooHR.':
		{
			translation:
				'You will be redirected back to your management dashboard, where a new tab titled \\"BambooHR\\" has been added to your main menu. Go to the BambooHR tab, and click Settings to see a list of employees has been pulled from BambooHR. Match these employees to the correct employee name in Boomr. This ensures that hours tracked in Boomr are accurately matched to the correct employee in BambooHR.',
		},
	'You will be responsible for collecting and paying garnishments for **{1} {2}**.':
		{
			translation:
				'You will be responsible for collecting and paying garnishments for **{1} {2}**.',
		},
	'You will be responsible for collecting and paying garnishments for *{1} {2}*.':
		{
			translation:
				'You will be responsible for collecting and paying garnishments for *{1} {2}*.',
		},
	'You will continue to manage all employee data and information in BambooHR. You can rest assured knowing that when you update information in BambooHR such as employment status, salary, marital status and more all the information will be automatically reflected in PlanSource. Installing this app will add a few needed fields for the integration, as well as enable the configuration for Single Sign-On (SSO) from BambooHR to PlanSource.':
		{
			translation:
				'You will continue to manage all employee data and information in BambooHR. You can rest assured knowing that when you update information in BambooHR such as employment status, salary, marital status and more all the information will be automatically reflected in PlanSource. Installing this app will add a few needed fields for the integration, as well as enable the configuration for Single Sign-On (SSO) from BambooHR to PlanSource.',
		},
	'You will lose all time not used by %s': {
		translation: 'You will lose all time not used by %s',
	},
	'You will lose all time not used by your anniversary date': {
		translation: 'You will lose all time not used by your anniversary date',
	},
	"You will lose any progress you've made on this %1.": {
		translation: "You will lose any progress you've made on this %1.",
	},
	'You will need to apply this plan to at least one benefit group in order to use it.':
		{
			translation:
				'You will need to apply this plan to at least one benefit group in order to use it.',
		},
	'You will need to update any missing payroll info before including this employee in payroll':
		{
			translation:
				'You will need to update any missing payroll info before including this employee in payroll',
		},
	'You will not be able to change this setting.': {
		translation: 'You will not be able to change this setting.',
	},
	'You will not be able to make any changes.': {
		translation: 'You will not be able to make any changes.',
	},
	'You will not be able to send out another survey until': {
		translation: 'You will not be able to send out another survey until',
	},
	'You will receive a paper check until you add direct deposit info': {
		translation:
			'You will receive a paper check until you add direct deposit info',
	},
	'You will receive a paper check until you add direct deposit info.': {
		translation:
			'You will receive a paper check until you add direct deposit info.',
	},
	'You will set how much employees pay when you enroll them in this plan.': {
		translation:
			'You will set how much employees pay when you enroll them in this plan.',
	},
	'You will start receiving paper checks': {
		translation: 'You will start receiving paper checks',
	},
	'You will stop accruing time after you hit a balance of %s %s': {
		translation: 'You will stop accruing time after you hit a balance of %s %s',
	},
	'You will then be able to continue approving.': {
		translation: 'You will then be able to continue approving.',
	},
	"You won't be able to use this approval until you enable it again.": {
		translation:
			"You won't be able to use this approval until you enable it again.",
	},
	"You won't have to re-enter anything after this process is complete. We're only making changes to how you determine who is eligible for benefits in the future.":
		{
			translation:
				"You won't have to re-enter anything after this process is complete. We're only making changes to how you determine who is eligible for benefits in the future.",
		},
	'You won’t be able to make adjustments until after the pay day has passed.': {
		translation:
			'You won’t be able to make adjustments until after the pay day has passed.',
	},
	'You won’t be able to use any of the peer feedback tools until it has been activated in the customers performance settings.':
		{
			translation:
				'You won’t be able to use any of the peer feedback tools until it has been activated in the customers performance settings.',
		},
	"You'll be able to do things like request time off and see your company directory and calendar.":
		{
			translation:
				"You'll be able to do things like request time off and see your company directory and calendar.",
		},
	"You'll be able to download copies of these documents after you accept the offer.":
		{
			translation:
				"You'll be able to download copies of these documents after you accept the offer.",
		},
	"You'll be bypassing some approvers.": {
		translation: "You'll be bypassing some approvers.",
	},
	"You'll need to add benefit groups to make your plans useful.": {
		translation: "You'll need to add benefit groups to make your plans useful.",
	},
	"You'll need to be an admin to view this page. Contact your account owner for help.":
		{
			translation:
				"You'll need to be an admin to view this page. Contact your account owner for help.",
		},
	"You'll only need to do this once, and it can be changed later in Payroll settings.":
		{
			translation:
				"You'll only need to do this once, and it can be changed later in Payroll settings.",
		},
	"You'll receive a paper check with any remaining balance": {
		translation: "You'll receive a paper check with any remaining balance",
	},
	"You'll receive a paper check with any remaining balance.": {
		translation: "You'll receive a paper check with any remaining balance.",
	},
	"You're all safe and logged out": {
		translation: "You're all safe and logged out",
	},
	"You're all set!": {
		translation: "You're all set!",
	},
	"You're all set, feel free to close this window and move on with your life.":
		{
			translation:
				"You're all set, feel free to close this window and move on with your life.",
		},
	"You're almost done, but first we'd like to get to know a bit more about you so we can introduce you to the rest of the team.":
		{
			translation:
				"You're almost done, but first we'd like to get to know a bit more about you so we can introduce you to the rest of the team.",
		},
	"You're almost done, but first we'd like to get to know a bit more about you so we can introduce you to the rest of the team. Please answer the following questions and we'll send out a quick introduction email to the people you'll be working with.":
		{
			translation:
				"You're almost done, but first we'd like to get to know a bit more about you so we can introduce you to the rest of the team. Please answer the following questions and we'll send out a quick introduction email to the people you'll be working with.",
		},
	"You're changes have been saved.": {
		translation: "You're changes have been saved.",
	},
	"You're good to go! We'll go ahead and install %1$s": {
		translation: "You're good to go! We'll go ahead and install %1$s",
	},
	"You're good to go! Your time off types look great.": {
		translation: "You're good to go! Your time off types look great.",
	},
	"You're looking at BambooHR, your new tool for work.": {
		translation: "You're looking at BambooHR, your new tool for work.",
	},
	"You're looking at BambooHR, your new tool for work. Here's a quick look at some of the things you can do with BambooHR.":
		{
			translation:
				"You're looking at BambooHR, your new tool for work. Here's a quick look at some of the things you can do with BambooHR.",
		},
	"You're on top of it! There are no time off requests.": {
		translation: "You're on top of it! There are no time off requests.",
	},
	"You've added all active applicant statuses...": {
		translation: "You've added all active applicant statuses...",
	},
	"You've added too many fields to this report. Please reduce the number of fields to ":
		{
			translation:
				"You've added too many fields to this report. Please reduce the number of fields to ",
		},
	"You've added too many filters to this report. Please reduce the number of filters.":
		{
			translation:
				"You've added too many filters to this report. Please reduce the number of filters.",
		},
	"You've been added as a collaborator!": {
		translation: "You've been added as a collaborator!",
	},
	"You've completed your benefit setup. You can now review your information and make any changes in the Benefit Settings page.":
		{
			translation:
				"You've completed your benefit setup. You can now review your information and make any changes in the Benefit Settings page.",
		},
	"You've exceeded the allowed number of attempts to enter the correct deposit amount.":
		{
			translation:
				"You've exceeded the allowed number of attempts to enter the correct deposit amount.",
		},
	"You've got %1$s employees in this %2$s": {
		translation: "You've got %1$s employees in this %2$s",
	},
	"You've got %1$s employees in this benefit group.": {
		translation: "You've got %1$s employees in this benefit group.",
	},
	"You've got 1 employee assigned to this %1$s": {
		translation: "You've got 1 employee assigned to this %1$s",
	},
	"You've got 1 employee in this benefit group.": {
		translation: "You've got 1 employee in this benefit group.",
	},
	"You've reached the employee limit for your current plan.": {
		translation: "You've reached the employee limit for your current plan.",
	},
	"You've still got %1$s employees in this benefit group.": {
		translation: "You've still got %1$s employees in this benefit group.",
	},
	"You've still got %1$s employees using this coverage option": {
		translation: "You've still got %1$s employees using this coverage option",
	},
	"You've still got %1$s employees using this coverage option.": {
		translation: "You've still got %1$s employees using this coverage option.",
	},
	"You've still got 1 employee in this benefit group.": {
		translation: "You've still got 1 employee in this benefit group.",
	},
	"You've still got 1 employee using this coverage option": {
		translation: "You've still got 1 employee using this coverage option",
	},
	"You've still got 1 employee using this coverage option.": {
		translation: "You've still got 1 employee using this coverage option.",
	},
	"You've successfully deleted the %s tab.": {
		translation: "You've successfully deleted the %s tab.",
	},
	'Your %1 Assessment has been successfully submitted.': {
		translation: 'Your %1 Assessment has been successfully submitted.',
	},
	'Your %1$s has been saved.': {
		translation: 'Your %1$s has been saved.',
	},
	'Your *{1}* eNPS is *{2}*': {
		translation: 'Your *{1}* eNPS is *{2}*',
	},
	'Your 1099 form is ready': {
		translation: 'Your 1099 form is ready',
	},
	'Your Account': {
		translation: 'Your Account',
	},
	'Your BambooHR URL': {
		translation: 'Your BambooHR URL',
	},
	'Your Benefit Group has been saved.': {
		translation: 'Your Benefit Group has been saved.',
	},
	'Your Current Pay Groups': {
		translation: 'Your Current Pay Groups',
	},
	'Your Default Hours per Day have been saved.': {
		translation: 'Your Default Hours per Day have been saved.',
	},
	'Your Direct Deposit Information Changed': {
		translation: 'Your Direct Deposit Information Changed',
	},
	'Your Embed Code': {
		translation: 'Your Embed Code',
	},
	'Your Employee Satisfaction survey is ready to go.': {
		translation: 'Your Employee Satisfaction survey is ready to go.',
	},
	'Your Employees will start showing once their Manager Assessment is completed.':
		{
			translation:
				'Your Employees will start showing once their Manager Assessment is completed.',
		},
	'Your Federal Withholding is': {
		translation: 'Your Federal Withholding is',
	},
	'Your Federal Withholding was': {
		translation: 'Your Federal Withholding was',
	},
	'Your Federal Withholding was %5$s%1$s%6$s%2$s, and your State Withholding was %5$s%3$s%6$s%4$s.':
		{
			translation:
				'Your Federal Withholding was %5$s%1$s%6$s%2$s, and your State Withholding was %5$s%3$s%6$s%4$s.',
		},
	'Your Federal Withholding was **{1}**': {
		translation: 'Your Federal Withholding was **{1}**',
	},
	'Your First Day': {
		translation: 'Your First Day',
	},
	'Your Free Trial has': {
		translation: 'Your Free Trial has',
	},
	'Your HR Project Manager': {
		translation: 'Your HR Project Manager',
	},
	'Your HR admin should be able to help you out.': {
		translation: 'Your HR admin should be able to help you out.',
	},
	'Your Manager': {
		translation: 'Your Manager',
	},
	'Your Manager Assessment has been saved. You can come back and complete it later.':
		{
			translation:
				'Your Manager Assessment has been saved. You can come back and complete it later.',
		},
	'Your Manager Assessment has been successfully submitted.': {
		translation: 'Your Manager Assessment has been successfully submitted.',
	},
	'Your Most-Run': {
		translation: 'Your Most-Run',
	},
	'Your New Goal': {
		translation: 'Your New Goal',
	},
	'Your Path to Awesome!': {
		translation: 'Your Path to Awesome!',
	},
	'Your Pay': {
		translation: 'Your Pay',
	},
	'Your Primary Payment Method has expired. Please %1$s to update your primary payment method to avoid missing a payment.':
		{
			translation:
				'Your Primary Payment Method has expired. Please %1$s to update your primary payment method to avoid missing a payment.',
		},
	'Your Primary Payment Method is expiring soon. Please %1$s to update your primary payment method to avoid missing a payment.':
		{
			translation:
				'Your Primary Payment Method is expiring soon. Please %1$s to update your primary payment method to avoid missing a payment.',
		},
	'Your Primary Payment Method will expire before your next payment is due. Please %1$s to update your primary payment method to avoid missing a payment.':
		{
			translation:
				'Your Primary Payment Method will expire before your next payment is due. Please %1$s to update your primary payment method to avoid missing a payment.',
		},
	'Your Profile Photo': {
		translation: 'Your Profile Photo',
	},
	"Your Radius Account Manager, and the Radius team will ensure the sync is setup and running smoothly. But if you have any questions be sure to reach out to BambooHR's support team at <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or call 1-866-387-9595.":
		{
			translation:
				"Your Radius Account Manager, and the Radius team will ensure the sync is setup and running smoothly. But if you have any questions be sure to reach out to BambooHR's support team at <a href='mailto:support@bamboohr.com'>support@bamboohr.com</a> or call 1-866-387-9595.",
		},
	'Your Request has Expired': {
		translation: 'Your Request has Expired',
	},
	'Your Self Assessment has been saved. You can come back and complete it later.':
		{
			translation:
				'Your Self Assessment has been saved. You can come back and complete it later.',
		},
	'Your Self Assessment has been successfully submitted.': {
		translation: 'Your Self Assessment has been successfully submitted.',
	},
	'Your State Withholding is': {
		translation: 'Your State Withholding is',
	},
	'Your State Withholding was': {
		translation: 'Your State Withholding was',
	},
	'Your System Of Record': {
		translation: 'Your System Of Record',
	},
	'Your Tax Withholding (W4) Info for this Check': {
		translation: 'Your Tax Withholding (W4) Info for this Check',
	},
	'Your Team': {
		translation: 'Your Team',
	},
	'Your Team Has Celebrations!': {
		translation: 'Your Team Has Celebrations!',
	},
	'Your Team Member Has a Celebration!': {
		translation: 'Your Team Member Has a Celebration!',
	},
	"Your Team's Goal Progress": {
		translation: "Your Team's Goal Progress",
	},
	'Your URL': {
		translation: 'Your URL',
	},
	'Your W-2 form is ready': {
		translation: 'Your W-2 form is ready',
	},
	'Your account has been locked. Please try again in %d minutes.': {
		translation:
			'Your account has been locked. Please try again in %d minutes.',
	},
	'Your account has been updated': {
		translation: 'Your account has been updated',
	},
	'Your account owner has been changed.': {
		translation: 'Your account owner has been changed.',
	},
	'Your account verification is complete': {
		translation: 'Your account verification is complete',
	},
	'Your account will be suspended by the end of the day.': {
		translation: 'Your account will be suspended by the end of the day.',
	},
	'Your account will be suspended by the end of the day. Please %1$s to review your billing information and make a payment to avoid suspension.':
		{
			translation:
				'Your account will be suspended by the end of the day. Please %1$s to review your billing information and make a payment to avoid suspension.',
		},
	'Your account will change to %s job opening.': {
		translation: {
			one: 'Your account will change to %s job opening.',
			other: 'Your account will change to %s job openings.',
		},
	},
	'Your all dbs query file will be available for download until %1$s.': {
		translation:
			'Your all dbs query file will be available for download until %1$s.',
	},
	'Your announcement has been published': {
		translation: 'Your announcement has been published',
	},
	'Your announcement has been published and emailed': {
		translation: 'Your announcement has been published and emailed',
	},
	'Your announcement has been published and emailed, but not all files were attached':
		{
			translation:
				'Your announcement has been published and emailed, but not all files were attached',
		},
	'Your announcement has been published, but not all files were attached': {
		translation:
			'Your announcement has been published, but not all files were attached',
	},
	'Your announcement has been saved as a draft': {
		translation: 'Your announcement has been saved as a draft',
	},
	'Your announcement has been saved as a draft, but not all files were attached':
		{
			translation:
				'Your announcement has been saved as a draft, but not all files were attached',
		},
	'Your answers to the following four questions are entirely optional.': {
		translation:
			'Your answers to the following four questions are entirely optional.',
	},
	'Your application was submitted successfully.': {
		translation: 'Your application was submitted successfully.',
	},
	'Your assessment does not exist. Your file(s) were not uploaded!': {
		translation:
			'Your assessment does not exist. Your file(s) were not uploaded!',
	},
	'Your assessment period is set to begin %1.': {
		translation: 'Your assessment period is set to begin %1.',
	},
	'Your assessment will be shared with %1$s on the date you select. You will not be able to edit the assessment.':
		{
			translation:
				'Your assessment will be shared with %1$s on the date you select. You will not be able to edit the assessment.',
		},
	'Your assessment will be shared with your manager and you will not be able to make any changes.':
		{
			translation:
				'Your assessment will be shared with your manager and you will not be able to make any changes.',
		},
	'Your billing information was updated.': {
		translation: 'Your billing information was updated.',
	},
	'Your broker can help you determine if this plan meets the ACA requirements, or you can learn more about %1minimum value requirements here%2 and %3minimum essential coverage here%4.':
		{
			translation:
				'Your broker can help you determine if this plan meets the ACA requirements, or you can learn more about %1minimum value requirements here%2 and %3minimum essential coverage here%4.',
		},
	'Your broker can help you determine if this plan meets the ACA requirements, or you can learn more about [minimum value requirements here](1) and [minimum essential coverage here](2).':
		{
			translation:
				'Your broker can help you determine if this plan meets the ACA requirements, or you can learn more about [minimum value requirements here](1) and [minimum essential coverage here](2).',
		},
	'Your changes have been requested.': {
		translation: 'Your changes have been requested.',
	},
	'Your changes have been saved': {
		translation: 'Your changes have been saved',
	},
	'Your changes have been saved, some of them will need to be approved.': {
		translation:
			'Your changes have been saved, some of them will need to be approved.',
	},
	'Your changes have been saved.': {
		translation: 'Your changes have been saved.',
	},
	'Your changes have been saved.  Some will need to be approved.': {
		translation:
			'Your changes have been saved.  Some will need to be approved.',
	},
	'Your changes to %1$s have been saved.': {
		translation: 'Your changes to %1$s have been saved.',
	},
	'Your changes to %s were saved, but there was an error updating location. Please go to location settings and try again.':
		{
			translation:
				'Your changes to %s were saved, but there was an error updating location. Please go to location settings and try again.',
		},
	'Your changes to %s were saved.': {
		translation: 'Your changes to %s were saved.',
	},
	'Your changes to the New Hire Packet were saved successfully.': {
		translation: 'Your changes to the New Hire Packet were saved successfully.',
	},
	'Your changes will be lost if you navigate away from this page without saving.':
		{
			translation:
				'Your changes will be lost if you navigate away from this page without saving.',
		},
	'Your color settings have been saved.': {
		translation: 'Your color settings have been saved.',
	},
	'Your comment was added successfully.': {
		translation: 'Your comment was added successfully.',
	},
	"Your comment will be added to each applicant you're updating.": {
		translation:
			"Your comment will be added to each applicant you're updating.",
	},
	'Your company and bank account info has been verified': {
		translation: 'Your company and bank account info has been verified',
	},
	"Your company doesn't have an active review period. Please contact your administrator.":
		{
			translation:
				"Your company doesn't have an active review period. Please contact your administrator.",
		},
	"Your company has disabled Performance Management in Bamboo. There's nothing to do here.":
		{
			translation:
				"Your company has disabled Performance Management in Bamboo. There's nothing to do here.",
		},
	'Your company has not yet completed its first performance assessment. Come back once your first review period is complete.':
		{
			translation:
				'Your company has not yet completed its first performance assessment. Come back once your first review period is complete.',
		},
	"Your company hasn't added any Links yet.": {
		translation: "Your company hasn't added any Links yet.",
	},
	'Your company needs at least one pay schedule syncing with payroll in order to run this report.':
		{
			translation:
				'Your company needs at least one pay schedule syncing with payroll in order to run this report.',
		},
	'Your custom site address is too long.': {
		translation: 'Your custom site address is too long.',
	},
	'Your custom site address may only contain numbers and letters.': {
		translation:
			'Your custom site address may only contain numbers and letters.',
	},
	'Your data': {
		translation: 'Your data',
	},
	'Your data (Loading...)': {
		translation: 'Your data (Loading...)',
	},
	'Your data contains employees that report to each other.  This can prevent the chart from displaying correctly.':
		{
			translation:
				'Your data contains employees that report to each other.  This can prevent the chart from displaying correctly.',
		},
	'Your domain has restricted API access. Please visit the "Security" settings in the Admin Console for your domain, and enable API access.':
		{
			translation:
				'Your domain has restricted API access. Please visit the \\"Security\\" settings in the Admin Console for your domain, and enable API access.',
		},
	'Your eNPS = *% of Promoters* – ': {
		translation: 'Your eNPS = *% of Promoters* – ',
	},
	'Your eNPS Score': {
		translation: 'Your eNPS Score',
	},
	'Your email has already been validated.': {
		translation: 'Your email has already been validated.',
	},
	'Your email is too big. Please shorten your message and/or remove large attachments':
		{
			translation:
				'Your email is too big. Please shorten your message and/or remove large attachments',
		},
	'Your email to %1$s is on its way!': {
		translation: 'Your email to %1$s is on its way!',
	},
	'Your email to %1$s is scheduled and will be sent %2$s!': {
		translation: 'Your email to %1$s is scheduled and will be sent %2$s!',
	},
	'Your email was not received': {
		translation: 'Your email was not received',
	},
	'Your email was not sent to the applicant as there is no longer a record of the applicant in BambooHR. If this is unexpected please reach out to the hiring lead or a BambooHR administrator for help.':
		{
			translation:
				'Your email was not sent to the applicant as there is no longer a record of the applicant in BambooHR. If this is unexpected please reach out to the hiring lead or a BambooHR administrator for help.',
		},
	'Your email was not sent to the applicant as there is no longer a record of the applicant in BambooHR.<br /><br />If this is unexpected please reach out to the hiring lead or a BambooHR administrator for help.':
		{
			translation:
				'Your email was not sent to the applicant as there is no longer a record of the applicant in BambooHR.<br /><br />If this is unexpected please reach out to the hiring lead or a BambooHR administrator for help.',
		},
	"Your email was unable to send as we could not locate the intended recipient's email address. Feel free to reach out to %1$s directly.  Sorry about the hassle.":
		{
			translation:
				"Your email was unable to send as we could not locate the intended recipient's email address. Feel free to reach out to %1$s directly.  Sorry about the hassle.",
		},
	"Your email was unable to send as we could not locate the intended recipient's email address.<br /><br />Feel free to reach out to %1$s directly.  Sorry about the hassle.":
		{
			translation:
				"Your email was unable to send as we could not locate the intended recipient's email address.<br /><br />Feel free to reach out to %1$s directly.  Sorry about the hassle.",
		},
	'Your emails are on their way!': {
		translation: 'Your emails are on their way!',
	},
	'Your employees are busy working.': {
		translation: 'Your employees are busy working.',
	},
	'Your employees are scheduled to begin using time tracking.': {
		translation: 'Your employees are scheduled to begin using time tracking.',
	},
	'Your employees were busy working.': {
		translation: 'Your employees were busy working.',
	},
	'Your employees will be able to start tracking their time through BambooHR immediately.':
		{
			translation:
				'Your employees will be able to start tracking their time through BambooHR immediately.',
		},
	'Your employment statuses need an ACA status.': {
		translation: 'Your employment statuses need an ACA status.',
	},
	'Your export file will be available for download until %1$s': {
		translation: 'Your export file will be available for download until %1$s',
	},
	'Your export file will be available for download until %1$s.': {
		translation: 'Your export file will be available for download until %1$s.',
	},
	'Your feedback is very important.': {
		translation: 'Your feedback is very important.',
	},
	'Your feedback will be kept completely [anonymous].': {
		translation: 'Your feedback will be kept completely [anonymous].',
	},
	"Your feedback will help %s know what to continue doing and how to improve--so please share what you feel will be most helpful. Oh, and don't worry %s will never see what you write.":
		{
			translation:
				"Your feedback will help %s know what to continue doing and how to improve--so please share what you feel will be most helpful. Oh, and don't worry %s will never see what you write.",
		},
	"Your feedback will help %s know what to continue doing and how to improve--so please share what you feel will be most helpful. Oh, and don't worry, %s will never see what you write.":
		{
			translation:
				"Your feedback will help %s know what to continue doing and how to improve--so please share what you feel will be most helpful. Oh, and don't worry, %s will never see what you write.",
		},
	'Your fields have been saved': {
		translation: 'Your fields have been saved',
	},
	'Your file has been sent.': {
		translation: 'Your file has been sent.',
	},
	'Your file is still uploading. Please try again once the upload is complete.':
		{
			translation:
				'Your file is still uploading. Please try again once the upload is complete.',
		},
	'Your file was deleted successfully': {
		translation: 'Your file was deleted successfully',
	},
	'Your file was uploaded successfully': {
		translation: 'Your file was uploaded successfully',
	},
	'Your filter has timed out and we can no longer filter the employees.  You can go back to the report to re-apply the filter.':
		{
			translation:
				'Your filter has timed out and we can no longer filter the employees.  You can go back to the report to re-apply the filter.',
		},
	'Your follow-up note has been saved.': {
		translation: 'Your follow-up note has been saved.',
	},
	'Your form has been successfully saved.': {
		translation: 'Your form has been successfully saved.',
	},
	'Your goal does not exist. Your file(s) were not uploaded!': {
		translation: 'Your goal does not exist. Your file(s) were not uploaded!',
	},
	'Your hours worked have been successfully recorded.': {
		translation: 'Your hours worked have been successfully recorded.',
	},
	'Your job opening for %s was added, but there was an error updating location. Please go to location settings and try again.':
		{
			translation:
				'Your job opening for %s was added, but there was an error updating location. Please go to location settings and try again.',
		},
	'Your job opening for %s was added.': {
		translation: 'Your job opening for %s was added.',
	},
	'Your link expired after 4 days.': {
		translation: 'Your link expired after 4 days.',
	},
	'Your logo & color settings have been saved.': {
		translation: 'Your logo & color settings have been saved.',
	},
	'Your logo must be a PNG, GIF or JPG file.': {
		translation: 'Your logo must be a PNG, GIF or JPG file.',
	},
	'Your manager assessment has been saved. You can come back and complete it later.':
		{
			translation:
				'Your manager assessment has been saved. You can come back and complete it later.',
		},
	'Your manager assessment has been successfully submitted.': {
		translation: 'Your manager assessment has been successfully submitted.',
	},
	"Your manager currently doesn't have access to BambooHR and can't complete your assessment.":
		{
			translation:
				"Your manager currently doesn't have access to BambooHR and can't complete your assessment.",
		},
	'Your message was sent! Our payroll administrators will reach out to you shortly.':
		{
			translation:
				'Your message was sent! Our payroll administrators will reach out to you shortly.',
		},
	'Your new employee will be able to enter their own personal information, sign paperwork, see their team, and more.':
		{
			translation:
				'Your new employee will be able to enter their own personal information, sign paperwork, see their team, and more.',
		},
	'Your new password has been saved.': {
		translation: 'Your new password has been saved.',
	},
	'Your new passwords do not match.': {
		translation: 'Your new passwords do not match.',
	},
	'Your next scheduled pay date is within 3 business days of today.': {
		translation:
			'Your next scheduled pay date is within 3 business days of today.',
	},
	'Your next scheduled pay date was already approved.': {
		translation: 'Your next scheduled pay date was already approved.',
	},
	'Your offer from %s': {
		translation: 'Your offer from %s',
	},
	'Your offer letter has been sent to %s. Watch the progress below.': {
		translation:
			'Your offer letter has been sent to %s. Watch the progress below.',
	},
	'Your offer letter is now saved as a draft.': {
		translation: 'Your offer letter is now saved as a draft.',
	},
	'Your org chart has employees that report to one another.': {
		translation: 'Your org chart has employees that report to one another.',
	},
	'Your password has been updated': {
		translation: 'Your password has been updated',
	},
	'Your password has been updated on all companies': {
		translation: 'Your password has been updated on all companies',
	},
	'Your password is invalid': {
		translation: 'Your password is invalid',
	},
	'Your pay schedule setting has been saved.': {
		translation: 'Your pay schedule setting has been saved.',
	},
	'Your pay stubs should show here soon...': {
		translation: 'Your pay stubs should show here soon...',
	},
	'Your payroll implementation rep will contact you soon': {
		translation: 'Your payroll implementation rep will contact you soon',
	},
	'Your payroll is ready to roll.': {
		translation: 'Your payroll is ready to roll.',
	},
	'Your payroll project manager will be reaching out to assist you with completing your payroll setup':
		{
			translation:
				'Your payroll project manager will be reaching out to assist you with completing your payroll setup',
		},
	'Your peers, manager, and direct reports.': {
		translation: 'Your peers, manager, and direct reports.',
	},
	'Your progress on this document has been saved! Come back anytime to finish it.':
		{
			translation:
				'Your progress on this document has been saved! Come back anytime to finish it.',
		},
	'Your project was saved successfully!': {
		translation: 'Your project was saved successfully!',
	},
	'Your rate change for %1$s has been saved and will take effect on %2$s.': {
		translation:
			'Your rate change for %1$s has been saved and will take effect on %2$s.',
	},
	'Your ratings have been updated': {
		translation: 'Your ratings have been updated',
	},
	'Your report has been sent.': {
		translation: 'Your report has been sent.',
	},
	'Your response could not be sent. Please reach out to the hiring lead directly':
		{
			translation:
				'Your response could not be sent. Please reach out to the hiring lead directly',
		},
	'Your results are excluded to promote confidentiality.': {
		translation: 'Your results are excluded to promote confidentiality.',
	},
	'Your self assessment has been saved. You can come back and complete it later.':
		{
			translation:
				'Your self assessment has been saved. You can come back and complete it later.',
		},
	'Your self assessment has been successfully submitted.': {
		translation: 'Your self assessment has been successfully submitted.',
	},
	"Your server's clock may be slow. Syncing your server's clock with a trusted internet time source should fix this issue.":
		{
			translation:
				"Your server's clock may be slow. Syncing your server's clock with a trusted internet time source should fix this issue.",
		},
	'Your settings have been saved.': {
		translation: 'Your settings have been saved.',
	},
	'Your snapshot has been created': {
		translation: 'Your snapshot has been created',
	},
	'Your snapshot has been deleted': {
		translation: 'Your snapshot has been deleted',
	},
	'Your snapshot has been restored and migrations have been run': {
		translation: 'Your snapshot has been restored and migrations have been run',
	},
	'Your survey is in full swing. Here’s how things are looking so far.': {
		translation:
			'Your survey is in full swing. Here’s how things are looking so far.',
	},
	'Your tag was sucessfully updated': {
		translation: 'Your tag was sucessfully updated',
	},
	'Your tax documents delivery preference has been saved.': {
		translation: 'Your tax documents delivery preference has been saved.',
	},
	'Your team members WILL NOT be able to see the feedback.': {
		translation: 'Your team members WILL NOT be able to see the feedback.',
	},
	'Your time off request has been submitted for review.': {
		translation: 'Your time off request has been submitted for review.',
	},
	'Your time off request has been updated and submitted for review.': {
		translation:
			'Your time off request has been updated and submitted for review.',
	},
	'Your timesheet has already been approved.': {
		translation: 'Your timesheet has already been approved.',
	},
	'Your timesheet was approved before you submitted your hours.': {
		translation: 'Your timesheet was approved before you submitted your hours.',
	},
	'Your top secret pay information is under here. Hover in here to see it.': {
		translation:
			'Your top secret pay information is under here. Hover in here to see it.',
	},
	'Your trial has ended': {
		translation: 'Your trial has ended',
	},
	'Your year end tax documents (W2 or 1099) will show up here. You will be notified by email when they are available.':
		{
			translation:
				'Your year end tax documents (W2 or 1099) will show up here. You will be notified by email when they are available.',
		},
	'You’ll need to re-select which field group has “Show History” checked.': {
		translation:
			'You’ll need to re-select which field group has “Show History” checked.',
	},
	'You’ll receive a paper check with any remaining balance.': {
		translation: 'You’ll receive a paper check with any remaining balance.',
	},
	'You’re Requesting %1$s %2$s off': {
		translation: 'You’re Requesting %1$s %2$s off',
	},
	'You’re all set, feel free to close this window and move on with your life.':
		{
			translation:
				'You’re all set, feel free to close this window and move on with your life.',
		},
	'You’re clearing out at least one time entry with a note. You will lose the note(s) associated with these entries if you continue.':
		{
			translation:
				'You’re clearing out at least one time entry with a note. You will lose the note(s) associated with these entries if you continue.',
		},
	'You’re good to go.': {
		translation: 'You’re good to go.',
	},
	'You’ve already requested time for this period.': {
		translation: 'You’ve already requested time for this period.',
	},
	'You’ve already signed this document.': {
		translation: 'You’ve already signed this document.',
	},
	'You’ve finished all the setup tasks!': {
		translation: 'You’ve finished all the setup tasks!',
	},
	'You’ve successfully signed this, but it’s still processing. Check back in a few minutes.':
		{
			translation:
				'You’ve successfully signed this, but it’s still processing. Check back in a few minutes.',
		},
	'Yup, I got it': {
		translation: 'Yup, I got it',
	},
	'Z to A': {
		translation: 'Z to A',
	},
	ZIP: {
		translation: 'ZIP',
	},
	'ZIP Code': {
		translation: 'ZIP Code',
	},
	'ZIP/Postal Code': {
		translation: 'ZIP/Postal Code',
	},
	'Ze/hir': {
		translation: 'Ze/hir',
	},
	'Ze/zir': {
		translation: 'Ze/zir',
	},
	"Zing!  You've updated 1 employee.  How's that for speedy?": {
		translation: {
			one: "Zing!  You've updated 1 employee.  How's that for speedy?",
			other: "Zing!  You've updated %d employees.  How's that for speedy?",
		},
	},
	Zip: {
		translation: 'Zip',
	},
	'Zip Code': {
		translation: 'Zip Code',
	},
	'Zip/Postal Code': {
		translation: 'Zip/Postal Code',
	},
	'Zipcode is required': {
		translation: 'Zipcode is required',
	},
	'Zoinks! This file is too big. The maximum file size is 20 MB.': {
		translation:
			'Zoinks! This file is too big. The maximum file size is 20 MB.',
	},
	Zoom: {
		translation: 'Zoom',
	},
	'Zoom In': {
		translation: 'Zoom In',
	},
	'Zoom Out': {
		translation: 'Zoom Out',
	},
	'[BambooHR - Gusto] Errors during synchronization': {
		translation: '[BambooHR - Gusto] Errors during synchronization',
	},
	'[Deleted Field]': {
		translation: '[Deleted Field]',
	},
	'[disabled]': {
		translation: '[disabled]',
	},
	'a month ago ': {
		translation: {
			one: 'a month ago ',
			other: '%s months ago',
		},
	},
	'a new policy': {
		translation: 'a new policy',
	},
	'a specific day': {
		translation: 'a specific day',
	},
	'a week ago ': {
		translation: {
			one: 'a week ago ',
			other: '%s weeks ago',
		},
	},
	'a year ago ': {
		translation: {
			one: 'a year ago ',
			other: '%s years ago',
		},
	},
	'a.) What kind of work will you be doing?': {
		translation: 'a.) What kind of work will you be doing?',
	},
	'action link': {
		translation: 'action link',
	},
	add: {
		translation: 'add',
	},
	added: {
		translation: 'added',
	},
	after: {
		translation: 'after',
	},
	'after hire date': {
		translation: 'after hire date',
	},
	'after hire.': {
		translation: 'after hire.',
	},
	'after the request is made': {
		translation: 'after the request is made',
	},
	all: {
		translation: 'all',
	},
	'all employees': {
		translation: 'all employees',
	},
	'all rows': {
		translation: 'all rows',
	},
	'an hour ago': {
		translation: {
			one: 'an hour ago',
			other: '%s hours ago',
		},
	},
	and: {
		translation: 'and',
	},
	'and %1 others...': {
		translation: 'and %1 others...',
	},
	'and %1$s more...': {
		translation: 'and %1$s more...',
	},
	'and %s more...': {
		translation: 'and %s more...',
	},
	'and %s others...': {
		translation: 'and %s others...',
	},
	'and can carry over up to %s %s': {
		translation: 'and can carry over up to %s %s',
	},
	'and lose all time not used by %s': {
		translation: 'and lose all time not used by %s',
	},
	'and lose all time not used by your anniversary date': {
		translation: 'and lose all time not used by your anniversary date',
	},
	'and so on...': {
		translation: 'and so on...',
	},
	'and the': {
		translation: 'and the',
	},
	'and there is no limit to the number of %s you can carry over': {
		translation: 'and there is no limit to the number of %s you can carry over',
	},
	'and your State Withholding is': {
		translation: 'and your State Withholding is',
	},
	'and your State Withholding was': {
		translation: 'and your State Withholding was',
	},
	'and your State Withholding was **{1}**': {
		translation: 'and your State Withholding was **{1}**',
	},
	'and...': {
		translation: 'and...',
	},
	any: {
		translation: 'any',
	},
	approved: {
		translation: 'approved',
	},
	assigned: {
		translation: 'assigned',
	},
	'assigned date': {
		translation: 'assigned date',
	},
	at: {
		translation: 'at',
	},
	'b.) How did you learn about the job?': {
		translation: 'b.) How did you learn about the job?',
	},
	'bar chart': {
		translation: 'bar chart',
	},
	before: {
		translation: 'before',
	},
	'before the pay date': {
		translation: 'before the pay date',
	},
	'benefit effective date': {
		translation: 'benefit effective date',
	},
	'benefit plan': {
		translation: 'benefit plan',
	},
	'benefit plans': {
		translation: 'benefit plans',
	},
	'benefitPlanId and effectiveDate are required': {
		translation: 'benefitPlanId and effectiveDate are required',
	},
	'benefitPlanIds and employeeIds are required': {
		translation: 'benefitPlanIds and employeeIds are required',
	},
	between: {
		translation: 'between',
	},
	'by ': {
		translation: 'by ',
	},
	'by {1}': {
		translation: 'by {1}',
	},
	'c.) What made it attractive to you?': {
		translation: 'c.) What made it attractive to you?',
	},
	cancel: {
		translation: 'cancel',
	},
	'cancel this offer?': {
		translation: 'cancel this offer?',
	},
	canceled: {
		translation: 'canceled',
	},
	'canceled: %1$s': {
		translation: 'canceled: %1$s',
	},
	change: {
		translation: 'change',
	},
	'change the setting, and then re-enroll employees': {
		translation: 'change the setting, and then re-enroll employees',
	},
	'changes as completed. Are you sure that you ': {
		translation: 'changes as completed. Are you sure that you ',
	},
	'close modal': {
		translation: 'close modal',
	},
	'commented on your goals': {
		translation: 'commented on your goals',
	},
	'commented on your goals.': {
		translation: 'commented on your goals.',
	},
	companydomain: {
		translation: 'companydomain',
	},
	'contact you once we receive a verification response.': {
		translation: 'contact you once we receive a verification response.',
	},
	contains: {
		translation: 'contains',
	},
	copy: {
		translation: 'copy',
	},
	count: {
		translation: 'count',
	},
	'currently not in a benefit group': {
		translation: 'currently not in a benefit group',
	},
	'd.) What will your new salary be? (Note: this information will be kept confidential)':
		{
			translation:
				'd.) What will your new salary be? (Note: this information will be kept confidential)',
		},
	daily: {
		translation: 'daily',
	},
	'date range': {
		translation: 'date range',
	},
	day: {
		translation: {
			one: 'day',
			other: 'days',
		},
	},
	'day of': {
		translation: 'day of',
	},
	'day of %2$s': {
		translation: {
			one: 'day of %2$s',
			other: 'days of %2$s',
		},
	},
	'day(s) after the period ends': {
		translation: 'day(s) after the period ends',
	},
	days: {
		translation: 'days',
	},
	'days after hire date': {
		translation: 'days after hire date',
	},
	'days ago': {
		translation: 'days ago',
	},
	'days left in your free trial. Call 1-800-342-3523 to sign up!': {
		translation:
			'days left in your free trial. Call 1-800-342-3523 to sign up!',
	},
	decrease: {
		translation: 'decrease',
	},
	delete: {
		translation: 'delete',
	},
	'delete "%1$s" ?': {
		translation: 'delete \\"%1$s\\" ?',
	},
	'delete this user?': {
		translation: 'delete this user?',
	},
	deleted: {
		translation: 'deleted',
	},
	denied: {
		translation: 'denied',
	},
	'deposited to %1$s %2$s': {
		translation: 'deposited to %1$s %2$s',
	},
	'does not contain': {
		translation: 'does not contain',
	},
	'does not equal': {
		translation: 'does not equal',
	},
	'does not include': {
		translation: 'does not include',
	},
	"doesn't": {
		translation: "doesn't",
	},
	"don't": {
		translation: "don't",
	},
	'e.g. $10-$15 Hourly DOE': {
		translation: 'e.g. $10-$15 Hourly DOE',
	},
	'e.g. $500,000 term coverage': {
		translation: 'e.g. $500,000 term coverage',
	},
	'e.g. Aetna Disability': {
		translation: 'e.g. Aetna Disability',
	},
	'e.g. Aflac - Health Insurance': {
		translation: 'e.g. Aflac - Health Insurance',
	},
	'e.g. Blue Cross - FSA': {
		translation: 'e.g. Blue Cross - FSA',
	},
	'e.g. Blue Cross - HSA': {
		translation: 'e.g. Blue Cross - HSA',
	},
	'e.g. Colonial Life Insurance': {
		translation: 'e.g. Colonial Life Insurance',
	},
	'e.g. Company events are announced monthly': {
		translation: 'e.g. Company events are announced monthly',
	},
	'e.g. Company matches up to 6%': {
		translation: 'e.g. Company matches up to 6%',
	},
	'e.g. Company matches up to 6%%': {
		translation: 'e.g. Company matches up to 6%%',
	},
	'e.g. Covers 60% of current salary': {
		translation: 'e.g. Covers 60% of current salary',
	},
	'e.g. Covers 60%% of current salary': {
		translation: 'e.g. Covers 60%% of current salary',
	},
	'e.g. Dental Select': {
		translation: 'e.g. Dental Select',
	},
	'e.g. Full Time Employees': {
		translation: 'e.g. Full Time Employees',
	},
	'e.g. Full-Time Sales': {
		translation: 'e.g. Full-Time Sales',
	},
	'e.g. Humana - Vision Insurance': {
		translation: 'e.g. Humana - Vision Insurance',
	},
	'e.g. Invitation to phone screen': {
		translation: 'e.g. Invitation to phone screen',
	},
	'e.g. Receipts must be turned in to accounting.': {
		translation: 'e.g. Receipts must be turned in to accounting.',
	},
	'e.g. Salary Vacation Policy': {
		translation: 'e.g. Salary Vacation Policy',
	},
	'e.g. SelectHealth - Platinum': {
		translation: 'e.g. SelectHealth - Platinum',
	},
	'e.g. Sponsored Fitness Program': {
		translation: 'e.g. Sponsored Fitness Program',
	},
	'e.g. Tuition Reimbursement': {
		translation: 'e.g. Tuition Reimbursement',
	},
	'e.g. Vacation': {
		translation: 'e.g. Vacation',
	},
	'e.g. Variable Rate Health - Platinum': {
		translation: 'e.g. Variable Rate Health - Platinum',
	},
	'e.g. Wealthfront - 401(k)': {
		translation: 'e.g. Wealthfront - 401(k)',
	},
	'e.g. executives, tenure, salary band': {
		translation: 'e.g. executives, tenure, salary band',
	},
	'eNPS Keyword Breakdown': {
		translation: 'eNPS Keyword Breakdown',
	},
	'eNPS Refresher Video': {
		translation: 'eNPS Refresher Video',
	},
	'eNPS Report': {
		translation: 'eNPS Report',
	},
	'eNPS Setup': {
		translation: 'eNPS Setup',
	},
	'eNPS Survey Import complete for ': {
		translation: 'eNPS Survey Import complete for ',
	},
	'eNPS Survey Response Import for ': {
		translation: 'eNPS Survey Response Import for ',
	},
	'eNPS Trend': {
		translation: 'eNPS Trend',
	},
	'eNPS is a standard way to measure the happiness and satisfaction of your employees using surveys. Employees are asked the question “On a scale of 0–10, how likely are you to refer your company as a place to work?” and then a follow up question to explain their answer. The follow up question depends on the score they give:':
		{
			translation:
				'eNPS is a standard way to measure the happiness and satisfaction of your employees using surveys. Employees are asked the question “On a scale of 0–10, how likely are you to refer your company as a place to work?” and then a follow up question to explain their answer. The follow up question depends on the score they give:',
		},
	edit: {
		translation: 'edit',
	},
	'edit filename': {
		translation: 'edit filename',
	},
	edited: {
		translation: 'edited',
	},
	employee: {
		translation: 'employee',
	},
	'employee + child(ren)': {
		translation: 'employee + child(ren)',
	},
	'employee + family': {
		translation: 'employee + family',
	},
	'employee + spouse': {
		translation: 'employee + spouse',
	},
	'employee avatar': {
		translation: 'employee avatar',
	},
	'employee hire date': {
		translation: 'employee hire date',
	},
	'employee matches': {
		translation: 'employee matches',
	},
	'employee termination date': {
		translation: 'employee termination date',
	},
	'employeeDeductionId is not found': {
		translation: 'employeeDeductionId is not found',
	},
	'employeeId is not found': {
		translation: 'employeeId is not found',
	},
	'employeeIds are required': {
		translation: 'employeeIds are required',
	},
	employees: {
		translation: 'employees',
	},
	'employees match': {
		translation: 'employees match',
	},
	engagement: {
		translation: 'engagement',
	},
	'eor Annual Pay': {
		translation: 'eor Annual Pay',
	},
	'equal to': {
		translation: 'equal to',
	},
	'equal to or greater than': {
		translation: 'equal to or greater than',
	},
	'equal to or less than': {
		translation: 'equal to or less than',
	},
	equals: {
		translation: 'equals',
	},
	error: {
		translation: 'error',
	},
	every: {
		translation: 'every',
	},
	'every other week on %s': {
		translation: 'every other week on %s',
	},
	expired: {
		translation: 'expired',
	},
	family: {
		translation: 'family',
	},
	'field can be no more than %1$s characters': {
		translation: 'field can be no more than %1$s characters',
	},
	'field contains inappropriate characters. Cannot contain any of the following characters: %1$s':
		{
			translation:
				'field contains inappropriate characters. Cannot contain any of the following characters: %1$s',
		},
	'field data has been lost. Please try re-uploading': {
		translation: 'field data has been lost. Please try re-uploading',
	},
	'field is in invalid format.': {
		translation: 'field is in invalid format.',
	},
	'field is in invalid format. Valid format is %1$s': {
		translation: 'field is in invalid format. Valid format is %1$s',
	},
	'field is required': {
		translation: 'field is required',
	},
	'field may only contain the following characters: %1$s': {
		translation: 'field may only contain the following characters: %1$s',
	},
	first: {
		translation: 'first',
	},
	'fit the filters that you set. Try adding or removing filters.': {
		translation:
			'fit the filters that you set. Try adding or removing filters.',
	},
	for: {
		translation: 'for',
	},
	'for great people to join our team in the future.': {
		translation: 'for great people to join our team in the future.',
	},
	four: {
		translation: 'four',
	},
	fourth: {
		translation: 'fourth',
	},
	'go to billing': {
		translation: 'go to billing',
	},
	'goes to ': {
		translation: 'goes to ',
	},
	'greater than': {
		translation: 'greater than',
	},
	'has an invalid value': {
		translation: 'has an invalid value',
	},
	'help guides.': {
		translation: 'help guides.',
	},
	'here.': {
		translation: 'here.',
	},
	herself: {
		translation: 'herself',
	},
	himself: {
		translation: 'himself',
	},
	'hire date': {
		translation: 'hire date',
	},
	holiday: {
		translation: 'holiday',
	},
	home: {
		translation: 'home',
	},
	hour: {
		translation: {
			one: 'hour',
			other: 'hours',
		},
	},
	'hour of %2$s': {
		translation: {
			one: 'hour of %2$s',
			other: 'hours of %2$s',
		},
	},
	hours: {
		translation: 'hours',
	},
	'hours for': {
		translation: 'hours for',
	},
	'iApplicants allows you to transfer information about an applicant directly into BambooHR creating a new employee record. To do this, view the information about the applicant in question, and select an option from the "Position Hired For" drop-down field. You will then need to click the "Save" button at the bottom of the screen.':
		{
			translation:
				'iApplicants allows you to transfer information about an applicant directly into BambooHR creating a new employee record. To do this, view the information about the applicant in question, and select an option from the \\"Position Hired For\\" drop-down field. You will then need to click the \\"Save\\" button at the bottom of the screen.',
		},
	'iApplicants&trade; provides Employer Careers Websites and Application Management Systems designed to be Flexible, Easy to Use, and Inexpensive. Even the smallest employer can afford to leave their paper application behind for a web-based hiring system. Our system is powerful enough to get the job done, but easy enough that your receptionist could run it!':
		{
			translation:
				'iApplicants&trade; provides Employer Careers Websites and Application Management Systems designed to be Flexible, Easy to Use, and Inexpensive. Even the smallest employer can afford to leave their paper application behind for a web-based hiring system. Our system is powerful enough to get the job done, but easy enough that your receptionist could run it!',
		},
	iCal: {
		translation: 'iCal',
	},
	'iCal Feeds': {
		translation: 'iCal Feeds',
	},
	'iCalendar Feeds': {
		translation: 'iCalendar Feeds',
	},
	"iCalendar feeds allow users to pull calendar information (who's out, birthdays, etc.) from BambooHR into programs like Microsoft Outlook, Google Calendar and Apple Calendar.":
		{
			translation:
				"iCalendar feeds allow users to pull calendar information (who's out, birthdays, etc.) from BambooHR into programs like Microsoft Outlook, Google Calendar and Apple Calendar.",
		},
	'iCalendar feeds allow you to pull BambooHR calendar information into calendars like macOS Calendar, Microsoft Outlook, or Google Calendar.':
		{
			translation:
				'iCalendar feeds allow you to pull BambooHR calendar information into calendars like macOS Calendar, Microsoft Outlook, or Google Calendar.',
		},
	'iCalendar feeds allow you to pull calendar information into programs like Mac iCal, Microsoft Outlook, or Google Calendar. These feeds are NOT password protected, so if you feel the link has been shared with the wrong person you can reset the URL.':
		{
			translation:
				'iCalendar feeds allow you to pull calendar information into programs like Mac iCal, Microsoft Outlook, or Google Calendar. These feeds are NOT password protected, so if you feel the link has been shared with the wrong person you can reset the URL.',
		},
	'iCalendar feeds are publicly viewable to anyone who has the URL. However, a unique URL is created for each user and can be reset for security purposes (Example URL: %s)':
		{
			translation:
				'iCalendar feeds are publicly viewable to anyone who has the URL. However, a unique URL is created for each user and can be reset for security purposes (Example URL: %s)',
		},
	in: {
		translation: 'in',
	},
	'in ': {
		translation: 'in ',
	},
	'in %s': {
		translation: 'in %s',
	},
	'in Department': {
		translation: 'in Department',
	},
	'in group': {
		translation: 'in group',
	},
	'in last 30 days': {
		translation: 'in last 30 days',
	},
	'in this benefit group': {
		translation: 'in this benefit group',
	},
	includes: {
		translation: 'includes',
	},
	increase: {
		translation: 'increase',
	},
	info: {
		translation: 'info',
	},
	'invalid tasklist/employee': {
		translation: 'invalid tasklist/employee',
	},
	'invalid time off type id': {
		translation: 'invalid time off type id',
	},
	'invalid webhook id': {
		translation: 'invalid webhook id',
	},
	is: {
		translation: 'is',
	},
	'is active': {
		translation: 'is active',
	},
	'is after': {
		translation: 'is after',
	},
	'is before': {
		translation: 'is before',
	},
	'is blank': {
		translation: 'is blank',
	},
	'is checked': {
		translation: 'is checked',
	},
	'is during': {
		translation: 'is during',
	},
	'is not': {
		translation: 'is not',
	},
	'is not active': {
		translation: 'is not active',
	},
	'is not blank': {
		translation: 'is not blank',
	},
	'is not checked': {
		translation: 'is not checked',
	},
	'is not equal to': {
		translation: 'is not equal to',
	},
	'is on': {
		translation: 'is on',
	},
	'is on or after': {
		translation: 'is on or after',
	},
	'is on or before': {
		translation: 'is on or before',
	},
	'is requesting:': {
		translation: 'is requesting:',
	},
	keep: {
		translation: 'keep',
	},
	last: {
		translation: 'last',
	},
	'last day': {
		translation: 'last day',
	},
	left: {
		translation: 'left',
	},
	'less than': {
		translation: 'less than',
	},
	'link opens in a new tab': {
		translation: 'link opens in a new tab',
	},
	'link to this job': {
		translation: 'link to this job',
	},
	loading: {
		translation: 'loading',
	},
	month_one: {
		translation: 'month',
	},
	month_other: {
		translation: '',
	},
	'monthly on the %s': {
		translation: 'monthly on the %s',
	},
	'monthly on the last day of the month': {
		translation: 'monthly on the last day of the month',
	},
	months: {
		translation: 'months',
	},
	'months ago': {
		translation: 'months ago',
	},
	more: {
		translation: 'more',
	},
	'more Benefit': {
		translation: 'more Benefit',
	},
	'more Benefits': {
		translation: 'more Benefits',
	},
	'more Goal': {
		translation: 'more Goal',
	},
	'more Goals': {
		translation: 'more Goals',
	},
	'more Training': {
		translation: 'more Training',
	},
	'more Trainings': {
		translation: 'more Trainings',
	},
	'more info': {
		translation: 'more info',
	},
	'more people': {
		translation: 'more people',
	},
	'more person': {
		translation: 'more person',
	},
	'most common': {
		translation: 'most common',
	},
	'most run': {
		translation: 'most run',
	},
	'n/a': {
		translation: 'n/a',
	},
	'name is required': {
		translation: 'name is required',
	},
	'needs translation': {
		translation: 'needs translation',
	},
	next: {
		translation: 'next',
	},
	no: {
		translation: 'no',
	},
	'no employee': {
		translation: 'no employee',
	},
	'no name': {
		translation: 'no name',
	},
	'no package': {
		translation: 'no package',
	},
	'no tasklist': {
		translation: 'no tasklist',
	},
	nothing: {
		translation: 'nothing',
	},
	of: {
		translation: 'of',
	},
	'of Gross': {
		translation: 'of Gross',
	},
	'of Net': {
		translation: 'of Net',
	},
	'of each check': {
		translation: 'of each check',
	},
	'of each check into': {
		translation: 'of each check into',
	},
	'of each check into:': {
		translation: 'of each check into:',
	},
	'of each month': {
		translation: 'of each month',
	},
	'of gross pay': {
		translation: 'of gross pay',
	},
	'of gross pay, per paycheck': {
		translation: 'of gross pay, per paycheck',
	},
	'of net pay': {
		translation: 'of net pay',
	},
	'of the following conditions:': {
		translation: 'of the following conditions:',
	},
	'of the remaining amount': {
		translation: 'of the remaining amount',
	},
	'of the remaining amount into': {
		translation: 'of the remaining amount into',
	},
	'of the remaining amount into:': {
		translation: 'of the remaining amount into:',
	},
	old: {
		translation: 'old',
	},
	'older Notification': {
		translation: 'older Notification',
	},
	'older Notifications': {
		translation: 'older Notifications',
	},
	on: {
		translation: 'on',
	},
	'on %1': {
		translation: 'on %1',
	},
	'on step %1 of %2': {
		translation: 'on step %1 of %2',
	},
	'on the': {
		translation: 'on the',
	},
	"on the anniversary of the employee's hire date.": {
		translation: "on the anniversary of the employee's hire date.",
	},
	'on the anniversary of their hire date': {
		translation: 'on the anniversary of their hire date',
	},
	one: {
		translation: 'one',
	},
	'only employees': {
		translation: 'only employees',
	},
	'only rows': {
		translation: 'only rows',
	},
	'only viewable employees': {
		translation: 'only viewable employees',
	},
	optional: {
		translation: 'optional',
	},
	'optional, not signed': {
		translation: 'optional, not signed',
	},
	'optional, signed': {
		translation: 'optional, signed',
	},
	or: {
		translation: 'or',
	},
	'or %1$s': {
		translation: 'or %1$s',
	},
	overtime: {
		translation: 'overtime',
	},
	'past due': {
		translation: 'past due',
	},
	'pay date_one': {
		translation: 'pay date',
	},
	'pay date_other': {
		translation: '',
	},
	'pay dates': {
		translation: 'pay dates',
	},
	pays: {
		translation: 'pays',
	},
	per: {
		translation: 'per',
	},
	'per ': {
		translation: 'per ',
	},
	'per hour worked': {
		translation: 'per hour worked',
	},
	'per hour worked (estimated for salary)': {
		translation: 'per hour worked (estimated for salary)',
	},
	'per month': {
		translation: 'per month',
	},
	'per pay period': {
		translation: 'per pay period',
	},
	'per paycheck': {
		translation: 'per paycheck',
	},
	'permission denied': {
		translation: 'permission denied',
	},
	'personal information.': {
		translation: 'personal information.',
	},
	'plus an additional': {
		translation: 'plus an additional',
	},
	policy: {
		translation: 'policy',
	},
	'profile picture': {
		translation: 'profile picture',
	},
	'provided as a paper check': {
		translation: 'provided as a paper check',
	},
	'quarterly on %s, %s, %s, and %s': {
		translation: 'quarterly on %s, %s, %s, and %s',
	},
	'rated %s stars': {
		translation: 'rated %s stars',
	},
	reconciled: {
		translation: 'reconciled',
	},
	regular: {
		translation: 'regular',
	},
	'relative to the benefit effective date': {
		translation: 'relative to the benefit effective date',
	},
	remove: {
		translation: 'remove',
	},
	'remove file': {
		translation: 'remove file',
	},
	'repeating every': {
		translation: 'repeating every',
	},
	'reportId must be set to the report ID the modal will show for.': {
		translation:
			'reportId must be set to the report ID the modal will show for.',
	},
	requested: {
		translation: 'requested',
	},
	required: {
		translation: 'required',
	},
	'required, not signed': {
		translation: 'required, not signed',
	},
	'required, signed': {
		translation: 'required, signed',
	},
	right: {
		translation: 'right',
	},
	salary: {
		translation: 'salary',
	},
	second: {
		translation: 'second',
	},
	seconds: {
		translation: 'seconds',
	},
	'showModal must be set to either 0(false) or 1(true)': {
		translation: 'showModal must be set to either 0(false) or 1(true)',
	},
	'singular %s': {
		translation: {
			one: 'singular %s',
			other: 'plural %s',
		},
	},
	'soonest is due ': {
		translation: 'soonest is due ',
	},
	span: {
		translation: 'span',
	},
	star: {
		translation: {
			one: 'star',
			other: 'stars',
		},
	},
	success: {
		translation: 'success',
	},
	superseded: {
		translation: 'superseded',
	},
	tag: {
		translation: 'tag',
	},
	'termination date': {
		translation: 'termination date',
	},
	test: {
		translation: 'test',
	},
	testeditclass: {
		translation: 'testeditclass',
	},
	'that match': {
		translation: 'that match',
	},
	'the benefit effective date': {
		translation: 'the benefit effective date',
	},
	'the benefit effective date.': {
		translation: 'the benefit effective date.',
	},
	'the filters that you set but are not in the benefit group': {
		translation: 'the filters that you set but are not in the benefit group',
	},
	'the last day of %s': {
		translation: 'the last day of %s',
	},
	'the love child of HR awesomeness and simple payroll.': {
		translation: 'the love child of HR awesomeness and simple payroll.',
	},
	'the names of files attached to offer letter templates are viewable by anyone with this permission, regardless of individual file permissions.':
		{
			translation:
				'the names of files attached to offer letter templates are viewable by anyone with this permission, regardless of individual file permissions.',
		},
	'the normal base rate': {
		translation: 'the normal base rate',
	},
	'the user': {
		translation: 'the user',
	},
	'then by ': {
		translation: 'then by ',
	},
	'these employees': {
		translation: 'these employees',
	},
	third: {
		translation: 'third',
	},
	'this employee is the hiring lead for one or more job openings.': {
		translation:
			'this employee is the hiring lead for one or more job openings.',
	},
	'this job': {
		translation: 'this job',
	},
	'this training': {
		translation: 'this training',
	},
	timeToHire: {
		translation: 'timeToHire',
	},
	'times every': {
		translation: 'times every',
	},
	to: {
		translation: 'to',
	},
	'to %1$s %2$s': {
		translation: 'to %1$s %2$s',
	},
	'to add.': {
		translation: 'to add.',
	},
	today: {
		translation: 'today',
	},
	'today at': {
		translation: 'today at',
	},
	total: {
		translation: 'total',
	},
	'total for %s': {
		translation: 'total for %s',
	},
	'trial exp. %1$s': {
		translation: 'trial exp. %1$s',
	},
	'twice a month on the %s and %s': {
		translation: 'twice a month on the %s and %s',
	},
	'twice a year on %s and %s': {
		translation: 'twice a year on %s and %s',
	},
	two: {
		translation: 'two',
	},
	'two-party': {
		translation: 'two-party',
	},
	'unable to access webhook details': {
		translation: 'unable to access webhook details',
	},
	'unassigned policy': {
		translation: 'unassigned policy',
	},
	'unenroll all employees in the plan type': {
		translation: 'unenroll all employees in the plan type',
	},
	unreconciled: {
		translation: 'unreconciled',
	},
	update: {
		translation: 'update',
	},
	upwards: {
		translation: 'upwards',
	},
	'user does not have permissions': {
		translation: 'user does not have permissions',
	},
	'valid folder name required': {
		translation: 'valid folder name required',
	},
	value: {
		translation: 'value',
	},
	'want to continue?': {
		translation: 'want to continue?',
	},
	warning: {
		translation: 'warning',
	},
	week_one: {
		translation: 'week',
	},
	week_other: {
		translation: '',
	},
	'weekly on %s': {
		translation: 'weekly on %s',
	},
	weeks: {
		translation: 'weeks',
	},
	'weeks ago': {
		translation: 'weeks ago',
	},
	'which is currently set as the default level for Payroll Admins': {
		translation:
			'which is currently set as the default level for Payroll Admins',
	},
	'will be eligible for these plans automatically.': {
		translation: 'will be eligible for these plans automatically.',
	},
	'will be eligible on %s': {
		translation: 'will be eligible on %s',
	},
	'will be enrolled on %s': {
		translation: 'will be enrolled on %s',
	},
	'will be ineligible on %s': {
		translation: 'will be ineligible on %s',
	},
	'will be terminated on %s': {
		translation: 'will be terminated on %s',
	},
	'will be updated on %s': {
		translation: 'will be updated on %s',
	},
	'will be waived on %s': {
		translation: 'will be waived on %s',
	},
	'will be withdrawn on %s': {
		translation: 'will be withdrawn on %s',
	},
	'with ': {
		translation: 'with ',
	},
	work: {
		translation: 'work',
	},
	'work and home': {
		translation: 'work and home',
	},
	x: {
		translation: 'x',
	},
	'x.509 Certificate': {
		translation: 'x.509 Certificate',
	},
	year_one: {
		translation: 'year',
	},
	year_other: {
		translation: '',
	},
	'yearly on %s': {
		translation: 'yearly on %s',
	},
	years: {
		translation: 'years',
	},
	yes: {
		translation: 'yes',
	},
	'you do not have access to this employee': {
		translation: 'you do not have access to this employee',
	},
	'you do not have permissions to add folder to base level': {
		translation: 'you do not have permissions to add folder to base level',
	},
	'you do not have permissions to edit the folder': {
		translation: 'you do not have permissions to edit the folder',
	},
	'you do not have permissions to modify a default folder': {
		translation: 'you do not have permissions to modify a default folder',
	},
	'you do not have the permissions to access the files in this section for this employee':
		{
			translation:
				'you do not have the permissions to access the files in this section for this employee',
		},
	"your employees' enrollments will not be affected.": {
		translation: "your employees' enrollments will not be affected.",
	},
	zoom: {
		translation: 'zoom',
	},
	'{1}': {
		translation: '{1}',
	},
	'{1}  {2}!': {
		translation: '{1}  {2}!',
	},
	'{1} **{2}**:': {
		translation: '{1} **{2}**:',
	},
	'{1} Assessment': {
		translation: '{1} Assessment',
	},
	'{1} Candidates Selected on this page.': {
		translation: '{1} Candidates Selected on this page.',
	},
	'{1} Filters Applied': {
		translation: '{1} Filters Applied',
	},
	'{1} Offers Pending!': {
		translation: '{1} Offers Pending!',
	},
	'{1} Participant ID:': {
		translation: '{1} Participant ID:',
	},
	'{1} WILL NOT SEE Your Answers to These 2 Questions': {
		translation: '{1} WILL NOT SEE Your Answers to These 2 Questions',
	},
	'{1} WILL SEE Your Answers to The Following Questions': {
		translation: '{1} WILL SEE Your Answers to The Following Questions',
	},
	'{1} and {2} more...': {
		translation: '{1} and {2} more...',
	},
	'{1} at {2}': {
		translation: '{1} at {2}',
	},
	"{1} doesn't have any completed goals.": {
		translation: "{1} doesn't have any completed goals.",
	},
	"{1} doesn't have any goals in progress.": {
		translation: "{1} doesn't have any goals in progress.",
	},
	'{1} has until {2} ({3} days) to complete this.': {
		translation: '{1} has until {2} ({3} days) to complete this.',
	},
	'| Storage Used:': {
		translation: '| Storage Used:',
	},
	'« Back to %s': {
		translation: '« Back to %s',
	},
	'–Select Access Level–': {
		translation: '–Select Access Level–',
	},
	'–Select–': {
		translation: '–Select–',
	},
	'“How likely are you to refer your company as a place to work?”': {
		translation:
			'“How likely are you to refer your company as a place to work?”',
	},
	'%1$s Training Completed_The number of training tasks completed': {
		translation: {
			one: '%1$s Training Completed',
			other: '%1$s Trainings Completed',
		},
	},
	'%1$s at %2$s_date time, like Apr 31, 2012 at 5:34 PM': {
		translation: '%1$s at %2$s',
	},
	'%1$s day_singular': {
		translation: '%1$s day',
	},
	'1 year_singular': {
		translation: '1 year',
	},
	Age_singular: {
		translation: 'Age',
	},
	Yesterday_singular: {
		translation: 'Yesterday',
	},
	'(MTD)_Month to date': {
		translation: '(MTD)',
	},
	'(QTD)_Quarter to date': {
		translation: '(QTD)',
	},
	'(YTD)_Year to date': {
		translation: '(YTD)',
	},
	'1 year_duration-singular': {
		translation: '1 year',
	},
	'Accrued_Amount of time off accrued': {
		translation: 'Accrued',
	},
	'Adjustments_Adjustments to the time off balance': {
		translation: 'Adjustments',
	},
	'All_Filter option for all employee trainings': {
		translation: 'All',
	},
	'All_Filter option for all years of employee trainings': {
		translation: 'All',
	},
	'An email\'s "subject"_An email\'s "subject"': {
		translation: 'An email\'s "subject"',
	},
	'CSV_Comma-separated values': {
		translation: 'CSV',
	},
	'Could not sync [%s]. Google responded with [%s]._An unexpected Google API error message':
		{
			translation: 'Could not sync %s. Google responded with %s.',
		},
	'Could not sync [%s]. Jumpcloud responded with [%s]._An unexpected error message':
		{
			translation: 'Could not sync %s. Jumpcloud responded with %s.',
		},
	"Couldn't sync department for employee: %s. Error message: %s_Couldn't assign a valid department for this employee. An error message follows.":
		{
			translation:
				"Couldn't sync department for employee: %s. Error message: %s",
		},
	"Couldn't sync employee: %s. No hire date was set for employee. Please set the employee's hire date._A BambooHR hire date doesn't exist for this employee":
		{
			translation:
				"Couldn't sync employee: %s. No hire date was set for employee. Please set the employee's hire date.",
		},
	"Couldn't sync employee: %s. No matching subsidiaries were found for division: %s. Please verify that this division matches a Netsuite Subsidiary._A BambooHR division doesn't match it's counterpart (subsidiary) in Netsuite API":
		{
			translation:
				"Couldn't sync employee: %s. No matching subsidiaries were found for division: %s. Please verify that this division matches a Netsuite Subsidiary.",
		},
	'Date_day of the week': {
		translation: 'Date',
	},
	'Domain [%s] is over user limit! Can not create [%s]._Customer limit to create Google users has been met.':
		{
			translation: 'Domain %s is over user limit! Can not create %s.',
		},
	'Duplicate_Create a duplicate report': {
		translation: 'Duplicate',
	},
	'Email_Verb meaning send an email': {
		translation: 'Email',
	},
	'Excel_Microsoft Office Excel': {
		translation: 'Excel',
	},
	'First_First Name': {
		translation: 'First',
	},
	'In regard to_In regard to': {
		translation: 'In regard to',
	},
	'Last_Last Name': {
		translation: 'Last',
	},
	'Middle_Middle Name': {
		translation: 'Middle',
	},
	'Modifying admins is prohibited by the identity consumer! Syncing [%s] with Work Email [%s] was refused._Google refuses the sync attempt because user is an admin in Google.':
		{
			translation:
				'Modifying admins is prohibited by the identity consumer! Syncing %s with Work Email %s was refused.',
		},
	'Most Recent_Filter option for most-recently recorded employee trainings': {
		translation: 'Most Recent',
	},
	'Name_Persons name': {
		translation: 'Name',
	},
	'Nice!_as in Congratulations': {
		translation: 'Nice!',
	},
	'PDF_Portable Document Format': {
		translation: 'PDF',
	},
	'PTO_Paid time off': {
		translation: 'PTO',
	},
	'Total PTO_Paid time off': {
		translation: 'Total PTO',
	},
	'Scheduled_Amount of time off scheduled': {
		translation: 'Scheduled',
	},
	'Sending an email "from" sender_Sending an email "from" sender': {
		translation: 'Sending an email "from" sender',
	},
	'Sending an email "to" recipent_Sending an email "to" recipent': {
		translation: 'Sending an email "to" recipent',
	},
	'Single_Marital status': {
		translation: 'Single',
	},
	'Successfully connected BambooHR to %s_app name': {
		translation: 'Successfully connected BambooHR to %s',
	},
	'Used_Amount of time off used or spent': {
		translation: 'Used',
	},
	"We can't modify users from the [%s] domain! Syncing [%s] with Work Email [%s] was refused._Current email contains a different domain that we can't modify.":
		{
			translation:
				"We can't modify users from the %s domain! Syncing %s with Work Email %s was refused.",
		},
	"Work Email [%s] appears to be empty or invalid! We did not attempt to modify [%s]._If work email has an invalid character, we won't attempt to sync.":
		{
			translation:
				'Work Email %s appears to be empty or invalid! We did not attempt to modify %s.',
		},
	'Work Email [%s] appears to have changed for [%s]! Identity consumer refuses the change email for an existing account._Google refuses the change an email for previously created account':
		{
			translation:
				'Work Email %s appears to have changed for %s! Identity consumer refuses the change email for an existing account.',
		},
	'account is over user limit! Can not create [%s]._Customer limit to create users has been met.':
		{
			translation: 'account is over user limit! Can not create %s.',
		},
	'to unhide_to unhide': {
		translation: 'to unhide',
	},
} satisfies StructuredResource;
